
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// src/random/Types.ts
var $a434a6e836fe5827$export$7b5b9f2074b71a21 = Math.random;


// src/util/GuardThrowFromResult.ts
var $984cc5641d701af3$export$3c71f17eb3232c2e = (test)=>{
    if (test[0]) return false;
    else throw new Error(test[1]);
};
// src/util/GuardNumbers.ts
var $984cc5641d701af3$export$b9e43d1765415474 = (x)=>Math.log2(x) % 1 === 0;
var $984cc5641d701af3$export$98989fe6ff9c28e = (v, fallback)=>{
    if (Number.isNaN(v)) return fallback;
    if (typeof v !== `number`) throw new TypeError(`v is not a number. Got: ${typeof v}`);
    return v;
};
var $984cc5641d701af3$export$3590893fb629ef46 = (value, range = ``, defaultValue = Number.NaN)=>{
    if (value === void 0) return defaultValue;
    if (value === null) return defaultValue;
    try {
        const parsed = Number.parseInt(value);
        const r = $984cc5641d701af3$export$a92c1e031174f8ef(parsed, range, `parsed`);
        return r[0] ? parsed : defaultValue;
    } catch  {
        return defaultValue;
    }
};
var $984cc5641d701af3$export$4e9798519a1d5a63 = (value, range = ``, parameterName = `?`)=>{
    if (value === null) return [
        false,
        `Parameter '${parameterName}' is null`
    ];
    if (typeof value === `undefined`) return [
        false,
        `Parameter '${parameterName}' is undefined`
    ];
    if (Number.isNaN(value)) return [
        false,
        `Parameter '${parameterName}' is NaN`
    ];
    if (typeof value !== `number`) return [
        false,
        `Parameter '${parameterName}' is not a number (${JSON.stringify(value)})`
    ];
    switch(range){
        case `finite`:
            if (!Number.isFinite(value)) return [
                false,
                `Parameter '${parameterName} must be finite (Got: ${value})`
            ];
            break;
        case `positive`:
            if (value < 0) return [
                false,
                `Parameter '${parameterName}' must be at least zero (${value})`
            ];
            break;
        case `negative`:
            if (value > 0) return [
                false,
                `Parameter '${parameterName}' must be zero or lower (${value})`
            ];
            break;
        case `aboveZero`:
            if (value <= 0) return [
                false,
                `Parameter '${parameterName}' must be above zero (${value})`
            ];
            break;
        case `belowZero`:
            if (value >= 0) return [
                false,
                `Parameter '${parameterName}' must be below zero (${value})`
            ];
            break;
        case `percentage`:
            if (value > 1 || value < 0) return [
                false,
                `Parameter '${parameterName}' must be in percentage range (0 to 1). (${value})`
            ];
            break;
        case `nonZero`:
            if (value === 0) return [
                false,
                `Parameter '${parameterName}' must non-zero. (${value})`
            ];
            break;
        case `bipolar`:
            if (value > 1 || value < -1) return [
                false,
                `Parameter '${parameterName}' must be in bipolar percentage range (-1 to 1). (${value})`
            ];
            break;
    }
    return [
        true
    ];
};
var $984cc5641d701af3$export$d60fcb8dda779864 = (value, range = ``, parameterName = `?`)=>{
    $984cc5641d701af3$export$3c71f17eb3232c2e($984cc5641d701af3$export$4e9798519a1d5a63(value, range, parameterName));
};
var $984cc5641d701af3$export$3cedf23f07f59717 = (value, parameterName = `?`)=>$984cc5641d701af3$export$4e9798519a1d5a63(value, `percentage`, parameterName);
var $984cc5641d701af3$export$212d07e09a081c79 = (value, parameterName = `?`)=>{
    $984cc5641d701af3$export$3c71f17eb3232c2e($984cc5641d701af3$export$3cedf23f07f59717(value, parameterName));
};
var $984cc5641d701af3$export$a92c1e031174f8ef = (value, range = ``, parameterName = `?`)=>{
    const r = $984cc5641d701af3$export$4e9798519a1d5a63(value, range, parameterName);
    if (!r[0]) return r;
    if (!Number.isInteger(value)) return [
        false,
        `Param '${parameterName}' is not an integer`
    ];
    return [
        true
    ];
};
var $984cc5641d701af3$export$a4ff393eb12b0888 = (value, range = ``, parameterName = `?`)=>{
    $984cc5641d701af3$export$3c71f17eb3232c2e($984cc5641d701af3$export$a92c1e031174f8ef(value, range, parameterName));
};


// src/random/FloatSource.ts
var $ecc9b4c6822e4e6b$export$a627116c255f4dc3 = (maxOrOptions = 1)=>{
    const options = typeof maxOrOptions === `number` ? {
        max: maxOrOptions
    } : maxOrOptions;
    let max = options.max;
    let min = options.min ?? 0;
    const source = options.source ?? (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(min, ``, `min`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(max, ``, `max`);
    if (!options.min && max < 0) {
        min = max;
        max = 0;
    }
    if (min > max) throw new Error(`Min is greater than max. Min: ${min} max: ${max}`);
    return ()=>source() * (max - min) + min;
};
var $ecc9b4c6822e4e6b$export$6b5cd3983e3ee5ab = (maxOrOptions = 1)=>$ecc9b4c6822e4e6b$export$a627116c255f4dc3(maxOrOptions)();
// src/numbers/Count.ts
function* $ecc9b4c6822e4e6b$export$85b9a36db797e02b(amount, offset = 0) {
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(amount, ``, `amount`);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(offset, ``, `offset`);
    if (amount === 0) return;
    let index = 0;
    do yield amount < 0 ? -index + offset : index + offset;
    while (index++ < Math.abs(amount) - 1);
}


// src/numbers/Clamp.ts
var $ab835bc9d61bae68$export$7d15b64cf5a3a4c4 = (value, min = 0, max = 1)=>{
    if (Number.isNaN(value)) throw new Error(`Param 'value' is NaN`);
    if (Number.isNaN(min)) throw new Error(`Param 'min' is NaN`);
    if (Number.isNaN(max)) throw new Error(`Param 'max' is NaN`);
    if (value < min) return min;
    if (value > max) return max;
    return value;
};
var $ab835bc9d61bae68$export$fc151c03e1fcd7c = (min = 0, max = 1)=>{
    if (Number.isNaN(min)) throw new Error(`Param 'min' is NaN`);
    if (Number.isNaN(max)) throw new Error(`Param 'max' is NaN`);
    return (v)=>{
        if (v > max) return max;
        if (v < min) return min;
        return v;
    };
};
var $ab835bc9d61bae68$export$cdbb71092bf28e30 = (v, arrayOrLength)=>{
    if (!Number.isInteger(v)) throw new TypeError(`v parameter must be an integer (${v})`);
    const length = Array.isArray(arrayOrLength) ? arrayOrLength.length : arrayOrLength;
    if (!Number.isInteger(length)) throw new TypeError(`length parameter must be an integer (${length}, ${typeof length})`);
    v = Math.round(v);
    if (v < 0) return 0;
    if (v >= length) return length - 1;
    return v;
};


// src/data/arrays/GuardArray.ts
var $2a676fe0e1f81a0d$export$e16ff0ad2c951403 = (array, name = `?`)=>{
    if (array === void 0) throw new TypeError(`Param '${name}' is undefined. Expected array.`);
    if (array === null) throw new TypeError(`Param '${name}' is null. Expected array.`);
    if (!Array.isArray(array)) throw new TypeError(`Param '${name}' not an array as expected`);
};


// src/data/arrays/Pairwise.ts
function* $86813b6110828816$export$8f9d79d42bff1aac(values) {
    (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(values, `values`);
    if (values.length < 2) throw new Error(`Array needs to have at least two entries. Length: ${values.length}`);
    for(let index = 1; index < values.length; index++)yield [
        values[index - 1],
        values[index]
    ];
}
var $86813b6110828816$export$cf06ea7d47c75571 = (array, reducer, initial)=>{
    (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(array, `arr`);
    if (array.length < 2) return initial;
    for(let index = 0; index < array.length - 1; index++)initial = reducer(initial, array[index], array[index + 1]);
    return initial;
};



// src/debug/GetErrorMessage.ts
var $96302e292290d7c3$export$82f46aa4e6535a45 = (ex)=>{
    if (typeof ex === `string`) return ex;
    if (ex instanceof Error) return ex.message;
    return ex;
};


// src/util/Results.ts
function $e8ad1dce15e1a2c0$export$11a85548c4f5cb8b(result) {
    if (result.success) return true;
    if (typeof result.error === `string`) throw new Error(result.error);
    throw result.error;
}
function $e8ad1dce15e1a2c0$export$e7f2125cfeb7086c(result) {
    if (typeof result.error === `string`) return new Error(result.error);
    else return result.error;
}
function $e8ad1dce15e1a2c0$export$d71b473300b7b03e(result) {
    if (result.success) return result.value;
    else throw $e8ad1dce15e1a2c0$export$e7f2125cfeb7086c(result);
}
function $e8ad1dce15e1a2c0$export$99d5c87bcc0b582e(result) {
    if (typeof result.error === `string`) return result.error;
    else return (0, $96302e292290d7c3$export$82f46aa4e6535a45)(result.error);
}



var $f81dde33861c7f4f$var$__create = Object.create;
var $f81dde33861c7f4f$var$__defProp = Object.defineProperty;
var $f81dde33861c7f4f$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $f81dde33861c7f4f$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $f81dde33861c7f4f$var$__getProtoOf = Object.getPrototypeOf;
var $f81dde33861c7f4f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f81dde33861c7f4f$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $f81dde33861c7f4f$export$c98acbe61b4a254a = (cb, mod)=>function __require() {
        return mod || (0, cb[$f81dde33861c7f4f$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $f81dde33861c7f4f$export$cd3da3bb63c78796 = (target, all)=>{
    for(var name in all)$f81dde33861c7f4f$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $f81dde33861c7f4f$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $f81dde33861c7f4f$var$__getOwnPropNames(from))if (!$f81dde33861c7f4f$var$__hasOwnProp.call(to, key) && key !== except) $f81dde33861c7f4f$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $f81dde33861c7f4f$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $f81dde33861c7f4f$export$82dec27a9dce9602 = (mod, isNodeMode, target)=>(target = mod != null ? $f81dde33861c7f4f$var$__create($f81dde33861c7f4f$var$__getProtoOf(mod)) : {}, $f81dde33861c7f4f$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $f81dde33861c7f4f$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $f81dde33861c7f4f$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $f81dde33861c7f4f$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $f81dde33861c7f4f$var$__defProp(target, key, result);
    return result;
};
var $f81dde33861c7f4f$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $f81dde33861c7f4f$var$__typeError("Cannot " + msg);
var $f81dde33861c7f4f$export$18a094aefa070634 = (obj, member, getter)=>($f81dde33861c7f4f$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $f81dde33861c7f4f$export$addf369becd23283 = (obj, member, value)=>member.has(obj) ? $f81dde33861c7f4f$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $f81dde33861c7f4f$export$42432efe6614d3b4 = (obj, member, value, setter)=>($f81dde33861c7f4f$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $f81dde33861c7f4f$export$fa92d15b718fce20 = (obj, member, method)=>($f81dde33861c7f4f$var$__accessCheck(obj, member, "access private method"), method);


// src/numbers/Scale.ts
var $8a5cbeb1c6ae1b41$export$dcdf75081b88279d = (v, inMin, inMax, outMin, outMax, easing)=>$8a5cbeb1c6ae1b41$export$392c70347f2a027f(inMin, inMax, outMin, outMax, easing)(v);
var $8a5cbeb1c6ae1b41$export$392c70347f2a027f = (inMin, inMax, outMin, outMax, easing, clamped)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(inMin, `finite`, `inMin`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(inMax, `finite`, `inMax`);
    const oMax = outMax ?? 1;
    const oMin = outMin ?? 0;
    const clampFunction = clamped ? (0, $ab835bc9d61bae68$export$fc151c03e1fcd7c)(outMin, outMax) : void 0;
    return (v)=>{
        if (inMin === inMax) return oMax;
        let a2 = (v - inMin) / (inMax - inMin);
        if (easing !== void 0) a2 = easing(a2);
        const x = a2 * (oMax - oMin) + oMin;
        if (clampFunction) return clampFunction(x);
        return x;
    };
};
var $8a5cbeb1c6ae1b41$export$9d3e539142ae65ac = (v, inMin, inMax, outMin, outMax, easing)=>{
    if (outMax === void 0) outMax = 1;
    if (outMin === void 0) outMin = 0;
    if (inMin === inMax) return outMax;
    const x = $8a5cbeb1c6ae1b41$export$dcdf75081b88279d(v, inMin, inMax, outMin, outMax, easing);
    return (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(x, outMin, outMax);
};
var $8a5cbeb1c6ae1b41$export$b609727d97245517 = (percentage, outMin, outMax = 1)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(percentage, `percentage`, `v`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(outMin, `percentage`, `outMin`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(outMax, `percentage`, `outMax`);
    return $8a5cbeb1c6ae1b41$export$dcdf75081b88279d(percentage, 0, 1, outMin, outMax);
};
var $8a5cbeb1c6ae1b41$export$14499786dedefe2f = (v, outMin, outMax)=>$8a5cbeb1c6ae1b41$export$a2e4f19528ae6b43(outMin, outMax)(v);
var $8a5cbeb1c6ae1b41$export$a2e4f19528ae6b43 = (outMin, outMax)=>{
    return (v)=>{
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(v, `percentage`, `v`);
        return $8a5cbeb1c6ae1b41$export$dcdf75081b88279d(v, 0, 1, outMin, outMax);
    };
};
var $8a5cbeb1c6ae1b41$export$eb38615a970f20ed = (inMin, inMax, outMin = 0, outMax = 1, clamped = false, easing)=>{
    const toOut = $8a5cbeb1c6ae1b41$export$392c70347f2a027f(inMin, inMax, outMin, outMax, easing, clamped);
    const toIn = $8a5cbeb1c6ae1b41$export$392c70347f2a027f(outMin, outMax, inMin, inMax, easing, clamped);
    return {
        out: toOut,
        in: toIn
    };
};
// src/visual/Colour.ts
var $8a5cbeb1c6ae1b41$export$da5c41284313e6e3 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($8a5cbeb1c6ae1b41$export$da5c41284313e6e3, {
    cssLinearGradient: ()=>$8a5cbeb1c6ae1b41$var$cssLinearGradient,
    fromHsl: ()=>$8a5cbeb1c6ae1b41$var$fromHsl,
    getCssVariable: ()=>$8a5cbeb1c6ae1b41$export$246d3e180f7f2ea,
    goldenAngleColour: ()=>$8a5cbeb1c6ae1b41$var$goldenAngleColour,
    interpolator: ()=>$8a5cbeb1c6ae1b41$var$interpolator,
    multiplyOpacity: ()=>$8a5cbeb1c6ae1b41$export$876e3715299813be,
    multiplySaturation: ()=>$8a5cbeb1c6ae1b41$var$multiplySaturation,
    parseRgbObject: ()=>$8a5cbeb1c6ae1b41$export$5dcc4524a470324,
    randomHue: ()=>$8a5cbeb1c6ae1b41$export$d870adf6a93a40c,
    resolve: ()=>$8a5cbeb1c6ae1b41$export$f7ad0328861e2f03,
    resolveToString: ()=>$8a5cbeb1c6ae1b41$export$23fa9a8c7e36c17,
    scale: ()=>$8a5cbeb1c6ae1b41$var$scale3,
    toHex: ()=>$8a5cbeb1c6ae1b41$export$7ea66e3774a60b67,
    toHsl: ()=>$8a5cbeb1c6ae1b41$export$3dae994ede898e09,
    toRgb: ()=>$8a5cbeb1c6ae1b41$export$593768a1c887fc17,
    toRgb8bit: ()=>$8a5cbeb1c6ae1b41$export$550846ee437f5547,
    toString: ()=>$8a5cbeb1c6ae1b41$var$toString
});
// node_modules/colorjs.io/dist/color.js
function $8a5cbeb1c6ae1b41$var$multiplyMatrices(A, B) {
    let m3 = A.length;
    if (!Array.isArray(A[0])) A = [
        A
    ];
    if (!Array.isArray(B[0])) B = B.map((x)=>[
            x
        ]);
    let p2 = B[0].length;
    let B_cols = B[0].map((_, i)=>B.map((x)=>x[i]));
    let product = A.map((row)=>B_cols.map((col)=>{
            let ret = 0;
            if (!Array.isArray(row)) {
                for (let c4 of col)ret += row * c4;
                return ret;
            }
            for(let i = 0; i < row.length; i++)ret += row[i] * (col[i] || 0);
            return ret;
        }));
    if (m3 === 1) product = product[0];
    if (p2 === 1) return product.map((x)=>x[0]);
    return product;
}
function $8a5cbeb1c6ae1b41$var$isString(str) {
    return $8a5cbeb1c6ae1b41$var$type(str) === "string";
}
function $8a5cbeb1c6ae1b41$var$type(o) {
    let str = Object.prototype.toString.call(o);
    return (str.match(/^\[object\s+(.*?)\]$/)[1] || "").toLowerCase();
}
function $8a5cbeb1c6ae1b41$var$serializeNumber(n2, { precision: precision, unit: unit }) {
    if ($8a5cbeb1c6ae1b41$var$isNone(n2)) return "none";
    return $8a5cbeb1c6ae1b41$var$toPrecision(n2, precision) + (unit ?? "");
}
function $8a5cbeb1c6ae1b41$var$isNone(n2) {
    return Number.isNaN(n2) || n2 instanceof Number && n2?.none;
}
function $8a5cbeb1c6ae1b41$var$skipNone(n2) {
    return $8a5cbeb1c6ae1b41$var$isNone(n2) ? 0 : n2;
}
function $8a5cbeb1c6ae1b41$var$toPrecision(n2, precision) {
    if (n2 === 0) return 0;
    let integer = ~~n2;
    let digits = 0;
    if (integer && precision) digits = ~~Math.log10(Math.abs(integer)) + 1;
    const multiplier = 10 ** (precision - digits);
    return Math.floor(n2 * multiplier + 0.5) / multiplier;
}
var $8a5cbeb1c6ae1b41$var$angleFactor = {
    deg: 1,
    grad: 0.9,
    rad: 180 / Math.PI,
    turn: 360
};
function $8a5cbeb1c6ae1b41$var$parseFunction(str) {
    if (!str) return;
    str = str.trim();
    const isFunctionRegex = /^([a-z]+)\((.+?)\)$/i;
    const isNumberRegex = /^-?[\d.]+$/;
    const unitValueRegex = /%|deg|g?rad|turn$/;
    const singleArgument = /\/?\s*(none|[-\w.]+(?:%|deg|g?rad|turn)?)/g;
    let parts = str.match(isFunctionRegex);
    if (parts) {
        let args = [];
        parts[2].replace(singleArgument, ($0, rawArg)=>{
            let match = rawArg.match(unitValueRegex);
            let arg = rawArg;
            if (match) {
                let unit = match[0];
                let unitlessArg = arg.slice(0, -unit.length);
                if (unit === "%") {
                    arg = new Number(unitlessArg / 100);
                    arg.type = "<percentage>";
                } else {
                    arg = new Number(unitlessArg * $8a5cbeb1c6ae1b41$var$angleFactor[unit]);
                    arg.type = "<angle>";
                    arg.unit = unit;
                }
            } else if (isNumberRegex.test(arg)) {
                arg = new Number(arg);
                arg.type = "<number>";
            } else if (arg === "none") {
                arg = new Number(NaN);
                arg.none = true;
            }
            if ($0.startsWith("/")) {
                arg = arg instanceof Number ? arg : new Number(arg);
                arg.alpha = true;
            }
            if (typeof arg === "object" && arg instanceof Number) arg.raw = rawArg;
            args.push(arg);
        });
        return {
            name: parts[1].toLowerCase(),
            rawName: parts[1],
            rawArgs: parts[2],
            args: // An argument could be (as of css-color-4):
            // a number, percentage, degrees (hue), ident (in color())
            args
        };
    }
}
function $8a5cbeb1c6ae1b41$var$last(arr) {
    return arr[arr.length - 1];
}
function $8a5cbeb1c6ae1b41$var$interpolate(start, end, p2) {
    if (isNaN(start)) return end;
    if (isNaN(end)) return start;
    return start + (end - start) * p2;
}
function $8a5cbeb1c6ae1b41$var$interpolateInv(start, end, value) {
    return (value - start) / (end - start);
}
function $8a5cbeb1c6ae1b41$var$mapRange(from, to2, value) {
    return $8a5cbeb1c6ae1b41$var$interpolate(to2[0], to2[1], $8a5cbeb1c6ae1b41$var$interpolateInv(from[0], from[1], value));
}
function $8a5cbeb1c6ae1b41$var$parseCoordGrammar(coordGrammars) {
    return coordGrammars.map((coordGrammar2)=>{
        return coordGrammar2.split("|").map((type2)=>{
            type2 = type2.trim();
            let range2 = type2.match(/^(<[a-z]+>)\[(-?[.\d]+),\s*(-?[.\d]+)\]?$/);
            if (range2) {
                let ret = new String(range2[1]);
                ret.range = [
                    +range2[2],
                    +range2[3]
                ];
                return ret;
            }
            return type2;
        });
    });
}
function $8a5cbeb1c6ae1b41$var$clamp2(min, val, max2) {
    return Math.max(Math.min(max2, val), min);
}
function $8a5cbeb1c6ae1b41$var$copySign(to2, from) {
    return Math.sign(to2) === Math.sign(from) ? to2 : -to2;
}
function $8a5cbeb1c6ae1b41$var$spow(base, exp) {
    return $8a5cbeb1c6ae1b41$var$copySign(Math.abs(base) ** exp, base);
}
function $8a5cbeb1c6ae1b41$var$zdiv(n2, d2) {
    return d2 === 0 ? 0 : n2 / d2;
}
function $8a5cbeb1c6ae1b41$var$bisectLeft(arr, value, lo = 0, hi = arr.length) {
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (arr[mid] < value) lo = mid + 1;
        else hi = mid;
    }
    return lo;
}
var $8a5cbeb1c6ae1b41$var$util = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    bisectLeft: $8a5cbeb1c6ae1b41$var$bisectLeft,
    clamp: $8a5cbeb1c6ae1b41$var$clamp2,
    copySign: $8a5cbeb1c6ae1b41$var$copySign,
    interpolate: $8a5cbeb1c6ae1b41$var$interpolate,
    interpolateInv: $8a5cbeb1c6ae1b41$var$interpolateInv,
    isNone: $8a5cbeb1c6ae1b41$var$isNone,
    isString: $8a5cbeb1c6ae1b41$var$isString,
    last: $8a5cbeb1c6ae1b41$var$last,
    mapRange: $8a5cbeb1c6ae1b41$var$mapRange,
    multiplyMatrices: $8a5cbeb1c6ae1b41$var$multiplyMatrices,
    parseCoordGrammar: $8a5cbeb1c6ae1b41$var$parseCoordGrammar,
    parseFunction: $8a5cbeb1c6ae1b41$var$parseFunction,
    serializeNumber: $8a5cbeb1c6ae1b41$var$serializeNumber,
    skipNone: $8a5cbeb1c6ae1b41$var$skipNone,
    spow: $8a5cbeb1c6ae1b41$var$spow,
    toPrecision: $8a5cbeb1c6ae1b41$var$toPrecision,
    type: $8a5cbeb1c6ae1b41$var$type,
    zdiv: $8a5cbeb1c6ae1b41$var$zdiv
});
var $8a5cbeb1c6ae1b41$var$Hooks = class {
    add(name, callback, first) {
        if (typeof arguments[0] != "string") {
            for(var name in arguments[0])this.add(name, arguments[0][name], arguments[1]);
            return;
        }
        (Array.isArray(name) ? name : [
            name
        ]).forEach(function(name2) {
            this[name2] = this[name2] || [];
            if (callback) this[name2][first ? "unshift" : "push"](callback);
        }, this);
    }
    run(name, env) {
        this[name] = this[name] || [];
        this[name].forEach(function(callback) {
            callback.call(env && env.context ? env.context : env, env);
        });
    }
};
var $8a5cbeb1c6ae1b41$var$hooks = new $8a5cbeb1c6ae1b41$var$Hooks();
var $8a5cbeb1c6ae1b41$var$defaults = {
    gamut_mapping: "css",
    precision: 5,
    deltaE: "76",
    // Default deltaE method
    verbose: globalThis?.process?.env?.NODE_ENV?.toLowerCase() !== "test",
    warn: function warn(msg) {
        if (this.verbose) globalThis?.console?.warn?.(msg);
    }
};
var $8a5cbeb1c6ae1b41$var$WHITES = {
    // for compatibility, the four-digit chromaticity-derived ones everyone else uses
    D50: [
        0.3457 / 0.3585,
        1,
        0.8251046025104602
    ],
    D65: [
        0.3127 / 0.329,
        1,
        1.0890577507598784
    ]
};
function $8a5cbeb1c6ae1b41$var$getWhite(name) {
    if (Array.isArray(name)) return name;
    return $8a5cbeb1c6ae1b41$var$WHITES[name];
}
function $8a5cbeb1c6ae1b41$var$adapt$2(W1, W2, XYZ, options = {}) {
    W1 = $8a5cbeb1c6ae1b41$var$getWhite(W1);
    W2 = $8a5cbeb1c6ae1b41$var$getWhite(W2);
    if (!W1 || !W2) throw new TypeError(`Missing white point to convert ${!W1 ? "from" : ""}${!W1 && !W2 ? "/" : ""}${!W2 ? "to" : ""}`);
    if (W1 === W2) return XYZ;
    let env = {
        W1: W1,
        W2: W2,
        XYZ: XYZ,
        options: options
    };
    $8a5cbeb1c6ae1b41$var$hooks.run("chromatic-adaptation-start", env);
    if (!env.M) {
        if (env.W1 === $8a5cbeb1c6ae1b41$var$WHITES.D65 && env.W2 === $8a5cbeb1c6ae1b41$var$WHITES.D50) env.M = [
            [
                1.0479297925449969,
                0.022946870601609652,
                -0.05019226628920524
            ],
            [
                0.02962780877005599,
                0.9904344267538799,
                -0.017073799063418826
            ],
            [
                -0.009243040646204504,
                0.015055191490298152,
                0.7518742814281371
            ]
        ];
        else if (env.W1 === $8a5cbeb1c6ae1b41$var$WHITES.D50 && env.W2 === $8a5cbeb1c6ae1b41$var$WHITES.D65) env.M = [
            [
                0.955473421488075,
                -0.02309845494876471,
                0.06325924320057072
            ],
            [
                -0.0283697093338637,
                1.0099953980813041,
                0.021041441191917323
            ],
            [
                0.012314014864481998,
                -0.020507649298898964,
                1.330365926242124
            ]
        ];
    }
    $8a5cbeb1c6ae1b41$var$hooks.run("chromatic-adaptation-end", env);
    if (env.M) return $8a5cbeb1c6ae1b41$var$multiplyMatrices(env.M, env.XYZ);
    else throw new TypeError("Only Bradford CAT with white points D50 and D65 supported for now.");
}
var $8a5cbeb1c6ae1b41$var$noneTypes = /* @__PURE__ */ new Set([
    "<number>",
    "<percentage>",
    "<angle>"
]);
function $8a5cbeb1c6ae1b41$var$coerceCoords(space, format, name, coords) {
    let types = Object.entries(space.coords).map(([id, coordMeta], i)=>{
        let coordGrammar2 = format.coordGrammar[i];
        let arg = coords[i];
        let providedType = arg?.type;
        let type2;
        if (arg.none) type2 = coordGrammar2.find((c4)=>$8a5cbeb1c6ae1b41$var$noneTypes.has(c4));
        else type2 = coordGrammar2.find((c4)=>c4 == providedType);
        if (!type2) {
            let coordName = coordMeta.name || id;
            throw new TypeError(`${providedType ?? arg.raw} not allowed for ${coordName} in ${name}()`);
        }
        let fromRange = type2.range;
        if (providedType === "<percentage>") fromRange ||= [
            0,
            1
        ];
        let toRange = coordMeta.range || coordMeta.refRange;
        if (fromRange && toRange) coords[i] = $8a5cbeb1c6ae1b41$var$mapRange(fromRange, toRange, coords[i]);
        return type2;
    });
    return types;
}
function $8a5cbeb1c6ae1b41$var$parse(str, { meta: meta } = {}) {
    let env = {
        "str": String(str)?.trim()
    };
    $8a5cbeb1c6ae1b41$var$hooks.run("parse-start", env);
    if (env.color) return env.color;
    env.parsed = $8a5cbeb1c6ae1b41$var$parseFunction(env.str);
    if (env.parsed) {
        let name = env.parsed.name;
        if (name === "color") {
            let id = env.parsed.args.shift();
            let alternateId = id.startsWith("--") ? id.substring(2) : `--${id}`;
            let ids = [
                id,
                alternateId
            ];
            let alpha = env.parsed.rawArgs.indexOf("/") > 0 ? env.parsed.args.pop() : 1;
            for (let space of $8a5cbeb1c6ae1b41$var$ColorSpace.all){
                let colorSpec = space.getFormat("color");
                if (colorSpec) {
                    if (ids.includes(colorSpec.id) || colorSpec.ids?.filter((specId)=>ids.includes(specId)).length) {
                        const coords = Object.keys(space.coords).map((_, i)=>env.parsed.args[i] || 0);
                        let types;
                        if (colorSpec.coordGrammar) types = $8a5cbeb1c6ae1b41$var$coerceCoords(space, colorSpec, "color", coords);
                        if (meta) Object.assign(meta, {
                            formatId: "color",
                            types: types
                        });
                        if (colorSpec.id.startsWith("--") && !id.startsWith("--")) $8a5cbeb1c6ae1b41$var$defaults.warn(`${space.name} is a non-standard space and not currently supported in the CSS spec. Use prefixed color(${colorSpec.id}) instead of color(${id}).`);
                        if (id.startsWith("--") && !colorSpec.id.startsWith("--")) $8a5cbeb1c6ae1b41$var$defaults.warn(`${space.name} is a standard space and supported in the CSS spec. Use color(${colorSpec.id}) instead of prefixed color(${id}).`);
                        return {
                            spaceId: space.id,
                            coords: coords,
                            alpha: alpha
                        };
                    }
                }
            }
            let didYouMean = "";
            let registryId = id in $8a5cbeb1c6ae1b41$var$ColorSpace.registry ? id : alternateId;
            if (registryId in $8a5cbeb1c6ae1b41$var$ColorSpace.registry) {
                let cssId = $8a5cbeb1c6ae1b41$var$ColorSpace.registry[registryId].formats?.color?.id;
                if (cssId) didYouMean = `Did you mean color(${cssId})?`;
            }
            throw new TypeError(`Cannot parse color(${id}). ` + (didYouMean || "Missing a plugin?"));
        } else for (let space of $8a5cbeb1c6ae1b41$var$ColorSpace.all){
            let format = space.getFormat(name);
            if (format && format.type === "function") {
                let alpha = 1;
                if (format.lastAlpha || $8a5cbeb1c6ae1b41$var$last(env.parsed.args).alpha) alpha = env.parsed.args.pop();
                let coords = env.parsed.args;
                let types;
                if (format.coordGrammar) types = $8a5cbeb1c6ae1b41$var$coerceCoords(space, format, name, coords);
                if (meta) Object.assign(meta, {
                    formatId: format.name,
                    types: types
                });
                return {
                    spaceId: space.id,
                    coords: coords,
                    alpha: alpha
                };
            }
        }
    } else {
        for (let space of $8a5cbeb1c6ae1b41$var$ColorSpace.all)for(let formatId in space.formats){
            let format = space.formats[formatId];
            if (format.type !== "custom") continue;
            if (format.test && !format.test(env.str)) continue;
            let color = format.parse(env.str);
            if (color) {
                color.alpha ??= 1;
                if (meta) meta.formatId = formatId;
                return color;
            }
        }
    }
    throw new TypeError(`Could not parse ${str} as a color. Missing a plugin?`);
}
function $8a5cbeb1c6ae1b41$var$getColor(color) {
    if (Array.isArray(color)) return color.map($8a5cbeb1c6ae1b41$var$getColor);
    if (!color) throw new TypeError("Empty color reference");
    if ($8a5cbeb1c6ae1b41$var$isString(color)) color = $8a5cbeb1c6ae1b41$var$parse(color);
    let space = color.space || color.spaceId;
    if (!(space instanceof $8a5cbeb1c6ae1b41$var$ColorSpace)) color.space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    if (color.alpha === void 0) color.alpha = 1;
    return color;
}
var $8a5cbeb1c6ae1b41$var$\u03B5$7 = 75e-6;
var $8a5cbeb1c6ae1b41$var$ColorSpace = class _ColorSpace {
    constructor(options){
        this.id = options.id;
        this.name = options.name;
        this.base = options.base ? _ColorSpace.get(options.base) : null;
        this.aliases = options.aliases;
        if (this.base) {
            this.fromBase = options.fromBase;
            this.toBase = options.toBase;
        }
        let coords = options.coords ?? this.base.coords;
        for(let name in coords)if (!("name" in coords[name])) coords[name].name = name;
        this.coords = coords;
        let white2 = options.white ?? this.base.white ?? "D65";
        this.white = $8a5cbeb1c6ae1b41$var$getWhite(white2);
        this.formats = options.formats ?? {};
        for(let name in this.formats){
            let format = this.formats[name];
            format.type ||= "function";
            format.name ||= name;
        }
        if (!this.formats.color?.id) this.formats.color = {
            ...this.formats.color ?? {},
            id: options.cssId || this.id
        };
        if (options.gamutSpace) this.gamutSpace = options.gamutSpace === "self" ? this : _ColorSpace.get(options.gamutSpace);
        else if (this.isPolar) this.gamutSpace = this.base;
        else this.gamutSpace = this;
        if (this.gamutSpace.isUnbounded) this.inGamut = (coords2, options2)=>{
            return true;
        };
        this.referred = options.referred;
        Object.defineProperty(this, "path", {
            value: $8a5cbeb1c6ae1b41$var$getPath(this).reverse(),
            writable: false,
            enumerable: true,
            configurable: true
        });
        $8a5cbeb1c6ae1b41$var$hooks.run("colorspace-init-end", this);
    }
    inGamut(coords, { epsilon: epsilon = $8a5cbeb1c6ae1b41$var$\u03B5$7 } = {}) {
        if (!this.equals(this.gamutSpace)) {
            coords = this.to(this.gamutSpace, coords);
            return this.gamutSpace.inGamut(coords, {
                epsilon: epsilon
            });
        }
        let coordMeta = Object.values(this.coords);
        return coords.every((c4, i)=>{
            let meta = coordMeta[i];
            if (meta.type !== "angle" && meta.range) {
                if (Number.isNaN(c4)) return true;
                let [min, max2] = meta.range;
                return (min === void 0 || c4 >= min - epsilon) && (max2 === void 0 || c4 <= max2 + epsilon);
            }
            return true;
        });
    }
    get isUnbounded() {
        return Object.values(this.coords).every((coord)=>!("range" in coord));
    }
    get cssId() {
        return this.formats?.color?.id || this.id;
    }
    get isPolar() {
        for(let id in this.coords){
            if (this.coords[id].type === "angle") return true;
        }
        return false;
    }
    getFormat(format) {
        if (typeof format === "object") {
            format = $8a5cbeb1c6ae1b41$var$processFormat(format, this);
            return format;
        }
        let ret;
        if (format === "default") ret = Object.values(this.formats)[0];
        else ret = this.formats[format];
        if (ret) {
            ret = $8a5cbeb1c6ae1b41$var$processFormat(ret, this);
            return ret;
        }
        return null;
    }
    /**
   * Check if this color space is the same as another color space reference.
   * Allows proxying color space objects and comparing color spaces with ids.
   * @param {string | ColorSpace} space ColorSpace object or id to compare to
   * @returns {boolean}
   */ equals(space) {
        if (!space) return false;
        return this === space || this.id === space || this.id === space.id;
    }
    to(space, coords) {
        if (arguments.length === 1) {
            const color = $8a5cbeb1c6ae1b41$var$getColor(space);
            [space, coords] = [
                color.space,
                color.coords
            ];
        }
        space = _ColorSpace.get(space);
        if (this.equals(space)) return coords;
        coords = coords.map((c4)=>Number.isNaN(c4) ? 0 : c4);
        let myPath = this.path;
        let otherPath = space.path;
        let connectionSpace, connectionSpaceIndex;
        for(let i = 0; i < myPath.length; i++){
            if (myPath[i].equals(otherPath[i])) {
                connectionSpace = myPath[i];
                connectionSpaceIndex = i;
            } else break;
        }
        if (!connectionSpace) throw new Error(`Cannot convert between color spaces ${this} and ${space}: no connection space was found`);
        for(let i = myPath.length - 1; i > connectionSpaceIndex; i--)coords = myPath[i].toBase(coords);
        for(let i = connectionSpaceIndex + 1; i < otherPath.length; i++)coords = otherPath[i].fromBase(coords);
        return coords;
    }
    from(space, coords) {
        if (arguments.length === 1) {
            const color = $8a5cbeb1c6ae1b41$var$getColor(space);
            [space, coords] = [
                color.space,
                color.coords
            ];
        }
        space = _ColorSpace.get(space);
        return space.to(this, coords);
    }
    toString() {
        return `${this.name} (${this.id})`;
    }
    getMinCoords() {
        let ret = [];
        for(let id in this.coords){
            let meta = this.coords[id];
            let range2 = meta.range || meta.refRange;
            ret.push(range2?.min ?? 0);
        }
        return ret;
    }
    static registry = {};
    // Returns array of unique color spaces
    static get all() {
        return [
            ...new Set(Object.values(_ColorSpace.registry))
        ];
    }
    static register(id, space) {
        if (arguments.length === 1) {
            space = arguments[0];
            id = space.id;
        }
        space = this.get(space);
        if (this.registry[id] && this.registry[id] !== space) throw new Error(`Duplicate color space registration: '${id}'`);
        this.registry[id] = space;
        if (arguments.length === 1 && space.aliases) for (let alias of space.aliases)this.register(alias, space);
        return space;
    }
    /**
   * Lookup ColorSpace object by name
   * @param {ColorSpace | string} name
   */ static get(space, ...alternatives) {
        if (!space || space instanceof _ColorSpace) return space;
        let argType = $8a5cbeb1c6ae1b41$var$type(space);
        if (argType === "string") {
            let ret = _ColorSpace.registry[space.toLowerCase()];
            if (!ret) throw new TypeError(`No color space found with id = "${space}"`);
            return ret;
        }
        if (alternatives.length) return _ColorSpace.get(...alternatives);
        throw new TypeError(`${space} is not a valid color space`);
    }
    /**
   * Get metadata about a coordinate of a color space
   *
   * @static
   * @param {Array | string} ref
   * @param {ColorSpace | string} [workingSpace]
   * @return {Object}
   */ static resolveCoord(ref, workingSpace) {
        let coordType = $8a5cbeb1c6ae1b41$var$type(ref);
        let space, coord;
        if (coordType === "string") {
            if (ref.includes(".")) [space, coord] = ref.split(".");
            else [space, coord] = [
                ,
                ref
            ];
        } else if (Array.isArray(ref)) [space, coord] = ref;
        else {
            space = ref.space;
            coord = ref.coordId;
        }
        space = _ColorSpace.get(space);
        if (!space) space = workingSpace;
        if (!space) throw new TypeError(`Cannot resolve coordinate reference ${ref}: No color space specified and relative references are not allowed here`);
        coordType = $8a5cbeb1c6ae1b41$var$type(coord);
        if (coordType === "number" || coordType === "string" && coord >= 0) {
            let meta = Object.entries(space.coords)[coord];
            if (meta) return {
                space: space,
                id: meta[0],
                index: coord,
                ...meta[1]
            };
        }
        space = _ColorSpace.get(space);
        let normalizedCoord = coord.toLowerCase();
        let i = 0;
        for(let id in space.coords){
            let meta = space.coords[id];
            if (id.toLowerCase() === normalizedCoord || meta.name?.toLowerCase() === normalizedCoord) return {
                space: space,
                id: id,
                index: i,
                ...meta
            };
            i++;
        }
        throw new TypeError(`No "${coord}" coordinate found in ${space.name}. Its coordinates are: ${Object.keys(space.coords).join(", ")}`);
    }
    static DEFAULT_FORMAT = {
        type: "functions",
        name: "color"
    };
};
function $8a5cbeb1c6ae1b41$var$getPath(space) {
    let ret = [
        space
    ];
    for(let s = space; s = s.base;)ret.push(s);
    return ret;
}
function $8a5cbeb1c6ae1b41$var$processFormat(format, { coords: coords } = {}) {
    if (format.coords && !format.coordGrammar) {
        format.type ||= "function";
        format.name ||= "color";
        format.coordGrammar = $8a5cbeb1c6ae1b41$var$parseCoordGrammar(format.coords);
        let coordFormats = Object.entries(coords).map(([id, coordMeta], i)=>{
            let outputType = format.coordGrammar[i][0];
            let fromRange = coordMeta.range || coordMeta.refRange;
            let toRange = outputType.range, suffix = "";
            if (outputType == "<percentage>") {
                toRange = [
                    0,
                    100
                ];
                suffix = "%";
            } else if (outputType == "<angle>") suffix = "deg";
            return {
                fromRange: fromRange,
                toRange: toRange,
                suffix: suffix
            };
        });
        format.serializeCoords = (coords2, precision)=>{
            return coords2.map((c4, i)=>{
                let { fromRange: fromRange, toRange: toRange, suffix: suffix } = coordFormats[i];
                if (fromRange && toRange) c4 = $8a5cbeb1c6ae1b41$var$mapRange(fromRange, toRange, c4);
                c4 = $8a5cbeb1c6ae1b41$var$serializeNumber(c4, {
                    precision: precision,
                    unit: suffix
                });
                return c4;
            });
        };
    }
    return format;
}
var $8a5cbeb1c6ae1b41$var$xyz_d65 = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "xyz-d65",
    name: "XYZ D65",
    coords: {
        x: {
            name: "X"
        },
        y: {
            name: "Y"
        },
        z: {
            name: "Z"
        }
    },
    white: "D65",
    formats: {
        color: {
            ids: [
                "xyz-d65",
                "xyz"
            ]
        }
    },
    aliases: [
        "xyz"
    ]
});
var $8a5cbeb1c6ae1b41$var$RGBColorSpace = class extends $8a5cbeb1c6ae1b41$var$ColorSpace {
    /**
   * Creates a new RGB ColorSpace.
   * If coords are not specified, they will use the default RGB coords.
   * Instead of `fromBase()` and `toBase()` functions,
   * you can specify to/from XYZ matrices and have `toBase()` and `fromBase()` automatically generated.
   * @param {*} options - Same options as {@link ColorSpace} plus:
   * @param {number[][]} options.toXYZ_M - Matrix to convert to XYZ
   * @param {number[][]} options.fromXYZ_M - Matrix to convert from XYZ
   */ constructor(options){
        if (!options.coords) options.coords = {
            r: {
                range: [
                    0,
                    1
                ],
                name: "Red"
            },
            g: {
                range: [
                    0,
                    1
                ],
                name: "Green"
            },
            b: {
                range: [
                    0,
                    1
                ],
                name: "Blue"
            }
        };
        if (!options.base) options.base = $8a5cbeb1c6ae1b41$var$xyz_d65;
        if (options.toXYZ_M && options.fromXYZ_M) {
            options.toBase ??= (rgb)=>{
                let xyz = $8a5cbeb1c6ae1b41$var$multiplyMatrices(options.toXYZ_M, rgb);
                if (this.white !== this.base.white) xyz = $8a5cbeb1c6ae1b41$var$adapt$2(this.white, this.base.white, xyz);
                return xyz;
            };
            options.fromBase ??= (xyz)=>{
                xyz = $8a5cbeb1c6ae1b41$var$adapt$2(this.base.white, this.white, xyz);
                return $8a5cbeb1c6ae1b41$var$multiplyMatrices(options.fromXYZ_M, xyz);
            };
        }
        options.referred ??= "display";
        super(options);
    }
};
function $8a5cbeb1c6ae1b41$var$getAll(color, space) {
    color = $8a5cbeb1c6ae1b41$var$getColor(color);
    if (!space || color.space.equals(space)) return color.coords.slice();
    space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    return space.from(color);
}
function $8a5cbeb1c6ae1b41$var$get(color, prop) {
    color = $8a5cbeb1c6ae1b41$var$getColor(color);
    let { space: space, index: index } = $8a5cbeb1c6ae1b41$var$ColorSpace.resolveCoord(prop, color.space);
    let coords = $8a5cbeb1c6ae1b41$var$getAll(color, space);
    return coords[index];
}
function $8a5cbeb1c6ae1b41$var$setAll(color, space, coords) {
    color = $8a5cbeb1c6ae1b41$var$getColor(color);
    space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    color.coords = space.to(color.space, coords);
    return color;
}
$8a5cbeb1c6ae1b41$var$setAll.returns = "color";
function $8a5cbeb1c6ae1b41$var$set(color, prop, value) {
    color = $8a5cbeb1c6ae1b41$var$getColor(color);
    if (arguments.length === 2 && $8a5cbeb1c6ae1b41$var$type(arguments[1]) === "object") {
        let object = arguments[1];
        for(let p2 in object)$8a5cbeb1c6ae1b41$var$set(color, p2, object[p2]);
    } else {
        if (typeof value === "function") value = value($8a5cbeb1c6ae1b41$var$get(color, prop));
        let { space: space, index: index } = $8a5cbeb1c6ae1b41$var$ColorSpace.resolveCoord(prop, color.space);
        let coords = $8a5cbeb1c6ae1b41$var$getAll(color, space);
        coords[index] = value;
        $8a5cbeb1c6ae1b41$var$setAll(color, space, coords);
    }
    return color;
}
$8a5cbeb1c6ae1b41$var$set.returns = "color";
var $8a5cbeb1c6ae1b41$var$XYZ_D50 = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "xyz-d50",
    name: "XYZ D50",
    white: "D50",
    base: $8a5cbeb1c6ae1b41$var$xyz_d65,
    fromBase: (coords)=>$8a5cbeb1c6ae1b41$var$adapt$2($8a5cbeb1c6ae1b41$var$xyz_d65.white, "D50", coords),
    toBase: (coords)=>$8a5cbeb1c6ae1b41$var$adapt$2("D50", $8a5cbeb1c6ae1b41$var$xyz_d65.white, coords)
});
var $8a5cbeb1c6ae1b41$var$\u03B5$6 = 216 / 24389;
var $8a5cbeb1c6ae1b41$var$\u03B53$1 = 24 / 116;
var $8a5cbeb1c6ae1b41$var$\u03BA$4 = 24389 / 27;
var $8a5cbeb1c6ae1b41$var$white$4 = $8a5cbeb1c6ae1b41$var$WHITES.D50;
var $8a5cbeb1c6ae1b41$var$lab = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "lab",
    name: "Lab",
    coords: {
        l: {
            refRange: [
                0,
                100
            ],
            name: "Lightness"
        },
        a: {
            refRange: [
                -125,
                125
            ]
        },
        b: {
            refRange: [
                -125,
                125
            ]
        }
    },
    // Assuming XYZ is relative to D50, convert to CIE Lab
    // from CIE standard, which now defines these as a rational fraction
    white: $8a5cbeb1c6ae1b41$var$white$4,
    base: $8a5cbeb1c6ae1b41$var$XYZ_D50,
    // Convert D50-adapted XYX to Lab
    //  CIE 15.3:2004 section 8.2.1.1
    fromBase (XYZ) {
        let xyz = XYZ.map((value, i)=>value / $8a5cbeb1c6ae1b41$var$white$4[i]);
        let f = xyz.map((value)=>value > $8a5cbeb1c6ae1b41$var$\u03B5$6 ? Math.cbrt(value) : ($8a5cbeb1c6ae1b41$var$\u03BA$4 * value + 16) / 116);
        return [
            116 * f[1] - 16,
            // L
            500 * (f[0] - f[1]),
            // a
            200 * (f[1] - f[2])
        ];
    },
    // Convert Lab to D50-adapted XYZ
    // Same result as CIE 15.3:2004 Appendix D although the derivation is different
    // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
    toBase (Lab) {
        let f = [];
        f[1] = (Lab[0] + 16) / 116;
        f[0] = Lab[1] / 500 + f[1];
        f[2] = f[1] - Lab[2] / 200;
        let xyz = [
            f[0] > $8a5cbeb1c6ae1b41$var$\u03B53$1 ? Math.pow(f[0], 3) : (116 * f[0] - 16) / $8a5cbeb1c6ae1b41$var$\u03BA$4,
            Lab[0] > 8 ? Math.pow((Lab[0] + 16) / 116, 3) : Lab[0] / $8a5cbeb1c6ae1b41$var$\u03BA$4,
            f[2] > $8a5cbeb1c6ae1b41$var$\u03B53$1 ? Math.pow(f[2], 3) : (116 * f[2] - 16) / $8a5cbeb1c6ae1b41$var$\u03BA$4
        ];
        return xyz.map((value, i)=>value * $8a5cbeb1c6ae1b41$var$white$4[i]);
    },
    formats: {
        "lab": {
            coords: [
                "<number> | <percentage>",
                "<number> | <percentage>[-1,1]",
                "<number> | <percentage>[-1,1]"
            ]
        }
    }
});
function $8a5cbeb1c6ae1b41$var$constrain(angle) {
    return (angle % 360 + 360) % 360;
}
function $8a5cbeb1c6ae1b41$var$adjust(arc, angles) {
    if (arc === "raw") return angles;
    let [a1, a2] = angles.map($8a5cbeb1c6ae1b41$var$constrain);
    let angleDiff = a2 - a1;
    if (arc === "increasing") {
        if (angleDiff < 0) a2 += 360;
    } else if (arc === "decreasing") {
        if (angleDiff > 0) a1 += 360;
    } else if (arc === "longer") {
        if (-180 < angleDiff && angleDiff < 180) {
            if (angleDiff > 0) a1 += 360;
            else a2 += 360;
        }
    } else if (arc === "shorter") {
        if (angleDiff > 180) a1 += 360;
        else if (angleDiff < -180) a2 += 360;
    }
    return [
        a1,
        a2
    ];
}
var $8a5cbeb1c6ae1b41$var$lch = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "lch",
    name: "LCH",
    coords: {
        l: {
            refRange: [
                0,
                100
            ],
            name: "Lightness"
        },
        c: {
            refRange: [
                0,
                150
            ],
            name: "Chroma"
        },
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$lab,
    fromBase (Lab) {
        let [L, a2, b2] = Lab;
        let hue;
        const \u03B52 = 0.02;
        if (Math.abs(a2) < \u03B52 && Math.abs(b2) < \u03B52) hue = NaN;
        else hue = Math.atan2(b2, a2) * 180 / Math.PI;
        return [
            L,
            // L is still L
            Math.sqrt(a2 ** 2 + b2 ** 2),
            // Chroma
            $8a5cbeb1c6ae1b41$var$constrain(hue)
        ];
    },
    toBase (LCH) {
        let [Lightness, Chroma, Hue] = LCH;
        if (Chroma < 0) Chroma = 0;
        if (isNaN(Hue)) Hue = 0;
        return [
            Lightness,
            // L is still L
            Chroma * Math.cos(Hue * Math.PI / 180),
            // a
            Chroma * Math.sin(Hue * Math.PI / 180)
        ];
    },
    formats: {
        "lch": {
            coords: [
                "<number> | <percentage>",
                "<number> | <percentage>",
                "<number> | <angle>"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$Gfactor = 25 ** 7;
var $8a5cbeb1c6ae1b41$var$\u03C0$1 = Math.PI;
var $8a5cbeb1c6ae1b41$var$r2d = 180 / $8a5cbeb1c6ae1b41$var$\u03C0$1;
var $8a5cbeb1c6ae1b41$var$d2r$1 = $8a5cbeb1c6ae1b41$var$\u03C0$1 / 180;
function $8a5cbeb1c6ae1b41$var$pow7(x) {
    const x2 = x * x;
    const x7 = x2 * x2 * x2 * x;
    return x7;
}
function $8a5cbeb1c6ae1b41$var$deltaE2000(color, sample, { kL: kL = 1, kC: kC = 1, kH: kH = 1 } = {}) {
    [color, sample] = $8a5cbeb1c6ae1b41$var$getColor([
        color,
        sample
    ]);
    let [L1, a1, b1] = $8a5cbeb1c6ae1b41$var$lab.from(color);
    let C1 = $8a5cbeb1c6ae1b41$var$lch.from($8a5cbeb1c6ae1b41$var$lab, [
        L1,
        a1,
        b1
    ])[1];
    let [L2, a2, b2] = $8a5cbeb1c6ae1b41$var$lab.from(sample);
    let C2 = $8a5cbeb1c6ae1b41$var$lch.from($8a5cbeb1c6ae1b41$var$lab, [
        L2,
        a2,
        b2
    ])[1];
    if (C1 < 0) C1 = 0;
    if (C2 < 0) C2 = 0;
    let Cbar = (C1 + C2) / 2;
    let C7 = $8a5cbeb1c6ae1b41$var$pow7(Cbar);
    let G = 0.5 * (1 - Math.sqrt(C7 / (C7 + $8a5cbeb1c6ae1b41$var$Gfactor)));
    let adash1 = (1 + G) * a1;
    let adash2 = (1 + G) * a2;
    let Cdash1 = Math.sqrt(adash1 ** 2 + b1 ** 2);
    let Cdash2 = Math.sqrt(adash2 ** 2 + b2 ** 2);
    let h1 = adash1 === 0 && b1 === 0 ? 0 : Math.atan2(b1, adash1);
    let h2 = adash2 === 0 && b2 === 0 ? 0 : Math.atan2(b2, adash2);
    if (h1 < 0) h1 += 2 * $8a5cbeb1c6ae1b41$var$\u03C0$1;
    if (h2 < 0) h2 += 2 * $8a5cbeb1c6ae1b41$var$\u03C0$1;
    h1 *= $8a5cbeb1c6ae1b41$var$r2d;
    h2 *= $8a5cbeb1c6ae1b41$var$r2d;
    let \u0394L = L2 - L1;
    let \u0394C = Cdash2 - Cdash1;
    let hdiff = h2 - h1;
    let hsum = h1 + h2;
    let habs = Math.abs(hdiff);
    let \u0394h;
    if (Cdash1 * Cdash2 === 0) \u0394h = 0;
    else if (habs <= 180) \u0394h = hdiff;
    else if (hdiff > 180) \u0394h = hdiff - 360;
    else if (hdiff < -180) \u0394h = hdiff + 360;
    else $8a5cbeb1c6ae1b41$var$defaults.warn("the unthinkable has happened");
    let \u0394H = 2 * Math.sqrt(Cdash2 * Cdash1) * Math.sin(\u0394h * $8a5cbeb1c6ae1b41$var$d2r$1 / 2);
    let Ldash = (L1 + L2) / 2;
    let Cdash = (Cdash1 + Cdash2) / 2;
    let Cdash7 = $8a5cbeb1c6ae1b41$var$pow7(Cdash);
    let hdash;
    if (Cdash1 * Cdash2 === 0) hdash = hsum;
    else if (habs <= 180) hdash = hsum / 2;
    else if (hsum < 360) hdash = (hsum + 360) / 2;
    else hdash = (hsum - 360) / 2;
    let lsq = (Ldash - 50) ** 2;
    let SL = 1 + 0.015 * lsq / Math.sqrt(20 + lsq);
    let SC = 1 + 0.045 * Cdash;
    let T = 1;
    T -= 0.17 * Math.cos((hdash - 30) * $8a5cbeb1c6ae1b41$var$d2r$1);
    T += 0.24 * Math.cos(2 * hdash * $8a5cbeb1c6ae1b41$var$d2r$1);
    T += 0.32 * Math.cos((3 * hdash + 6) * $8a5cbeb1c6ae1b41$var$d2r$1);
    T -= 0.2 * Math.cos((4 * hdash - 63) * $8a5cbeb1c6ae1b41$var$d2r$1);
    let SH = 1 + 0.015 * Cdash * T;
    let \u0394\u03B8 = 30 * Math.exp(-1 * ((hdash - 275) / 25) ** 2);
    let RC = 2 * Math.sqrt(Cdash7 / (Cdash7 + $8a5cbeb1c6ae1b41$var$Gfactor));
    let RT = -1 * Math.sin(2 * \u0394\u03B8 * $8a5cbeb1c6ae1b41$var$d2r$1) * RC;
    let dE = (\u0394L / (kL * SL)) ** 2;
    dE += (\u0394C / (kC * SC)) ** 2;
    dE += (\u0394H / (kH * SH)) ** 2;
    dE += RT * (\u0394C / (kC * SC)) * (\u0394H / (kH * SH));
    return Math.sqrt(dE);
}
var $8a5cbeb1c6ae1b41$var$XYZtoLMS_M$1 = [
    [
        0.819022437996703,
        0.3619062600528904,
        -0.1288737815209879
    ],
    [
        0.0329836539323885,
        0.9292868615863434,
        0.0361446663506424
    ],
    [
        0.0481771893596242,
        0.2642395317527308,
        0.6335478284694309
    ]
];
var $8a5cbeb1c6ae1b41$var$LMStoXYZ_M$1 = [
    [
        1.2268798758459243,
        -0.5578149944602171,
        0.2813910456659647
    ],
    [
        -0.0405757452148008,
        1.112286803280317,
        -0.0717110580655164
    ],
    [
        -0.0763729366746601,
        -0.4214933324022432,
        1.5869240198367816
    ]
];
var $8a5cbeb1c6ae1b41$var$LMStoLab_M = [
    [
        0.210454268309314,
        0.7936177747023054,
        -0.0040720430116193
    ],
    [
        1.9779985324311684,
        -2.42859224204858,
        0.450593709617411
    ],
    [
        0.0259040424655478,
        0.7827717124575296,
        -0.8086757549230774
    ]
];
var $8a5cbeb1c6ae1b41$var$LabtoLMS_M = [
    [
        1,
        0.3963377773761749,
        0.2158037573099136
    ],
    [
        1,
        -0.1055613458156586,
        -0.0638541728258133
    ],
    [
        1,
        -0.0894841775298119,
        -1.2914855480194092
    ]
];
var $8a5cbeb1c6ae1b41$var$OKLab = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "oklab",
    name: "Oklab",
    coords: {
        l: {
            refRange: [
                0,
                1
            ],
            name: "Lightness"
        },
        a: {
            refRange: [
                -0.4,
                0.4
            ]
        },
        b: {
            refRange: [
                -0.4,
                0.4
            ]
        }
    },
    // Note that XYZ is relative to D65
    white: "D65",
    base: $8a5cbeb1c6ae1b41$var$xyz_d65,
    fromBase (XYZ) {
        let LMS = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$XYZtoLMS_M$1, XYZ);
        let LMSg = LMS.map((val)=>Math.cbrt(val));
        return $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$LMStoLab_M, LMSg);
    },
    toBase (OKLab2) {
        let LMSg = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$LabtoLMS_M, OKLab2);
        let LMS = LMSg.map((val)=>val ** 3);
        return $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$LMStoXYZ_M$1, LMS);
    },
    formats: {
        "oklab": {
            coords: [
                "<percentage> | <number>",
                "<number> | <percentage>[-1,1]",
                "<number> | <percentage>[-1,1]"
            ]
        }
    }
});
function $8a5cbeb1c6ae1b41$var$deltaEOK(color, sample) {
    [color, sample] = $8a5cbeb1c6ae1b41$var$getColor([
        color,
        sample
    ]);
    let [L1, a1, b1] = $8a5cbeb1c6ae1b41$var$OKLab.from(color);
    let [L2, a2, b2] = $8a5cbeb1c6ae1b41$var$OKLab.from(sample);
    let \u0394L = L1 - L2;
    let \u0394a = a1 - a2;
    let \u0394b = b1 - b2;
    return Math.sqrt(\u0394L ** 2 + \u0394a ** 2 + \u0394b ** 2);
}
var $8a5cbeb1c6ae1b41$var$\u03B5$5 = 75e-6;
function $8a5cbeb1c6ae1b41$var$inGamut(color, space, { epsilon: epsilon = $8a5cbeb1c6ae1b41$var$\u03B5$5 } = {}) {
    color = $8a5cbeb1c6ae1b41$var$getColor(color);
    if (!space) space = color.space;
    space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    let coords = color.coords;
    if (space !== color.space) coords = space.from(color);
    return space.inGamut(coords, {
        epsilon: epsilon
    });
}
function $8a5cbeb1c6ae1b41$var$clone(color) {
    return {
        space: color.space,
        coords: color.coords.slice(),
        alpha: color.alpha
    };
}
function $8a5cbeb1c6ae1b41$var$distance(color1, color2, space = "lab") {
    space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    let coords1 = space.from(color1);
    let coords2 = space.from(color2);
    return Math.sqrt(coords1.reduce((acc, c12, i)=>{
        let c22 = coords2[i];
        if (isNaN(c12) || isNaN(c22)) return acc;
        return acc + (c22 - c12) ** 2;
    }, 0));
}
function $8a5cbeb1c6ae1b41$var$deltaE76(color, sample) {
    return $8a5cbeb1c6ae1b41$var$distance(color, sample, "lab");
}
var $8a5cbeb1c6ae1b41$var$\u03C0 = Math.PI;
var $8a5cbeb1c6ae1b41$var$d2r = $8a5cbeb1c6ae1b41$var$\u03C0 / 180;
function $8a5cbeb1c6ae1b41$var$deltaECMC(color, sample, { l: l = 2, c: c4 = 1 } = {}) {
    [color, sample] = $8a5cbeb1c6ae1b41$var$getColor([
        color,
        sample
    ]);
    let [L1, a1, b1] = $8a5cbeb1c6ae1b41$var$lab.from(color);
    let [, C1, H1] = $8a5cbeb1c6ae1b41$var$lch.from($8a5cbeb1c6ae1b41$var$lab, [
        L1,
        a1,
        b1
    ]);
    let [L2, a2, b2] = $8a5cbeb1c6ae1b41$var$lab.from(sample);
    let C2 = $8a5cbeb1c6ae1b41$var$lch.from($8a5cbeb1c6ae1b41$var$lab, [
        L2,
        a2,
        b2
    ])[1];
    if (C1 < 0) C1 = 0;
    if (C2 < 0) C2 = 0;
    let \u0394L = L1 - L2;
    let \u0394C = C1 - C2;
    let \u0394a = a1 - a2;
    let \u0394b = b1 - b2;
    let H2 = \u0394a ** 2 + \u0394b ** 2 - \u0394C ** 2;
    let SL = 0.511;
    if (L1 >= 16) SL = 0.040975 * L1 / (1 + 0.01765 * L1);
    let SC = 0.0638 * C1 / (1 + 0.0131 * C1) + 0.638;
    let T;
    if (Number.isNaN(H1)) H1 = 0;
    if (H1 >= 164 && H1 <= 345) T = 0.56 + Math.abs(0.2 * Math.cos((H1 + 168) * $8a5cbeb1c6ae1b41$var$d2r));
    else T = 0.36 + Math.abs(0.4 * Math.cos((H1 + 35) * $8a5cbeb1c6ae1b41$var$d2r));
    let C4 = Math.pow(C1, 4);
    let F = Math.sqrt(C4 / (C4 + 1900));
    let SH = SC * (F * T + 1 - F);
    let dE = (\u0394L / (l * SL)) ** 2;
    dE += (\u0394C / (c4 * SC)) ** 2;
    dE += H2 / SH ** 2;
    return Math.sqrt(dE);
}
var $8a5cbeb1c6ae1b41$var$Yw$1 = 203;
var $8a5cbeb1c6ae1b41$var$XYZ_Abs_D65 = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    // Absolute CIE XYZ, with a D65 whitepoint,
    // as used in most HDR colorspaces as a starting point.
    // SDR spaces are converted per BT.2048
    // so that diffuse, media white is 203 cd/m²
    id: "xyz-abs-d65",
    cssId: "--xyz-abs-d65",
    name: "Absolute XYZ D65",
    coords: {
        x: {
            refRange: [
                0,
                9504.7
            ],
            name: "Xa"
        },
        y: {
            refRange: [
                0,
                1e4
            ],
            name: "Ya"
        },
        z: {
            refRange: [
                0,
                10888.3
            ],
            name: "Za"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$xyz_d65,
    fromBase (XYZ) {
        return XYZ.map((v)=>Math.max(v * $8a5cbeb1c6ae1b41$var$Yw$1, 0));
    },
    toBase (AbsXYZ) {
        return AbsXYZ.map((v)=>Math.max(v / $8a5cbeb1c6ae1b41$var$Yw$1, 0));
    }
});
var $8a5cbeb1c6ae1b41$var$b$1 = 1.15;
var $8a5cbeb1c6ae1b41$var$g = 0.66;
var $8a5cbeb1c6ae1b41$var$n$1 = 2610 / 2 ** 14;
var $8a5cbeb1c6ae1b41$var$ninv$1 = 2 ** 14 / 2610;
var $8a5cbeb1c6ae1b41$var$c1$2 = 0.8359375;
var $8a5cbeb1c6ae1b41$var$c2$2 = 18.8515625;
var $8a5cbeb1c6ae1b41$var$c3$2 = 18.6875;
var $8a5cbeb1c6ae1b41$var$p = 1.7 * 2523 / 32;
var $8a5cbeb1c6ae1b41$var$pinv = 32 / (1.7 * 2523);
var $8a5cbeb1c6ae1b41$var$d = -0.56;
var $8a5cbeb1c6ae1b41$var$d0 = 16295499532821565e-27;
var $8a5cbeb1c6ae1b41$var$XYZtoCone_M = [
    [
        0.41478972,
        0.579999,
        0.014648
    ],
    [
        -0.20151,
        1.120649,
        0.0531008
    ],
    [
        -0.0166008,
        0.2648,
        0.6684799
    ]
];
var $8a5cbeb1c6ae1b41$var$ConetoXYZ_M = [
    [
        1.9242264357876067,
        -1.0047923125953657,
        0.037651404030618
    ],
    [
        0.35031676209499907,
        0.7264811939316552,
        -0.06538442294808501
    ],
    [
        -0.09098281098284752,
        -0.3127282905230739,
        1.5227665613052603
    ]
];
var $8a5cbeb1c6ae1b41$var$ConetoIab_M = [
    [
        0.5,
        0.5,
        0
    ],
    [
        3.524,
        -4.066708,
        0.542708
    ],
    [
        0.199076,
        1.096799,
        -1.295875
    ]
];
var $8a5cbeb1c6ae1b41$var$IabtoCone_M = [
    [
        1,
        0.1386050432715393,
        0.05804731615611886
    ],
    [
        0.9999999999999999,
        -0.1386050432715393,
        -0.05804731615611886
    ],
    [
        0.9999999999999998,
        -0.09601924202631895,
        -0.8118918960560388
    ]
];
var $8a5cbeb1c6ae1b41$var$Jzazbz = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "jzazbz",
    name: "Jzazbz",
    coords: {
        jz: {
            refRange: [
                0,
                1
            ],
            name: "Jz"
        },
        az: {
            refRange: [
                -0.5,
                0.5
            ]
        },
        bz: {
            refRange: [
                -0.5,
                0.5
            ]
        }
    },
    base: $8a5cbeb1c6ae1b41$var$XYZ_Abs_D65,
    fromBase (XYZ) {
        let [Xa, Ya, Za] = XYZ;
        let Xm = $8a5cbeb1c6ae1b41$var$b$1 * Xa - ($8a5cbeb1c6ae1b41$var$b$1 - 1) * Za;
        let Ym = $8a5cbeb1c6ae1b41$var$g * Ya - ($8a5cbeb1c6ae1b41$var$g - 1) * Xa;
        let LMS = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$XYZtoCone_M, [
            Xm,
            Ym,
            Za
        ]);
        let PQLMS = LMS.map(function(val) {
            let num = $8a5cbeb1c6ae1b41$var$c1$2 + $8a5cbeb1c6ae1b41$var$c2$2 * (val / 1e4) ** $8a5cbeb1c6ae1b41$var$n$1;
            let denom = 1 + $8a5cbeb1c6ae1b41$var$c3$2 * (val / 1e4) ** $8a5cbeb1c6ae1b41$var$n$1;
            return (num / denom) ** $8a5cbeb1c6ae1b41$var$p;
        });
        let [Iz, az, bz] = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$ConetoIab_M, PQLMS);
        let Jz = (1 + $8a5cbeb1c6ae1b41$var$d) * Iz / (1 + $8a5cbeb1c6ae1b41$var$d * Iz) - $8a5cbeb1c6ae1b41$var$d0;
        return [
            Jz,
            az,
            bz
        ];
    },
    toBase (Jzazbz2) {
        let [Jz, az, bz] = Jzazbz2;
        let Iz = (Jz + $8a5cbeb1c6ae1b41$var$d0) / (1 + $8a5cbeb1c6ae1b41$var$d - $8a5cbeb1c6ae1b41$var$d * (Jz + $8a5cbeb1c6ae1b41$var$d0));
        let PQLMS = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$IabtoCone_M, [
            Iz,
            az,
            bz
        ]);
        let LMS = PQLMS.map(function(val) {
            let num = $8a5cbeb1c6ae1b41$var$c1$2 - val ** $8a5cbeb1c6ae1b41$var$pinv;
            let denom = $8a5cbeb1c6ae1b41$var$c3$2 * val ** $8a5cbeb1c6ae1b41$var$pinv - $8a5cbeb1c6ae1b41$var$c2$2;
            let x = 1e4 * (num / denom) ** $8a5cbeb1c6ae1b41$var$ninv$1;
            return x;
        });
        let [Xm, Ym, Za] = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$ConetoXYZ_M, LMS);
        let Xa = (Xm + ($8a5cbeb1c6ae1b41$var$b$1 - 1) * Za) / $8a5cbeb1c6ae1b41$var$b$1;
        let Ya = (Ym + ($8a5cbeb1c6ae1b41$var$g - 1) * Xa) / $8a5cbeb1c6ae1b41$var$g;
        return [
            Xa,
            Ya,
            Za
        ];
    },
    formats: {
        // https://drafts.csswg.org/css-color-hdr/#Jzazbz
        "color": {
            coords: [
                "<number> | <percentage>",
                "<number> | <percentage>[-1,1]",
                "<number> | <percentage>[-1,1]"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$jzczhz = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "jzczhz",
    name: "JzCzHz",
    coords: {
        jz: {
            refRange: [
                0,
                1
            ],
            name: "Jz"
        },
        cz: {
            refRange: [
                0,
                1
            ],
            name: "Chroma"
        },
        hz: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$Jzazbz,
    fromBase (jzazbz) {
        let [Jz, az, bz] = jzazbz;
        let hue;
        const \u03B52 = 2e-4;
        if (Math.abs(az) < \u03B52 && Math.abs(bz) < \u03B52) hue = NaN;
        else hue = Math.atan2(bz, az) * 180 / Math.PI;
        return [
            Jz,
            // Jz is still Jz
            Math.sqrt(az ** 2 + bz ** 2),
            // Chroma
            $8a5cbeb1c6ae1b41$var$constrain(hue)
        ];
    },
    toBase (jzczhz2) {
        return [
            jzczhz2[0],
            // Jz is still Jz
            jzczhz2[1] * Math.cos(jzczhz2[2] * Math.PI / 180),
            // az
            jzczhz2[1] * Math.sin(jzczhz2[2] * Math.PI / 180)
        ];
    }
});
function $8a5cbeb1c6ae1b41$var$deltaEJz(color, sample) {
    [color, sample] = $8a5cbeb1c6ae1b41$var$getColor([
        color,
        sample
    ]);
    let [Jz1, Cz1, Hz1] = $8a5cbeb1c6ae1b41$var$jzczhz.from(color);
    let [Jz2, Cz2, Hz2] = $8a5cbeb1c6ae1b41$var$jzczhz.from(sample);
    let \u0394J = Jz1 - Jz2;
    let \u0394C = Cz1 - Cz2;
    if (Number.isNaN(Hz1) && Number.isNaN(Hz2)) {
        Hz1 = 0;
        Hz2 = 0;
    } else if (Number.isNaN(Hz1)) Hz1 = Hz2;
    else if (Number.isNaN(Hz2)) Hz2 = Hz1;
    let \u0394h = Hz1 - Hz2;
    let \u0394H = 2 * Math.sqrt(Cz1 * Cz2) * Math.sin(\u0394h / 2 * (Math.PI / 180));
    return Math.sqrt(\u0394J ** 2 + \u0394C ** 2 + \u0394H ** 2);
}
var $8a5cbeb1c6ae1b41$var$c1$1 = 0.8359375;
var $8a5cbeb1c6ae1b41$var$c2$1 = 2413 / 128;
var $8a5cbeb1c6ae1b41$var$c3$1 = 18.6875;
var $8a5cbeb1c6ae1b41$var$m1$1 = 2610 / 16384;
var $8a5cbeb1c6ae1b41$var$m2 = 2523 / 32;
var $8a5cbeb1c6ae1b41$var$im1 = 16384 / 2610;
var $8a5cbeb1c6ae1b41$var$im2 = 32 / 2523;
var $8a5cbeb1c6ae1b41$var$XYZtoLMS_M = [
    [
        0.3592832590121217,
        0.6976051147779502,
        -0.035891593232029
    ],
    [
        -0.1920808463704993,
        1.100476797037432,
        0.0753748658519118
    ],
    [
        0.0070797844607479,
        0.0748396662186362,
        0.8433265453898765
    ]
];
var $8a5cbeb1c6ae1b41$var$LMStoIPT_M = [
    [
        0.5,
        0.5,
        0
    ],
    [
        6610 / 4096,
        -13613 / 4096,
        7003 / 4096
    ],
    [
        17933 / 4096,
        -17390 / 4096,
        -543 / 4096
    ]
];
var $8a5cbeb1c6ae1b41$var$IPTtoLMS_M = [
    [
        0.9999999999999998,
        0.0086090370379328,
        0.111029625003026
    ],
    [
        0.9999999999999998,
        -0.0086090370379328,
        -0.1110296250030259
    ],
    [
        0.9999999999999998,
        0.5600313357106791,
        -0.3206271749873188
    ]
];
var $8a5cbeb1c6ae1b41$var$LMStoXYZ_M = [
    [
        2.0701522183894223,
        -1.3263473389671563,
        0.2066510476294053
    ],
    [
        0.3647385209748072,
        0.6805660249472273,
        -0.0453045459220347
    ],
    [
        -0.0497472075358123,
        -0.0492609666966131,
        1.1880659249923042
    ]
];
var $8a5cbeb1c6ae1b41$var$ictcp = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "ictcp",
    name: "ICTCP",
    // From BT.2100-2 page 7:
    // During production, signal values are expected to exceed the
    // range E′ = [0.0 : 1.0]. This provides processing headroom and avoids
    // signal degradation during cascaded processing. Such values of E′,
    // below 0.0 or exceeding 1.0, should not be clipped during production
    // and exchange.
    // Values below 0.0 should not be clipped in reference displays (even
    // though they represent “negative” light) to allow the black level of
    // the signal (LB) to be properly set using test signals known as “PLUGE”
    coords: {
        i: {
            refRange: [
                0,
                1
            ],
            // Constant luminance,
            name: "I"
        },
        ct: {
            refRange: [
                -0.5,
                0.5
            ],
            // Full BT.2020 gamut in range [-0.5, 0.5]
            name: "CT"
        },
        cp: {
            refRange: [
                -0.5,
                0.5
            ],
            name: "CP"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$XYZ_Abs_D65,
    fromBase (XYZ) {
        let LMS = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$XYZtoLMS_M, XYZ);
        return $8a5cbeb1c6ae1b41$var$LMStoICtCp(LMS);
    },
    toBase (ICtCp) {
        let LMS = $8a5cbeb1c6ae1b41$var$ICtCptoLMS(ICtCp);
        return $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$LMStoXYZ_M, LMS);
    }
});
function $8a5cbeb1c6ae1b41$var$LMStoICtCp(LMS) {
    let PQLMS = LMS.map(function(val) {
        let num = $8a5cbeb1c6ae1b41$var$c1$1 + $8a5cbeb1c6ae1b41$var$c2$1 * (val / 1e4) ** $8a5cbeb1c6ae1b41$var$m1$1;
        let denom = 1 + $8a5cbeb1c6ae1b41$var$c3$1 * (val / 1e4) ** $8a5cbeb1c6ae1b41$var$m1$1;
        return (num / denom) ** $8a5cbeb1c6ae1b41$var$m2;
    });
    return $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$LMStoIPT_M, PQLMS);
}
function $8a5cbeb1c6ae1b41$var$ICtCptoLMS(ICtCp) {
    let PQLMS = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$IPTtoLMS_M, ICtCp);
    let LMS = PQLMS.map(function(val) {
        let num = Math.max(val ** $8a5cbeb1c6ae1b41$var$im2 - $8a5cbeb1c6ae1b41$var$c1$1, 0);
        let denom = $8a5cbeb1c6ae1b41$var$c2$1 - $8a5cbeb1c6ae1b41$var$c3$1 * val ** $8a5cbeb1c6ae1b41$var$im2;
        return 1e4 * (num / denom) ** $8a5cbeb1c6ae1b41$var$im1;
    });
    return LMS;
}
function $8a5cbeb1c6ae1b41$var$deltaEITP(color, sample) {
    [color, sample] = $8a5cbeb1c6ae1b41$var$getColor([
        color,
        sample
    ]);
    let [I1, T1, P1] = $8a5cbeb1c6ae1b41$var$ictcp.from(color);
    let [I2, T2, P2] = $8a5cbeb1c6ae1b41$var$ictcp.from(sample);
    return 720 * Math.sqrt((I1 - I2) ** 2 + 0.25 * (T1 - T2) ** 2 + (P1 - P2) ** 2);
}
var $8a5cbeb1c6ae1b41$var$white$3 = $8a5cbeb1c6ae1b41$var$WHITES.D65;
var $8a5cbeb1c6ae1b41$var$adaptedCoef = 0.42;
var $8a5cbeb1c6ae1b41$var$adaptedCoefInv = 1 / $8a5cbeb1c6ae1b41$var$adaptedCoef;
var $8a5cbeb1c6ae1b41$var$tau = 2 * Math.PI;
var $8a5cbeb1c6ae1b41$var$cat16 = [
    [
        0.401288,
        0.650173,
        -0.051461
    ],
    [
        -0.250268,
        1.204414,
        0.045854
    ],
    [
        -0.002079,
        0.048952,
        0.953127
    ]
];
var $8a5cbeb1c6ae1b41$var$cat16Inv = [
    [
        1.8620678550872327,
        -1.0112546305316843,
        0.14918677544445175
    ],
    [
        0.38752654323613717,
        0.6214474419314753,
        -0.008973985167612518
    ],
    [
        -0.015841498849333856,
        -0.03412293802851557,
        1.0499644368778496
    ]
];
var $8a5cbeb1c6ae1b41$var$m1 = [
    [
        460,
        451,
        288
    ],
    [
        460,
        -891,
        -261
    ],
    [
        460,
        -220,
        -6300
    ]
];
var $8a5cbeb1c6ae1b41$var$surroundMap = {
    dark: [
        0.8,
        0.525,
        0.8
    ],
    dim: [
        0.9,
        0.59,
        0.9
    ],
    average: [
        1,
        0.69,
        1
    ]
};
var $8a5cbeb1c6ae1b41$var$hueQuadMap = {
    // Red, Yellow, Green, Blue, Red
    h: [
        20.14,
        90,
        164.25,
        237.53,
        380.14
    ],
    e: [
        0.8,
        0.7,
        1,
        1.2,
        0.8
    ],
    H: [
        0,
        100,
        200,
        300,
        400
    ]
};
var $8a5cbeb1c6ae1b41$var$rad2deg = 180 / Math.PI;
var $8a5cbeb1c6ae1b41$var$deg2rad$1 = Math.PI / 180;
function $8a5cbeb1c6ae1b41$var$adapt$1(coords, fl) {
    const temp = coords.map((c4)=>{
        const x = $8a5cbeb1c6ae1b41$var$spow(fl * Math.abs(c4) * 0.01, $8a5cbeb1c6ae1b41$var$adaptedCoef);
        return 400 * $8a5cbeb1c6ae1b41$var$copySign(x, c4) / (x + 27.13);
    });
    return temp;
}
function $8a5cbeb1c6ae1b41$var$unadapt(adapted, fl) {
    const constant = 100 / fl * 27.13 ** $8a5cbeb1c6ae1b41$var$adaptedCoefInv;
    return adapted.map((c4)=>{
        const cabs = Math.abs(c4);
        return $8a5cbeb1c6ae1b41$var$copySign(constant * $8a5cbeb1c6ae1b41$var$spow(cabs / (400 - cabs), $8a5cbeb1c6ae1b41$var$adaptedCoefInv), c4);
    });
}
function $8a5cbeb1c6ae1b41$var$hueQuadrature(h) {
    let hp = $8a5cbeb1c6ae1b41$var$constrain(h);
    if (hp <= $8a5cbeb1c6ae1b41$var$hueQuadMap.h[0]) hp += 360;
    const i = $8a5cbeb1c6ae1b41$var$bisectLeft($8a5cbeb1c6ae1b41$var$hueQuadMap.h, hp) - 1;
    const [hi, hii] = $8a5cbeb1c6ae1b41$var$hueQuadMap.h.slice(i, i + 2);
    const [ei, eii] = $8a5cbeb1c6ae1b41$var$hueQuadMap.e.slice(i, i + 2);
    const Hi = $8a5cbeb1c6ae1b41$var$hueQuadMap.H[i];
    const t = (hp - hi) / ei;
    return Hi + 100 * t / (t + (hii - hp) / eii);
}
function $8a5cbeb1c6ae1b41$var$invHueQuadrature(H) {
    let Hp = (H % 400 + 400) % 400;
    const i = Math.floor(0.01 * Hp);
    Hp = Hp % 100;
    const [hi, hii] = $8a5cbeb1c6ae1b41$var$hueQuadMap.h.slice(i, i + 2);
    const [ei, eii] = $8a5cbeb1c6ae1b41$var$hueQuadMap.e.slice(i, i + 2);
    return $8a5cbeb1c6ae1b41$var$constrain((Hp * (eii * hi - ei * hii) - 100 * hi * eii) / (Hp * (eii - ei) - 100 * eii));
}
function $8a5cbeb1c6ae1b41$var$environment(refWhite, adaptingLuminance, backgroundLuminance, surround, discounting) {
    const env = {};
    env.discounting = discounting;
    env.refWhite = refWhite;
    env.surround = surround;
    const xyzW = refWhite.map((c4)=>{
        return c4 * 100;
    });
    env.la = adaptingLuminance;
    env.yb = backgroundLuminance;
    const yw = xyzW[1];
    const rgbW = $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$cat16, xyzW);
    surround = $8a5cbeb1c6ae1b41$var$surroundMap[env.surround];
    const f = surround[0];
    env.c = surround[1];
    env.nc = surround[2];
    const k = 1 / (5 * env.la + 1);
    const k4 = k ** 4;
    env.fl = k4 * env.la + 0.1 * (1 - k4) * (1 - k4) * Math.cbrt(5 * env.la);
    env.flRoot = env.fl ** 0.25;
    env.n = env.yb / yw;
    env.z = 1.48 + Math.sqrt(env.n);
    env.nbb = 0.725 * env.n ** -0.2;
    env.ncb = env.nbb;
    const d2 = discounting ? 1 : Math.max(Math.min(f * (1 - 1 / 3.6 * Math.exp((-env.la - 42) / 92)), 1), 0);
    env.dRgb = rgbW.map((c4)=>{
        return $8a5cbeb1c6ae1b41$var$interpolate(1, yw / c4, d2);
    });
    env.dRgbInv = env.dRgb.map((c4)=>{
        return 1 / c4;
    });
    const rgbCW = rgbW.map((c4, i)=>{
        return c4 * env.dRgb[i];
    });
    const rgbAW = $8a5cbeb1c6ae1b41$var$adapt$1(rgbCW, env.fl);
    env.aW = env.nbb * (2 * rgbAW[0] + rgbAW[1] + 0.05 * rgbAW[2]);
    return env;
}
var $8a5cbeb1c6ae1b41$var$viewingConditions$1 = $8a5cbeb1c6ae1b41$var$environment($8a5cbeb1c6ae1b41$var$white$3, 64 / Math.PI * 0.2, 20, "average", false);
function $8a5cbeb1c6ae1b41$var$fromCam16(cam162, env) {
    if (!(cam162.J !== void 0 ^ cam162.Q !== void 0)) throw new Error("Conversion requires one and only one: 'J' or 'Q'");
    if (!(cam162.C !== void 0 ^ cam162.M !== void 0 ^ cam162.s !== void 0)) throw new Error("Conversion requires one and only one: 'C', 'M' or 's'");
    if (!(cam162.h !== void 0 ^ cam162.H !== void 0)) throw new Error("Conversion requires one and only one: 'h' or 'H'");
    if (cam162.J === 0 || cam162.Q === 0) return [
        0,
        0,
        0
    ];
    let hRad = 0;
    if (cam162.h !== void 0) hRad = $8a5cbeb1c6ae1b41$var$constrain(cam162.h) * $8a5cbeb1c6ae1b41$var$deg2rad$1;
    else hRad = $8a5cbeb1c6ae1b41$var$invHueQuadrature(cam162.H) * $8a5cbeb1c6ae1b41$var$deg2rad$1;
    const cosh = Math.cos(hRad);
    const sinh = Math.sin(hRad);
    let Jroot = 0;
    if (cam162.J !== void 0) Jroot = $8a5cbeb1c6ae1b41$var$spow(cam162.J, 0.5) * 0.1;
    else if (cam162.Q !== void 0) Jroot = 0.25 * env.c * cam162.Q / ((env.aW + 4) * env.flRoot);
    let alpha = 0;
    if (cam162.C !== void 0) alpha = cam162.C / Jroot;
    else if (cam162.M !== void 0) alpha = cam162.M / env.flRoot / Jroot;
    else if (cam162.s !== void 0) alpha = 4e-4 * cam162.s ** 2 * (env.aW + 4) / env.c;
    const t = $8a5cbeb1c6ae1b41$var$spow(alpha * Math.pow(1.64 - Math.pow(0.29, env.n), -0.73), 10 / 9);
    const et = 0.25 * (Math.cos(hRad + 2) + 3.8);
    const A = env.aW * $8a5cbeb1c6ae1b41$var$spow(Jroot, 2 / env.c / env.z);
    const p1 = 5e4 / 13 * env.nc * env.ncb * et;
    const p2 = A / env.nbb;
    const r = 23 * (p2 + 0.305) * $8a5cbeb1c6ae1b41$var$zdiv(t, 23 * p1 + t * (11 * cosh + 108 * sinh));
    const a2 = r * cosh;
    const b2 = r * sinh;
    const rgb_c = $8a5cbeb1c6ae1b41$var$unadapt($8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$m1, [
        p2,
        a2,
        b2
    ]).map((c4)=>{
        return c4 * 1 / 1403;
    }), env.fl);
    return $8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$cat16Inv, rgb_c.map((c4, i)=>{
        return c4 * env.dRgbInv[i];
    })).map((c4)=>{
        return c4 / 100;
    });
}
function $8a5cbeb1c6ae1b41$var$toCam16(xyzd65, env) {
    const xyz100 = xyzd65.map((c4)=>{
        return c4 * 100;
    });
    const rgbA = $8a5cbeb1c6ae1b41$var$adapt$1($8a5cbeb1c6ae1b41$var$multiplyMatrices($8a5cbeb1c6ae1b41$var$cat16, xyz100).map((c4, i)=>{
        return c4 * env.dRgb[i];
    }), env.fl);
    const a2 = rgbA[0] + (-12 * rgbA[1] + rgbA[2]) / 11;
    const b2 = (rgbA[0] + rgbA[1] - 2 * rgbA[2]) / 9;
    const hRad = (Math.atan2(b2, a2) % $8a5cbeb1c6ae1b41$var$tau + $8a5cbeb1c6ae1b41$var$tau) % $8a5cbeb1c6ae1b41$var$tau;
    const et = 0.25 * (Math.cos(hRad + 2) + 3.8);
    const t = 5e4 / 13 * env.nc * env.ncb * $8a5cbeb1c6ae1b41$var$zdiv(et * Math.sqrt(a2 ** 2 + b2 ** 2), rgbA[0] + rgbA[1] + 1.05 * rgbA[2] + 0.305);
    const alpha = $8a5cbeb1c6ae1b41$var$spow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, env.n), 0.73);
    const A = env.nbb * (2 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]);
    const Jroot = $8a5cbeb1c6ae1b41$var$spow(A / env.aW, 0.5 * env.c * env.z);
    const J = 100 * $8a5cbeb1c6ae1b41$var$spow(Jroot, 2);
    const Q = 4 / env.c * Jroot * (env.aW + 4) * env.flRoot;
    const C = alpha * Jroot;
    const M = C * env.flRoot;
    const h = $8a5cbeb1c6ae1b41$var$constrain(hRad * $8a5cbeb1c6ae1b41$var$rad2deg);
    const H = $8a5cbeb1c6ae1b41$var$hueQuadrature(h);
    const s = 50 * $8a5cbeb1c6ae1b41$var$spow(env.c * alpha / (env.aW + 4), 0.5);
    return {
        J: J,
        C: C,
        h: h,
        s: s,
        Q: Q,
        M: M,
        H: H
    };
}
var $8a5cbeb1c6ae1b41$var$cam16 = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "cam16-jmh",
    cssId: "--cam16-jmh",
    name: "CAM16-JMh",
    coords: {
        j: {
            refRange: [
                0,
                100
            ],
            name: "J"
        },
        m: {
            refRange: [
                0,
                105
            ],
            name: "Colorfulness"
        },
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$xyz_d65,
    fromBase (xyz) {
        const cam162 = $8a5cbeb1c6ae1b41$var$toCam16(xyz, $8a5cbeb1c6ae1b41$var$viewingConditions$1);
        return [
            cam162.J,
            cam162.M,
            cam162.h
        ];
    },
    toBase (cam162) {
        return $8a5cbeb1c6ae1b41$var$fromCam16({
            J: cam162[0],
            M: cam162[1],
            h: cam162[2]
        }, $8a5cbeb1c6ae1b41$var$viewingConditions$1);
    }
});
var $8a5cbeb1c6ae1b41$var$white$2 = $8a5cbeb1c6ae1b41$var$WHITES.D65;
var $8a5cbeb1c6ae1b41$var$\u03B5$4 = 216 / 24389;
var $8a5cbeb1c6ae1b41$var$\u03BA$3 = 24389 / 27;
function $8a5cbeb1c6ae1b41$var$toLstar(y) {
    const fy = y > $8a5cbeb1c6ae1b41$var$\u03B5$4 ? Math.cbrt(y) : ($8a5cbeb1c6ae1b41$var$\u03BA$3 * y + 16) / 116;
    return 116 * fy - 16;
}
function $8a5cbeb1c6ae1b41$var$fromLstar(lstar) {
    return lstar > 8 ? Math.pow((lstar + 16) / 116, 3) : lstar / $8a5cbeb1c6ae1b41$var$\u03BA$3;
}
function $8a5cbeb1c6ae1b41$var$fromHct(coords, env) {
    let [h, c4, t] = coords;
    let xyz = [];
    let j = 0;
    if (t === 0) return [
        0,
        0,
        0
    ];
    let y = $8a5cbeb1c6ae1b41$var$fromLstar(t);
    if (t > 0) j = 0.00379058511492914 * t ** 2 + 0.608983189401032 * t + 0.9155088574762233;
    else j = 9514440756550361e-21 * t ** 2 + 0.08693057439788597 * t - 21.928975842194614;
    const threshold = 2e-12;
    const max_attempts = 15;
    let attempt = 0;
    let last2 = Infinity;
    while(attempt <= max_attempts){
        xyz = $8a5cbeb1c6ae1b41$var$fromCam16({
            J: j,
            C: c4,
            h: h
        }, env);
        const delta = Math.abs(xyz[1] - y);
        if (delta < last2) {
            if (delta <= threshold) return xyz;
            last2 = delta;
        }
        j = j - (xyz[1] - y) * j / (2 * xyz[1]);
        attempt += 1;
    }
    return $8a5cbeb1c6ae1b41$var$fromCam16({
        J: j,
        C: c4,
        h: h
    }, env);
}
function $8a5cbeb1c6ae1b41$var$toHct(xyz, env) {
    const t = $8a5cbeb1c6ae1b41$var$toLstar(xyz[1]);
    if (t === 0) return [
        0,
        0,
        0
    ];
    const cam162 = $8a5cbeb1c6ae1b41$var$toCam16(xyz, $8a5cbeb1c6ae1b41$var$viewingConditions);
    return [
        $8a5cbeb1c6ae1b41$var$constrain(cam162.h),
        cam162.C,
        t
    ];
}
var $8a5cbeb1c6ae1b41$var$viewingConditions = $8a5cbeb1c6ae1b41$var$environment($8a5cbeb1c6ae1b41$var$white$2, 200 / Math.PI * $8a5cbeb1c6ae1b41$var$fromLstar(50), $8a5cbeb1c6ae1b41$var$fromLstar(50) * 100, "average", false);
var $8a5cbeb1c6ae1b41$var$hct = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "hct",
    name: "HCT",
    coords: {
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        },
        c: {
            refRange: [
                0,
                145
            ],
            name: "Colorfulness"
        },
        t: {
            refRange: [
                0,
                100
            ],
            name: "Tone"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$xyz_d65,
    fromBase (xyz) {
        return $8a5cbeb1c6ae1b41$var$toHct(xyz);
    },
    toBase (hct2) {
        return $8a5cbeb1c6ae1b41$var$fromHct(hct2, $8a5cbeb1c6ae1b41$var$viewingConditions);
    },
    formats: {
        color: {
            id: "--hct",
            coords: [
                "<number> | <angle>",
                "<percentage> | <number>",
                "<percentage> | <number>"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$deg2rad = Math.PI / 180;
var $8a5cbeb1c6ae1b41$var$ucsCoeff = [
    1,
    7e-3,
    0.0228
];
function $8a5cbeb1c6ae1b41$var$convertUcsAb(coords) {
    if (coords[1] < 0) coords = $8a5cbeb1c6ae1b41$var$hct.fromBase($8a5cbeb1c6ae1b41$var$hct.toBase(coords));
    const M = Math.log(Math.max(1 + $8a5cbeb1c6ae1b41$var$ucsCoeff[2] * coords[1] * $8a5cbeb1c6ae1b41$var$viewingConditions.flRoot, 1)) / $8a5cbeb1c6ae1b41$var$ucsCoeff[2];
    const hrad = coords[0] * $8a5cbeb1c6ae1b41$var$deg2rad;
    const a2 = M * Math.cos(hrad);
    const b2 = M * Math.sin(hrad);
    return [
        coords[2],
        a2,
        b2
    ];
}
function $8a5cbeb1c6ae1b41$var$deltaEHCT(color, sample) {
    [color, sample] = $8a5cbeb1c6ae1b41$var$getColor([
        color,
        sample
    ]);
    let [t1, a1, b1] = $8a5cbeb1c6ae1b41$var$convertUcsAb($8a5cbeb1c6ae1b41$var$hct.from(color));
    let [t2, a2, b2] = $8a5cbeb1c6ae1b41$var$convertUcsAb($8a5cbeb1c6ae1b41$var$hct.from(sample));
    return Math.sqrt((t1 - t2) ** 2 + (a1 - a2) ** 2 + (b1 - b2) ** 2);
}
var $8a5cbeb1c6ae1b41$var$deltaEMethods = {
    deltaE76: $8a5cbeb1c6ae1b41$var$deltaE76,
    deltaECMC: $8a5cbeb1c6ae1b41$var$deltaECMC,
    deltaE2000: $8a5cbeb1c6ae1b41$var$deltaE2000,
    deltaEJz: $8a5cbeb1c6ae1b41$var$deltaEJz,
    deltaEITP: $8a5cbeb1c6ae1b41$var$deltaEITP,
    deltaEOK: $8a5cbeb1c6ae1b41$var$deltaEOK,
    deltaEHCT: $8a5cbeb1c6ae1b41$var$deltaEHCT
};
function $8a5cbeb1c6ae1b41$var$calcEpsilon(jnd) {
    const order = !jnd ? 0 : Math.floor(Math.log10(Math.abs(jnd)));
    return Math.max(parseFloat(`1e${order - 2}`), 1e-6);
}
var $8a5cbeb1c6ae1b41$var$GMAPPRESET = {
    "hct": {
        method: "hct.c",
        jnd: 2,
        deltaEMethod: "hct",
        blackWhiteClamp: {}
    },
    "hct-tonal": {
        method: "hct.c",
        jnd: 0,
        deltaEMethod: "hct",
        blackWhiteClamp: {
            channel: "hct.t",
            min: 0,
            max: 100
        }
    }
};
function $8a5cbeb1c6ae1b41$var$toGamut(color, { method: method = $8a5cbeb1c6ae1b41$var$defaults.gamut_mapping, space: space, deltaEMethod: deltaEMethod = "", jnd: jnd = 2, blackWhiteClamp: blackWhiteClamp = {} } = {}) {
    color = $8a5cbeb1c6ae1b41$var$getColor(color);
    if ($8a5cbeb1c6ae1b41$var$isString(arguments[1])) space = arguments[1];
    else if (!space) space = color.space;
    space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    if ($8a5cbeb1c6ae1b41$var$inGamut(color, space, {
        epsilon: 0
    })) return color;
    let spaceColor;
    if (method === "css") spaceColor = $8a5cbeb1c6ae1b41$var$toGamutCSS(color, {
        space: space
    });
    else {
        if (method !== "clip" && !$8a5cbeb1c6ae1b41$var$inGamut(color, space)) {
            if (Object.prototype.hasOwnProperty.call($8a5cbeb1c6ae1b41$var$GMAPPRESET, method)) ({ method: method, jnd: jnd, deltaEMethod: deltaEMethod, blackWhiteClamp: blackWhiteClamp } = $8a5cbeb1c6ae1b41$var$GMAPPRESET[method]);
            let de = $8a5cbeb1c6ae1b41$var$deltaE2000;
            if (deltaEMethod !== "") {
                for(let m3 in $8a5cbeb1c6ae1b41$var$deltaEMethods)if ("deltae" + deltaEMethod.toLowerCase() === m3.toLowerCase()) {
                    de = $8a5cbeb1c6ae1b41$var$deltaEMethods[m3];
                    break;
                }
            }
            let clipped = $8a5cbeb1c6ae1b41$var$toGamut($8a5cbeb1c6ae1b41$var$to(color, space), {
                method: "clip",
                space: space
            });
            if (de(color, clipped) > jnd) {
                if (Object.keys(blackWhiteClamp).length === 3) {
                    let channelMeta = $8a5cbeb1c6ae1b41$var$ColorSpace.resolveCoord(blackWhiteClamp.channel);
                    let channel = $8a5cbeb1c6ae1b41$var$get($8a5cbeb1c6ae1b41$var$to(color, channelMeta.space), channelMeta.id);
                    if ($8a5cbeb1c6ae1b41$var$isNone(channel)) channel = 0;
                    if (channel >= blackWhiteClamp.max) return $8a5cbeb1c6ae1b41$var$to({
                        space: "xyz-d65",
                        coords: $8a5cbeb1c6ae1b41$var$WHITES["D65"]
                    }, color.space);
                    else if (channel <= blackWhiteClamp.min) return $8a5cbeb1c6ae1b41$var$to({
                        space: "xyz-d65",
                        coords: [
                            0,
                            0,
                            0
                        ]
                    }, color.space);
                }
                let coordMeta = $8a5cbeb1c6ae1b41$var$ColorSpace.resolveCoord(method);
                let mapSpace = coordMeta.space;
                let coordId = coordMeta.id;
                let mappedColor = $8a5cbeb1c6ae1b41$var$to(color, mapSpace);
                mappedColor.coords.forEach((c4, i)=>{
                    if ($8a5cbeb1c6ae1b41$var$isNone(c4)) mappedColor.coords[i] = 0;
                });
                let bounds = coordMeta.range || coordMeta.refRange;
                let min = bounds[0];
                let \u03B52 = $8a5cbeb1c6ae1b41$var$calcEpsilon(jnd);
                let low = min;
                let high = $8a5cbeb1c6ae1b41$var$get(mappedColor, coordId);
                while(high - low > \u03B52){
                    let clipped2 = $8a5cbeb1c6ae1b41$var$clone(mappedColor);
                    clipped2 = $8a5cbeb1c6ae1b41$var$toGamut(clipped2, {
                        space: space,
                        method: "clip"
                    });
                    let deltaE2 = de(mappedColor, clipped2);
                    if (deltaE2 - jnd < \u03B52) low = $8a5cbeb1c6ae1b41$var$get(mappedColor, coordId);
                    else high = $8a5cbeb1c6ae1b41$var$get(mappedColor, coordId);
                    $8a5cbeb1c6ae1b41$var$set(mappedColor, coordId, (low + high) / 2);
                }
                spaceColor = $8a5cbeb1c6ae1b41$var$to(mappedColor, space);
            } else spaceColor = clipped;
        } else spaceColor = $8a5cbeb1c6ae1b41$var$to(color, space);
        if (method === "clip" || !$8a5cbeb1c6ae1b41$var$inGamut(spaceColor, space, {
            epsilon: 0
        })) {
            let bounds = Object.values(space.coords).map((c4)=>c4.range || []);
            spaceColor.coords = spaceColor.coords.map((c4, i)=>{
                let [min, max2] = bounds[i];
                if (min !== void 0) c4 = Math.max(min, c4);
                if (max2 !== void 0) c4 = Math.min(c4, max2);
                return c4;
            });
        }
    }
    if (space !== color.space) spaceColor = $8a5cbeb1c6ae1b41$var$to(spaceColor, color.space);
    color.coords = spaceColor.coords;
    return color;
}
$8a5cbeb1c6ae1b41$var$toGamut.returns = "color";
var $8a5cbeb1c6ae1b41$var$COLORS = {
    WHITE: {
        space: $8a5cbeb1c6ae1b41$var$OKLab,
        coords: [
            1,
            0,
            0
        ]
    },
    BLACK: {
        space: $8a5cbeb1c6ae1b41$var$OKLab,
        coords: [
            0,
            0,
            0
        ]
    }
};
function $8a5cbeb1c6ae1b41$var$toGamutCSS(origin, { space: space } = {}) {
    const JND = 0.02;
    const \u03B52 = 1e-4;
    origin = $8a5cbeb1c6ae1b41$var$getColor(origin);
    if (!space) space = origin.space;
    space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    const oklchSpace = $8a5cbeb1c6ae1b41$var$ColorSpace.get("oklch");
    if (space.isUnbounded) return $8a5cbeb1c6ae1b41$var$to(origin, space);
    const origin_OKLCH = $8a5cbeb1c6ae1b41$var$to(origin, oklchSpace);
    let L = origin_OKLCH.coords[0];
    if (L >= 1) {
        const white2 = $8a5cbeb1c6ae1b41$var$to($8a5cbeb1c6ae1b41$var$COLORS.WHITE, space);
        white2.alpha = origin.alpha;
        return $8a5cbeb1c6ae1b41$var$to(white2, space);
    }
    if (L <= 0) {
        const black = $8a5cbeb1c6ae1b41$var$to($8a5cbeb1c6ae1b41$var$COLORS.BLACK, space);
        black.alpha = origin.alpha;
        return $8a5cbeb1c6ae1b41$var$to(black, space);
    }
    if ($8a5cbeb1c6ae1b41$var$inGamut(origin_OKLCH, space, {
        epsilon: 0
    })) return $8a5cbeb1c6ae1b41$var$to(origin_OKLCH, space);
    function clip(_color) {
        const destColor = $8a5cbeb1c6ae1b41$var$to(_color, space);
        const spaceCoords = Object.values(space.coords);
        destColor.coords = destColor.coords.map((coord, index)=>{
            if ("range" in spaceCoords[index]) {
                const [min2, max3] = spaceCoords[index].range;
                return $8a5cbeb1c6ae1b41$var$clamp2(min2, coord, max3);
            }
            return coord;
        });
        return destColor;
    }
    let min = 0;
    let max2 = origin_OKLCH.coords[1];
    let min_inGamut = true;
    let current = $8a5cbeb1c6ae1b41$var$clone(origin_OKLCH);
    let clipped = clip(current);
    let E = $8a5cbeb1c6ae1b41$var$deltaEOK(clipped, current);
    if (E < JND) return clipped;
    while(max2 - min > \u03B52){
        const chroma = (min + max2) / 2;
        current.coords[1] = chroma;
        if (min_inGamut && $8a5cbeb1c6ae1b41$var$inGamut(current, space, {
            epsilon: 0
        })) min = chroma;
        else {
            clipped = clip(current);
            E = $8a5cbeb1c6ae1b41$var$deltaEOK(clipped, current);
            if (E < JND) {
                if (JND - E < \u03B52) break;
                else {
                    min_inGamut = false;
                    min = chroma;
                }
            } else max2 = chroma;
        }
    }
    return clipped;
}
function $8a5cbeb1c6ae1b41$var$to(color, space, { inGamut: inGamut2 } = {}) {
    color = $8a5cbeb1c6ae1b41$var$getColor(color);
    space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    let coords = space.from(color);
    let ret = {
        space: space,
        coords: coords,
        alpha: color.alpha
    };
    if (inGamut2) ret = $8a5cbeb1c6ae1b41$var$toGamut(ret, inGamut2 === true ? void 0 : inGamut2);
    return ret;
}
$8a5cbeb1c6ae1b41$var$to.returns = "color";
function $8a5cbeb1c6ae1b41$var$serialize(color, { precision: precision = $8a5cbeb1c6ae1b41$var$defaults.precision, format: format = "default", inGamut: inGamut$1 = true, ...customOptions } = {}) {
    let ret;
    color = $8a5cbeb1c6ae1b41$var$getColor(color);
    let formatId = format;
    format = color.space.getFormat(format) ?? color.space.getFormat("default") ?? $8a5cbeb1c6ae1b41$var$ColorSpace.DEFAULT_FORMAT;
    let coords = color.coords.slice();
    inGamut$1 ||= format.toGamut;
    if (inGamut$1 && !$8a5cbeb1c6ae1b41$var$inGamut(color)) coords = $8a5cbeb1c6ae1b41$var$toGamut($8a5cbeb1c6ae1b41$var$clone(color), inGamut$1 === true ? void 0 : inGamut$1).coords;
    if (format.type === "custom") {
        customOptions.precision = precision;
        if (format.serialize) ret = format.serialize(coords, color.alpha, customOptions);
        else throw new TypeError(`format ${formatId} can only be used to parse colors, not for serialization`);
    } else {
        let name = format.name || "color";
        if (format.serializeCoords) coords = format.serializeCoords(coords, precision);
        else if (precision !== null) coords = coords.map((c4)=>{
            return $8a5cbeb1c6ae1b41$var$serializeNumber(c4, {
                precision: precision
            });
        });
        let args = [
            ...coords
        ];
        if (name === "color") {
            let cssId = format.id || format.ids?.[0] || color.space.id;
            args.unshift(cssId);
        }
        let alpha = color.alpha;
        if (precision !== null) alpha = $8a5cbeb1c6ae1b41$var$serializeNumber(alpha, {
            precision: precision
        });
        let strAlpha = color.alpha >= 1 || format.noAlpha ? "" : `${format.commas ? "," : " /"} ${alpha}`;
        ret = `${name}(${args.join(format.commas ? ", " : " ")}${strAlpha})`;
    }
    return ret;
}
var $8a5cbeb1c6ae1b41$var$toXYZ_M$5 = [
    [
        0.6369580483012914,
        0.14461690358620832,
        0.1688809751641721
    ],
    [
        0.2627002120112671,
        0.6779980715188708,
        0.05930171646986196
    ],
    [
        0,
        0.028072693049087428,
        1.060985057710791
    ]
];
var $8a5cbeb1c6ae1b41$var$fromXYZ_M$5 = [
    [
        1.716651187971268,
        -0.355670783776392,
        -0.25336628137366
    ],
    [
        -0.666684351832489,
        1.616481236634939,
        0.0157685458139111
    ],
    [
        0.017639857445311,
        -0.042770613257809,
        0.942103121235474
    ]
];
var $8a5cbeb1c6ae1b41$var$REC2020Linear = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "rec2020-linear",
    cssId: "--rec2020-linear",
    name: "Linear REC.2020",
    white: "D65",
    toXYZ_M: $8a5cbeb1c6ae1b41$var$toXYZ_M$5,
    fromXYZ_M: $8a5cbeb1c6ae1b41$var$fromXYZ_M$5
});
var $8a5cbeb1c6ae1b41$var$\u03B1 = 1.09929682680944;
var $8a5cbeb1c6ae1b41$var$\u03B2 = 0.018053968510807;
var $8a5cbeb1c6ae1b41$var$REC2020 = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "rec2020",
    name: "REC.2020",
    base: $8a5cbeb1c6ae1b41$var$REC2020Linear,
    // Non-linear transfer function from Rec. ITU-R BT.2020-2 table 4
    toBase (RGB) {
        return RGB.map(function(val) {
            if (val < $8a5cbeb1c6ae1b41$var$\u03B2 * 4.5) return val / 4.5;
            return Math.pow((val + $8a5cbeb1c6ae1b41$var$\u03B1 - 1) / $8a5cbeb1c6ae1b41$var$\u03B1, 1 / 0.45);
        });
    },
    fromBase (RGB) {
        return RGB.map(function(val) {
            if (val >= $8a5cbeb1c6ae1b41$var$\u03B2) return $8a5cbeb1c6ae1b41$var$\u03B1 * Math.pow(val, 0.45) - ($8a5cbeb1c6ae1b41$var$\u03B1 - 1);
            return 4.5 * val;
        });
    }
});
var $8a5cbeb1c6ae1b41$var$toXYZ_M$4 = [
    [
        0.4865709486482162,
        0.26566769316909306,
        0.1982172852343625
    ],
    [
        0.2289745640697488,
        0.6917385218365064,
        0.079286914093745
    ],
    [
        0,
        0.04511338185890264,
        1.043944368900976
    ]
];
var $8a5cbeb1c6ae1b41$var$fromXYZ_M$4 = [
    [
        2.493496911941425,
        -0.9313836179191239,
        -0.40271078445071684
    ],
    [
        -0.8294889695615747,
        1.7626640603183463,
        0.023624685841943577
    ],
    [
        0.03584583024378447,
        -0.07617238926804182,
        0.9568845240076872
    ]
];
var $8a5cbeb1c6ae1b41$var$P3Linear = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "p3-linear",
    cssId: "--display-p3-linear",
    name: "Linear P3",
    white: "D65",
    toXYZ_M: $8a5cbeb1c6ae1b41$var$toXYZ_M$4,
    fromXYZ_M: $8a5cbeb1c6ae1b41$var$fromXYZ_M$4
});
var $8a5cbeb1c6ae1b41$var$toXYZ_M$3 = [
    [
        0.41239079926595934,
        0.357584339383878,
        0.1804807884018343
    ],
    [
        0.21263900587151027,
        0.715168678767756,
        0.07219231536073371
    ],
    [
        0.01933081871559182,
        0.11919477979462598,
        0.9505321522496607
    ]
];
var $8a5cbeb1c6ae1b41$var$fromXYZ_M$3 = [
    [
        3.2409699419045226,
        -1.537383177570094,
        -0.4986107602930034
    ],
    [
        -0.9692436362808796,
        1.8759675015077202,
        0.04155505740717559
    ],
    [
        0.05563007969699366,
        -0.20397695888897652,
        1.0569715142428786
    ]
];
var $8a5cbeb1c6ae1b41$var$sRGBLinear = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "srgb-linear",
    name: "Linear sRGB",
    white: "D65",
    toXYZ_M: $8a5cbeb1c6ae1b41$var$toXYZ_M$3,
    fromXYZ_M: $8a5cbeb1c6ae1b41$var$fromXYZ_M$3
});
var $8a5cbeb1c6ae1b41$var$KEYWORDS = {
    "aliceblue": [
        240 / 255,
        248 / 255,
        1
    ],
    "antiquewhite": [
        250 / 255,
        235 / 255,
        215 / 255
    ],
    "aqua": [
        0,
        1,
        1
    ],
    "aquamarine": [
        127 / 255,
        1,
        212 / 255
    ],
    "azure": [
        240 / 255,
        1,
        1
    ],
    "beige": [
        245 / 255,
        245 / 255,
        220 / 255
    ],
    "bisque": [
        1,
        228 / 255,
        196 / 255
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        1,
        235 / 255,
        205 / 255
    ],
    "blue": [
        0,
        0,
        1
    ],
    "blueviolet": [
        138 / 255,
        43 / 255,
        226 / 255
    ],
    "brown": [
        165 / 255,
        42 / 255,
        42 / 255
    ],
    "burlywood": [
        222 / 255,
        184 / 255,
        135 / 255
    ],
    "cadetblue": [
        95 / 255,
        158 / 255,
        160 / 255
    ],
    "chartreuse": [
        127 / 255,
        1,
        0
    ],
    "chocolate": [
        210 / 255,
        105 / 255,
        30 / 255
    ],
    "coral": [
        1,
        127 / 255,
        80 / 255
    ],
    "cornflowerblue": [
        100 / 255,
        149 / 255,
        237 / 255
    ],
    "cornsilk": [
        1,
        248 / 255,
        220 / 255
    ],
    "crimson": [
        220 / 255,
        20 / 255,
        60 / 255
    ],
    "cyan": [
        0,
        1,
        1
    ],
    "darkblue": [
        0,
        0,
        139 / 255
    ],
    "darkcyan": [
        0,
        139 / 255,
        139 / 255
    ],
    "darkgoldenrod": [
        184 / 255,
        134 / 255,
        11 / 255
    ],
    "darkgray": [
        169 / 255,
        169 / 255,
        169 / 255
    ],
    "darkgreen": [
        0,
        100 / 255,
        0
    ],
    "darkgrey": [
        169 / 255,
        169 / 255,
        169 / 255
    ],
    "darkkhaki": [
        189 / 255,
        183 / 255,
        107 / 255
    ],
    "darkmagenta": [
        139 / 255,
        0,
        139 / 255
    ],
    "darkolivegreen": [
        85 / 255,
        107 / 255,
        47 / 255
    ],
    "darkorange": [
        1,
        140 / 255,
        0
    ],
    "darkorchid": [
        0.6,
        50 / 255,
        0.8
    ],
    "darkred": [
        139 / 255,
        0,
        0
    ],
    "darksalmon": [
        233 / 255,
        150 / 255,
        122 / 255
    ],
    "darkseagreen": [
        143 / 255,
        188 / 255,
        143 / 255
    ],
    "darkslateblue": [
        72 / 255,
        61 / 255,
        139 / 255
    ],
    "darkslategray": [
        47 / 255,
        79 / 255,
        79 / 255
    ],
    "darkslategrey": [
        47 / 255,
        79 / 255,
        79 / 255
    ],
    "darkturquoise": [
        0,
        206 / 255,
        209 / 255
    ],
    "darkviolet": [
        148 / 255,
        0,
        211 / 255
    ],
    "deeppink": [
        1,
        20 / 255,
        147 / 255
    ],
    "deepskyblue": [
        0,
        191 / 255,
        1
    ],
    "dimgray": [
        105 / 255,
        105 / 255,
        105 / 255
    ],
    "dimgrey": [
        105 / 255,
        105 / 255,
        105 / 255
    ],
    "dodgerblue": [
        30 / 255,
        144 / 255,
        1
    ],
    "firebrick": [
        178 / 255,
        34 / 255,
        34 / 255
    ],
    "floralwhite": [
        1,
        250 / 255,
        240 / 255
    ],
    "forestgreen": [
        34 / 255,
        139 / 255,
        34 / 255
    ],
    "fuchsia": [
        1,
        0,
        1
    ],
    "gainsboro": [
        220 / 255,
        220 / 255,
        220 / 255
    ],
    "ghostwhite": [
        248 / 255,
        248 / 255,
        1
    ],
    "gold": [
        1,
        215 / 255,
        0
    ],
    "goldenrod": [
        218 / 255,
        165 / 255,
        32 / 255
    ],
    "gray": [
        128 / 255,
        128 / 255,
        128 / 255
    ],
    "green": [
        0,
        128 / 255,
        0
    ],
    "greenyellow": [
        173 / 255,
        1,
        47 / 255
    ],
    "grey": [
        128 / 255,
        128 / 255,
        128 / 255
    ],
    "honeydew": [
        240 / 255,
        1,
        240 / 255
    ],
    "hotpink": [
        1,
        105 / 255,
        180 / 255
    ],
    "indianred": [
        205 / 255,
        92 / 255,
        92 / 255
    ],
    "indigo": [
        75 / 255,
        0,
        130 / 255
    ],
    "ivory": [
        1,
        1,
        240 / 255
    ],
    "khaki": [
        240 / 255,
        230 / 255,
        140 / 255
    ],
    "lavender": [
        230 / 255,
        230 / 255,
        250 / 255
    ],
    "lavenderblush": [
        1,
        240 / 255,
        245 / 255
    ],
    "lawngreen": [
        124 / 255,
        252 / 255,
        0
    ],
    "lemonchiffon": [
        1,
        250 / 255,
        205 / 255
    ],
    "lightblue": [
        173 / 255,
        216 / 255,
        230 / 255
    ],
    "lightcoral": [
        240 / 255,
        128 / 255,
        128 / 255
    ],
    "lightcyan": [
        224 / 255,
        1,
        1
    ],
    "lightgoldenrodyellow": [
        250 / 255,
        250 / 255,
        210 / 255
    ],
    "lightgray": [
        211 / 255,
        211 / 255,
        211 / 255
    ],
    "lightgreen": [
        144 / 255,
        238 / 255,
        144 / 255
    ],
    "lightgrey": [
        211 / 255,
        211 / 255,
        211 / 255
    ],
    "lightpink": [
        1,
        182 / 255,
        193 / 255
    ],
    "lightsalmon": [
        1,
        160 / 255,
        122 / 255
    ],
    "lightseagreen": [
        32 / 255,
        178 / 255,
        170 / 255
    ],
    "lightskyblue": [
        135 / 255,
        206 / 255,
        250 / 255
    ],
    "lightslategray": [
        119 / 255,
        136 / 255,
        0.6
    ],
    "lightslategrey": [
        119 / 255,
        136 / 255,
        0.6
    ],
    "lightsteelblue": [
        176 / 255,
        196 / 255,
        222 / 255
    ],
    "lightyellow": [
        1,
        1,
        224 / 255
    ],
    "lime": [
        0,
        1,
        0
    ],
    "limegreen": [
        50 / 255,
        205 / 255,
        50 / 255
    ],
    "linen": [
        250 / 255,
        240 / 255,
        230 / 255
    ],
    "magenta": [
        1,
        0,
        1
    ],
    "maroon": [
        128 / 255,
        0,
        0
    ],
    "mediumaquamarine": [
        0.4,
        205 / 255,
        170 / 255
    ],
    "mediumblue": [
        0,
        0,
        205 / 255
    ],
    "mediumorchid": [
        186 / 255,
        85 / 255,
        211 / 255
    ],
    "mediumpurple": [
        147 / 255,
        112 / 255,
        219 / 255
    ],
    "mediumseagreen": [
        60 / 255,
        179 / 255,
        113 / 255
    ],
    "mediumslateblue": [
        123 / 255,
        104 / 255,
        238 / 255
    ],
    "mediumspringgreen": [
        0,
        250 / 255,
        154 / 255
    ],
    "mediumturquoise": [
        72 / 255,
        209 / 255,
        0.8
    ],
    "mediumvioletred": [
        199 / 255,
        21 / 255,
        133 / 255
    ],
    "midnightblue": [
        25 / 255,
        25 / 255,
        112 / 255
    ],
    "mintcream": [
        245 / 255,
        1,
        250 / 255
    ],
    "mistyrose": [
        1,
        228 / 255,
        225 / 255
    ],
    "moccasin": [
        1,
        228 / 255,
        181 / 255
    ],
    "navajowhite": [
        1,
        222 / 255,
        173 / 255
    ],
    "navy": [
        0,
        0,
        128 / 255
    ],
    "oldlace": [
        253 / 255,
        245 / 255,
        230 / 255
    ],
    "olive": [
        128 / 255,
        128 / 255,
        0
    ],
    "olivedrab": [
        107 / 255,
        142 / 255,
        35 / 255
    ],
    "orange": [
        1,
        165 / 255,
        0
    ],
    "orangered": [
        1,
        69 / 255,
        0
    ],
    "orchid": [
        218 / 255,
        112 / 255,
        214 / 255
    ],
    "palegoldenrod": [
        238 / 255,
        232 / 255,
        170 / 255
    ],
    "palegreen": [
        152 / 255,
        251 / 255,
        152 / 255
    ],
    "paleturquoise": [
        175 / 255,
        238 / 255,
        238 / 255
    ],
    "palevioletred": [
        219 / 255,
        112 / 255,
        147 / 255
    ],
    "papayawhip": [
        1,
        239 / 255,
        213 / 255
    ],
    "peachpuff": [
        1,
        218 / 255,
        185 / 255
    ],
    "peru": [
        205 / 255,
        133 / 255,
        63 / 255
    ],
    "pink": [
        1,
        192 / 255,
        203 / 255
    ],
    "plum": [
        221 / 255,
        160 / 255,
        221 / 255
    ],
    "powderblue": [
        176 / 255,
        224 / 255,
        230 / 255
    ],
    "purple": [
        128 / 255,
        0,
        128 / 255
    ],
    "rebeccapurple": [
        0.4,
        0.2,
        0.6
    ],
    "red": [
        1,
        0,
        0
    ],
    "rosybrown": [
        188 / 255,
        143 / 255,
        143 / 255
    ],
    "royalblue": [
        65 / 255,
        105 / 255,
        225 / 255
    ],
    "saddlebrown": [
        139 / 255,
        69 / 255,
        19 / 255
    ],
    "salmon": [
        250 / 255,
        128 / 255,
        114 / 255
    ],
    "sandybrown": [
        244 / 255,
        164 / 255,
        96 / 255
    ],
    "seagreen": [
        46 / 255,
        139 / 255,
        87 / 255
    ],
    "seashell": [
        1,
        245 / 255,
        238 / 255
    ],
    "sienna": [
        160 / 255,
        82 / 255,
        45 / 255
    ],
    "silver": [
        192 / 255,
        192 / 255,
        192 / 255
    ],
    "skyblue": [
        135 / 255,
        206 / 255,
        235 / 255
    ],
    "slateblue": [
        106 / 255,
        90 / 255,
        205 / 255
    ],
    "slategray": [
        112 / 255,
        128 / 255,
        144 / 255
    ],
    "slategrey": [
        112 / 255,
        128 / 255,
        144 / 255
    ],
    "snow": [
        1,
        250 / 255,
        250 / 255
    ],
    "springgreen": [
        0,
        1,
        127 / 255
    ],
    "steelblue": [
        70 / 255,
        130 / 255,
        180 / 255
    ],
    "tan": [
        210 / 255,
        180 / 255,
        140 / 255
    ],
    "teal": [
        0,
        128 / 255,
        128 / 255
    ],
    "thistle": [
        216 / 255,
        191 / 255,
        216 / 255
    ],
    "tomato": [
        1,
        99 / 255,
        71 / 255
    ],
    "turquoise": [
        64 / 255,
        224 / 255,
        208 / 255
    ],
    "violet": [
        238 / 255,
        130 / 255,
        238 / 255
    ],
    "wheat": [
        245 / 255,
        222 / 255,
        179 / 255
    ],
    "white": [
        1,
        1,
        1
    ],
    "whitesmoke": [
        245 / 255,
        245 / 255,
        245 / 255
    ],
    "yellow": [
        1,
        1,
        0
    ],
    "yellowgreen": [
        154 / 255,
        205 / 255,
        50 / 255
    ]
};
var $8a5cbeb1c6ae1b41$var$coordGrammar = Array(3).fill("<percentage> | <number>[0, 255]");
var $8a5cbeb1c6ae1b41$var$coordGrammarNumber = Array(3).fill("<number>[0, 255]");
var $8a5cbeb1c6ae1b41$var$sRGB = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "srgb",
    name: "sRGB",
    base: $8a5cbeb1c6ae1b41$var$sRGBLinear,
    fromBase: (rgb)=>{
        return rgb.map((val)=>{
            let sign = val < 0 ? -1 : 1;
            let abs = val * sign;
            if (abs > 31308e-7) return sign * (1.055 * abs ** (1 / 2.4) - 0.055);
            return 12.92 * val;
        });
    },
    toBase: (rgb)=>{
        return rgb.map((val)=>{
            let sign = val < 0 ? -1 : 1;
            let abs = val * sign;
            if (abs <= 0.04045) return val / 12.92;
            return sign * ((abs + 0.055) / 1.055) ** 2.4;
        });
    },
    formats: {
        "rgb": {
            coords: $8a5cbeb1c6ae1b41$var$coordGrammar
        },
        "rgb_number": {
            name: "rgb",
            commas: true,
            coords: $8a5cbeb1c6ae1b41$var$coordGrammarNumber,
            noAlpha: true
        },
        "color": {
        },
        "rgba": {
            coords: $8a5cbeb1c6ae1b41$var$coordGrammar,
            commas: true,
            lastAlpha: true
        },
        "rgba_number": {
            name: "rgba",
            commas: true,
            coords: $8a5cbeb1c6ae1b41$var$coordGrammarNumber
        },
        "hex": {
            type: "custom",
            toGamut: true,
            test: (str)=>/^#([a-f0-9]{3,4}){1,2}$/i.test(str),
            parse (str) {
                if (str.length <= 5) str = str.replace(/[a-f0-9]/gi, "$&$&");
                let rgba = [];
                str.replace(/[a-f0-9]{2}/gi, (component)=>{
                    rgba.push(parseInt(component, 16) / 255);
                });
                return {
                    spaceId: "srgb",
                    coords: rgba.slice(0, 3),
                    alpha: rgba.slice(3)[0]
                };
            },
            serialize: (coords, alpha, { collapse: collapse = true } = {})=>{
                if (alpha < 1) coords.push(alpha);
                coords = coords.map((c4)=>Math.round(c4 * 255));
                let collapsible = collapse && coords.every((c4)=>c4 % 17 === 0);
                let hex = coords.map((c4)=>{
                    if (collapsible) return (c4 / 17).toString(16);
                    return c4.toString(16).padStart(2, "0");
                }).join("");
                return "#" + hex;
            }
        },
        "keyword": {
            type: "custom",
            test: (str)=>/^[a-z]+$/i.test(str),
            parse (str) {
                str = str.toLowerCase();
                let ret = {
                    spaceId: "srgb",
                    coords: null,
                    alpha: 1
                };
                if (str === "transparent") {
                    ret.coords = $8a5cbeb1c6ae1b41$var$KEYWORDS.black;
                    ret.alpha = 0;
                } else ret.coords = $8a5cbeb1c6ae1b41$var$KEYWORDS[str];
                if (ret.coords) return ret;
            }
        }
    }
});
var $8a5cbeb1c6ae1b41$var$P3 = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "p3",
    cssId: "display-p3",
    name: "P3",
    base: $8a5cbeb1c6ae1b41$var$P3Linear,
    // Gamma encoding/decoding is the same as sRGB
    fromBase: $8a5cbeb1c6ae1b41$var$sRGB.fromBase,
    toBase: $8a5cbeb1c6ae1b41$var$sRGB.toBase
});
$8a5cbeb1c6ae1b41$var$defaults.display_space = $8a5cbeb1c6ae1b41$var$sRGB;
var $8a5cbeb1c6ae1b41$var$supportsNone;
if (typeof CSS !== "undefined" && CSS.supports) for (let space of [
    $8a5cbeb1c6ae1b41$var$lab,
    $8a5cbeb1c6ae1b41$var$REC2020,
    $8a5cbeb1c6ae1b41$var$P3
]){
    let coords = space.getMinCoords();
    let color = {
        space: space,
        coords: coords,
        alpha: 1
    };
    let str = $8a5cbeb1c6ae1b41$var$serialize(color);
    if (CSS.supports("color", str)) {
        $8a5cbeb1c6ae1b41$var$defaults.display_space = space;
        break;
    }
}
function $8a5cbeb1c6ae1b41$var$display(color, { space: space = $8a5cbeb1c6ae1b41$var$defaults.display_space, ...options } = {}) {
    let ret = $8a5cbeb1c6ae1b41$var$serialize(color, options);
    if (typeof CSS === "undefined" || CSS.supports("color", ret) || !$8a5cbeb1c6ae1b41$var$defaults.display_space) {
        ret = new String(ret);
        ret.color = color;
    } else {
        let fallbackColor = color;
        let hasNone = color.coords.some($8a5cbeb1c6ae1b41$var$isNone) || $8a5cbeb1c6ae1b41$var$isNone(color.alpha);
        if (hasNone) {
            if (!($8a5cbeb1c6ae1b41$var$supportsNone ??= CSS.supports("color", "hsl(none 50% 50%)"))) {
                fallbackColor = $8a5cbeb1c6ae1b41$var$clone(color);
                fallbackColor.coords = fallbackColor.coords.map($8a5cbeb1c6ae1b41$var$skipNone);
                fallbackColor.alpha = $8a5cbeb1c6ae1b41$var$skipNone(fallbackColor.alpha);
                ret = $8a5cbeb1c6ae1b41$var$serialize(fallbackColor, options);
                if (CSS.supports("color", ret)) {
                    ret = new String(ret);
                    ret.color = fallbackColor;
                    return ret;
                }
            }
        }
        fallbackColor = $8a5cbeb1c6ae1b41$var$to(fallbackColor, space);
        ret = new String($8a5cbeb1c6ae1b41$var$serialize(fallbackColor, options));
        ret.color = fallbackColor;
    }
    return ret;
}
function $8a5cbeb1c6ae1b41$var$equals(color1, color2) {
    color1 = $8a5cbeb1c6ae1b41$var$getColor(color1);
    color2 = $8a5cbeb1c6ae1b41$var$getColor(color2);
    return color1.space === color2.space && color1.alpha === color2.alpha && color1.coords.every((c4, i)=>c4 === color2.coords[i]);
}
function $8a5cbeb1c6ae1b41$var$getLuminance(color) {
    return $8a5cbeb1c6ae1b41$var$get(color, [
        $8a5cbeb1c6ae1b41$var$xyz_d65,
        "y"
    ]);
}
function $8a5cbeb1c6ae1b41$var$setLuminance(color, value) {
    $8a5cbeb1c6ae1b41$var$set(color, [
        $8a5cbeb1c6ae1b41$var$xyz_d65,
        "y"
    ], value);
}
function $8a5cbeb1c6ae1b41$var$register$2(Color2) {
    Object.defineProperty(Color2.prototype, "luminance", {
        get () {
            return $8a5cbeb1c6ae1b41$var$getLuminance(this);
        },
        set (value) {
            $8a5cbeb1c6ae1b41$var$setLuminance(this, value);
        }
    });
}
var $8a5cbeb1c6ae1b41$var$luminance = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    getLuminance: $8a5cbeb1c6ae1b41$var$getLuminance,
    register: $8a5cbeb1c6ae1b41$var$register$2,
    setLuminance: $8a5cbeb1c6ae1b41$var$setLuminance
});
function $8a5cbeb1c6ae1b41$var$contrastWCAG21(color1, color2) {
    color1 = $8a5cbeb1c6ae1b41$var$getColor(color1);
    color2 = $8a5cbeb1c6ae1b41$var$getColor(color2);
    let Y1 = Math.max($8a5cbeb1c6ae1b41$var$getLuminance(color1), 0);
    let Y2 = Math.max($8a5cbeb1c6ae1b41$var$getLuminance(color2), 0);
    if (Y2 > Y1) [Y1, Y2] = [
        Y2,
        Y1
    ];
    return (Y1 + 0.05) / (Y2 + 0.05);
}
var $8a5cbeb1c6ae1b41$var$normBG = 0.56;
var $8a5cbeb1c6ae1b41$var$normTXT = 0.57;
var $8a5cbeb1c6ae1b41$var$revTXT = 0.62;
var $8a5cbeb1c6ae1b41$var$revBG = 0.65;
var $8a5cbeb1c6ae1b41$var$blkThrs = 0.022;
var $8a5cbeb1c6ae1b41$var$blkClmp = 1.414;
var $8a5cbeb1c6ae1b41$var$loClip = 0.1;
var $8a5cbeb1c6ae1b41$var$deltaYmin = 5e-4;
var $8a5cbeb1c6ae1b41$var$scaleBoW = 1.14;
var $8a5cbeb1c6ae1b41$var$loBoWoffset = 0.027;
var $8a5cbeb1c6ae1b41$var$scaleWoB = 1.14;
function $8a5cbeb1c6ae1b41$var$fclamp(Y) {
    if (Y >= $8a5cbeb1c6ae1b41$var$blkThrs) return Y;
    return Y + ($8a5cbeb1c6ae1b41$var$blkThrs - Y) ** $8a5cbeb1c6ae1b41$var$blkClmp;
}
function $8a5cbeb1c6ae1b41$var$linearize(val) {
    let sign = val < 0 ? -1 : 1;
    let abs = Math.abs(val);
    return sign * Math.pow(abs, 2.4);
}
function $8a5cbeb1c6ae1b41$var$contrastAPCA(background, foreground) {
    foreground = $8a5cbeb1c6ae1b41$var$getColor(foreground);
    background = $8a5cbeb1c6ae1b41$var$getColor(background);
    let S;
    let C;
    let Sapc;
    let R, G, B;
    foreground = $8a5cbeb1c6ae1b41$var$to(foreground, "srgb");
    [R, G, B] = foreground.coords;
    let lumTxt = $8a5cbeb1c6ae1b41$var$linearize(R) * 0.2126729 + $8a5cbeb1c6ae1b41$var$linearize(G) * 0.7151522 + $8a5cbeb1c6ae1b41$var$linearize(B) * 0.072175;
    background = $8a5cbeb1c6ae1b41$var$to(background, "srgb");
    [R, G, B] = background.coords;
    let lumBg = $8a5cbeb1c6ae1b41$var$linearize(R) * 0.2126729 + $8a5cbeb1c6ae1b41$var$linearize(G) * 0.7151522 + $8a5cbeb1c6ae1b41$var$linearize(B) * 0.072175;
    let Ytxt = $8a5cbeb1c6ae1b41$var$fclamp(lumTxt);
    let Ybg = $8a5cbeb1c6ae1b41$var$fclamp(lumBg);
    let BoW = Ybg > Ytxt;
    if (Math.abs(Ybg - Ytxt) < $8a5cbeb1c6ae1b41$var$deltaYmin) C = 0;
    else if (BoW) {
        S = Ybg ** $8a5cbeb1c6ae1b41$var$normBG - Ytxt ** $8a5cbeb1c6ae1b41$var$normTXT;
        C = S * $8a5cbeb1c6ae1b41$var$scaleBoW;
    } else {
        S = Ybg ** $8a5cbeb1c6ae1b41$var$revBG - Ytxt ** $8a5cbeb1c6ae1b41$var$revTXT;
        C = S * $8a5cbeb1c6ae1b41$var$scaleWoB;
    }
    if (Math.abs(C) < $8a5cbeb1c6ae1b41$var$loClip) Sapc = 0;
    else if (C > 0) Sapc = C - $8a5cbeb1c6ae1b41$var$loBoWoffset;
    else Sapc = C + $8a5cbeb1c6ae1b41$var$loBoWoffset;
    return Sapc * 100;
}
function $8a5cbeb1c6ae1b41$var$contrastMichelson(color1, color2) {
    color1 = $8a5cbeb1c6ae1b41$var$getColor(color1);
    color2 = $8a5cbeb1c6ae1b41$var$getColor(color2);
    let Y1 = Math.max($8a5cbeb1c6ae1b41$var$getLuminance(color1), 0);
    let Y2 = Math.max($8a5cbeb1c6ae1b41$var$getLuminance(color2), 0);
    if (Y2 > Y1) [Y1, Y2] = [
        Y2,
        Y1
    ];
    let denom = Y1 + Y2;
    return denom === 0 ? 0 : (Y1 - Y2) / denom;
}
var $8a5cbeb1c6ae1b41$var$max = 5e4;
function $8a5cbeb1c6ae1b41$var$contrastWeber(color1, color2) {
    color1 = $8a5cbeb1c6ae1b41$var$getColor(color1);
    color2 = $8a5cbeb1c6ae1b41$var$getColor(color2);
    let Y1 = Math.max($8a5cbeb1c6ae1b41$var$getLuminance(color1), 0);
    let Y2 = Math.max($8a5cbeb1c6ae1b41$var$getLuminance(color2), 0);
    if (Y2 > Y1) [Y1, Y2] = [
        Y2,
        Y1
    ];
    return Y2 === 0 ? $8a5cbeb1c6ae1b41$var$max : (Y1 - Y2) / Y2;
}
function $8a5cbeb1c6ae1b41$var$contrastLstar(color1, color2) {
    color1 = $8a5cbeb1c6ae1b41$var$getColor(color1);
    color2 = $8a5cbeb1c6ae1b41$var$getColor(color2);
    let L1 = $8a5cbeb1c6ae1b41$var$get(color1, [
        $8a5cbeb1c6ae1b41$var$lab,
        "l"
    ]);
    let L2 = $8a5cbeb1c6ae1b41$var$get(color2, [
        $8a5cbeb1c6ae1b41$var$lab,
        "l"
    ]);
    return Math.abs(L1 - L2);
}
var $8a5cbeb1c6ae1b41$var$\u03B5$3 = 216 / 24389;
var $8a5cbeb1c6ae1b41$var$\u03B53 = 24 / 116;
var $8a5cbeb1c6ae1b41$var$\u03BA$2 = 24389 / 27;
var $8a5cbeb1c6ae1b41$var$white$1 = $8a5cbeb1c6ae1b41$var$WHITES.D65;
var $8a5cbeb1c6ae1b41$var$lab_d65 = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "lab-d65",
    name: "Lab D65",
    coords: {
        l: {
            refRange: [
                0,
                100
            ],
            name: "Lightness"
        },
        a: {
            refRange: [
                -125,
                125
            ]
        },
        b: {
            refRange: [
                -125,
                125
            ]
        }
    },
    // Assuming XYZ is relative to D65, convert to CIE Lab
    // from CIE standard, which now defines these as a rational fraction
    white: $8a5cbeb1c6ae1b41$var$white$1,
    base: $8a5cbeb1c6ae1b41$var$xyz_d65,
    // Convert D65-adapted XYZ to Lab
    //  CIE 15.3:2004 section 8.2.1.1
    fromBase (XYZ) {
        let xyz = XYZ.map((value, i)=>value / $8a5cbeb1c6ae1b41$var$white$1[i]);
        let f = xyz.map((value)=>value > $8a5cbeb1c6ae1b41$var$\u03B5$3 ? Math.cbrt(value) : ($8a5cbeb1c6ae1b41$var$\u03BA$2 * value + 16) / 116);
        return [
            116 * f[1] - 16,
            // L
            500 * (f[0] - f[1]),
            // a
            200 * (f[1] - f[2])
        ];
    },
    // Convert Lab to D65-adapted XYZ
    // Same result as CIE 15.3:2004 Appendix D although the derivation is different
    // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
    toBase (Lab) {
        let f = [];
        f[1] = (Lab[0] + 16) / 116;
        f[0] = Lab[1] / 500 + f[1];
        f[2] = f[1] - Lab[2] / 200;
        let xyz = [
            f[0] > $8a5cbeb1c6ae1b41$var$\u03B53 ? Math.pow(f[0], 3) : (116 * f[0] - 16) / $8a5cbeb1c6ae1b41$var$\u03BA$2,
            Lab[0] > 8 ? Math.pow((Lab[0] + 16) / 116, 3) : Lab[0] / $8a5cbeb1c6ae1b41$var$\u03BA$2,
            f[2] > $8a5cbeb1c6ae1b41$var$\u03B53 ? Math.pow(f[2], 3) : (116 * f[2] - 16) / $8a5cbeb1c6ae1b41$var$\u03BA$2
        ];
        return xyz.map((value, i)=>value * $8a5cbeb1c6ae1b41$var$white$1[i]);
    },
    formats: {
        "lab-d65": {
            coords: [
                "<number> | <percentage>",
                "<number> | <percentage>[-1,1]",
                "<number> | <percentage>[-1,1]"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$phi = Math.pow(5, 0.5) * 0.5 + 0.5;
function $8a5cbeb1c6ae1b41$var$contrastDeltaPhi(color1, color2) {
    color1 = $8a5cbeb1c6ae1b41$var$getColor(color1);
    color2 = $8a5cbeb1c6ae1b41$var$getColor(color2);
    let Lstr1 = $8a5cbeb1c6ae1b41$var$get(color1, [
        $8a5cbeb1c6ae1b41$var$lab_d65,
        "l"
    ]);
    let Lstr2 = $8a5cbeb1c6ae1b41$var$get(color2, [
        $8a5cbeb1c6ae1b41$var$lab_d65,
        "l"
    ]);
    let deltaPhiStar = Math.abs(Math.pow(Lstr1, $8a5cbeb1c6ae1b41$var$phi) - Math.pow(Lstr2, $8a5cbeb1c6ae1b41$var$phi));
    let contrast2 = Math.pow(deltaPhiStar, 1 / $8a5cbeb1c6ae1b41$var$phi) * Math.SQRT2 - 40;
    return contrast2 < 7.5 ? 0 : contrast2;
}
var $8a5cbeb1c6ae1b41$var$contrastMethods = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    contrastAPCA: $8a5cbeb1c6ae1b41$var$contrastAPCA,
    contrastDeltaPhi: $8a5cbeb1c6ae1b41$var$contrastDeltaPhi,
    contrastLstar: $8a5cbeb1c6ae1b41$var$contrastLstar,
    contrastMichelson: $8a5cbeb1c6ae1b41$var$contrastMichelson,
    contrastWCAG21: $8a5cbeb1c6ae1b41$var$contrastWCAG21,
    contrastWeber: $8a5cbeb1c6ae1b41$var$contrastWeber
});
function $8a5cbeb1c6ae1b41$var$contrast(background, foreground, o = {}) {
    if ($8a5cbeb1c6ae1b41$var$isString(o)) o = {
        algorithm: o
    };
    let { algorithm: algorithm, ...rest } = o;
    if (!algorithm) {
        let algorithms = Object.keys($8a5cbeb1c6ae1b41$var$contrastMethods).map((a2)=>a2.replace(/^contrast/, "")).join(", ");
        throw new TypeError(`contrast() function needs a contrast algorithm. Please specify one of: ${algorithms}`);
    }
    background = $8a5cbeb1c6ae1b41$var$getColor(background);
    foreground = $8a5cbeb1c6ae1b41$var$getColor(foreground);
    for(let a2 in $8a5cbeb1c6ae1b41$var$contrastMethods){
        if ("contrast" + algorithm.toLowerCase() === a2.toLowerCase()) return $8a5cbeb1c6ae1b41$var$contrastMethods[a2](background, foreground, rest);
    }
    throw new TypeError(`Unknown contrast algorithm: ${algorithm}`);
}
function $8a5cbeb1c6ae1b41$var$uv(color) {
    let [X, Y, Z] = $8a5cbeb1c6ae1b41$var$getAll(color, $8a5cbeb1c6ae1b41$var$xyz_d65);
    let denom = X + 15 * Y + 3 * Z;
    return [
        4 * X / denom,
        9 * Y / denom
    ];
}
function $8a5cbeb1c6ae1b41$var$xy(color) {
    let [X, Y, Z] = $8a5cbeb1c6ae1b41$var$getAll(color, $8a5cbeb1c6ae1b41$var$xyz_d65);
    let sum = X + Y + Z;
    return [
        X / sum,
        Y / sum
    ];
}
function $8a5cbeb1c6ae1b41$var$register$1(Color2) {
    Object.defineProperty(Color2.prototype, "uv", {
        get () {
            return $8a5cbeb1c6ae1b41$var$uv(this);
        }
    });
    Object.defineProperty(Color2.prototype, "xy", {
        get () {
            return $8a5cbeb1c6ae1b41$var$xy(this);
        }
    });
}
var $8a5cbeb1c6ae1b41$var$chromaticity = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    register: $8a5cbeb1c6ae1b41$var$register$1,
    uv: $8a5cbeb1c6ae1b41$var$uv,
    xy: $8a5cbeb1c6ae1b41$var$xy
});
function $8a5cbeb1c6ae1b41$var$deltaE(c12, c22, o = {}) {
    if ($8a5cbeb1c6ae1b41$var$isString(o)) o = {
        method: o
    };
    let { method: method = $8a5cbeb1c6ae1b41$var$defaults.deltaE, ...rest } = o;
    for(let m3 in $8a5cbeb1c6ae1b41$var$deltaEMethods){
        if ("deltae" + method.toLowerCase() === m3.toLowerCase()) return $8a5cbeb1c6ae1b41$var$deltaEMethods[m3](c12, c22, rest);
    }
    throw new TypeError(`Unknown deltaE method: ${method}`);
}
function $8a5cbeb1c6ae1b41$var$lighten(color, amount = 0.25) {
    let space = $8a5cbeb1c6ae1b41$var$ColorSpace.get("oklch", "lch");
    let lightness = [
        space,
        "l"
    ];
    return $8a5cbeb1c6ae1b41$var$set(color, lightness, (l)=>l * (1 + amount));
}
function $8a5cbeb1c6ae1b41$var$darken(color, amount = 0.25) {
    let space = $8a5cbeb1c6ae1b41$var$ColorSpace.get("oklch", "lch");
    let lightness = [
        space,
        "l"
    ];
    return $8a5cbeb1c6ae1b41$var$set(color, lightness, (l)=>l * (1 - amount));
}
var $8a5cbeb1c6ae1b41$var$variations = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    darken: $8a5cbeb1c6ae1b41$var$darken,
    lighten: $8a5cbeb1c6ae1b41$var$lighten
});
function $8a5cbeb1c6ae1b41$var$mix(c12, c22, p2 = 0.5, o = {}) {
    [c12, c22] = [
        $8a5cbeb1c6ae1b41$var$getColor(c12),
        $8a5cbeb1c6ae1b41$var$getColor(c22)
    ];
    if ($8a5cbeb1c6ae1b41$var$type(p2) === "object") [p2, o] = [
        0.5,
        p2
    ];
    let r = $8a5cbeb1c6ae1b41$var$range(c12, c22, o);
    return r(p2);
}
function $8a5cbeb1c6ae1b41$var$steps(c12, c22, options = {}) {
    let colorRange;
    if ($8a5cbeb1c6ae1b41$var$isRange(c12)) {
        [colorRange, options] = [
            c12,
            c22
        ];
        [c12, c22] = colorRange.rangeArgs.colors;
    }
    let { maxDeltaE: maxDeltaE, deltaEMethod: deltaEMethod, steps: steps2 = 2, maxSteps: maxSteps = 1e3, ...rangeOptions } = options;
    if (!colorRange) {
        [c12, c22] = [
            $8a5cbeb1c6ae1b41$var$getColor(c12),
            $8a5cbeb1c6ae1b41$var$getColor(c22)
        ];
        colorRange = $8a5cbeb1c6ae1b41$var$range(c12, c22, rangeOptions);
    }
    let totalDelta = $8a5cbeb1c6ae1b41$var$deltaE(c12, c22);
    let actualSteps = maxDeltaE > 0 ? Math.max(steps2, Math.ceil(totalDelta / maxDeltaE) + 1) : steps2;
    let ret = [];
    if (maxSteps !== void 0) actualSteps = Math.min(actualSteps, maxSteps);
    if (actualSteps === 1) ret = [
        {
            p: 0.5,
            color: colorRange(0.5)
        }
    ];
    else {
        let step = 1 / (actualSteps - 1);
        ret = Array.from({
            length: actualSteps
        }, (_, i)=>{
            let p2 = i * step;
            return {
                p: p2,
                color: colorRange(p2)
            };
        });
    }
    if (maxDeltaE > 0) {
        let maxDelta = ret.reduce((acc, cur, i)=>{
            if (i === 0) return 0;
            let \u0394\u0395 = $8a5cbeb1c6ae1b41$var$deltaE(cur.color, ret[i - 1].color, deltaEMethod);
            return Math.max(acc, \u0394\u0395);
        }, 0);
        while(maxDelta > maxDeltaE){
            maxDelta = 0;
            for(let i = 1; i < ret.length && ret.length < maxSteps; i++){
                let prev = ret[i - 1];
                let cur = ret[i];
                let p2 = (cur.p + prev.p) / 2;
                let color = colorRange(p2);
                maxDelta = Math.max(maxDelta, $8a5cbeb1c6ae1b41$var$deltaE(color, prev.color), $8a5cbeb1c6ae1b41$var$deltaE(color, cur.color));
                ret.splice(i, 0, {
                    p: p2,
                    color: colorRange(p2)
                });
                i++;
            }
        }
    }
    ret = ret.map((a2)=>a2.color);
    return ret;
}
function $8a5cbeb1c6ae1b41$var$range(color1, color2, options = {}) {
    if ($8a5cbeb1c6ae1b41$var$isRange(color1)) {
        let [r, options2] = [
            color1,
            color2
        ];
        return $8a5cbeb1c6ae1b41$var$range(...r.rangeArgs.colors, {
            ...r.rangeArgs.options,
            ...options2
        });
    }
    let { space: space, outputSpace: outputSpace, progression: progression, premultiplied: premultiplied } = options;
    color1 = $8a5cbeb1c6ae1b41$var$getColor(color1);
    color2 = $8a5cbeb1c6ae1b41$var$getColor(color2);
    color1 = $8a5cbeb1c6ae1b41$var$clone(color1);
    color2 = $8a5cbeb1c6ae1b41$var$clone(color2);
    let rangeArgs = {
        colors: [
            color1,
            color2
        ],
        options: options
    };
    if (space) space = $8a5cbeb1c6ae1b41$var$ColorSpace.get(space);
    else space = $8a5cbeb1c6ae1b41$var$ColorSpace.registry[$8a5cbeb1c6ae1b41$var$defaults.interpolationSpace] || color1.space;
    outputSpace = outputSpace ? $8a5cbeb1c6ae1b41$var$ColorSpace.get(outputSpace) : space;
    color1 = $8a5cbeb1c6ae1b41$var$to(color1, space);
    color2 = $8a5cbeb1c6ae1b41$var$to(color2, space);
    color1 = $8a5cbeb1c6ae1b41$var$toGamut(color1);
    color2 = $8a5cbeb1c6ae1b41$var$toGamut(color2);
    if (space.coords.h && space.coords.h.type === "angle") {
        let arc = options.hue = options.hue || "shorter";
        let hue = [
            space,
            "h"
        ];
        let [\u03B81, \u03B82] = [
            $8a5cbeb1c6ae1b41$var$get(color1, hue),
            $8a5cbeb1c6ae1b41$var$get(color2, hue)
        ];
        if (isNaN(\u03B81) && !isNaN(\u03B82)) \u03B81 = \u03B82;
        else if (isNaN(\u03B82) && !isNaN(\u03B81)) \u03B82 = \u03B81;
        [\u03B81, \u03B82] = $8a5cbeb1c6ae1b41$var$adjust(arc, [
            \u03B81,
            \u03B82
        ]);
        $8a5cbeb1c6ae1b41$var$set(color1, hue, \u03B81);
        $8a5cbeb1c6ae1b41$var$set(color2, hue, \u03B82);
    }
    if (premultiplied) {
        color1.coords = color1.coords.map((c4)=>c4 * color1.alpha);
        color2.coords = color2.coords.map((c4)=>c4 * color2.alpha);
    }
    return Object.assign((p2)=>{
        p2 = progression ? progression(p2) : p2;
        let coords = color1.coords.map((start, i)=>{
            let end = color2.coords[i];
            return $8a5cbeb1c6ae1b41$var$interpolate(start, end, p2);
        });
        let alpha = $8a5cbeb1c6ae1b41$var$interpolate(color1.alpha, color2.alpha, p2);
        let ret = {
            space: space,
            coords: coords,
            alpha: alpha
        };
        if (premultiplied) ret.coords = ret.coords.map((c4)=>c4 / alpha);
        if (outputSpace !== space) ret = $8a5cbeb1c6ae1b41$var$to(ret, outputSpace);
        return ret;
    }, {
        rangeArgs: rangeArgs
    });
}
function $8a5cbeb1c6ae1b41$var$isRange(val) {
    return $8a5cbeb1c6ae1b41$var$type(val) === "function" && !!val.rangeArgs;
}
$8a5cbeb1c6ae1b41$var$defaults.interpolationSpace = "lab";
function $8a5cbeb1c6ae1b41$var$register(Color2) {
    Color2.defineFunction("mix", $8a5cbeb1c6ae1b41$var$mix, {
        returns: "color"
    });
    Color2.defineFunction("range", $8a5cbeb1c6ae1b41$var$range, {
        returns: "function<color>"
    });
    Color2.defineFunction("steps", $8a5cbeb1c6ae1b41$var$steps, {
        returns: "array<color>"
    });
}
var $8a5cbeb1c6ae1b41$var$interpolation = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    isRange: $8a5cbeb1c6ae1b41$var$isRange,
    mix: $8a5cbeb1c6ae1b41$var$mix,
    range: $8a5cbeb1c6ae1b41$var$range,
    register: $8a5cbeb1c6ae1b41$var$register,
    steps: $8a5cbeb1c6ae1b41$var$steps
});
var $8a5cbeb1c6ae1b41$var$HSL = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "hsl",
    name: "HSL",
    coords: {
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        },
        s: {
            range: [
                0,
                100
            ],
            name: "Saturation"
        },
        l: {
            range: [
                0,
                100
            ],
            name: "Lightness"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$sRGB,
    // Adapted from https://drafts.csswg.org/css-color-4/better-rgbToHsl.js
    fromBase: (rgb)=>{
        let max2 = Math.max(...rgb);
        let min = Math.min(...rgb);
        let [r, g2, b2] = rgb;
        let [h, s, l] = [
            NaN,
            0,
            (min + max2) / 2
        ];
        let d2 = max2 - min;
        if (d2 !== 0) {
            s = l === 0 || l === 1 ? 0 : (max2 - l) / Math.min(l, 1 - l);
            switch(max2){
                case r:
                    h = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
                    break;
                case g2:
                    h = (b2 - r) / d2 + 2;
                    break;
                case b2:
                    h = (r - g2) / d2 + 4;
            }
            h = h * 60;
        }
        if (s < 0) {
            h += 180;
            s = Math.abs(s);
        }
        if (h >= 360) h -= 360;
        return [
            h,
            s * 100,
            l * 100
        ];
    },
    // Adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
    toBase: (hsl)=>{
        let [h, s, l] = hsl;
        h = h % 360;
        if (h < 0) h += 360;
        s /= 100;
        l /= 100;
        function f(n2) {
            let k = (n2 + h / 30) % 12;
            let a2 = s * Math.min(l, 1 - l);
            return l - a2 * Math.max(-1, Math.min(k - 3, 9 - k, 1));
        }
        return [
            f(0),
            f(8),
            f(4)
        ];
    },
    formats: {
        "hsl": {
            coords: [
                "<number> | <angle>",
                "<percentage>",
                "<percentage>"
            ]
        },
        "hsla": {
            coords: [
                "<number> | <angle>",
                "<percentage>",
                "<percentage>"
            ],
            commas: true,
            lastAlpha: true
        }
    }
});
var $8a5cbeb1c6ae1b41$var$HSV = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "hsv",
    name: "HSV",
    coords: {
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        },
        s: {
            range: [
                0,
                100
            ],
            name: "Saturation"
        },
        v: {
            range: [
                0,
                100
            ],
            name: "Value"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$HSL,
    // https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion
    fromBase (hsl) {
        let [h, s, l] = hsl;
        s /= 100;
        l /= 100;
        let v = l + s * Math.min(l, 1 - l);
        return [
            h,
            // h is the same
            v === 0 ? 0 : 200 * (1 - l / v),
            // s
            100 * v
        ];
    },
    // https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion
    toBase (hsv) {
        let [h, s, v] = hsv;
        s /= 100;
        v /= 100;
        let l = v * (1 - s / 2);
        return [
            h,
            // h is the same
            l === 0 || l === 1 ? 0 : (v - l) / Math.min(l, 1 - l) * 100,
            l * 100
        ];
    },
    formats: {
        color: {
            id: "--hsv",
            coords: [
                "<number> | <angle>",
                "<percentage> | <number>",
                "<percentage> | <number>"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$hwb = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "hwb",
    name: "HWB",
    coords: {
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        },
        w: {
            range: [
                0,
                100
            ],
            name: "Whiteness"
        },
        b: {
            range: [
                0,
                100
            ],
            name: "Blackness"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$HSV,
    fromBase (hsv) {
        let [h, s, v] = hsv;
        return [
            h,
            v * (100 - s) / 100,
            100 - v
        ];
    },
    toBase (hwb2) {
        let [h, w, b2] = hwb2;
        w /= 100;
        b2 /= 100;
        let sum = w + b2;
        if (sum >= 1) {
            let gray = w / sum;
            return [
                h,
                0,
                gray * 100
            ];
        }
        let v = 1 - b2;
        let s = v === 0 ? 0 : 1 - w / v;
        return [
            h,
            s * 100,
            v * 100
        ];
    },
    formats: {
        "hwb": {
            coords: [
                "<number> | <angle>",
                "<percentage> | <number>",
                "<percentage> | <number>"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$toXYZ_M$2 = [
    [
        0.5766690429101305,
        0.1855582379065463,
        0.1882286462349947
    ],
    [
        0.29734497525053605,
        0.6273635662554661,
        0.07529145849399788
    ],
    [
        0.02703136138641234,
        0.07068885253582723,
        0.9913375368376388
    ]
];
var $8a5cbeb1c6ae1b41$var$fromXYZ_M$2 = [
    [
        2.0415879038107465,
        -0.5650069742788596,
        -0.34473135077832956
    ],
    [
        -0.9692436362808795,
        1.8759675015077202,
        0.04155505740717557
    ],
    [
        0.013444280632031142,
        -0.11836239223101838,
        1.0151749943912054
    ]
];
var $8a5cbeb1c6ae1b41$var$A98Linear = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "a98rgb-linear",
    cssId: "--a98-rgb-linear",
    name: "Linear Adobe\xAE 98 RGB compatible",
    white: "D65",
    toXYZ_M: $8a5cbeb1c6ae1b41$var$toXYZ_M$2,
    fromXYZ_M: $8a5cbeb1c6ae1b41$var$fromXYZ_M$2
});
var $8a5cbeb1c6ae1b41$var$a98rgb = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "a98rgb",
    cssId: "a98-rgb",
    name: "Adobe\xAE 98 RGB compatible",
    base: $8a5cbeb1c6ae1b41$var$A98Linear,
    toBase: (RGB)=>RGB.map((val)=>Math.pow(Math.abs(val), 563 / 256) * Math.sign(val)),
    fromBase: (RGB)=>RGB.map((val)=>Math.pow(Math.abs(val), 256 / 563) * Math.sign(val))
});
var $8a5cbeb1c6ae1b41$var$toXYZ_M$1 = [
    [
        0.7977666449006423,
        0.13518129740053308,
        0.0313477341283922
    ],
    [
        0.2880748288194013,
        0.711835234241873,
        8993693872564e-17
    ],
    [
        0,
        0,
        0.8251046025104602
    ]
];
var $8a5cbeb1c6ae1b41$var$fromXYZ_M$1 = [
    [
        1.3457868816471583,
        -0.25557208737979464,
        -0.05110186497554526
    ],
    [
        -0.5446307051249019,
        1.5082477428451468,
        0.02052744743642139
    ],
    [
        0,
        0,
        1.2119675456389452
    ]
];
var $8a5cbeb1c6ae1b41$var$ProPhotoLinear = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "prophoto-linear",
    cssId: "--prophoto-rgb-linear",
    name: "Linear ProPhoto",
    white: "D50",
    base: $8a5cbeb1c6ae1b41$var$XYZ_D50,
    toXYZ_M: $8a5cbeb1c6ae1b41$var$toXYZ_M$1,
    fromXYZ_M: $8a5cbeb1c6ae1b41$var$fromXYZ_M$1
});
var $8a5cbeb1c6ae1b41$var$Et = 1 / 512;
var $8a5cbeb1c6ae1b41$var$Et2 = 16 / 512;
var $8a5cbeb1c6ae1b41$var$prophoto = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "prophoto",
    cssId: "prophoto-rgb",
    name: "ProPhoto",
    base: $8a5cbeb1c6ae1b41$var$ProPhotoLinear,
    toBase (RGB) {
        return RGB.map((v)=>v < $8a5cbeb1c6ae1b41$var$Et2 ? v / 16 : v ** 1.8);
    },
    fromBase (RGB) {
        return RGB.map((v)=>v >= $8a5cbeb1c6ae1b41$var$Et ? v ** (1 / 1.8) : 16 * v);
    }
});
var $8a5cbeb1c6ae1b41$var$oklch = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "oklch",
    name: "Oklch",
    coords: {
        l: {
            refRange: [
                0,
                1
            ],
            name: "Lightness"
        },
        c: {
            refRange: [
                0,
                0.4
            ],
            name: "Chroma"
        },
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        }
    },
    white: "D65",
    base: $8a5cbeb1c6ae1b41$var$OKLab,
    fromBase (oklab) {
        let [L, a2, b2] = oklab;
        let h;
        const \u03B52 = 2e-4;
        if (Math.abs(a2) < \u03B52 && Math.abs(b2) < \u03B52) h = NaN;
        else h = Math.atan2(b2, a2) * 180 / Math.PI;
        return [
            L,
            // OKLab L is still L
            Math.sqrt(a2 ** 2 + b2 ** 2),
            // Chroma
            $8a5cbeb1c6ae1b41$var$constrain(h)
        ];
    },
    // Convert from polar form
    toBase (oklch2) {
        let [L, C, h] = oklch2;
        let a2, b2;
        if (isNaN(h)) {
            a2 = 0;
            b2 = 0;
        } else {
            a2 = C * Math.cos(h * Math.PI / 180);
            b2 = C * Math.sin(h * Math.PI / 180);
        }
        return [
            L,
            a2,
            b2
        ];
    },
    formats: {
        "oklch": {
            coords: [
                "<percentage> | <number>",
                "<number> | <percentage>[0,1]",
                "<number> | <angle>"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$white = $8a5cbeb1c6ae1b41$var$WHITES.D65;
var $8a5cbeb1c6ae1b41$var$\u03B5$2 = 216 / 24389;
var $8a5cbeb1c6ae1b41$var$\u03BA$1 = 24389 / 27;
var [$8a5cbeb1c6ae1b41$var$U_PRIME_WHITE, $8a5cbeb1c6ae1b41$var$V_PRIME_WHITE] = $8a5cbeb1c6ae1b41$var$uv({
    space: $8a5cbeb1c6ae1b41$var$xyz_d65,
    coords: $8a5cbeb1c6ae1b41$var$white
});
var $8a5cbeb1c6ae1b41$var$Luv = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "luv",
    name: "Luv",
    coords: {
        l: {
            refRange: [
                0,
                100
            ],
            name: "Lightness"
        },
        // Reference ranges from https://facelessuser.github.io/coloraide/colors/luv/
        u: {
            refRange: [
                -215,
                215
            ]
        },
        v: {
            refRange: [
                -215,
                215
            ]
        }
    },
    white: $8a5cbeb1c6ae1b41$var$white,
    base: $8a5cbeb1c6ae1b41$var$xyz_d65,
    // Convert D65-adapted XYZ to Luv
    // https://en.wikipedia.org/wiki/CIELUV#The_forward_transformation
    fromBase (XYZ) {
        let xyz = [
            $8a5cbeb1c6ae1b41$var$skipNone(XYZ[0]),
            $8a5cbeb1c6ae1b41$var$skipNone(XYZ[1]),
            $8a5cbeb1c6ae1b41$var$skipNone(XYZ[2])
        ];
        let y = xyz[1];
        let [up, vp] = $8a5cbeb1c6ae1b41$var$uv({
            space: $8a5cbeb1c6ae1b41$var$xyz_d65,
            coords: xyz
        });
        if (!Number.isFinite(up) || !Number.isFinite(vp)) return [
            0,
            0,
            0
        ];
        let L = y <= $8a5cbeb1c6ae1b41$var$\u03B5$2 ? $8a5cbeb1c6ae1b41$var$\u03BA$1 * y : 116 * Math.cbrt(y) - 16;
        return [
            L,
            13 * L * (up - $8a5cbeb1c6ae1b41$var$U_PRIME_WHITE),
            13 * L * (vp - $8a5cbeb1c6ae1b41$var$V_PRIME_WHITE)
        ];
    },
    // Convert Luv to D65-adapted XYZ
    // https://en.wikipedia.org/wiki/CIELUV#The_reverse_transformation
    toBase (Luv2) {
        let [L, u, v] = Luv2;
        if (L === 0 || $8a5cbeb1c6ae1b41$var$isNone(L)) return [
            0,
            0,
            0
        ];
        u = $8a5cbeb1c6ae1b41$var$skipNone(u);
        v = $8a5cbeb1c6ae1b41$var$skipNone(v);
        let up = u / (13 * L) + $8a5cbeb1c6ae1b41$var$U_PRIME_WHITE;
        let vp = v / (13 * L) + $8a5cbeb1c6ae1b41$var$V_PRIME_WHITE;
        let y = L <= 8 ? L / $8a5cbeb1c6ae1b41$var$\u03BA$1 : Math.pow((L + 16) / 116, 3);
        return [
            y * (9 * up / (4 * vp)),
            y,
            y * ((12 - 3 * up - 20 * vp) / (4 * vp))
        ];
    },
    formats: {
        color: {
            id: "--luv",
            coords: [
                "<number> | <percentage>",
                "<number> | <percentage>[-1,1]",
                "<number> | <percentage>[-1,1]"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$LCHuv = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "lchuv",
    name: "LChuv",
    coords: {
        l: {
            refRange: [
                0,
                100
            ],
            name: "Lightness"
        },
        c: {
            refRange: [
                0,
                220
            ],
            name: "Chroma"
        },
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$Luv,
    fromBase (Luv2) {
        let [L, u, v] = Luv2;
        let hue;
        const \u03B52 = 0.02;
        if (Math.abs(u) < \u03B52 && Math.abs(v) < \u03B52) hue = NaN;
        else hue = Math.atan2(v, u) * 180 / Math.PI;
        return [
            L,
            // L is still L
            Math.sqrt(u ** 2 + v ** 2),
            // Chroma
            $8a5cbeb1c6ae1b41$var$constrain(hue)
        ];
    },
    toBase (LCH) {
        let [Lightness, Chroma, Hue] = LCH;
        if (Chroma < 0) Chroma = 0;
        if (isNaN(Hue)) Hue = 0;
        return [
            Lightness,
            // L is still L
            Chroma * Math.cos(Hue * Math.PI / 180),
            // u
            Chroma * Math.sin(Hue * Math.PI / 180)
        ];
    },
    formats: {
        color: {
            id: "--lchuv",
            coords: [
                "<number> | <percentage>",
                "<number> | <percentage>",
                "<number> | <angle>"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$\u03B5$1 = 216 / 24389;
var $8a5cbeb1c6ae1b41$var$\u03BA = 24389 / 27;
var $8a5cbeb1c6ae1b41$var$m_r0 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[0][0];
var $8a5cbeb1c6ae1b41$var$m_r1 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[0][1];
var $8a5cbeb1c6ae1b41$var$m_r2 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[0][2];
var $8a5cbeb1c6ae1b41$var$m_g0 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[1][0];
var $8a5cbeb1c6ae1b41$var$m_g1 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[1][1];
var $8a5cbeb1c6ae1b41$var$m_g2 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[1][2];
var $8a5cbeb1c6ae1b41$var$m_b0 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[2][0];
var $8a5cbeb1c6ae1b41$var$m_b1 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[2][1];
var $8a5cbeb1c6ae1b41$var$m_b2 = $8a5cbeb1c6ae1b41$var$fromXYZ_M$3[2][2];
function $8a5cbeb1c6ae1b41$var$distanceFromOriginAngle(slope, intercept, angle) {
    const d2 = intercept / (Math.sin(angle) - slope * Math.cos(angle));
    return d2 < 0 ? Infinity : d2;
}
function $8a5cbeb1c6ae1b41$var$calculateBoundingLines(l) {
    const sub1 = Math.pow(l + 16, 3) / 1560896;
    const sub2 = sub1 > $8a5cbeb1c6ae1b41$var$\u03B5$1 ? sub1 : l / $8a5cbeb1c6ae1b41$var$\u03BA;
    const s1r = sub2 * (284517 * $8a5cbeb1c6ae1b41$var$m_r0 - 94839 * $8a5cbeb1c6ae1b41$var$m_r2);
    const s2r = sub2 * (838422 * $8a5cbeb1c6ae1b41$var$m_r2 + 769860 * $8a5cbeb1c6ae1b41$var$m_r1 + 731718 * $8a5cbeb1c6ae1b41$var$m_r0);
    const s3r = sub2 * (632260 * $8a5cbeb1c6ae1b41$var$m_r2 - 126452 * $8a5cbeb1c6ae1b41$var$m_r1);
    const s1g = sub2 * (284517 * $8a5cbeb1c6ae1b41$var$m_g0 - 94839 * $8a5cbeb1c6ae1b41$var$m_g2);
    const s2g = sub2 * (838422 * $8a5cbeb1c6ae1b41$var$m_g2 + 769860 * $8a5cbeb1c6ae1b41$var$m_g1 + 731718 * $8a5cbeb1c6ae1b41$var$m_g0);
    const s3g = sub2 * (632260 * $8a5cbeb1c6ae1b41$var$m_g2 - 126452 * $8a5cbeb1c6ae1b41$var$m_g1);
    const s1b = sub2 * (284517 * $8a5cbeb1c6ae1b41$var$m_b0 - 94839 * $8a5cbeb1c6ae1b41$var$m_b2);
    const s2b = sub2 * (838422 * $8a5cbeb1c6ae1b41$var$m_b2 + 769860 * $8a5cbeb1c6ae1b41$var$m_b1 + 731718 * $8a5cbeb1c6ae1b41$var$m_b0);
    const s3b = sub2 * (632260 * $8a5cbeb1c6ae1b41$var$m_b2 - 126452 * $8a5cbeb1c6ae1b41$var$m_b1);
    return {
        r0s: s1r / s3r,
        r0i: s2r * l / s3r,
        r1s: s1r / (s3r + 126452),
        r1i: (s2r - 769860) * l / (s3r + 126452),
        g0s: s1g / s3g,
        g0i: s2g * l / s3g,
        g1s: s1g / (s3g + 126452),
        g1i: (s2g - 769860) * l / (s3g + 126452),
        b0s: s1b / s3b,
        b0i: s2b * l / s3b,
        b1s: s1b / (s3b + 126452),
        b1i: (s2b - 769860) * l / (s3b + 126452)
    };
}
function $8a5cbeb1c6ae1b41$var$calcMaxChromaHsluv(lines, h) {
    const hueRad = h / 360 * Math.PI * 2;
    const r0 = $8a5cbeb1c6ae1b41$var$distanceFromOriginAngle(lines.r0s, lines.r0i, hueRad);
    const r1 = $8a5cbeb1c6ae1b41$var$distanceFromOriginAngle(lines.r1s, lines.r1i, hueRad);
    const g0 = $8a5cbeb1c6ae1b41$var$distanceFromOriginAngle(lines.g0s, lines.g0i, hueRad);
    const g1 = $8a5cbeb1c6ae1b41$var$distanceFromOriginAngle(lines.g1s, lines.g1i, hueRad);
    const b0 = $8a5cbeb1c6ae1b41$var$distanceFromOriginAngle(lines.b0s, lines.b0i, hueRad);
    const b1 = $8a5cbeb1c6ae1b41$var$distanceFromOriginAngle(lines.b1s, lines.b1i, hueRad);
    return Math.min(r0, r1, g0, g1, b0, b1);
}
var $8a5cbeb1c6ae1b41$var$hsluv = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "hsluv",
    name: "HSLuv",
    coords: {
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        },
        s: {
            range: [
                0,
                100
            ],
            name: "Saturation"
        },
        l: {
            range: [
                0,
                100
            ],
            name: "Lightness"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$LCHuv,
    gamutSpace: $8a5cbeb1c6ae1b41$var$sRGB,
    // Convert LCHuv to HSLuv
    fromBase (lch2) {
        let [l, c4, h] = [
            $8a5cbeb1c6ae1b41$var$skipNone(lch2[0]),
            $8a5cbeb1c6ae1b41$var$skipNone(lch2[1]),
            $8a5cbeb1c6ae1b41$var$skipNone(lch2[2])
        ];
        let s;
        if (l > 99.9999999) {
            s = 0;
            l = 100;
        } else if (l < 1e-8) {
            s = 0;
            l = 0;
        } else {
            let lines = $8a5cbeb1c6ae1b41$var$calculateBoundingLines(l);
            let max2 = $8a5cbeb1c6ae1b41$var$calcMaxChromaHsluv(lines, h);
            s = c4 / max2 * 100;
        }
        return [
            h,
            s,
            l
        ];
    },
    // Convert HSLuv to LCHuv
    toBase (hsl) {
        let [h, s, l] = [
            $8a5cbeb1c6ae1b41$var$skipNone(hsl[0]),
            $8a5cbeb1c6ae1b41$var$skipNone(hsl[1]),
            $8a5cbeb1c6ae1b41$var$skipNone(hsl[2])
        ];
        let c4;
        if (l > 99.9999999) {
            l = 100;
            c4 = 0;
        } else if (l < 1e-8) {
            l = 0;
            c4 = 0;
        } else {
            let lines = $8a5cbeb1c6ae1b41$var$calculateBoundingLines(l);
            let max2 = $8a5cbeb1c6ae1b41$var$calcMaxChromaHsluv(lines, h);
            c4 = max2 / 100 * s;
        }
        return [
            l,
            c4,
            h
        ];
    },
    formats: {
        color: {
            id: "--hsluv",
            coords: [
                "<number> | <angle>",
                "<percentage> | <number>",
                "<percentage> | <number>"
            ]
        }
    }
});
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[0][0];
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[0][1];
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[0][2];
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[1][0];
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[1][1];
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[1][2];
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[2][0];
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[2][1];
$8a5cbeb1c6ae1b41$var$fromXYZ_M$3[2][2];
function $8a5cbeb1c6ae1b41$var$distanceFromOrigin(slope, intercept) {
    return Math.abs(intercept) / Math.sqrt(Math.pow(slope, 2) + 1);
}
function $8a5cbeb1c6ae1b41$var$calcMaxChromaHpluv(lines) {
    let r0 = $8a5cbeb1c6ae1b41$var$distanceFromOrigin(lines.r0s, lines.r0i);
    let r1 = $8a5cbeb1c6ae1b41$var$distanceFromOrigin(lines.r1s, lines.r1i);
    let g0 = $8a5cbeb1c6ae1b41$var$distanceFromOrigin(lines.g0s, lines.g0i);
    let g1 = $8a5cbeb1c6ae1b41$var$distanceFromOrigin(lines.g1s, lines.g1i);
    let b0 = $8a5cbeb1c6ae1b41$var$distanceFromOrigin(lines.b0s, lines.b0i);
    let b1 = $8a5cbeb1c6ae1b41$var$distanceFromOrigin(lines.b1s, lines.b1i);
    return Math.min(r0, r1, g0, g1, b0, b1);
}
var $8a5cbeb1c6ae1b41$var$hpluv = new $8a5cbeb1c6ae1b41$var$ColorSpace({
    id: "hpluv",
    name: "HPLuv",
    coords: {
        h: {
            refRange: [
                0,
                360
            ],
            type: "angle",
            name: "Hue"
        },
        s: {
            range: [
                0,
                100
            ],
            name: "Saturation"
        },
        l: {
            range: [
                0,
                100
            ],
            name: "Lightness"
        }
    },
    base: $8a5cbeb1c6ae1b41$var$LCHuv,
    gamutSpace: "self",
    // Convert LCHuv to HPLuv
    fromBase (lch2) {
        let [l, c4, h] = [
            $8a5cbeb1c6ae1b41$var$skipNone(lch2[0]),
            $8a5cbeb1c6ae1b41$var$skipNone(lch2[1]),
            $8a5cbeb1c6ae1b41$var$skipNone(lch2[2])
        ];
        let s;
        if (l > 99.9999999) {
            s = 0;
            l = 100;
        } else if (l < 1e-8) {
            s = 0;
            l = 0;
        } else {
            let lines = $8a5cbeb1c6ae1b41$var$calculateBoundingLines(l);
            let max2 = $8a5cbeb1c6ae1b41$var$calcMaxChromaHpluv(lines);
            s = c4 / max2 * 100;
        }
        return [
            h,
            s,
            l
        ];
    },
    // Convert HPLuv to LCHuv
    toBase (hsl) {
        let [h, s, l] = [
            $8a5cbeb1c6ae1b41$var$skipNone(hsl[0]),
            $8a5cbeb1c6ae1b41$var$skipNone(hsl[1]),
            $8a5cbeb1c6ae1b41$var$skipNone(hsl[2])
        ];
        let c4;
        if (l > 99.9999999) {
            l = 100;
            c4 = 0;
        } else if (l < 1e-8) {
            l = 0;
            c4 = 0;
        } else {
            let lines = $8a5cbeb1c6ae1b41$var$calculateBoundingLines(l);
            let max2 = $8a5cbeb1c6ae1b41$var$calcMaxChromaHpluv(lines);
            c4 = max2 / 100 * s;
        }
        return [
            l,
            c4,
            h
        ];
    },
    formats: {
        color: {
            id: "--hpluv",
            coords: [
                "<number> | <angle>",
                "<percentage> | <number>",
                "<percentage> | <number>"
            ]
        }
    }
});
var $8a5cbeb1c6ae1b41$var$Yw = 203;
var $8a5cbeb1c6ae1b41$var$n = 2610 / 2 ** 14;
var $8a5cbeb1c6ae1b41$var$ninv = 2 ** 14 / 2610;
var $8a5cbeb1c6ae1b41$var$m = 78.84375;
var $8a5cbeb1c6ae1b41$var$minv = 32 / 2523;
var $8a5cbeb1c6ae1b41$var$c1 = 0.8359375;
var $8a5cbeb1c6ae1b41$var$c2 = 18.8515625;
var $8a5cbeb1c6ae1b41$var$c3 = 18.6875;
var $8a5cbeb1c6ae1b41$var$rec2100Pq = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "rec2100pq",
    cssId: "rec2100-pq",
    name: "REC.2100-PQ",
    base: $8a5cbeb1c6ae1b41$var$REC2020Linear,
    toBase (RGB) {
        return RGB.map(function(val) {
            let x = (Math.max(val ** $8a5cbeb1c6ae1b41$var$minv - $8a5cbeb1c6ae1b41$var$c1, 0) / ($8a5cbeb1c6ae1b41$var$c2 - $8a5cbeb1c6ae1b41$var$c3 * val ** $8a5cbeb1c6ae1b41$var$minv)) ** $8a5cbeb1c6ae1b41$var$ninv;
            return x * 1e4 / $8a5cbeb1c6ae1b41$var$Yw;
        });
    },
    fromBase (RGB) {
        return RGB.map(function(val) {
            let x = Math.max(val * $8a5cbeb1c6ae1b41$var$Yw / 1e4, 0);
            let num = $8a5cbeb1c6ae1b41$var$c1 + $8a5cbeb1c6ae1b41$var$c2 * x ** $8a5cbeb1c6ae1b41$var$n;
            let denom = 1 + $8a5cbeb1c6ae1b41$var$c3 * x ** $8a5cbeb1c6ae1b41$var$n;
            return (num / denom) ** $8a5cbeb1c6ae1b41$var$m;
        });
    }
});
var $8a5cbeb1c6ae1b41$var$a = 0.17883277;
var $8a5cbeb1c6ae1b41$var$b = 0.28466892;
var $8a5cbeb1c6ae1b41$var$c = 0.55991073;
var $8a5cbeb1c6ae1b41$var$scale2 = 3.7743;
var $8a5cbeb1c6ae1b41$var$rec2100Hlg = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "rec2100hlg",
    cssId: "rec2100-hlg",
    name: "REC.2100-HLG",
    referred: "scene",
    base: $8a5cbeb1c6ae1b41$var$REC2020Linear,
    toBase (RGB) {
        return RGB.map(function(val) {
            if (val <= 0.5) return val ** 2 / 3 * $8a5cbeb1c6ae1b41$var$scale2;
            return (Math.exp((val - $8a5cbeb1c6ae1b41$var$c) / $8a5cbeb1c6ae1b41$var$a) + $8a5cbeb1c6ae1b41$var$b) / 12 * $8a5cbeb1c6ae1b41$var$scale2;
        });
    },
    fromBase (RGB) {
        return RGB.map(function(val) {
            val /= $8a5cbeb1c6ae1b41$var$scale2;
            if (val <= 1 / 12) return Math.sqrt(3 * val);
            return $8a5cbeb1c6ae1b41$var$a * Math.log(12 * val - $8a5cbeb1c6ae1b41$var$b) + $8a5cbeb1c6ae1b41$var$c;
        });
    }
});
var $8a5cbeb1c6ae1b41$var$CATs = {};
$8a5cbeb1c6ae1b41$var$hooks.add("chromatic-adaptation-start", (env)=>{
    if (env.options.method) env.M = $8a5cbeb1c6ae1b41$var$adapt(env.W1, env.W2, env.options.method);
});
$8a5cbeb1c6ae1b41$var$hooks.add("chromatic-adaptation-end", (env)=>{
    if (!env.M) env.M = $8a5cbeb1c6ae1b41$var$adapt(env.W1, env.W2, env.options.method);
});
function $8a5cbeb1c6ae1b41$var$defineCAT({ id: id, toCone_M: toCone_M, fromCone_M: fromCone_M }) {
    $8a5cbeb1c6ae1b41$var$CATs[id] = arguments[0];
}
function $8a5cbeb1c6ae1b41$var$adapt(W1, W2, id = "Bradford") {
    let method = $8a5cbeb1c6ae1b41$var$CATs[id];
    let [\u03C1s, \u03B3s, \u03B2s] = $8a5cbeb1c6ae1b41$var$multiplyMatrices(method.toCone_M, W1);
    let [\u03C1d, \u03B3d, \u03B2d] = $8a5cbeb1c6ae1b41$var$multiplyMatrices(method.toCone_M, W2);
    let scale4 = [
        [
            \u03C1d / \u03C1s,
            0,
            0
        ],
        [
            0,
            \u03B3d / \u03B3s,
            0
        ],
        [
            0,
            0,
            \u03B2d / \u03B2s
        ]
    ];
    let scaled_cone_M = $8a5cbeb1c6ae1b41$var$multiplyMatrices(scale4, method.toCone_M);
    let adapt_M = $8a5cbeb1c6ae1b41$var$multiplyMatrices(method.fromCone_M, scaled_cone_M);
    return adapt_M;
}
$8a5cbeb1c6ae1b41$var$defineCAT({
    id: "von Kries",
    toCone_M: [
        [
            0.40024,
            0.7076,
            -0.08081
        ],
        [
            -0.2263,
            1.16532,
            0.0457
        ],
        [
            0,
            0,
            0.91822
        ]
    ],
    fromCone_M: [
        [
            1.8599363874558397,
            -1.1293816185800916,
            0.21989740959619328
        ],
        [
            0.3611914362417676,
            0.6388124632850422,
            -0.000006370596838649899
        ],
        [
            0,
            0,
            1.0890636230968613
        ]
    ]
});
$8a5cbeb1c6ae1b41$var$defineCAT({
    id: "Bradford",
    // Convert an array of XYZ values in the range 0.0 - 1.0
    // to cone fundamentals
    toCone_M: [
        [
            0.8951,
            0.2664,
            -0.1614
        ],
        [
            -0.7502,
            1.7135,
            0.0367
        ],
        [
            0.0389,
            -0.0685,
            1.0296
        ]
    ],
    // and back
    fromCone_M: [
        [
            0.9869929054667121,
            -0.14705425642099013,
            0.15996265166373122
        ],
        [
            0.4323052697233945,
            0.5183602715367774,
            0.049291228212855594
        ],
        [
            -0.00852866457517732,
            0.04004282165408486,
            0.96848669578755
        ]
    ]
});
$8a5cbeb1c6ae1b41$var$defineCAT({
    id: "CAT02",
    // with complete chromatic adaptation to W2, so D = 1.0
    toCone_M: [
        [
            0.7328,
            0.4296,
            -0.1624
        ],
        [
            -0.7036,
            1.6975,
            61e-4
        ],
        [
            3e-3,
            0.0136,
            0.9834
        ]
    ],
    fromCone_M: [
        [
            1.0961238208355142,
            -0.27886900021828726,
            0.18274517938277307
        ],
        [
            0.4543690419753592,
            0.4735331543074117,
            0.07209780371722911
        ],
        [
            -0.009627608738429355,
            -0.00569803121611342,
            1.0153256399545427
        ]
    ]
});
$8a5cbeb1c6ae1b41$var$defineCAT({
    id: "CAT16",
    toCone_M: [
        [
            0.401288,
            0.650173,
            -0.051461
        ],
        [
            -0.250268,
            1.204414,
            0.045854
        ],
        [
            -0.002079,
            0.048952,
            0.953127
        ]
    ],
    // the extra precision is needed to avoid roundtripping errors
    fromCone_M: [
        [
            1.862067855087233,
            -1.0112546305316845,
            0.14918677544445172
        ],
        [
            0.3875265432361372,
            0.6214474419314753,
            -0.008973985167612521
        ],
        [
            -0.01584149884933386,
            -0.03412293802851557,
            1.0499644368778496
        ]
    ]
});
Object.assign($8a5cbeb1c6ae1b41$var$WHITES, {
    // whitepoint values from ASTM E308-01 with 10nm spacing, 1931 2 degree observer
    // all normalized to Y (luminance) = 1.00000
    // Illuminant A is a tungsten electric light, giving a very warm, orange light.
    A: [
        1.0985,
        1,
        0.35585
    ],
    // Illuminant C was an early approximation to daylight: illuminant A with a blue filter.
    C: [
        0.98074,
        1,
        1.18232
    ],
    // The daylight series of illuminants simulate natural daylight.
    // The color temperature (in degrees Kelvin/100) ranges from
    // cool, overcast daylight (D50) to bright, direct sunlight (D65).
    D55: [
        0.95682,
        1,
        0.92149
    ],
    D75: [
        0.94972,
        1,
        1.22638
    ],
    // Equal-energy illuminant, used in two-stage CAT16
    E: [
        1,
        1,
        1
    ],
    // The F series of illuminants represent fluorescent lights
    F2: [
        0.99186,
        1,
        0.67393
    ],
    F7: [
        0.95041,
        1,
        1.08747
    ],
    F11: [
        1.00962,
        1,
        0.6435
    ]
});
$8a5cbeb1c6ae1b41$var$WHITES.ACES = [
    0.32168 / 0.33767,
    1,
    1.0088251843515859
];
var $8a5cbeb1c6ae1b41$var$toXYZ_M = [
    [
        0.6624541811085053,
        0.13400420645643313,
        0.1561876870049078
    ],
    [
        0.27222871678091454,
        0.6740817658111484,
        0.05368951740793705
    ],
    [
        -0.005574649490394108,
        0.004060733528982826,
        1.0103391003129971
    ]
];
var $8a5cbeb1c6ae1b41$var$fromXYZ_M = [
    [
        1.6410233796943257,
        -0.32480329418479,
        -0.23642469523761225
    ],
    [
        -0.6636628587229829,
        1.6153315916573379,
        0.016756347685530137
    ],
    [
        0.011721894328375376,
        -0.008284441996237409,
        0.9883948585390215
    ]
];
var $8a5cbeb1c6ae1b41$var$ACEScg = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "acescg",
    cssId: "--acescg",
    name: "ACEScg",
    // ACEScg – A scene-referred, linear-light encoding of ACES Data
    // https://docs.acescentral.com/specifications/acescg/
    // uses the AP1 primaries, see section 4.3.1 Color primaries
    coords: {
        r: {
            range: [
                0,
                65504
            ],
            name: "Red"
        },
        g: {
            range: [
                0,
                65504
            ],
            name: "Green"
        },
        b: {
            range: [
                0,
                65504
            ],
            name: "Blue"
        }
    },
    referred: "scene",
    white: $8a5cbeb1c6ae1b41$var$WHITES.ACES,
    toXYZ_M: $8a5cbeb1c6ae1b41$var$toXYZ_M,
    fromXYZ_M: $8a5cbeb1c6ae1b41$var$fromXYZ_M
});
var $8a5cbeb1c6ae1b41$var$\u03B5 = 2 ** -16;
var $8a5cbeb1c6ae1b41$var$ACES_min_nonzero = -0.35828683;
var $8a5cbeb1c6ae1b41$var$ACES_cc_max = (Math.log2(65504) + 9.72) / 17.52;
var $8a5cbeb1c6ae1b41$var$acescc = new $8a5cbeb1c6ae1b41$var$RGBColorSpace({
    id: "acescc",
    cssId: "--acescc",
    name: "ACEScc",
    // see S-2014-003 ACEScc – A Logarithmic Encoding of ACES Data
    // https://docs.acescentral.com/specifications/acescc/
    // uses the AP1 primaries, see section 4.3.1 Color primaries
    // Appendix A: "Very small ACES scene referred values below 7 1/4 stops
    // below 18% middle gray are encoded as negative ACEScc values.
    // These values should be preserved per the encoding in Section 4.4
    // so that all positive ACES values are maintained."
    coords: {
        r: {
            range: [
                $8a5cbeb1c6ae1b41$var$ACES_min_nonzero,
                $8a5cbeb1c6ae1b41$var$ACES_cc_max
            ],
            name: "Red"
        },
        g: {
            range: [
                $8a5cbeb1c6ae1b41$var$ACES_min_nonzero,
                $8a5cbeb1c6ae1b41$var$ACES_cc_max
            ],
            name: "Green"
        },
        b: {
            range: [
                $8a5cbeb1c6ae1b41$var$ACES_min_nonzero,
                $8a5cbeb1c6ae1b41$var$ACES_cc_max
            ],
            name: "Blue"
        }
    },
    referred: "scene",
    base: $8a5cbeb1c6ae1b41$var$ACEScg,
    // from section 4.4.2 Decoding Function
    toBase (RGB) {
        const low = (9.72 - 15) / 17.52;
        return RGB.map(function(val) {
            if (val <= low) return (2 ** (val * 17.52 - 9.72) - $8a5cbeb1c6ae1b41$var$\u03B5) * 2;
            else if (val < $8a5cbeb1c6ae1b41$var$ACES_cc_max) return 2 ** (val * 17.52 - 9.72);
            else return 65504;
        });
    },
    // Non-linear encoding function from S-2014-003, section 4.4.1 Encoding Function
    fromBase (RGB) {
        return RGB.map(function(val) {
            if (val <= 0) return (Math.log2($8a5cbeb1c6ae1b41$var$\u03B5) + 9.72) / 17.52;
            else if (val < $8a5cbeb1c6ae1b41$var$\u03B5) return (Math.log2($8a5cbeb1c6ae1b41$var$\u03B5 + val * 0.5) + 9.72) / 17.52;
            else return (Math.log2(val) + 9.72) / 17.52;
        });
    }
});
var $8a5cbeb1c6ae1b41$var$spaces = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    A98RGB: $8a5cbeb1c6ae1b41$var$a98rgb,
    A98RGB_Linear: $8a5cbeb1c6ae1b41$var$A98Linear,
    ACEScc: $8a5cbeb1c6ae1b41$var$acescc,
    ACEScg: $8a5cbeb1c6ae1b41$var$ACEScg,
    CAM16_JMh: $8a5cbeb1c6ae1b41$var$cam16,
    HCT: $8a5cbeb1c6ae1b41$var$hct,
    HPLuv: $8a5cbeb1c6ae1b41$var$hpluv,
    HSL: $8a5cbeb1c6ae1b41$var$HSL,
    HSLuv: $8a5cbeb1c6ae1b41$var$hsluv,
    HSV: $8a5cbeb1c6ae1b41$var$HSV,
    HWB: $8a5cbeb1c6ae1b41$var$hwb,
    ICTCP: $8a5cbeb1c6ae1b41$var$ictcp,
    JzCzHz: $8a5cbeb1c6ae1b41$var$jzczhz,
    Jzazbz: $8a5cbeb1c6ae1b41$var$Jzazbz,
    LCH: $8a5cbeb1c6ae1b41$var$lch,
    LCHuv: $8a5cbeb1c6ae1b41$var$LCHuv,
    Lab: $8a5cbeb1c6ae1b41$var$lab,
    Lab_D65: $8a5cbeb1c6ae1b41$var$lab_d65,
    Luv: $8a5cbeb1c6ae1b41$var$Luv,
    OKLCH: $8a5cbeb1c6ae1b41$var$oklch,
    OKLab: $8a5cbeb1c6ae1b41$var$OKLab,
    P3: $8a5cbeb1c6ae1b41$var$P3,
    P3_Linear: $8a5cbeb1c6ae1b41$var$P3Linear,
    ProPhoto: $8a5cbeb1c6ae1b41$var$prophoto,
    ProPhoto_Linear: $8a5cbeb1c6ae1b41$var$ProPhotoLinear,
    REC_2020: $8a5cbeb1c6ae1b41$var$REC2020,
    REC_2020_Linear: $8a5cbeb1c6ae1b41$var$REC2020Linear,
    REC_2100_HLG: $8a5cbeb1c6ae1b41$var$rec2100Hlg,
    REC_2100_PQ: $8a5cbeb1c6ae1b41$var$rec2100Pq,
    XYZ_ABS_D65: $8a5cbeb1c6ae1b41$var$XYZ_Abs_D65,
    XYZ_D50: $8a5cbeb1c6ae1b41$var$XYZ_D50,
    XYZ_D65: $8a5cbeb1c6ae1b41$var$xyz_d65,
    sRGB: $8a5cbeb1c6ae1b41$var$sRGB,
    sRGB_Linear: $8a5cbeb1c6ae1b41$var$sRGBLinear
});
var $8a5cbeb1c6ae1b41$var$Color = class _Color {
    /**
   * Creates an instance of Color.
   * Signatures:
   * - `new Color(stringToParse)`
   * - `new Color(otherColor)`
   * - `new Color({space, coords, alpha})`
   * - `new Color(space, coords, alpha)`
   * - `new Color(spaceId, coords, alpha)`
   */ constructor(...args){
        let color;
        if (args.length === 1) color = $8a5cbeb1c6ae1b41$var$getColor(args[0]);
        let space, coords, alpha;
        if (color) {
            space = color.space || color.spaceId;
            coords = color.coords;
            alpha = color.alpha;
        } else [space, coords, alpha] = args;
        Object.defineProperty(this, "space", {
            value: $8a5cbeb1c6ae1b41$var$ColorSpace.get(space),
            writable: false,
            enumerable: true,
            configurable: true
        });
        this.coords = coords ? coords.slice() : [
            0,
            0,
            0
        ];
        this.alpha = alpha > 1 || alpha === void 0 ? 1 : alpha < 0 ? 0 : alpha;
        for(let i = 0; i < this.coords.length; i++)if (this.coords[i] === "NaN") this.coords[i] = NaN;
        for(let id in this.space.coords)Object.defineProperty(this, id, {
            get: ()=>this.get(id),
            set: (value)=>this.set(id, value)
        });
    }
    get spaceId() {
        return this.space.id;
    }
    clone() {
        return new _Color(this.space, this.coords, this.alpha);
    }
    toJSON() {
        return {
            spaceId: this.spaceId,
            coords: this.coords,
            alpha: this.alpha
        };
    }
    display(...args) {
        let ret = $8a5cbeb1c6ae1b41$var$display(this, ...args);
        ret.color = new _Color(ret.color);
        return ret;
    }
    /**
   * Get a color from the argument passed
   * Basically gets us the same result as new Color(color) but doesn't clone an existing color object
   */ static get(color, ...args) {
        if (color instanceof _Color) return color;
        return new _Color(color, ...args);
    }
    static defineFunction(name, code, o = code) {
        let { instance: instance = true, returns: returns } = o;
        let func = function(...args) {
            let ret = code(...args);
            if (returns === "color") ret = _Color.get(ret);
            else if (returns === "function<color>") {
                let f = ret;
                ret = function(...args2) {
                    let ret2 = f(...args2);
                    return _Color.get(ret2);
                };
                Object.assign(ret, f);
            } else if (returns === "array<color>") ret = ret.map((c4)=>_Color.get(c4));
            return ret;
        };
        if (!(name in _Color)) _Color[name] = func;
        if (instance) _Color.prototype[name] = function(...args) {
            return func(this, ...args);
        };
    }
    static defineFunctions(o) {
        for(let name in o)_Color.defineFunction(name, o[name], o[name]);
    }
    static extend(exports) {
        if (exports.register) exports.register(_Color);
        else for(let name in exports)_Color.defineFunction(name, exports[name]);
    }
};
$8a5cbeb1c6ae1b41$var$Color.defineFunctions({
    get: $8a5cbeb1c6ae1b41$var$get,
    getAll: $8a5cbeb1c6ae1b41$var$getAll,
    set: $8a5cbeb1c6ae1b41$var$set,
    setAll: $8a5cbeb1c6ae1b41$var$setAll,
    to: $8a5cbeb1c6ae1b41$var$to,
    equals: $8a5cbeb1c6ae1b41$var$equals,
    inGamut: $8a5cbeb1c6ae1b41$var$inGamut,
    toGamut: $8a5cbeb1c6ae1b41$var$toGamut,
    distance: $8a5cbeb1c6ae1b41$var$distance,
    toString: $8a5cbeb1c6ae1b41$var$serialize
});
Object.assign($8a5cbeb1c6ae1b41$var$Color, {
    util: $8a5cbeb1c6ae1b41$var$util,
    hooks: $8a5cbeb1c6ae1b41$var$hooks,
    WHITES: $8a5cbeb1c6ae1b41$var$WHITES,
    Space: $8a5cbeb1c6ae1b41$var$ColorSpace,
    spaces: $8a5cbeb1c6ae1b41$var$ColorSpace.registry,
    parse: $8a5cbeb1c6ae1b41$var$parse,
    defaults: // Global defaults one may want to configure
    $8a5cbeb1c6ae1b41$var$defaults
});
for (let key of Object.keys($8a5cbeb1c6ae1b41$var$spaces))$8a5cbeb1c6ae1b41$var$ColorSpace.register($8a5cbeb1c6ae1b41$var$spaces[key]);
for(let id in $8a5cbeb1c6ae1b41$var$ColorSpace.registry)$8a5cbeb1c6ae1b41$var$addSpaceAccessors(id, $8a5cbeb1c6ae1b41$var$ColorSpace.registry[id]);
$8a5cbeb1c6ae1b41$var$hooks.add("colorspace-init-end", (space)=>{
    $8a5cbeb1c6ae1b41$var$addSpaceAccessors(space.id, space);
    space.aliases?.forEach((alias)=>{
        $8a5cbeb1c6ae1b41$var$addSpaceAccessors(alias, space);
    });
});
function $8a5cbeb1c6ae1b41$var$addSpaceAccessors(id, space) {
    let propId = id.replace(/-/g, "_");
    Object.defineProperty($8a5cbeb1c6ae1b41$var$Color.prototype, propId, {
        // Convert coords to coords in another colorspace and return them
        // Source colorspace: this.spaceId
        // Target colorspace: id
        get () {
            let ret = this.getAll(id);
            if (typeof Proxy === "undefined") return ret;
            return new Proxy(ret, {
                has: (obj, property)=>{
                    try {
                        $8a5cbeb1c6ae1b41$var$ColorSpace.resolveCoord([
                            space,
                            property
                        ]);
                        return true;
                    } catch (e) {}
                    return Reflect.has(obj, property);
                },
                get: (obj, property, receiver)=>{
                    if (property && typeof property !== "symbol" && !(property in obj)) {
                        let { index: index } = $8a5cbeb1c6ae1b41$var$ColorSpace.resolveCoord([
                            space,
                            property
                        ]);
                        if (index >= 0) return obj[index];
                    }
                    return Reflect.get(obj, property, receiver);
                },
                set: (obj, property, value, receiver)=>{
                    if (property && typeof property !== "symbol" && !(property in obj) || property >= 0) {
                        let { index: index } = $8a5cbeb1c6ae1b41$var$ColorSpace.resolveCoord([
                            space,
                            property
                        ]);
                        if (index >= 0) {
                            obj[index] = value;
                            this.setAll(id, obj);
                            return true;
                        }
                    }
                    return Reflect.set(obj, property, value, receiver);
                }
            });
        },
        // Convert coords in another colorspace to internal coords and set them
        // Target colorspace: this.spaceId
        // Source colorspace: id
        set (coords) {
            this.setAll(id, coords);
        },
        configurable: true,
        enumerable: true
    });
}
$8a5cbeb1c6ae1b41$var$Color.extend($8a5cbeb1c6ae1b41$var$deltaEMethods);
$8a5cbeb1c6ae1b41$var$Color.extend({
    deltaE: $8a5cbeb1c6ae1b41$var$deltaE
});
Object.assign($8a5cbeb1c6ae1b41$var$Color, {
    deltaEMethods: $8a5cbeb1c6ae1b41$var$deltaEMethods
});
$8a5cbeb1c6ae1b41$var$Color.extend($8a5cbeb1c6ae1b41$var$variations);
$8a5cbeb1c6ae1b41$var$Color.extend({
    contrast: $8a5cbeb1c6ae1b41$var$contrast
});
$8a5cbeb1c6ae1b41$var$Color.extend($8a5cbeb1c6ae1b41$var$chromaticity);
$8a5cbeb1c6ae1b41$var$Color.extend($8a5cbeb1c6ae1b41$var$luminance);
$8a5cbeb1c6ae1b41$var$Color.extend($8a5cbeb1c6ae1b41$var$interpolation);
$8a5cbeb1c6ae1b41$var$Color.extend($8a5cbeb1c6ae1b41$var$contrastMethods);
// src/visual/Colour.ts
var $8a5cbeb1c6ae1b41$export$3dae994ede898e09 = (colour, safe = false)=>{
    if (typeof colour === `string` && colour === `transparent`) return {
        h: 0,
        s: 0,
        l: 0,
        opacity: 0,
        space: `hsl`
    };
    const c4 = $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(colour);
    const hsl = c4.hsl;
    let hue = hsl[0];
    if (Number.isNaN(hue) && safe) hue = 0;
    let sat = hsl[1];
    if (Number.isNaN(sat) && safe) sat = 0;
    const parsedHsl = {
        h: hue / 360,
        s: sat / 100,
        l: hsl[2] / 100,
        opacity: 1,
        space: `hsl`
    };
    if (c4.alpha !== 1) {
        if (`type` in c4.alpha) {
            const alphaRaw = Number.parseFloat(c4.alpha.raw);
            return {
                ...parsedHsl,
                opacity: alphaRaw
            };
        }
        return {
            ...parsedHsl,
            opacity: c4.alpha / 100
        };
    }
    return parsedHsl;
};
var $8a5cbeb1c6ae1b41$var$hslToColorJs = (hsl, safe)=>{
    const h = hsl.h === null ? safe ? 0 : null : hsl.h;
    const opacity = hsl.opacity === void 0 ? 1 : hsl.opacity;
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(h, `percentage`, `hsl.h`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(hsl.s, `percentage`, `hsl.s`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(hsl.l, `percentage`, `hsl.l`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(opacity, `percentage`, `hsl.opacity`);
    const coords = [
        h * 360,
        hsl.s * 100,
        hsl.l * 100
    ];
    return new $8a5cbeb1c6ae1b41$var$Color(`hsl`, coords, opacity);
};
var $8a5cbeb1c6ae1b41$var$oklchToColorJs = (oklch2)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(oklch2.l, `percentage`, `oklch.l`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(oklch2.c, `percentage`, `oklch.c`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(oklch2.h, `percentage`, `oklch.h`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(oklch2.opacity, `percentage`, `oklch.opacity`);
    const coords = [
        oklch2.l,
        oklch2.c * 0.4,
        oklch2.h * 360
    ];
    return new $8a5cbeb1c6ae1b41$var$Color(`oklch`, coords, oklch2.opacity);
};
var $8a5cbeb1c6ae1b41$var$rgbToColorJs = (rgb)=>{
    let { r: r, g: g2, b: b2, opacity: opacity } = rgb;
    if (rgb.unit === `8bit`) {
        r /= 255;
        g2 /= 255;
        b2 /= 255;
        if (opacity !== void 0) opacity /= 255;
    }
    const coords = [
        r,
        g2,
        b2
    ];
    return opacity === void 0 ? new $8a5cbeb1c6ae1b41$var$Color(`srgb`, coords) : new $8a5cbeb1c6ae1b41$var$Color(`srgb`, coords, opacity);
};
var $8a5cbeb1c6ae1b41$var$toString = (colour)=>{
    const c4 = $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(colour);
    return c4.display();
};
var $8a5cbeb1c6ae1b41$var$goldenAngleColour = (index, saturation = 0.5, lightness = 0.75, alpha = 1)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(index, `positive`, `index`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(saturation, `percentage`, `saturation`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(lightness, `percentage`, `lightness`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(alpha, `percentage`, `alpha`);
    const hue = index * 137.508;
    return alpha === 1 ? `hsl(${hue},${saturation * 100}%,${lightness * 100}%)` : `hsl(${hue},${saturation * 100}%,${lightness * 100}%,${alpha * 100}%)`;
};
var $8a5cbeb1c6ae1b41$export$d870adf6a93a40c = (rand = (0, $a434a6e836fe5827$export$7b5b9f2074b71a21))=>{
    const r = rand();
    return r * 360;
};
var $8a5cbeb1c6ae1b41$var$fromHsl = (h, s = 1, l = 0.5, opacity = 1)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(h, `percentage`, `h`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(s, `percentage`, `s`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(l, `percentage`, `l`);
    return $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03({
        h: h,
        s: s,
        l: l,
        opacity: opacity,
        space: `hsl`
    });
};
var $8a5cbeb1c6ae1b41$export$593768a1c887fc17 = (colour)=>{
    const c4 = $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(colour);
    const rgb = c4.srgb;
    return c4.alpha < 1 ? {
        r: rgb.r,
        g: rgb.g,
        b: rgb.b,
        opacity: c4.alpha,
        space: `srgb`,
        unit: `relative`
    } : {
        r: rgb.r,
        g: rgb.g,
        b: rgb.b,
        opacity: 1,
        space: `srgb`,
        unit: `relative`
    };
};
var $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03 = (colour, safe = false)=>{
    if (typeof colour === `string`) {
        if (colour.startsWith(`--`)) colour = getComputedStyle(document.body).getPropertyValue(colour);
        return new $8a5cbeb1c6ae1b41$var$Color(colour);
    } else {
        if ($8a5cbeb1c6ae1b41$var$isHsl(colour)) return new $8a5cbeb1c6ae1b41$var$Color($8a5cbeb1c6ae1b41$var$hslToColorJs(colour, safe));
        const rgb = $8a5cbeb1c6ae1b41$export$5dcc4524a470324(colour);
        if (rgb.success) return new $8a5cbeb1c6ae1b41$var$Color($8a5cbeb1c6ae1b41$var$rgbToColorJs(rgb.value));
        if ($8a5cbeb1c6ae1b41$var$isOklch(colour)) return new $8a5cbeb1c6ae1b41$var$Color($8a5cbeb1c6ae1b41$var$oklchToColorJs(colour));
    }
    return colour;
};
var $8a5cbeb1c6ae1b41$export$23fa9a8c7e36c17 = (...colours)=>{
    for (const colour of colours){
        if (colour === void 0) continue;
        if (colour === null) continue;
        const c4 = $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(colour);
        try {
            return c4.display();
        } catch (_error) {
            return c4.toString();
        }
    }
    return `rebeccapurple`;
};
var $8a5cbeb1c6ae1b41$export$7ea66e3774a60b67 = (colour, safe = false)=>{
    if (typeof colour === `string` && colour === `transparent`) return `#00000000`;
    const c4 = $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(colour, safe);
    if (`to` in c4) return c4.to(`srgb`).toString({
        format: `hex`,
        collapse: false
    });
    else throw new Error(`Could not parse colour: ${JSON.stringify(colour)}`);
};
var $8a5cbeb1c6ae1b41$export$550846ee437f5547 = (rgb)=>{
    const result = $8a5cbeb1c6ae1b41$export$5dcc4524a470324(rgb);
    (0, $e8ad1dce15e1a2c0$export$11a85548c4f5cb8b)(result);
    if (rgb.unit === `8bit`) return rgb;
    const { r: r, g: g2, b: b2, opacity: opacity } = rgb;
    const t = {
        r: r * 255,
        g: g2 * 255,
        b: b2 * 255,
        unit: `8bit`,
        space: rgb.space
    };
    if (opacity !== void 0) return {
        ...t,
        opacity: opacity * 255
    };
    return t;
};
var $8a5cbeb1c6ae1b41$export$876e3715299813be = (colour, amt)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(amt, `percentage`, `amt`);
    const c4 = $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(colour);
    const alpha = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)((c4.alpha ?? 0) * amt);
    c4.alpha = alpha;
    return c4.toString();
};
var $8a5cbeb1c6ae1b41$var$multiplySaturation = (colour, amt)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(amt, `percentage`, `amt`);
    const c4 = $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(colour);
    c4.s = (c4.s ?? 0) * amt;
    return c4.toString();
};
var $8a5cbeb1c6ae1b41$export$246d3e180f7f2ea = (name, fallbackColour = `black`, root)=>{
    if (root === void 0) root = document.body;
    if (name.startsWith(`--`)) name = name.slice(2);
    const fromCss = getComputedStyle(root).getPropertyValue(`--${name}`).trim();
    if (fromCss === void 0 || fromCss.length === 0) return fallbackColour;
    return fromCss;
};
var $8a5cbeb1c6ae1b41$var$interpolator = (colours, opts = {})=>{
    const space = opts.space ?? `lch`;
    const hue = opts.hue ?? `shorter`;
    const pieces = $8a5cbeb1c6ae1b41$var$interpolatorInit(colours);
    const ranges = pieces.map((piece)=>piece[0].range(piece[1], {
            space: space,
            hue: hue
        }));
    return (amt)=>{
        amt = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(amt);
        const s = $8a5cbeb1c6ae1b41$export$dcdf75081b88279d(amt, 0, 1, 0, ranges.length);
        const index = Math.floor(s);
        const amtAdjusted = s - index;
        return ranges[index](amtAdjusted);
    };
};
var $8a5cbeb1c6ae1b41$var$interpolatorInit = (colours)=>{
    if (!Array.isArray(colours)) throw new Error(`Param 'colours' is not an array as expected. Got: ${typeof colours}`);
    if (colours.length < 2) throw new Error(`Param 'colours' should be at least two in length. Got: ${colours.length}`);
    const c4 = colours.map((colour)=>$8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(colour));
    return [
        ...(0, $86813b6110828816$export$8f9d79d42bff1aac)(c4)
    ];
};
var $8a5cbeb1c6ae1b41$var$scale3 = (colours, numberOfSteps, opts = {})=>{
    const space = opts.space ?? `lch`;
    const hue = opts.hue ?? `shorter`;
    const pieces = $8a5cbeb1c6ae1b41$var$interpolatorInit(colours);
    const stepsPerPair = Math.floor(numberOfSteps / pieces.length);
    const steps2 = pieces.map((piece)=>piece[0].steps(piece[1], {
            space: space,
            hue: hue,
            steps: stepsPerPair,
            outputSpace: `srgb`
        }));
    return steps2.flat();
};
var $8a5cbeb1c6ae1b41$var$cssLinearGradient = (colours)=>{
    const c4 = colours.map((c5)=>$8a5cbeb1c6ae1b41$export$f7ad0328861e2f03(c5));
    return `linear-gradient(to right, ${c4.map((v)=>v.display()).join(`, `)})`;
};
var $8a5cbeb1c6ae1b41$var$isHsl = (p2)=>{
    if (p2 === void 0 || p2 === null) return false;
    if (typeof p2 !== `object`) return false;
    if (p2.spaceId !== void 0) return false;
    if (p2.coords !== void 0) return false;
    const space = p2.space;
    if (space !== `hsl` && space !== void 0) return false;
    const pp = p2;
    if (pp.h === void 0) return false;
    if (pp.s === void 0) return false;
    if (pp.l === void 0) return false;
    return true;
};
var $8a5cbeb1c6ae1b41$var$isOklch = (p2)=>{
    if (p2 === void 0 || p2 === null) return false;
    if (typeof p2 !== `object`) return false;
    if (p2.spaceId !== void 0) return false;
    if (p2.coords !== void 0) return false;
    if (p2.space !== `oklch`) return false;
    if (p2.l === void 0) return false;
    if (p2.c === void 0) return false;
    if (p2.h === void 0) return false;
    return true;
};
var $8a5cbeb1c6ae1b41$export$5dcc4524a470324 = (p2)=>{
    if (p2 === void 0 || p2 === null) return {
        success: false,
        error: `Undefined/null`
    };
    if (typeof p2 !== `object`) return {
        success: false,
        error: `Not an object`
    };
    const space = p2.space ?? `srgb`;
    let { r: r, g: g2, b: b2, opacity: opacity } = p2;
    if (r !== void 0 || g2 !== void 0 || b2 !== void 0) ;
    else {
        const { red: red, green: green, blue: blue } = p2;
        if (red !== void 0 || green !== void 0 || blue !== void 0) {
            r = red;
            g2 = green;
            b2 = blue;
        } else return {
            success: false,
            error: `Does not contain r,g,b or red,green,blue`
        };
    }
    let unit = p2.unit;
    if (unit === `relative`) {
        if (r > 1 || r < 0) return {
            success: false,
            error: `Relative units, but 'r' exceeds 0..1`
        };
        if (g2 > 1 || g2 < 0) return {
            success: false,
            error: `Relative units, but 'g' exceeds 0..1`
        };
        if (b2 > 1 || b2 < 0) return {
            success: false,
            error: `Relative units, but 'b' exceeds 0..1`
        };
        if (opacity > 1 || opacity < 0) return {
            success: false,
            error: `Relative units, but opacity exceeds 0..1`
        };
    } else if (unit === `8bit`) {
        if (r > 255 || r < 0) return {
            success: false,
            error: `8bit units, but r exceeds 0..255`
        };
        if (g2 > 255 || g2 < 0) return {
            success: false,
            error: `8bit units, but g exceeds 0..255`
        };
        if (b2 > 255 || b2 < 0) return {
            success: false,
            error: `8bit units, but b exceeds 0..255`
        };
        if (opacity > 255 || opacity < 0) return {
            success: false,
            error: `8bit units, but opacity exceeds 0..255`
        };
    } else if (!unit) {
        if (r > 1 || g2 > 1 || b2 > 1) {
            if (r <= 255 && g2 <= 255 && b2 <= 255) unit = `8bit`;
            else return {
                success: false,
                error: `Unknown units, outside 0..255 range`
            };
        } else if (r <= 1 && g2 <= 1 && b2 <= 1) {
            if (r >= 0 && g2 >= 0 && b2 >= 0) unit = `relative`;
            else return {
                success: false,
                error: `Unknown units, outside of 0..1 range`
            };
        } else return {
            success: false,
            error: `Unknown units for r,g,b,opacity values`
        };
    }
    if (opacity === void 0) opacity = unit === `8bit` ? 255 : 1;
    const c4 = {
        r: r,
        g: g2,
        b: b2,
        opacity: opacity,
        unit: unit,
        space: space
    };
    return {
        success: true,
        value: c4
    };
};
// src/geometry/point/Guard.ts
var $8a5cbeb1c6ae1b41$export$630801d484da15df = (p2)=>{
    if ($8a5cbeb1c6ae1b41$export$dfc736aa30714ce2(p2)) {
        if (p2.z !== null) return false;
    }
    return p2.x === null && p2.y === null;
};
var $8a5cbeb1c6ae1b41$export$c9f5652083b8129d = (p2)=>{
    if ($8a5cbeb1c6ae1b41$export$dfc736aa30714ce2(p2)) {
        if (!Number.isNaN(p2.z)) return false;
    }
    return Number.isNaN(p2.x) || Number.isNaN(p2.y);
};
function $8a5cbeb1c6ae1b41$export$864d727b48066337(p2, name = `Point`) {
    if (p2 === void 0) throw new Error(`'${name}' is undefined. Expected {x,y} got ${JSON.stringify(p2)}`);
    if (p2 === null) throw new Error(`'${name}' is null. Expected {x,y} got ${JSON.stringify(p2)}`);
    if (p2.x === void 0) throw new Error(`'${name}.x' is undefined. Expected {x,y} got ${JSON.stringify(p2)}`);
    if (p2.y === void 0) throw new Error(`'${name}.y' is undefined. Expected {x,y} got ${JSON.stringify(p2)}`);
    if (typeof p2.x !== `number`) throw new TypeError(`'${name}.x' must be a number. Got ${typeof p2.x}`);
    if (typeof p2.y !== `number`) throw new TypeError(`'${name}.y' must be a number. Got ${typeof p2.y}`);
    if (p2.z !== void 0) {
        if (typeof p2.z !== `number`) throw new TypeError(`${name}.z must be a number. Got: ${typeof p2.z}`);
        if (Number.isNaN(p2.z)) throw new Error(`'${name}.z' is NaN. Got: ${JSON.stringify(p2)}`);
    }
    if (p2.x === null) throw new Error(`'${name}.x' is null`);
    if (p2.y === null) throw new Error(`'${name}.y' is null`);
    if (Number.isNaN(p2.x)) throw new Error(`'${name}.x' is NaN`);
    if (Number.isNaN(p2.y)) throw new Error(`'${name}.y' is NaN`);
}
var $8a5cbeb1c6ae1b41$export$af9855bfa425668c = (pt, name = `pt`)=>{
    $8a5cbeb1c6ae1b41$export$864d727b48066337(pt, name);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(pt.x, `nonZero`, `${name}.x`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(pt.y, `nonZero`, `${name}.y`);
    if (typeof pt.z !== `undefined`) (0, $984cc5641d701af3$export$d60fcb8dda779864)(pt.z, `nonZero`, `${name}.z`);
    return true;
};
function $8a5cbeb1c6ae1b41$export$aff838a5553f2a92(p2) {
    if (p2 === void 0) return false;
    if (p2 === null) return false;
    if (p2.x === void 0) return false;
    if (p2.y === void 0) return false;
    return true;
}
var $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2 = (p2)=>{
    if (p2 === void 0) return false;
    if (p2 === null) return false;
    if (p2.x === void 0) return false;
    if (p2.y === void 0) return false;
    if (p2.z === void 0) return false;
    return true;
};
var $8a5cbeb1c6ae1b41$export$dd1bc94b04021eeb = (p2)=>{
    if ($8a5cbeb1c6ae1b41$export$dfc736aa30714ce2(p2)) {
        if (p2.z !== 0) return false;
    }
    return p2.x === 0 && p2.y === 0;
};
var $8a5cbeb1c6ae1b41$export$2047bcc885291b3f = (p2)=>{
    if ($8a5cbeb1c6ae1b41$export$dfc736aa30714ce2(p2)) {
        if (!Number.isNaN(p2.z)) return false;
    }
    return Number.isNaN(p2.x) && Number.isNaN(p2.y);
};



// src/numbers/Round.ts
function $42f472314cb088f7$export$2077e0241d6afd3c(a, b, roundUp) {
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(a, `positive`, `decimalPlaces`);
    let up = typeof b === `boolean` ? b : roundUp ?? false;
    let rounder;
    if (a === 0) rounder = Math.round;
    else {
        const p = Math.pow(10, a);
        if (up) rounder = (v)=>Math.ceil(v * p) / p;
        else rounder = (v)=>Math.floor(v * p) / p;
    }
    if (typeof b === `number`) return rounder(b);
    return rounder;
}


// src/util/ToString.ts
var $847987b26b102cb8$var$objectToString = Object.prototype.toString;
var $847987b26b102cb8$var$toTypeString = (value)=>$847987b26b102cb8$var$objectToString.call(value);
var $847987b26b102cb8$export$5c90113a285f2241 = (value)=>$847987b26b102cb8$var$toTypeString(value) === `[object Map]`;
var $847987b26b102cb8$export$6750766a7c7ec627 = (value)=>$847987b26b102cb8$var$toTypeString(value) === `[object Set]`;
var $847987b26b102cb8$export$f5a6f2033c1996c8 = (itemToMakeStringFor)=>typeof itemToMakeStringFor === `string` ? itemToMakeStringFor : JSON.stringify(itemToMakeStringFor);
var $847987b26b102cb8$export$ae78f4343db4f3a1 = (object)=>{
    if (object === null) return `null`;
    if (typeof object === `boolean` || typeof object === `number`) return object.toString();
    if (typeof object === `string`) return object;
    if (typeof object === `symbol`) throw new TypeError(`Symbol cannot be converted to string`);
    return JSON.stringify(object);
};
// src/util/IsEqual.ts
var $847987b26b102cb8$export$745623af0d0533c6 = (itemToMakeStringFor)=>{
    if (typeof itemToMakeStringFor === `string`) return itemToMakeStringFor;
    const allKeys = /* @__PURE__ */ new Set();
    JSON.stringify(itemToMakeStringFor, (key, value)=>(allKeys.add(key), value));
    return JSON.stringify(itemToMakeStringFor, [
        ...allKeys
    ].sort());
};
var $847987b26b102cb8$export$22f6c405afa58f6b = (a, b)=>a === b;
var $847987b26b102cb8$export$a8a61f8380f29e3a = (a, b)=>{
    if (a === b) return true;
    return $847987b26b102cb8$export$f5a6f2033c1996c8(a) === $847987b26b102cb8$export$f5a6f2033c1996c8(b);
};
var $847987b26b102cb8$export$dd9e4d4278c66dbf = (a, b, fieldComparer)=>{
    if (typeof a !== `object`) throw new Error(`Parameter 'a' expected to be object`);
    if (typeof b !== `object`) throw new Error(`Parameter 'b' expected to be object`);
    if (Object.is(a, b)) return true;
    const comparer = fieldComparer ?? $847987b26b102cb8$export$dd9e4d4278c66dbf;
    for (const entryB of Object.entries(b)){
        const valueA = a[entryB[0]];
        const valueB = entryB[1];
        if (typeof valueA === `object` && typeof valueB === `object`) {
            if (!comparer(valueA, valueB)) return false;
        } else {
            if (valueA !== valueB) return false;
        }
    }
    return true;
};
var $847987b26b102cb8$export$7edc20bb5dc6700c = (a, b)=>{
    if (a === b) return true;
    return $847987b26b102cb8$export$745623af0d0533c6(a) === $847987b26b102cb8$export$745623af0d0533c6(b);
};




// src/Events.ts
var $96f72d8c52c10ae7$export$4c7712ccf2c665d3 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($96f72d8c52c10ae7$export$4c7712ccf2c665d3, {
    SimpleEventEmitter: ()=>$96f72d8c52c10ae7$export$115762dd560f5323,
    eventRace: ()=>$96f72d8c52c10ae7$export$848b3f93e34d51fc
});
// src/DefaultKeyer.ts
var $96f72d8c52c10ae7$export$8ccc4b0affe653ec = (a)=>{
    return typeof a === `string` ? a : JSON.stringify(a);
};
// src/collections/map/MapMultiFns.ts
var $96f72d8c52c10ae7$var$firstEntryByValue = (map, value, isEqual = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    for (const e of map.entries()){
        const val = e[1];
        for (const subValue of val){
            if (isEqual(subValue, value)) return e;
        }
    }
};
// src/collections/map/MapOfSimpleBase.ts
var $96f72d8c52c10ae7$var$MapOfSimpleBase = class {
    /**
   * Constructor
   * @param groupBy Creates keys for values when using `addValue`. By default uses JSON.stringify
   * @param valueEq Compare values. By default uses JS logic for equality
   */ constructor(groupBy = $96f72d8c52c10ae7$export$8ccc4b0affe653ec, valueEq = (0, $847987b26b102cb8$export$22f6c405afa58f6b), initial = []){
        this.groupBy = groupBy;
        this.valueEq = valueEq;
        this.map = new Map(initial);
    }
    /**
   * Returns _true_ if `key` exists
   * @param key
   * @returns
   */ has(key) {
        return this.map.has(key);
    }
    /**
   * Returns _true_ if `value` exists under `key`.
   * @param key Key
   * @param value Value to seek under `key`
   * @returns _True_ if `value` exists under `key`.
   */ hasKeyValue(key, value) {
        const values = this.map.get(key);
        if (!values) return false;
        for (const v of values){
            if (this.valueEq(v, value)) return true;
        }
        return false;
    }
    /**
   * Debug dump of contents
   * @returns
   */ debugString() {
        let r = ``;
        const keys = [
            ...this.map.keys()
        ];
        keys.every((k)=>{
            const v = this.map.get(k);
            if (v === void 0) return;
            r += k + ` (${v.length}) = ${JSON.stringify(v)}\r
`;
        });
        return r;
    }
    /**
   * Return number of values stored under `key`.
   * Returns 0 if `key` is not found.
   * @param key
   * @returns
   */ count(key) {
        const values = this.map.get(key);
        if (!values) return 0;
        return values.length;
    }
    /**
  * Returns first key that contains `value`
  * @param value 
  * @param eq 
  * @returns 
  */ firstKeyByValue(value, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b)) {
        const entry = $96f72d8c52c10ae7$var$firstEntryByValue(this, value, eq);
        if (entry) return entry[0];
    }
    /**
   * Iterate over all entries
   */ *entriesFlat() {
        for (const key of this.map.keys())for (const value of this.map.get(key))yield [
            key,
            value
        ];
    }
    /**
   * Iterate over keys and array of values for that key
   */ *entries() {
        for (const [k, v] of this.map.entries())yield [
            k,
            [
                ...v
            ]
        ];
    }
    /**
   * Get all values under `key`
   * @param key
   * @returns
   */ *get(key) {
        const m = this.map.get(key);
        if (!m) return;
        yield* m.values();
    }
    /**
   * Iterate over all keys
   */ *keys() {
        yield* this.map.keys();
    }
    /**
   * Iterate over all values (regardless of key).
   * Use {@link values} to iterate over a set of values per key
   */ *valuesFlat() {
        for (const entries of this.map)yield* entries[1];
    }
    /**
   * Yields the values for each key in sequence, returning an array.
   * Use {@link valuesFlat} to iterate over all keys regardless of key.
   */ *values() {
        for (const entries of this.map)yield entries[1];
    }
    /**
   * Iterate over keys and length of values stored under keys
   */ *keysAndCounts() {
        for (const entries of this.map)yield [
            entries[0],
            entries[1].length
        ];
    }
    /**
   * Returns the count of keys.
   */ get lengthKeys() {
        return this.map.size;
    }
    /**
  * _True_ if empty
  */ get isEmpty() {
        return this.map.size === 0;
    }
};
// src/collections/map/MapOfSimpleMutable.ts
var $96f72d8c52c10ae7$export$518c283e08c68164 = class extends $96f72d8c52c10ae7$var$MapOfSimpleBase {
    addKeyedValues(key, ...values) {
        const existing = this.map.get(key);
        if (existing === void 0) this.map.set(key, values);
        else this.map.set(key, [
            ...existing,
            ...values
        ]);
    }
    /**
   * Set `values` to `key`.
   * Previous data stored under `key` is thrown away.
   * @param key 
   * @param values 
   */ setValues(key, values) {
        this.map.set(key, values);
    }
    /**
   * Adds a value, automatically extracting a key via the
   * `groupBy` function assigned in the constructor options.
   * @param values Adds several values
   */ addValue(...values) {
        for (const v of values){
            const key = this.groupBy(v);
            this.addKeyedValues(key, v);
        }
    }
    /**
   * Delete `value` under a particular `key`
   * @param key
   * @param value
   * @returns _True_ if `value` was found under `key`
   */ deleteKeyValue(key, value) {
        const existing = this.map.get(key);
        if (existing === void 0) return false;
        const without = existing.filter((existingValue)=>!this.valueEq(existingValue, value));
        this.map.set(key, without);
        return without.length < existing.length;
    }
    /**
   * Deletes `value` regardless of key.
   *
   * Uses the constructor-defined equality function.
   * @param value Value to delete
   * @returns
   */ deleteByValue(value) {
        let del = false;
        const entries = [
            ...this.map.entries()
        ];
        for (const keyEntries of entries){
            for (const values of keyEntries[1])if (this.valueEq(values, value)) {
                del = true;
                this.deleteKeyValue(keyEntries[0], value);
            }
        }
        return del;
    }
    /**
   * Deletes all values under `key`,
   * @param key
   * @returns _True_ if `key` was found and values stored
   */ delete(key) {
        const values = this.map.get(key);
        if (!values) return false;
        if (values.length === 0) return false;
        this.map.delete(key);
        return true;
    }
    /**
   * Clear contents
   */ clear() {
        this.map.clear();
    }
};
var $96f72d8c52c10ae7$export$37f12e23142dd83c = (groupBy = $96f72d8c52c10ae7$export$8ccc4b0affe653ec, valueEq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>new $96f72d8c52c10ae7$export$518c283e08c68164(groupBy, valueEq);
// src/flow/IntervalType.ts
function $96f72d8c52c10ae7$export$a3f539fb9b9188ff(interval, defaultNumber) {
    if ($96f72d8c52c10ae7$export$59b3ee3d90b7f75e(interval)) {
        if (typeof interval === `number`) return interval;
        let ms = interval.millis ?? 0;
        ms += (interval.hours ?? 0) * 3600000;
        ms += (interval.mins ?? 0) * 60000;
        ms += (interval.secs ?? 0) * 1e3;
        return ms;
    } else {
        if (typeof defaultNumber !== `undefined`) return defaultNumber;
        throw new Error(`Not a valid interval: ${interval}`);
    }
}
function $96f72d8c52c10ae7$export$59b3ee3d90b7f75e(interval) {
    if (interval === void 0) return false;
    if (interval === null) return false;
    if (typeof interval === `number`) {
        if (Number.isNaN(interval)) return false;
        if (!Number.isFinite(interval)) return false;
        return true;
    } else if (typeof interval !== `object`) return false;
    const hasMillis = `millis` in interval;
    const hasSecs = `secs` in interval;
    const hasMins = `mins` in interval;
    const hasHours = `hours` in interval;
    if (hasMillis && !(0, $984cc5641d701af3$export$4e9798519a1d5a63)(interval.millis)[0]) return false;
    if (hasSecs && !(0, $984cc5641d701af3$export$4e9798519a1d5a63)(interval.secs)[0]) return false;
    if (hasMins && !(0, $984cc5641d701af3$export$4e9798519a1d5a63)(interval.mins)[0]) return false;
    if (hasHours && !(0, $984cc5641d701af3$export$4e9798519a1d5a63)(interval.hours)[0]) return false;
    if (hasMillis || hasSecs || hasHours || hasMins) return true;
    return false;
}
var $96f72d8c52c10ae7$export$8822669ae797429a = (millisOrFunction, rounding = 2)=>{
    let interval = 0;
    if (typeof millisOrFunction === `function`) {
        const intervalResult = millisOrFunction();
        return $96f72d8c52c10ae7$export$8822669ae797429a(intervalResult);
    } else if (typeof millisOrFunction === `number`) interval = millisOrFunction;
    else if (typeof millisOrFunction === `object`) interval = $96f72d8c52c10ae7$export$a3f539fb9b9188ff(interval);
    let ms = $96f72d8c52c10ae7$export$a3f539fb9b9188ff(interval);
    if (typeof ms === `undefined`) return `(undefined)`;
    if (ms < 1e3) return `${(0, $42f472314cb088f7$export$2077e0241d6afd3c)(rounding, ms)}ms`;
    ms /= 1e3;
    if (ms < 120) return `${ms.toFixed(1)}secs`;
    ms /= 60;
    if (ms < 60) return `${ms.toFixed(2)}mins`;
    ms /= 60;
    return `${ms.toFixed(2)}hrs`;
};
// src/Events.ts
var $96f72d8c52c10ae7$export$848b3f93e34d51fc = (target, eventNames, options = {})=>{
    const intervalMs = $96f72d8c52c10ae7$export$a3f539fb9b9188ff(options.timeout, 60000);
    const signal = options.signal;
    let triggered = false;
    let disposed = false;
    let timeout;
    const promise = new Promise((resolve, reject)=>{
        const onEvent = (event)=>{
            if (`type` in event) {
                if (eventNames.includes(event.type)) {
                    triggered = true;
                    resolve(event);
                    dispose();
                } else console.warn(`eventRace: Got event '${event.type}' that is not in race list`);
            } else {
                console.warn(`eventRace: Event data does not have expected 'type' field`);
                console.log(event);
            }
        };
        for (const name of eventNames)target.addEventListener(name, onEvent);
        const dispose = ()=>{
            if (disposed) return;
            if (timeout !== void 0) clearTimeout(timeout);
            timeout = void 0;
            disposed = true;
            for (const name of eventNames)target.removeEventListener(name, onEvent);
        };
        timeout = setTimeout(()=>{
            if (triggered || disposed) return;
            dispose();
            reject(new Error(`eventRace: Events not fired within interval. Events: ${JSON.stringify(eventNames)} Interval: ${intervalMs}`));
        }, intervalMs);
        signal?.addEventListener(`abort`, ()=>{
            if (triggered || disposed) return;
            dispose();
            reject(new Error(`Abort signal received ${signal.reason}`));
        });
    });
    return promise;
};
var $96f72d8c52c10ae7$export$115762dd560f5323 = class {
    #listeners = $96f72d8c52c10ae7$export$37f12e23142dd83c();
    #disposed = false;
    dispose() {
        if (this.#disposed) return;
        this.clearEventListeners();
    }
    get isDisposed() {
        return this.#disposed;
    }
    /**
   * Fire event
   * @param type Type of event
   * @param args Arguments for event
   * @returns
   */ fireEvent(type, args) {
        if (this.#disposed) throw new Error(`Disposed`);
        const listeners = this.#listeners.get(type);
        for (const l of listeners)l(args, this);
    }
    /**
   * Adds event listener.
   * 
   * @throws Error if emitter is disposed
   * @typeParam K - Events
   * @param name Event name
   * @param listener Event handler
   */ addEventListener(name, listener) {
        if (this.#disposed) throw new Error(`Disposed`);
        this.#listeners.addKeyedValues(name, listener);
    }
    /**
   * Remove event listener
   *
   * @param listener
   */ removeEventListener(type, listener) {
        if (this.#disposed) return;
        this.#listeners.deleteKeyValue(type, listener);
    }
    /**
   * Clear all event listeners
   * @private
   */ clearEventListeners() {
        if (this.#disposed) return;
        this.#listeners.clear();
    }
};



// src/iterables/Iterable.ts
var $3f856c338f7c6dcb$export$edb10ab8dd75a915 = (v)=>Symbol.asyncIterator in new Object(v);
var $3f856c338f7c6dcb$export$9652023d9040757 = (v)=>Symbol.iterator in new Object(v);
var $3f856c338f7c6dcb$export$a36e16046ae8f1bb = (eventSource, eventType)=>{
    const pullQueue = [];
    const pushQueue = [];
    let done = false;
    const pushValue = (args)=>{
        if (pullQueue.length > 0) {
            const resolver = pullQueue.shift();
            resolver(...args);
        } else pushQueue.push(args);
    };
    const pullValue = ()=>new Promise((resolve)=>{
            if (pushQueue.length > 0) {
                const arguments_ = pushQueue.shift();
                resolve(...arguments_);
            } else pullQueue.push(resolve);
        });
    const handler = (...arguments_)=>{
        pushValue(arguments_);
    };
    eventSource.addEventListener(eventType, handler);
    const r = {
        next: async ()=>{
            if (done) return {
                done: true,
                value: void 0
            };
            return {
                done: false,
                value: await pullValue()
            };
        },
        //eslint-disable-next-line @typescript-eslint/require-await
        return: async ()=>{
            done = true;
            eventSource.removeEventListener(eventType, handler);
            return {
                done: true,
                value: void 0
            };
        },
        //eslint-disable-next-line @typescript-eslint/require-await
        throw: async (error)=>{
            done = true;
            return {
                done: true,
                value: Promise.reject(new Error(error))
            };
        }
    };
    return r;
};
// src/collections/queue/QueueFns.ts
var $3f856c338f7c6dcb$var$trimQueue = (opts, queue, toAdd)=>{
    const potentialLength = queue.length + toAdd.length;
    const capacity = opts.capacity ?? potentialLength;
    const toRemove = potentialLength - capacity;
    const policy = opts.discardPolicy ?? `additions`;
    switch(policy){
        // Only add what we can from toAdd
        case `additions`:
            if (queue.length === 0) return toAdd.slice(0, toAdd.length - toRemove);
            if (queue.length === opts.capacity) return queue;
            else return [
                ...queue,
                ...toAdd.slice(0, toRemove - 1)
            ];
        // Remove from rear of queue (last index) before adding new things
        case `newer`:
            if (toRemove >= queue.length) {
                if (queue.length === 0) return [
                    ...toAdd.slice(0, capacity - 1),
                    toAdd.at(-1)
                ];
                return toAdd.slice(Math.max(0, toAdd.length - capacity), Math.min(toAdd.length, capacity) + 1);
            } else {
                const countToAdd = Math.max(1, toAdd.length - queue.length);
                const toAddFinal = toAdd.slice(toAdd.length - countToAdd, toAdd.length);
                const toKeep = queue.slice(0, Math.min(queue.length, capacity - 1));
                const t = [
                    ...toKeep,
                    ...toAddFinal
                ];
                return t;
            }
        // Remove from the front of the queue (0 index). ie. older items are discarded
        case `older`:
            return [
                ...queue,
                ...toAdd
            ].slice(toRemove);
        default:
            throw new Error(`Unknown overflow policy ${policy}`);
    }
};
var $3f856c338f7c6dcb$export$513072ba72100d9c = (opts, queue, ...toAdd)=>{
    if (opts === void 0) throw new Error(`opts parameter undefined`);
    const potentialLength = queue.length + toAdd.length;
    const overSize = opts.capacity && potentialLength > opts.capacity;
    const toReturn = overSize ? $3f856c338f7c6dcb$var$trimQueue(opts, queue, toAdd) : [
        ...queue,
        ...toAdd
    ];
    if (opts.capacity && toReturn.length !== opts.capacity && overSize) throw new Error(`Bug! Expected return to be at capacity. Return len: ${toReturn.length} capacity: ${opts.capacity} opts: ${JSON.stringify(opts)}`);
    if (!opts.capacity && toReturn.length !== potentialLength) throw new Error(`Bug! Return length not expected. Return len: ${toReturn.length} expected: ${potentialLength} opts: ${JSON.stringify(opts)}`);
    return toReturn;
};
var $3f856c338f7c6dcb$export$58dd174b2651c9b9 = (opts, queue)=>{
    if (queue.length === 0) throw new Error(`Queue is empty`);
    return queue.slice(1);
};
var $3f856c338f7c6dcb$export$4d3fb11e950abb9e = (opts, queue)=>queue[0];
var $3f856c338f7c6dcb$export$dd1bc94b04021eeb = (opts, queue)=>queue.length === 0;
var $3f856c338f7c6dcb$export$491ce42b393aa93e = (opts, queue)=>{
    if (opts.capacity) return queue.length >= opts.capacity;
    return false;
};
// src/collections/queue/QueueMutable.ts
var $3f856c338f7c6dcb$export$24f44af47d707e8e = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    constructor(opts = {}, data = []){
        super();
        if (opts === void 0) throw new Error(`opts parameter undefined`);
        this.options = opts;
        this.data = data;
        this.eq = opts.eq ?? (0, $847987b26b102cb8$export$22f6c405afa58f6b);
    }
    clear() {
        const copy = [
            ...this.data
        ];
        this.data = [];
        this.fireEvent(`removed`, {
            finalData: this.data,
            removed: copy
        });
        this.onClear();
    }
    /**
   * Called when all data is cleared
   */ onClear() {}
    at(index) {
        if (index >= this.data.length) throw new Error(`Index outside bounds of queue`);
        const v = this.data.at(index);
        if (v === void 0) throw new Error(`Index appears to be outside range of queue`);
        return v;
    }
    enqueue(...toAdd) {
        this.data = $3f856c338f7c6dcb$export$513072ba72100d9c(this.options, this.data, ...toAdd);
        const length = this.data.length;
        this.onEnqueue(this.data, toAdd);
        return length;
    }
    onEnqueue(result, attemptedToAdd) {
        this.fireEvent(`enqueue`, {
            added: attemptedToAdd,
            finalData: result
        });
    }
    dequeue() {
        const v = $3f856c338f7c6dcb$export$4d3fb11e950abb9e(this.options, this.data);
        if (v === void 0) return;
        this.data = $3f856c338f7c6dcb$export$58dd174b2651c9b9(this.options, this.data);
        this.fireEvent(`dequeue`, {
            removed: v,
            finalData: this.data
        });
        this.onRemoved([
            v
        ], this.data);
        return v;
    }
    onRemoved(removed, finalData) {
        this.fireEvent(`removed`, {
            removed: removed,
            finalData: finalData
        });
    }
    /**
   * Removes values that match `predicate`.
   * @param predicate 
   * @returns Returns number of items removed.
   */ removeWhere(predicate) {
        const countPre = this.data.length;
        const toRemove = this.data.filter((v)=>predicate(v));
        if (toRemove.length === 0) return 0;
        this.data = this.data.filter((element)=>!predicate(element));
        this.onRemoved(toRemove, this.data);
        return countPre - this.data.length;
    }
    /**
  * Return a copy of the array
  * @returns 
  */ toArray() {
        return [
            ...this.data
        ];
    }
    get isEmpty() {
        return $3f856c338f7c6dcb$export$dd1bc94b04021eeb(this.options, this.data);
    }
    get isFull() {
        return $3f856c338f7c6dcb$export$491ce42b393aa93e(this.options, this.data);
    }
    get length() {
        return this.data.length;
    }
    get peek() {
        return $3f856c338f7c6dcb$export$4d3fb11e950abb9e(this.options, this.data);
    }
};
function $3f856c338f7c6dcb$export$9cc7a411a0b9bd72(options = {}, ...startingItems) {
    return new $3f856c338f7c6dcb$export$24f44af47d707e8e({
        ...options
    }, [
        ...startingItems
    ]);
}



// src/data/arrays/ContainsDuplicateInstances.ts
var $0d2c4a84d3bf26b3$export$5ec1bebad0fa749 = (array)=>{
    if (!Array.isArray(array)) throw new Error(`Parameter needs to be an array`);
    for(let index = 0; index < array.length; index++)for(let x = 0; x < array.length; x++){
        if (index === x) continue;
        if (array[index] === array[x]) return true;
    }
    return false;
};






// src/Text.ts
var $ae8f83c19bfd8110$export$fd755b8b866eeec3 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($ae8f83c19bfd8110$export$fd755b8b866eeec3, {
    abbreviate: ()=>$ae8f83c19bfd8110$export$f8e59455b4837291,
    afterMatch: ()=>$ae8f83c19bfd8110$export$ece7822811de3aeb,
    beforeAfterMatch: ()=>$ae8f83c19bfd8110$export$98f4ab5ccff98cba,
    beforeMatch: ()=>$ae8f83c19bfd8110$export$b1d9c5188d32d22a,
    between: ()=>$ae8f83c19bfd8110$export$cf95c51b03f10bae,
    betweenChomp: ()=>$ae8f83c19bfd8110$export$2a1e8b7e9c9869,
    countCharsFromStart: ()=>$ae8f83c19bfd8110$export$d52c103cba2d8915,
    htmlEntities: ()=>$ae8f83c19bfd8110$export$324699496a105db8,
    indexOfCharCode: ()=>$ae8f83c19bfd8110$export$98697ab6aa598b83,
    lineSpan: ()=>$ae8f83c19bfd8110$export$dd4058218745a74f,
    omitChars: ()=>$ae8f83c19bfd8110$export$aafb194044d2a289,
    random: ()=>$ae8f83c19bfd8110$export$22b082955e083ec3,
    splitByLength: ()=>$ae8f83c19bfd8110$export$7a32dd8b629a0529,
    splitRanges: ()=>$ae8f83c19bfd8110$export$891fd7a2ef812db8,
    startsEnds: ()=>$ae8f83c19bfd8110$export$d887b02ac2402f2,
    toStringAbbreviate: ()=>$ae8f83c19bfd8110$export$a53336b0e6664704,
    unwrap: ()=>$ae8f83c19bfd8110$export$debb760848ca95a,
    wildcard: ()=>$ae8f83c19bfd8110$export$f1a4f6fe7579a018
});
// src/random/String.ts
var $ae8f83c19bfd8110$export$22b082955e083ec3 = (lengthOrOptions = 5)=>{
    const options = typeof lengthOrOptions === `number` ? {
        length: lengthOrOptions
    } : lengthOrOptions;
    const calculate = options.source ?? (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    return calculate().toString(36).slice(2, length + 2);
};
// src/Text.ts
var $ae8f83c19bfd8110$export$f8e59455b4837291 = (source, maxLength = 15)=>{
    (0, $984cc5641d701af3$export$3c71f17eb3232c2e)((0, $984cc5641d701af3$export$a92c1e031174f8ef)(maxLength, `aboveZero`, `maxLength`));
    if (typeof source !== `string`) throw new Error(`Parameter 'source' is not a string`);
    if (source.length > maxLength && source.length > 3) {
        if (maxLength > 15) {
            const chunk = Math.round((maxLength - 2) / 2);
            return source.slice(0, chunk) + `...` + source.slice(-chunk);
        }
        return source.slice(0, maxLength) + `...`;
    }
    return source;
};
var $ae8f83c19bfd8110$export$a53336b0e6664704 = (source, maxLength = 20)=>{
    if (source === void 0) return `(undefined)`;
    if (source === null) return `(null)`;
    return $ae8f83c19bfd8110$export$f8e59455b4837291(JSON.stringify(source), maxLength);
};
var $ae8f83c19bfd8110$export$cf95c51b03f10bae = (source, start, end, lastEndMatch = true)=>{
    const startPos = source.indexOf(start);
    if (startPos < 0) return;
    if (end === void 0) end = start;
    const endPos = lastEndMatch ? source.lastIndexOf(end) : source.indexOf(end, startPos + 1);
    if (endPos < 0) return;
    return source.slice(startPos + 1, endPos);
};
var $ae8f83c19bfd8110$export$2a1e8b7e9c9869 = (source, start, end, lastEndMatch = true)=>{
    if (typeof source !== `string`) throw new Error(`Parameter 'source' is not a string`);
    if (typeof start !== `string`) throw new Error(`Parameter 'start' is not a string`);
    if (end !== void 0 && typeof end !== `string`) throw new Error(`Parameter 'end' is not a string`);
    const startPos = source.indexOf(start);
    if (startPos < 0) return [
        source,
        void 0
    ];
    if (end === void 0) end = start;
    const endPos = lastEndMatch ? source.lastIndexOf(end) : source.indexOf(end, startPos + 1);
    if (endPos < 0) return [
        source,
        void 0
    ];
    const between2 = source.slice(startPos + 1, endPos);
    const sourceResult = source.slice(0, startPos) + source.slice(endPos + 1);
    return [
        sourceResult,
        between2
    ];
};
var $ae8f83c19bfd8110$export$98697ab6aa598b83 = (source, code, start = 0, end = source.length - 1)=>{
    for(let index = start; index <= end; index++){
        if (source.codePointAt(index) === code) return index;
    }
    return -1;
};
var $ae8f83c19bfd8110$export$aafb194044d2a289 = (source, removeStart, removeLength)=>source.slice(0, removeStart) + source.slice(removeStart + removeLength);
var $ae8f83c19bfd8110$export$7a32dd8b629a0529 = (source, length2)=>{
    (0, $984cc5641d701af3$export$3c71f17eb3232c2e)((0, $984cc5641d701af3$export$a92c1e031174f8ef)(length2, `aboveZero`, `length`));
    if (source === null) throw new Error(`source parameter null`);
    if (typeof source !== `string`) throw new TypeError(`source parameter not a string`);
    const chunks = Math.ceil(source.length / length2);
    const returnValue = [];
    let start = 0;
    for(let c = 0; c < chunks; c++){
        returnValue.push(source.slice(start, start + length2));
        start += length2;
    }
    return returnValue;
};
var $ae8f83c19bfd8110$export$b1d9c5188d32d22a = (source, match, options = {})=>{
    const ba = $ae8f83c19bfd8110$export$98f4ab5ccff98cba(source, match, options);
    return ba[0];
};
var $ae8f83c19bfd8110$export$ece7822811de3aeb = (source, match, options = {})=>{
    const ba = $ae8f83c19bfd8110$export$98f4ab5ccff98cba(source, match, options);
    return ba[1];
};
var $ae8f83c19bfd8110$export$98f4ab5ccff98cba = (source, match, options = {})=>{
    if (source === void 0) throw new Error(`Param 'source' is undefined`);
    let fallback = options.fallback;
    const ifNoMatch = options.ifNoMatch ?? (fallback ? `fallback` : `original`);
    if (ifNoMatch === `original`) fallback = source;
    if (ifNoMatch === `fallback` && fallback === void 0) throw new Error(`Fallback must be provided`);
    const startPos = options.startPos ?? void 0;
    const fromEnd = options.fromEnd ?? false;
    const m = fromEnd ? source.lastIndexOf(match, startPos) : source.indexOf(match, startPos);
    if (m < 0 && ifNoMatch === `throw`) throw new Error(`Match '${match}' not found in source.`);
    if (m < 0 && ifNoMatch === `original`) return [
        source,
        source
    ];
    if (m < 0 && ifNoMatch === `fallback`) return [
        fallback,
        fallback
    ];
    return [
        source.slice(0, m),
        source.slice(Math.max(0, m + match.length))
    ];
};
var $ae8f83c19bfd8110$export$debb760848ca95a = (source, ...wrappers)=>{
    let matched = false;
    do {
        matched = false;
        for (const w of wrappers)if (source.startsWith(w) && source.endsWith(w)) {
            source = source.slice(w.length, source.length - w.length * 2 + 1);
            matched = true;
        }
    }while (matched);
    return source;
};
var $ae8f83c19bfd8110$export$dd4058218745a74f = (ranges, start, end)=>{
    let s = -1;
    let endPos = -1;
    for (const [index, r] of ranges.entries()){
        s = index;
        if (r.text.length === 0) continue;
        if (start < r.end) break;
    }
    for(let index = s; index < ranges.length; index++){
        const r = ranges[index];
        endPos = index;
        if (end === r.end) {
            endPos = index + 1;
            break;
        }
        if (end < r.end) break;
    }
    return {
        length: endPos - s,
        start: s,
        end: endPos
    };
};
var $ae8f83c19bfd8110$export$891fd7a2ef812db8 = (source, split)=>{
    let start = 0;
    let text = ``;
    const ranges = [];
    let index = 0;
    for(let i = 0; i < source.length; i++)if (source.indexOf(split, i) === i) {
        const end = i;
        ranges.push({
            text: text,
            start: start,
            end: end,
            index: index
        });
        start = end + 1;
        text = ``;
        index++;
    } else text += source.charAt(i);
    if (start < source.length) ranges.push({
        text: text,
        start: start,
        index: index,
        end: source.length
    });
    return ranges;
};
var $ae8f83c19bfd8110$export$d52c103cba2d8915 = (source, ...chars)=>{
    let counted = 0;
    for(let index = 0; index < source.length; index++){
        if (chars.includes(source.charAt(index))) counted++;
        else break;
    }
    return counted;
};
var $ae8f83c19bfd8110$export$d887b02ac2402f2 = (source, start, end = start)=>source.startsWith(start) && source.endsWith(end);
var $ae8f83c19bfd8110$export$324699496a105db8 = (source)=>source.replaceAll(/[&<>\u00A0-\u9999]/g, (index)=>`&#${index.codePointAt(0)};`);
var $ae8f83c19bfd8110$export$f1a4f6fe7579a018 = (pattern)=>{
    const escapeRegex = (value)=>value.replaceAll(/([!$()*+./:=?[\\\]^{|}])/g, `\\$1`);
    pattern = pattern.split(`*`).map((m)=>escapeRegex(m)).join(`.*`);
    pattern = `^` + pattern + `$`;
    const regex = new RegExp(pattern);
    return (value)=>{
        return regex.test(value);
    };
};





// src/util/guards.ts
var $876c839e98abd7e2$export$4209a3271b8ae59d = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($876c839e98abd7e2$export$4209a3271b8ae59d, {
    arrayTest: ()=>$876c839e98abd7e2$export$a31928ed0c4709ab,
    defined: ()=>$876c839e98abd7e2$export$43f40ad3fa1d5c97,
    functionTest: ()=>$876c839e98abd7e2$export$f809157d3f6affaf,
    ifNaN: ()=>(0, $984cc5641d701af3$export$98989fe6ff9c28e),
    integerParse: ()=>(0, $984cc5641d701af3$export$3590893fb629ef46),
    integerTest: ()=>(0, $984cc5641d701af3$export$a92c1e031174f8ef),
    isFunction: ()=>$876c839e98abd7e2$export$f6e2535fb5126e54,
    isPlainObject: ()=>$876c839e98abd7e2$export$53b83ca8eaab0383,
    isPlainObjectOrPrimitive: ()=>$876c839e98abd7e2$export$70870f43c8775ec5,
    isPowerOfTwo: ()=>(0, $984cc5641d701af3$export$b9e43d1765415474),
    isStringArray: ()=>$876c839e98abd7e2$export$f6e922e536d8305c,
    nullUndef: ()=>$876c839e98abd7e2$export$98c757892a2d9792,
    numberTest: ()=>(0, $984cc5641d701af3$export$4e9798519a1d5a63),
    percentTest: ()=>(0, $984cc5641d701af3$export$3cedf23f07f59717),
    stringTest: ()=>$876c839e98abd7e2$export$8cfe3247db5b9175,
    throwArrayTest: ()=>$876c839e98abd7e2$export$53aeea48e3d2445b,
    throwFromResult: ()=>(0, $984cc5641d701af3$export$3c71f17eb3232c2e),
    throwFunctionTest: ()=>$876c839e98abd7e2$export$5d7109937b0a2906,
    throwIntegerTest: ()=>(0, $984cc5641d701af3$export$a4ff393eb12b0888),
    throwNullUndef: ()=>$876c839e98abd7e2$export$d208e7644e720d97,
    throwNumberTest: ()=>(0, $984cc5641d701af3$export$d60fcb8dda779864),
    throwPercentTest: ()=>(0, $984cc5641d701af3$export$212d07e09a081c79),
    throwStringTest: ()=>$876c839e98abd7e2$export$8eb398b02efaed4f
});
// src/util/GuardArrays.ts
var $876c839e98abd7e2$export$a31928ed0c4709ab = (value, parameterName = `?`)=>{
    if (!Array.isArray(value)) return [
        false,
        `Parameter '${parameterName}' is expected to be an array'`
    ];
    return [
        true
    ];
};
var $876c839e98abd7e2$export$53aeea48e3d2445b = (value, parameterName = `?`)=>{
    (0, $984cc5641d701af3$export$3c71f17eb3232c2e)($876c839e98abd7e2$export$a31928ed0c4709ab(value, parameterName));
};
var $876c839e98abd7e2$export$f6e922e536d8305c = (value)=>{
    if (!Array.isArray(value)) return false;
    return !value.some((v)=>typeof v !== `string`);
};
// src/util/GuardEmpty.ts
var $876c839e98abd7e2$export$98c757892a2d9792 = (value, parameterName = `?`)=>{
    if (typeof value === `undefined`) return [
        false,
        `${parameterName} param is undefined`
    ];
    if (value === null) return [
        false,
        `${parameterName} param is null`
    ];
    return [
        true
    ];
};
var $876c839e98abd7e2$export$d208e7644e720d97 = (value, parameterName = `?`)=>{
    const r = $876c839e98abd7e2$export$98c757892a2d9792(value, parameterName);
    if (r[0]) return;
    throw new Error(r[1]);
};
var $876c839e98abd7e2$export$43f40ad3fa1d5c97 = (argument)=>argument !== void 0;
// src/util/GuardFunction.ts
var $876c839e98abd7e2$export$f6e2535fb5126e54 = (object)=>object instanceof Function;
var $876c839e98abd7e2$export$f809157d3f6affaf = (value, parameterName = `?`)=>{
    if (value === void 0) return [
        false,
        `Param '${parameterName}' is undefined. Expected: function.`
    ];
    if (value === null) return [
        false,
        `Param '${parameterName}' is null. Expected: function.`
    ];
    if (typeof value !== `function`) return [
        false,
        `Param '${parameterName}' is type '${typeof value}'. Expected: function`
    ];
    return [
        true
    ];
};
var $876c839e98abd7e2$export$5d7109937b0a2906 = (value, parameterName = `?`)=>{
    const [ok, msg] = $876c839e98abd7e2$export$f809157d3f6affaf(value, parameterName);
    if (ok) return;
    throw new TypeError(msg);
};
// src/util/GuardObject.ts
var $876c839e98abd7e2$export$53b83ca8eaab0383 = (value)=>{
    if (typeof value !== `object` || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};
var $876c839e98abd7e2$export$70870f43c8775ec5 = (value)=>{
    const t = typeof value;
    if (t === `symbol`) return false;
    if (t === `function`) return false;
    if (t === `bigint`) return true;
    if (t === `number`) return true;
    if (t === `string`) return true;
    if (t === `boolean`) return true;
    return $876c839e98abd7e2$export$53b83ca8eaab0383(value);
};
// src/util/GuardString.ts
var $876c839e98abd7e2$export$8cfe3247db5b9175 = (value, range = ``, parameterName = `?`)=>{
    if (typeof value !== `string`) return [
        false,
        `Param '${parameterName} is not type string. Got: ${typeof value}`
    ];
    switch(range){
        case `non-empty`:
            if (value.length === 0) return [
                false,
                `Param '${parameterName} is empty`
            ];
            break;
    }
    return [
        true
    ];
};
var $876c839e98abd7e2$export$8eb398b02efaed4f = (value, range = ``, parameterName = `?`)=>{
    (0, $984cc5641d701af3$export$3c71f17eb3232c2e)($876c839e98abd7e2$export$8cfe3247db5b9175(value, range, parameterName));
};


// src/util/MapKeys.ts
var $c2544ba386edb7ad$export$781522908e4e76a1 = (object, mapFunction)=>{
    const destinationObject = {};
    for (const entries of Object.entries(object)){
        const key = mapFunction(entries[0]);
        destinationObject[key] = entries[1];
    }
    return destinationObject;
};





// src/util/index.ts
var $9364ac8ced0e518d$export$5988cee68c01a2e = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($9364ac8ced0e518d$export$5988cee68c01a2e, {
    Guards: ()=>(0, $876c839e98abd7e2$export$4209a3271b8ae59d),
    comparerInverse: ()=>$9364ac8ced0e518d$export$947347a7565cddcf,
    defaultComparer: ()=>$9364ac8ced0e518d$export$2c7d71451559ec2,
    defaultToString: ()=>(0, $847987b26b102cb8$export$ae78f4343db4f3a1),
    getSorter: ()=>$9364ac8ced0e518d$export$914380f37b1845f7,
    isEqualDefault: ()=>(0, $847987b26b102cb8$export$22f6c405afa58f6b),
    isEqualTrace: ()=>$9364ac8ced0e518d$export$877b80ac098353a5,
    isEqualValueDefault: ()=>(0, $847987b26b102cb8$export$a8a61f8380f29e3a),
    isEqualValueIgnoreOrder: ()=>(0, $847987b26b102cb8$export$7edc20bb5dc6700c),
    isEqualValuePartial: ()=>(0, $847987b26b102cb8$export$dd9e4d4278c66dbf),
    isInteger: ()=>$9364ac8ced0e518d$export$a287f47fed4544b8,
    isMap: ()=>(0, $847987b26b102cb8$export$5c90113a285f2241),
    isSet: ()=>(0, $847987b26b102cb8$export$6750766a7c7ec627),
    jsComparer: ()=>$9364ac8ced0e518d$export$d00313e19320f337,
    mapKeys: ()=>(0, $c2544ba386edb7ad$export$781522908e4e76a1),
    minMaxAvg: ()=>$9364ac8ced0e518d$export$d35fee1eaae8d066,
    numericComparer: ()=>$9364ac8ced0e518d$export$1fe7846c069ac4c9,
    resultErrorToString: ()=>(0, $e8ad1dce15e1a2c0$export$99d5c87bcc0b582e),
    resultToError: ()=>(0, $e8ad1dce15e1a2c0$export$e7f2125cfeb7086c),
    resultToValue: ()=>(0, $e8ad1dce15e1a2c0$export$d71b473300b7b03e),
    runningiOS: ()=>$9364ac8ced0e518d$export$65da683d686bc9aa,
    throwResult: ()=>(0, $e8ad1dce15e1a2c0$export$11a85548c4f5cb8b),
    toStringDefault: ()=>(0, $847987b26b102cb8$export$f5a6f2033c1996c8),
    toStringOrdered: ()=>(0, $847987b26b102cb8$export$745623af0d0533c6)
});
// src/util/Comparers.ts
var $9364ac8ced0e518d$export$1fe7846c069ac4c9 = (x, y)=>{
    if (x === y) return 0;
    if (x > y) return 1;
    return -1;
};
var $9364ac8ced0e518d$export$d00313e19320f337 = (x, y)=>{
    if (x === void 0 && y === void 0) return 0;
    if (x === void 0) return 1;
    if (y === void 0) return -1;
    const xString = (0, $847987b26b102cb8$export$ae78f4343db4f3a1)(x);
    const yString = (0, $847987b26b102cb8$export$ae78f4343db4f3a1)(y);
    if (xString < yString) return -1;
    if (xString > yString) return 1;
    return 0;
};
var $9364ac8ced0e518d$export$947347a7565cddcf = (comparer)=>{
    return (x, y)=>{
        const v = comparer(x, y);
        return v * -1;
    };
};
var $9364ac8ced0e518d$export$2c7d71451559ec2 = (x, y)=>{
    if (typeof x === `number` && typeof y === `number`) return $9364ac8ced0e518d$export$1fe7846c069ac4c9(x, y);
    return $9364ac8ced0e518d$export$d00313e19320f337(x, y);
};
// src/util/IsEqualTrace.ts
var $9364ac8ced0e518d$export$877b80ac098353a5 = (eq)=>{
    return (a, b)=>{
        const result = eq(a, b);
        console.log(`isEqualTrace eq: ${result} a: ${(0, $ae8f83c19bfd8110$export$a53336b0e6664704)(a)} b: ${(0, $ae8f83c19bfd8110$export$a53336b0e6664704)(b)}`);
        return result;
    };
};
// src/util/IsInteger.ts
var $9364ac8ced0e518d$export$a287f47fed4544b8 = (value)=>{
    if (value === void 0) return false;
    if (typeof value === `string`) {
        const v = Number.parseInt(value);
        if (Number.isNaN(v)) return false;
        if (v.toString() === value.toString()) return true;
        return false;
    }
    if (typeof value === `number`) {
        if (Number.isNaN(value)) return false;
        if (!Number.isFinite(value)) return false;
        if (Math.round(value) === value) return true;
        return false;
    }
    return false;
};
// src/util/Platform.ts
var $9364ac8ced0e518d$export$65da683d686bc9aa = ()=>[
        `iPad Simulator`,
        `iPhone Simulator`,
        `iPod Simulator`,
        `iPad`,
        `iPhone`,
        `iPod`
    ].includes(navigator.platform) || // iPad on iOS 13 detection
    navigator.userAgent.includes(`Mac`) && `ontouchend` in document;
// src/iterables/sync/Slice.ts
function* $9364ac8ced0e518d$export$58adb3bec8346d0f(it, start = 0, end = Number.POSITIVE_INFINITY) {
    const iit = it[Symbol.iterator]();
    if (end < start) throw new Error(`Param 'end' should be more than 'start'`);
    for(; start > 0; start--, end--)iit.next();
    for (const v of it){
        if (end-- > 0) yield v;
        else break;
    }
}
// src/data/arrays/GuardIndex.ts
var $9364ac8ced0e518d$export$cca6281cc24253c = (array, index, name = `index`)=>{
    (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(array);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(index, `positive`, name);
    if (index > array.length - 1) throw new Error(`'${name}' ${index} beyond array max of ${array.length - 1}`);
};
// src/data/arrays/Filter.ts
var $9364ac8ced0e518d$export$1ef67baf50ada97 = (data)=>{
    return data.filter((v)=>v !== void 0);
};
var $9364ac8ced0e518d$export$fb695f9b55880929 = (data, filter)=>{
    const a = [];
    const b = [];
    for (const datum of data)if (filter(datum)) a.push(datum);
    else b.push(datum);
    return [
        a,
        b
    ];
};
function* $9364ac8ced0e518d$export$b0c2b5b4231e629a(array, predicate, startIndex, endIndex) {
    (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(array);
    if (typeof startIndex === `undefined`) startIndex = 0;
    if (typeof endIndex === `undefined`) endIndex = array.length;
    $9364ac8ced0e518d$export$cca6281cc24253c(array, startIndex, `startIndex`);
    $9364ac8ced0e518d$export$cca6281cc24253c(array, endIndex - 1, `endIndex`);
    for(let index = startIndex; index < endIndex; index++)if (predicate(array[index], index, array)) yield array[index];
}
var $9364ac8ced0e518d$export$5d14bf425b37f49e = (sourceArray, toRemove, comparer = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    if (Array.isArray(toRemove)) {
        const returnArray = [];
        for (const source of sourceArray)if (!toRemove.some((v)=>comparer(source, v))) returnArray.push(source);
        return returnArray;
    } else return sourceArray.filter((v)=>!comparer(v, toRemove));
};
// src/numbers/MinMaxAvg.ts
var $9364ac8ced0e518d$export$24ad9025a0be0d69 = (data, opts = {})=>{
    if (data === void 0) throw new Error(`'data' is undefined`);
    if (!Array.isArray(data)) {
        if (`next` in data) {
            if (opts.startIndex || opts.endIndex) data = $9364ac8ced0e518d$export$58adb3bec8346d0f(data, opts.startIndex, opts.endIndex);
            let total2 = 0;
            let min = Number.MAX_SAFE_INTEGER;
            let max = Number.MIN_SAFE_INTEGER;
            let samples = 0;
            for (const v of data){
                if (typeof v !== `number`) throw new TypeError(`Generator should yield numbers. Got: ${typeof v}`);
                total2 += v;
                samples++;
                min = Math.min(min, v);
                max = Math.max(max, v);
            }
            return {
                avg: total2 / samples,
                total: total2,
                max: max,
                min: min
            };
        } else throw new Error(`'data' parameter is neither array or iterable`);
    }
    if (data.length === 0) return {
        total: 0,
        min: 0,
        max: 0,
        avg: 0
    };
    const startIndex = opts.startIndex ?? 0;
    const endIndex = opts.endIndex ?? data.length;
    const validNumbers = [
        ...$9364ac8ced0e518d$export$b0c2b5b4231e629a(data, (d)=>typeof d === `number` && !Number.isNaN(d), startIndex, endIndex)
    ];
    const total = validNumbers.reduce((accumulator, v)=>accumulator + v, 0);
    return {
        total: total,
        max: Math.max(...validNumbers),
        min: Math.min(...validNumbers),
        avg: total / validNumbers.length
    };
};
// src/util/KeyValue.ts
var $9364ac8ced0e518d$var$sorterByValueIndex = (index, reverse = false)=>{
    return (values)=>{
        const s = values.toSorted((a, b)=>{
            return $9364ac8ced0e518d$export$2c7d71451559ec2(a[index], b[index]);
        });
        if (reverse) return s.reverse();
        return s;
    };
};
var $9364ac8ced0e518d$export$914380f37b1845f7 = (sortStyle)=>{
    switch(sortStyle){
        case `value`:
            return $9364ac8ced0e518d$var$sorterByValueIndex(1, false);
        case `value-reverse`:
            return $9364ac8ced0e518d$var$sorterByValueIndex(1, true);
        case `key`:
            return $9364ac8ced0e518d$var$sorterByValueIndex(0, false);
        case `key-reverse`:
            return $9364ac8ced0e518d$var$sorterByValueIndex(0, true);
        default:
            throw new Error(`Unknown sorting value '${sortStyle}'. Expecting: value, value-reverse, key or key-reverse`);
    }
};
var $9364ac8ced0e518d$export$d35fee1eaae8d066 = (entries, conversionFunction)=>{
    const converter = conversionFunction ?? ((v)=>v[1]);
    const values = entries.map((entry)=>converter(entry));
    return $9364ac8ced0e518d$export$24ad9025a0be0d69(values);
};






// src/iterables/sync/Reduce.ts
function $eca7f6cd1c865161$export$533b26079ad0b4b(it, f, start) {
    for (const v of it)start = f(start, v);
    return start;
}
// src/iterables/IterableSync.ts
var $eca7f6cd1c865161$export$62a3c7ddd42c6686 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($eca7f6cd1c865161$export$62a3c7ddd42c6686, {
    asCallback: ()=>$eca7f6cd1c865161$export$11e61faed1285c36,
    chunks: ()=>$eca7f6cd1c865161$export$99f96ea7ddfd7ba9,
    chunksOverlapping: ()=>$eca7f6cd1c865161$var$chunksOverlapping,
    concat: ()=>$eca7f6cd1c865161$export$ee1b3e54f0441b22,
    dropWhile: ()=>$eca7f6cd1c865161$export$533af5c8cd6afa16,
    equals: ()=>$eca7f6cd1c865161$export$e9bab7fafb253603,
    every: ()=>$eca7f6cd1c865161$export$7ecc1a3b11b57dab,
    fill: ()=>$eca7f6cd1c865161$export$9563e054e6f787fb,
    filter: ()=>$eca7f6cd1c865161$export$3dea766d36a8935f,
    find: ()=>$eca7f6cd1c865161$export$71aa6c912b956294,
    first: ()=>$eca7f6cd1c865161$var$first,
    flatten: ()=>$eca7f6cd1c865161$export$bffa455ba8c619a6,
    forEach: ()=>$eca7f6cd1c865161$export$4b80e395e36b5a56,
    fromArray: ()=>$eca7f6cd1c865161$export$571d59b505e6bb4e,
    fromIterable: ()=>$eca7f6cd1c865161$export$dcccc29c315dd646,
    last: ()=>$eca7f6cd1c865161$var$last,
    map: ()=>$eca7f6cd1c865161$export$871de8747c9eaa88,
    max: ()=>$eca7f6cd1c865161$export$8960430cfd85939f,
    min: ()=>$eca7f6cd1c865161$export$96ec731ed4dcb222,
    next: ()=>$eca7f6cd1c865161$var$next,
    reduce: ()=>$eca7f6cd1c865161$export$533b26079ad0b4b,
    repeat: ()=>$eca7f6cd1c865161$var$repeat,
    slice: ()=>(0, $9364ac8ced0e518d$export$58adb3bec8346d0f),
    some: ()=>$eca7f6cd1c865161$export$ad14ef4001db2bcd,
    toArray: ()=>$eca7f6cd1c865161$export$45b10814cc054894,
    unique: ()=>$eca7f6cd1c865161$export$7a5d5c156e7dc406,
    uniqueByValue: ()=>$eca7f6cd1c865161$export$bf6a3c1875347125,
    until: ()=>$eca7f6cd1c865161$export$a40009bd2c363351,
    yieldNumber: ()=>$eca7f6cd1c865161$var$yieldNumber,
    zip: ()=>$eca7f6cd1c865161$export$8901015135f2fb22
});
function* $eca7f6cd1c865161$export$bf6a3c1875347125(input, toString2 = (0, $847987b26b102cb8$export$f5a6f2033c1996c8), seen = /* @__PURE__ */ new Set()) {
    for (const v of input){
        const key = toString2(v);
        if (seen.has(key)) continue;
        seen.add(key);
        yield v;
    }
}
function $eca7f6cd1c865161$export$11e61faed1285c36(input, callback, onDone) {
    for (const value2 of input)callback(value2);
    if (onDone) onDone();
}
function $eca7f6cd1c865161$var$yieldNumber(generator, defaultValue) {
    return ()=>{
        const v = generator.next().value;
        if (v === void 0) return defaultValue;
        return v;
    };
}
function $eca7f6cd1c865161$var$first(it) {
    for (const value2 of it)return value2;
}
function $eca7f6cd1c865161$var$last(it) {
    let returnValue;
    for (const value2 of it)returnValue = value2;
    return returnValue;
}
function* $eca7f6cd1c865161$var$chunksOverlapping(it, size) {
    if (size <= 1) throw new Error(`Size should be at least 2`);
    let buffer = [];
    for (const v of it){
        buffer.push(v);
        if (buffer.length === size) {
            yield buffer;
            buffer = [
                buffer.at(-1)
            ];
        }
    }
    if (buffer.length <= 1) return;
    if (buffer.length > 0) yield buffer;
}
function* $eca7f6cd1c865161$export$99f96ea7ddfd7ba9(it, size) {
    let buffer = [];
    for (const v of it){
        buffer.push(v);
        if (buffer.length === size) {
            yield buffer;
            buffer = [];
        }
    }
    if (buffer.length > 0) yield buffer;
}
function* $eca7f6cd1c865161$export$ee1b3e54f0441b22(...its) {
    for (const it of its)yield* it;
}
function* $eca7f6cd1c865161$export$533af5c8cd6afa16(it, f) {
    for (const v of it)if (!f(v)) yield v;
}
var $eca7f6cd1c865161$export$a40009bd2c363351 = (it, callback)=>{
    for (const _ of it){
        const value2 = callback();
        if (typeof value2 === `boolean` && !value2) break;
    }
};
var $eca7f6cd1c865161$var$next = (it)=>{
    return ()=>{
        const r = it.next();
        if (r.done) return;
        return r.value;
    };
};
function $eca7f6cd1c865161$export$e9bab7fafb253603(it1, it2, equality) {
    while(true){
        const index1 = it1.next(), index2 = it2.next();
        if (equality !== void 0) {
            if (!equality(index1.value, index2.value)) return false;
        } else if (index1.value !== index2.value) return false;
        if (index1.done ?? index2.done) return index1.done && index2.done;
    }
}
function $eca7f6cd1c865161$export$7ecc1a3b11b57dab(it, f) {
    for (const v of it){
        const result = f(v);
        if (!result) return false;
    }
    return true;
}
function* $eca7f6cd1c865161$export$9563e054e6f787fb(it, v) {
    for (const _ of it)yield v;
}
function $eca7f6cd1c865161$export$4b80e395e36b5a56(iterator, fn) {
    for (const v of iterator){
        const result = fn(v);
        if (typeof result === `boolean` && !result) break;
    }
}
function* $eca7f6cd1c865161$export$3dea766d36a8935f(it, f) {
    for (const v of it){
        if (!f(v)) continue;
        yield v;
    }
}
function $eca7f6cd1c865161$export$71aa6c912b956294(it, f) {
    for (const v of it){
        if (f(v)) return v;
    }
}
function* $eca7f6cd1c865161$export$bffa455ba8c619a6(it) {
    for (const v of it)if (typeof v === `object`) {
        if (Array.isArray(v)) for (const vv of v)yield vv;
        else if ((0, $3f856c338f7c6dcb$export$9652023d9040757)(v)) for (const vv of v)yield vv;
    } else yield v;
}
function* $eca7f6cd1c865161$export$871de8747c9eaa88(it, f) {
    for (const v of it)yield f(v);
}
function* $eca7f6cd1c865161$export$8960430cfd85939f(it, gt = (a, b)=>a > b) {
    let max2;
    for (const v of it){
        if (max2 === void 0) {
            max2 = v;
            yield max2;
            continue;
        }
        if (gt(v, max2)) {
            max2 = v;
            yield max2;
        }
    }
    return max2;
}
function* $eca7f6cd1c865161$export$96ec731ed4dcb222(it, gt = (a, b)=>a > b) {
    let min2;
    for (const v of it){
        if (min2 === void 0) {
            min2 = v;
            yield min2;
        }
        if (gt(min2, v)) {
            min2 = v;
            yield min2;
        }
    }
}
function $eca7f6cd1c865161$export$ad14ef4001db2bcd(it, f) {
    for (const v of it){
        if (f(v)) return true;
    }
    return false;
}
function* $eca7f6cd1c865161$var$repeat(genCreator, repeatsOrSignal) {
    const repeats = typeof repeatsOrSignal === `number` ? repeatsOrSignal : Number.POSITIVE_INFINITY;
    const signal = typeof repeatsOrSignal === `number` ? void 0 : repeatsOrSignal;
    let count = repeats;
    while(true){
        for (const v of genCreator()){
            yield v;
            if (signal?.aborted) break;
        }
        if (Number.isFinite(repeats)) {
            count--;
            if (count === 0) break;
        }
        if (signal?.aborted) break;
    }
}
function* $eca7f6cd1c865161$export$7a5d5c156e7dc406(iterable) {
    const buffer = [];
    let itera = [];
    itera = Array.isArray(iterable) ? iterable : [
        iterable
    ];
    for (const it of itera)for (const v of it){
        if (buffer.includes(v)) continue;
        buffer.push(v);
        yield v;
    }
}
function* $eca7f6cd1c865161$export$8901015135f2fb22(...its) {
    const iits = its.map((it)=>it[Symbol.iterator]());
    while(true){
        const vs = iits.map((it)=>it.next());
        if (vs.some((v)=>v.done)) return;
        yield vs.map((v)=>v.value);
    }
}
function* $eca7f6cd1c865161$export$dcccc29c315dd646(iterable) {
    for (const v of iterable)yield v;
}
function $eca7f6cd1c865161$export$45b10814cc054894(it, options = {}) {
    const result = [];
    const started = Date.now();
    const whileFunc = options.while;
    const maxItems = options.limit ?? Number.POSITIVE_INFINITY;
    const maxElapsed = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.elapsed, Number.POSITIVE_INFINITY);
    for (const v of it){
        if (whileFunc) {
            if (!whileFunc(result.length)) break;
        }
        if (result.length >= maxItems) break;
        if (Date.now() - started > maxElapsed) break;
        result.push(v);
    }
    return result;
}
function* $eca7f6cd1c865161$export$571d59b505e6bb4e(array) {
    for (const v of array)yield v;
}
// src/collections/stack/StackFns.ts
var $eca7f6cd1c865161$var$trimStack = (opts, stack, toAdd)=>{
    const potentialLength = stack.length + toAdd.length;
    const policy = opts.discardPolicy ?? `additions`;
    const capacity = opts.capacity ?? potentialLength;
    const toRemove = potentialLength - capacity;
    if (opts.debug) console.log(`Stack.push: stackLen: ${stack.length} potentialLen: ${potentialLength} toRemove: ${toRemove} policy: ${policy}`);
    switch(policy){
        case `additions`:
            if (opts.debug) console.log(`Stack.push:DiscardAdditions: stackLen: ${stack.length} slice: ${potentialLength - capacity} toAddLen: ${toAdd.length}`);
            if (stack.length === opts.capacity) return stack;
            else return [
                ...stack,
                ...toAdd.slice(0, toAdd.length - toRemove)
            ];
        case `newer`:
            if (toRemove >= stack.length) return toAdd.slice(Math.max(0, toAdd.length - capacity), Math.min(toAdd.length, capacity) + 1);
            else {
                if (opts.debug) console.log(` from orig: ${JSON.stringify(stack.slice(0, stack.length - toRemove))}`);
                return [
                    ...stack.slice(0, stack.length - toRemove),
                    ...toAdd.slice(0, Math.min(toAdd.length, capacity - toRemove + 1))
                ];
            }
        case `older`:
            return [
                ...stack,
                ...toAdd
            ].slice(toRemove);
        default:
            throw new Error(`Unknown discard policy ${policy}`);
    }
};
var $eca7f6cd1c865161$export$4cbf152802aa238 = (opts, stack, ...toAdd)=>{
    const potentialLength = stack.length + toAdd.length;
    const overSize = opts.capacity && potentialLength > opts.capacity;
    const toReturn = overSize ? $eca7f6cd1c865161$var$trimStack(opts, stack, toAdd) : [
        ...stack,
        ...toAdd
    ];
    return toReturn;
};
var $eca7f6cd1c865161$export$3e41007ebfff0e64 = (opts, stack)=>{
    if (stack.length === 0) throw new Error(`Stack is empty`);
    return stack.slice(0, -1);
};
var $eca7f6cd1c865161$export$4d3fb11e950abb9e = (opts, stack)=>stack.at(-1);
var $eca7f6cd1c865161$export$dd1bc94b04021eeb = (opts, stack)=>stack.length === 0;
var $eca7f6cd1c865161$export$491ce42b393aa93e = (opts, stack)=>{
    if (opts.capacity) return stack.length >= opts.capacity;
    return false;
};
// src/collections/stack/StackMutable.ts
var $eca7f6cd1c865161$export$54718c36d7236b27 = class {
    constructor(opts = {}, data = []){
        this.opts = opts;
        this.data = data;
    }
    /**
   * Push data onto the stack.
   * If `toAdd` is empty, nothing happens
   * @param toAdd Data to add
   * @returns Length of stack
   */ push(...toAdd) {
        if (toAdd.length === 0) return this.data.length;
        this.data = $eca7f6cd1c865161$export$4cbf152802aa238(this.opts, this.data, ...toAdd);
        return this.data.length;
    }
    forEach(fn) {
        this.data.forEach(fn);
    }
    forEachFromTop(fn) {
        [
            ...this.data
        ].reverse().forEach(fn);
    }
    pop() {
        const v = $eca7f6cd1c865161$export$4d3fb11e950abb9e(this.opts, this.data);
        this.data = $eca7f6cd1c865161$export$3e41007ebfff0e64(this.opts, this.data);
        return v;
    }
    get isEmpty() {
        return $eca7f6cd1c865161$export$dd1bc94b04021eeb(this.opts, this.data);
    }
    get isFull() {
        return $eca7f6cd1c865161$export$491ce42b393aa93e(this.opts, this.data);
    }
    get peek() {
        return $eca7f6cd1c865161$export$4d3fb11e950abb9e(this.opts, this.data);
    }
    get length() {
        return this.data.length;
    }
};
var $eca7f6cd1c865161$export$9cc7a411a0b9bd72 = (opts = {}, ...startingItems)=>new $eca7f6cd1c865161$export$54718c36d7236b27({
        ...opts
    }, [
        ...startingItems
    ]);
// src/collections/tree/TreeMutable.ts
var $eca7f6cd1c865161$export$5d6199e7c538bbcf = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($eca7f6cd1c865161$export$5d6199e7c538bbcf, {
    add: ()=>$eca7f6cd1c865161$var$add,
    addValue: ()=>$eca7f6cd1c865161$var$addValue,
    asDynamicTraversable: ()=>$eca7f6cd1c865161$export$29e468e556b9807e,
    breadthFirst: ()=>$eca7f6cd1c865161$var$breadthFirst,
    children: ()=>$eca7f6cd1c865161$var$children,
    childrenLength: ()=>$eca7f6cd1c865161$var$childrenLength,
    compare: ()=>$eca7f6cd1c865161$var$compare2,
    computeMaxDepth: ()=>$eca7f6cd1c865161$var$computeMaxDepth,
    createNode: ()=>$eca7f6cd1c865161$export$270e7ba5936d3c48,
    depthFirst: ()=>$eca7f6cd1c865161$var$depthFirst,
    findAnyChildByValue: ()=>$eca7f6cd1c865161$var$findAnyChildByValue,
    findChildByValue: ()=>$eca7f6cd1c865161$var$findChildByValue,
    followValue: ()=>$eca7f6cd1c865161$var$followValue,
    fromPlainObject: ()=>$eca7f6cd1c865161$var$fromPlainObject,
    getRoot: ()=>$eca7f6cd1c865161$export$31e4419873013369,
    hasAnyChild: ()=>$eca7f6cd1c865161$var$hasAnyChild,
    hasAnyParent: ()=>$eca7f6cd1c865161$var$hasAnyParent,
    hasChild: ()=>$eca7f6cd1c865161$var$hasChild,
    hasParent: ()=>$eca7f6cd1c865161$var$hasParent,
    nodeDepth: ()=>$eca7f6cd1c865161$var$nodeDepth,
    parents: ()=>$eca7f6cd1c865161$var$parents,
    queryByValue: ()=>$eca7f6cd1c865161$var$queryByValue,
    remove: ()=>$eca7f6cd1c865161$export$cd7f480d6b8286c3,
    root: ()=>$eca7f6cd1c865161$var$root,
    rootWrapped: ()=>$eca7f6cd1c865161$var$rootWrapped,
    setChildren: ()=>$eca7f6cd1c865161$var$setChildren,
    stripParentage: ()=>$eca7f6cd1c865161$var$stripParentage,
    throwTreeTest: ()=>$eca7f6cd1c865161$var$throwTreeTest,
    toStringDeep: ()=>$eca7f6cd1c865161$export$ae5510fdf995e281,
    treeTest: ()=>$eca7f6cd1c865161$var$treeTest,
    value: ()=>$eca7f6cd1c865161$var$value,
    wrap: ()=>$eca7f6cd1c865161$var$wrap
});
var $eca7f6cd1c865161$var$compare2 = (a, b, eq)=>{
    return $eca7f6cd1c865161$export$398604a469f7de9a($eca7f6cd1c865161$export$29e468e556b9807e(a), $eca7f6cd1c865161$export$29e468e556b9807e(b), eq);
};
var $eca7f6cd1c865161$var$stripParentage = (node)=>{
    const n = {
        value: node.value,
        childrenStore: node.childrenStore.map((c)=>$eca7f6cd1c865161$var$stripParentage(c))
    };
    return n;
};
var $eca7f6cd1c865161$var$unwrapped = (node)=>`wraps` in node ? node.wraps : node;
var $eca7f6cd1c865161$var$wrapped = (node)=>`wraps` in node ? node : $eca7f6cd1c865161$var$wrap(node);
var $eca7f6cd1c865161$var$wrap = (n)=>{
    return {
        *children () {
            for (const c of n.childrenStore)yield $eca7f6cd1c865161$var$wrap(c);
        },
        getValue: ()=>n.value,
        getIdentity: ()=>n,
        *queryValue (value2) {
            for (const v of $eca7f6cd1c865161$var$queryByValue(value2, $eca7f6cd1c865161$var$unwrapped(n)))yield $eca7f6cd1c865161$var$wrap(v);
        },
        getParent: ()=>n.parent === void 0 ? void 0 : $eca7f6cd1c865161$var$wrap(n.parent),
        hasParent: (parent)=>{
            return $eca7f6cd1c865161$var$hasParent(n, $eca7f6cd1c865161$var$unwrapped(parent));
        },
        hasAnyParent: (parent)=>{
            return $eca7f6cd1c865161$var$hasAnyParent(n, $eca7f6cd1c865161$var$unwrapped(parent));
        },
        hasChild: (child)=>{
            return $eca7f6cd1c865161$var$hasChild($eca7f6cd1c865161$var$unwrapped(child), n);
        },
        hasAnyChild: (child)=>{
            return $eca7f6cd1c865161$var$hasAnyChild($eca7f6cd1c865161$var$unwrapped(child), n);
        },
        remove: ()=>{
            $eca7f6cd1c865161$export$cd7f480d6b8286c3(n);
        },
        addValue: (value2)=>{
            const nodeValue = $eca7f6cd1c865161$var$addValue(value2, n);
            return $eca7f6cd1c865161$var$wrap(nodeValue);
        },
        add: (child)=>{
            $eca7f6cd1c865161$var$add($eca7f6cd1c865161$var$unwrapped(child), n);
            return $eca7f6cd1c865161$var$wrapped(child);
        },
        wraps: n
    };
};
var $eca7f6cd1c865161$export$cd7f480d6b8286c3 = (child)=>{
    const p = child.parent;
    if (p === void 0) return;
    child.parent = void 0;
    p.childrenStore = (0, $9364ac8ced0e518d$export$5d14bf425b37f49e)(p.childrenStore, child);
};
function* $eca7f6cd1c865161$var$depthFirst(node) {
    if (!$eca7f6cd1c865161$var$root) return;
    const stack = new $eca7f6cd1c865161$export$54718c36d7236b27();
    stack.push(...node.childrenStore);
    let entry = stack.pop();
    while(entry){
        yield entry;
        if (entry) stack.push(...entry.childrenStore);
        if (stack.isEmpty) break;
        entry = stack.pop();
    }
}
function* $eca7f6cd1c865161$var$breadthFirst(node) {
    if (!node) return;
    const queue = new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)();
    queue.enqueue(...node.childrenStore);
    let entry = queue.dequeue();
    while(entry){
        yield entry;
        if (entry) queue.enqueue(...entry.childrenStore);
        if (queue.isEmpty) break;
        entry = queue.dequeue();
    }
}
function $eca7f6cd1c865161$var$treeTest(root2, seen = []) {
    if (root2.parent === root2) return [
        false,
        `Root has itself as parent`,
        root2
    ];
    if (seen.includes(root2)) return [
        false,
        `Same node instance is appearing further in tree`,
        root2
    ];
    seen.push(root2);
    if ((0, $0d2c4a84d3bf26b3$export$5ec1bebad0fa749)(root2.childrenStore)) return [
        false,
        `Children list contains duplicates`,
        root2
    ];
    for (const c of root2.childrenStore){
        if (c.parent !== root2) return [
            false,
            `Member of childrenStore does not have .parent set`,
            c
        ];
        if ($eca7f6cd1c865161$var$hasAnyChild(root2, c)) return [
            false,
            `Child has parent as its own child`,
            c
        ];
        const v = $eca7f6cd1c865161$var$treeTest(c, seen);
        if (!v[0]) return v;
    }
    return [
        true,
        ``,
        root2
    ];
}
function $eca7f6cd1c865161$var$throwTreeTest(root2) {
    const v = $eca7f6cd1c865161$var$treeTest(root2);
    if (v[0]) return;
    throw new Error(`${v[1]} Node: ${(0, $ae8f83c19bfd8110$export$a53336b0e6664704)(v[2].value, 30)}`, {
        cause: v[2]
    });
}
function* $eca7f6cd1c865161$var$children(root2) {
    for (const c of root2.childrenStore)yield c;
}
function* $eca7f6cd1c865161$var$parents(root2) {
    let p = root2.parent;
    while(p){
        yield p;
        p = p.parent;
    }
}
function $eca7f6cd1c865161$var$nodeDepth(node) {
    const p = [
        ...$eca7f6cd1c865161$var$parents(node)
    ];
    return p.length;
}
var $eca7f6cd1c865161$var$hasChild = (child, parent)=>{
    for (const c of parent.childrenStore){
        if (c === child) return true;
    }
    return false;
};
var $eca7f6cd1c865161$var$findChildByValue = (value2, parent, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    for (const c of parent.childrenStore){
        if (eq(value2, c.value)) return c;
    }
};
function* $eca7f6cd1c865161$var$queryByValue(value2, parent, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b)) {
    for (const c of parent.childrenStore)if (eq(value2, c.value)) yield c;
}
var $eca7f6cd1c865161$var$hasAnyChild = (prospectiveChild, parent)=>{
    for (const c of $eca7f6cd1c865161$var$breadthFirst(parent)){
        if (c === prospectiveChild) return true;
    }
    return false;
};
var $eca7f6cd1c865161$var$findAnyChildByValue = (value2, parent, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    for (const c of $eca7f6cd1c865161$var$breadthFirst(parent)){
        if (eq(c.value, value2)) return c;
    }
};
var $eca7f6cd1c865161$export$31e4419873013369 = (node)=>{
    if (node.parent) return $eca7f6cd1c865161$export$31e4419873013369(node.parent);
    return node;
};
var $eca7f6cd1c865161$var$hasAnyParent = (child, prospectiveParent)=>{
    for (const p of $eca7f6cd1c865161$var$parents(child)){
        if (p === prospectiveParent) return true;
    }
    return false;
};
var $eca7f6cd1c865161$var$hasParent = (child, prospectiveParent)=>{
    return child.parent === prospectiveParent;
};
var $eca7f6cd1c865161$var$computeMaxDepth = (node)=>{
    return $eca7f6cd1c865161$var$computeMaxDepthImpl(node, 0);
};
var $eca7f6cd1c865161$var$computeMaxDepthImpl = (node, startingDepth = 0)=>{
    let depth = startingDepth;
    for (const c of node.childrenStore)depth = Math.max(depth, $eca7f6cd1c865161$var$computeMaxDepthImpl(c, startingDepth + 1));
    return depth;
};
var $eca7f6cd1c865161$var$add = (child, parent)=>{
    $eca7f6cd1c865161$var$throwAttemptedChild(child, parent);
    const p = child.parent;
    parent.childrenStore = [
        ...parent.childrenStore,
        child
    ];
    child.parent = parent;
    if (p) p.childrenStore = (0, $9364ac8ced0e518d$export$5d14bf425b37f49e)(p.childrenStore, child);
};
var $eca7f6cd1c865161$var$addValue = (value2, parent)=>{
    return $eca7f6cd1c865161$export$270e7ba5936d3c48(value2, parent);
};
var $eca7f6cd1c865161$var$root = (value2)=>{
    return $eca7f6cd1c865161$export$270e7ba5936d3c48(value2);
};
var $eca7f6cd1c865161$var$fromPlainObject = (value2, label = ``, parent, seen = [])=>{
    const entries = Object.entries(value2);
    parent = parent === void 0 ? $eca7f6cd1c865161$var$root() : $eca7f6cd1c865161$var$addValue({
        label: label,
        value: value2
    }, parent);
    for (const entry of entries){
        const value3 = entry[1];
        if (seen.includes(value3)) continue;
        seen.push(value3);
        if (typeof entry[1] === `object`) $eca7f6cd1c865161$var$fromPlainObject(value3, entry[0], parent, seen);
        else $eca7f6cd1c865161$var$addValue({
            label: entry[0],
            value: value3
        }, parent);
    }
    return parent;
};
var $eca7f6cd1c865161$var$rootWrapped = (value2)=>{
    return $eca7f6cd1c865161$var$wrap($eca7f6cd1c865161$export$270e7ba5936d3c48(value2));
};
var $eca7f6cd1c865161$export$270e7ba5936d3c48 = (value2, parent)=>{
    const n = {
        childrenStore: [],
        parent: parent,
        value: value2
    };
    if (parent !== void 0) parent.childrenStore = [
        ...parent.childrenStore,
        n
    ];
    return n;
};
var $eca7f6cd1c865161$var$childrenLength = (node)=>{
    return node.childrenStore.length;
};
var $eca7f6cd1c865161$var$value = (node)=>{
    return node.value;
};
var $eca7f6cd1c865161$export$29e468e556b9807e = (node)=>{
    const t = {
        *children () {
            for (const c of node.childrenStore)yield $eca7f6cd1c865161$export$29e468e556b9807e(c);
        },
        getParent () {
            if (node.parent === void 0) return;
            return $eca7f6cd1c865161$export$29e468e556b9807e(node.parent);
        },
        getValue () {
            return node.value;
        },
        getIdentity () {
            return node;
        }
    };
    return t;
};
var $eca7f6cd1c865161$var$throwAttemptedChild = (c, parent)=>{
    if (parent === c) throw new Error(`Cannot add self as child`);
    if (c.parent === parent) return;
    if ($eca7f6cd1c865161$var$hasAnyParent(parent, c)) throw new Error(`Child contains parent (1)`, {
        cause: c
    });
    if ($eca7f6cd1c865161$var$hasAnyParent(c, parent)) throw new Error(`Parent already contains child`, {
        cause: c
    });
    if ($eca7f6cd1c865161$var$hasAnyChild(parent, c)) throw new Error(`Child contains parent (2)`, {
        cause: c
    });
};
var $eca7f6cd1c865161$var$setChildren = (parent, children3)=>{
    for (const c of children3)$eca7f6cd1c865161$var$throwAttemptedChild(c, parent);
    parent.childrenStore = [
        ...children3
    ];
    for (const c of children3)c.parent = parent;
};
var $eca7f6cd1c865161$export$ae5510fdf995e281 = (node, indent = 0)=>{
    const t = `${`  `.repeat(indent)} + ${node.value ? JSON.stringify(node.value) : `-`}`;
    return node.childrenStore.length > 0 ? t + `
` + node.childrenStore.map((d)=>$eca7f6cd1c865161$export$ae5510fdf995e281(d, indent + 1)).join(`
`) : t;
};
function* $eca7f6cd1c865161$var$followValue(root2, continuePredicate, depth = 1) {
    for (const c of root2.childrenStore){
        const value2 = c.value;
        if (value2 === void 0) continue;
        if (continuePredicate(value2, depth)) {
            yield c.value;
            yield* $eca7f6cd1c865161$var$followValue(c, continuePredicate, depth + 1);
        }
    }
}
// src/collections/tree/Compare.ts
var $eca7f6cd1c865161$export$398604a469f7de9a = (a, b, eq = (0, $847987b26b102cb8$export$7edc20bb5dc6700c), parent)=>{
    const valueEqual = $eca7f6cd1c865161$var$valueOrIdentityEqual(a, b, eq);
    const childrenCompare = $eca7f6cd1c865161$var$compareChildren(a, b, eq);
    const diff = {
        valueChanged: !valueEqual,
        a: a,
        b: b,
        added: childrenCompare.added,
        removed: childrenCompare.removed,
        childChanged: false
    };
    const diffNode = {
        value: diff,
        childrenStore: [],
        parent: parent
    };
    const childrenDiff = childrenCompare.identical.map((c)=>$eca7f6cd1c865161$export$398604a469f7de9a(c[0], c[1], eq, diffNode));
    const someChildChange = $eca7f6cd1c865161$var$hasChange(diff) || childrenDiff.some((v)=>$eca7f6cd1c865161$var$hasChange(v.value));
    $eca7f6cd1c865161$var$setChildren(diffNode, childrenDiff);
    diffNode.toString = ()=>$eca7f6cd1c865161$var$toString(diffNode, 0);
    diffNode.value.childChanged = someChildChange;
    $eca7f6cd1c865161$var$throwTreeTest(diffNode);
    return diffNode;
};
var $eca7f6cd1c865161$var$hasChange = (vv)=>{
    if (vv === void 0) return false;
    if (vv.valueChanged) return true;
    if (vv.childChanged) return true;
    if (vv.added.length > 0) return true;
    if (vv.removed.length > 0) return true;
    return false;
};
var $eca7f6cd1c865161$var$compareChildren = (a, b, eq = (0, $847987b26b102cb8$export$7edc20bb5dc6700c))=>{
    const childrenOfA = [
        ...a.children()
    ];
    const childrenOfB = [
        ...b.children()
    ];
    const identical = [];
    const removed = [];
    for (const childA of childrenOfA){
        let foundIndex = -1;
        for (const [index, childOfB] of childrenOfB.entries()){
            const d = $eca7f6cd1c865161$var$valueOrIdentityEqual(childA, childOfB, eq);
            if (d) {
                identical.push([
                    childA,
                    childOfB
                ]);
                foundIndex = index;
                break;
            }
        }
        if (foundIndex === -1) removed.push(childA);
        else childrenOfB.splice(foundIndex, 1);
    }
    const added = [
        ...childrenOfB
    ];
    return {
        added: added,
        identical: identical,
        removed: removed
    };
};
var $eca7f6cd1c865161$var$valueOrIdentityEqual = (a, b, eq)=>{
    if (a.getIdentity() === b.getIdentity()) return true;
    if (eq(a.getValue(), b.getValue())) return true;
    return false;
};
var $eca7f6cd1c865161$var$toStringSingle = (n)=>{
    return JSON.stringify(n.getValue());
};
var $eca7f6cd1c865161$var$toString = (n, indent = 0)=>{
    if (n === void 0) return `(undefined)`;
    let t = $eca7f6cd1c865161$var$toStringDiff(n.value, indent);
    for (const c of n.childrenStore)t += $eca7f6cd1c865161$var$toString(c, indent + 2);
    return t;
};
var $eca7f6cd1c865161$var$toStringDiff = (n, indent)=>{
    const spaces = ` `.repeat(indent);
    if (n === void 0) return `${spaces}(undefined)`;
    const t = [];
    t.push(`a: ${$eca7f6cd1c865161$var$toStringSingle(n.a)} b: ${$eca7f6cd1c865161$var$toStringSingle(n.b)}`);
    if (n.valueChanged) t.push(`Value changed. Child changed: ${n.childChanged}`);
    else t.push(`Value unchanged. Child changed: ${n.childChanged}`);
    if (n.added.length > 0) {
        t.push(`Added:`);
        for (const c of n.added)t.push(` - ` + $eca7f6cd1c865161$var$toStringSingle(c));
    }
    if (n.removed.length > 0) {
        t.push(`Removed: ${n.removed.length}`);
        for (const c of n.removed)t.push(` - ` + $eca7f6cd1c865161$var$toStringSingle(c));
    }
    t.push(`----
`);
    return t.map((line)=>spaces + line).join(`
`);
};
// src/collections/tree/TraverseObject.ts
var $eca7f6cd1c865161$export$8e1e26c78c6458b6 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($eca7f6cd1c865161$export$8e1e26c78c6458b6, {
    asDynamicTraversable: ()=>$eca7f6cd1c865161$export$24081165d5606f1a,
    children: ()=>$eca7f6cd1c865161$var$children2,
    create: ()=>$eca7f6cd1c865161$var$create,
    createSimplified: ()=>$eca7f6cd1c865161$var$createSimplified,
    createWrapped: ()=>$eca7f6cd1c865161$var$createWrapped,
    depthFirst: ()=>$eca7f6cd1c865161$export$cb35ab06ef35a01e,
    getByPath: ()=>$eca7f6cd1c865161$var$getByPath,
    prettyPrint: ()=>$eca7f6cd1c865161$var$prettyPrint,
    prettyPrintEntries: ()=>$eca7f6cd1c865161$var$prettyPrintEntries,
    toStringDeep: ()=>$eca7f6cd1c865161$var$toStringDeep2,
    traceByPath: ()=>$eca7f6cd1c865161$var$traceByPath
});
// src/IsPrimitive.ts
function $eca7f6cd1c865161$export$c3825b437cbdea5c(value2) {
    if (typeof value2 === `number`) return true;
    if (typeof value2 === `string`) return true;
    if (typeof value2 === `bigint`) return true;
    if (typeof value2 === `boolean`) return true;
    return false;
}
// src/collections/tree/TraverseObject.ts
function $eca7f6cd1c865161$var$prettyPrintEntries(entries) {
    if (entries.length === 0) return `(empty)`;
    let t = ``;
    for (const [index, entry] of entries.entries()){
        t += `  `.repeat(index);
        t += entry.name + ` = ` + JSON.stringify(entry.nodeValue) + `
`;
    }
    return t;
}
var $eca7f6cd1c865161$var$prettyPrint = (node, indent = 0, options = {})=>{
    (0, $876c839e98abd7e2$export$d208e7644e720d97)(node, `node`);
    const defaultName = options.name ?? `node`;
    const entry = $eca7f6cd1c865161$var$getNamedEntry(node, defaultName);
    const t = `${`  `.repeat(indent)} + name: ${entry.name} value: ${JSON.stringify(entry.nodeValue)}`;
    const childrenAsArray = [
        ...$eca7f6cd1c865161$var$children2(node, options)
    ];
    return childrenAsArray.length > 0 ? t + `
` + childrenAsArray.map((d)=>$eca7f6cd1c865161$var$prettyPrint(d.nodeValue, indent + 1, {
            ...options,
            name: d.name
        })).join(`
`) : t;
};
var $eca7f6cd1c865161$var$toStringDeep2 = (node, indent = 0)=>{
    let t = ` `.repeat(indent) + ` ${node.value?.name}`;
    if (node.value !== void 0) {
        if (`sourceValue` in node.value && `nodeValue` in node.value) {
            let sourceValue = (0, $ae8f83c19bfd8110$export$a53336b0e6664704)(node.value?.sourceValue, 20);
            const nodeValue = (0, $ae8f83c19bfd8110$export$a53336b0e6664704)(node.value?.nodeValue, 20);
            sourceValue = sourceValue === nodeValue ? `` : `source: ` + sourceValue;
            t += ` = ${nodeValue} ${sourceValue}`;
        } else if (`value` in node.value && node.value.value !== void 0) t += ` = ${node.value.value}`;
        if (`ancestors` in node.value) t += ` (ancestors: ${node.value.ancestors.join(`, `)})`;
    }
    t += `
`;
    for (const c of node.childrenStore)t += $eca7f6cd1c865161$var$toStringDeep2(c, indent + 1);
    return t;
};
function* $eca7f6cd1c865161$var$children2(node, options = {}) {
    (0, $876c839e98abd7e2$export$d208e7644e720d97)(node, `node`);
    const filter2 = options.filter ?? `none`;
    const filterByValue = (v)=>{
        if (filter2 === `none`) return [
            true,
            $eca7f6cd1c865161$export$c3825b437cbdea5c(v)
        ];
        else if (filter2 === `leaves` && $eca7f6cd1c865161$export$c3825b437cbdea5c(v)) return [
            true,
            true
        ];
        else if (filter2 === `branches` && !$eca7f6cd1c865161$export$c3825b437cbdea5c(v)) return [
            true,
            false
        ];
        return [
            false,
            $eca7f6cd1c865161$export$c3825b437cbdea5c(v)
        ];
    };
    if (Array.isArray(node)) for (const [index, element] of node.entries()){
        const f = filterByValue(element);
        if (f[0]) yield {
            name: index.toString(),
            sourceValue: element,
            nodeValue: f[1] ? element : void 0
        };
    }
    else if (typeof node === `object`) {
        const entriesIter = `entries` in node ? node.entries() : Object.entries(node);
        for (const [name, value2] of entriesIter){
            const f = filterByValue(value2);
            if (f[0]) yield {
                name: name,
                sourceValue: value2,
                nodeValue: f[1] ? value2 : void 0
            };
        }
    }
}
function* $eca7f6cd1c865161$export$cb35ab06ef35a01e(node, options = {}, ancestors = []) {
    for (const c of $eca7f6cd1c865161$var$children2(node, options)){
        yield {
            ...c,
            ancestors: [
                ...ancestors
            ]
        };
        yield* $eca7f6cd1c865161$export$cb35ab06ef35a01e(c.sourceValue, options, [
            ...ancestors,
            c.name
        ]);
    }
}
function $eca7f6cd1c865161$var$childByName(name, node) {
    for (const d of $eca7f6cd1c865161$var$children2(node)){
        if (d.name === name) return d;
    }
}
function $eca7f6cd1c865161$var$getByPath(path, node, options = {}) {
    const v = $eca7f6cd1c865161$var$last($eca7f6cd1c865161$var$traceByPath(path, node, options));
    if (!v) throw new Error(`Could not trace path: ${path} `);
    return v;
}
function* $eca7f6cd1c865161$var$traceByPath(path, node, options = {}) {
    (0, $876c839e98abd7e2$export$d208e7644e720d97)(path, `path`);
    (0, $876c839e98abd7e2$export$d208e7644e720d97)(node, `node`);
    const separator = options.separator ?? `.`;
    const pathSplit = path.split(separator);
    const ancestors = [];
    for (const p of pathSplit){
        const entry = $eca7f6cd1c865161$var$childByName(p, node);
        if (!entry) {
            yield {
                name: p,
                sourceValue: void 0,
                nodeValue: void 0,
                ancestors: ancestors
            };
            return;
        }
        node = entry.sourceValue;
        yield {
            ...entry,
            ancestors: [
                ...ancestors
            ]
        };
        ancestors.push(p);
    }
}
var $eca7f6cd1c865161$export$24081165d5606f1a = (node, options = {}, ancestors = [], parent)=>{
    const name = options.name ?? `object`;
    const t = {
        *children () {
            for (const c of $eca7f6cd1c865161$var$children2(node, options))yield $eca7f6cd1c865161$export$24081165d5606f1a(c.sourceValue, {
                ...options,
                name: c.name
            }, [
                ...ancestors,
                name
            ], t);
        },
        getParent () {
            return parent;
        },
        getValue () {
            return {
                name: name,
                value: node,
                ancestors: ancestors
            };
        },
        getIdentity () {
            return node;
        }
    };
    return t;
};
var $eca7f6cd1c865161$var$createWrapped = (node, options)=>{
    return $eca7f6cd1c865161$var$wrap($eca7f6cd1c865161$var$create(node, options));
};
var $eca7f6cd1c865161$var$create = (node, options = {})=>{
    const valuesAtLeaves = options.valuesAtLeaves ?? false;
    const valueFor = valuesAtLeaves ? (v)=>{
        if ($eca7f6cd1c865161$export$c3825b437cbdea5c(v)) return v;
    } : (v)=>v;
    return $eca7f6cd1c865161$var$createImpl(node, valueFor(node), options, []);
};
var $eca7f6cd1c865161$var$createImpl = (sourceValue, nodeValue, options = {}, ancestors)=>{
    const defaultName = options.name ?? `object_ci`;
    const r = $eca7f6cd1c865161$var$root({
        name: defaultName,
        value: nodeValue,
        ancestors: [
            ...ancestors
        ]
    });
    ancestors = [
        ...ancestors,
        defaultName
    ];
    for (const c of $eca7f6cd1c865161$var$children2(sourceValue, options)){
        const v = options.valuesAtLeaves ? c.nodeValue : c.sourceValue;
        $eca7f6cd1c865161$var$add($eca7f6cd1c865161$var$createImpl(c.sourceValue, v, {
            ...options,
            name: c.name
        }, ancestors), r);
    }
    return r;
};
var $eca7f6cd1c865161$var$createSimplified = (node, options = {})=>{
    return $eca7f6cd1c865161$var$stripParentage($eca7f6cd1c865161$var$create(node, options));
};
function $eca7f6cd1c865161$var$getNamedEntry(node, defaultName = ``) {
    if (`name` in node && `nodeValue` in node && `sourceValue` in node) return node;
    if (`name` in node) return {
        name: node.name,
        nodeValue: node,
        sourceValue: node
    };
    return {
        name: defaultName,
        nodeValue: node,
        sourceValue: node
    };
}


// src/numbers/NumericArrays.ts
var $36aa4387660da012$export$89a2d5e3ba94fe8a = (data, fn)=>{
    const f = fn ?? ((x)=>x);
    const valid = $36aa4387660da012$export$dbc711cdddce94af(data);
    return valid.map((v, index)=>{
        const x = v * f(index / (valid.length - 1));
        return x;
    });
};
var $36aa4387660da012$export$dbc711cdddce94af = (data)=>data.filter((d)=>typeof d === `number` && !Number.isNaN(d));
var $36aa4387660da012$export$2dfa5a136446eaca = (values)=>{
    let r = 0;
    const length = values[0].length;
    for(let index = 0; index < length; index++){
        let t = 0;
        for (const [p, value] of values.entries())if (p === 0) t = value[index];
        else t *= value[index];
        r += t;
    }
    return r;
};
var $36aa4387660da012$export$cc6710ee5f037d57 = (data)=>{
    if (data === void 0) throw new Error(`data parameter is undefined`);
    const valid = $36aa4387660da012$export$dbc711cdddce94af(data);
    const total2 = valid.reduce((accumulator, v)=>accumulator + v, 0);
    return total2 / valid.length;
};
var $36aa4387660da012$export$96ec731ed4dcb222 = (data)=>Math.min(...$36aa4387660da012$export$dbc711cdddce94af(data));
var $36aa4387660da012$export$6e0413888cd9bad3 = (data)=>data.reduce((bestIndex, value, index, array)=>value > array[bestIndex] ? index : bestIndex, 0);
var $36aa4387660da012$export$e410eba367ce792b = (...data)=>data.reduce((bestIndex, value, index, array)=>value < array[bestIndex] ? index : bestIndex, 0);
var $36aa4387660da012$export$8960430cfd85939f = (data)=>Math.max(...$36aa4387660da012$export$dbc711cdddce94af(data));
var $36aa4387660da012$export$9086bb9c16b2b5b = (data)=>data.reduce((previous, current)=>{
        if (typeof current !== `number`) return previous;
        if (Number.isNaN(current)) return previous;
        if (!Number.isFinite(current)) return previous;
        return previous + current;
    }, 0);
var $36aa4387660da012$export$f41fc95ce818cf3e = (data)=>{
    let m = Number.MIN_SAFE_INTEGER;
    for (const datum of data)m = Math.max(m, datum);
    return m;
};
var $36aa4387660da012$export$cf1a774fd7314f92 = (data)=>{
    let m = 0;
    for (const datum of data)m += datum;
    return m;
};
var $36aa4387660da012$export$70f363b986c8e811 = (data)=>{
    let m = Number.MIN_SAFE_INTEGER;
    for (const datum of data)m = Math.min(m, datum);
    return m;
};


// src/collections/Map/MapImmutableFns.ts
var $70e9cec26f7f4191$var$addArray = (map, data)=>{
    const x = new Map(map.entries());
    for (const d of data){
        if (d[0] === void 0) throw new Error(`key cannot be undefined`);
        if (d[1] === void 0) throw new Error(`value cannot be undefined`);
        x.set(d[0], d[1]);
    }
    return x;
};
var $70e9cec26f7f4191$var$addObjects = (map, data)=>{
    const x = new Map(map.entries());
    for (const d of data){
        if (d.key === void 0) throw new Error(`key cannot be undefined`);
        if (d.value === void 0) throw new Error(`value cannot be undefined`);
        x.set(d.key, d.value);
    }
    return x;
};
var $70e9cec26f7f4191$export$a4f4bb6b1453fff5 = (map, key)=>map.has(key);
var $70e9cec26f7f4191$export$e16d8520af44a096 = (map, ...data)=>{
    if (map === void 0) throw new Error(`map parameter is undefined`);
    if (data === void 0) throw new Error(`data parameter i.s undefined`);
    if (data.length === 0) return map;
    const firstRecord = data[0];
    const isObject = typeof firstRecord.key !== `undefined` && typeof firstRecord.value !== `undefined`;
    return isObject ? $70e9cec26f7f4191$var$addObjects(map, data) : $70e9cec26f7f4191$var$addArray(map, data);
};
var $70e9cec26f7f4191$export$adaa4cf7ef1b65be = (map, key, value)=>{
    const x = new Map(map.entries());
    x.set(key, value);
    return x;
};
var $70e9cec26f7f4191$export$1d2f21e549771e67 = (map, key)=>{
    const x = new Map(map.entries());
    x.delete(key);
    return x;
};
// src/collections/Map/Map.ts
var $70e9cec26f7f4191$export$fc3a40dec7b33bf = (dataOrMap)=>{
    if (dataOrMap === void 0) return $70e9cec26f7f4191$export$fc3a40dec7b33bf([]);
    if (Array.isArray(dataOrMap)) return $70e9cec26f7f4191$export$fc3a40dec7b33bf($70e9cec26f7f4191$export$e16d8520af44a096(/* @__PURE__ */ new Map(), ...dataOrMap));
    const data = dataOrMap;
    return {
        add: (...itemsToAdd)=>{
            const s = $70e9cec26f7f4191$export$e16d8520af44a096(data, ...itemsToAdd);
            return $70e9cec26f7f4191$export$fc3a40dec7b33bf(s);
        },
        set: (key, value)=>{
            const s = $70e9cec26f7f4191$export$adaa4cf7ef1b65be(data, key, value);
            return $70e9cec26f7f4191$export$fc3a40dec7b33bf(s);
        },
        get: (key)=>data.get(key),
        delete: (key)=>$70e9cec26f7f4191$export$fc3a40dec7b33bf($70e9cec26f7f4191$export$1d2f21e549771e67(data, key)),
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        clear: ()=>$70e9cec26f7f4191$export$fc3a40dec7b33bf(),
        has: (key)=>data.has(key),
        entries: ()=>data.entries(),
        values: ()=>data.values(),
        isEmpty: ()=>data.size === 0
    };
};
// src/collections/Map/NumberMap.ts
var $70e9cec26f7f4191$export$8f8eb378cefe093d = class extends Map {
    constructor(defaultValue = 0){
        super();
        this.defaultValue = defaultValue;
    }
    get(key) {
        const v = super.get(key);
        if (v === void 0) return this.defaultValue;
        return v;
    }
    reset(key) {
        super.set(key, this.defaultValue);
        return this.defaultValue;
    }
    multiply(key, amount) {
        const v = super.get(key);
        let value = v ?? this.defaultValue;
        value *= amount;
        super.set(key, value);
        return value;
    }
    add(key, amount = 1) {
        const v = super.get(key);
        let value = v ?? this.defaultValue;
        value += amount;
        super.set(key, value);
        return value;
    }
    subtract(key, amount = 1) {
        const v = super.get(key);
        let value = v ?? this.defaultValue;
        value -= amount;
        super.set(key, value);
        return value;
    }
};



// src/data/maps/GetOrGenerate.ts
var $c40eb93fec8b01a3$export$49f01f9c43a27799 = (map, fn)=>(key, args)=>{
        let value = map.get(key);
        if (value !== void 0) return value;
        value = fn(key, args);
        map.set(key, value);
        return value;
    };
var $c40eb93fec8b01a3$export$8f4691274895b97 = (map, fn)=>async (key, args)=>{
        let value = map.get(key);
        if (value !== void 0) return value;
        value = await fn(key, args);
        if (value === void 0) throw new Error(`fn returned undefined`);
        map.set(key, value);
        return value;
    };
// src/debug/Logger.ts
var $c40eb93fec8b01a3$export$af88d00dbe7f521 = (prefix, kind = `log`, colourKey)=>(m)=>{
        if (m === void 0) m = `(undefined)`;
        else if (typeof m === `object`) m = JSON.stringify(m);
        const colour = colourKey ?? prefix;
        switch(kind){
            case `log`:
                console.log(`%c${prefix} ${m}`, `color: ${$c40eb93fec8b01a3$export$bab3e120901ceec2(colour)}`);
                break;
            case `warn`:
                console.warn(prefix, m);
                break;
            case `error`:
                console.error(prefix, m);
                break;
        }
    };
var $c40eb93fec8b01a3$export$84ef0e73991701e2 = (prefix, verbose = true, colourKey)=>{
    if (verbose) return {
        log: $c40eb93fec8b01a3$export$af88d00dbe7f521(prefix, `log`, colourKey),
        warn: $c40eb93fec8b01a3$export$af88d00dbe7f521(prefix, `warn`, colourKey),
        error: $c40eb93fec8b01a3$export$af88d00dbe7f521(prefix, `error`, colourKey)
    };
    return {
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        log: (_)=>{},
        warn: $c40eb93fec8b01a3$export$af88d00dbe7f521(prefix, `warn`, colourKey),
        error: $c40eb93fec8b01a3$export$af88d00dbe7f521(prefix, `error`, colourKey)
    };
};
var $c40eb93fec8b01a3$export$9b88029edfd31073 = (l, defaults = {})=>{
    if (l === void 0 || typeof l === `boolean` && !l) return (_)=>{};
    const defaultCat = defaults.category ?? ``;
    const defaultKind = defaults.kind ?? void 0;
    if (typeof l === `boolean`) return (messageOrString)=>{
        const m = typeof messageOrString === `string` ? {
            msg: messageOrString
        } : messageOrString;
        const kind = m.kind ?? defaultKind;
        const category = m.category ?? defaultCat;
        let message = m.msg;
        if (category) message = `[${category}] ${message}`;
        switch(kind){
            case `error`:
                console.error(message);
                break;
            case `warn`:
                console.warn(message);
                break;
            case `info`:
                console.info(message);
                break;
            default:
                console.log(message);
        }
    };
    return l;
};
var $c40eb93fec8b01a3$var$logColourCount = 0;
var $c40eb93fec8b01a3$export$bab3e120901ceec2 = $c40eb93fec8b01a3$export$49f01f9c43a27799(/* @__PURE__ */ new Map(), ()=>{
    const hue = ++$c40eb93fec8b01a3$var$logColourCount * 137.508;
    return `hsl(${hue},50%,75%)`;
});






// src/random/WeightedIndex.ts
var $7b02fea154055fc0$export$68443f7d8ee0abd1 = (weightings, rand = (0, $a434a6e836fe5827$export$7b5b9f2074b71a21))=>{
    const precompute = [];
    let total = 0;
    for(let index = 0; index < weightings.length; index++){
        total += weightings[index];
        precompute[index] = total;
    }
    if (total !== 1) throw new Error(`Weightings should add up to 1. Got: ${total}`);
    return ()=>{
        const v = rand();
        for(let index = 0; index < precompute.length; index++){
            if (v <= precompute[index]) return index;
        }
        throw new Error(`Bug: weightedIndex could not select index`);
    };
};
// src/data/arrays/Random.ts
var $7b02fea154055fc0$export$23b1f9ce5361528e = (array, rand = Math.random)=>Math.floor(rand() * array.length);
var $7b02fea154055fc0$export$cf248d6d1eb3d7bb = (array, mutate = false, rand = Math.random)=>{
    if (array === void 0) throw new Error(`array is undefined`);
    if (!Array.isArray(array)) throw new Error(`'array' param is not an array`);
    if (array.length === 0) return {
        value: void 0,
        array: []
    };
    const index = $7b02fea154055fc0$export$23b1f9ce5361528e(array, rand);
    if (mutate) return {
        value: array[index],
        //eslint-disable-next-line functional/immutable-data
        array: array.splice(index, 1)
    };
    else {
        const t = [
            ...array
        ];
        t.splice(index, 1);
        return {
            value: array[index],
            array: t
        };
    }
};
var $7b02fea154055fc0$export$d3d80cee07107776 = (array, rand = Math.random)=>{
    (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(array, `array`);
    return array[Math.floor(rand() * array.length)];
};
var $7b02fea154055fc0$export$321c827d616b50b4 = (array, weightings, randomSource = Math.random)=>{
    if (array.length !== weightings.length) throw new Error(`Lengths of 'array' and 'weightings' should be the same.`);
    const r = $7b02fea154055fc0$export$68443f7d8ee0abd1(weightings, randomSource);
    return ()=>{
        const index = r();
        return array[index];
    };
};
var $7b02fea154055fc0$export$448332262467e042 = (dataToShuffle, rand = Math.random)=>{
    const array = [
        ...dataToShuffle
    ];
    for(let index = array.length - 1; index > 0; index--){
        const index_ = Math.floor(rand() * (index + 1));
        [array[index], array[index_]] = [
            array[index_],
            array[index]
        ];
    }
    return array;
};
// src/iterables/sync/AdditionalValues.ts
function* $7b02fea154055fc0$var$additionalValues(source, values, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b)) {
    const sourceArray = Array.isArray(source) ? source : [
        ...source
    ];
    const yielded = [];
    for (const v of values){
        const found = sourceArray.find((index)=>eq(index, v));
        if (!found) {
            const alreadyYielded = yielded.find((ii)=>eq(ii, v));
            if (!alreadyYielded) {
                yielded.push(v);
                yield v;
            }
        }
    }
}
// src/data/arrays/Unique.ts
var $7b02fea154055fc0$export$7a5d5c156e7dc406 = (arrays, comparer = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    const t = [];
    for (const a of arrays){
        if (Array.isArray(a)) for (const v of $7b02fea154055fc0$var$additionalValues(t, a, comparer))t.push(v);
        else return [
            ...$7b02fea154055fc0$var$additionalValues([], arrays, comparer)
        ];
    }
    return t;
};




// src/flow/StateMachine.ts
var $29a41e51920ca8b4$export$b89f0c42b95fa6f6 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($29a41e51920ca8b4$export$b89f0c42b95fa6f6, {
    WithEvents: ()=>$29a41e51920ca8b4$export$9b20b63dc5d1b3c0,
    cloneState: ()=>$29a41e51920ca8b4$export$6b2fcc99c2448a1f,
    driver: ()=>$29a41e51920ca8b4$export$2cd8252107eb640b,
    fromList: ()=>$29a41e51920ca8b4$export$88e0dae599377b39,
    fromListBidirectional: ()=>$29a41e51920ca8b4$export$9bf8fff6dfc0c384,
    init: ()=>$29a41e51920ca8b4$export$4ca332855ce43113,
    isDone: ()=>$29a41e51920ca8b4$export$7caf56b642c4b5aa,
    isValidTransition: ()=>$29a41e51920ca8b4$export$1424803210717b8a,
    next: ()=>$29a41e51920ca8b4$export$48cfd1e771a65c4f,
    normaliseTargets: ()=>$29a41e51920ca8b4$export$4a3fbdaf5629a176,
    possible: ()=>$29a41e51920ca8b4$export$60b96687c0593cf3,
    possibleTargets: ()=>$29a41e51920ca8b4$export$6f77c31043bd6f89,
    reset: ()=>$29a41e51920ca8b4$export$aad8462122ac592b,
    to: ()=>$29a41e51920ca8b4$export$2c618a4308a30424,
    validateMachine: ()=>$29a41e51920ca8b4$export$ab5da1b9851b83d7,
    validateTransition: ()=>$29a41e51920ca8b4$export$5a9a92e87e4c7548
});
// src/flow/Execute.ts
var $29a41e51920ca8b4$export$889ea624f2cb2c57 = async (expressions, opts = {}, args)=>{
    const results = [];
    const compareFn = opts.rank ?? (0, $9364ac8ced0e518d$export$2c7d71451559ec2);
    let expressionsArray = Array.isArray(expressions) ? expressions : [
        expressions
    ];
    if (opts.shuffle) expressionsArray = (0, $7b02fea154055fc0$export$448332262467e042)(expressionsArray);
    for(let i = 0; i < expressionsArray.length; i++){
        const exp = expressionsArray[i];
        let r;
        if (typeof exp === "function") r = await exp(args);
        else r = exp;
        if (r !== void 0) {
            results.push(r);
            results.sort(compareFn);
        }
        if (typeof opts.stop !== "undefined") {
            if (opts.stop(r, results)) break;
        }
    }
    if (opts.filter) return results.filter(opts.filter);
    return results;
};
var $29a41e51920ca8b4$export$8dd5356d9d9c1db8 = async (expressions, opts = {}, args)=>{
    const results = await $29a41e51920ca8b4$export$889ea624f2cb2c57(expressions, opts, args);
    if (!results) return;
    if (results.length === 0) return;
    const at = opts.at ?? -1;
    return results.at(at);
};
// src/flow/StateMachineDriver.ts
async function $29a41e51920ca8b4$export$2cd8252107eb640b(machine, handlersOrOpts) {
    const opts = Array.isArray(handlersOrOpts) ? {
        handlers: handlersOrOpts
    } : handlersOrOpts;
    const debug = (0, $c40eb93fec8b01a3$export$9b88029edfd31073)(opts.debug, {
        category: `StateMachineDriver`
    });
    const byState = /* @__PURE__ */ new Map();
    for (const h of opts.handlers){
        const ifBlock = Array.isArray(h.if) ? h.if : [
            h.if
        ];
        for (const state of ifBlock){
            if (typeof state !== `string`) throw new TypeError(`Expected single or array of strings for the 'if' field. Got: '${typeof state}'.`);
            if (byState.has(state)) throw new Error(`Multiple handlers defined for state '${state}'. There should be at most one.`);
            byState.set(state, h);
        }
    }
    const runOpts = {
        // Rank results by score
        rank: (a, b)=>{
            return (0, $9364ac8ced0e518d$export$2c7d71451559ec2)(a.score ?? 0, b.score ?? 0);
        },
        shuffle: opts.shuffleHandlers ?? false
    };
    let sm = $29a41e51920ca8b4$export$4ca332855ce43113(machine);
    for (const [ifState] of byState){
        if (typeof sm.machine[ifState] === `undefined` && ifState !== `__fallback`) throw new Error(`StateMachineDriver handler references a state ('${ifState}') which is not defined on the machine. Therefore this handler will never run.'`);
    }
    const run2 = async ()=>{
        debug(`Run. State: ${sm.value}`);
        const state = sm.value;
        let handler = byState.get(state);
        if (handler === void 0) {
            debug(`  No handler for state '${state}', trying __fallback`);
            handler = byState.get(`__fallback`);
        }
        if (handler === void 0) {
            debug(`  No __fallback handler`);
            return;
        }
        const runOptionsForHandler = handler.resultChoice === `first` ? {
            ...runOpts,
            stop: (latest)=>{
                if (!latest) return false;
                if (`reset` in latest) return true;
                if (`next` in latest && latest.next !== void 0) return true;
                return false;
            }
        } : runOpts;
        const results = await $29a41e51920ca8b4$export$889ea624f2cb2c57(handler.then, runOptionsForHandler, sm);
        debug(`  In state '${sm.value}' results: ${results.length}. Choice: ${handler.resultChoice}`);
        let r;
        switch(handler.resultChoice ?? `highest`){
            case `highest`:
                r = results.at(-1);
                break;
            case `first`:
                r = results[0];
                break;
            case `lowest`:
                r = results.at(0);
                break;
            case `random`:
                r = (0, $7b02fea154055fc0$export$d3d80cee07107776)(results);
                break;
            default:
                throw new Error(`Unknown 'resultChoice' option: ${handler.resultChoice}. Expected highest, first, lowest or random`);
        }
        debug(`  Chosen result: ${JSON.stringify(r)}`);
        if (r?.reset) sm = $29a41e51920ca8b4$export$aad8462122ac592b(sm);
        else if (r && r.next) {
            if (typeof r.next === `boolean`) sm = $29a41e51920ca8b4$export$48cfd1e771a65c4f(sm);
            else {
                debug(JSON.stringify(results));
                sm = $29a41e51920ca8b4$export$2c618a4308a30424(sm, r.next);
            }
        }
        return sm;
    };
    return {
        reset: ()=>{
            sm = $29a41e51920ca8b4$export$aad8462122ac592b(sm);
        },
        getValue: ()=>sm.value,
        run: run2,
        to: (state)=>{
            sm = $29a41e51920ca8b4$export$2c618a4308a30424(sm, state);
            return sm;
        }
    };
}
// src/flow/Stopwatch.ts
var $29a41e51920ca8b4$export$ae56a3c442de3c6a = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($29a41e51920ca8b4$export$ae56a3c442de3c6a, {
    infinity: ()=>$29a41e51920ca8b4$export$a0978488bc4efbee,
    interval: ()=>$29a41e51920ca8b4$export$3174cdbf0a0cbc84,
    once: ()=>$29a41e51920ca8b4$export$d2de3aaeafa91619,
    since: ()=>$29a41e51920ca8b4$export$d83cdf5c040d043
});
// src/flow/Timer.ts
function $29a41e51920ca8b4$export$344a8df14eef2f80(elapsed) {
    const t = $29a41e51920ca8b4$export$f0e7d1106eeabbe6((0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(elapsed, 0), {
        timer: $29a41e51920ca8b4$export$14b940200a0da60a(),
        clampValue: true
    });
    return ()=>t.isDone;
}
function $29a41e51920ca8b4$export$d46c4dddecc8fa49(duration, opts = {}) {
    const totalMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(duration);
    if (!totalMs) throw new Error(`Param 'duration' not valid`);
    const timerOpts = {
        ...opts,
        timer: $29a41e51920ca8b4$export$14b940200a0da60a()
    };
    let t;
    return ()=>{
        if (!t) t = $29a41e51920ca8b4$export$f0e7d1106eeabbe6(totalMs, timerOpts);
        return t.elapsed;
    };
}
function $29a41e51920ca8b4$export$e37aa364174fb88f(totalTicks, opts = {}) {
    const timerOpts = {
        ...opts,
        timer: $29a41e51920ca8b4$export$8a83a8129259072d()
    };
    let t;
    return ()=>{
        if (!t) t = $29a41e51920ca8b4$export$f0e7d1106eeabbe6(totalTicks, timerOpts);
        return t.elapsed;
    };
}
var $29a41e51920ca8b4$export$8beb95963d8287f2 = ()=>({
        elapsed: 1,
        isDone: true,
        reset () {},
        mod (amt) {}
    });
var $29a41e51920ca8b4$export$99645f88bfcf27c6 = ()=>({
        elapsed: 0,
        isDone: false,
        reset () {},
        mod () {}
    });
var $29a41e51920ca8b4$export$f0e7d1106eeabbe6 = (total, options = {})=>{
    if (!Number.isFinite(total)) return $29a41e51920ca8b4$export$8beb95963d8287f2();
    else if (Number.isNaN(total)) return $29a41e51920ca8b4$export$99645f88bfcf27c6();
    const clampValue = options.clampValue ?? false;
    const wrapValue = options.wrapValue ?? false;
    if (clampValue && wrapValue) throw new Error(`clampValue and wrapValue cannot both be enabled`);
    let modulationAmount = 1;
    const timer = options.timer ?? $29a41e51920ca8b4$export$14b940200a0da60a();
    let lastValue = 0;
    const computeElapsed = (value)=>{
        lastValue = value;
        let v = value / (total * modulationAmount);
        if (clampValue) v = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(v);
        else if (wrapValue && v >= 1) v = v % 1;
        return v;
    };
    return {
        mod (amt) {
            modulationAmount = amt;
        },
        get isDone () {
            return computeElapsed(lastValue) >= 1;
        },
        get elapsed () {
            return computeElapsed(timer.elapsed);
        },
        reset: ()=>{
            timer.reset();
        }
    };
};
var $29a41e51920ca8b4$export$8c3ddf86ca88bc10 = (frequency, options = {})=>{
    const timer = options.timer ?? $29a41e51920ca8b4$export$14b940200a0da60a();
    const cyclesPerSecond = frequency / 1e3;
    let modulationAmount = 1;
    const computeElapsed = ()=>{
        const v = timer.elapsed * (cyclesPerSecond * modulationAmount);
        const f = v - Math.floor(v);
        if (f < 0) throw new Error(`Unexpected cycle fraction less than 0. Elapsed: ${v} f: ${f}`);
        if (f > 1) throw new Error(`Unexpected cycle fraction more than 1. Elapsed: ${v} f: ${f}`);
        return f;
    };
    return {
        mod: (amt)=>{
            modulationAmount = amt;
        },
        reset: ()=>{
            timer.reset();
        },
        get isDone () {
            return computeElapsed() >= 1;
        },
        get elapsed () {
            return computeElapsed();
        }
    };
};
var $29a41e51920ca8b4$export$14b940200a0da60a = ()=>{
    let start = performance.now();
    return {
        /**
     * Reset timer
     */ reset: ()=>{
            start = performance.now();
        },
        /**
     * Returns elapsed time since start
     */ get elapsed () {
            return performance.now() - start;
        }
    };
};
var $29a41e51920ca8b4$export$8a83a8129259072d = ()=>{
    let start = 0;
    return {
        /**
     * Reset ticks to 0. The next call to `elapsed` will return 1.
     */ reset: ()=>{
            start = 0;
        },
        /**
     * Get current ticks without incrementing.
     */ get peek () {
            return start;
        },
        /**
     * Returns the number of elapsed ticks as well as
     * incrementing the tick count. 
     * 
     * Minimum is 1
     * 
     * Use {@link peek} to get the current ticks without incrementing.
     */ get elapsed () {
            return ++start;
        }
    };
};
var $29a41e51920ca8b4$export$4dad9723f7b779bd = (fn, timer)=>{
    if (typeof fn !== `function`) throw new Error(`Param 'fn' should be a function. Got: ${typeof fn}`);
    let startCount = 1;
    return {
        get elapsed () {
            return timer.elapsed;
        },
        get isDone () {
            return timer.isDone;
        },
        get runState () {
            if (timer.isDone) return `idle`;
            return `scheduled`;
        },
        /**
     * Returns 1 if it has been created, returns +1 for each additional time the timer has been reset.
     */ get startCount () {
            return startCount;
        },
        get startCountTotal () {
            return startCount;
        },
        compute: ()=>{
            const elapsed = timer.elapsed;
            return fn(elapsed);
        },
        reset: ()=>{
            timer.reset();
            startCount++;
        }
    };
};
// src/flow/Stopwatch.ts
var $29a41e51920ca8b4$export$d83cdf5c040d043 = ()=>{
    const start = performance.now();
    return ()=>{
        return performance.now() - start;
    };
};
var $29a41e51920ca8b4$export$3174cdbf0a0cbc84 = ()=>{
    let start = performance.now();
    return ()=>{
        const now = performance.now();
        const x = now - start;
        start = now;
        return x;
    };
};
var $29a41e51920ca8b4$export$d2de3aaeafa91619 = ()=>{
    const start = Date.now();
    let stoppedAt = 0;
    return ()=>{
        if (stoppedAt === 0) stoppedAt = Date.now() - start;
        return stoppedAt;
    };
};
var $29a41e51920ca8b4$export$a0978488bc4efbee = ()=>{
    return ()=>{
        return Number.POSITIVE_INFINITY;
    };
};
// src/flow/StateMachineWithEvents.ts
var $29a41e51920ca8b4$export$9b20b63dc5d1b3c0 = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    #sm;
    #smInitial;
    #debug;
    #isDoneNeedsFiring = false;
    #isDone = false;
    #changedAt = $29a41e51920ca8b4$export$a0978488bc4efbee();
    /**
   * Create a state machine with initial state, description and options
   * @param m Machine description
   * @param opts Options for machine (defaults to `{debug:false}`)
   */ constructor(m, opts = {}){
        super();
        this.#debug = opts.debug ?? false;
        this.#sm = $29a41e51920ca8b4$export$4ca332855ce43113(m, opts.initial);
        this.#smInitial = $29a41e51920ca8b4$export$6b2fcc99c2448a1f(this.#sm);
    }
    #setIsDone(v) {
        if (this.#isDone === v) return;
        this.#isDone = v;
        if (v) {
            this.#isDoneNeedsFiring = true;
            setTimeout(()=>{
                if (!this.#isDoneNeedsFiring) return;
                this.#isDoneNeedsFiring = false;
                this.fireEvent(`stop`, {
                    state: this.#sm.value
                });
            }, 2);
        } else this.#isDoneNeedsFiring = false;
    }
    /**
   * Return a list of possible states from current state.
   *
   * If list is empty, no states are possible. Otherwise lists
   * possible states, including 'null' for terminal
   */ get statesPossible() {
        return $29a41e51920ca8b4$export$60b96687c0593cf3(this.#sm);
    }
    /**
   * Return a list of all defined states
   */ get statesDefined() {
        return Object.keys(this.#sm.machine);
    }
    /**
   * Moves to the next state if possible. If multiple states are possible, it will use the first.
   * If machine is finalised, no error is thrown and null is returned.
   *
   * @returns {(string|null)} Returns new state, or null if machine is finalised
   */ next() {
        const p = $29a41e51920ca8b4$export$60b96687c0593cf3(this.#sm);
        if (p.length === 0) return null;
        this.state = p[0];
        return p[0];
    }
    /**
   * Returns _true_ if state machine is in its final state
   *
   * @returns
   */ get isDone() {
        return $29a41e51920ca8b4$export$7caf56b642c4b5aa(this.#sm);
    }
    /**
   * Resets machine to initial state
   */ reset() {
        this.#setIsDone(false);
        this.#sm = $29a41e51920ca8b4$export$6b2fcc99c2448a1f(this.#smInitial);
        this.#changedAt = $29a41e51920ca8b4$export$d83cdf5c040d043();
    }
    /**
   * Throws if it's not valid to transition to `newState`
   * @param newState
   * @returns
   */ validateTransition(newState) {
        $29a41e51920ca8b4$export$5a9a92e87e4c7548(this.#sm, newState);
    }
    /**
   * Returns _true_ if `newState` is valid transition from current state.
   * Use {@link validateTransition} if you want an explanation for the _false_ results.
   * @param newState
   * @returns
   */ isValid(newState) {
        return $29a41e51920ca8b4$export$1424803210717b8a(this.#sm, newState);
    }
    /**
   * Gets or sets state. Throws an error if an invalid transition is attempted.
   * Use `isValid()` to check validity without changing.
   *
   * If `newState` is the same as current state, the request is ignored silently.
   */ set state(newState) {
        const priorState = this.#sm.value;
        if (newState === this.#sm.value) return;
        this.#sm = $29a41e51920ca8b4$export$2c618a4308a30424(this.#sm, newState);
        if (this.#debug) console.log(`StateMachine: ${priorState} -> ${newState}`);
        this.#changedAt = $29a41e51920ca8b4$export$d83cdf5c040d043();
        setTimeout(()=>{
            this.fireEvent(`change`, {
                newState: newState,
                priorState: priorState
            });
        }, 1);
        if ($29a41e51920ca8b4$export$7caf56b642c4b5aa(this.#sm)) this.#setIsDone(true);
    }
    get state() {
        return this.#sm.value;
    }
    /**
   * Returns timestamp when state was last changed.
   * See also `elapsed`
   */ get changedAt() {
        return this.#changedAt();
    }
    /**
   * Returns milliseconds elapsed since last state change.
   * See also `changedAt`
   */ get elapsed() {
        return this.#changedAt();
    }
};
// src/flow/StateMachine.ts
var $29a41e51920ca8b4$export$6b2fcc99c2448a1f = (toClone)=>{
    return Object.freeze({
        value: toClone.value,
        visited: [
            ...toClone.visited
        ],
        machine: toClone.machine
    });
};
var $29a41e51920ca8b4$export$4ca332855ce43113 = (stateMachine, initialState)=>{
    const [machine, machineValidationError] = $29a41e51920ca8b4$export$ab5da1b9851b83d7(stateMachine);
    if (!machine) throw new Error(machineValidationError);
    const state = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    initialState ?? Object.keys(machine.states)[0];
    if (machine.states[state] === void 0) throw new TypeError(`Initial state not found`);
    const transitions = $29a41e51920ca8b4$var$validateAndNormaliseTransitions(machine.states);
    if (transitions === void 0) throw new Error(`Could not normalise transitions`);
    return Object.freeze({
        value: state,
        visited: [],
        machine: Object.fromEntries(transitions)
    });
};
var $29a41e51920ca8b4$export$aad8462122ac592b = (sm)=>{
    return $29a41e51920ca8b4$export$4ca332855ce43113(sm.machine);
};
var $29a41e51920ca8b4$export$ab5da1b9851b83d7 = (smOrTransitions)=>{
    if (smOrTransitions === void 0) return [
        void 0,
        `Parameter undefined`
    ];
    if (smOrTransitions === null) return [
        void 0,
        `Parameter null`
    ];
    if (`states` in smOrTransitions) return [
        smOrTransitions,
        ``
    ];
    if (typeof smOrTransitions === `object`) return [
        {
            // @ts-expect-error
            states: smOrTransitions
        },
        ``
    ];
    return [
        void 0,
        `Unexpected type: ${typeof smOrTransitions}. Expected object`
    ];
};
var $29a41e51920ca8b4$export$7caf56b642c4b5aa = (sm)=>{
    return $29a41e51920ca8b4$export$60b96687c0593cf3(sm).length === 0;
};
var $29a41e51920ca8b4$export$6f77c31043bd6f89 = (sm)=>{
    $29a41e51920ca8b4$var$validateMachineState(sm);
    const fromS = sm.machine[sm.value];
    if (fromS.length === 1 && fromS[0].state === null) return [];
    return fromS;
};
var $29a41e51920ca8b4$export$60b96687c0593cf3 = (sm)=>{
    const targets = $29a41e51920ca8b4$export$6f77c31043bd6f89(sm);
    return targets.map((v)=>v.state);
};
var $29a41e51920ca8b4$export$4a3fbdaf5629a176 = (targets)=>{
    const normaliseSingleTarget = (target)=>{
        if (target === null) return {
            state: null
        };
        if (typeof target === `string`) return {
            state: target
        };
        else if (typeof target === `object` && `state` in target) {
            const targetState = target.state;
            if (typeof targetState !== `string`) throw new TypeError(`Target 'state' field is not a string. Got: ${typeof targetState}`);
            if (`preconditions` in target) return {
                state: targetState,
                preconditions: target.preconditions
            };
            return {
                state: targetState
            };
        } else throw new Error(`Unexpected type: ${typeof target}. Expected string or object with 'state' field.`);
    };
    if (Array.isArray(targets)) {
        let containsNull = false;
        const mapResults = targets.map((t)=>{
            const r = normaliseSingleTarget(t);
            if (!r) throw new Error(`Invalid target`);
            containsNull = containsNull || r.state === null;
            return r;
        });
        if (containsNull && mapResults.length > 1) throw new Error(`Cannot have null as an possible state`);
        return mapResults;
    } else {
        const target = normaliseSingleTarget(targets);
        if (!target) return;
        return [
            target
        ];
    }
};
var $29a41e51920ca8b4$var$validateAndNormaliseTransitions = (d)=>{
    const returnMap = /* @__PURE__ */ new Map();
    for (const [topLevelState, topLevelTargets] of Object.entries(d)){
        if (typeof topLevelState === `undefined`) throw new TypeError(`Top-level undefined state`);
        if (typeof topLevelTargets === `undefined`) throw new TypeError(`Undefined target state for ${topLevelState}`);
        if (returnMap.has(topLevelState)) throw new Error(`State defined twice: ${topLevelState}`);
        if (topLevelState.includes(` `)) throw new Error(`State names cannot contain spaces`);
        returnMap.set(topLevelState, []);
    }
    for (const [topLevelState, topLevelTargets] of Object.entries(d)){
        const targets = $29a41e51920ca8b4$export$4a3fbdaf5629a176(topLevelTargets);
        if (targets === void 0) throw new Error(`Could not normalise target`);
        if (targets !== null) {
            const seenStates = /* @__PURE__ */ new Set();
            for (const target of targets){
                if (seenStates.has(target.state)) throw new Error(`Target state '${target.state}' already exists for '${topLevelState}'`);
                seenStates.add(target.state);
                if (target.state === null) continue;
                if (!returnMap.has(target.state)) throw new Error(`Target state '${target.state}' is not defined as a top-level state. Defined under: '${topLevelState}'`);
            }
            returnMap.set(topLevelState, targets);
        }
    }
    return returnMap;
};
var $29a41e51920ca8b4$var$validateMachineState = (state)=>{
    if (state === void 0) throw new TypeError(`Parameter 'state' is undefined`);
    if (typeof state.value !== `string`) throw new TypeError(`Existing state is not a string`);
};
var $29a41e51920ca8b4$export$2c618a4308a30424 = (sm, toState)=>{
    $29a41e51920ca8b4$var$validateMachineState(sm);
    $29a41e51920ca8b4$export$5a9a92e87e4c7548(sm, toState);
    return Object.freeze({
        value: toState,
        machine: sm.machine,
        visited: (0, $7b02fea154055fc0$export$7a5d5c156e7dc406)([
            sm.visited,
            [
                sm.value
            ]
        ])
    });
};
var $29a41e51920ca8b4$export$48cfd1e771a65c4f = (sm)=>{
    const first = $29a41e51920ca8b4$export$6f77c31043bd6f89(sm).at(0);
    if (!first || first.state === null) throw new Error(`Not possible to move to a next state from '${sm.value}`);
    return $29a41e51920ca8b4$export$2c618a4308a30424(sm, first.state);
};
var $29a41e51920ca8b4$export$1424803210717b8a = (sm, toState)=>{
    try {
        $29a41e51920ca8b4$export$5a9a92e87e4c7548(sm, toState);
        return true;
    } catch  {
        return false;
    }
};
var $29a41e51920ca8b4$export$5a9a92e87e4c7548 = (sm, toState)=>{
    if (toState === null) throw new Error(`Cannot transition to null state`);
    if (toState === void 0) throw new Error(`Cannot transition to undefined state`);
    if (typeof toState !== `string`) throw new TypeError(`Parameter 'toState' should be a string. Got: ${typeof toState}`);
    const p = $29a41e51920ca8b4$export$60b96687c0593cf3(sm);
    if (p.length === 0) throw new Error(`Machine is in terminal state`);
    if (!p.includes(toState)) throw new Error(`Target state '${toState}' not available at current state '${sm.value}'. Possible states: ${p.join(`, `)}`);
};
var $29a41e51920ca8b4$export$88e0dae599377b39 = (...states)=>{
    const t = {};
    if (!Array.isArray(states)) throw new Error(`Expected array of strings`);
    if (states.length <= 2) throw new Error(`Expects at least two states`);
    for(let index = 0; index < states.length; index++){
        const s = states[index];
        if (typeof s !== `string`) throw new TypeError(`Expected array of strings. Got type '${typeof s}' at index ${index}`);
        t[s] = index === states.length - 1 ? null : states[index + 1];
    }
    return t;
};
var $29a41e51920ca8b4$export$9bf8fff6dfc0c384 = (...states)=>{
    const t = {};
    if (!Array.isArray(states)) throw new Error(`Expected array of strings`);
    if (states.length < 2) throw new Error(`Expects at least two states`);
    for (const [index, s] of states.entries()){
        if (typeof s !== `string`) throw new TypeError(`Expected array of strings. Got type '${typeof s}' at index ${index}`);
        t[s] = [];
    }
    for(let index = 0; index < states.length; index++){
        const v = t[states[index]];
        if (index === states.length - 1) {
            if (states.length > 1) v.push(states[index - 1]);
            else t[states[index]] = null;
        } else {
            v.push(states[index + 1]);
            if (index > 0) v.push(states[index - 1]);
        }
    }
    return t;
};








// src/flow/index.ts
var $f53657e65b61d2bb$export$262e28e3815f1ccb = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($f53657e65b61d2bb$export$262e28e3815f1ccb, {
    BehaviourTree: ()=>$f53657e65b61d2bb$export$e4d652a030487ea7,
    DispatchList: ()=>$f53657e65b61d2bb$export$5950d7e22009b6fe,
    Elapsed: ()=>(0, $29a41e51920ca8b4$export$ae56a3c442de3c6a),
    RequestResponseMatch: ()=>$f53657e65b61d2bb$export$30e40236490859fe,
    StateMachine: ()=>(0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6),
    SyncWait: ()=>$f53657e65b61d2bb$export$2449344532dcb5ce,
    TaskQueueMutable: ()=>$f53657e65b61d2bb$export$569994ba22a41a43,
    WaitForValue: ()=>$f53657e65b61d2bb$export$d33bfafa358ccd8a,
    backoffGenerator: ()=>$f53657e65b61d2bb$export$288aa5a292a95a4b,
    continuously: ()=>$f53657e65b61d2bb$export$5df75b4acf95a98a,
    debounce: ()=>$f53657e65b61d2bb$export$61fc7d43ac8f84b0,
    delay: ()=>$f53657e65b61d2bb$export$1391212d75b2ee65,
    delayLoop: ()=>$f53657e65b61d2bb$export$96448421370e6ebc,
    elapsedMillisecondsAbsolute: ()=>(0, $29a41e51920ca8b4$export$14b940200a0da60a),
    elapsedTicksAbsolute: ()=>(0, $29a41e51920ca8b4$export$8a83a8129259072d),
    elapsedToHumanString: ()=>(0, $96f72d8c52c10ae7$export$8822669ae797429a),
    everyNth: ()=>$f53657e65b61d2bb$export$b730691daab32e4b,
    frequencyTimer: ()=>(0, $29a41e51920ca8b4$export$8c3ddf86ca88bc10),
    hasElapsed: ()=>(0, $29a41e51920ca8b4$export$344a8df14eef2f80),
    infinity: ()=>(0, $29a41e51920ca8b4$export$a0978488bc4efbee),
    interval: ()=>(0, $29a41e51920ca8b4$export$3174cdbf0a0cbc84),
    intervalToMs: ()=>(0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff),
    isInterval: ()=>(0, $96f72d8c52c10ae7$export$59b3ee3d90b7f75e),
    ofTotal: ()=>(0, $29a41e51920ca8b4$export$d46c4dddecc8fa49),
    ofTotalTicks: ()=>(0, $29a41e51920ca8b4$export$e37aa364174fb88f),
    once: ()=>(0, $29a41e51920ca8b4$export$d2de3aaeafa91619),
    promiseFromEvent: ()=>$f53657e65b61d2bb$export$a0302146205b73d0,
    promiseWithResolvers: ()=>$f53657e65b61d2bb$export$283a1614f1b16769,
    rateMinimum: ()=>$f53657e65b61d2bb$export$58840f541415b418,
    relative: ()=>(0, $29a41e51920ca8b4$export$f0e7d1106eeabbe6),
    repeat: ()=>$f53657e65b61d2bb$export$76d90c956114f2c2,
    repeatSync: ()=>$f53657e65b61d2bb$export$788e1482613c4b84,
    retryFunction: ()=>$f53657e65b61d2bb$export$868bf35b6ef95abe,
    retryTask: ()=>$f53657e65b61d2bb$export$603f016548da7e82,
    run: ()=>(0, $29a41e51920ca8b4$export$889ea624f2cb2c57),
    runOnce: ()=>$f53657e65b61d2bb$export$b841d51e31c12bab,
    runSingle: ()=>(0, $29a41e51920ca8b4$export$8dd5356d9d9c1db8),
    since: ()=>(0, $29a41e51920ca8b4$export$d83cdf5c040d043),
    singleItem: ()=>$f53657e65b61d2bb$export$afd6c403a8d8fc41,
    sleep: ()=>$f53657e65b61d2bb$export$e772c8ff12451969,
    sleepWhile: ()=>$f53657e65b61d2bb$export$f6eba21a4f7b274e,
    throttle: ()=>$f53657e65b61d2bb$export$de363e709c412c8a,
    timeout: ()=>$f53657e65b61d2bb$export$83e74882c5df8fe1,
    timerAlwaysDone: ()=>(0, $29a41e51920ca8b4$export$8beb95963d8287f2),
    timerNeverDone: ()=>(0, $29a41e51920ca8b4$export$99645f88bfcf27c6),
    timerWithFunction: ()=>(0, $29a41e51920ca8b4$export$4dad9723f7b779bd),
    updateOutdated: ()=>$f53657e65b61d2bb$export$427819167c2dbd60,
    waitFor: ()=>$f53657e65b61d2bb$export$9bbfceb27f687c1b
});
// src/flow/BehaviourTree.ts
var $f53657e65b61d2bb$export$e4d652a030487ea7 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($f53657e65b61d2bb$export$e4d652a030487ea7, {
    iterateBreadth: ()=>$f53657e65b61d2bb$var$iterateBreadth,
    iterateDepth: ()=>$f53657e65b61d2bb$var$iterateDepth
});
var $f53657e65b61d2bb$var$getName = (t, defaultValue = ``)=>{
    if (typeof t === `object` && `name` in t && t.name !== void 0) return t.name;
    return defaultValue;
};
function* $f53657e65b61d2bb$var$iterateBreadth(t, pathPrefix) {
    if (typeof pathPrefix === `undefined`) pathPrefix = $f53657e65b61d2bb$var$getName(t);
    for (const [index, n] of $f53657e65b61d2bb$var$entries(t))yield [
        n,
        pathPrefix
    ];
    for (const [index, n] of $f53657e65b61d2bb$var$entries(t)){
        const name = $f53657e65b61d2bb$var$getName(n, `?`);
        const prefix = pathPrefix.length > 0 ? pathPrefix + `.` + name : name;
        yield* $f53657e65b61d2bb$var$iterateBreadth(n, prefix);
    }
}
function* $f53657e65b61d2bb$var$iterateDepth(t, pathPrefix) {
    if (typeof pathPrefix === `undefined`) pathPrefix = $f53657e65b61d2bb$var$getName(t);
    for (const [index, n] of $f53657e65b61d2bb$var$entries(t)){
        yield [
            n,
            pathPrefix
        ];
        const name = $f53657e65b61d2bb$var$getName(n, `?`);
        const prefix = pathPrefix.length > 0 ? pathPrefix + `.` + name : name;
        yield* $f53657e65b61d2bb$var$iterateBreadth(n, prefix);
    }
}
function $f53657e65b61d2bb$var$isSeqNode(n) {
    return n.seq !== void 0;
}
function $f53657e65b61d2bb$var$isSelNode(n) {
    return n.sel !== void 0;
}
function* $f53657e65b61d2bb$var$entries(n) {
    if ($f53657e65b61d2bb$var$isSeqNode(n)) yield* n.seq.entries();
    else if ($f53657e65b61d2bb$var$isSelNode(n)) yield* n.sel.entries();
    else if (typeof n === `string`) ;
    else throw new TypeError(`Unexpected shape of node. seq/sel missing`);
}
// src/flow/Continuously.ts
var $f53657e65b61d2bb$export$5df75b4acf95a98a = (callback, interval2, options = {})=>{
    let intervalMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(interval2, 0);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(intervalMs, `positive`, `interval`);
    const fireBeforeWait = options.fireBeforeWait ?? false;
    const onStartCalled = options.onStartCalled;
    const signal = options.signal;
    let disposed = false;
    let runState = `idle`;
    let startCount = 0;
    let startCountTotal = 0;
    let startedAt = performance.now();
    let intervalUsed = interval2 ?? 0;
    let cancelled = false;
    let currentTimer;
    const deschedule = ()=>{
        if (currentTimer === void 0) return;
        globalThis.clearTimeout(currentTimer);
        currentTimer = void 0;
        startCount = 0;
        startedAt = Number.NaN;
    };
    const schedule = (scheduledCallback)=>{
        if (intervalMs === 0) {
            if (typeof requestAnimationFrame === `undefined`) currentTimer = globalThis.setTimeout(scheduledCallback, 0);
            else {
                currentTimer = void 0;
                requestAnimationFrame(scheduledCallback);
            }
        } else currentTimer = globalThis.setTimeout(scheduledCallback, intervalMs);
    };
    const cancel = ()=>{
        if (cancelled) return;
        cancelled = true;
        if (runState === `idle`) return;
        runState = `idle`;
        deschedule();
    };
    const loop = async ()=>{
        if (signal?.aborted) runState = `idle`;
        if (runState === `idle`) return;
        runState = `running`;
        startCount++;
        startCountTotal++;
        const valueOrPromise = callback(startCount, performance.now() - startedAt);
        const value = typeof valueOrPromise === `object` ? await valueOrPromise : valueOrPromise;
        if (cancelled) return;
        runState = `scheduled`;
        if (value !== void 0 && !value) {
            cancel();
            return;
        }
        if (cancelled) return;
        schedule(loop);
    };
    const start = ()=>{
        if (disposed) throw new Error(`Disposed`);
        cancelled = false;
        if (onStartCalled !== void 0) {
            const doWhat = onStartCalled(startCount, performance.now() - startedAt);
            switch(doWhat){
                case `cancel`:
                    cancel();
                    return;
                case `reset`:
                    reset();
                    return;
                case `dispose`:
                    disposed = true;
                    cancel();
                    return;
            }
        }
        if (runState === `idle`) {
            startCount = 0;
            startedAt = performance.now();
            runState = `scheduled`;
            if (fireBeforeWait) loop();
            else schedule(loop);
        }
    };
    const reset = ()=>{
        if (disposed) throw new Error(`Disposed`);
        cancelled = false;
        startCount = 0;
        startedAt = Number.NaN;
        if (runState !== `idle`) cancel();
        start();
    };
    return {
        start: start,
        reset: reset,
        cancel: cancel,
        get interval () {
            return intervalUsed;
        },
        get runState () {
            return runState;
        },
        get startCountTotal () {
            return startCountTotal;
        },
        get startCount () {
            return startCount;
        },
        set interval (interval3){
            const ms = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(interval3, 0);
            (0, $984cc5641d701af3$export$a4ff393eb12b0888)(ms, `positive`, `interval`);
            intervalMs = ms;
            intervalUsed = interval3;
        },
        get isDisposed () {
            return disposed;
        },
        get elapsedMs () {
            return performance.now() - startedAt;
        }
    };
};
// src/flow/Timeout.ts
var $f53657e65b61d2bb$export$83e74882c5df8fe1 = (callback, interval2)=>{
    if (callback === void 0) throw new Error(`callback parameter is undefined`);
    const intervalMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(interval2);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(intervalMs, `aboveZero`, `interval`);
    let timer;
    let startedAt = 0;
    let startCount = 0;
    let startCountTotal = 0;
    let state = `idle`;
    const clear = ()=>{
        startedAt = 0;
        globalThis.clearTimeout(timer);
        state = `idle`;
    };
    const start = async (altInterval = interval2, args)=>{
        const p = new Promise((resolve2, reject)=>{
            startedAt = performance.now();
            const altTimeoutMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(altInterval);
            const it = (0, $984cc5641d701af3$export$a92c1e031174f8ef)(altTimeoutMs, `aboveZero`, `altTimeoutMs`);
            if (!it[0]) {
                reject(new Error(it[1]));
                return;
            }
            switch(state){
                case `scheduled`:
                    cancel();
                    break;
                case `running`:
                    break;
            }
            state = `scheduled`;
            timer = globalThis.setTimeout(async ()=>{
                if (state !== `scheduled`) {
                    console.warn(`Timeout skipping execution since state is not 'scheduled'`);
                    clear();
                    return;
                }
                const args_ = args ?? [];
                startCount++;
                startCountTotal++;
                state = `running`;
                await callback(performance.now() - startedAt, ...args_);
                state = `idle`;
                clear();
                resolve2();
            }, altTimeoutMs);
        });
        return p;
    };
    const cancel = ()=>{
        if (state === `idle`) return;
        clear();
    };
    return {
        start: // eslint-disable-next-line @typescript-eslint/no-misused-promises
        start,
        cancel: cancel,
        get runState () {
            return state;
        },
        get startCount () {
            return startCount;
        },
        get startCountTotal () {
            return startCountTotal;
        }
    };
};
// src/flow/Debounce.ts
var $f53657e65b61d2bb$export$61fc7d43ac8f84b0 = (callback, interval2)=>{
    const t = $f53657e65b61d2bb$export$83e74882c5df8fe1(callback, interval2);
    return (...args)=>{
        t.start(void 0, args);
    };
};
// src/flow/Sleep.ts
if (typeof window === `undefined` || !(`requestAnimationFrame` in window)) {
    if (typeof window === `undefined`) globalThis.requestAnimationFrame = (callback)=>{
        setTimeout(callback, 1);
    };
}
var $f53657e65b61d2bb$export$e772c8ff12451969 = (optsOrMillis)=>{
    const timeoutMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(optsOrMillis, 1);
    const signal = optsOrMillis.signal;
    const value = optsOrMillis.value;
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(timeoutMs, `positive`, `timeoutMs`);
    if (timeoutMs === 0) return new Promise((resolve2)=>requestAnimationFrame((_)=>{
            resolve2(value);
        }));
    else return new Promise((resolve2, reject)=>{
        const onAbortSignal = ()=>{
            clearTimeout(t);
            if (signal) {
                signal.removeEventListener(`abort`, onAbortSignal);
                reject(new Error(signal.reason));
            } else reject(new Error(`Cancelled`));
        };
        if (signal) signal.addEventListener(`abort`, onAbortSignal);
        const t = setTimeout(()=>{
            signal?.removeEventListener(`abort`, onAbortSignal);
            if (signal?.aborted) {
                reject(new Error(signal.reason));
                return;
            }
            resolve2(value);
        }, timeoutMs);
    });
};
var $f53657e65b61d2bb$export$f6eba21a4f7b274e = async (predicate, checkInterval = 100)=>{
    while(predicate())await $f53657e65b61d2bb$export$e772c8ff12451969(checkInterval);
};
// src/flow/Delay.ts
var $f53657e65b61d2bb$export$1391212d75b2ee65 = async (callback, optsOrMillis)=>{
    const opts = typeof optsOrMillis === `number` ? {
        millis: optsOrMillis
    } : optsOrMillis;
    const delayWhen = opts.delay ?? `before`;
    if (delayWhen === `before` || delayWhen === `both`) await $f53657e65b61d2bb$export$e772c8ff12451969(opts);
    const r = Promise.resolve(await callback());
    if (delayWhen === `after` || delayWhen === `both`) await $f53657e65b61d2bb$export$e772c8ff12451969(opts);
    return r;
};
async function* $f53657e65b61d2bb$var$delayAnimationLoop() {
    let resolve2;
    let p = new Promise((r)=>resolve2 = r);
    let timer = 0;
    const callback = ()=>{
        if (resolve2) resolve2();
        p = new Promise((r)=>resolve2 = r);
    };
    try {
        while(true){
            timer = globalThis.requestAnimationFrame(callback);
            const _ = await p;
            yield _;
        }
    } finally{
        if (resolve2) resolve2();
        globalThis.cancelAnimationFrame(timer);
    }
}
async function* $f53657e65b61d2bb$export$96448421370e6ebc(timeout2) {
    const timeoutMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(timeout2);
    if (typeof timeoutMs === `undefined`) throw new Error(`timeout is undefined`);
    if (timeoutMs < 0) throw new Error(`Timeout is less than zero`);
    if (timeoutMs === 0) return yield* $f53657e65b61d2bb$var$delayAnimationLoop();
    let resolve2;
    let p = new Promise((r)=>resolve2 = r);
    let timer;
    const callback = ()=>{
        if (resolve2) resolve2();
        p = new Promise((r)=>resolve2 = r);
    };
    try {
        while(true){
            timer = globalThis.setTimeout(callback, timeoutMs);
            const _ = await p;
            yield _;
        }
    } finally{
        if (resolve2) resolve2();
        if (timer !== void 0) globalThis.clearTimeout(timer);
        timer = void 0;
    }
}
// src/flow/DispatchList.ts
var $f53657e65b61d2bb$export$5950d7e22009b6fe = class {
    #handlers;
    #counter = 0;
    #id = Math.floor(Math.random() * 100);
    constructor(){
        this.#handlers = [];
    }
    /**
   * Returns _true_ if list is empty
   * @returns 
   */ isEmpty() {
        return this.#handlers.length === 0;
    }
    /**
   * Adds a handler
   * @param handler 
   * @param options 
   * @returns 
   */ add(handler, options = {}) {
        this.#counter++;
        const once2 = options.once ?? false;
        const wrap = {
            id: `${this.#id} - ${this.#counter}`,
            handler: handler,
            once: once2
        };
        this.#handlers.push(wrap);
        return wrap.id;
    }
    remove(id) {
        const length = this.#handlers.length;
        this.#handlers = this.#handlers.filter((handler)=>handler.id !== id);
        return this.#handlers.length !== length;
    }
    notify(value) {
        for (const handler of this.#handlers){
            handler.handler(value);
            if (handler.once) this.remove(handler.id);
        }
    }
    clear() {
        this.#handlers = [];
    }
};
// src/flow/Every.ts
var $f53657e65b61d2bb$export$b730691daab32e4b = (nth, callback)=>{
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(nth, `positive`, `nth`);
    let counter = 0;
    return (data)=>{
        counter++;
        if (counter === nth) {
            counter = 0;
            if (callback) callback(data);
            return true;
        }
        return false;
    };
};
// src/flow/PromiseFromEvent.ts
var $f53657e65b61d2bb$export$a0302146205b73d0 = (target, name)=>{
    return new Promise((resolve2)=>{
        const handler = (...args)=>{
            target.removeEventListener(name, handler);
            if (Array.isArray(args) && args.length === 1) resolve2(args[0]);
            else resolve2(args);
        };
        target.addEventListener(name, handler);
    });
};
// src/flow/PromiseWithResolvers.ts
function $f53657e65b61d2bb$export$283a1614f1b16769() {
    let resolve2;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve2 = _resolve;
        reject = _reject;
    });
    return {
        promise: promise,
        resolve: resolve2,
        reject: reject
    };
}
// src/flow/RateMinimum.ts
var $f53657e65b61d2bb$export$58840f541415b418 = (options)=>{
    let disposed = false;
    const t = $f53657e65b61d2bb$export$83e74882c5df8fe1(()=>{
        if (disposed) return;
        t.start();
        options.whatToCall(options.fallback());
    }, options.interval);
    if (options.abort) options.abort.addEventListener(`abort`, (_)=>{
        disposed = true;
        t.cancel();
    });
    t.start();
    return (args)=>{
        if (disposed) throw new Error(`AbortSignal has been fired`);
        t.start();
        options.whatToCall(args);
    };
};
// src/rx/Util.ts
function $f53657e65b61d2bb$export$3851969427163052(message) {
    if (message.value !== void 0) return false;
    if (`signal` in message && message.signal !== void 0) return true;
    return false;
}
function $f53657e65b61d2bb$export$49fb011922c314de(message) {
    if (message.value !== void 0) return false;
    if (`signal` in message && message.signal === `done`) return true;
    return false;
}
function $f53657e65b61d2bb$export$dd622c303f54f474(v) {
    if (v.value !== void 0) return true;
    return false;
}
var $f53657e65b61d2bb$export$85c51e1e5198ecb8 = (rx)=>{
    if (!$f53657e65b61d2bb$export$352205f445242f02(rx)) return false;
    if (`ping` in rx) return true;
    return false;
};
var $f53657e65b61d2bb$export$792719627301184c = (rx)=>{
    if (!$f53657e65b61d2bb$export$352205f445242f02(rx)) return false;
    if (`last` in rx) {
        const v = rx.last();
        if (v !== void 0) return true;
    }
    return false;
};
var $f53657e65b61d2bb$export$352205f445242f02 = (rx)=>{
    if (typeof rx !== `object`) return false;
    if (rx === null) return false;
    return `on` in rx && `onValue` in rx;
};
var $f53657e65b61d2bb$export$cc2b2f0230460456 = (rx)=>{
    if (!$f53657e65b61d2bb$export$352205f445242f02(rx)) return false;
    if (`set` in rx) return true;
    return false;
};
var $f53657e65b61d2bb$export$ec0fd572751979bc = (v)=>{
    if (typeof v !== `object`) return false;
    if (!(`source` in v)) return false;
    if (!(`annotate` in v)) return false;
    return true;
};
var $f53657e65b61d2bb$export$fd14f74bcdfcca7f = (fn, ...args)=>{
    return (source)=>{
        return fn(source, ...args);
    };
};
var $f53657e65b61d2bb$export$ff8c91f8b60a4fd0 = (t)=>`value` in t;
var $f53657e65b61d2bb$export$5bd8ad528a97e25f = (t)=>`fn` in t;
var $f53657e65b61d2bb$export$95cbacfcc8851121 = (t)=>(0, $3f856c338f7c6dcb$export$9652023d9040757)(t);
var $f53657e65b61d2bb$export$e5ddfc48b47912c = (t)=>{
    if (typeof t !== `object`) return false;
    if ($f53657e65b61d2bb$export$ff8c91f8b60a4fd0(t)) return true;
    if ($f53657e65b61d2bb$export$5bd8ad528a97e25f(t)) return true;
    if ($f53657e65b61d2bb$export$95cbacfcc8851121(t)) return true;
    return false;
};
function $f53657e65b61d2bb$export$17d169adcb1dceb3(t) {
    if ($f53657e65b61d2bb$export$ff8c91f8b60a4fd0(t)) return [
        t.value,
        false
    ];
    if ($f53657e65b61d2bb$export$5bd8ad528a97e25f(t)) {
        const v = t.fn();
        if (v === void 0) return [
            void 0,
            true
        ];
        return [
            v,
            false
        ];
    }
    if ($f53657e65b61d2bb$export$95cbacfcc8851121(t)) {
        const v = t.gen.next();
        if (v.done) return [
            void 0,
            true
        ];
        return [
            v.value,
            false
        ];
    }
    throw new Error(`Invalid trigger. Missing 'value' or 'fn' fields`);
}
// src/data/Resolve.ts
async function $f53657e65b61d2bb$export$f7ad0328861e2f03(r, ...args) {
    if (typeof r === `object`) {
        if (`next` in r) {
            const tag = r[Symbol.toStringTag];
            if (tag === `Generator` || tag == `Array Iterator`) {
                const v = r.next();
                if (`done` in v && `value` in v) return v.value;
                return v;
            } else if (tag === `AsyncGenerator`) {
                const v = await r.next();
                if (`done` in v && `value` in v) return v.value;
                return v;
            } else throw new Error(`Object has 'next' prop, but does not have 'AsyncGenerator', 'Generator' or 'Array Iterator' string tag symbol. Got: '${tag}'`);
        } else if ($f53657e65b61d2bb$export$352205f445242f02(r)) {
            if ($f53657e65b61d2bb$export$792719627301184c(r)) return r.last();
            throw new Error(`Reactive does not have last value`);
        } else return r;
    } else if (typeof r === `function`) {
        const v = await r(args);
        return v;
    } else return r;
}
function $f53657e65b61d2bb$export$90bb0c3a0ef8b4ca(r, ...args) {
    if (typeof r === `object`) {
        if (`next` in r) {
            const tag = r[Symbol.toStringTag];
            if (tag === `Generator` || tag == `Array Iterator`) {
                const v = r.next();
                if (`done` in v && `value` in v) return v.value;
                return v;
            } else if (tag === `AsyncGenerator`) throw new Error(`resolveSync cannot work with an async generator`);
            else throw new Error(`Object has 'next' prop, but does not have 'Generator' or 'Array Iterator' string tag symbol. Got: '${tag}'`);
        } else if ($f53657e65b61d2bb$export$352205f445242f02(r)) {
            if ($f53657e65b61d2bb$export$792719627301184c(r)) return r.last();
            throw new Error(`Reactive does not have last value`);
        } else return r;
    } else if (typeof r === `function`) return r(args);
    else return r;
}
async function $f53657e65b61d2bb$export$3773b921d3598ab9(p, fallback, ...args) {
    let errored = false;
    let fallbackValue = fallback.value;
    const overrideWithLast = fallback.overrideWithLast ?? false;
    if (fallbackValue === void 0) throw new Error(`Needs a fallback value`);
    try {
        const r = await $f53657e65b61d2bb$export$f7ad0328861e2f03(p, ...args);
        if (typeof r === `undefined`) return fallbackValue;
        if (typeof r === `number` && Number.isNaN(r)) return fallbackValue;
        if (overrideWithLast) fallbackValue = r;
        return r;
    } catch (error) {
        if (!errored) {
            errored = true;
            console.warn(`resolveWithFallback swallowed an error. Additional errors not reported.`, (0, $96302e292290d7c3$export$82f46aa4e6535a45)(error));
        }
        return fallbackValue;
    }
}
function $f53657e65b61d2bb$export$bf737119f3ba2592(p, fallback, ...args) {
    let errored = false;
    let fallbackValue = fallback.value;
    const overrideWithLast = fallback.overrideWithLast ?? false;
    if (fallbackValue === void 0) throw new Error(`Needs a fallback value`);
    try {
        const r = $f53657e65b61d2bb$export$90bb0c3a0ef8b4ca(p, ...args);
        if (typeof r === `undefined`) return fallbackValue;
        if (typeof r === `number` && Number.isNaN(r)) return fallbackValue;
        if (overrideWithLast) fallbackValue = r;
        return r;
    } catch (error) {
        if (!errored) {
            errored = true;
            console.warn(`resolveWithFallbackSync swallowed an error. Additional errors not reported.`, (0, $96302e292290d7c3$export$82f46aa4e6535a45)(error));
        }
        return fallbackValue;
    }
}
// src/flow/Repeat.ts
async function* $f53657e65b61d2bb$export$76d90c956114f2c2(produce, opts) {
    const signal = opts.signal ?? void 0;
    const delayWhen = opts.delayWhen ?? `before`;
    const count = opts.count ?? void 0;
    const allowUndefined = opts.allowUndefined ?? false;
    const minIntervalMs = opts.delayMinimum ? (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(opts.delayMinimum) : void 0;
    const whileFunc = opts.while;
    let cancelled = false;
    let sleepMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(opts.delay, (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(opts.delayMinimum, 0));
    let started = performance.now();
    const doDelay = async ()=>{
        const elapsed = performance.now() - started;
        if (typeof minIntervalMs !== `undefined`) sleepMs = Math.max(0, minIntervalMs - elapsed);
        if (sleepMs) await $f53657e65b61d2bb$export$e772c8ff12451969({
            millis: sleepMs,
            signal: signal
        });
        started = performance.now();
        if (signal?.aborted) throw new Error(`Signal aborted ${signal.reason}`);
    };
    if (Array.isArray(produce)) produce = produce.values();
    if (opts.onStart) opts.onStart();
    let errored = true;
    let loopedTimes = 0;
    try {
        while(!cancelled){
            loopedTimes++;
            if (delayWhen === `before` || delayWhen === `both`) await doDelay();
            const result = await $f53657e65b61d2bb$export$f7ad0328861e2f03(produce);
            if (typeof result === `undefined` && !allowUndefined) cancelled = true;
            else {
                yield result;
                if (delayWhen === `after` || delayWhen === `both`) await doDelay();
                if (count !== void 0 && loopedTimes >= count) cancelled = true;
            }
            if (whileFunc) {
                if (!whileFunc(loopedTimes)) cancelled = true;
            }
        }
        errored = false;
    } finally{
        cancelled = true;
        if (opts.onComplete) opts.onComplete(errored);
    }
}
function* $f53657e65b61d2bb$export$788e1482613c4b84(produce, opts) {
    const signal = opts.signal ?? void 0;
    const count = opts.count ?? void 0;
    const allowUndefined = opts.allowUndefined ?? false;
    let cancelled = false;
    if (Array.isArray(produce)) produce = produce.values();
    if (opts.onStart) opts.onStart();
    let errored = true;
    let loopedTimes = 0;
    try {
        while(!cancelled){
            loopedTimes++;
            const result = $f53657e65b61d2bb$export$90bb0c3a0ef8b4ca(produce);
            if (typeof result === `undefined` && !allowUndefined) cancelled = true;
            else {
                yield result;
                if (count !== void 0 && loopedTimes >= count) cancelled = true;
                if (signal?.aborted) cancelled = true;
            }
        }
        errored = false;
    } finally{
        cancelled = true;
        if (opts.onComplete) opts.onComplete(errored);
    }
}
// src/flow/RequestResponseMatch.ts
var $f53657e65b61d2bb$export$30e40236490859fe = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    #outgoing = /* @__PURE__ */ new Map();
    #maintainLoop;
    constructor(options = {}){
        super();
        if (typeof window === `undefined`) globalThis.window = {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
        this.timeoutMs = options.timeoutMs ?? 1e3;
        this.whenUnmatchedResponse = options.whenUnmatchedResponse ?? `throw`;
        this.#maintainLoop = $f53657e65b61d2bb$export$5df75b4acf95a98a(()=>this.#maintain(), this.timeoutMs * 2);
        if (options.key) {
            if (options.keyRequest) throw new Error(`Cannot set 'keyRequest' when 'key' is set `);
            if (options.keyResponse) throw new Error(`Cannot set 'keyResponse' when 'key' is set `);
            this.keyRequest = options.key;
            this.keyResponse = options.key;
        } else {
            if (!options.keyRequest || !options.keyResponse) throw new Error(`Expects 'keyRequest' & 'keyResponse' fields to be set if 'key' is not set`);
            this.keyRequest = options.keyRequest;
            this.keyResponse = options.keyResponse;
        }
    }
    #maintain() {
        const values = [
            ...this.#outgoing.values()
        ];
        const now = Date.now();
        for (const v of values)if (v.expiresAt <= now) {
            if (v.promiseReject) v.promiseReject(`Request timeout`);
            const callback = v.callback;
            if (callback) setTimeout(()=>{
                callback(true, `Request timeout`);
            }, 1);
            this.fireEvent(`completed`, {
                request: v.req,
                response: `Request timeout`,
                success: false
            });
            this.#outgoing.delete(v.id);
        }
        this.debugDump();
        return this.#outgoing.size > 0;
    }
    debugDump() {
        const values = [
            ...this.#outgoing.values()
        ];
        const now = Date.now();
        for (const v of values){
            const expire = now - v.expiresAt;
            console.log(`${v.id} Expires in: ${Math.floor(expire / 1e3)}s`);
        }
    }
    /**
   * Makes a request.
   * If `callback` is set, it's equivalent to calling `requestCallback`.
   * If `callback` is not set, a promise is returned
   * @param request 
   * @param callback 
   * @returns 
   */ // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    request(request, callback) {
        if (callback !== void 0) {
            this.#requestCallback(request, callback);
            return;
        }
        return this.#requestAwait(request);
    }
    /**
   * Make a request and don't wait for the outcome.
   * @param request 
   */ requestAndForget(request) {
        const id = this.keyRequest(request);
        if (this.#outgoing.has(id)) throw new Error(`Already a request pending with id '${id}'`);
        const r = {
            expiresAt: Date.now() + this.timeoutMs,
            id: id,
            req: request
        };
        this.#outgoing.set(id, r);
        this.#maintainLoop.start();
    }
    /**
   * Make a request, returning a Promise for the outcome.
   * Errors will throw an exception.
   * @param request 
   * @returns 
   */ #requestAwait(request) {
        const id = this.keyRequest(request);
        if (this.#outgoing.has(id)) throw new Error(`Already a request pending with id '${id}'`);
        const p = new Promise((resolve2, reject)=>{
            const r = {
                expiresAt: Date.now() + this.timeoutMs,
                id: id,
                req: request,
                promiseResolve: resolve2,
                promiseReject: reject
            };
            this.#outgoing.set(id, r);
            this.#maintainLoop.start();
        });
        return p;
    }
    /**
   * Make a request, and get notified of outcome with a callback
   * @param request 
   * @param callback 
   */ #requestCallback(request, callback) {
        const id = this.keyRequest(request);
        if (this.#outgoing.has(id)) throw new Error(`Already a request pending with id '${id}'`);
        const r = {
            expiresAt: Date.now() + this.timeoutMs,
            id: id,
            req: request,
            callback: callback
        };
        this.#outgoing.set(id, r);
        this.#maintainLoop.start();
    }
    /**
   * Response has been received
   * @param response Response
   * @returns _True_ if response matched a request 
   */ response(response, keepAlive) {
        const id = this.keyResponse(response);
        const request = this.#outgoing.get(id);
        if (!request) {
            if (this.whenUnmatchedResponse === `throw`) throw new Error(`Unmatched response with id: '${id}'`, {
                cause: response
            });
            return false;
        }
        if (keepAlive) request.expiresAt = Date.now() + this.timeoutMs;
        else this.#outgoing.delete(id);
        if (request.promiseResolve) request.promiseResolve(response);
        if (request.callback) request.callback(false, response);
        this.fireEvent(`match`, {
            request: request.req,
            response: response
        });
        if (!keepAlive) this.fireEvent(`completed`, {
            request: request.req,
            response: response,
            success: true
        });
        return true;
    }
};
// src/flow/Retry.ts
function* $f53657e65b61d2bb$export$288aa5a292a95a4b(options = {}) {
    const startAt = options.startAt ?? 1;
    let limitAttempts = options.limitAttempts ?? Number.MAX_SAFE_INTEGER;
    const limitValue = options.limitValue;
    const power = options.power ?? 1.1;
    let value = startAt;
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(limitAttempts, `aboveZero`, `limitAttempts`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(startAt, ``, `startAt`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(limitAttempts, ``, `limitAttempts`);
    if (limitValue !== void 0) (0, $984cc5641d701af3$export$d60fcb8dda779864)(limitValue, ``, `limitValue`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(power, ``, `power`);
    while(limitAttempts > 0){
        if (limitValue && value >= limitValue) return;
        limitAttempts--;
        yield value;
        value += Math.pow(value, power);
    }
}
var $f53657e65b61d2bb$export$868bf35b6ef95abe = (callback, options = {})=>{
    const task = {
        async probe () {
            try {
                const v = await callback();
                if (v === void 0) return {
                    value: options.taskValueFallback,
                    error: `Fallback`,
                    success: false
                };
                return {
                    value: v,
                    success: true
                };
            } catch (error) {
                return {
                    success: false,
                    error: error
                };
            }
        }
    };
    return $f53657e65b61d2bb$export$603f016548da7e82(task, options);
};
var $f53657e65b61d2bb$export$603f016548da7e82 = async (task, opts = {})=>{
    const signal = opts.abort;
    const log = (0, $c40eb93fec8b01a3$export$9b88029edfd31073)(opts.log);
    const predelayMs = opts.predelayMs ?? 0;
    const startedAt = (0, $29a41e51920ca8b4$export$d83cdf5c040d043)();
    let attempts = 0;
    const initialValue = opts.startAt ?? 1e3;
    const limitAttempts = opts.limitAttempts ?? Number.MAX_SAFE_INTEGER;
    const backoffGen = $f53657e65b61d2bb$export$288aa5a292a95a4b({
        ...opts,
        startAt: initialValue,
        limitAttempts: limitAttempts
    });
    if (initialValue <= 0) throw new Error(`Param 'initialValue' must be above zero`);
    if (predelayMs > 0) try {
        await $f53657e65b61d2bb$export$e772c8ff12451969({
            millis: predelayMs,
            signal: signal
        });
    } catch (error) {
        return {
            success: false,
            attempts: attempts,
            value: opts.taskValueFallback,
            elapsed: startedAt(),
            message: (0, $96302e292290d7c3$export$82f46aa4e6535a45)(error)
        };
    }
    for (const t of backoffGen){
        attempts++;
        const result = await task.probe(attempts);
        if (result.success) return {
            success: result.success,
            value: result.value,
            attempts: attempts,
            elapsed: startedAt()
        };
        log({
            msg: `retry attempts: ${attempts} t: ${(0, $96f72d8c52c10ae7$export$8822669ae797429a)(t)}`
        });
        if (attempts >= limitAttempts) break;
        try {
            await $f53657e65b61d2bb$export$e772c8ff12451969({
                millis: t,
                signal: signal
            });
        } catch (error) {
            return {
                success: false,
                attempts: attempts,
                value: opts.taskValueFallback,
                message: (0, $96302e292290d7c3$export$82f46aa4e6535a45)(error),
                elapsed: startedAt()
            };
        }
    }
    return {
        message: `Giving up after ${attempts} attempts.`,
        success: false,
        attempts: attempts,
        value: opts.taskValueFallback,
        elapsed: startedAt()
    };
};
// src/flow/RunOnce.ts
var $f53657e65b61d2bb$export$b841d51e31c12bab = (onRun)=>{
    let run2 = false;
    let success = false;
    return ()=>{
        if (run2) return success;
        run2 = true;
        success = onRun();
        return success;
    };
};
// src/flow/SyncWait.ts
var $f53657e65b61d2bb$export$2449344532dcb5ce = class {
    #resolve;
    #reject;
    #promise;
    signal() {
        if (this.#resolve) {
            this.#resolve();
            this.#resolve = void 0;
        }
        this.#promise = Promise.resolve();
    }
    /**
   * Throw away any previous signalled state.
   * This will cause any currently waiters to throw
   */ flush() {
        if (this.#reject) {
            this.#reject(`Flushed`);
            this.#reject = void 0;
        }
        this.#resolve = void 0;
        this.#promise = void 0;
    }
    #initPromise() {
        const p = new Promise((resolve2, reject)=>{
            this.#resolve = resolve2;
            this.#reject = reject;
        });
        this.#promise = p;
        return p;
    }
    /**
   * Call with `await` to wait until .signal() happens.
   * If a wait period is specified, an exception is thrown if signal does not happen within this time.
   * @param maximumWaitMs 
   */ async forSignal(maximumWaitMs) {
        let p = this.#promise;
        if (!p) p = this.#initPromise();
        if (maximumWaitMs) {
            const reject = this.#reject;
            setTimeout(()=>{
                if (reject) reject(`Timeout elapsed ${maximumWaitMs}`);
            }, maximumWaitMs);
        }
        await p;
        this.#promise = void 0;
        this.#resolve = void 0;
        this.#reject = void 0;
    }
    /**
   * An alternative to {@link forSignal}, returning _true_
   * if signalled, or _false_ if wait period was exceeded 
   * 
   * ```js
   * const s = await sw.didSignal(5000);
   * ```
   * @param maximumWaitMs 
   * @returns 
   */ async didSignal(maximumWaitMs) {
        try {
            await this.forSignal(maximumWaitMs);
            return true;
        } catch  {
            return false;
        }
    }
};
// src/flow/TaskQueueMutable.ts
var $f53657e65b61d2bb$export$569994ba22a41a43 = class _TaskQueueMutable extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    static #_ = this.shared = new _TaskQueueMutable();
    constructor(){
        super();
        this._queue = (0, $3f856c338f7c6dcb$export$9cc7a411a0b9bd72)();
        this._loop = $f53657e65b61d2bb$export$5df75b4acf95a98a(()=>{
            return this.processQueue();
        }, 100);
    }
    /**
   * Adds a task. This triggers processing loop if not already started.
   *
   * ```js
   * queue.add(async () => {
   *  await sleep(1000);
   * });
   * ```
   * @param task Task to run
   */ enqueue(task) {
        const length = this._queue.enqueue(task);
        if (this._loop.runState === `idle`) {
            this.fireEvent(`started`, {});
            this._loop.start();
        }
        return length;
    }
    dequeue() {
        return this._queue.dequeue();
    }
    async processQueue() {
        const task = this._queue.dequeue();
        if (task === void 0) {
            this.fireEvent(`empty`, {});
            return false;
        }
        try {
            await task();
        } catch (error) {
            console.error(error);
        }
    }
    /**
   * Clears all tasks, and stops any scheduled processing.
   * Currently running tasks will continue.
   * @returns 
   */ clear() {
        if (this._queue.length === 0) return;
        this._queue.clear();
        this._loop.cancel();
        this.fireEvent(`empty`, {});
    }
    /**
  * Returns true if queue is empty
  */ get isEmpty() {
        return this._queue.isEmpty;
    }
    /**
   * Number of items in queue
   */ get length() {
        return this._queue.length;
    }
};
// src/flow/Throttle.ts
var $f53657e65b61d2bb$export$de363e709c412c8a = (callback, intervalMinMs)=>{
    let trigger = 0;
    return async (...args)=>{
        const elapsed = performance.now() - trigger;
        if (elapsed >= intervalMinMs) {
            const r = callback(elapsed, ...args);
            if (typeof r === `object`) await r;
            trigger = performance.now();
        }
    };
};
// src/flow/UpdateOutdated.ts
var $f53657e65b61d2bb$export$427819167c2dbd60 = (fn, interval2, updateFail = `slow`)=>{
    let lastRun = 0;
    let lastValue;
    let intervalMsCurrent = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(interval2, 1e3);
    return ()=>// eslint-disable-next-line @typescript-eslint/no-misused-promises
        new Promise(async (resolve2, reject)=>{
            const elapsed = performance.now() - lastRun;
            if (lastValue === void 0 || elapsed > intervalMsCurrent) try {
                lastRun = performance.now();
                lastValue = await fn(elapsed);
                intervalMsCurrent = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(interval2, 1e3);
            } catch (error) {
                if (updateFail === `fast`) {
                    lastValue = void 0;
                    lastRun = 0;
                } else if (updateFail === `backoff`) intervalMsCurrent = Math.floor(intervalMsCurrent * 1.2);
                reject(error);
                return;
            }
            resolve2(lastValue);
        });
};
// src/flow/WaitFor.ts
var $f53657e65b61d2bb$export$9bbfceb27f687c1b = (timeoutMs, onAborted, onComplete)=>{
    let t;
    let success = false;
    const done = (error)=>{
        if (t !== void 0) {
            window.clearTimeout(t);
            t = void 0;
        }
        if (error) onAborted(error);
        else success = true;
        if (onComplete !== void 0) onComplete(success);
    };
    t = globalThis.setTimeout(()=>{
        t = void 0;
        try {
            onAborted(`Timeout after ${timeoutMs}ms`);
        } finally{
            if (onComplete !== void 0) onComplete(success);
        }
    }, timeoutMs);
    return done;
};
// src/flow/WaitForValue.ts
var $f53657e65b61d2bb$export$d33bfafa358ccd8a = class {
    #promise;
    #resolve;
    #written = false;
    constructor(){
        const { promise: promise, resolve: resolve2 } = $f53657e65b61d2bb$export$283a1614f1b16769();
        this.#promise = promise;
        this.#resolve = resolve2;
    }
    get() {
        return this.#promise;
    }
    add(value) {
        if (this.#written) throw new Error(`QueueSingleUse has already been used`);
        this.#written = true;
        this.#resolve(value);
    }
    /**
   * Returns _true_ if a value has been added
   * and therefore no more values can be written
   */ get isUsed() {
        return this.#written;
    }
};
var $f53657e65b61d2bb$export$afd6c403a8d8fc41 = ()=>new $f53657e65b61d2bb$export$d33bfafa358ccd8a();








// src/dom/ResolveEl.ts
var $35a128b42d0e06cd$export$5c3b1267168ecce4 = (domQueryOrEl)=>{
    const r = $35a128b42d0e06cd$export$832ddfb93b3cb5a2(domQueryOrEl);
    if (r.success) return r.value;
    throw (0, $e8ad1dce15e1a2c0$export$e7f2125cfeb7086c)(r);
};
var $35a128b42d0e06cd$export$832ddfb93b3cb5a2 = (domQueryOrEl)=>{
    if (typeof domQueryOrEl === `string`) {
        const d = document.querySelector(domQueryOrEl);
        if (d === null) {
            const error = domQueryOrEl.startsWith(`#`) ? `Query '${domQueryOrEl}' did not match anything. Try '#id', 'div', or '.class'` : `Query '${domQueryOrEl}' did not match anything. Did you mean '#${domQueryOrEl}?`;
            return {
                success: false,
                error: error
            };
        }
        domQueryOrEl = d;
    } else if (domQueryOrEl === null) return {
        success: false,
        error: `Param 'domQueryOrEl' is null`
    };
    else if (domQueryOrEl === void 0) return {
        success: false,
        error: `Param 'domQueryOrEl' is undefined`
    };
    const el = domQueryOrEl;
    return {
        success: true,
        value: el
    };
};
var $35a128b42d0e06cd$export$7c36a5fc73d4a4d3 = (selectors)=>{
    if (selectors === void 0) return [];
    if (selectors === null) return [];
    if (Array.isArray(selectors)) return selectors;
    if (typeof selectors === `string`) {
        const elements = [
            ...document.querySelectorAll(selectors)
        ];
        return elements;
    }
    return [
        selectors
    ];
};






// src/data/maps/MapFns.ts
var $3ffa4b3bf3c5db47$export$b9b5c2c805112ed2 = (data, target)=>{
    target = Math.round(target);
    if (data.has(target)) return target;
    else {
        let offset = 1;
        while(offset < 1e3){
            if (data.has(target - offset)) return target - offset;
            else if (data.has(target + offset)) return target + offset;
            offset++;
        }
        throw new Error(`Could not find target ${target}`);
    }
};
var $3ffa4b3bf3c5db47$export$d9154ce654446643 = (data, keys)=>{
    for (const key of keys){
        if (data.has(key)) return data.get(key);
    }
};
var $3ffa4b3bf3c5db47$export$4883817542665016 = (map, key, value, comparer)=>{
    if (!map.has(key)) return false;
    const values = [
        ...map.values()
    ];
    return values.some((v)=>comparer(v, value));
};
var $3ffa4b3bf3c5db47$export$78990a8040ea3609 = (map, value, comparer = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    for (const entry of Object.entries(map))if (comparer(entry[1], value)) map.delete(entry[0]);
};
var $3ffa4b3bf3c5db47$export$43f098bb06003dcd = (map, predicate)=>{
    for (const entry of map.entries()){
        if (predicate(entry[1], entry[0])) return entry;
    }
};
var $3ffa4b3bf3c5db47$export$bfe2e9bd3ffe559f = (map, value, isEqual = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    for (const entry of map.entries()){
        if (isEqual(entry[1], value)) return entry;
    }
};
var $3ffa4b3bf3c5db47$export$702daf3d1fbfead1 = (set, hasher, ...values)=>{
    const s = set === void 0 ? /* @__PURE__ */ new Map() : new Map(set);
    for (const v of values){
        const hashResult = hasher(v);
        if (s.has(hashResult)) continue;
        s.set(hashResult, v);
    }
    return s;
};
var $3ffa4b3bf3c5db47$export$6391cb5d0ad73621 = (map, comparer)=>{
    const f = comparer ?? (0, $9364ac8ced0e518d$export$2c7d71451559ec2);
    return [
        ...map.entries()
    ].sort((a, b)=>f(a[1], b[1]));
};
var $3ffa4b3bf3c5db47$export$96a66db6d6b0113 = (map, property, compareFunction)=>{
    const cfn = typeof compareFunction === `undefined` ? (0, $9364ac8ced0e518d$export$2c7d71451559ec2) : compareFunction;
    return [
        ...map.entries()
    ].sort((aE, bE)=>{
        const a = aE[1];
        const b = bE[1];
        return cfn(a[property], b[property]);
    });
};
var $3ffa4b3bf3c5db47$export$d12a2b6ab14817dd = (map, value, comparer)=>{
    const entries = [
        ...map.entries()
    ];
    return entries.some((kv)=>comparer(kv[1], value));
};
function* $3ffa4b3bf3c5db47$export$3dea766d36a8935f(map, predicate) {
    for (const v of map.values())if (predicate(v)) yield v;
}
var $3ffa4b3bf3c5db47$export$45b10814cc054894 = (map)=>[
        ...map.values()
    ];
var $3ffa4b3bf3c5db47$export$dcccc29c315dd646 = (data, keyFunction = (0, $847987b26b102cb8$export$f5a6f2033c1996c8), allowOverwrites = false)=>{
    const m = /* @__PURE__ */ new Map();
    for (const d of data){
        const id = keyFunction(d);
        if (m.has(id) && !allowOverwrites) throw new Error(`id ${id} is already used and new data will overwrite it. `);
        m.set(id, d);
    }
    return m;
};
var $3ffa4b3bf3c5db47$export$9144c32b59cbaec4 = (data)=>{
    const map = /* @__PURE__ */ new Map();
    if (Array.isArray(data)) for (const d of data)$3ffa4b3bf3c5db47$export$3526b99afee61ae2(map, d);
    else $3ffa4b3bf3c5db47$export$3526b99afee61ae2(map, data);
    return map;
};
var $3ffa4b3bf3c5db47$export$3526b99afee61ae2 = (map, data)=>{
    const entries = Object.entries(data);
    for (const [key, value] of entries)map.set(key, value);
};
var $3ffa4b3bf3c5db47$export$71aa6c912b956294 = (map, predicate)=>[
        ...map.values()
    ].find((v)=>predicate(v));
var $3ffa4b3bf3c5db47$export$ad14ef4001db2bcd = (map, predicate)=>[
        ...map.values()
    ].some((v)=>predicate(v));
var $3ffa4b3bf3c5db47$export$29ddc7b84ebfc668 = (m, valueTransform)=>// eslint-disable-next-line @typescript-eslint/no-unsafe-return, unicorn/no-array-reduce
    [
        ...m
    ].reduce((object, [key, value])=>{
        const t = valueTransform(value);
        object[key] = t;
        return object;
    }, {});
var $3ffa4b3bf3c5db47$export$c2d6f401933fc426 = (keys, values)=>{
    if (keys.length !== values.length) throw new Error(`Keys and values arrays should be same length`);
    return Object.fromEntries(keys.map((k, index)=>[
            k,
            values[index]
        ]));
};
var $3ffa4b3bf3c5db47$export$5f7754d40b4c8f37 = (source, transformer)=>new Map(Array.from(source, (v)=>[
            v[0],
            transformer(v[1], v[0])
        ]));
var $3ffa4b3bf3c5db47$export$697e4a1b90752ce2 = (m)=>// eslint-disable-next-line @typescript-eslint/no-unsafe-return
    [
        ...m
    ].reduce((object, [key, value])=>{
        object[key] = value;
        return object;
    }, {});
var $3ffa4b3bf3c5db47$export$c24a744d5dd88a3b = (m, transformer)=>[
        ...m.entries()
    ].map((x)=>transformer(x[0], x[1]));
var $3ffa4b3bf3c5db47$export$5848149affbf5a72 = (reconcile, ...maps)=>{
    const result = /* @__PURE__ */ new Map();
    for (const m of maps)for (const [mk, mv] of m){
        let v = result.get(mk);
        v = v ? reconcile(v, mv) : mv;
        result.set(mk, v);
    }
    return result;
};








// src/data/arrays/index.ts
var $b63753f448317b08$export$da86460d40002d1f = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($b63753f448317b08$export$da86460d40002d1f, {
    Sorted: ()=>$b63753f448317b08$export$fb3a4475396e3f7,
    atWrap: ()=>$b63753f448317b08$export$dee66a597156a4c8,
    chunks: ()=>$b63753f448317b08$export$99f96ea7ddfd7ba9,
    contains: ()=>$b63753f448317b08$export$2344b14b097df817,
    containsDuplicateInstances: ()=>(0, $0d2c4a84d3bf26b3$export$5ec1bebad0fa749),
    containsDuplicateValues: ()=>$b63753f448317b08$export$80954d29581e5e18,
    cycle: ()=>$b63753f448317b08$export$c04a9f24a4230e1f,
    ensureLength: ()=>$b63753f448317b08$export$18c10fc16f815ad5,
    filterAB: ()=>(0, $9364ac8ced0e518d$export$fb695f9b55880929),
    filterBetween: ()=>(0, $9364ac8ced0e518d$export$b0c2b5b4231e629a),
    flatten: ()=>$b63753f448317b08$export$bffa455ba8c619a6,
    groupBy: ()=>$b63753f448317b08$export$3f063810d7bf01bd,
    guardArray: ()=>(0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403),
    guardIndex: ()=>(0, $9364ac8ced0e518d$export$cca6281cc24253c),
    insertAt: ()=>$b63753f448317b08$export$9f200c4466975173,
    interleave: ()=>$b63753f448317b08$export$306776142e961518,
    intersection: ()=>$b63753f448317b08$export$bc86dfbf7795668c,
    isContentsTheSame: ()=>$b63753f448317b08$export$751560eb3cce2427,
    isEqual: ()=>$b63753f448317b08$export$248d38f6296296c5,
    mergeByKey: ()=>$b63753f448317b08$export$5848149affbf5a72,
    minMaxAvg: ()=>(0, $9364ac8ced0e518d$export$24ad9025a0be0d69),
    pairwise: ()=>(0, $86813b6110828816$export$8f9d79d42bff1aac),
    pairwiseReduce: ()=>(0, $86813b6110828816$export$cf06ea7d47c75571),
    randomElement: ()=>(0, $7b02fea154055fc0$export$d3d80cee07107776),
    randomElementWeightedSource: ()=>(0, $7b02fea154055fc0$export$321c827d616b50b4),
    randomIndex: ()=>(0, $7b02fea154055fc0$export$23b1f9ce5361528e),
    randomPluck: ()=>(0, $7b02fea154055fc0$export$cf248d6d1eb3d7bb),
    remove: ()=>$b63753f448317b08$export$cd7f480d6b8286c3,
    sample: ()=>$b63753f448317b08$export$4812e460280c6ef2,
    shuffle: ()=>(0, $7b02fea154055fc0$export$448332262467e042),
    sortByNumericProperty: ()=>$b63753f448317b08$export$def566e6b50bc276,
    sortByProperty: ()=>$b63753f448317b08$export$3bf4e72ed1d44710,
    unique: ()=>(0, $7b02fea154055fc0$export$7a5d5c156e7dc406),
    until: ()=>$b63753f448317b08$export$a40009bd2c363351,
    without: ()=>(0, $9364ac8ced0e518d$export$5d14bf425b37f49e),
    withoutUndefined: ()=>(0, $9364ac8ced0e518d$export$1ef67baf50ada97),
    zip: ()=>$b63753f448317b08$export$8901015135f2fb22
});
// src/data/arrays/ArrayCycle.ts
var $b63753f448317b08$export$c04a9f24a4230e1f = (options)=>{
    const opts = [
        ...options
    ];
    let index = 0;
    const next = ()=>{
        index++;
        if (index === opts.length) index = 0;
        return value();
    };
    const prev = ()=>{
        index--;
        if (index === -1) index = opts.length - 1;
        return value();
    };
    const value = ()=>{
        return opts.at(index);
    };
    const select = (indexOrValue)=>{
        if (typeof indexOrValue === `number`) index = indexOrValue;
        else {
            const found = opts.indexOf(indexOrValue);
            if (found === -1) throw new Error(`Could not find value`);
            index = found;
        }
    };
    const toArray = ()=>[
            ...opts
        ];
    return {
        toArray: toArray,
        next: next,
        prev: prev,
        get current () {
            return value();
        },
        select: select
    };
};
// src/data/arrays/AtWrap.ts
var $b63753f448317b08$export$dee66a597156a4c8 = (array, index)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(index, ``, `index`);
    if (!Array.isArray(array)) throw new Error(`Param 'array' is not an array`);
    index = index % array.length;
    return array.at(index);
};
// src/data/arrays/Chunks.ts
function $b63753f448317b08$export$99f96ea7ddfd7ba9(array, size) {
    const output = [];
    for(let index = 0; index < array.length; index += size)output.push(array.slice(index, index + size));
    return output;
}
// src/data/arrays/Contains.ts
var $b63753f448317b08$export$2344b14b097df817 = (haystack, needles, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    if (!Array.isArray(haystack)) throw new TypeError(`Expects haystack parameter to be an array`);
    if (!Array.isArray(needles)) throw new TypeError(`Expects needles parameter to be an array`);
    for (const needle of needles){
        let found = false;
        for (const element of haystack)if (eq(needle, element)) {
            found = true;
            break;
        }
        if (!found) return false;
    }
    return true;
};
var $b63753f448317b08$export$80954d29581e5e18 = (array, keyFunction = (0, $847987b26b102cb8$export$f5a6f2033c1996c8))=>{
    if (!Array.isArray(array)) throw new Error(`Parameter needs to be an array`);
    try {
        const _ = (0, $3ffa4b3bf3c5db47$export$dcccc29c315dd646)(array, keyFunction);
    } catch  {
        return true;
    }
    return false;
};
// src/data/arrays/EnsureLength.ts
var $b63753f448317b08$export$18c10fc16f815ad5 = (data, length, expand = `undefined`)=>{
    if (data === void 0) throw new Error(`Data undefined`);
    if (!Array.isArray(data)) throw new Error(`data is not an array`);
    if (data.length === length) return [
        ...data
    ];
    if (data.length > length) return data.slice(0, length);
    const d = [
        ...data
    ];
    const add = length - d.length;
    for(let index = 0; index < add; index++)switch(expand){
        case `undefined`:
            d.push(void 0);
            break;
        case `repeat`:
            d.push(data[index % data.length]);
            break;
        case `first`:
            d.push(data[0]);
            break;
        case `last`:
            d.push(data.at(-1));
            break;
    }
    return d;
};
// src/data/arrays/Equality.ts
var $b63753f448317b08$export$248d38f6296296c5 = (arrayA, arrayB, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(arrayA, `arrayA`);
    (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(arrayB, `arrayB`);
    if (arrayA.length !== arrayB.length) return false;
    for(let indexA = 0; indexA < arrayA.length; indexA++){
        if (!eq(arrayA[indexA], arrayB[indexA])) return false;
    }
    return true;
};
var $b63753f448317b08$export$751560eb3cce2427 = (array, equality)=>{
    if (!Array.isArray(array)) throw new Error(`Param 'array' is not an array.`);
    if (array.length === 0) return true;
    const eq = equality ?? (0, $847987b26b102cb8$export$a8a61f8380f29e3a);
    const a = array[0];
    const r = array.some((v)=>!eq(a, v));
    if (r) return false;
    return true;
};
// src/data/arrays/Flatten.ts
var $b63753f448317b08$export$bffa455ba8c619a6 = (array)=>[
        ...array
    ].flat();
// src/data/arrays/GroupBy.ts
var $b63753f448317b08$export$3f063810d7bf01bd = (array, grouper)=>{
    const map = /* @__PURE__ */ new Map();
    for (const a of array){
        const key = grouper(a);
        let existing = map.get(key);
        if (!existing) {
            existing = [];
            map.set(key, existing);
        }
        existing.push(a);
    }
    return map;
};
// src/data/arrays/InsertAt.ts
var $b63753f448317b08$export$9f200c4466975173 = (data, index, ...values)=>{
    if (!Array.isArray(data)) throw new TypeError(`Param 'data' is not an arry`);
    return [
        ...data.slice(0, index),
        ...values,
        ...data.slice(index + 1)
    ];
};
// src/data/arrays/Interleave.ts
var $b63753f448317b08$export$306776142e961518 = (...arrays)=>{
    if (arrays.some((a)=>!Array.isArray(a))) throw new Error(`All parameters must be an array`);
    const lengths = arrays.map((a)=>a.length);
    if (!$b63753f448317b08$export$751560eb3cce2427(lengths)) throw new Error(`Arrays must be of same length`);
    const returnValue = [];
    const length = lengths[0];
    for(let index = 0; index < length; index++)for (const array of arrays)returnValue.push(array[index]);
    return returnValue;
};
// src/data/arrays/Intersection.ts
var $b63753f448317b08$export$bc86dfbf7795668c = (arrayA, arrayB, equality = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>arrayA.filter((valueFromA)=>arrayB.some((valueFromB)=>equality(valueFromA, valueFromB)));
// src/data/arrays/MergeByKey.ts
var $b63753f448317b08$export$5848149affbf5a72 = (keyFunction, reconcile, ...arrays)=>{
    const result = /* @__PURE__ */ new Map();
    for (const m of arrays)for (const mv of m){
        if (mv === void 0) continue;
        const mk = keyFunction(mv);
        let v = result.get(mk);
        v = v ? reconcile(v, mv) : mv;
        result.set(mk, v);
    }
    return [
        ...result.values()
    ];
};
// src/data/arrays/Remove.ts
var $b63753f448317b08$export$cd7f480d6b8286c3 = (data, index)=>{
    if (!Array.isArray(data)) throw new TypeError(`'data' parameter should be an array`);
    (0, $9364ac8ced0e518d$export$cca6281cc24253c)(data, index, `index`);
    return [
        ...data.slice(0, index),
        ...data.slice(index + 1)
    ];
};
// src/data/arrays/Sample.ts
var $b63753f448317b08$export$4812e460280c6ef2 = (array, amount)=>{
    let subsampleSteps = 1;
    if (amount <= 1) {
        const numberOfItems = array.length * amount;
        subsampleSteps = Math.round(array.length / numberOfItems);
    } else subsampleSteps = amount;
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(subsampleSteps, `positive`, `amount`);
    if (subsampleSteps > array.length - 1) throw new Error(`Subsample steps exceeds array length`);
    const r = [];
    for(let index = subsampleSteps - 1; index < array.length; index += subsampleSteps)r.push(array[index]);
    return r;
};
// src/data/arrays/Sort.ts
var $b63753f448317b08$export$def566e6b50bc276 = (data, propertyName)=>[
        ...data
    ].sort((a, b)=>{
        (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(data, `data`);
        const av = a[propertyName];
        const bv = b[propertyName];
        if (av < bv) return -1;
        if (av > bv) return 1;
        return 0;
    });
var $b63753f448317b08$export$3bf4e72ed1d44710 = (data, propertyName)=>[
        ...data
    ].sort((a, b)=>{
        (0, $2a676fe0e1f81a0d$export$e16ff0ad2c951403)(data, `data`);
        const av = a[propertyName];
        const bv = b[propertyName];
        if (av < bv) return -1;
        if (av > bv) return 1;
        return 0;
    });
// src/data/arrays/Until.ts
function* $b63753f448317b08$export$a40009bd2c363351(data, predicate, initial) {
    let total = initial;
    for (const datum of data){
        const [stop, accumulator] = predicate(datum, total);
        if (stop) break;
        total = accumulator;
        yield datum;
    }
}
// src/data/arrays/Zip.ts
var $b63753f448317b08$export$8901015135f2fb22 = (...arrays)=>{
    if (arrays.some((a)=>!Array.isArray(a))) throw new Error(`All parameters must be an array`);
    const lengths = arrays.map((a)=>a.length);
    if (!$b63753f448317b08$export$751560eb3cce2427(lengths)) throw new Error(`Arrays must be of same length`);
    const returnValue = [];
    const length = lengths[0];
    for(let index = 0; index < length; index++)returnValue.push(arrays.map((a)=>a[index]));
    return returnValue;
};
// src/data/arrays/SortedArray.ts
var $b63753f448317b08$export$fb3a4475396e3f7 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($b63753f448317b08$export$fb3a4475396e3f7, {
    indexOf: ()=>$b63753f448317b08$var$indexOf,
    insert: ()=>$b63753f448317b08$var$insert,
    insertionIndex: ()=>$b63753f448317b08$var$insertionIndex,
    merge: ()=>$b63753f448317b08$var$merge,
    remove: ()=>$b63753f448317b08$var$remove2,
    sort: ()=>$b63753f448317b08$var$sort,
    wrapSorted: ()=>$b63753f448317b08$var$wrapSorted,
    wrapUnsorted: ()=>$b63753f448317b08$var$wrapUnsorted
});
var $b63753f448317b08$var$wrapUnsorted = (unsortedData, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>$b63753f448317b08$var$wrapSorted(unsortedData.toSorted(comparer));
var $b63753f448317b08$var$wrapSorted = (sortedData, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>{
    const store = [
        ...sortedData
    ];
    return {
        /**
     * Returns index of an item, or -1 if not found
     * @param sought Item to find
     * @param start 
     * @param end 
     * @returns 
     */ indexOf: (sought, start = 0, end = store.length)=>{
            return $b63753f448317b08$var$indexOf(store, sought, start, end, comparer);
        },
        insertionIndex: (toInsert)=>{
            return $b63753f448317b08$var$insertionIndex(store, toInsert, 0, store.length, comparer);
        },
        /**
     * Inserts an item, returning a new wrapper
     * @param toInsert 
     * @returns 
     */ insert: (toInsert)=>{
            return $b63753f448317b08$var$wrapSorted($b63753f448317b08$var$insert(store, toInsert, comparer), comparer);
        },
        /**
     * Removes an item, returning a new wrapper
     * @param toRemove 
     * @returns 
     */ remove: (toRemove)=>{
            return $b63753f448317b08$var$wrapSorted($b63753f448317b08$var$remove2(store, toRemove, comparer));
        },
        /**
     * Gets item at a specified offset
     * @param offset 
     * @returns 
     */ at: (offset)=>{
            return store.at(offset);
        },
        /**
     * Gets length
     */ get length () {
            return store.length;
        },
        /**
     * Gets underlying data.
     * Be careful not to mutate. Use `toArray` to get a copy
     * that can be modified.
     */ get data () {
            return store;
        },
        /**
     * Returns a copy of data which is safe to modify.
     * @returns 
     */ toArray: ()=>{
            return [
                ...store
            ];
        }
    };
};
var $b63753f448317b08$var$indexOf = (data, sought, start = 0, end = data.length, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>{
    if (end <= start) return -1;
    const mid = Math.floor((start + end) / 2);
    const result = comparer(data[mid], sought);
    if (result === 0) return mid;
    if (result > 0) return $b63753f448317b08$var$indexOf(data, sought, start, mid - 1, comparer);
    return $b63753f448317b08$var$indexOf(data, sought, mid + 1, end, comparer);
};
var $b63753f448317b08$var$insertionIndex = (data, toInsert, start = 0, end = data.length, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>{
    const mid = Math.floor((start + end) / 2);
    const result = comparer(data[mid], toInsert);
    if (result === 0) return mid + 1;
    if (result > 0) {
        if (start === end) return start;
        if (start + 1 === end) return start;
        return $b63753f448317b08$var$insertionIndex(data, toInsert, start, mid - 1, comparer);
    }
    return $b63753f448317b08$var$insertionIndex(data, toInsert, mid + 1, end, comparer);
};
var $b63753f448317b08$var$insert = (sortedArray, toInsert, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>{
    const index = $b63753f448317b08$var$insertionIndex(sortedArray, toInsert, 0, sortedArray.length, comparer);
    const pre = sortedArray.slice(0, index);
    const post = sortedArray.slice(index);
    return [
        ...pre,
        toInsert,
        ...post
    ];
};
var $b63753f448317b08$var$remove2 = (data, toRemove, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>{
    const index = $b63753f448317b08$var$indexOf(data, toRemove, 0, data.length, comparer);
    if (index === -1) return data;
    const pre = data.slice(0, index);
    const post = data.slice(index + 1);
    return [
        ...pre,
        ...post
    ];
};
var $b63753f448317b08$var$merge = (a, b, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>{
    const t = [];
    let aIndex = 0;
    let bIndex = 0;
    while(aIndex + bIndex < a.length + b.length){
        const aItem = a[aIndex];
        const bItem = b[bIndex];
        const comp = comparer(aItem, bItem);
        if (aItem === void 0) {
            t.push(bItem);
            bIndex++;
        } else if (bItem === void 0) {
            t.push(aItem);
            aIndex++;
        } else if (comp < 0) {
            t.push(aItem);
            aIndex++;
        } else {
            t.push(bItem);
            bIndex++;
        }
    }
    return t;
};
var $b63753f448317b08$var$sortMerge = (data, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>{
    if (data.length <= 1) return [
        ...data
    ];
    const mIndex = Math.floor(data.length / 2);
    const a = data.slice(0, mIndex);
    const b = data.slice(mIndex);
    return $b63753f448317b08$var$merge($b63753f448317b08$var$sortMerge(a, comparer), $b63753f448317b08$var$sortMerge(b, comparer), comparer);
};
var $b63753f448317b08$var$sort = (data, algo = `default`, comparer = (0, $9364ac8ced0e518d$export$2c7d71451559ec2))=>{
    switch(algo){
        case `merge`:
            return $b63753f448317b08$var$sortMerge(data, comparer);
        case "default":
            return data.toSorted(comparer);
    }
};












// src/iterables/CompareValues.ts
var $a67c984aa26c5d8f$export$39bc47f2f22de526 = (iterable, scorer)=>{
    let highestValue;
    let highestScore = Number.MIN_SAFE_INTEGER;
    for (const value of iterable){
        const score = scorer(value);
        if (score >= highestScore) {
            highestScore = score;
            highestValue = value;
        }
    }
    return highestValue;
};
var $a67c984aa26c5d8f$export$96ec731ed4dcb222 = (iterable, scorer)=>{
    let lowestValue;
    let lowestScore = Number.MAX_SAFE_INTEGER;
    for (const value of iterable){
        const score = scorer(value);
        if (score <= lowestScore) {
            lowestScore = score;
            lowestValue = value;
        }
    }
    return lowestValue;
};
var $a67c984aa26c5d8f$var$compareValuesShallow = (a, b, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    const shared = [];
    const aUnique = [];
    const bUnique = [];
    for (const elementOfA of a){
        let seenInB = false;
        for (const elementOfB of b)if (eq(elementOfA, elementOfB)) {
            seenInB = true;
            break;
        }
        if (seenInB) shared.push(elementOfA);
        else aUnique.push(elementOfA);
    }
    for (const elementOfB of b){
        let seenInA = false;
        for (const elementOfA of a)if (eq(elementOfB, elementOfA)) seenInA = true;
        if (!seenInA) bUnique.push(elementOfB);
    }
    const isSame = aUnique.length === 0 && bUnique.length === 0;
    return {
        shared: shared,
        isSame: isSame,
        a: aUnique,
        b: bUnique
    };
};
// src/data/Compare.ts
var $a67c984aa26c5d8f$export$557e783abb8f7505 = (a, b)=>{
    const c = $a67c984aa26c5d8f$var$compareValuesShallow(Object.keys(a), Object.keys(b));
    return c;
};
var $a67c984aa26c5d8f$export$fd94c2af3aa18420 = (a, b)=>{
    const r = $a67c984aa26c5d8f$export$5afcaa214b99f50d(a, b, true);
    if (Object.entries(r.added).length > 0) throw new Error(`Shape of data has changed`);
    if (Object.entries(r.removed).length > 0) throw new Error(`Shape of data has changed`);
    const output = $a67c984aa26c5d8f$var$compareResultToObject(r, b);
    return output;
};
var $a67c984aa26c5d8f$var$compareResultToObject = (r, b)=>{
    const output = {};
    if (r.isArray) return b;
    for (const entry of Object.entries(r.changed))output[entry[0]] = entry[1];
    for (const entry of Object.entries(r.added))output[entry[0]] = entry[1];
    for (const childEntry of Object.entries(r.children))if (childEntry[1].hasChanged) output[childEntry[0]] = $a67c984aa26c5d8f$var$compareResultToObject(childEntry[1], b[childEntry[0]]);
    return output;
};
var $a67c984aa26c5d8f$export$fc16749c794bf6ff = (a, b, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    if (!Array.isArray(a)) throw new Error(`Param 'a' is not an array`);
    if (!Array.isArray(b)) throw new Error(`Param 'b' is not an array`);
    const c = $a67c984aa26c5d8f$export$5afcaa214b99f50d(a, b, false, eq);
    if (!c.isArray) throw new Error(`Change set does not have arrays as parameters`);
    const convert = (key)=>{
        if (key.startsWith(`_`)) return Number.parseInt(key.slice(1));
        else throw new Error(`Unexpected key '${key}'`);
    };
    const cc = {
        ...c,
        added: (0, $c2544ba386edb7ad$export$781522908e4e76a1)(c.added, convert),
        changed: (0, $c2544ba386edb7ad$export$781522908e4e76a1)(c.changed, convert),
        removed: c.removed.map((v)=>convert(v)),
        summary: c.summary.map((value)=>{
            return [
                value[0],
                convert(value[1]),
                value[2]
            ];
        })
    };
    return cc;
};
var $a67c984aa26c5d8f$export$5afcaa214b99f50d = (a, b, assumeSameShape = false, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    const entriesA = Object.entries(a);
    const entriesB = Object.entries(b);
    const scannedKeys = /* @__PURE__ */ new Set();
    const changed = {};
    const added = {};
    const children = {};
    const removed = [];
    const isArray = Array.isArray(a);
    const summary = new Array();
    let hasChanged = false;
    for (const entry of entriesA){
        const outputKey = isArray ? `_${entry[0]}` : entry[0];
        const aValue = entry[1];
        const bValue = b[entry[0]];
        scannedKeys.add(entry[0]);
        if (bValue === void 0) {
            hasChanged = true;
            if (assumeSameShape && !isArray) {
                changed[outputKey] = bValue;
                summary.push([
                    `mutate`,
                    outputKey,
                    bValue
                ]);
            } else {
                removed.push(outputKey);
                summary.push([
                    `del`,
                    outputKey,
                    aValue
                ]);
            }
            continue;
        }
        if (typeof aValue === `object`) {
            const r = $a67c984aa26c5d8f$export$5afcaa214b99f50d(aValue, bValue, assumeSameShape, eq);
            if (r.hasChanged) hasChanged = true;
            children[outputKey] = r;
            const childSummary = r.summary.map((sum)=>{
                return [
                    sum[0],
                    outputKey + `.` + sum[1],
                    sum[2]
                ];
            });
            summary.push(...childSummary);
        } else if (!eq(aValue, bValue)) {
            changed[outputKey] = bValue;
            hasChanged = true;
            summary.push([
                `mutate`,
                outputKey,
                bValue
            ]);
        }
    }
    if (!assumeSameShape || isArray) for (const entry of entriesB){
        const key = isArray ? `_${entry[0]}` : entry[0];
        if (scannedKeys.has(entry[0])) continue;
        added[key] = entry[1];
        hasChanged = true;
        summary.push([
            `add`,
            key,
            entry[1]
        ]);
    }
    return {
        changed: changed,
        added: added,
        removed: removed,
        children: children,
        hasChanged: hasChanged,
        isArray: isArray,
        summary: summary
    };
};






// src/rx/index.ts
var $2edc1eef02a7c199$export$56863f48ae3d9885 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$56863f48ae3d9885, {
    Dom: ()=>$2edc1eef02a7c199$export$e02548a286707272,
    From: ()=>$2edc1eef02a7c199$export$db4e272a145fb195,
    Ops: ()=>$2edc1eef02a7c199$export$2655e45458bc48f3,
    Sinks: ()=>$2edc1eef02a7c199$export$3ac4f45559bd5a90,
    annotate: ()=>$2edc1eef02a7c199$export$1012f5f00ec31870,
    annotateWithOp: ()=>$2edc1eef02a7c199$export$be3adf485fb3cad4,
    average: ()=>$2edc1eef02a7c199$export$5c3bbf40eb9d4622,
    chunk: ()=>$2edc1eef02a7c199$export$5f7ec48d69707ddd,
    cloneFromFields: ()=>$2edc1eef02a7c199$export$794074063fcf8125,
    combineLatestToArray: ()=>$2edc1eef02a7c199$export$b5235d9cdb97b833,
    combineLatestToObject: ()=>$2edc1eef02a7c199$export$75430b411d43dc3f,
    computeWithPrevious: ()=>$2edc1eef02a7c199$export$9be32a0a2ad8b67,
    debounce: ()=>$2edc1eef02a7c199$export$61fc7d43ac8f84b0,
    drop: ()=>$2edc1eef02a7c199$export$663103110d94aac9,
    elapsed: ()=>$2edc1eef02a7c199$export$e04aa69d28450d55,
    field: ()=>$2edc1eef02a7c199$export$e0f35d825088c098,
    filter: ()=>$2edc1eef02a7c199$export$5f7dfb0a65ac6c,
    hasLast: ()=>(0, $f53657e65b61d2bb$export$792719627301184c),
    interpolate: ()=>$2edc1eef02a7c199$export$402e16690d69fb88,
    isPingable: ()=>(0, $f53657e65b61d2bb$export$85c51e1e5198ecb8),
    isReactive: ()=>(0, $f53657e65b61d2bb$export$352205f445242f02),
    isTrigger: ()=>(0, $f53657e65b61d2bb$export$e5ddfc48b47912c),
    isTriggerFunction: ()=>(0, $f53657e65b61d2bb$export$5bd8ad528a97e25f),
    isTriggerGenerator: ()=>(0, $f53657e65b61d2bb$export$95cbacfcc8851121),
    isTriggerValue: ()=>(0, $f53657e65b61d2bb$export$ff8c91f8b60a4fd0),
    isWrapped: ()=>(0, $f53657e65b61d2bb$export$ec0fd572751979bc),
    isWritable: ()=>(0, $f53657e65b61d2bb$export$cc2b2f0230460456),
    manual: ()=>$2edc1eef02a7c199$export$d5db38ffe1f43b01,
    max: ()=>$2edc1eef02a7c199$export$22cda90bd12095a9,
    messageHasValue: ()=>(0, $f53657e65b61d2bb$export$dd622c303f54f474),
    messageIsDoneSignal: ()=>(0, $f53657e65b61d2bb$export$49fb011922c314de),
    messageIsSignal: ()=>(0, $f53657e65b61d2bb$export$3851969427163052),
    min: ()=>$2edc1eef02a7c199$export$b393be5a551404be,
    opify: ()=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f),
    pipe: ()=>$2edc1eef02a7c199$export$a4627e546088548d,
    prepare: ()=>$2edc1eef02a7c199$export$18298bb220d85216,
    rank: ()=>$2edc1eef02a7c199$export$7bfb89b13199fa43,
    resolveSource: ()=>$2edc1eef02a7c199$export$6b1de85efae8a879,
    resolveTriggerValue: ()=>(0, $f53657e65b61d2bb$export$17d169adcb1dceb3),
    run: ()=>$2edc1eef02a7c199$export$889ea624f2cb2c57,
    setHtmlText: ()=>$2edc1eef02a7c199$export$a6c95c2b8a92aa27,
    singleFromArray: ()=>$2edc1eef02a7c199$export$a5a4a5cffa78c0a4,
    split: ()=>$2edc1eef02a7c199$export$65980d18b75784e2,
    splitLabelled: ()=>$2edc1eef02a7c199$export$ecb39c0370b0b52d,
    sum: ()=>$2edc1eef02a7c199$export$8cb7414e874a9718,
    switcher: ()=>$2edc1eef02a7c199$export$8987e38cfd004b13,
    symbol: ()=>$2edc1eef02a7c199$export$8f701197936bc2a6,
    syncToArray: ()=>$2edc1eef02a7c199$export$5eb154d8c1f8350,
    syncToObject: ()=>$2edc1eef02a7c199$export$b32b2cebf6eb1280,
    takeNextValue: ()=>$2edc1eef02a7c199$export$df6ae744d7e44e30,
    tally: ()=>$2edc1eef02a7c199$export$7ed03ecedcf10c1,
    tapOps: ()=>$2edc1eef02a7c199$export$b6abe60b3da98fc9,
    tapProcess: ()=>$2edc1eef02a7c199$export$b6175151fde1dc87,
    tapStream: ()=>$2edc1eef02a7c199$export$bedfced534e7bc06,
    throttle: ()=>$2edc1eef02a7c199$export$de363e709c412c8a,
    timeoutPing: ()=>$2edc1eef02a7c199$export$23da8b73b6fbb5b7,
    timeoutValue: ()=>$2edc1eef02a7c199$export$8862a6a079f688d3,
    to: ()=>$2edc1eef02a7c199$export$2c618a4308a30424,
    toArray: ()=>$2edc1eef02a7c199$export$85fdf2f290cd8da1,
    toArrayOrThrow: ()=>$2edc1eef02a7c199$export$a830f0e6169c5d5f,
    toGenerator: ()=>$2edc1eef02a7c199$export$597d2615a33e50cf,
    transform: ()=>$2edc1eef02a7c199$export$51186ad6e864892a,
    valueToPing: ()=>$2edc1eef02a7c199$export$12a06accaa98bb2f,
    withValue: ()=>$2edc1eef02a7c199$export$3a92ed5088d25bc6,
    wrap: ()=>$2edc1eef02a7c199$export$df323ceab6412a9a,
    writable: ()=>$2edc1eef02a7c199$export$e6d3eada50a007b1
});
// src/rx/sources/Function.ts
function $2edc1eef02a7c199$var$func(callback, options = {}) {
    const maximumRepeats = options.maximumRepeats ?? Number.MAX_SAFE_INTEGER;
    const closeOnError = options.closeOnError ?? true;
    const intervalMs = options.interval ? (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.interval) : -1;
    let manual2 = options.manual ?? false;
    if (options.interval === void 0 && options.manual === void 0) manual2 = true;
    if (manual2 && options.interval) throw new Error(`If option 'manual' is set, option 'interval' cannot be used`);
    const predelay = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.predelay, 0);
    const lazy = options.lazy ?? `very`;
    const signal = options.signal;
    const internalAbort = new AbortController();
    const internalAbortCallback = (reason)=>{
        internalAbort.abort(reason);
    };
    let sentResults = 0;
    let enabled = false;
    const done = (reason)=>{
        events.dispose(reason);
        enabled = false;
        if (run2) run2.cancel();
    };
    const ping = async ()=>{
        if (!enabled) return false;
        if (predelay) await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(predelay);
        if (sentResults >= maximumRepeats) {
            done(`Maximum repeats reached ${maximumRepeats.toString()}`);
            return false;
        }
        try {
            if (signal?.aborted) {
                done(`Signal (${signal.aborted})`);
                return false;
            }
            const value = await callback(internalAbortCallback);
            sentResults++;
            events.set(value);
            return true;
        } catch (error) {
            if (closeOnError) {
                done(`Function error: ${(0, $96302e292290d7c3$export$82f46aa4e6535a45)(error)}`);
                return false;
            } else {
                events.signal(`warn`, (0, $96302e292290d7c3$export$82f46aa4e6535a45)(error));
                return true;
            }
        }
    };
    const run2 = manual2 ? void 0 : (0, $f53657e65b61d2bb$export$5df75b4acf95a98a)(async ()=>{
        const pingResult = await ping();
        if (!pingResult) return false;
        if (internalAbort.signal.aborted) {
            done(`callback function aborted (${internalAbort.signal.reason})`);
            return false;
        }
    }, intervalMs);
    const events = $2edc1eef02a7c199$var$initLazyStream({
        lazy: lazy,
        onStart () {
            enabled = true;
            if (run2) run2.start();
        },
        onStop () {
            enabled = false;
            if (run2) run2.cancel();
        }
    });
    if (lazy === `never` && run2) run2.start();
    return {
        ...events,
        ping: ping
    };
}
// src/iterables/IterableAsync.ts
var $2edc1eef02a7c199$export$95889358bed0a2dc = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$95889358bed0a2dc, {
    asCallback: ()=>$2edc1eef02a7c199$export$11e61faed1285c36,
    chunks: ()=>$2edc1eef02a7c199$export$99f96ea7ddfd7ba9,
    concat: ()=>$2edc1eef02a7c199$export$ee1b3e54f0441b22,
    dropWhile: ()=>$2edc1eef02a7c199$export$533af5c8cd6afa16,
    equals: ()=>$2edc1eef02a7c199$export$e9bab7fafb253603,
    every: ()=>$2edc1eef02a7c199$export$7ecc1a3b11b57dab,
    fill: ()=>$2edc1eef02a7c199$export$9563e054e6f787fb,
    filter: ()=>$2edc1eef02a7c199$export$3dea766d36a8935f,
    find: ()=>$2edc1eef02a7c199$export$71aa6c912b956294,
    flatten: ()=>$2edc1eef02a7c199$export$bffa455ba8c619a6,
    forEach: ()=>$2edc1eef02a7c199$export$4b80e395e36b5a56,
    fromArray: ()=>$2edc1eef02a7c199$export$571d59b505e6bb4e,
    fromIterable: ()=>$2edc1eef02a7c199$export$dcccc29c315dd646,
    map: ()=>$2edc1eef02a7c199$export$871de8747c9eaa88,
    max: ()=>$2edc1eef02a7c199$export$ebc969c3f7f41c0b,
    min: ()=>$2edc1eef02a7c199$export$8efb1fc49a968b94,
    nextWithTimeout: ()=>$2edc1eef02a7c199$export$c8e96baae762a91b,
    reduce: ()=>$2edc1eef02a7c199$export$533b26079ad0b4b,
    repeat: ()=>$2edc1eef02a7c199$var$repeat,
    slice: ()=>$2edc1eef02a7c199$export$58adb3bec8346d0f,
    some: ()=>$2edc1eef02a7c199$export$ad14ef4001db2bcd,
    toArray: ()=>$2edc1eef02a7c199$export$45b10814cc054894,
    unique: ()=>$2edc1eef02a7c199$export$7a5d5c156e7dc406,
    uniqueByValue: ()=>$2edc1eef02a7c199$export$bf6a3c1875347125,
    until: ()=>$2edc1eef02a7c199$export$a40009bd2c363351,
    withDelay: ()=>$2edc1eef02a7c199$var$withDelay,
    zip: ()=>$2edc1eef02a7c199$export$8901015135f2fb22
});
async function* $2edc1eef02a7c199$export$571d59b505e6bb4e(array3, interval = 1) {
    for (const v of array3){
        yield v;
        await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(interval);
    }
}
async function* $2edc1eef02a7c199$export$dcccc29c315dd646(iterable, interval = 1) {
    for await (const v of iterable){
        yield v;
        await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(interval);
    }
}
async function* $2edc1eef02a7c199$export$99f96ea7ddfd7ba9(it, size) {
    let buffer = [];
    for await (const v of it){
        buffer.push(v);
        if (buffer.length === size) {
            yield buffer;
            buffer = [];
        }
    }
    if (buffer.length > 0) yield buffer;
}
async function* $2edc1eef02a7c199$export$ee1b3e54f0441b22(...its) {
    for await (const it of its)yield* it;
}
async function* $2edc1eef02a7c199$export$533af5c8cd6afa16(it, f) {
    for await (const v of it)if (!f(v)) yield v;
}
var $2edc1eef02a7c199$export$a40009bd2c363351 = async (it, callback)=>{
    for await (const _ of it){
        const value = await callback();
        if (typeof value === `boolean` && !value) break;
    }
};
var $2edc1eef02a7c199$var$repeat = async function*(genCreator, repeatsOrSignal) {
    const repeats = typeof repeatsOrSignal === `number` ? repeatsOrSignal : Number.POSITIVE_INFINITY;
    const signal = typeof repeatsOrSignal === `number` ? void 0 : repeatsOrSignal;
    let count2 = repeats;
    while(true){
        for await (const v of genCreator()){
            yield v;
            if (signal?.aborted) break;
        }
        if (Number.isFinite(repeats)) {
            count2--;
            if (count2 === 0) break;
        }
        if (signal?.aborted) break;
    }
};
async function $2edc1eef02a7c199$export$e9bab7fafb253603(it1, it2, equality) {
    const iit1 = it1[Symbol.asyncIterator]();
    const iit2 = it2[Symbol.asyncIterator]();
    while(true){
        const index1 = await iit1.next();
        const index2 = await iit2.next();
        if (equality !== void 0) {
            if (!equality(index1.value, index2.value)) return false;
        } else if (index1.value !== index2.value) return false;
        if (index1.done ?? index2.done) return index1.done && index2.done;
    }
}
async function $2edc1eef02a7c199$export$7ecc1a3b11b57dab(it, f) {
    for await (const v of it){
        const result = await f(v);
        if (!result) return false;
    }
    return true;
}
async function* $2edc1eef02a7c199$export$9563e054e6f787fb(it, v) {
    for await (const _ of it)yield v;
}
async function* $2edc1eef02a7c199$export$3dea766d36a8935f(it, f) {
    for await (const v of it){
        if (!await f(v)) continue;
        yield v;
    }
}
async function $2edc1eef02a7c199$export$71aa6c912b956294(it, f) {
    for await (const v of it){
        if (await f(v)) return v;
    }
}
async function* $2edc1eef02a7c199$export$bffa455ba8c619a6(it) {
    for await (const v of it)if (typeof v === `object`) {
        if (Array.isArray(v)) for (const vv of v)yield vv;
        else if ((0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(v)) for await (const vv of v)yield vv;
        else if ((0, $3f856c338f7c6dcb$export$9652023d9040757)(v)) for (const vv of v)yield vv;
    } else yield v;
}
var $2edc1eef02a7c199$export$4b80e395e36b5a56 = async function(iterator2, fn, options = {}) {
    const interval = options.interval;
    if (Array.isArray(iterator2)) for (const x of iterator2){
        const r = await fn(x);
        if (typeof r === `boolean` && !r) break;
        if (interval) await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(interval);
    }
    else for await (const x of iterator2){
        const r = await fn(x);
        if (typeof r === `boolean` && !r) break;
        if (interval) await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(interval);
    }
};
async function* $2edc1eef02a7c199$export$871de8747c9eaa88(it, f) {
    for await (const v of it)yield f(v);
}
async function* $2edc1eef02a7c199$export$ebc969c3f7f41c0b(it, gt = (a, b)=>a > b) {
    let max5;
    for await (const v of it){
        if (max5 === void 0) {
            max5 = v;
            yield max5;
            continue;
        }
        if (gt(v, max5)) {
            max5 = v;
            yield v;
        }
    }
}
async function* $2edc1eef02a7c199$export$8efb1fc49a968b94(it, gt = (a, b)=>a > b) {
    let min6;
    for await (const v of it){
        if (min6 === void 0) {
            min6 = v;
            yield min6;
            continue;
        }
        if (gt(min6, v)) {
            min6 = v;
            yield v;
        }
    }
    return min6;
}
async function $2edc1eef02a7c199$export$533b26079ad0b4b(it, f, start) {
    for await (const v of it)start = f(start, v);
    return start;
}
async function $2edc1eef02a7c199$export$11e61faed1285c36(input, callback, onDone) {
    for await (const value of input)callback(value);
    if (onDone) onDone();
}
async function* $2edc1eef02a7c199$export$58adb3bec8346d0f(it, start = 0, end = Number.POSITIVE_INFINITY) {
    const iit = it[Symbol.asyncIterator]();
    if (end < start) throw new Error(`Param 'end' should be more than 'start'`);
    for(; start > 0; start--, end--)await iit.next();
    for await (const v of it){
        if (end-- > 0) yield v;
        else break;
    }
}
async function* $2edc1eef02a7c199$var$withDelay(it, delay) {
    for (const v of it){
        await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(delay);
        yield v;
    }
}
async function $2edc1eef02a7c199$export$c8e96baae762a91b(it, options) {
    const ms = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options, 1e3);
    const value = await Promise.race([
        (async ()=>{
            await (0, $f53657e65b61d2bb$export$e772c8ff12451969)({
                millis: ms,
                signal: options.signal
            });
            return void 0;
        })(),
        (async ()=>{
            return await it.next();
        })()
    ]);
    if (value === void 0) throw new Error(`Timeout`);
    return value;
}
async function $2edc1eef02a7c199$export$ad14ef4001db2bcd(it, f) {
    for await (const v of it){
        if (await f(v)) return true;
    }
    return false;
}
async function $2edc1eef02a7c199$export$45b10814cc054894(it, options = {}) {
    const result = [];
    const iterator2 = it[Symbol.asyncIterator]();
    const started = Date.now();
    const maxItems = options.limit ?? Number.POSITIVE_INFINITY;
    const whileFunc = options.while;
    const maxElapsed = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.elapsed, Number.POSITIVE_INFINITY);
    while(result.length < maxItems && Date.now() - started < maxElapsed){
        if (whileFunc) {
            if (!whileFunc(result.length)) break;
        }
        const r = await iterator2.next();
        if (r.done) break;
        result.push(r.value);
    }
    return result;
}
async function* $2edc1eef02a7c199$export$7a5d5c156e7dc406(iterable) {
    const buffer = [];
    const itera = Array.isArray(iterable) ? iterable : [
        iterable
    ];
    for await (const it of itera)for await (const v of it){
        if (buffer.includes(v)) continue;
        buffer.push(v);
        yield v;
    }
}
async function* $2edc1eef02a7c199$export$bf6a3c1875347125(input, toString3 = (0, $847987b26b102cb8$export$f5a6f2033c1996c8), seen = /* @__PURE__ */ new Set()) {
    for await (const v of input){
        const key = toString3(v);
        if (seen.has(key)) continue;
        seen.add(key);
        yield v;
    }
}
async function* $2edc1eef02a7c199$export$8901015135f2fb22(...its) {
    const iits = its.map((it)=>it[Symbol.asyncIterator]());
    while(true){
        const vs = await Promise.all(iits.map((it)=>it.next()));
        if (vs.some((v)=>v.done)) return;
        yield vs.map((v)=>v.value);
    }
}
// src/rx/sources/Iterator.ts
function $2edc1eef02a7c199$var$iterator(source, options = {}) {
    const lazy = options.lazy ?? `very`;
    const log = options.traceLifecycle ? (message)=>{
        console.log(`Rx.From.iterator ${message}`);
    } : (_)=>{};
    const readIntervalMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.readInterval, 5);
    const readTimeoutMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.readTimeout, 300000);
    const whenStopped = options.whenStopped ?? `continue`;
    let iterator2;
    let ourAc;
    let sm = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).init({
        idle: [
            `wait_for_next`
        ],
        wait_for_next: [
            `processing_result`,
            `stopping`,
            `disposed`
        ],
        processing_result: [
            `queued`,
            `disposed`,
            `stopping`
        ],
        queued: [
            `wait_for_next`,
            `disposed`,
            `stopping`
        ],
        stopping: `idle`,
        // eslint-disable-next-line unicorn/no-null
        disposed: null
    }, `idle`);
    const onExternalSignal = ()=>{
        log(`onExternalSignal`);
        ourAc?.abort(options.signal?.reason);
    };
    if (options.signal) options.signal.addEventListener(`abort`, onExternalSignal, {
        once: true
    });
    const read = async ()=>{
        log(`read. State: ${sm.value}`);
        ourAc = new AbortController();
        try {
            sm = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(sm, `wait_for_next`);
            const v = await $2edc1eef02a7c199$export$c8e96baae762a91b(iterator2, {
                signal: ourAc.signal,
                millis: readTimeoutMs
            });
            sm = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(sm, `processing_result`);
            ourAc?.abort(`nextWithTimeout completed`);
            if (v.done) {
                log(`read v.done true`);
                events.dispose(`Generator complete`);
                sm = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(sm, `disposed`);
            }
            if (sm.value === `stopping`) {
                log(`read. sm.value = stopping`);
                sm = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(sm, `idle`);
                return;
            }
            if (sm.value === `disposed`) {
                log(`read. sm.value = disposed`);
                return;
            }
            events.set(v.value);
        } catch (error) {
            events.dispose(`Generator error: ${error.toString()}`);
            return;
        }
        if (sm.value === `processing_result`) {
            sm = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(sm, `queued`);
            log(`scheduling read. State: ${sm.value}`);
            setTimeout(read, readIntervalMs);
        } else sm = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(sm, `idle`);
    };
    const events = $2edc1eef02a7c199$var$initLazyStream({
        ...options,
        lazy: lazy,
        onStart () {
            log(`onStart state: ${sm.value} whenStopped: ${whenStopped}`);
            if (sm.value !== `idle`) return;
            if (sm.value === `idle` && whenStopped === `reset` || iterator2 === void 0) iterator2 = (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(source) ? source[Symbol.asyncIterator]() : source[Symbol.iterator]();
            read();
        },
        onStop () {
            log(`onStop state: ${sm.value} whenStopped: ${whenStopped}`);
            sm = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(sm, `stopping`);
            if (whenStopped === `reset`) {
                log(`onStop reiniting iterator`);
                iterator2 = (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(source) ? source[Symbol.asyncIterator]() : source[Symbol.iterator]();
            }
        },
        onDispose (reason) {
            log(`onDispose (${reason})`);
            ourAc?.abort(`Rx.From.iterator disposed (${reason})`);
            if (options.signal) options.signal.removeEventListener(`abort`, onExternalSignal);
        }
    });
    return events;
}
// src/rx/ResolveSource.ts
var $2edc1eef02a7c199$export$6b1de85efae8a879 = (source, options = {})=>{
    if ((0, $f53657e65b61d2bb$export$352205f445242f02)(source)) return source;
    const generatorOptions = options.generator ?? {
        lazy: `initial`,
        interval: 5
    };
    const functionOptions = options.function ?? {
        lazy: `very`
    };
    if (Array.isArray(source)) return $2edc1eef02a7c199$var$iterator(source.values(), generatorOptions);
    else if (typeof source === `function`) return $2edc1eef02a7c199$var$func(source, functionOptions);
    else if (typeof source === `object`) {
        if ((0, $f53657e65b61d2bb$export$ec0fd572751979bc)(source)) return source.source;
        if ((0, $3f856c338f7c6dcb$export$9652023d9040757)(source) || (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(source)) return $2edc1eef02a7c199$var$iterator(source, generatorOptions);
    }
    throw new TypeError(`Unable to resolve source. Supports: array, Reactive, Async/Iterable. Got type: ${typeof source}`);
};
// src/rx/Cache.ts
function $2edc1eef02a7c199$var$cache(r, initialValue) {
    let lastValue = initialValue;
    r.onValue((value)=>{
        lastValue = value;
    });
    return {
        ...r,
        last () {
            return lastValue;
        },
        resetCachedValue () {
            lastValue = void 0;
        }
    };
}
// src/rx/InitStream.ts
function $2edc1eef02a7c199$var$initUpstream(upstreamSource, options) {
    const lazy = options.lazy ?? `initial`;
    const disposeIfSourceDone = options.disposeIfSourceDone ?? true;
    const onValue = options.onValue ?? ((_v)=>{});
    const source = $2edc1eef02a7c199$export$6b1de85efae8a879(upstreamSource);
    let unsub;
    const debugLabel = options.debugLabel ? `[${options.debugLabel}]` : ``;
    const onStop = ()=>{
        if (unsub === void 0) return;
        unsub();
        unsub = void 0;
        if (options.onStop) options.onStop();
    };
    const onStart = ()=>{
        if (unsub !== void 0) return;
        if (options.onStart) options.onStart();
        unsub = source.on((value)=>{
            if ((0, $f53657e65b61d2bb$export$3851969427163052)(value)) {
                if (value.signal === `done`) {
                    onStop();
                    events.signal(value.signal, value.context);
                    if (disposeIfSourceDone) events.dispose(`Upstream source ${debugLabel} has completed (${value.context ?? ``})`);
                } else events.signal(value.signal, value.context);
            } else if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(value)) onValue(value.value);
        });
    };
    const events = $2edc1eef02a7c199$var$initLazyStream({
        ...options,
        lazy: lazy,
        onStart: onStart,
        onStop: onStop
    });
    return events;
}
function $2edc1eef02a7c199$var$initLazyStream(options) {
    const lazy = options.lazy ?? `initial`;
    const onStop = options.onStop ?? (()=>{});
    const onStart = options.onStart ?? (()=>{});
    const debugLabel = options.debugLabel ? `[${options.debugLabel}]` : ``;
    const events = $2edc1eef02a7c199$var$initStream({
        ...options,
        onFirstSubscribe () {
            if (lazy !== `never`) onStart();
        },
        onNoSubscribers () {
            if (lazy === `very`) onStop();
        }
    });
    if (lazy === `never`) onStart();
    return events;
}
function $2edc1eef02a7c199$var$initStream(options = {}) {
    let dispatcher;
    let disposed = false;
    let firstSubscribe = false;
    let emptySubscriptions = true;
    const onFirstSubscribe = options.onFirstSubscribe ?? void 0;
    const onNoSubscribers = options.onNoSubscribers ?? void 0;
    const debugLabel = options.debugLabel ? `[${options.debugLabel}]` : ``;
    const isEmpty3 = ()=>{
        if (dispatcher === void 0) return;
        if (!dispatcher.isEmpty) return;
        if (!emptySubscriptions) {
            emptySubscriptions = true;
            firstSubscribe = false;
            if (onNoSubscribers) onNoSubscribers();
        }
    };
    const subscribe = (handler)=>{
        if (disposed) throw new Error(`Disposed, cannot subscribe ${debugLabel}`);
        if (dispatcher === void 0) dispatcher = new (0, $f53657e65b61d2bb$export$5950d7e22009b6fe)();
        const id = dispatcher.add(handler);
        emptySubscriptions = false;
        if (!firstSubscribe) {
            firstSubscribe = true;
            if (onFirstSubscribe) onFirstSubscribe();
        }
        return ()=>{
            dispatcher?.remove(id);
            isEmpty3();
        };
    };
    return {
        dispose: (reason)=>{
            if (disposed) return;
            dispatcher?.notify({
                value: void 0,
                signal: `done`,
                context: `Disposed: ${reason}`
            });
            disposed = true;
            if (options.onDispose) options.onDispose(reason);
        },
        isDisposed: ()=>{
            return disposed;
        },
        removeAllSubscribers: ()=>{
            dispatcher?.clear();
            isEmpty3();
        },
        set: (v)=>{
            if (disposed) throw new Error(`${debugLabel} Disposed, cannot set`);
            dispatcher?.notify({
                value: v
            });
        },
        // through: (pass: Passed<V>) => {
        //   if (disposed) throw new Error(`Disposed, cannot through`);
        //   dispatcher?.notify(pass)
        // },
        signal: (signal, context)=>{
            if (disposed) throw new Error(`${debugLabel} Disposed, cannot signal`);
            dispatcher?.notify({
                signal: signal,
                value: void 0,
                context: context
            });
        },
        on: (handler)=>subscribe(handler),
        onValue: (handler)=>{
            const unsub = subscribe((message)=>{
                if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) handler(message.value);
            });
            return unsub;
        }
    };
}
// src/dom/SetProperty.ts
function $2edc1eef02a7c199$export$cbe0d99836e1498f(selectors, value) {
    return $2edc1eef02a7c199$export$a41c68a4eb5ff164(`textContent`, selectors, value);
}
function $2edc1eef02a7c199$export$e9d3191caab19f4d(selectors, value) {
    return $2edc1eef02a7c199$export$a41c68a4eb5ff164(`innerHTML`, selectors, value);
}
function $2edc1eef02a7c199$export$a41c68a4eb5ff164(property, selectors, value) {
    let elements2 = [];
    const set = (v)=>{
        const typ = typeof v;
        const vv = typ === `string` || typ === `number` || typ === `boolean` ? v : JSON.stringify(v);
        if (elements2.length === 0) elements2 = (0, $35a128b42d0e06cd$export$7c36a5fc73d4a4d3)(selectors);
        for (const element of elements2)element[property] = vv;
        return vv;
    };
    return value === void 0 ? set : set(value);
}
// src/rx/sinks/Dom.ts
var $2edc1eef02a7c199$export$a6c95c2b8a92aa27 = (rxOrSource, optionsOrElementOrQuery)=>{
    let el;
    let options;
    if (typeof optionsOrElementOrQuery === `string`) options = {
        query: optionsOrElementOrQuery
    };
    if (typeof optionsOrElementOrQuery === `object`) {
        if (`nodeName` in optionsOrElementOrQuery) options = {
            el: optionsOrElementOrQuery
        };
        else options = optionsOrElementOrQuery;
    }
    if (options === void 0) throw new TypeError(`Missing element as second parameter or option`);
    if (`el` in options) el = options.el;
    else if (`query` in options) el = document.querySelector(options.query);
    else throw new TypeError(`Options does not include 'el' or 'query' fields`);
    if (el === null || el === void 0) throw new Error(`Element could not be resolved.`);
    const stream = $2edc1eef02a7c199$export$6b1de85efae8a879(rxOrSource);
    const setter = $2edc1eef02a7c199$export$a41c68a4eb5ff164(options.asHtml ? `innerHTML` : `textContent`, el);
    const off = stream.onValue((value)=>{
        setter(value);
    });
    return off;
};
// src/rx/ToReadable.ts
var $2edc1eef02a7c199$var$toReadable = (stream)=>({
        on: stream.on,
        dispose: stream.dispose,
        isDisposed: stream.isDisposed,
        onValue: stream.onValue
    });
// src/rx/ops/Annotate.ts
function $2edc1eef02a7c199$export$1012f5f00ec31870(input, annotator, options = {}) {
    const upstream = $2edc1eef02a7c199$var$initUpstream(input, {
        ...options,
        onValue (value) {
            const annotation = annotator(value);
            upstream.set({
                value: value,
                annotation: annotation
            });
        }
    });
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
function $2edc1eef02a7c199$export$be3adf485fb3cad4(input, annotatorOp) {
    const inputStream = $2edc1eef02a7c199$export$6b1de85efae8a879(input);
    const stream = annotatorOp(inputStream);
    const synced = $2edc1eef02a7c199$export$b32b2cebf6eb1280({
        value: inputStream,
        annotation: stream
    });
    return synced;
}
// src/rx/ops/Chunk.ts
function $2edc1eef02a7c199$export$5f7ec48d69707ddd(source, options = {}) {
    const queue = new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)();
    const quantity = options.quantity ?? 0;
    const returnRemainder = options.returnRemainder ?? true;
    const upstreamOpts = {
        ...options,
        onStop () {
            if (returnRemainder && !queue.isEmpty) {
                const data = queue.toArray();
                queue.clear();
                upstream.set(data);
            }
        },
        onValue (value) {
            queue.enqueue(value);
            if (quantity > 0 && queue.length >= quantity) send();
            if (timer !== void 0 && timer.runState === `idle`) timer.start();
        }
    };
    const upstream = $2edc1eef02a7c199$var$initUpstream(source, upstreamOpts);
    const send = ()=>{
        if (queue.isEmpty) return;
        if (timer !== void 0) timer.start();
        const data = queue.toArray();
        queue.clear();
        setTimeout(()=>upstream.set(data));
    };
    const timer = options.elapsed ? (0, $f53657e65b61d2bb$export$83e74882c5df8fe1)(send, options.elapsed) : void 0;
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
// src/rx/ops/Transform.ts
function $2edc1eef02a7c199$export$51186ad6e864892a(input, transformer, options = {}) {
    const traceInput = options.traceInput ?? false;
    const traceOutput = options.traceOutput ?? false;
    const upstream = $2edc1eef02a7c199$var$initUpstream(input, {
        lazy: `initial`,
        ...options,
        onValue (value) {
            const t2 = transformer(value);
            if (traceInput && traceOutput) console.log(`Rx.Ops.transform input: ${JSON.stringify(value)} output: ${JSON.stringify(t2)}`);
            else if (traceInput) console.log(`Rx.Ops.transform input: ${JSON.stringify(value)}`);
            else if (traceOutput) console.log(`Rx.Ops.transform output: ${JSON.stringify(t2)}`);
            upstream.set(t2);
        }
    });
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
// src/rx/ops/CloneFromFields.ts
var $2edc1eef02a7c199$export$794074063fcf8125 = (source)=>{
    return $2edc1eef02a7c199$export$51186ad6e864892a(source, (v)=>{
        const entries = [];
        for(const field2 in v){
            const value = v[field2];
            if ((0, $876c839e98abd7e2$export$70870f43c8775ec5)(value)) entries.push([
                field2,
                value
            ]);
        }
        return Object.fromEntries(entries);
    });
};
// src/rx/ops/CombineLatestToArray.ts
function $2edc1eef02a7c199$export$b5235d9cdb97b833(reactiveSources, options = {}) {
    const event2 = $2edc1eef02a7c199$var$initStream();
    const onSourceDone = options.onSourceDone ?? `break`;
    const data = [];
    const sources = reactiveSources.map((source)=>$2edc1eef02a7c199$export$6b1de85efae8a879(source));
    const noop = ()=>{};
    const sourceOff = sources.map((_)=>noop);
    const doneSources = sources.map((_)=>false);
    const unsub = ()=>{
        for (const v of sourceOff)v();
    };
    for (const [index, v] of sources.entries()){
        data[index] = void 0;
        sourceOff[index] = v.on((message)=>{
            if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) {
                doneSources[index] = true;
                sourceOff[index]();
                sourceOff[index] = noop;
                if (onSourceDone === `break`) {
                    unsub();
                    event2.dispose(`Source has completed and 'break' is set`);
                    return;
                }
                if (!doneSources.includes(false)) {
                    unsub();
                    event2.dispose(`All sources completed`);
                }
            } else if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
                data[index] = message.value;
                event2.set([
                    ...data
                ]);
            }
        });
    }
    return {
        dispose: event2.dispose,
        isDisposed: event2.isDisposed,
        on: event2.on,
        onValue: event2.onValue
    };
}
// src/data/Pathed.ts
var $2edc1eef02a7c199$export$5bcf239e15b1d3e = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$5bcf239e15b1d3e, {
    applyChanges: ()=>$2edc1eef02a7c199$var$applyChanges,
    compareData: ()=>$2edc1eef02a7c199$var$compareData2,
    getField: ()=>$2edc1eef02a7c199$var$getField,
    getPaths: ()=>$2edc1eef02a7c199$var$getPaths,
    getPathsAndData: ()=>$2edc1eef02a7c199$var$getPathsAndData,
    updateByPath: ()=>$2edc1eef02a7c199$var$updateByPath
});
// src/data/Util.ts
var $2edc1eef02a7c199$export$6b9b46bf1ae463eb = (value)=>[
        ...Object.entries(value)
    ].length === 0;
var $2edc1eef02a7c199$export$550c6b464c465bb4 = (a, b, _path)=>{
    return JSON.stringify(a) === JSON.stringify(b);
};
// src/data/Pathed.ts
var $2edc1eef02a7c199$var$getEntries = (target, deepProbe)=>{
    if (target === void 0) throw new Error(`Param 'target' is undefined`);
    if (target === null) throw new Error(`Param 'target' is null`);
    if (typeof target !== `object`) throw new Error(`Param 'target' is not an object (got: ${typeof target})`);
    if (deepProbe) {
        const entries = [];
        for(const field2 in target){
            const value = target[field2];
            if ((0, $876c839e98abd7e2$export$70870f43c8775ec5)(value)) entries.push([
                field2,
                value
            ]);
        }
        return entries;
    } else return Object.entries(target);
};
function* $2edc1eef02a7c199$var$compareData2(a, b, options = {}) {
    if (a === void 0) {
        yield {
            path: options.pathPrefix ?? ``,
            value: b,
            state: `added`
        };
        return;
    }
    if (b === void 0) {
        yield {
            path: options.pathPrefix ?? ``,
            previous: a,
            value: void 0,
            state: `removed`
        };
        return;
    }
    const asPartial = options.asPartial ?? false;
    const undefinedValueMeansRemoved = options.undefinedValueMeansRemoved ?? false;
    const pathPrefix = options.pathPrefix ?? ``;
    const deepEntries = options.deepEntries ?? false;
    const eq = options.eq ?? $2edc1eef02a7c199$export$550c6b464c465bb4;
    const includeMissingFromA = options.includeMissingFromA ?? false;
    const includeParents = options.includeParents ?? false;
    if ((0, $eca7f6cd1c865161$export$c3825b437cbdea5c)(a) && (0, $eca7f6cd1c865161$export$c3825b437cbdea5c)(b)) {
        if (a !== b) yield {
            path: pathPrefix,
            value: b,
            previous: a,
            state: `change`
        };
        return;
    }
    if ((0, $eca7f6cd1c865161$export$c3825b437cbdea5c)(b)) {
        yield {
            path: pathPrefix,
            value: b,
            previous: a,
            state: `change`
        };
        return;
    }
    const entriesA = $2edc1eef02a7c199$var$getEntries(a, deepEntries);
    const entriesAKeys = /* @__PURE__ */ new Set();
    for (const [key, valueA] of entriesA){
        entriesAKeys.add(key);
        const keyOfAInB = key in b;
        const valueOfKeyInB = b[key];
        if (typeof valueA === `object` && valueA !== null) {
            if (keyOfAInB) {
                if (valueOfKeyInB === void 0) throw new Error(`Pathed.compareData Value for key ${key} is undefined`);
                else {
                    const sub = [
                        ...$2edc1eef02a7c199$var$compareData2(valueA, valueOfKeyInB, {
                            ...options,
                            pathPrefix: pathPrefix + key + `.`
                        })
                    ];
                    if (sub.length > 0) {
                        for (const s of sub)yield s;
                        if (includeParents) yield {
                            path: pathPrefix + key,
                            value: b[key],
                            previous: valueA,
                            state: `change`
                        };
                    }
                }
            } else {
                if (asPartial) continue;
                yield {
                    path: pathPrefix + key,
                    value: void 0,
                    previous: valueA,
                    state: `removed`
                };
            }
        } else {
            const subPath = pathPrefix + key;
            if (keyOfAInB) {
                if (valueOfKeyInB === void 0 && undefinedValueMeansRemoved) yield {
                    path: subPath,
                    previous: valueA,
                    value: void 0,
                    state: `removed`
                };
                else if (!eq(valueA, valueOfKeyInB, subPath)) yield {
                    path: subPath,
                    previous: valueA,
                    value: valueOfKeyInB,
                    state: `change`
                };
            } else {
                if (asPartial) continue;
                yield {
                    path: subPath,
                    previous: valueA,
                    value: void 0,
                    state: `removed`
                };
            }
        }
    }
    if (includeMissingFromA) {
        const entriesB = $2edc1eef02a7c199$var$getEntries(b, deepEntries);
        for (const [key, valueB] of entriesB){
            if (entriesAKeys.has(key)) continue;
            yield {
                path: pathPrefix + key,
                previous: void 0,
                value: valueB,
                state: `added`
            };
        }
    }
}
var $2edc1eef02a7c199$var$applyChanges = (source, changes)=>{
    for (const change of changes)source = $2edc1eef02a7c199$var$updateByPath(source, change.path, change.value);
    return source;
};
var $2edc1eef02a7c199$var$updateByPath = (target, path, value, allowShapeChange = false)=>{
    if (path === void 0) throw new Error(`Parameter 'path' is undefined`);
    if (typeof path !== `string`) throw new Error(`Parameter 'path' should be a string. Got: ${typeof path}`);
    if (target === void 0) throw new Error(`Parameter 'target' is undefined`);
    if (target === null) throw new Error(`Parameter 'target' is null`);
    const split2 = path.split(`.`);
    const r = $2edc1eef02a7c199$var$updateByPathImpl(target, split2, value, allowShapeChange);
    return r;
};
var $2edc1eef02a7c199$var$updateByPathImpl = (o, split2, value, allowShapeChange)=>{
    if (split2.length === 0) {
        if (allowShapeChange) return value;
        if (Array.isArray(o) && !Array.isArray(value)) throw new Error(`Expected array value, got: '${JSON.stringify(value)}'. Set allowShapeChange=true to ignore.`);
        if (!Array.isArray(o) && Array.isArray(value)) throw new Error(`Unexpected array value, got: '${JSON.stringify(value)}'. Set allowShapeChange=true to ignore.`);
        if (typeof o !== typeof value) throw new Error(`Cannot reassign object type. (${typeof o} -> ${typeof value}). Set allowShapeChange=true to ignore.`);
        if (typeof o === `object` && !Array.isArray(o)) {
            const c = (0, $a67c984aa26c5d8f$export$557e783abb8f7505)(o, value);
            if (c.a.length > 0) throw new Error(`New value is missing key(s): ${c.a.join(`,`)}`);
            if (c.b.length > 0) throw new Error(`New value cannot add new key(s): ${c.b.join(`,`)}`);
        }
        return value;
    }
    const start = split2.shift();
    if (!start) return value;
    const isInt = (0, $9364ac8ced0e518d$export$a287f47fed4544b8)(start);
    if (isInt && Array.isArray(o)) {
        const index = Number.parseInt(start);
        if (index >= o.length && !allowShapeChange) throw new Error(`Array index ${index.toString()} is outside of the existing length of ${o.length.toString()}. Use allowShapeChange=true to permit this.`);
        const copy = [
            ...o
        ];
        copy[index] = $2edc1eef02a7c199$var$updateByPathImpl(copy[index], split2, value, allowShapeChange);
        return copy;
    } else if (start in o) {
        const copy = {
            ...o
        };
        copy[start] = $2edc1eef02a7c199$var$updateByPathImpl(copy[start], split2, value, allowShapeChange);
        return copy;
    } else throw new Error(`Path ${start} not found in data`);
};
var $2edc1eef02a7c199$var$getField = (object2, path)=>{
    if (typeof path !== `string`) throw new Error(`Param 'path' ought to be a string. Got: '${typeof path}'`);
    if (path.length === 0) throw new Error(`Param string 'path' is empty`);
    if (object2 === void 0) throw new Error(`Param 'object' is undefined`);
    if (object2 === null) throw new Error(`Param 'object' is null`);
    const split2 = path.split(`.`);
    const v = $2edc1eef02a7c199$var$getFieldImpl(object2, split2);
    return v;
};
var $2edc1eef02a7c199$var$getFieldImpl = (object2, split2)=>{
    if (object2 === void 0) throw new Error(`Param 'object' is undefined`);
    if (split2.length === 0) throw new Error(`Path has run out`);
    const start = split2.shift();
    if (!start) throw new Error(`Unexpected empty split path`);
    const isInt = (0, $9364ac8ced0e518d$export$a287f47fed4544b8)(start);
    if (isInt && Array.isArray(object2)) {
        const index = Number.parseInt(start);
        if (typeof object2[index] === `undefined`) return {
            success: false,
            error: `Index '${index}' does not exist. Length: ${object2.length}`
        };
        if (split2.length === 0) return {
            value: object2[index],
            success: true
        };
        else return $2edc1eef02a7c199$var$getFieldImpl(object2[index], split2);
    } else if (typeof object2 === `object` && start in object2) {
        if (split2.length === 0) return {
            value: object2[start],
            success: true
        };
        else return $2edc1eef02a7c199$var$getFieldImpl(object2[start], split2);
    } else return {
        success: false,
        error: `Path '${start}' not found`
    };
};
function* $2edc1eef02a7c199$var$getPaths(object2, onlyLeaves = false) {
    if (object2 === void 0 || object2 === null) return;
    const iter = (0, $eca7f6cd1c865161$export$cb35ab06ef35a01e)(object2);
    for (const c of iter){
        if (c.nodeValue === void 0 && onlyLeaves) continue;
        let path = c.name;
        if (c.ancestors.length > 0) path = c.ancestors.join(`.`) + `.` + path;
        yield path;
    }
}
function* $2edc1eef02a7c199$var$getPathsAndData(o, onlyLeaves = false, maxDepth = Number.MAX_SAFE_INTEGER, prefix = ``) {
    if (o === null) return;
    if (o === void 0) return;
    yield* $2edc1eef02a7c199$var$getPathsAndDataImpl(o, prefix, onlyLeaves, maxDepth);
}
function* $2edc1eef02a7c199$var$getPathsAndDataImpl(o, prefix, onlyLeaves = false, maxDepth) {
    if (maxDepth <= 0) return;
    if (typeof o !== `object`) return;
    for (const entries of Object.entries(o)){
        const sub = (prefix.length > 0 ? prefix + `.` : ``) + entries[0];
        const value = entries[1];
        const leaf = typeof value !== `object`;
        if (onlyLeaves && leaf || !onlyLeaves) yield {
            path: sub,
            value: value
        };
        yield* $2edc1eef02a7c199$var$getPathsAndDataImpl(value, sub, onlyLeaves, maxDepth - 1);
    }
}
// src/rx/sources/Object.ts
function $2edc1eef02a7c199$var$object(initialValue, options = {}) {
    const eq = options.eq ?? $2edc1eef02a7c199$export$550c6b464c465bb4;
    const setEvent = $2edc1eef02a7c199$var$initStream();
    const diffEvent = $2edc1eef02a7c199$var$initStream();
    const fieldChangeEvents = [];
    let value = initialValue;
    let disposed = false;
    const set = (v)=>{
        const diff = [
            ...$2edc1eef02a7c199$var$compareData2(value ?? {}, v, {
                ...options,
                includeMissingFromA: true
            })
        ];
        if (diff.length === 0) return;
        value = v;
        setEvent.set(v);
        diffEvent.set(diff);
    };
    const fireFieldUpdate = (field2, value2)=>{
        for (const [matcher, pattern, list] of fieldChangeEvents)if (matcher(field2)) list.notify({
            fieldName: field2,
            pattern: pattern,
            value: value2
        });
    };
    const updateCompareOptions = {
        asPartial: true,
        includeParents: true
    };
    const update = (toMerge)=>{
        if (value === void 0) {
            value = toMerge;
            setEvent.set(value);
            for (const [k, v] of Object.entries(toMerge))fireFieldUpdate(k, v);
            return value;
        } else {
            const diff = [
                ...$2edc1eef02a7c199$var$compareData2(value, toMerge, updateCompareOptions)
            ];
            if (diff.length === 0) return value;
            value = {
                ...value,
                ...toMerge
            };
            setEvent.set(value);
            diffEvent.set(diff);
            for (const d of diff)fireFieldUpdate(d.path, d.value);
            return value;
        }
    };
    const updateField = (path, valueForField)=>{
        if (value === void 0) throw new Error(`Cannot update value when it has not already been set`);
        const existing = $2edc1eef02a7c199$var$getField(value, path);
        if (!(0, $e8ad1dce15e1a2c0$export$11a85548c4f5cb8b)(existing)) return;
        if (eq(existing.value, valueForField, path)) return;
        let diff = [
            ...$2edc1eef02a7c199$var$compareData2(existing.value, valueForField, {
                ...options,
                includeMissingFromA: true
            })
        ];
        diff = diff.map((d)=>{
            if (d.path.length > 0) return {
                ...d,
                path: path + `.` + d.path
            };
            return {
                ...d,
                path: path
            };
        });
        const o = $2edc1eef02a7c199$var$updateByPath(value, path, valueForField, true);
        value = o;
        setEvent.set(o);
        diffEvent.set(diff);
        fireFieldUpdate(path, valueForField);
    };
    const dispose = (reason)=>{
        if (disposed) return;
        diffEvent.dispose(reason);
        setEvent.dispose(reason);
        disposed = true;
    };
    return {
        dispose: dispose,
        isDisposed () {
            return disposed;
        },
        updateField: /**
     * Update a field.
     * Exception is thrown if field does not exist
     */ updateField,
        last: ()=>value,
        on: setEvent.on,
        onValue: setEvent.onValue,
        onDiff: diffEvent.onValue,
        onField (fieldPattern, handler) {
            const matcher = (0, $ae8f83c19bfd8110$export$f1a4f6fe7579a018)(fieldPattern);
            const listeners = new (0, $f53657e65b61d2bb$export$5950d7e22009b6fe)();
            fieldChangeEvents.push([
                matcher,
                fieldPattern,
                listeners
            ]);
            const id = listeners.add(handler);
            return ()=>listeners.remove(id);
        },
        set: /**
     * Set the whole object
     */ set,
        update: /**
     * Update the object with a partial set of fields and values
     */ update
    };
}
// src/rx/ops/CombineLatestToObject.ts
function $2edc1eef02a7c199$export$75430b411d43dc3f(reactiveSources, options = {}) {
    const disposeSources = options.disposeSources ?? true;
    const event2 = $2edc1eef02a7c199$var$object(void 0);
    const onSourceDone = options.onSourceDone ?? `break`;
    const emitInitial = options.emitInitial ?? true;
    let emitInitialDone = false;
    const states = /* @__PURE__ */ new Map();
    for (const [key, source] of Object.entries(reactiveSources)){
        const initialData = `last` in source ? source.last() : void 0;
        const s = {
            source: $2edc1eef02a7c199$export$6b1de85efae8a879(source),
            done: false,
            data: initialData,
            off: ()=>{}
        };
        states.set(key, s);
    }
    const sources = Object.fromEntries(Object.entries(states).map((entry)=>[
            entry[0],
            entry[1].source
        ]));
    const someUnfinished = ()=>(0, $3ffa4b3bf3c5db47$export$ad14ef4001db2bcd)(states, (v)=>!v.done);
    const unsub = ()=>{
        for (const state of states.values())state.off();
    };
    const getData = ()=>{
        const r = {};
        for (const [key, state] of states){
            const d = state.data;
            if (d !== void 0) r[key] = state.data;
        }
        return r;
    };
    const trigger = ()=>{
        emitInitialDone = true;
        const d = getData();
        event2.set(d);
    };
    const wireUpState = (state)=>{
        state.off = state.source.on((message)=>{
            if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) {
                state.done = true;
                state.off();
                state.off = ()=>{};
                if (onSourceDone === `break`) {
                    unsub();
                    event2.dispose(`Source has completed and 'break' is behaviour`);
                    return;
                }
                if (!someUnfinished()) {
                    unsub();
                    event2.dispose(`All sources completed`);
                }
            } else if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
                state.data = message.value;
                trigger();
            }
        });
    };
    for (const state of states.values())wireUpState(state);
    if (!emitInitialDone && emitInitial) trigger();
    return {
        ...event2,
        hasSource (field2) {
            return states.has(field2);
        },
        replaceSource (field2, source) {
            const state = states.get(field2);
            if (state === void 0) throw new Error(`Field does not exist: '${field2}'`);
            state.off();
            const s = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
            state.source = s;
            wireUpState(state);
        },
        setWith (data) {
            let written = {};
            for (const [key, value] of Object.entries(data)){
                const state = states.get(key);
                if (state !== void 0) {
                    if ((0, $f53657e65b61d2bb$export$cc2b2f0230460456)(state.source)) {
                        state.source.set(value);
                        written[key] = value;
                    }
                    state.data = value;
                }
            }
            return written;
        },
        sources: sources,
        last () {
            return getData();
        },
        dispose (reason) {
            unsub();
            event2.dispose(reason);
            if (disposeSources) for (const v of states.values())v.source.dispose(`Part of disposed mergeToObject`);
        }
    };
}
// src/rx/ops/ComputeWithPrevious.ts
function $2edc1eef02a7c199$export$9be32a0a2ad8b67(input, fn) {
    let previousValue;
    let currentValue;
    if ((0, $f53657e65b61d2bb$export$792719627301184c)(input)) currentValue = previousValue = input.last();
    const trigger = ()=>{
        if (previousValue === void 0 && currentValue !== void 0) {
            previousValue = currentValue;
            upstream.set(previousValue);
        } else if (previousValue !== void 0 && currentValue !== void 0) {
            const vv = fn(previousValue, currentValue);
            previousValue = vv;
            upstream.set(vv);
        }
    };
    const upstream = $2edc1eef02a7c199$var$initUpstream(input, {
        lazy: "very",
        debugLabel: `computeWithPrevious`,
        onValue (value) {
            currentValue = value;
            trigger();
        }
    });
    if (currentValue) trigger();
    return {
        ...$2edc1eef02a7c199$var$toReadable(upstream),
        ping: ()=>{
            if (currentValue !== void 0) trigger();
        }
    };
}
// src/rx/ops/Debounce.ts
function $2edc1eef02a7c199$export$61fc7d43ac8f84b0(source, options = {}) {
    const elapsed2 = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.elapsed, 50);
    let lastValue;
    const timer = (0, $f53657e65b61d2bb$export$83e74882c5df8fe1)(()=>{
        const v = lastValue;
        if (v) {
            upstream.set(v);
            lastValue = void 0;
        }
    }, elapsed2);
    const upstream = $2edc1eef02a7c199$var$initUpstream(source, {
        ...options,
        onValue (value) {
            lastValue = value;
            timer.start();
        }
    });
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
// src/rx/ops/Elapsed.ts
var $2edc1eef02a7c199$export$e04aa69d28450d55 = (input)=>{
    let last = 0;
    return $2edc1eef02a7c199$export$51186ad6e864892a(input, (_ignored)=>{
        const elapsed2 = last === 0 ? 0 : Date.now() - last;
        last = Date.now();
        return elapsed2;
    });
};
// src/rx/ops/Field.ts
function $2edc1eef02a7c199$export$e0f35d825088c098(fieldSource, fieldName, options = {}) {
    const fallbackFieldValue = options.fallbackFieldValue;
    const fallbackObject = options.fallbackObject;
    const upstream = $2edc1eef02a7c199$var$initUpstream(fieldSource, {
        disposeIfSourceDone: true,
        ...options,
        onValue (value) {
            let v;
            if (fieldName in value) v = value[fieldName];
            else if (fallbackObject && fieldName in fallbackObject) v = fallbackObject[fieldName];
            if (v === void 0) v = fallbackFieldValue;
            if (v !== void 0) upstream.set(v);
        }
    });
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
// src/rx/ops/Filter.ts
function $2edc1eef02a7c199$export$5f7dfb0a65ac6c(input, predicate, options) {
    const upstream = $2edc1eef02a7c199$var$initUpstream(input, {
        ...options,
        onValue (value) {
            if (predicate(value)) upstream.set(value);
        }
    });
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
function $2edc1eef02a7c199$export$663103110d94aac9(input, predicate, options) {
    const upstream = $2edc1eef02a7c199$var$initUpstream(input, {
        ...options,
        onValue (value) {
            if (!predicate(value)) upstream.set(value);
        }
    });
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
// src/numbers/Wrap.ts
var $2edc1eef02a7c199$export$39360f24a1bae86c = (v, min6 = 0, max5 = 360)=>{
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(v, void 0, `v`);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(min6, void 0, `min`);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(max5, void 0, `max`);
    if (v === min6) return min6;
    if (v === max5) return min6;
    if (v > 0 && v < min6) v += min6;
    v -= min6;
    max5 -= min6;
    v = v % max5;
    if (v < 0) v = max5 - Math.abs(v) + min6;
    return v + min6;
};
var $2edc1eef02a7c199$export$4997ffc0176396a6 = (v, min6 = 0, max5 = 1)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(v, ``, `min`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(min6, ``, `min`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(max5, ``, `max`);
    if (v === min6) return min6;
    if (v === max5) return min6;
    while(v <= min6 || v >= max5){
        if (v === max5) break;
        if (v === min6) break;
        if (v > max5) v = min6 + (v - max5);
        else if (v < min6) v = max5 - (min6 - v);
    }
    return v;
};
var $2edc1eef02a7c199$export$4fa93d78fefc051b = (min6, max5, fn, a, b)=>{
    let r = 0;
    const distF = Math.abs(b - a);
    const distFwrap = Math.abs(max5 - a + b);
    const distBWrap = Math.abs(a + (360 - b));
    const distMin = Math.min(distF, distFwrap, distBWrap);
    if (distMin === distBWrap) r = a - fn(distMin);
    else if (distMin === distFwrap) r = a + fn(distMin);
    else if (a > b) r = a - fn(distMin);
    else r = a + fn(distMin);
    return $2edc1eef02a7c199$export$39360f24a1bae86c(r, min6, max5);
};
// src/modulation/easing/index.ts
var $2edc1eef02a7c199$export$892cfef512d4ea3d = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$892cfef512d4ea3d, {
    Named: ()=>$2edc1eef02a7c199$var$EasingsNamed_exports,
    create: ()=>$2edc1eef02a7c199$var$create2,
    get: ()=>$2edc1eef02a7c199$export$3988ae62b71be9a3,
    getEasingNames: ()=>$2edc1eef02a7c199$var$getEasingNames,
    line: ()=>$2edc1eef02a7c199$var$line,
    tickEasing: ()=>$2edc1eef02a7c199$var$tickEasing,
    ticks: ()=>$2edc1eef02a7c199$var$ticks2,
    time: ()=>$2edc1eef02a7c199$var$time2,
    timeEasing: ()=>$2edc1eef02a7c199$var$timeEasing
});
// src/modulation/easing/EasingsNamed.ts
var $2edc1eef02a7c199$var$EasingsNamed_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$var$EasingsNamed_exports, {
    arch: ()=>$2edc1eef02a7c199$var$arch,
    backIn: ()=>$2edc1eef02a7c199$var$backIn,
    backInOut: ()=>$2edc1eef02a7c199$var$backInOut,
    backOut: ()=>$2edc1eef02a7c199$var$backOut,
    bell: ()=>$2edc1eef02a7c199$var$bell,
    bounceIn: ()=>$2edc1eef02a7c199$var$bounceIn,
    bounceInOut: ()=>$2edc1eef02a7c199$var$bounceInOut,
    bounceOut: ()=>$2edc1eef02a7c199$var$bounceOut,
    circIn: ()=>$2edc1eef02a7c199$var$circIn,
    circInOut: ()=>$2edc1eef02a7c199$var$circInOut,
    circOut: ()=>$2edc1eef02a7c199$var$circOut,
    cubicIn: ()=>$2edc1eef02a7c199$var$cubicIn,
    cubicOut: ()=>$2edc1eef02a7c199$var$cubicOut,
    elasticIn: ()=>$2edc1eef02a7c199$var$elasticIn,
    elasticInOut: ()=>$2edc1eef02a7c199$var$elasticInOut,
    elasticOut: ()=>$2edc1eef02a7c199$var$elasticOut,
    expoIn: ()=>$2edc1eef02a7c199$var$expoIn,
    expoInOut: ()=>$2edc1eef02a7c199$var$expoInOut,
    expoOut: ()=>$2edc1eef02a7c199$var$expoOut,
    quadIn: ()=>$2edc1eef02a7c199$var$quadIn,
    quadInOut: ()=>$2edc1eef02a7c199$var$quadInOut,
    quadOut: ()=>$2edc1eef02a7c199$var$quadOut,
    quartIn: ()=>$2edc1eef02a7c199$var$quartIn,
    quartOut: ()=>$2edc1eef02a7c199$var$quartOut,
    quintIn: ()=>$2edc1eef02a7c199$var$quintIn,
    quintInOut: ()=>$2edc1eef02a7c199$var$quintInOut,
    quintOut: ()=>$2edc1eef02a7c199$var$quintOut,
    sineIn: ()=>$2edc1eef02a7c199$var$sineIn,
    sineInOut: ()=>$2edc1eef02a7c199$var$sineInOut,
    sineOut: ()=>$2edc1eef02a7c199$var$sineOut,
    smootherstep: ()=>$2edc1eef02a7c199$var$smootherstep,
    smoothstep: ()=>$2edc1eef02a7c199$var$smoothstep
});
// src/modulation/Gaussian.ts
var $2edc1eef02a7c199$var$pow = Math.pow;
var $2edc1eef02a7c199$var$gaussianA = 1 / Math.sqrt(2 * Math.PI);
var $2edc1eef02a7c199$export$b2743cdc8f493e4c = (standardDeviation = 0.4)=>{
    const mean = 0.5;
    return (t2)=>{
        const f = $2edc1eef02a7c199$var$gaussianA / standardDeviation;
        let p = -2.5;
        let c = (t2 - mean) / standardDeviation;
        c *= c;
        p *= c;
        const v = f * $2edc1eef02a7c199$var$pow(Math.E, p);
        if (v > 1) return 1;
        if (v < 0) return 0;
        return v;
    };
};
// src/modulation/easing/EasingsNamed.ts
var $2edc1eef02a7c199$var$sqrt = Math.sqrt;
var $2edc1eef02a7c199$var$pow2 = Math.pow;
var $2edc1eef02a7c199$var$cos = Math.cos;
var $2edc1eef02a7c199$var$pi = Math.PI;
var $2edc1eef02a7c199$var$sin = Math.sin;
var $2edc1eef02a7c199$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $2edc1eef02a7c199$var$quintIn = (x)=>x * x * x * x * x;
var $2edc1eef02a7c199$var$quintOut = (x)=>1 - $2edc1eef02a7c199$var$pow2(1 - x, 5);
var $2edc1eef02a7c199$var$arch = (x)=>x * (1 - x) * 4;
var $2edc1eef02a7c199$var$smoothstep = (x)=>x * x * (3 - 2 * x);
var $2edc1eef02a7c199$var$smootherstep = (x)=>(x * (x * 6 - 15) + 10) * x * x * x;
var $2edc1eef02a7c199$var$sineIn = (x)=>1 - $2edc1eef02a7c199$var$cos(x * $2edc1eef02a7c199$var$pi / 2);
var $2edc1eef02a7c199$var$sineOut = (x)=>$2edc1eef02a7c199$var$sin(x * $2edc1eef02a7c199$var$pi / 2);
var $2edc1eef02a7c199$var$quadIn = (x)=>x * x;
var $2edc1eef02a7c199$var$quadOut = (x)=>1 - (1 - x) * (1 - x);
var $2edc1eef02a7c199$var$sineInOut = (x)=>-($2edc1eef02a7c199$var$cos($2edc1eef02a7c199$var$pi * x) - 1) / 2;
var $2edc1eef02a7c199$var$quadInOut = (x)=>x < 0.5 ? 2 * x * x : 1 - $2edc1eef02a7c199$var$pow2(-2 * x + 2, 2) / 2;
var $2edc1eef02a7c199$var$cubicIn = (x)=>x * x * x;
var $2edc1eef02a7c199$var$cubicOut = (x)=>1 - $2edc1eef02a7c199$var$pow2(1 - x, 3);
var $2edc1eef02a7c199$var$quartIn = (x)=>x * x * x * x;
var $2edc1eef02a7c199$var$quartOut = (x)=>1 - $2edc1eef02a7c199$var$pow2(1 - x, 4);
var $2edc1eef02a7c199$var$expoIn = (x)=>x === 0 ? 0 : $2edc1eef02a7c199$var$pow2(2, 10 * x - 10);
var $2edc1eef02a7c199$var$expoOut = (x)=>x === 1 ? 1 : 1 - $2edc1eef02a7c199$var$pow2(2, -10 * x);
var $2edc1eef02a7c199$var$quintInOut = (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - $2edc1eef02a7c199$var$pow2(-2 * x + 2, 5) / 2;
var $2edc1eef02a7c199$var$expoInOut = (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? $2edc1eef02a7c199$var$pow2(2, 20 * x - 10) / 2 : (2 - $2edc1eef02a7c199$var$pow2(2, -20 * x + 10)) / 2;
var $2edc1eef02a7c199$var$circIn = (x)=>1 - $2edc1eef02a7c199$var$sqrt(1 - $2edc1eef02a7c199$var$pow2(x, 2));
var $2edc1eef02a7c199$var$circOut = (x)=>$2edc1eef02a7c199$var$sqrt(1 - $2edc1eef02a7c199$var$pow2(x - 1, 2));
var $2edc1eef02a7c199$var$backIn = (x)=>{
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return c3 * x * x * x - c1 * x * x;
};
var $2edc1eef02a7c199$var$backOut = (x)=>{
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return 1 + c3 * $2edc1eef02a7c199$var$pow2(x - 1, 3) + c1 * $2edc1eef02a7c199$var$pow2(x - 1, 2);
};
var $2edc1eef02a7c199$var$circInOut = (x)=>x < 0.5 ? (1 - $2edc1eef02a7c199$var$sqrt(1 - $2edc1eef02a7c199$var$pow2(2 * x, 2))) / 2 : ($2edc1eef02a7c199$var$sqrt(1 - $2edc1eef02a7c199$var$pow2(-2 * x + 2, 2)) + 1) / 2;
var $2edc1eef02a7c199$var$backInOut = (x)=>{
    const c1 = 1.70158;
    const c2 = c1 * 1.525;
    return x < 0.5 ? $2edc1eef02a7c199$var$pow2(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : ($2edc1eef02a7c199$var$pow2(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
};
var $2edc1eef02a7c199$var$elasticIn = (x)=>{
    const c4 = 2 * $2edc1eef02a7c199$var$pi / 3;
    return x === 0 ? 0 : x === 1 ? 1 : -$2edc1eef02a7c199$var$pow2(2, 10 * x - 10) * $2edc1eef02a7c199$var$sin((x * 10 - 10.75) * c4);
};
var $2edc1eef02a7c199$var$elasticOut = (x)=>{
    const c4 = 2 * $2edc1eef02a7c199$var$pi / 3;
    return x === 0 ? 0 : x === 1 ? 1 : $2edc1eef02a7c199$var$pow2(2, -10 * x) * $2edc1eef02a7c199$var$sin((x * 10 - 0.75) * c4) + 1;
};
var $2edc1eef02a7c199$var$bounceIn = (x)=>1 - $2edc1eef02a7c199$var$bounceOut(1 - x);
var $2edc1eef02a7c199$var$bell = $2edc1eef02a7c199$export$b2743cdc8f493e4c();
var $2edc1eef02a7c199$var$elasticInOut = (x)=>{
    const c5 = 2 * $2edc1eef02a7c199$var$pi / 4.5;
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -($2edc1eef02a7c199$var$pow2(2, 20 * x - 10) * $2edc1eef02a7c199$var$sin((20 * x - 11.125) * c5)) / 2 : $2edc1eef02a7c199$var$pow2(2, -20 * x + 10) * $2edc1eef02a7c199$var$sin((20 * x - 11.125) * c5) / 2 + 1;
};
var $2edc1eef02a7c199$var$bounceInOut = (x)=>x < 0.5 ? (1 - $2edc1eef02a7c199$var$bounceOut(1 - 2 * x)) / 2 : (1 + $2edc1eef02a7c199$var$bounceOut(2 * x - 1)) / 2;
// src/geometry/point/index.ts
var $2edc1eef02a7c199$export$686cad0ec81705cb = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$686cad0ec81705cb, {
    Empty: ()=>$2edc1eef02a7c199$export$1f74963c34e8bfec,
    Empty3d: ()=>$2edc1eef02a7c199$var$Empty3d,
    Placeholder: ()=>$2edc1eef02a7c199$export$84712d0562a614b8,
    Placeholder3d: ()=>$2edc1eef02a7c199$var$Placeholder3d,
    Unit: ()=>$2edc1eef02a7c199$var$Unit,
    Unit3d: ()=>$2edc1eef02a7c199$var$Unit3d,
    abs: ()=>$2edc1eef02a7c199$var$abs,
    angleRadian: ()=>$2edc1eef02a7c199$export$8052d07eb1c2870e,
    angleRadianCircle: ()=>$2edc1eef02a7c199$var$angleRadianCircle,
    apply: ()=>$2edc1eef02a7c199$var$apply,
    averager: ()=>$2edc1eef02a7c199$var$averager,
    bbox: ()=>$2edc1eef02a7c199$export$bf67010aacbe66fa,
    bbox3d: ()=>$2edc1eef02a7c199$var$bbox3d,
    centroid: ()=>$2edc1eef02a7c199$var$centroid,
    clamp: ()=>$2edc1eef02a7c199$var$clamp2,
    clampMagnitude: ()=>$2edc1eef02a7c199$export$1552ac3ebb4a79b7,
    compare: ()=>$2edc1eef02a7c199$var$compare,
    compareByX: ()=>$2edc1eef02a7c199$var$compareByX,
    compareByY: ()=>$2edc1eef02a7c199$var$compareByY,
    compareByZ: ()=>$2edc1eef02a7c199$var$compareByZ,
    convexHull: ()=>$2edc1eef02a7c199$var$convexHull,
    distance: ()=>$2edc1eef02a7c199$export$9f17032d917177de,
    distanceToCenter: ()=>$2edc1eef02a7c199$var$distanceToCenter,
    distanceToExterior: ()=>$2edc1eef02a7c199$var$distanceToExterior,
    divide: ()=>$2edc1eef02a7c199$export$cd007d971a5a2143,
    divider: ()=>$2edc1eef02a7c199$var$divider,
    dotProduct: ()=>$2edc1eef02a7c199$export$2dfa5a136446eaca,
    findMinimum: ()=>$2edc1eef02a7c199$var$findMinimum,
    from: ()=>$2edc1eef02a7c199$var$from,
    fromNumbers: ()=>$2edc1eef02a7c199$export$c2b110734982f150,
    fromString: ()=>$2edc1eef02a7c199$var$fromString,
    getPointParameter: ()=>$2edc1eef02a7c199$export$fe216fb4d5cb9144,
    getTwoPointParameters: ()=>$2edc1eef02a7c199$var$getTwoPointParameters,
    guard: ()=>(0, $8a5cbeb1c6ae1b41$export$864d727b48066337),
    guardNonZeroPoint: ()=>(0, $8a5cbeb1c6ae1b41$export$af9855bfa425668c),
    interpolate: ()=>$2edc1eef02a7c199$var$interpolate2,
    invert: ()=>$2edc1eef02a7c199$var$invert,
    isEmpty: ()=>(0, $8a5cbeb1c6ae1b41$export$dd1bc94b04021eeb),
    isEqual: ()=>$2edc1eef02a7c199$export$248d38f6296296c5,
    isNaN: ()=>(0, $8a5cbeb1c6ae1b41$export$c9f5652083b8129d),
    isNull: ()=>(0, $8a5cbeb1c6ae1b41$export$630801d484da15df),
    isPlaceholder: ()=>(0, $8a5cbeb1c6ae1b41$export$2047bcc885291b3f),
    isPoint: ()=>(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92),
    isPoint3d: ()=>(0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2),
    leftmost: ()=>$2edc1eef02a7c199$var$leftmost,
    multiply: ()=>$2edc1eef02a7c199$export$2060d2db72cce88f,
    multiplyScalar: ()=>$2edc1eef02a7c199$export$c697bed75648cdb7,
    normalise: ()=>$2edc1eef02a7c199$export$40f4ec979313550f,
    normaliseByRect: ()=>$2edc1eef02a7c199$export$6c3af93e8b0137fa,
    pipeline: ()=>$2edc1eef02a7c199$var$pipeline,
    pipelineApply: ()=>$2edc1eef02a7c199$var$pipelineApply,
    progressBetween: ()=>$2edc1eef02a7c199$var$progressBetween,
    project: ()=>$2edc1eef02a7c199$export$ab03b6763ed7026f,
    quantiseEvery: ()=>$2edc1eef02a7c199$var$quantiseEvery2,
    random: ()=>$2edc1eef02a7c199$var$random,
    random3d: ()=>$2edc1eef02a7c199$var$random3d,
    reduce: ()=>$2edc1eef02a7c199$export$45ce22197e959b90,
    relation: ()=>$2edc1eef02a7c199$export$c7330cd8359b642f,
    rightmost: ()=>$2edc1eef02a7c199$var$rightmost,
    rotate: ()=>$2edc1eef02a7c199$export$bb628a54ab399bc9,
    rotatePointArray: ()=>$2edc1eef02a7c199$var$rotatePointArray,
    round: ()=>$2edc1eef02a7c199$var$round2,
    subtract: ()=>$2edc1eef02a7c199$export$4e2d2ead65e5f7e3,
    sum: ()=>$2edc1eef02a7c199$export$97b149eb05063bd8,
    to2d: ()=>$2edc1eef02a7c199$var$to2d,
    to3d: ()=>$2edc1eef02a7c199$var$to3d,
    toArray: ()=>$2edc1eef02a7c199$var$toArray3,
    toIntegerValues: ()=>$2edc1eef02a7c199$var$toIntegerValues,
    toString: ()=>$2edc1eef02a7c199$export$eaaba333dd67ec2a,
    withinRange: ()=>$2edc1eef02a7c199$var$withinRange,
    wrap: ()=>$2edc1eef02a7c199$var$wrap2
});
// src/geometry/point/Abs.ts
function $2edc1eef02a7c199$var$abs(pt) {
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(pt)) return Object.freeze({
        ...pt,
        x: Math.abs(pt.x),
        y: Math.abs(pt.y),
        z: Math.abs(pt.z)
    });
    else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(pt)) return Object.freeze({
        ...pt,
        x: Math.abs(pt.x),
        y: Math.abs(pt.y)
    });
    else throw new TypeError(`Param 'pt' is not a point`);
}
// src/geometry/point/Angle.ts
var $2edc1eef02a7c199$export$8052d07eb1c2870e = (a, b, c)=>{
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(a, `a`);
    if (b === void 0) return Math.atan2(a.y, a.x);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(b, `b`);
    if (c === void 0) return Math.atan2(b.y - a.y, b.x - a.x);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(c, `c`);
    return Math.atan2(b.y - a.y, b.x - a.x) - Math.atan2(c.y - a.y, c.x - a.x);
};
var $2edc1eef02a7c199$var$angleRadianCircle = (a, b, c)=>{
    const angle = $2edc1eef02a7c199$export$8052d07eb1c2870e(a, b, c);
    if (angle < 0) return angle + $2edc1eef02a7c199$export$2c99c7b81f64b3e5;
    return angle;
};
// src/geometry/point/Apply.ts
function $2edc1eef02a7c199$var$apply(pt, fn) {
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `pt`);
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(pt)) return Object.freeze({
        ...pt,
        x: fn(pt.x, `x`),
        y: fn(pt.y, `y`),
        z: fn(pt.z, `z`)
    });
    return Object.freeze({
        ...pt,
        x: fn(pt.x, `x`),
        y: fn(pt.y, `y`)
    });
}
// src/numbers/AverageWeighted.ts
var $2edc1eef02a7c199$export$bbd5ff27d45679 = (data, weightings)=>{
    if (typeof weightings === `function`) weightings = (0, $36aa4387660da012$export$89a2d5e3ba94fe8a)(data, weightings);
    const ww = (0, $b63753f448317b08$export$8901015135f2fb22)(data, weightings);
    const [totalV, totalW] = ww.reduce((accumulator, v)=>[
            accumulator[0] + v[0] * v[1],
            accumulator[1] + v[1]
        ], [
        0,
        0
    ]);
    return totalV / totalW;
};
// src/numbers/MovingAverage.ts
var $2edc1eef02a7c199$var$PiPi = Math.PI * 2;
var $2edc1eef02a7c199$export$a5d561de29dbfedf = (scaling = 3)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(scaling, `aboveZero`, `scaling`);
    let average4 = 0;
    let count2 = 0;
    return (v)=>{
        const r = (0, $984cc5641d701af3$export$4e9798519a1d5a63)(v, ``, `v`);
        if (r[0] && v !== void 0) {
            count2++;
            average4 = average4 + (v - average4) / Math.min(count2, scaling);
        }
        return average4;
    };
};
var $2edc1eef02a7c199$export$89050dda36d62cd2 = (options)=>{
    const average4 = $2edc1eef02a7c199$export$a5d561de29dbfedf();
    const rm = (0, $f53657e65b61d2bb$export$58840f541415b418)({
        ...options,
        whatToCall: (distance3)=>{
            average4(distance3);
        },
        fallback () {
            return options.default ?? 0;
        }
    });
    return (v)=>{
        rm(v);
        return average4();
    };
};
var $2edc1eef02a7c199$export$e0ccbd22a5b3aab6 = (samples = 100, weighter)=>{
    const q = new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)({
        capacity: samples,
        discardPolicy: `older`
    });
    return (v)=>{
        const r = (0, $984cc5641d701af3$export$4e9798519a1d5a63)(v);
        if (r[0] && v !== void 0) q.enqueue(v);
        return weighter === void 0 ? (0, $36aa4387660da012$export$cc6710ee5f037d57)(q.data) : $2edc1eef02a7c199$export$bbd5ff27d45679(q.data, weighter);
    };
};
var $2edc1eef02a7c199$var$smoothingFactor = (timeDelta, cutoff)=>{
    const r = $2edc1eef02a7c199$var$PiPi * cutoff * timeDelta;
    return r / (r + 1);
};
var $2edc1eef02a7c199$var$exponentialSmoothing = (smoothingFactor2, value, previous)=>{
    return smoothingFactor2 * value + (1 - smoothingFactor2) * previous;
};
var $2edc1eef02a7c199$export$4ab932ba473f741c = (cutoffMin = 1, speedCoefficient = 0, cutoffDefault = 1)=>{
    let previousValue = 0;
    let derivativeLast = 0;
    let timestampLast = 0;
    const compute = (value, timestamp)=>{
        if (timestamp === void 0) timestamp = performance.now();
        const timeDelta = timestamp - timestampLast;
        const s = $2edc1eef02a7c199$var$smoothingFactor(timeDelta, cutoffDefault);
        const valueDelta = (value - previousValue) / timeDelta;
        const derivative = $2edc1eef02a7c199$var$exponentialSmoothing(s, valueDelta, derivativeLast);
        const cutoff = cutoffMin + speedCoefficient * Math.abs(derivative);
        const a = $2edc1eef02a7c199$var$smoothingFactor(timeDelta, cutoff);
        const smoothed = $2edc1eef02a7c199$var$exponentialSmoothing(a, value, previousValue);
        previousValue = smoothed;
        derivativeLast = derivative;
        timestampLast = timestamp;
        return smoothed;
    };
    return compute;
};
// src/geometry/point/Averager.ts
function $2edc1eef02a7c199$var$averager(kind, opts) {
    let x;
    let y;
    let z;
    switch(kind){
        case `moving-average-light`:
            const scaling = opts.scaling ?? 3;
            x = $2edc1eef02a7c199$export$a5d561de29dbfedf(scaling);
            y = $2edc1eef02a7c199$export$a5d561de29dbfedf(scaling);
            z = $2edc1eef02a7c199$export$a5d561de29dbfedf(scaling);
            break;
        default:
            throw new Error(`Unknown averaging kind '${kind}'. Expected: 'moving-average-light'`);
    }
    return (point)=>{
        let ax = x(point.x);
        let ay = y(point.y);
        if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(point)) {
            let az = z(point.z);
            return Object.freeze({
                x: ax,
                y: ay,
                z: az
            });
        } else return Object.freeze({
            x: ax,
            y: ay
        });
    };
}
// src/geometry/point/FindMinimum.ts
function $2edc1eef02a7c199$var$findMinimum(comparer, ...points) {
    if (points.length === 0) throw new Error(`No points provided`);
    let min6 = points[0];
    for (const p of points)if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(min6) && (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(p)) min6 = comparer(min6, p);
    else min6 = comparer(min6, p);
    return min6;
}
// src/geometry/rect/Max.ts
var $2edc1eef02a7c199$export$f17e239f3c38bb6 = (topLeft, topRight, bottomRight, bottomLeft)=>{
    if (topLeft.y > bottomRight.y) throw new Error(`topLeft.y greater than bottomRight.y`);
    if (topLeft.y > bottomLeft.y) throw new Error(`topLeft.y greater than bottomLeft.y`);
    const w1 = topRight.x - topLeft.x;
    const w2 = bottomRight.x - bottomLeft.x;
    const h1 = Math.abs(bottomLeft.y - topLeft.y);
    const h2 = Math.abs(bottomRight.y - topRight.y);
    return {
        x: Math.min(topLeft.x, bottomLeft.x),
        y: Math.min(topRight.y, topLeft.y),
        width: Math.max(w1, w2),
        height: Math.max(h1, h2)
    };
};
// src/geometry/point/Bbox.ts
var $2edc1eef02a7c199$export$bf67010aacbe66fa = (...points)=>{
    const leftMost = $2edc1eef02a7c199$var$findMinimum((a, b)=>{
        return a.x < b.x ? a : b;
    }, ...points);
    const rightMost = $2edc1eef02a7c199$var$findMinimum((a, b)=>{
        return a.x > b.x ? a : b;
    }, ...points);
    const topMost = $2edc1eef02a7c199$var$findMinimum((a, b)=>{
        return a.y < b.y ? a : b;
    }, ...points);
    const bottomMost = $2edc1eef02a7c199$var$findMinimum((a, b)=>{
        return a.y > b.y ? a : b;
    }, ...points);
    const topLeft = {
        x: leftMost.x,
        y: topMost.y
    };
    const topRight = {
        x: rightMost.x,
        y: topMost.y
    };
    const bottomRight = {
        x: rightMost.x,
        y: bottomMost.y
    };
    const bottomLeft = {
        x: leftMost.x,
        y: bottomMost.y
    };
    return $2edc1eef02a7c199$export$f17e239f3c38bb6(topLeft, topRight, bottomRight, bottomLeft);
};
var $2edc1eef02a7c199$var$bbox3d = (...points)=>{
    const box = $2edc1eef02a7c199$export$bf67010aacbe66fa(...points);
    const zMin = $2edc1eef02a7c199$var$findMinimum((a, b)=>{
        return a.z < b.z ? a : b;
    }, ...points);
    const zMax = $2edc1eef02a7c199$var$findMinimum((a, b)=>{
        return a.z > b.z ? a : b;
    }, ...points);
    return {
        ...box,
        z: zMin.z,
        depth: zMax.z - zMin.z
    };
};
// src/geometry/point/Centroid.ts
var $2edc1eef02a7c199$var$centroid = (...points)=>{
    if (!Array.isArray(points)) throw new Error(`Expected list of points`);
    const sum4 = points.reduce((previous, p)=>{
        if (p === void 0) return previous;
        if (Array.isArray(p)) throw new TypeError(`'points' list contains an array. Did you mean: centroid(...myPoints)?`);
        if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(p)) throw new Error(`'points' contains something which is not a point: ${JSON.stringify(p)}`);
        return {
            x: previous.x + p.x,
            y: previous.y + p.y
        };
    }, {
        x: 0,
        y: 0
    });
    return Object.freeze({
        x: sum4.x / points.length,
        y: sum4.y / points.length
    });
};
// src/geometry/point/Clamp.ts
function $2edc1eef02a7c199$var$clamp2(a, min6 = 0, max5 = 1) {
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(a)) return Object.freeze({
        x: (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(a.x, min6, max5),
        y: (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(a.y, min6, max5),
        z: (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(a.z, min6, max5)
    });
    else return Object.freeze({
        x: (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(a.x, min6, max5),
        y: (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(a.y, min6, max5)
    });
}
// src/geometry/point/Compare.ts
var $2edc1eef02a7c199$var$compare = (a, b)=>{
    if (a.x < b.x && a.y < b.y) return -2;
    if (a.x > b.x && a.y > b.y) return 2;
    if (a.x < b.x || a.y < b.y) return -1;
    if (a.x > b.x || a.y > b.y) return 1;
    if (a.x === b.x && a.x === b.y) return 0;
    return Number.NaN;
};
var $2edc1eef02a7c199$var$compareByX = (a, b)=>{
    if (a.x === b.x) return 0;
    if (a.x < b.x) return -1;
    return 1;
};
var $2edc1eef02a7c199$var$compareByY = (a, b)=>{
    if (a.y === b.y) return 0;
    if (a.y < b.y) return -1;
    return 1;
};
var $2edc1eef02a7c199$var$compareByZ = (a, b)=>{
    if (a.z === b.z) return 0;
    if (a.z < b.z) return -1;
    return 1;
};
// src/geometry/point/IsEqual.ts
var $2edc1eef02a7c199$export$248d38f6296296c5 = (...p)=>{
    if (p === void 0) throw new Error(`parameter 'p' is undefined`);
    if (p.length < 2) return true;
    for(let index = 1; index < p.length; index++){
        if (p[index].x !== p[0].x) return false;
        if (p[index].y !== p[0].y) return false;
    }
    return true;
};
// src/geometry/point/ConvexHull.ts
var $2edc1eef02a7c199$var$convexHull = (...pts)=>{
    const sorted = [
        ...pts
    ].sort($2edc1eef02a7c199$var$compareByX);
    if (sorted.length === 1) return sorted;
    const x = (points)=>{
        const v = [];
        for (const p of points){
            while(v.length >= 2){
                const q = v.at(-1);
                const r = v.at(-2);
                if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) v.pop();
                else break;
            }
            v.push(p);
        }
        v.pop();
        return v;
    };
    const upper = x(sorted);
    const lower = x(sorted.reverse());
    if (upper.length === 1 && lower.length === 1 && $2edc1eef02a7c199$export$248d38f6296296c5(lower[0], upper[0])) return upper;
    return [
        ...upper,
        ...lower
    ];
};
// src/geometry/point/GetPointParameter.ts
function $2edc1eef02a7c199$var$getTwoPointParameters(a1, ab2, ab3, ab4, ab5, ab6) {
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(a1) && (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ab2)) return [
        a1,
        ab2
    ];
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a1) && (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(ab2)) return [
        a1,
        ab2
    ];
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(a1)) {
        const b2 = {
            x: ab2,
            y: ab3,
            z: ab4
        };
        if (!(0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(b2)) throw new Error(`Expected x, y & z parameters`);
        return [
            a1,
            b2
        ];
    }
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a1)) {
        const b2 = {
            x: ab2,
            y: ab3
        };
        if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b2)) throw new Error(`Expected x & y parameters`);
        return [
            a1,
            b2
        ];
    }
    if (typeof ab5 !== `undefined` && typeof ab4 !== `undefined`) {
        const a2 = {
            x: a1,
            y: ab2,
            z: ab3
        };
        const b2 = {
            x: ab4,
            y: ab5,
            z: ab6
        };
        if (!(0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(a2)) throw new Error(`Expected x,y,z for first point`);
        if (!(0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(b2)) throw new Error(`Expected x,y,z for second point`);
        return [
            a2,
            b2
        ];
    }
    const a = {
        x: a1,
        y: ab2
    };
    const b = {
        x: ab3,
        y: ab4
    };
    if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a)) throw new Error(`Expected x,y for first point`);
    if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b)) throw new Error(`Expected x,y for second point`);
    return [
        a,
        b
    ];
}
function $2edc1eef02a7c199$export$fe216fb4d5cb9144(a, b, c) {
    if (a === void 0) return {
        x: 0,
        y: 0
    };
    if (Array.isArray(a)) {
        if (a.length === 0) return Object.freeze({
            x: 0,
            y: 0
        });
        if (a.length === 1) return Object.freeze({
            x: a[0],
            y: 0
        });
        if (a.length === 2) return Object.freeze({
            x: a[0],
            y: a[1]
        });
        if (a.length === 3) return Object.freeze({
            x: a[0],
            y: a[1],
            z: a[2]
        });
        throw new Error(`Expected array to be 1-3 elements in length. Got ${a.length}.`);
    }
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a)) return a;
    else if (typeof a !== `number` || typeof b !== `number`) throw new TypeError(`Expected point or x,y as parameters. Got: a: ${JSON.stringify(a)} b: ${JSON.stringify(b)}`);
    if (typeof c === `number`) return Object.freeze({
        x: a,
        y: b,
        z: c
    });
    return Object.freeze({
        x: a,
        y: b
    });
}
// src/geometry/point/Distance.ts
function $2edc1eef02a7c199$export$9f17032d917177de(a, xOrB, y, z) {
    const pt = $2edc1eef02a7c199$export$fe216fb4d5cb9144(xOrB, y, z);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `b`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(a, `a`);
    return (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(pt) && (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(a) ? Math.hypot(pt.x - a.x, pt.y - a.y, pt.z - a.z) : Math.hypot(pt.x - a.x, pt.y - a.y);
}
// src/geometry/circle/Guard.ts
var $2edc1eef02a7c199$export$864d727b48066337 = (circle, parameterName = `circle`)=>{
    if ($2edc1eef02a7c199$export$e5d02b282a20f571(circle)) (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(circle, `circle`);
    if (Number.isNaN(circle.radius)) throw new Error(`${parameterName}.radius is NaN`);
    if (circle.radius <= 0) throw new Error(`${parameterName}.radius must be greater than zero`);
};
var $2edc1eef02a7c199$export$8592c2ea033f4712 = (circle, parameterName = `circle`)=>{
    if (!$2edc1eef02a7c199$export$e5d02b282a20f571(circle)) throw new Error(`Expected a positioned circle with x,y`);
    $2edc1eef02a7c199$export$864d727b48066337(circle, parameterName);
};
var $2edc1eef02a7c199$export$c9f5652083b8129d = (a)=>{
    if (Number.isNaN(a.radius)) return true;
    if ($2edc1eef02a7c199$export$e5d02b282a20f571(a)) {
        if (Number.isNaN(a.x)) return true;
        if (Number.isNaN(a.y)) return true;
    }
    return false;
};
var $2edc1eef02a7c199$export$6c86b85491191ecd = (p)=>p.x !== void 0 && p.y !== void 0;
var $2edc1eef02a7c199$export$777046f736854c19 = (p)=>p.radius !== void 0;
var $2edc1eef02a7c199$export$e5d02b282a20f571 = (p)=>$2edc1eef02a7c199$export$777046f736854c19(p) && $2edc1eef02a7c199$export$6c86b85491191ecd(p);
// src/geometry/circle/DistanceCenter.ts
var $2edc1eef02a7c199$export$42bba38af02b837f = (a, b)=>{
    $2edc1eef02a7c199$export$8592c2ea033f4712(a, `a`);
    if ($2edc1eef02a7c199$export$e5d02b282a20f571(b)) $2edc1eef02a7c199$export$8592c2ea033f4712(b, `b`);
    return $2edc1eef02a7c199$export$9f17032d917177de(a, b);
};
// src/geometry/circle/DistanceFromExterior.ts
var $2edc1eef02a7c199$export$73f895ad8864ed4c = (a, b)=>{
    $2edc1eef02a7c199$export$8592c2ea033f4712(a, `a`);
    if ($2edc1eef02a7c199$export$e5d02b282a20f571(b)) return Math.max(0, $2edc1eef02a7c199$export$42bba38af02b837f(a, b) - a.radius - b.radius);
    else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b)) {
        const distribution = $2edc1eef02a7c199$export$9f17032d917177de(a, b);
        if (distribution < a.radius) return 0;
        return distribution;
    } else throw new Error(`Second parameter invalid type`);
};
// src/geometry/rect/Guard.ts
var $2edc1eef02a7c199$export$5caca1faed27694e = (d, name = `Dimension`)=>{
    if (d === void 0) throw new Error(`${name} is undefined`);
    if (Number.isNaN(d)) throw new Error(`${name} is NaN`);
    if (d < 0) throw new Error(`${name} cannot be negative`);
};
var $2edc1eef02a7c199$export$290a3749c7970426 = (rect, name = `rect`)=>{
    if (rect === void 0) throw new Error(`{$name} undefined`);
    if ($2edc1eef02a7c199$export$db5736f7047b4d1f(rect)) (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(rect, name);
    $2edc1eef02a7c199$export$5caca1faed27694e(rect.width, name + `.width`);
    $2edc1eef02a7c199$export$5caca1faed27694e(rect.height, name + `.height`);
};
var $2edc1eef02a7c199$export$7d980350c5bbfbdd = (rect, origin)=>{
    $2edc1eef02a7c199$export$290a3749c7970426(rect);
    if ($2edc1eef02a7c199$export$db5736f7047b4d1f(rect) && origin === void 0) return rect;
    if (origin === void 0) throw new Error(`Unpositioned rect needs origin parameter`);
    return Object.freeze({
        ...rect,
        ...origin
    });
};
var $2edc1eef02a7c199$export$cafbc58a575a627c = (rect, name = `rect`)=>{
    if (!$2edc1eef02a7c199$export$db5736f7047b4d1f(rect)) throw new Error(`Expected ${name} to have x,y`);
    $2edc1eef02a7c199$export$290a3749c7970426(rect, name);
};
var $2edc1eef02a7c199$export$dd1bc94b04021eeb = (rect)=>rect.width === 0 && rect.height === 0;
var $2edc1eef02a7c199$export$2047bcc885291b3f = (rect)=>Number.isNaN(rect.width) && Number.isNaN(rect.height);
var $2edc1eef02a7c199$export$db5736f7047b4d1f = (rect)=>rect.x !== void 0 && rect.y !== void 0;
var $2edc1eef02a7c199$export$707a34ba392ff427 = (rect)=>{
    if (rect === void 0) return false;
    if (rect.width === void 0) return false;
    if (rect.height === void 0) return false;
    return true;
};
var $2edc1eef02a7c199$export$5dc6ff369cea976c = (rect)=>$2edc1eef02a7c199$export$707a34ba392ff427(rect) && $2edc1eef02a7c199$export$db5736f7047b4d1f(rect);
// src/geometry/circle/IsEqual.ts
var $2edc1eef02a7c199$export$cc13405da3dca563 = (a, b)=>{
    if (a.radius !== b.radius) return false;
    if ($2edc1eef02a7c199$export$e5d02b282a20f571(a) && $2edc1eef02a7c199$export$e5d02b282a20f571(b)) {
        if (a.x !== b.x) return false;
        if (a.y !== b.y) return false;
        if (a.z !== b.z) return false;
        return true;
    } else if (!$2edc1eef02a7c199$export$e5d02b282a20f571(a) && !$2edc1eef02a7c199$export$e5d02b282a20f571(b)) ;
    else return false;
    return false;
};
// src/geometry/point/Sum.ts
function $2edc1eef02a7c199$export$97b149eb05063bd8(a1, ab2, ab3, ab4, ab5, ab6) {
    const [ptA, ptB] = $2edc1eef02a7c199$var$getTwoPointParameters(a1, ab2, ab3, ab4, ab5, ab6);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptA, `a`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptB, `b`);
    let pt = {
        x: ptA.x + ptB.x,
        y: ptA.y + ptB.y
    };
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ptA) || (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ptB)) pt.z = (ptA.z ?? 0) + (ptB.z ?? 0);
    return Object.freeze(pt);
}
// src/geometry/point/Subtract.ts
function $2edc1eef02a7c199$export$4e2d2ead65e5f7e3(a1, ab2, ab3, ab4, ab5, ab6) {
    const [ptA, ptB] = $2edc1eef02a7c199$var$getTwoPointParameters(a1, ab2, ab3, ab4, ab5, ab6);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptA, `a`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptB, `b`);
    let pt = {
        x: ptA.x - ptB.x,
        y: ptA.y - ptB.y
    };
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ptA) || (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ptB)) pt.z = (ptA.z ?? 0) - (ptB.z ?? 0);
    return Object.freeze(pt);
}
// src/geometry/circle/Intersections.ts
var $2edc1eef02a7c199$export$27d113dcd5f4d891 = (circle, line2)=>{
    const v1 = {
        x: line2.b.x - line2.a.x,
        y: line2.b.y - line2.a.y
    };
    const v2 = {
        x: line2.a.x - circle.x,
        y: line2.a.y - circle.y
    };
    const b = (v1.x * v2.x + v1.y * v2.y) * -2;
    const c = 2 * (v1.x * v1.x + v1.y * v1.y);
    const d = Math.sqrt(b * b - 2 * c * (v2.x * v2.x + v2.y * v2.y - circle.radius * circle.radius));
    if (Number.isNaN(d)) return [];
    const u1 = (b - d) / c;
    const u2 = (b + d) / c;
    const returnValue = [];
    if (u1 <= 1 && u1 >= 0) returnValue.push({
        x: line2.a.x + v1.x * u1,
        y: line2.a.y + v1.y * u1
    });
    if (u2 <= 1 && u2 >= 0) returnValue.push({
        x: line2.a.x + v1.x * u2,
        y: line2.a.y + v1.y * u2
    });
    return returnValue;
};
var $2edc1eef02a7c199$export$1eab5cf80b02390a = (a, b)=>{
    const vector = $2edc1eef02a7c199$export$4e2d2ead65e5f7e3(b, a);
    const centerD = Math.hypot(vector.y, vector.x);
    if (centerD > a.radius + b.radius) return [];
    if (centerD < Math.abs(a.radius - b.radius)) return [];
    if ($2edc1eef02a7c199$export$cc13405da3dca563(a, b)) return [];
    const centroidD = (a.radius * a.radius - b.radius * b.radius + centerD * centerD) / (2 * centerD);
    const centroid2 = {
        x: a.x + vector.x * centroidD / centerD,
        y: a.y + vector.y * centroidD / centerD
    };
    const centroidIntersectionD = Math.sqrt(a.radius * a.radius - centroidD * centroidD);
    const intersection = {
        x: -vector.y * (centroidIntersectionD / centerD),
        y: vector.x * (centroidIntersectionD / centerD)
    };
    return [
        $2edc1eef02a7c199$export$97b149eb05063bd8(centroid2, intersection),
        $2edc1eef02a7c199$export$4e2d2ead65e5f7e3(centroid2, intersection)
    ];
};
// src/geometry/Intersects.ts
var $2edc1eef02a7c199$export$e629676a0f9e1c8c = (a, b)=>{
    const deltaX = a.x - Math.max(b.x, Math.min(a.x, b.x + b.width));
    const deltaY = a.y - Math.max(b.y, Math.min(a.y, b.y + b.height));
    return deltaX * deltaX + deltaY * deltaY < a.radius * a.radius;
};
var $2edc1eef02a7c199$export$b85ee8633cdf5ab6 = (a, b)=>$2edc1eef02a7c199$export$1eab5cf80b02390a(a, b).length === 2;
// src/geometry/rect/Intersects.ts
function $2edc1eef02a7c199$export$5723c514448bc2af(rect, a, b) {
    $2edc1eef02a7c199$export$290a3749c7970426(rect, `rect`);
    let x = 0;
    let y = 0;
    if (typeof a === `number`) {
        if (b === void 0) throw new Error(`x and y coordinate needed`);
        x = a;
        y = b;
    } else {
        x = a.x;
        y = a.y;
    }
    if ($2edc1eef02a7c199$export$db5736f7047b4d1f(rect)) {
        if (x - rect.x > rect.width || x < rect.x) return false;
        if (y - rect.y > rect.height || y < rect.y) return false;
    } else {
        if (x > rect.width || x < 0) return false;
        if (y > rect.height || y < 0) return false;
    }
    return true;
}
var $2edc1eef02a7c199$export$8d3dd0be5eb9f11f = (a, b)=>{
    if (!$2edc1eef02a7c199$export$5dc6ff369cea976c(a)) throw new Error(`a parameter should be RectPositioned`);
    if ($2edc1eef02a7c199$export$e5d02b282a20f571(b)) return $2edc1eef02a7c199$export$e629676a0f9e1c8c(b, a);
    else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b)) return $2edc1eef02a7c199$export$5723c514448bc2af(a, b);
    throw new Error(`Unknown shape for b: ${JSON.stringify(b)}`);
};
// src/geometry/rect/Center.ts
var $2edc1eef02a7c199$export$3481c78889e8fbe8 = (rect, origin)=>{
    $2edc1eef02a7c199$export$290a3749c7970426(rect);
    if (origin === void 0 && (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect)) origin = rect;
    else if (origin === void 0) origin = {
        x: 0,
        y: 0
    };
    const r = $2edc1eef02a7c199$export$7d980350c5bbfbdd(rect, origin);
    return Object.freeze({
        x: origin.x + rect.width / 2,
        y: origin.y + rect.height / 2
    });
};
// src/geometry/point/PointType.ts
var $2edc1eef02a7c199$export$84712d0562a614b8 = Object.freeze({
    x: Number.NaN,
    y: Number.NaN
});
var $2edc1eef02a7c199$var$Placeholder3d = Object.freeze({
    x: Number.NaN,
    y: Number.NaN,
    z: Number.NaN
});
// src/geometry/rect/Distance.ts
var $2edc1eef02a7c199$export$1d7fc3f9c9c3404e = (rect, pt)=>{
    $2edc1eef02a7c199$export$cafbc58a575a627c(rect, `rect`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `pt`);
    if ($2edc1eef02a7c199$export$5723c514448bc2af(rect, pt)) return 0;
    const dx = Math.max(rect.x - pt.x, 0, pt.x - rect.x + rect.width);
    const dy = Math.max(rect.y - pt.y, 0, pt.y - rect.y + rect.height);
    return Math.hypot(dx, dy);
};
var $2edc1eef02a7c199$export$1ba1d731b131b9aa = (rect, pt)=>$2edc1eef02a7c199$export$9f17032d917177de($2edc1eef02a7c199$export$3481c78889e8fbe8(rect), pt);
// src/geometry/point/DistanceToCenter.ts
var $2edc1eef02a7c199$var$distanceToCenter = (a, shape)=>{
    if ($2edc1eef02a7c199$export$5dc6ff369cea976c(shape)) return $2edc1eef02a7c199$export$1d7fc3f9c9c3404e(shape, a);
    if ($2edc1eef02a7c199$export$e5d02b282a20f571(shape)) return $2edc1eef02a7c199$export$73f895ad8864ed4c(shape, a);
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(shape)) return $2edc1eef02a7c199$export$9f17032d917177de(a, shape);
    throw new Error(`Unknown shape`);
};
// src/geometry/point/DistanceToExterior.ts
var $2edc1eef02a7c199$var$distanceToExterior = (a, shape)=>{
    if ($2edc1eef02a7c199$export$5dc6ff369cea976c(shape)) return $2edc1eef02a7c199$export$1d7fc3f9c9c3404e(shape, a);
    if ($2edc1eef02a7c199$export$e5d02b282a20f571(shape)) return $2edc1eef02a7c199$export$73f895ad8864ed4c(shape, a);
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(shape)) return $2edc1eef02a7c199$export$9f17032d917177de(a, shape);
    throw new Error(`Unknown shape`);
};
// src/geometry/point/Divider.ts
function $2edc1eef02a7c199$export$cd007d971a5a2143(a1, ab2, ab3, ab4, ab5, ab6) {
    const [ptA, ptB] = $2edc1eef02a7c199$var$getTwoPointParameters(a1, ab2, ab3, ab4, ab5, ab6);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptA, `a`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptB, `b`);
    if (ptB.x === 0) throw new TypeError("Cannot divide by zero (b.x is 0)");
    if (ptB.y === 0) throw new TypeError("Cannot divide by zero (b.y is 0)");
    let pt = {
        x: ptA.x / ptB.x,
        y: ptA.y / ptB.y
    };
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ptA) || (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ptB)) {
        if (ptB.z === 0) throw new TypeError("Cannot divide by zero (b.z is 0)");
        pt.z = (ptA.z ?? 0) / (ptB.z ?? 0);
    }
    return Object.freeze(pt);
}
function $2edc1eef02a7c199$var$divider(a, b, c) {
    const divisor = $2edc1eef02a7c199$export$fe216fb4d5cb9144(a, b, c);
    (0, $8a5cbeb1c6ae1b41$export$af9855bfa425668c)(divisor, `divisor`);
    return (aa, bb, cc)=>{
        const dividend = $2edc1eef02a7c199$export$fe216fb4d5cb9144(aa, bb, cc);
        return typeof dividend.z === `undefined` ? Object.freeze({
            x: dividend.x / divisor.x,
            y: dividend.y / divisor.y
        }) : Object.freeze({
            x: dividend.x / divisor.x,
            y: dividend.y / divisor.y,
            z: dividend.z / (divisor.z ?? 1)
        });
    };
}
// src/geometry/point/ToArray.ts
var $2edc1eef02a7c199$var$toArray3 = (p)=>[
        p.x,
        p.y
    ];
// src/geometry/point/DotProduct.ts
var $2edc1eef02a7c199$export$2dfa5a136446eaca = (...pts)=>{
    const a = pts.map((p)=>$2edc1eef02a7c199$var$toArray3(p));
    return (0, $36aa4387660da012$export$2dfa5a136446eaca)(a);
};
// src/geometry/point/Empty.ts
var $2edc1eef02a7c199$export$1f74963c34e8bfec = {
    x: 0,
    y: 0
};
var $2edc1eef02a7c199$var$Unit = {
    x: 1,
    y: 1
};
var $2edc1eef02a7c199$var$Empty3d = {
    x: 0,
    y: 0,
    z: 0
};
var $2edc1eef02a7c199$var$Unit3d = {
    x: 1,
    y: 1,
    z: 1
};
// src/geometry/point/From.ts
function $2edc1eef02a7c199$var$from(xOrArray, y, z) {
    if (Array.isArray(xOrArray)) {
        if (xOrArray.length === 3) return Object.freeze({
            x: xOrArray[0],
            y: xOrArray[1],
            z: xOrArray[2]
        });
        else if (xOrArray.length === 2) return Object.freeze({
            x: xOrArray[0],
            y: xOrArray[1]
        });
        else throw new Error(`Expected array of length two or three, got ${xOrArray.length}`);
    } else {
        if (xOrArray === void 0) throw new Error(`Requires an array of [x,y] or x,y parameters at least`);
        else if (Number.isNaN(xOrArray)) throw new Error(`x is NaN`);
        if (y === void 0) throw new Error(`Param 'y' is missing`);
        else if (Number.isNaN(y)) throw new Error(`y is NaN`);
        if (z === void 0) return Object.freeze({
            x: xOrArray,
            y: y
        });
        else return Object.freeze({
            x: xOrArray,
            y: y,
            z: z
        });
    }
}
var $2edc1eef02a7c199$var$fromString = (str)=>{
    if (typeof str !== `string`) throw new TypeError(`Param 'str' ought to be a string. Got: ${typeof str}`);
    const comma = str.indexOf(`,`);
    const x = Number.parseFloat(str.substring(0, comma));
    const nextComma = str.indexOf(",", comma + 1);
    if (nextComma > 0) {
        const y = Number.parseFloat(str.substring(comma + 1, nextComma - comma + 2));
        const z = Number.parseFloat(str.substring(nextComma + 1));
        return {
            x: x,
            y: y,
            z: z
        };
    } else {
        const y = Number.parseFloat(str.substring(comma + 1));
        return {
            x: x,
            y: y
        };
    }
};
var $2edc1eef02a7c199$export$c2b110734982f150 = (...coords)=>{
    const pts = [];
    if (Array.isArray(coords[0])) for (const coord of coords){
        if (!(coord.length % 2 === 0)) throw new Error(`coords array should be even-numbered`);
        pts.push(Object.freeze({
            x: coord[0],
            y: coord[1]
        }));
    }
    else {
        if (coords.length % 2 !== 0) throw new Error(`Expected even number of elements: [x,y,x,y...]`);
        for(let index = 0; index < coords.length; index += 2)pts.push(Object.freeze({
            x: coords[index],
            y: coords[index + 1]
        }));
    }
    return pts;
};
// src/geometry/line/Guard.ts
var $2edc1eef02a7c199$export$36082bc57fd6e7b6 = (p)=>{
    if (p === void 0) return false;
    if (p.a === void 0) return false;
    if (p.b === void 0) return false;
    if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(p.a)) return false;
    if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(p.b)) return false;
    return true;
};
var $2edc1eef02a7c199$export$ed7bbaf3881693af = (p)=>{
    if (!Array.isArray(p)) return false;
    const valid = !p.some((v)=>!$2edc1eef02a7c199$export$36082bc57fd6e7b6(v));
    return valid;
};
var $2edc1eef02a7c199$export$c1206aca6ae0febb = (line2, name = `line`)=>{
    if (line2 === void 0) throw new Error(`${name} undefined`);
    if (line2.a === void 0) throw new Error(`${name}.a undefined. Expected {a:Point, b:Point}. Got: ${JSON.stringify(line2)}`);
    if (line2.b === void 0) throw new Error(`${name}.b undefined. Expected {a:Point, b:Point} Got: ${JSON.stringify(line2)}`);
};
// src/geometry/line/GetPointsParameter.ts
var $2edc1eef02a7c199$export$ee879d4500fa8b5d = (aOrLine, b)=>{
    let a;
    if ($2edc1eef02a7c199$export$36082bc57fd6e7b6(aOrLine)) {
        b = aOrLine.b;
        a = aOrLine.a;
    } else {
        a = aOrLine;
        if (b === void 0) throw new Error(`Since first parameter is not a line, two points are expected. Got a: ${JSON.stringify(a)} b: ${JSON.stringify(b)}`);
    }
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(a, `a`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(a, `b`);
    return [
        a,
        b
    ];
};
// src/geometry/line/Length.ts
function $2edc1eef02a7c199$export$f24224f1c91d8156(aOrLine, pointB) {
    if ($2edc1eef02a7c199$export$ed7bbaf3881693af(aOrLine)) {
        const sum4 = aOrLine.reduce((accumulator, v)=>$2edc1eef02a7c199$export$f24224f1c91d8156(v) + accumulator, 0);
        return sum4;
    }
    if (aOrLine === void 0) throw new TypeError(`Parameter 'aOrLine' is undefined`);
    const [a, b] = $2edc1eef02a7c199$export$ee879d4500fa8b5d(aOrLine, pointB);
    const x = b.x - a.x;
    const y = b.y - a.y;
    if (a.z !== void 0 && b.z !== void 0) {
        const z = b.z - a.z;
        return Math.hypot(x, y, z);
    } else return Math.hypot(x, y);
}
// src/geometry/line/Interpolate.ts
function $2edc1eef02a7c199$export$89e29e4ab65e70a9(amount, aOrLine, pointBOrAllowOverflow, allowOverflow) {
    if (typeof pointBOrAllowOverflow === `boolean`) {
        allowOverflow = pointBOrAllowOverflow;
        pointBOrAllowOverflow = void 0;
    }
    if (!allowOverflow) (0, $984cc5641d701af3$export$212d07e09a081c79)(amount, `amount`);
    else (0, $984cc5641d701af3$export$d60fcb8dda779864)(amount, ``, `amount`);
    const [a, b] = $2edc1eef02a7c199$export$ee879d4500fa8b5d(aOrLine, pointBOrAllowOverflow);
    const d = $2edc1eef02a7c199$export$f24224f1c91d8156(a, b);
    const d2 = d * (1 - amount);
    if (d === 0 && d2 === 0) return Object.freeze({
        ...b
    });
    const x = b.x - d2 * (b.x - a.x) / d;
    const y = b.y - d2 * (b.y - a.y) / d;
    return Object.freeze({
        ...b,
        x: x,
        y: y
    });
}
// src/geometry/point/Interpolate.ts
var $2edc1eef02a7c199$var$interpolate2 = (amount, a, b, allowOverflow = false)=>$2edc1eef02a7c199$export$89e29e4ab65e70a9(amount, a, b, allowOverflow);
// src/geometry/point/Invert.ts
var $2edc1eef02a7c199$var$invert = (pt, what = `both`)=>{
    switch(what){
        case `both`:
            return (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(pt) ? Object.freeze({
                ...pt,
                x: pt.x * -1,
                y: pt.y * -1,
                z: pt.z * -1
            }) : Object.freeze({
                ...pt,
                x: pt.x * -1,
                y: pt.y * -1
            });
        case `x`:
            return Object.freeze({
                ...pt,
                x: pt.x * -1
            });
        case `y`:
            return Object.freeze({
                ...pt,
                y: pt.y * -1
            });
        case `z`:
            if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(pt)) return Object.freeze({
                ...pt,
                z: pt.z * -1
            });
            else throw new Error(`pt parameter is missing z`);
        default:
            throw new Error(`Unknown what parameter. Expecting 'both', 'x' or 'y'`);
    }
};
// src/geometry/point/Multiply.ts
function $2edc1eef02a7c199$export$2060d2db72cce88f(a1, ab2, ab3, ab4, ab5, ab6) {
    const [ptA, ptB] = $2edc1eef02a7c199$var$getTwoPointParameters(a1, ab2, ab3, ab4, ab5, ab6);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptA, `a`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptB, `b`);
    let pt = {
        x: ptA.x * ptB.x,
        y: ptA.y * ptB.y
    };
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ptA) || (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(ptB)) pt.z = (ptA.z ?? 0) * (ptB.z ?? 0);
    return Object.freeze(pt);
}
var $2edc1eef02a7c199$export$c697bed75648cdb7 = (pt, v)=>{
    return (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(pt) ? Object.freeze({
        ...pt,
        x: pt.x * v,
        y: pt.y * v,
        z: pt.z * v
    }) : Object.freeze({
        ...pt,
        x: pt.x * v,
        y: pt.y * v
    });
};
// src/geometry/point/Magnitude.ts
var $2edc1eef02a7c199$export$1552ac3ebb4a79b7 = (pt, max5 = 1, min6 = 0)=>{
    const length3 = $2edc1eef02a7c199$export$9f17032d917177de(pt);
    let ratio = 1;
    if (length3 > max5) ratio = max5 / length3;
    else if (length3 < min6) ratio = min6 / length3;
    return ratio === 1 ? pt : $2edc1eef02a7c199$export$2060d2db72cce88f(pt, ratio, ratio);
};
// src/geometry/point/Most.ts
var $2edc1eef02a7c199$var$leftmost = (...points)=>$2edc1eef02a7c199$var$findMinimum((a, b)=>a.x <= b.x ? a : b, ...points);
var $2edc1eef02a7c199$var$rightmost = (...points)=>$2edc1eef02a7c199$var$findMinimum((a, b)=>a.x >= b.x ? a : b, ...points);
// src/geometry/point/Normalise.ts
var $2edc1eef02a7c199$var$length2 = (ptOrX, y)=>{
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(ptOrX)) {
        y = ptOrX.y;
        ptOrX = ptOrX.x;
    }
    if (y === void 0) throw new Error(`Expected y`);
    return Math.hypot(ptOrX, y);
};
var $2edc1eef02a7c199$export$40f4ec979313550f = (ptOrX, y)=>{
    const pt = $2edc1eef02a7c199$export$fe216fb4d5cb9144(ptOrX, y);
    const l = $2edc1eef02a7c199$var$length2(pt);
    if (l === 0) return $2edc1eef02a7c199$export$1f74963c34e8bfec;
    return Object.freeze({
        ...pt,
        x: pt.x / l,
        y: pt.y / l
    });
};
// src/geometry/point/NormaliseByRect.ts
function $2edc1eef02a7c199$export$6c3af93e8b0137fa(a, b, c, d) {
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a)) {
        if (typeof b === `number` && c !== void 0) {
            (0, $984cc5641d701af3$export$d60fcb8dda779864)(b, `positive`, `width`);
            (0, $984cc5641d701af3$export$d60fcb8dda779864)(c, `positive`, `height`);
        } else {
            if (!$2edc1eef02a7c199$export$707a34ba392ff427(b)) throw new Error(`Expected second parameter to be a rect`);
            c = b.height;
            b = b.width;
        }
        return Object.freeze({
            x: a.x / b,
            y: a.y / c
        });
    } else {
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(a, `positive`, `x`);
        if (typeof b !== `number`) throw new TypeError(`Expecting second parameter to be a number (width)`);
        if (typeof c !== `number`) throw new TypeError(`Expecting third parameter to be a number (height)`);
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(b, `positive`, `y`);
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(c, `positive`, `width`);
        if (d === void 0) throw new Error(`Expected height parameter`);
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(d, `positive`, `height`);
        return Object.freeze({
            x: a / c,
            y: b / d
        });
    }
}
// src/geometry/point/Pipeline.ts
var $2edc1eef02a7c199$var$pipelineApply = (point, ...pipelineFns)=>$2edc1eef02a7c199$var$pipeline(...pipelineFns)(point);
var $2edc1eef02a7c199$var$pipeline = (...pipeline2)=>(pt)=>// eslint-disable-next-line unicorn/no-array-reduce
        pipeline2.reduce((previous, current)=>current(previous), pt);
// src/geometry/point/ProgressBetween.ts
var $2edc1eef02a7c199$var$progressBetween = (position, waypointA, waypointB)=>{
    const a = $2edc1eef02a7c199$export$4e2d2ead65e5f7e3(position, waypointA);
    const b = $2edc1eef02a7c199$export$4e2d2ead65e5f7e3(waypointB, waypointA);
    return (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(a) && (0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(b) ? (a.x * b.x + a.y * b.y + a.z * b.z) / (b.x * b.x + b.y * b.y + b.z * b.z) : (a.x * b.x + a.y * b.y) / (b.x * b.x + b.y * b.y);
};
// src/geometry/point/Project.ts
var $2edc1eef02a7c199$export$ab03b6763ed7026f = (origin, distance3, angle)=>{
    const x = Math.cos(angle) * distance3 + origin.x;
    const y = Math.sin(angle) * distance3 + origin.y;
    return {
        x: x,
        y: y
    };
};
// src/numbers/Quantise.ts
var $2edc1eef02a7c199$export$c0481193539b5c4e = (v, every2, middleRoundsUp = true)=>{
    const everyStr = every2.toString();
    const decimal = everyStr.indexOf(`.`);
    let multiplier = 1;
    if (decimal >= 0) {
        let d = everyStr.substring(decimal + 1).length;
        multiplier = 10 * d;
        every2 = Math.floor(multiplier * every2);
        v = v * multiplier;
    }
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(v, ``, `v`);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(every2, ``, `every`);
    let div = v / every2;
    const divModule = div % 1;
    div = Math.floor(div);
    if (divModule === 0.5 && middleRoundsUp || divModule > 0.5) div++;
    const vv = every2 * div / multiplier;
    return vv;
};
// src/geometry/point/Quantise.ts
function $2edc1eef02a7c199$var$quantiseEvery2(pt, snap, middleRoundsUp = true) {
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `pt`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(snap, `snap`);
    if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(pt)) {
        if (!(0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(snap)) throw new TypeError(`Param 'snap' is missing 'z' field`);
        return Object.freeze({
            x: $2edc1eef02a7c199$export$c0481193539b5c4e(pt.x, snap.x, middleRoundsUp),
            y: $2edc1eef02a7c199$export$c0481193539b5c4e(pt.y, snap.y, middleRoundsUp),
            z: $2edc1eef02a7c199$export$c0481193539b5c4e(pt.z, snap.z, middleRoundsUp)
        });
    }
    return Object.freeze({
        x: $2edc1eef02a7c199$export$c0481193539b5c4e(pt.x, snap.x, middleRoundsUp),
        y: $2edc1eef02a7c199$export$c0481193539b5c4e(pt.y, snap.y, middleRoundsUp)
    });
}
// src/geometry/point/Random.ts
var $2edc1eef02a7c199$var$random = (rando)=>{
    if (rando === void 0) rando = (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    return Object.freeze({
        x: rando(),
        y: rando()
    });
};
var $2edc1eef02a7c199$var$random3d = (rando)=>{
    if (rando === void 0) rando = (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    return Object.freeze({
        x: rando(),
        y: rando(),
        z: rando()
    });
};
// src/geometry/point/Reduce.ts
var $2edc1eef02a7c199$export$45ce22197e959b90 = (pts, fn, initial)=>{
    if (initial === void 0) initial = {
        x: 0,
        y: 0
    };
    let accumulator = initial;
    for (const p of pts)accumulator = fn(p, accumulator);
    return accumulator;
};
// src/geometry/point/Relation.ts
var $2edc1eef02a7c199$export$c7330cd8359b642f = (a, b)=>{
    const start = $2edc1eef02a7c199$export$fe216fb4d5cb9144(a, b);
    let totalX = 0;
    let totalY = 0;
    let count2 = 0;
    let lastUpdate = performance.now();
    let lastPoint = start;
    const update = (aa, bb)=>{
        const p = $2edc1eef02a7c199$export$fe216fb4d5cb9144(aa, bb);
        totalX += p.x;
        totalY += p.y;
        count2++;
        const distanceFromStart = $2edc1eef02a7c199$export$9f17032d917177de(p, start);
        const distanceFromLast = $2edc1eef02a7c199$export$9f17032d917177de(p, lastPoint);
        const now = performance.now();
        const speed = distanceFromLast / (now - lastUpdate);
        lastUpdate = now;
        lastPoint = p;
        return Object.freeze({
            angle: $2edc1eef02a7c199$export$8052d07eb1c2870e(p, start),
            distanceFromStart: distanceFromStart,
            distanceFromLast: distanceFromLast,
            speed: speed,
            centroid: $2edc1eef02a7c199$var$centroid(p, start),
            average: {
                x: totalX / count2,
                y: totalY / count2
            }
        });
    };
    return update;
};
// src/geometry/Polar.ts
var $2edc1eef02a7c199$export$c20c3ae8c54a7e6a = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$c20c3ae8c54a7e6a, {
    clampMagnitude: ()=>$2edc1eef02a7c199$export$ca9febc7c1cba526,
    divide: ()=>$2edc1eef02a7c199$var$divide2,
    dotProduct: ()=>$2edc1eef02a7c199$export$cb831202f517eedd,
    fromCartesian: ()=>$2edc1eef02a7c199$export$42bfa0bfc1a1a94,
    guard: ()=>$2edc1eef02a7c199$var$guard6,
    invert: ()=>$2edc1eef02a7c199$var$invert2,
    isAntiParallel: ()=>$2edc1eef02a7c199$var$isAntiParallel,
    isOpposite: ()=>$2edc1eef02a7c199$var$isOpposite,
    isParallel: ()=>$2edc1eef02a7c199$var$isParallel,
    isPolarCoord: ()=>$2edc1eef02a7c199$export$9517f709836def0c,
    multiply: ()=>$2edc1eef02a7c199$var$multiply2,
    normalise: ()=>$2edc1eef02a7c199$export$d07f4a5006fe85de,
    rotate: ()=>$2edc1eef02a7c199$var$rotate,
    rotateDegrees: ()=>$2edc1eef02a7c199$var$rotateDegrees,
    spiral: ()=>$2edc1eef02a7c199$var$spiral,
    spiralRaw: ()=>$2edc1eef02a7c199$var$spiralRaw,
    toCartesian: ()=>$2edc1eef02a7c199$export$24440bbdd34c95b6,
    toPoint: ()=>$2edc1eef02a7c199$export$b63cca88ddc558a9,
    toString: ()=>$2edc1eef02a7c199$export$f84e8e69fd4488a5
});
// src/data/index.ts
var $2edc1eef02a7c199$export$cb2be0d88bf25ccd = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$cb2be0d88bf25ccd, {
    Arrays: ()=>(0, $b63753f448317b08$export$da86460d40002d1f),
    Correlate: ()=>$2edc1eef02a7c199$export$61e1f5d8c8880444,
    Maps: ()=>$2edc1eef02a7c199$export$a1f53b853226be71,
    Pathed: ()=>$2edc1eef02a7c199$export$5bcf239e15b1d3e,
    Pool: ()=>$2edc1eef02a7c199$export$a05827b0e03cef68,
    Process: ()=>$2edc1eef02a7c199$export$b10e2093dd734b61,
    changedDataFields: ()=>(0, $a67c984aa26c5d8f$export$fd94c2af3aa18420),
    cloneFromFields: ()=>$2edc1eef02a7c199$export$12773f791ff2c9ff,
    compareArrays: ()=>(0, $a67c984aa26c5d8f$export$fc16749c794bf6ff),
    compareData: ()=>(0, $a67c984aa26c5d8f$export$5afcaa214b99f50d),
    compareKeys: ()=>(0, $a67c984aa26c5d8f$export$557e783abb8f7505),
    isEmptyEntries: ()=>$2edc1eef02a7c199$export$6b9b46bf1ae463eb,
    isEqualContextString: ()=>$2edc1eef02a7c199$export$550c6b464c465bb4,
    keysToNumbers: ()=>$2edc1eef02a7c199$export$584a44cd196a41b0,
    mapObjectByObject: ()=>$2edc1eef02a7c199$export$147a81dbf84ee787,
    mapObjectShallow: ()=>$2edc1eef02a7c199$export$3e53a9d8791790c9,
    piPi: ()=>$2edc1eef02a7c199$export$bd2071c7829e2c8f,
    resolve: ()=>(0, $f53657e65b61d2bb$export$f7ad0328861e2f03),
    resolveFields: ()=>$2edc1eef02a7c199$export$b340e91215f77267,
    resolveFieldsSync: ()=>$2edc1eef02a7c199$export$81d9cacab5d762c0,
    resolveSync: ()=>(0, $f53657e65b61d2bb$export$90bb0c3a0ef8b4ca),
    resolveWithFallback: ()=>(0, $f53657e65b61d2bb$export$3773b921d3598ab9),
    resolveWithFallbackSync: ()=>(0, $f53657e65b61d2bb$export$bf737119f3ba2592)
});
// src/data/Correlate.ts
var $2edc1eef02a7c199$export$61e1f5d8c8880444 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$61e1f5d8c8880444, {
    align: ()=>$2edc1eef02a7c199$var$align,
    alignById: ()=>$2edc1eef02a7c199$var$alignById
});
var $2edc1eef02a7c199$var$orderScore = (a, b)=>{
    if (a.score > b.score) return -1;
    else if (a.score < b.score) return 1;
    return 0;
};
var $2edc1eef02a7c199$var$align = (similarityFn, lastData, newData, options = {})=>{
    const matchThreshold = options.matchThreshold ?? 0;
    const debug = options.debug ?? false;
    const results = /* @__PURE__ */ new Map();
    const newThings = [];
    const lastMap = /* @__PURE__ */ new Map();
    lastData?.forEach((d, index)=>{
        if (d === void 0) throw new Error(`'lastData' contains undefined (index: ${index})`);
        lastMap.set(d.id, d);
    });
    for(let i = 0; i < newData.length; i++){
        const newD = newData[i];
        if (!lastData || lastData.length === 0) {
            if (debug) console.debug(`Correlate.align() new id: ${newD.id}`);
            newThings.push(newD);
            continue;
        }
        const scoredLastValues = Array.from(lastMap.values()).map((last)=>({
                id: last.id,
                score: last === null ? -1 : similarityFn(last, newD),
                last: last
            }));
        if (scoredLastValues.length === 0) {
            if (debug) console.debug(`Correlate.align() no valid last values id: ${newD.id}`);
            newThings.push(newD);
            continue;
        }
        scoredLastValues.sort($2edc1eef02a7c199$var$orderScore);
        const top = scoredLastValues[0];
        if (top.score < matchThreshold) {
            if (debug) console.debug(`Correlate.align() new item does not reach threshold. Top score: ${top.score} id: ${newD.id}`);
            newThings.push(newD);
            continue;
        }
        if (debug && top.id !== newD.id) console.log(`Correlate.align() Remapped ${newD.id} -> ${top.id} (score: ${top.score})`);
        results.set(top.id, {
            ...newD,
            id: top.id
        });
        lastMap.delete(top.id);
    }
    newThings.forEach((t2)=>results.set(t2.id, t2));
    return Array.from(results.values());
};
var $2edc1eef02a7c199$var$alignById = (fn, options = {})=>{
    let lastData = [];
    const compute = (newData)=>{
        lastData = $2edc1eef02a7c199$var$align(fn, lastData, newData, options);
        return [
            ...lastData
        ];
    };
    return compute;
};
// src/data/CloneFromFields.ts
var $2edc1eef02a7c199$export$12773f791ff2c9ff = (source)=>{
    const entries = [];
    for(const field2 in source){
        const value = source[field2];
        if ((0, $876c839e98abd7e2$export$70870f43c8775ec5)(value)) entries.push([
            field2,
            value
        ]);
    }
    return Object.fromEntries(entries);
};
// src/data/KeysToNumbers.ts
var $2edc1eef02a7c199$export$584a44cd196a41b0 = (object2, onInvalidKey = `throw`)=>{
    const returnObject = {};
    for (const entry of Object.entries(object2)){
        const asNumber = Number.parseInt(entry[0]);
        if (Number.isNaN(asNumber)) switch(onInvalidKey){
            case `throw`:
                throw new TypeError(`Cannot convert key '${entry[0]}' to an integer`);
            case `ignore`:
                continue;
            case `keep`:
                returnObject[entry[0]] = entry[1];
                continue;
            default:
                throw new Error(`Param 'onInvalidKey' should be: 'throw', 'ignore' or 'keep'.`);
        }
        returnObject[asNumber] = entry[1];
    }
    return returnObject;
};
// src/data/MapObject.ts
var $2edc1eef02a7c199$export$3e53a9d8791790c9 = (object2, mapFunction)=>{
    const entries = Object.entries(object2);
    const mapped = entries.map(([sourceField, sourceFieldValue], index)=>[
            sourceField,
            mapFunction({
                value: sourceFieldValue,
                field: sourceField,
                index: index,
                path: sourceField
            })
        ]);
    return Object.fromEntries(mapped);
};
function $2edc1eef02a7c199$export$147a81dbf84ee787(data, mapper) {
    const entries = Object.entries(data);
    for(let i = 0; i < entries.length; i++){
        const e = entries[i];
        if (e[0] in mapper) {
            const m = mapper[e[0]];
            e[1] = typeof m === `object` ? $2edc1eef02a7c199$export$147a81dbf84ee787(e[1], m) : m(e[1], data);
        }
    }
    return Object.fromEntries(entries);
}
// src/data/Pool.ts
var $2edc1eef02a7c199$export$a05827b0e03cef68 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$a05827b0e03cef68, {
    Pool: ()=>$2edc1eef02a7c199$var$Pool,
    PoolUser: ()=>$2edc1eef02a7c199$var$PoolUser,
    Resource: ()=>$2edc1eef02a7c199$var$Resource,
    create: ()=>$2edc1eef02a7c199$var$create
});
var $2edc1eef02a7c199$var$PoolUser = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    /**
   * Constructor
   * @param key User key
   * @param resource Resource being used
   */ //eslint-disable-next-line functional/prefer-immutable-types
    constructor(key, resource){
        super();
        this.key = key;
        this.resource = resource;
        this._lastUpdate = performance.now();
        this._pool = resource.pool;
        this._userExpireAfterMs = this._pool.userExpireAfterMs;
        this._state = `idle`;
        this._pool.log.log(`PoolUser ctor key: ${this.key}`);
    }
    /**
   * Returns a human readable debug string
   * @returns
   */ toString() {
        if (this.isDisposed) return `PoolUser. State: disposed`;
        return `PoolUser. State: ${this._state} Elapsed: ${performance.now() - this._lastUpdate} Data: ${JSON.stringify(this.resource.data)}`;
    }
    /**
   * Resets countdown for instance expiry.
   * Throws an error if instance is disposed.
   */ keepAlive() {
        if (this._state === `disposed`) throw new Error(`PoolItem disposed`);
        this._lastUpdate = performance.now();
    }
    /**
   * @internal
   * @param reason
   * @returns
   */ _dispose(reason, data) {
        if (this._state === `disposed`) return;
        const resource = this.resource;
        this._state = `disposed`;
        resource._release(this);
        this._pool.log.log(`PoolUser dispose key: ${this.key} reason: ${reason}`);
        this.fireEvent(`disposed`, {
            data: data,
            reason: reason
        });
        super.clearEventListeners();
    }
    /**
   * Release this instance
   * @param reason
   */ release(reason) {
        if (this.isDisposed) throw new Error(`User disposed`);
        const resource = this.resource;
        const data = resource.data;
        this._pool.log.log(`PoolUser release key: ${this.key} reason: ${reason}`);
        this.fireEvent(`released`, {
            data: data,
            reason: reason
        });
        this._dispose(`release-${reason}`, data);
    }
    // #region Properties
    get data() {
        if (this.isDisposed) throw new Error(`User disposed`);
        return this.resource.data;
    }
    /**
   * Returns true if this instance has expired.
   * Expiry counts if elapsed time is greater than `userExpireAfterMs`
   */ get isExpired() {
        if (this._userExpireAfterMs > 0) return performance.now() > this._lastUpdate + this._userExpireAfterMs;
        return false;
    }
    /**
   * Returns elapsed time since last 'update'
   */ get elapsed() {
        return performance.now() - this._lastUpdate;
    }
    /**
   * Returns true if instance is disposed
   */ get isDisposed() {
        return this._state === `disposed`;
    }
    /**
   * Returns true if instance is neither disposed nor expired
   */ get isValid() {
        if (this.isDisposed || this.isExpired) return false;
        if (this.resource.isDisposed) return false;
        return true;
    }
};
var $2edc1eef02a7c199$var$Resource = class {
    /**
   * Constructor.
   * @param pool Pool
   * @param data Data
   */ constructor(pool, data){
        this.pool = pool;
        if (data === void 0) throw new Error(`Parameter 'data' is undefined`);
        if (pool === void 0) throw new Error(`Parameter 'pool' is undefined`);
        this.#data = data;
        this.#lastUsersChange = 0;
        this.#resourcesWithoutUserExpireAfterMs = pool.resourcesWithoutUserExpireAfterMs;
        this.#capacityPerResource = pool.capacityPerResource;
        this.#users = [];
        this.#state = `idle`;
    }
    #state;
    #data;
    #users;
    #capacityPerResource;
    #resourcesWithoutUserExpireAfterMs;
    #lastUsersChange;
    /**
   * Gets data associated with resource.
   * Throws an error if disposed
   */ get data() {
        if (this.#state === `disposed`) throw new Error(`Resource disposed`);
        return this.#data;
    }
    /**
   * Changes the data associated with this resource.
   * Throws an error if disposed or `data` is undefined.
   * @param data
   */ updateData(data) {
        if (this.#state === `disposed`) throw new Error(`Resource disposed`);
        if (data === void 0) throw new Error(`Parameter 'data' is undefined`);
        this.#data = data;
    }
    /**
   * Returns a human-readable debug string for resource
   * @returns
   */ toString() {
        return `Resource (expired: ${this.isExpiredFromUsers} users: ${this.#users.length}, state: ${this.#state}) data: ${JSON.stringify(this.data)}`;
    }
    /**
   * Assigns a user to this resource.
   * @internal
   * @param user
   */ _assign(user) {
        const existing = this.#users.find((u)=>u === user || u.key === user.key);
        if (existing) throw new Error(`User instance already assigned to resource`);
        this.#users.push(user);
        this.#lastUsersChange = performance.now();
    }
    /**
   * Releases a user from this resource
   * @internal
   * @param user
   */ _release(user) {
        this.#users = this.#users.filter((u)=>u !== user);
        this.pool._release(user);
        this.#lastUsersChange = performance.now();
    }
    /**
   * Returns true if resource can have additional users allocated
   */ get hasUserCapacity() {
        return this.usersCount < this.#capacityPerResource;
    }
    /**
   * Returns number of uses of the resource
   */ get usersCount() {
        return this.#users.length;
    }
    /**
   * Returns true if automatic expiry is enabled, and that interval
   * has elapsed since the users list has changed for this resource
   */ get isExpiredFromUsers() {
        if (this.#resourcesWithoutUserExpireAfterMs <= 0) return false;
        if (this.#users.length > 0) return false;
        return performance.now() > this.#resourcesWithoutUserExpireAfterMs + this.#lastUsersChange;
    }
    /**
   * Returns true if instance is disposed
   */ get isDisposed() {
        return this.#state === `disposed`;
    }
    /**
   * Disposes the resource.
   * If it is already disposed, it does nothing.
   * @param reason
   * @returns
   */ dispose(reason) {
        if (this.#state === `disposed`) return;
        const data = this.#data;
        this.#state = `disposed`;
        this.pool.log.log(`Resource disposed (${reason})`);
        for (const u of this.#users)u._dispose(`resource-${reason}`, data);
        this.#users = [];
        this.#lastUsersChange = performance.now();
        this.pool._releaseResource(this, reason);
        if (this.pool.freeResource) this.pool.freeResource(data);
    }
};
var $2edc1eef02a7c199$var$Pool = class {
    /**
   * Constructor.
   *
   * By default, no capacity limit, one user per resource
   * @param options Pool options
   */ constructor(options = {}){
        this.capacity = options.capacity ?? -1;
        this.fullPolicy = options.fullPolicy ?? `error`;
        this.capacityPerResource = options.capacityPerResource ?? 1;
        this.userExpireAfterMs = options.userExpireAfterMs ?? -1;
        this.resourcesWithoutUserExpireAfterMs = options.resourcesWithoutUserExpireAfterMs ?? -1;
        this.generateResource = options.generate;
        this.freeResource = options.free;
        this._users = /* @__PURE__ */ new Map();
        this._resources = [];
        this.log = (0, $c40eb93fec8b01a3$export$84ef0e73991701e2)(`Pool`, options.debug ?? false);
        const timer = Math.max(this.userExpireAfterMs, this.resourcesWithoutUserExpireAfterMs);
        if (timer > 0) setInterval(()=>{
            this.maintain();
        }, timer * 1.1);
    }
    /**
   * Returns a debug string of Pool state
   * @returns
   */ dumpToString() {
        let r = `Pool
    capacity: ${this.capacity} userExpireAfterMs: ${this.userExpireAfterMs} capacityPerResource: ${this.capacityPerResource}
    resources count: ${this._resources.length}`;
        const resource = this._resources.map((r2)=>r2.toString()).join(`\r
	`);
        r += `\r
Resources:\r
	` + resource;
        r += `\r
Users: \r
`;
        for (const [k, v] of this._users.entries())r += `	k: ${k} v: ${v.toString()}\r
`;
        return r;
    }
    /**
   * Sorts users by longest elapsed time since update
   * @returns
   */ getUsersByLongestElapsed() {
        return [
            ...this._users.values()
        ].sort((a, b)=>{
            const aa = a.elapsed;
            const bb = b.elapsed;
            if (aa === bb) return 0;
            if (aa < bb) return 1;
            return -1;
        });
    }
    /**
   * Returns resources sorted with least used first
   * @returns
   */ getResourcesSortedByUse() {
        return [
            ...this._resources
        ].sort((a, b)=>{
            if (a.usersCount === b.usersCount) return 0;
            if (a.usersCount < b.usersCount) return -1;
            return 1;
        });
    }
    /**
   * Adds a shared resource to the pool
   * @throws Error if the capacity limit is reached or resource is null
   * @param resource
   * @returns
   */ addResource(resource) {
        if (resource === void 0) throw new Error(`Cannot add undefined resource`);
        if (resource === null) throw new TypeError(`Cannot add null resource`);
        if (this.capacity > 0 && this._resources.length === this.capacity) throw new Error(`Capacity limit (${this.capacity}) reached. Cannot add more.`);
        this.log.log(`Adding resource: ${JSON.stringify(resource)}`);
        const pi4 = new $2edc1eef02a7c199$var$Resource(this, resource);
        this._resources.push(pi4);
        return pi4;
    }
    /**
   * Performs maintenance, removing disposed/expired resources & users.
   * This is called automatically when using a resource.
   */ maintain() {
        let changed = false;
        const nuke = [];
        for (const p of this._resources){
            if (p.isDisposed) {
                this.log.log(`Maintain, disposed resource: ${JSON.stringify(p.data)}`);
                nuke.push(p);
            } else if (p.isExpiredFromUsers) {
                this.log.log(`Maintain, expired resource: ${JSON.stringify(p.data)}`);
                nuke.push(p);
            }
        }
        if (nuke.length > 0) {
            for (const resource of nuke)resource.dispose(`diposed/expired`);
            changed = true;
        }
        const userKeysToRemove = [];
        for (const [key, user] of this._users.entries())if (!user.isValid) {
            this.log.log(`Maintain. Invalid user: ${user.key} (Disposed: ${user.isDisposed} Expired: ${user.isExpired} Resource disposed: ${user.resource.isDisposed})`);
            userKeysToRemove.push(key);
            user._dispose(`invalid`, user.data);
        }
        for (const userKey of userKeysToRemove){
            this._users.delete(userKey);
            changed = true;
        }
        if (changed) this.log.log(`End: resource len: ${this._resources.length} users: ${this.usersLength}`);
    }
    /**
   * Iterate over resources in the pool.
   * To iterate over the data associated with each resource, use
   * `values`.
   */ *resources() {
        const resource = [
            ...this._resources
        ];
        for (const r of resource)yield r;
    }
    /**
   * Iterate over resource values in the pool.
   * to iterate over the resources, use `resources`.
   *
   * Note that values may be returned even though there is no
   * active user.
   */ *values() {
        const resource = [
            ...this._resources
        ];
        for (const r of resource)yield r.data;
    }
    /**
   * Unassociate a key with a pool item
   * @param userKey
   */ release(userKey, reason) {
        const pi4 = this._users.get(userKey);
        if (!pi4) return;
        pi4.release(reason ?? `Pool.release`);
    }
    /**
   * @internal
   * @param user
   */ //eslint-disable-next-line functional/prefer-immutable-types
    _release(user) {
        this._users.delete(user.key);
    }
    /**
   * @internal
   * @param resource
   * @param _
   */ //eslint-disable-next-line functional/prefer-immutable-types
    _releaseResource(resource, _) {
        this._resources = this._resources.filter((v)=>v !== resource);
    }
    /**
   * Returns true if `v` has an associted resource in the pool
   * @param resource
   * @returns
   */ hasResource(resource) {
        const found = this._resources.find((v)=>v.data === resource);
        return found !== void 0;
    }
    /**
   * Returns true if a given `userKey` is in use.
   * @param userKey
   * @returns
   */ hasUser(userKey) {
        return this._users.has(userKey);
    }
    /**
   * @internal
   * @param key
   * @param resource
   * @returns
   */ //eslint-disable-next-line functional/prefer-immutable-types
    _assign(key, resource) {
        const u = new $2edc1eef02a7c199$var$PoolUser(key, resource);
        this._users.set(key, u);
        resource._assign(u);
        return u;
    }
    /**
   * Allocates a resource for `userKey`
   * @internal
   * @param userKey
   * @returns
   */ #allocateResource(userKey) {
        const sorted = this.getResourcesSortedByUse();
        if (sorted.length > 0 && sorted[0].hasUserCapacity) {
            const u = this._assign(userKey, sorted[0]);
            return u;
        }
        if (this.generateResource && (this.capacity < 0 || this._resources.length < this.capacity)) {
            this.log.log(`capacity: ${this.capacity} resources: ${this._resources.length}`);
            const resourceGenerated = this.addResource(this.generateResource());
            const u = this._assign(userKey, resourceGenerated);
            return u;
        }
    }
    /**
   * Return the number of users
   */ get usersLength() {
        return [
            ...this._users.values()
        ].length;
    }
    /**
   * 'Uses' a resource, returning the value
   * @param userKey
   * @returns
   */ useValue(userKey) {
        const resource = this.use(userKey);
        return resource.resource.data;
    }
    /**
   * Gets a pool item based on a 'user' key.
   * 
   * The same key should return the same pool item,
   * for as long as it still exists.
   * 
   * If a 'user' already has a resource, it will 'keep alive' their use.
   * If a 'user' does not already have resource
   *  - if there is capacity, a resource is allocated to user
   *  - if pool is full
   *    - fullPolicy = 'error': an error is thrown
   *    - fullPolicy = 'evictOldestUser': evicts an older user
   *    - Throw error
   * @param userKey
   * @throws Error If all resources are used and fullPolicy = 'error'
   * @returns
   */ use(userKey) {
        const pi4 = this._users.get(userKey);
        if (pi4) {
            pi4.keepAlive();
            return pi4;
        }
        this.maintain();
        const match = this.#allocateResource(userKey);
        if (match) return match;
        if (this.fullPolicy === `error`) throw new Error(`Pool is fully used (fullPolicy: ${this.fullPolicy}, capacity: ${this.capacity})`);
        if (this.fullPolicy === `evictOldestUser`) {
            const users = this.getUsersByLongestElapsed();
            if (users.length > 0) {
                this.release(users[0].key, `evictedOldestUser`);
                const match2 = this.#allocateResource(userKey);
                if (match2) return match2;
            }
        }
        throw new Error(`Pool is fully used (${this.fullPolicy})`);
    }
};
var $2edc1eef02a7c199$var$create = (options = {})=>new $2edc1eef02a7c199$var$Pool(options);
// src/data/Process.ts
var $2edc1eef02a7c199$export$b10e2093dd734b61 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$b10e2093dd734b61, {
    CancelError: ()=>$2edc1eef02a7c199$var$CancelError,
    average: ()=>$2edc1eef02a7c199$export$cc6710ee5f037d57,
    cancelIfUndefined: ()=>$2edc1eef02a7c199$var$cancelIfUndefined,
    flow: ()=>$2edc1eef02a7c199$var$flow,
    ifNotUndefined: ()=>$2edc1eef02a7c199$var$ifNotUndefined,
    ifUndefined: ()=>$2edc1eef02a7c199$var$ifUndefined,
    max: ()=>$2edc1eef02a7c199$export$8960430cfd85939f,
    min: ()=>$2edc1eef02a7c199$export$96ec731ed4dcb222,
    rank: ()=>$2edc1eef02a7c199$export$fbc8bcd33b574fbc,
    seenLastToUndefined: ()=>$2edc1eef02a7c199$var$seenLastToUndefined,
    seenToUndefined: ()=>$2edc1eef02a7c199$var$seenToUndefined,
    seenToUndefinedByKey: ()=>$2edc1eef02a7c199$var$seenToUndefinedByKey,
    sum: ()=>$2edc1eef02a7c199$export$8a63f25cc62965f1,
    tally: ()=>$2edc1eef02a7c199$export$344c33cac828114d
});
// src/data/BasicProcessors.ts
var $2edc1eef02a7c199$export$8960430cfd85939f = ()=>{
    let max5 = Number.MIN_SAFE_INTEGER;
    const compute = (value)=>{
        const valueArray = Array.isArray(value) ? value : [
            value
        ];
        for (const subValue of valueArray){
            if (typeof subValue !== `number`) break;
            max5 = Math.max(subValue, max5);
        }
        return max5;
    };
    return compute;
};
var $2edc1eef02a7c199$export$96ec731ed4dcb222 = ()=>{
    let min6 = Number.MAX_SAFE_INTEGER;
    const compute = (value)=>{
        const valueArray = Array.isArray(value) ? value : [
            value
        ];
        for (const subValue of valueArray){
            if (typeof subValue !== `number`) break;
            min6 = Math.min(subValue, min6);
        }
        return min6;
    };
    return compute;
};
var $2edc1eef02a7c199$export$8a63f25cc62965f1 = ()=>{
    let t2 = 0;
    const compute = (value)=>{
        const valueArray = Array.isArray(value) ? value : [
            value
        ];
        for (const subValue of valueArray){
            if (typeof subValue !== `number`) continue;
            t2 += subValue;
        }
        return t2;
    };
    return compute;
};
var $2edc1eef02a7c199$export$cc6710ee5f037d57 = ()=>{
    let total = 0;
    let tally3 = 0;
    const compute = (value)=>{
        const valueArray = Array.isArray(value) ? value : [
            value
        ];
        for (const subValue of valueArray){
            if (typeof subValue !== `number`) continue;
            tally3++;
            total += subValue;
        }
        return total / tally3;
    };
    return compute;
};
var $2edc1eef02a7c199$export$344c33cac828114d = (countArrayItems)=>{
    let t2 = 0;
    const compute = (value)=>{
        if (countArrayItems) {
            if (Array.isArray(value)) t2 += value.length;
            else t2++;
        } else t2++;
        return t2;
    };
    return compute;
};
function $2edc1eef02a7c199$export$fbc8bcd33b574fbc(r, options = {}) {
    const includeType = options.includeType;
    const emitEqualRanked = options.emitEqualRanked ?? false;
    const emitRepeatHighest = options.emitRepeatHighest ?? false;
    let best;
    return (value)=>{
        if (includeType && typeof value !== includeType) return;
        if (best === void 0) {
            best = value;
            return best;
        } else {
            const result = r(value, best);
            if (result == `a`) {
                best = value;
                return best;
            } else if (result === `eq` && emitEqualRanked) return best;
            else if (emitRepeatHighest) return best;
        }
    };
}
// src/data/Process.ts
function $2edc1eef02a7c199$var$flow(...processors) {
    return (value)=>{
        let v = value;
        for (const p of processors)try {
            v = p(v);
        } catch (err) {
            if (err instanceof $2edc1eef02a7c199$var$CancelError) break;
            else throw err;
        }
        return v;
    };
}
function $2edc1eef02a7c199$var$seenLastToUndefined(eq) {
    if (eq === void 0) eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b);
    let lastValue;
    return (value)=>{
        if (value !== lastValue) {
            lastValue = value;
            return value;
        }
        return void 0;
    };
}
function $2edc1eef02a7c199$var$seenToUndefined(eq) {
    let seen = [];
    if (eq === void 0) eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b);
    return (value)=>{
        if (value === void 0) return;
        for (const s of seen){
            if (eq(s, value)) return;
        }
        seen.push(value);
        return value;
    };
}
function $2edc1eef02a7c199$var$seenToUndefinedByKey(toString3) {
    let seen = /* @__PURE__ */ new Set();
    if (toString3 === void 0) toString3 = (0, $847987b26b102cb8$export$f5a6f2033c1996c8);
    return (value)=>{
        if (value === void 0) return;
        const key = toString3(value);
        if (seen.has(key)) return;
        seen.add(key);
        return value;
    };
}
function $2edc1eef02a7c199$var$ifNotUndefined(fn) {
    return (value)=>{
        if (value === void 0) return value;
        const v = fn(value);
        return v;
    };
}
var $2edc1eef02a7c199$var$CancelError = class extends Error {
    constructor(message){
        super(message);
        this.name = `CancelError`;
    }
};
function $2edc1eef02a7c199$var$cancelIfUndefined() {
    return (value)=>{
        if (value === void 0) throw new $2edc1eef02a7c199$var$CancelError(`cancel`);
        return value;
    };
}
function $2edc1eef02a7c199$var$ifUndefined(fn) {
    return (value)=>{
        if (value === void 0) return fn();
        else return value;
    };
}
// src/data/ResolveFields.ts
async function $2edc1eef02a7c199$export$b340e91215f77267(object2) {
    const resolvers = [];
    const keys = [];
    for (const entry of Object.entries(object2)){
        const resolvable = entry[1];
        resolvers.push((0, $f53657e65b61d2bb$export$f7ad0328861e2f03)(resolvable));
        keys.push(entry[0]);
    }
    const results = await Promise.all(resolvers);
    const entries = (0, $b63753f448317b08$export$8901015135f2fb22)(keys, results);
    return Object.fromEntries(entries);
}
function $2edc1eef02a7c199$export$81d9cacab5d762c0(object2) {
    const entries = [];
    for (const entry of Object.entries(object2)){
        const resolvable = entry[1];
        const value = (0, $f53657e65b61d2bb$export$90bb0c3a0ef8b4ca)(resolvable);
        entries.push([
            entry[0],
            value
        ]);
    }
    return Object.fromEntries(entries);
}
// src/data/maps/index.ts
var $2edc1eef02a7c199$export$a1f53b853226be71 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$a1f53b853226be71, {
    addKeepingExisting: ()=>(0, $3ffa4b3bf3c5db47$export$702daf3d1fbfead1),
    addObject: ()=>(0, $3ffa4b3bf3c5db47$export$3526b99afee61ae2),
    deleteByValue: ()=>(0, $3ffa4b3bf3c5db47$export$78990a8040ea3609),
    filter: ()=>(0, $3ffa4b3bf3c5db47$export$3dea766d36a8935f),
    find: ()=>(0, $3ffa4b3bf3c5db47$export$71aa6c912b956294),
    firstEntryByPredicate: ()=>(0, $3ffa4b3bf3c5db47$export$43f098bb06003dcd),
    firstEntryByValue: ()=>(0, $3ffa4b3bf3c5db47$export$bfe2e9bd3ffe559f),
    fromIterable: ()=>(0, $3ffa4b3bf3c5db47$export$dcccc29c315dd646),
    fromObject: ()=>(0, $3ffa4b3bf3c5db47$export$9144c32b59cbaec4),
    getClosestIntegerKey: ()=>(0, $3ffa4b3bf3c5db47$export$b9b5c2c805112ed2),
    getFromKeys: ()=>(0, $3ffa4b3bf3c5db47$export$d9154ce654446643),
    getOrGenerate: ()=>(0, $c40eb93fec8b01a3$export$8f4691274895b97),
    getOrGenerateSync: ()=>(0, $c40eb93fec8b01a3$export$49f01f9c43a27799),
    hasAnyValue: ()=>(0, $3ffa4b3bf3c5db47$export$d12a2b6ab14817dd),
    hasKeyValue: ()=>(0, $3ffa4b3bf3c5db47$export$4883817542665016),
    mapToArray: ()=>(0, $3ffa4b3bf3c5db47$export$c24a744d5dd88a3b),
    mapToObjectTransform: ()=>(0, $3ffa4b3bf3c5db47$export$29ddc7b84ebfc668),
    mergeByKey: ()=>(0, $3ffa4b3bf3c5db47$export$5848149affbf5a72),
    some: ()=>(0, $3ffa4b3bf3c5db47$export$ad14ef4001db2bcd),
    sortByValue: ()=>(0, $3ffa4b3bf3c5db47$export$6391cb5d0ad73621),
    sortByValueProperty: ()=>(0, $3ffa4b3bf3c5db47$export$96a66db6d6b0113),
    toArray: ()=>(0, $3ffa4b3bf3c5db47$export$45b10814cc054894),
    toObject: ()=>(0, $3ffa4b3bf3c5db47$export$697e4a1b90752ce2),
    transformMap: ()=>(0, $3ffa4b3bf3c5db47$export$5f7754d40b4c8f37),
    zipKeyValue: ()=>(0, $3ffa4b3bf3c5db47$export$c2d6f401933fc426)
});
// src/data/index.ts
var $2edc1eef02a7c199$export$bd2071c7829e2c8f = Math.PI * 2;
// src/geometry/Angles.ts
function $2edc1eef02a7c199$export$4f2c4f194778dcbb(angleInDegrees) {
    return Array.isArray(angleInDegrees) ? angleInDegrees.map((v)=>v * (Math.PI / 180)) : angleInDegrees * (Math.PI / 180);
}
function $2edc1eef02a7c199$export$57ad4b75fcab2ed3(angleInRadians) {
    return (angleInRadians + Math.PI) % (2 * Math.PI);
}
function $2edc1eef02a7c199$export$1c20e104e3e29a0a(angleInRadians) {
    return Array.isArray(angleInRadians) ? angleInRadians.map((v)=>v * 180 / Math.PI) : angleInRadians * 180 / Math.PI;
}
var $2edc1eef02a7c199$export$425ef84e46bc63f9 = (point)=>Math.atan2(point.x, point.y);
var $2edc1eef02a7c199$export$781dc0a0f963c01e = (start, amount, clockwise = true)=>{
    if (clockwise) {
        let x = start + amount;
        if (x >= $2edc1eef02a7c199$export$bd2071c7829e2c8f) x = x % $2edc1eef02a7c199$export$bd2071c7829e2c8f;
        return x;
    } else {
        const x = start - amount;
        if (x < 0) return $2edc1eef02a7c199$export$bd2071c7829e2c8f + x;
        return x;
    }
};
var $2edc1eef02a7c199$export$bf711920567cfd9 = (start, amount, clockwise = true)=>$2edc1eef02a7c199$export$1c20e104e3e29a0a($2edc1eef02a7c199$export$781dc0a0f963c01e($2edc1eef02a7c199$export$4f2c4f194778dcbb(start), $2edc1eef02a7c199$export$4f2c4f194778dcbb(amount), clockwise));
var $2edc1eef02a7c199$export$cfbb66a3a90db1a8 = (start, end, clockwise = true)=>{
    let s = start;
    if (end < s) {
        s = 0;
        end = $2edc1eef02a7c199$export$bd2071c7829e2c8f - start + end;
    }
    let d = end - s;
    if (clockwise) d = $2edc1eef02a7c199$export$bd2071c7829e2c8f - d;
    if (d >= $2edc1eef02a7c199$export$bd2071c7829e2c8f) return d % $2edc1eef02a7c199$export$bd2071c7829e2c8f;
    return d;
};
var $2edc1eef02a7c199$export$2b1e3480567b14b8 = (start, end, clockwise = true)=>$2edc1eef02a7c199$export$1c20e104e3e29a0a($2edc1eef02a7c199$export$cfbb66a3a90db1a8($2edc1eef02a7c199$export$4f2c4f194778dcbb(start), $2edc1eef02a7c199$export$4f2c4f194778dcbb(end), clockwise));
// src/geometry/Polar.ts
var $2edc1eef02a7c199$var$EmptyCartesian = Object.freeze({
    x: 0,
    y: 0
});
var $2edc1eef02a7c199$export$9517f709836def0c = (p)=>{
    if (p.distance === void 0) return false;
    if (p.angleRadian === void 0) return false;
    return true;
};
var $2edc1eef02a7c199$export$42bfa0bfc1a1a94 = (point, origin)=>{
    point = $2edc1eef02a7c199$export$4e2d2ead65e5f7e3(point, origin);
    const angle = Math.atan2(point.y, point.x);
    return Object.freeze({
        ...point,
        angleRadian: angle,
        distance: Math.hypot(point.x, point.y)
    });
};
var $2edc1eef02a7c199$export$24440bbdd34c95b6 = (a, b, c)=>{
    if ($2edc1eef02a7c199$export$9517f709836def0c(a)) {
        if (b === void 0) b = $2edc1eef02a7c199$export$1f74963c34e8bfec;
        if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b)) return $2edc1eef02a7c199$var$polarToCartesian(a.distance, a.angleRadian, b);
        throw new Error(`Expecting (Coord, Point). Second parameter is not a point`);
    } else if (typeof a === `object`) throw new TypeError(`First param is an object, but not a Coord: ${JSON.stringify(a)}`);
    else {
        if (typeof a === `number` && typeof b === `number`) {
            if (c === void 0) c = $2edc1eef02a7c199$export$1f74963c34e8bfec;
            if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(c)) throw new Error(`Expecting (number, number, Point). Point param wrong type`);
            return $2edc1eef02a7c199$var$polarToCartesian(a, b, c);
        } else throw new TypeError(`Expecting parameters of (number, number). Got: (${typeof a}, ${typeof b}, ${typeof c}). a: ${JSON.stringify(a)}`);
    }
};
function* $2edc1eef02a7c199$var$spiral(smoothness, zoom) {
    let step = 0;
    while(true){
        const a = smoothness * step++;
        yield {
            distance: zoom * a,
            angleRadian: a,
            step: step
        };
    }
}
var $2edc1eef02a7c199$var$rotate = (c, amountRadian)=>Object.freeze({
        ...c,
        angleRadian: c.angleRadian + amountRadian
    });
var $2edc1eef02a7c199$export$d07f4a5006fe85de = (c)=>{
    if (c.distance === 0) throw new Error(`Cannot normalise vector of length 0`);
    return Object.freeze({
        ...c,
        distance: 1
    });
};
var $2edc1eef02a7c199$var$guard6 = (p, name = `Point`)=>{
    if (p === void 0) throw new Error(`'${name}' is undefined. Expected {distance, angleRadian} got ${JSON.stringify(p)}`);
    if (p === null) throw new Error(`'${name}' is null. Expected {distance, angleRadian} got ${JSON.stringify(p)}`);
    if (p.angleRadian === void 0) throw new Error(`'${name}.angleRadian' is undefined. Expected {distance, angleRadian} got ${JSON.stringify(p)}`);
    if (p.distance === void 0) throw new Error(`'${name}.distance' is undefined. Expected {distance, angleRadian} got ${JSON.stringify(p)}`);
    if (typeof p.angleRadian !== `number`) throw new TypeError(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `'${name}.angleRadian' must be a number. Got ${p.angleRadian}`);
    if (typeof p.distance !== `number`) throw new TypeError(`'${name}.distance' must be a number. Got ${p.distance}`);
    if (p.angleRadian === null) throw new Error(`'${name}.angleRadian' is null`);
    if (p.distance === null) throw new Error(`'${name}.distance' is null`);
    if (Number.isNaN(p.angleRadian)) throw new TypeError(`'${name}.angleRadian' is NaN`);
    if (Number.isNaN(p.distance)) throw new Error(`'${name}.distance' is NaN`);
};
var $2edc1eef02a7c199$export$cb831202f517eedd = (a, b)=>{
    $2edc1eef02a7c199$var$guard6(a, `a`);
    $2edc1eef02a7c199$var$guard6(b, `b`);
    return a.distance * b.distance * Math.cos(b.angleRadian - a.angleRadian);
};
var $2edc1eef02a7c199$var$invert2 = (p)=>{
    $2edc1eef02a7c199$var$guard6(p, `c`);
    return Object.freeze({
        ...p,
        angleRadian: p.angleRadian - Math.PI
    });
};
var $2edc1eef02a7c199$var$isOpposite = (a, b)=>{
    $2edc1eef02a7c199$var$guard6(a, `a`);
    $2edc1eef02a7c199$var$guard6(b, `b`);
    if (a.distance !== b.distance) return false;
    return a.angleRadian === -b.angleRadian;
};
var $2edc1eef02a7c199$var$isParallel = (a, b)=>{
    $2edc1eef02a7c199$var$guard6(a, `a`);
    $2edc1eef02a7c199$var$guard6(b, `b`);
    return a.angleRadian === b.angleRadian;
};
var $2edc1eef02a7c199$var$isAntiParallel = (a, b)=>{
    $2edc1eef02a7c199$var$guard6(a, `a`);
    $2edc1eef02a7c199$var$guard6(b, `b`);
    return a.angleRadian === -b.angleRadian;
};
var $2edc1eef02a7c199$var$rotateDegrees = (c, amountDeg)=>Object.freeze({
        ...c,
        angleRadian: c.angleRadian + $2edc1eef02a7c199$export$4f2c4f194778dcbb(amountDeg)
    });
var $2edc1eef02a7c199$var$spiralRaw = (step, smoothness, zoom)=>{
    const a = smoothness * step;
    return Object.freeze({
        distance: zoom * a,
        angleRadian: a
    });
};
var $2edc1eef02a7c199$var$multiply2 = (v, amt)=>{
    $2edc1eef02a7c199$var$guard6(v);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(amt, ``, `amt`);
    return Object.freeze({
        ...v,
        distance: v.distance * amt
    });
};
var $2edc1eef02a7c199$var$divide2 = (v, amt)=>{
    $2edc1eef02a7c199$var$guard6(v);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(amt, ``, `amt`);
    return Object.freeze({
        ...v,
        distance: v.distance / amt
    });
};
var $2edc1eef02a7c199$export$ca9febc7c1cba526 = (v, max5 = 1, min6 = 0)=>{
    let mag = v.distance;
    if (mag > max5) mag = max5;
    if (mag < min6) mag = min6;
    return Object.freeze({
        ...v,
        distance: mag
    });
};
var $2edc1eef02a7c199$var$polarToCartesian = (distance3, angleRadians, origin = $2edc1eef02a7c199$export$1f74963c34e8bfec)=>{
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(origin);
    return Object.freeze({
        x: origin.x + distance3 * Math.cos(angleRadians),
        y: origin.y + distance3 * Math.sin(angleRadians)
    });
};
var $2edc1eef02a7c199$export$f84e8e69fd4488a5 = (p, digits)=>{
    if (p === void 0) return `(undefined)`;
    if (p === null) return `(null)`;
    const angleDeg = $2edc1eef02a7c199$export$1c20e104e3e29a0a(p.angleRadian);
    const d = digits ? p.distance.toFixed(digits) : p.distance;
    const a = digits ? angleDeg.toFixed(digits) : angleDeg;
    return `(${d},${a})`;
};
var $2edc1eef02a7c199$export$b63cca88ddc558a9 = (v, origin = $2edc1eef02a7c199$var$EmptyCartesian)=>{
    $2edc1eef02a7c199$var$guard6(v, `v`);
    return Object.freeze({
        x: origin.x + v.distance * Math.cos(v.angleRadian),
        y: origin.y + v.distance * Math.sin(v.angleRadian)
    });
};
// src/geometry/point/Rotate.ts
function $2edc1eef02a7c199$export$bb628a54ab399bc9(pt, amountRadian, origin) {
    if (origin === void 0) origin = {
        x: 0,
        y: 0
    };
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(origin, `origin`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(amountRadian, ``, `amountRadian`);
    const arrayInput = Array.isArray(pt);
    if (amountRadian === 0) return pt;
    if (!arrayInput) pt = [
        pt
    ];
    const ptAr = pt;
    for (const [index, p] of ptAr.entries())(0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(p, `pt[${index}]`);
    const asPolar = ptAr.map((p)=>$2edc1eef02a7c199$export$42bfa0bfc1a1a94(p, origin));
    const rotated = asPolar.map((p)=>$2edc1eef02a7c199$var$rotate(p, amountRadian));
    const asCartesisan = rotated.map((p)=>$2edc1eef02a7c199$export$24440bbdd34c95b6(p, origin));
    return arrayInput ? asCartesisan : asCartesisan[0];
}
// src/geometry/point/RotatePointArray.ts
var $2edc1eef02a7c199$var$rotatePointArray = (v, amountRadian)=>{
    const mat = [
        [
            Math.cos(amountRadian),
            -Math.sin(amountRadian)
        ],
        [
            Math.sin(amountRadian),
            Math.cos(amountRadian)
        ]
    ];
    const result = [];
    for (const [index, element] of v.entries())result[index] = [
        mat[0][0] * element[0] + mat[0][1] * element[1],
        mat[1][0] * element[0] + mat[1][1] * element[1]
    ];
    return result;
};
// src/geometry/point/Round.ts
var $2edc1eef02a7c199$var$round2 = (ptOrX, yOrDigits, digits)=>{
    const pt = $2edc1eef02a7c199$export$fe216fb4d5cb9144(ptOrX, yOrDigits);
    digits = digits ?? yOrDigits;
    digits = digits ?? 2;
    return Object.freeze({
        ...pt,
        x: (0, $42f472314cb088f7$export$2077e0241d6afd3c)(digits, pt.x),
        y: (0, $42f472314cb088f7$export$2077e0241d6afd3c)(digits, pt.y)
    });
};
// src/geometry/point/To.ts
var $2edc1eef02a7c199$var$toIntegerValues = (pt, rounder = Math.round)=>{
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `pt`);
    return Object.freeze({
        x: rounder(pt.x),
        y: rounder(pt.y)
    });
};
var $2edc1eef02a7c199$var$to2d = (pt)=>{
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `pt`);
    let copy = {
        ...pt
    };
    delete copy.z;
    return Object.freeze(copy);
};
var $2edc1eef02a7c199$var$to3d = (pt, z = 0)=>{
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `pt`);
    return Object.freeze({
        ...pt,
        z: z
    });
};
function $2edc1eef02a7c199$export$eaaba333dd67ec2a(p, digits) {
    if (p === void 0) return `(undefined)`;
    if (p === null) return `(null)`;
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(p, `pt`);
    const x = digits ? p.x.toFixed(digits) : p.x;
    const y = digits ? p.y.toFixed(digits) : p.y;
    if (p.z === void 0) return `(${x},${y})`;
    else {
        const z = digits ? p.z.toFixed(digits) : p.z;
        return `(${x},${y},${z})`;
    }
}
// src/geometry/point/WithinRange.ts
var $2edc1eef02a7c199$var$withinRange = (a, b, maxRange)=>{
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(a, `a`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(b, `b`);
    if (typeof maxRange === `number`) {
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(maxRange, `positive`, `maxRange`);
        maxRange = {
            x: maxRange,
            y: maxRange
        };
    } else (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(maxRange, `maxRange`);
    const x = Math.abs(b.x - a.x);
    const y = Math.abs(b.y - a.y);
    return x <= maxRange.x && y <= maxRange.y;
};
// src/geometry/point/Wrap.ts
var $2edc1eef02a7c199$var$wrap2 = (pt, ptMax, ptMin)=>{
    if (ptMax === void 0) ptMax = {
        x: 1,
        y: 1
    };
    if (ptMin === void 0) ptMin = {
        x: 0,
        y: 0
    };
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `pt`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptMax, `ptMax`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(ptMin, `ptMin`);
    return Object.freeze({
        x: $2edc1eef02a7c199$export$4997ffc0176396a6(pt.x, ptMin.x, ptMax.x),
        y: $2edc1eef02a7c199$export$4997ffc0176396a6(pt.y, ptMin.y, ptMax.y)
    });
};
// src/geometry/bezier/index.ts
var $2edc1eef02a7c199$export$2219b47b432bbc78 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$2219b47b432bbc78, {
    cubic: ()=>$2edc1eef02a7c199$var$cubic,
    interpolator: ()=>$2edc1eef02a7c199$var$interpolator,
    isCubicBezier: ()=>$2edc1eef02a7c199$export$77290801a62f77a2,
    isQuadraticBezier: ()=>$2edc1eef02a7c199$export$9e33c9da719c393,
    quadratic: ()=>$2edc1eef02a7c199$var$quadratic,
    quadraticSimple: ()=>$2edc1eef02a7c199$export$b1e639a4c61456b1,
    quadraticToSvgString: ()=>$2edc1eef02a7c199$var$quadraticToSvgString,
    toPath: ()=>$2edc1eef02a7c199$export$440836a238ff8548
});
// node_modules/bezier-js/src/utils.js
var { abs: $2edc1eef02a7c199$var$abs2, cos: $2edc1eef02a7c199$var$cos2, sin: $2edc1eef02a7c199$var$sin2, acos: $2edc1eef02a7c199$var$acos, atan2: $2edc1eef02a7c199$var$atan2, sqrt: $2edc1eef02a7c199$var$sqrt2, pow: $2edc1eef02a7c199$var$pow3 } = Math;
function $2edc1eef02a7c199$var$crt(v) {
    return v < 0 ? -$2edc1eef02a7c199$var$pow3(-v, 1 / 3) : $2edc1eef02a7c199$var$pow3(v, 1 / 3);
}
var $2edc1eef02a7c199$var$pi2 = Math.PI;
var $2edc1eef02a7c199$var$tau = 2 * $2edc1eef02a7c199$var$pi2;
var $2edc1eef02a7c199$var$quart = $2edc1eef02a7c199$var$pi2 / 2;
var $2edc1eef02a7c199$var$epsilon = 1e-6;
var $2edc1eef02a7c199$var$nMax = Number.MAX_SAFE_INTEGER || 9007199254740991;
var $2edc1eef02a7c199$var$nMin = Number.MIN_SAFE_INTEGER || -9007199254740991;
var $2edc1eef02a7c199$var$ZERO = {
    x: 0,
    y: 0,
    z: 0
};
var $2edc1eef02a7c199$var$utils = {
    // Legendre-Gauss abscissae with n=24 (x_i values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
    Tvalues: [
        -0.06405689286260563,
        0.06405689286260563,
        -0.1911188674736163,
        0.1911188674736163,
        -0.3150426796961634,
        0.3150426796961634,
        -0.4337935076260451,
        0.4337935076260451,
        -0.5454214713888396,
        0.5454214713888396,
        -0.6480936519369755,
        0.6480936519369755,
        -0.7401241915785544,
        0.7401241915785544,
        -0.820001985973903,
        0.820001985973903,
        -0.8864155270044011,
        0.8864155270044011,
        -0.9382745520027328,
        0.9382745520027328,
        -0.9747285559713095,
        0.9747285559713095,
        -0.9951872199970213,
        0.9951872199970213
    ],
    // Legendre-Gauss weights with n=24 (w_i values, defined by a function linked to in the Bezier primer article)
    Cvalues: [
        0.12793819534675216,
        0.12793819534675216,
        0.1258374563468283,
        0.1258374563468283,
        0.12167047292780339,
        0.12167047292780339,
        0.1155056680537256,
        0.1155056680537256,
        0.10744427011596563,
        0.10744427011596563,
        0.09761865210411388,
        0.09761865210411388,
        0.08619016153195327,
        0.08619016153195327,
        0.0733464814110803,
        0.0733464814110803,
        0.05929858491543678,
        0.05929858491543678,
        0.04427743881741981,
        0.04427743881741981,
        0.028531388628933663,
        0.028531388628933663,
        0.0123412297999872,
        0.0123412297999872
    ],
    arcfn: function(t2, derivativeFn) {
        const d = derivativeFn(t2);
        let l = d.x * d.x + d.y * d.y;
        if (typeof d.z !== "undefined") l += d.z * d.z;
        return $2edc1eef02a7c199$var$sqrt2(l);
    },
    compute: function(t2, points, _3d) {
        if (t2 === 0) {
            points[0].t = 0;
            return points[0];
        }
        const order = points.length - 1;
        if (t2 === 1) {
            points[order].t = 1;
            return points[order];
        }
        const mt = 1 - t2;
        let p = points;
        if (order === 0) {
            points[0].t = t2;
            return points[0];
        }
        if (order === 1) {
            const ret = {
                x: mt * p[0].x + t2 * p[1].x,
                y: mt * p[0].y + t2 * p[1].y,
                t: t2
            };
            if (_3d) ret.z = mt * p[0].z + t2 * p[1].z;
            return ret;
        }
        if (order < 4) {
            let mt2 = mt * mt, t22 = t2 * t2, a, b, c, d = 0;
            if (order === 2) {
                p = [
                    p[0],
                    p[1],
                    p[2],
                    $2edc1eef02a7c199$var$ZERO
                ];
                a = mt2;
                b = mt * t2 * 2;
                c = t22;
            } else if (order === 3) {
                a = mt2 * mt;
                b = mt2 * t2 * 3;
                c = mt * t22 * 3;
                d = t2 * t22;
            }
            const ret = {
                x: a * p[0].x + b * p[1].x + c * p[2].x + d * p[3].x,
                y: a * p[0].y + b * p[1].y + c * p[2].y + d * p[3].y,
                t: t2
            };
            if (_3d) ret.z = a * p[0].z + b * p[1].z + c * p[2].z + d * p[3].z;
            return ret;
        }
        const dCpts = JSON.parse(JSON.stringify(points));
        while(dCpts.length > 1){
            for(let i = 0; i < dCpts.length - 1; i++){
                dCpts[i] = {
                    x: dCpts[i].x + (dCpts[i + 1].x - dCpts[i].x) * t2,
                    y: dCpts[i].y + (dCpts[i + 1].y - dCpts[i].y) * t2
                };
                if (typeof dCpts[i].z !== "undefined") dCpts[i].z = dCpts[i].z + (dCpts[i + 1].z - dCpts[i].z) * t2;
            }
            dCpts.splice(dCpts.length - 1, 1);
        }
        dCpts[0].t = t2;
        return dCpts[0];
    },
    computeWithRatios: function(t2, points, ratios, _3d) {
        const mt = 1 - t2, r = ratios, p = points;
        let f1 = r[0], f2 = r[1], f3 = r[2], f4 = r[3], d;
        f1 *= mt;
        f2 *= t2;
        if (p.length === 2) {
            d = f1 + f2;
            return {
                x: (f1 * p[0].x + f2 * p[1].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z) / d,
                t: t2
            };
        }
        f1 *= mt;
        f2 *= 2 * mt;
        f3 *= t2 * t2;
        if (p.length === 3) {
            d = f1 + f2 + f3;
            return {
                x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z) / d,
                t: t2
            };
        }
        f1 *= mt;
        f2 *= 1.5 * mt;
        f3 *= 3 * mt;
        f4 *= t2 * t2 * t2;
        if (p.length === 4) {
            d = f1 + f2 + f3 + f4;
            return {
                x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x + f4 * p[3].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y + f4 * p[3].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z + f4 * p[3].z) / d,
                t: t2
            };
        }
    },
    derive: function(points, _3d) {
        const dpoints = [];
        for(let p = points, d = p.length, c = d - 1; d > 1; d--, c--){
            const list = [];
            for(let j = 0, dpt; j < c; j++){
                dpt = {
                    x: c * (p[j + 1].x - p[j].x),
                    y: c * (p[j + 1].y - p[j].y)
                };
                if (_3d) dpt.z = c * (p[j + 1].z - p[j].z);
                list.push(dpt);
            }
            dpoints.push(list);
            p = list;
        }
        return dpoints;
    },
    between: function(v, m, M) {
        return m <= v && v <= M || $2edc1eef02a7c199$var$utils.approximately(v, m) || $2edc1eef02a7c199$var$utils.approximately(v, M);
    },
    approximately: function(a, b, precision) {
        return $2edc1eef02a7c199$var$abs2(a - b) <= (precision || $2edc1eef02a7c199$var$epsilon);
    },
    length: function(derivativeFn) {
        const z = 0.5, len = $2edc1eef02a7c199$var$utils.Tvalues.length;
        let sum4 = 0;
        for(let i = 0, t2; i < len; i++){
            t2 = z * $2edc1eef02a7c199$var$utils.Tvalues[i] + z;
            sum4 += $2edc1eef02a7c199$var$utils.Cvalues[i] * $2edc1eef02a7c199$var$utils.arcfn(t2, derivativeFn);
        }
        return z * sum4;
    },
    map: function(v, ds, de, ts, te) {
        const d1 = de - ds, d2 = te - ts, v2 = v - ds, r = v2 / d1;
        return ts + d2 * r;
    },
    lerp: function(r, v1, v2) {
        const ret = {
            x: v1.x + r * (v2.x - v1.x),
            y: v1.y + r * (v2.y - v1.y)
        };
        if (v1.z !== void 0 && v2.z !== void 0) ret.z = v1.z + r * (v2.z - v1.z);
        return ret;
    },
    pointToString: function(p) {
        let s = p.x + "/" + p.y;
        if (typeof p.z !== "undefined") s += "/" + p.z;
        return s;
    },
    pointsToString: function(points) {
        return "[" + points.map($2edc1eef02a7c199$var$utils.pointToString).join(", ") + "]";
    },
    copy: function(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    angle: function(o, v1, v2) {
        const dx1 = v1.x - o.x, dy1 = v1.y - o.y, dx2 = v2.x - o.x, dy2 = v2.y - o.y, cross = dx1 * dy2 - dy1 * dx2, dot = dx1 * dx2 + dy1 * dy2;
        return $2edc1eef02a7c199$var$atan2(cross, dot);
    },
    // round as string, to avoid rounding errors
    round: function(v, d) {
        const s = "" + v;
        const pos = s.indexOf(".");
        return parseFloat(s.substring(0, pos + 1 + d));
    },
    dist: function(p1, p2) {
        const dx = p1.x - p2.x, dy = p1.y - p2.y;
        return $2edc1eef02a7c199$var$sqrt2(dx * dx + dy * dy);
    },
    closest: function(LUT, point) {
        let mdist = $2edc1eef02a7c199$var$pow3(2, 63), mpos, d;
        LUT.forEach(function(p, idx) {
            d = $2edc1eef02a7c199$var$utils.dist(point, p);
            if (d < mdist) {
                mdist = d;
                mpos = idx;
            }
        });
        return {
            mdist: mdist,
            mpos: mpos
        };
    },
    abcratio: function(t2, n) {
        if (n !== 2 && n !== 3) return false;
        if (typeof t2 === "undefined") t2 = 0.5;
        else if (t2 === 0 || t2 === 1) return t2;
        const bottom = $2edc1eef02a7c199$var$pow3(t2, n) + $2edc1eef02a7c199$var$pow3(1 - t2, n), top = bottom - 1;
        return $2edc1eef02a7c199$var$abs2(top / bottom);
    },
    projectionratio: function(t2, n) {
        if (n !== 2 && n !== 3) return false;
        if (typeof t2 === "undefined") t2 = 0.5;
        else if (t2 === 0 || t2 === 1) return t2;
        const top = $2edc1eef02a7c199$var$pow3(1 - t2, n), bottom = $2edc1eef02a7c199$var$pow3(t2, n) + top;
        return top / bottom;
    },
    lli8: function(x1, y1, x2, y2, x3, y3, x4, y4) {
        const nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4), ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4), d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        if (d == 0) return false;
        return {
            x: nx / d,
            y: ny / d
        };
    },
    lli4: function(p1, p2, p3, p4) {
        const x1 = p1.x, y1 = p1.y, x2 = p2.x, y2 = p2.y, x3 = p3.x, y3 = p3.y, x4 = p4.x, y4 = p4.y;
        return $2edc1eef02a7c199$var$utils.lli8(x1, y1, x2, y2, x3, y3, x4, y4);
    },
    lli: function(v1, v2) {
        return $2edc1eef02a7c199$var$utils.lli4(v1, v1.c, v2, v2.c);
    },
    makeline: function(p1, p2) {
        return new $2edc1eef02a7c199$var$Bezier(p1.x, p1.y, (p1.x + p2.x) / 2, (p1.y + p2.y) / 2, p2.x, p2.y);
    },
    findbbox: function(sections) {
        let mx = $2edc1eef02a7c199$var$nMax, my = $2edc1eef02a7c199$var$nMax, MX = $2edc1eef02a7c199$var$nMin, MY = $2edc1eef02a7c199$var$nMin;
        sections.forEach(function(s) {
            const bbox2 = s.bbox();
            if (mx > bbox2.x.min) mx = bbox2.x.min;
            if (my > bbox2.y.min) my = bbox2.y.min;
            if (MX < bbox2.x.max) MX = bbox2.x.max;
            if (MY < bbox2.y.max) MY = bbox2.y.max;
        });
        return {
            x: {
                min: mx,
                mid: (mx + MX) / 2,
                max: MX,
                size: MX - mx
            },
            y: {
                min: my,
                mid: (my + MY) / 2,
                max: MY,
                size: MY - my
            }
        };
    },
    shapeintersections: function(s1, bbox1, s2, bbox2, curveIntersectionThreshold) {
        if (!$2edc1eef02a7c199$var$utils.bboxoverlap(bbox1, bbox2)) return [];
        const intersections2 = [];
        const a1 = [
            s1.startcap,
            s1.forward,
            s1.back,
            s1.endcap
        ];
        const a2 = [
            s2.startcap,
            s2.forward,
            s2.back,
            s2.endcap
        ];
        a1.forEach(function(l1) {
            if (l1.virtual) return;
            a2.forEach(function(l2) {
                if (l2.virtual) return;
                const iss = l1.intersects(l2, curveIntersectionThreshold);
                if (iss.length > 0) {
                    iss.c1 = l1;
                    iss.c2 = l2;
                    iss.s1 = s1;
                    iss.s2 = s2;
                    intersections2.push(iss);
                }
            });
        });
        return intersections2;
    },
    makeshape: function(forward, back, curveIntersectionThreshold) {
        const bpl = back.points.length;
        const fpl = forward.points.length;
        const start = $2edc1eef02a7c199$var$utils.makeline(back.points[bpl - 1], forward.points[0]);
        const end = $2edc1eef02a7c199$var$utils.makeline(forward.points[fpl - 1], back.points[0]);
        const shape = {
            startcap: start,
            forward: forward,
            back: back,
            endcap: end,
            bbox: $2edc1eef02a7c199$var$utils.findbbox([
                start,
                forward,
                back,
                end
            ])
        };
        shape.intersections = function(s2) {
            return $2edc1eef02a7c199$var$utils.shapeintersections(shape, shape.bbox, s2, s2.bbox, curveIntersectionThreshold);
        };
        return shape;
    },
    getminmax: function(curve, d, list) {
        if (!list) return {
            min: 0,
            max: 0
        };
        let min6 = $2edc1eef02a7c199$var$nMax, max5 = $2edc1eef02a7c199$var$nMin, t2, c;
        if (list.indexOf(0) === -1) list = [
            0
        ].concat(list);
        if (list.indexOf(1) === -1) list.push(1);
        for(let i = 0, len = list.length; i < len; i++){
            t2 = list[i];
            c = curve.get(t2);
            if (c[d] < min6) min6 = c[d];
            if (c[d] > max5) max5 = c[d];
        }
        return {
            min: min6,
            mid: (min6 + max5) / 2,
            max: max5,
            size: max5 - min6
        };
    },
    align: function(points, line2) {
        const tx = line2.p1.x, ty = line2.p1.y, a = -$2edc1eef02a7c199$var$atan2(line2.p2.y - ty, line2.p2.x - tx), d = function(v) {
            return {
                x: (v.x - tx) * $2edc1eef02a7c199$var$cos2(a) - (v.y - ty) * $2edc1eef02a7c199$var$sin2(a),
                y: (v.x - tx) * $2edc1eef02a7c199$var$sin2(a) + (v.y - ty) * $2edc1eef02a7c199$var$cos2(a)
            };
        };
        return points.map(d);
    },
    roots: function(points, line2) {
        line2 = line2 || {
            p1: {
                x: 0,
                y: 0
            },
            p2: {
                x: 1,
                y: 0
            }
        };
        const order = points.length - 1;
        const aligned = $2edc1eef02a7c199$var$utils.align(points, line2);
        const reduce3 = function(t2) {
            return 0 <= t2 && t2 <= 1;
        };
        if (order === 2) {
            const a2 = aligned[0].y, b2 = aligned[1].y, c2 = aligned[2].y, d2 = a2 - 2 * b2 + c2;
            if (d2 !== 0) {
                const m1 = -$2edc1eef02a7c199$var$sqrt2(b2 * b2 - a2 * c2), m2 = -a2 + b2, v12 = -(m1 + m2) / d2, v2 = -(-m1 + m2) / d2;
                return [
                    v12,
                    v2
                ].filter(reduce3);
            } else if (b2 !== c2 && d2 === 0) return [
                (2 * b2 - c2) / (2 * b2 - 2 * c2)
            ].filter(reduce3);
            return [];
        }
        const pa = aligned[0].y, pb = aligned[1].y, pc = aligned[2].y, pd = aligned[3].y;
        let d = -pa + 3 * pb - 3 * pc + pd, a = 3 * pa - 6 * pb + 3 * pc, b = -3 * pa + 3 * pb, c = pa;
        if ($2edc1eef02a7c199$var$utils.approximately(d, 0)) {
            if ($2edc1eef02a7c199$var$utils.approximately(a, 0)) {
                if ($2edc1eef02a7c199$var$utils.approximately(b, 0)) return [];
                return [
                    -c / b
                ].filter(reduce3);
            }
            const q3 = $2edc1eef02a7c199$var$sqrt2(b * b - 4 * a * c), a2 = 2 * a;
            return [
                (q3 - b) / a2,
                (-b - q3) / a2
            ].filter(reduce3);
        }
        a /= d;
        b /= d;
        c /= d;
        const p = (3 * b - a * a) / 3, p3 = p / 3, q = (2 * a * a * a - 9 * a * b + 27 * c) / 27, q2 = q / 2, discriminant = q2 * q2 + p3 * p3 * p3;
        let u1, v1, x1, x2, x3;
        if (discriminant < 0) {
            const mp3 = -p / 3, mp33 = mp3 * mp3 * mp3, r = $2edc1eef02a7c199$var$sqrt2(mp33), t2 = -q / (2 * r), cosphi = t2 < -1 ? -1 : t2 > 1 ? 1 : t2, phi = $2edc1eef02a7c199$var$acos(cosphi), crtr = $2edc1eef02a7c199$var$crt(r), t1 = 2 * crtr;
            x1 = t1 * $2edc1eef02a7c199$var$cos2(phi / 3) - a / 3;
            x2 = t1 * $2edc1eef02a7c199$var$cos2((phi + $2edc1eef02a7c199$var$tau) / 3) - a / 3;
            x3 = t1 * $2edc1eef02a7c199$var$cos2((phi + 2 * $2edc1eef02a7c199$var$tau) / 3) - a / 3;
            return [
                x1,
                x2,
                x3
            ].filter(reduce3);
        } else if (discriminant === 0) {
            u1 = q2 < 0 ? $2edc1eef02a7c199$var$crt(-q2) : -$2edc1eef02a7c199$var$crt(q2);
            x1 = 2 * u1 - a / 3;
            x2 = -u1 - a / 3;
            return [
                x1,
                x2
            ].filter(reduce3);
        } else {
            const sd = $2edc1eef02a7c199$var$sqrt2(discriminant);
            u1 = $2edc1eef02a7c199$var$crt(-q2 + sd);
            v1 = $2edc1eef02a7c199$var$crt(q2 + sd);
            return [
                u1 - v1 - a / 3
            ].filter(reduce3);
        }
    },
    droots: function(p) {
        if (p.length === 3) {
            const a = p[0], b = p[1], c = p[2], d = a - 2 * b + c;
            if (d !== 0) {
                const m1 = -$2edc1eef02a7c199$var$sqrt2(b * b - a * c), m2 = -a + b, v1 = -(m1 + m2) / d, v2 = -(-m1 + m2) / d;
                return [
                    v1,
                    v2
                ];
            } else if (b !== c && d === 0) return [
                (2 * b - c) / (2 * (b - c))
            ];
            return [];
        }
        if (p.length === 2) {
            const a = p[0], b = p[1];
            if (a !== b) return [
                a / (a - b)
            ];
            return [];
        }
        return [];
    },
    curvature: function(t2, d1, d2, _3d, kOnly) {
        let num, dnm, adk, dk, k = 0, r = 0;
        const d = $2edc1eef02a7c199$var$utils.compute(t2, d1);
        const dd = $2edc1eef02a7c199$var$utils.compute(t2, d2);
        const qdsum = d.x * d.x + d.y * d.y;
        if (_3d) {
            num = $2edc1eef02a7c199$var$sqrt2($2edc1eef02a7c199$var$pow3(d.y * dd.z - dd.y * d.z, 2) + $2edc1eef02a7c199$var$pow3(d.z * dd.x - dd.z * d.x, 2) + $2edc1eef02a7c199$var$pow3(d.x * dd.y - dd.x * d.y, 2));
            dnm = $2edc1eef02a7c199$var$pow3(qdsum + d.z * d.z, 1.5);
        } else {
            num = d.x * dd.y - d.y * dd.x;
            dnm = $2edc1eef02a7c199$var$pow3(qdsum, 1.5);
        }
        if (num === 0 || dnm === 0) return {
            k: 0,
            r: 0
        };
        k = num / dnm;
        r = dnm / num;
        if (!kOnly) {
            const pk = $2edc1eef02a7c199$var$utils.curvature(t2 - 1e-3, d1, d2, _3d, true).k;
            const nk = $2edc1eef02a7c199$var$utils.curvature(t2 + 1e-3, d1, d2, _3d, true).k;
            dk = (nk - k + (k - pk)) / 2;
            adk = ($2edc1eef02a7c199$var$abs2(nk - k) + $2edc1eef02a7c199$var$abs2(k - pk)) / 2;
        }
        return {
            k: k,
            r: r,
            dk: dk,
            adk: adk
        };
    },
    inflections: function(points) {
        if (points.length < 4) return [];
        const p = $2edc1eef02a7c199$var$utils.align(points, {
            p1: points[0],
            p2: points.slice(-1)[0]
        }), a = p[2].x * p[1].y, b = p[3].x * p[1].y, c = p[1].x * p[2].y, d = p[3].x * p[2].y, v1 = 18 * (-3 * a + 2 * b + 3 * c - d), v2 = 18 * (3 * a - b - 3 * c), v3 = 18 * (c - a);
        if ($2edc1eef02a7c199$var$utils.approximately(v1, 0)) {
            if (!$2edc1eef02a7c199$var$utils.approximately(v2, 0)) {
                let t2 = -v3 / v2;
                if (0 <= t2 && t2 <= 1) return [
                    t2
                ];
            }
            return [];
        }
        const d2 = 2 * v1;
        if ($2edc1eef02a7c199$var$utils.approximately(d2, 0)) return [];
        const trm = v2 * v2 - 4 * v1 * v3;
        if (trm < 0) return [];
        const sq = Math.sqrt(trm);
        return [
            (sq - v2) / d2,
            -(v2 + sq) / d2
        ].filter(function(r) {
            return 0 <= r && r <= 1;
        });
    },
    bboxoverlap: function(b1, b2) {
        const dims = [
            "x",
            "y"
        ], len = dims.length;
        for(let i = 0, dim, l, t2, d; i < len; i++){
            dim = dims[i];
            l = b1[dim].mid;
            t2 = b2[dim].mid;
            d = (b1[dim].size + b2[dim].size) / 2;
            if ($2edc1eef02a7c199$var$abs2(l - t2) >= d) return false;
        }
        return true;
    },
    expandbox: function(bbox2, _bbox) {
        if (_bbox.x.min < bbox2.x.min) bbox2.x.min = _bbox.x.min;
        if (_bbox.y.min < bbox2.y.min) bbox2.y.min = _bbox.y.min;
        if (_bbox.z && _bbox.z.min < bbox2.z.min) bbox2.z.min = _bbox.z.min;
        if (_bbox.x.max > bbox2.x.max) bbox2.x.max = _bbox.x.max;
        if (_bbox.y.max > bbox2.y.max) bbox2.y.max = _bbox.y.max;
        if (_bbox.z && _bbox.z.max > bbox2.z.max) bbox2.z.max = _bbox.z.max;
        bbox2.x.mid = (bbox2.x.min + bbox2.x.max) / 2;
        bbox2.y.mid = (bbox2.y.min + bbox2.y.max) / 2;
        if (bbox2.z) bbox2.z.mid = (bbox2.z.min + bbox2.z.max) / 2;
        bbox2.x.size = bbox2.x.max - bbox2.x.min;
        bbox2.y.size = bbox2.y.max - bbox2.y.min;
        if (bbox2.z) bbox2.z.size = bbox2.z.max - bbox2.z.min;
    },
    pairiteration: function(c1, c2, curveIntersectionThreshold) {
        const c1b = c1.bbox(), c2b = c2.bbox(), r = 1e5, threshold = curveIntersectionThreshold || 0.5;
        if (c1b.x.size + c1b.y.size < threshold && c2b.x.size + c2b.y.size < threshold) return [
            (r * (c1._t1 + c1._t2) / 2 | 0) / r + "/" + (r * (c2._t1 + c2._t2) / 2 | 0) / r
        ];
        let cc1 = c1.split(0.5), cc2 = c2.split(0.5), pairs = [
            {
                left: cc1.left,
                right: cc2.left
            },
            {
                left: cc1.left,
                right: cc2.right
            },
            {
                left: cc1.right,
                right: cc2.right
            },
            {
                left: cc1.right,
                right: cc2.left
            }
        ];
        pairs = pairs.filter(function(pair) {
            return $2edc1eef02a7c199$var$utils.bboxoverlap(pair.left.bbox(), pair.right.bbox());
        });
        let results = [];
        if (pairs.length === 0) return results;
        pairs.forEach(function(pair) {
            results = results.concat($2edc1eef02a7c199$var$utils.pairiteration(pair.left, pair.right, threshold));
        });
        results = results.filter(function(v, i) {
            return results.indexOf(v) === i;
        });
        return results;
    },
    getccenter: function(p1, p2, p3) {
        const dx1 = p2.x - p1.x, dy1 = p2.y - p1.y, dx2 = p3.x - p2.x, dy2 = p3.y - p2.y, dx1p = dx1 * $2edc1eef02a7c199$var$cos2($2edc1eef02a7c199$var$quart) - dy1 * $2edc1eef02a7c199$var$sin2($2edc1eef02a7c199$var$quart), dy1p = dx1 * $2edc1eef02a7c199$var$sin2($2edc1eef02a7c199$var$quart) + dy1 * $2edc1eef02a7c199$var$cos2($2edc1eef02a7c199$var$quart), dx2p = dx2 * $2edc1eef02a7c199$var$cos2($2edc1eef02a7c199$var$quart) - dy2 * $2edc1eef02a7c199$var$sin2($2edc1eef02a7c199$var$quart), dy2p = dx2 * $2edc1eef02a7c199$var$sin2($2edc1eef02a7c199$var$quart) + dy2 * $2edc1eef02a7c199$var$cos2($2edc1eef02a7c199$var$quart), mx1 = (p1.x + p2.x) / 2, my1 = (p1.y + p2.y) / 2, mx2 = (p2.x + p3.x) / 2, my2 = (p2.y + p3.y) / 2, mx1n = mx1 + dx1p, my1n = my1 + dy1p, mx2n = mx2 + dx2p, my2n = my2 + dy2p, arc = $2edc1eef02a7c199$var$utils.lli8(mx1, my1, mx1n, my1n, mx2, my2, mx2n, my2n), r = $2edc1eef02a7c199$var$utils.dist(arc, p1);
        let s = $2edc1eef02a7c199$var$atan2(p1.y - arc.y, p1.x - arc.x), m = $2edc1eef02a7c199$var$atan2(p2.y - arc.y, p2.x - arc.x), e = $2edc1eef02a7c199$var$atan2(p3.y - arc.y, p3.x - arc.x), _;
        if (s < e) {
            if (s > m || m > e) s += $2edc1eef02a7c199$var$tau;
            if (s > e) {
                _ = e;
                e = s;
                s = _;
            }
        } else if (e < m && m < s) {
            _ = e;
            e = s;
            s = _;
        } else e += $2edc1eef02a7c199$var$tau;
        arc.s = s;
        arc.e = e;
        arc.r = r;
        return arc;
    },
    numberSort: function(a, b) {
        return a - b;
    }
};
// node_modules/bezier-js/src/poly-bezier.js
var $2edc1eef02a7c199$var$PolyBezier = class _PolyBezier {
    constructor(curves){
        this.curves = [];
        this._3d = false;
        if (!!curves) {
            this.curves = curves;
            this._3d = this.curves[0]._3d;
        }
    }
    valueOf() {
        return this.toString();
    }
    toString() {
        return "[" + this.curves.map(function(curve) {
            return $2edc1eef02a7c199$var$utils.pointsToString(curve.points);
        }).join(", ") + "]";
    }
    addCurve(curve) {
        this.curves.push(curve);
        this._3d = this._3d || curve._3d;
    }
    length() {
        return this.curves.map(function(v) {
            return v.length();
        }).reduce(function(a, b) {
            return a + b;
        });
    }
    curve(idx) {
        return this.curves[idx];
    }
    bbox() {
        const c = this.curves;
        var bbox2 = c[0].bbox();
        for(var i = 1; i < c.length; i++)$2edc1eef02a7c199$var$utils.expandbox(bbox2, c[i].bbox());
        return bbox2;
    }
    offset(d) {
        const offset = [];
        this.curves.forEach(function(v) {
            offset.push(...v.offset(d));
        });
        return new _PolyBezier(offset);
    }
};
// node_modules/bezier-js/src/bezier.js
var { abs: $2edc1eef02a7c199$var$abs3, min: $2edc1eef02a7c199$var$min4, max: $2edc1eef02a7c199$var$max3, cos: $2edc1eef02a7c199$var$cos3, sin: $2edc1eef02a7c199$var$sin3, acos: $2edc1eef02a7c199$var$acos2, sqrt: $2edc1eef02a7c199$var$sqrt3 } = Math;
var $2edc1eef02a7c199$var$pi3 = Math.PI;
var $2edc1eef02a7c199$var$Bezier = class _Bezier {
    constructor(coords){
        let args = coords && coords.forEach ? coords : Array.from(arguments).slice();
        let coordlen = false;
        if (typeof args[0] === "object") {
            coordlen = args.length;
            const newargs = [];
            args.forEach(function(point2) {
                [
                    "x",
                    "y",
                    "z"
                ].forEach(function(d) {
                    if (typeof point2[d] !== "undefined") newargs.push(point2[d]);
                });
            });
            args = newargs;
        }
        let higher = false;
        const len = args.length;
        if (coordlen) {
            if (coordlen > 4) {
                if (arguments.length !== 1) throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
                higher = true;
            }
        } else if (len !== 6 && len !== 8 && len !== 9 && len !== 12) {
            if (arguments.length !== 1) throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
        }
        const _3d = this._3d = !higher && (len === 9 || len === 12) || coords && coords[0] && typeof coords[0].z !== "undefined";
        const points = this.points = [];
        for(let idx = 0, step = _3d ? 3 : 2; idx < len; idx += step){
            var point = {
                x: args[idx],
                y: args[idx + 1]
            };
            if (_3d) point.z = args[idx + 2];
            points.push(point);
        }
        const order = this.order = points.length - 1;
        const dims = this.dims = [
            "x",
            "y"
        ];
        if (_3d) dims.push("z");
        this.dimlen = dims.length;
        const aligned = $2edc1eef02a7c199$var$utils.align(points, {
            p1: points[0],
            p2: points[order]
        });
        const baselength = $2edc1eef02a7c199$var$utils.dist(points[0], points[order]);
        this._linear = aligned.reduce((t2, p)=>t2 + $2edc1eef02a7c199$var$abs3(p.y), 0) < baselength / 50;
        this._lut = [];
        this._t1 = 0;
        this._t2 = 1;
        this.update();
    }
    static quadraticFromPoints(p1, p2, p3, t2) {
        if (typeof t2 === "undefined") t2 = 0.5;
        if (t2 === 0) return new _Bezier(p2, p2, p3);
        if (t2 === 1) return new _Bezier(p1, p2, p2);
        const abc = _Bezier.getABC(2, p1, p2, p3, t2);
        return new _Bezier(p1, abc.A, p3);
    }
    static cubicFromPoints(S, B, E, t2, d1) {
        if (typeof t2 === "undefined") t2 = 0.5;
        const abc = _Bezier.getABC(3, S, B, E, t2);
        if (typeof d1 === "undefined") d1 = $2edc1eef02a7c199$var$utils.dist(B, abc.C);
        const d2 = d1 * (1 - t2) / t2;
        const selen = $2edc1eef02a7c199$var$utils.dist(S, E), lx = (E.x - S.x) / selen, ly = (E.y - S.y) / selen, bx1 = d1 * lx, by1 = d1 * ly, bx2 = d2 * lx, by2 = d2 * ly;
        const e1 = {
            x: B.x - bx1,
            y: B.y - by1
        }, e2 = {
            x: B.x + bx2,
            y: B.y + by2
        }, A = abc.A, v1 = {
            x: A.x + (e1.x - A.x) / (1 - t2),
            y: A.y + (e1.y - A.y) / (1 - t2)
        }, v2 = {
            x: A.x + (e2.x - A.x) / t2,
            y: A.y + (e2.y - A.y) / t2
        }, nc1 = {
            x: S.x + (v1.x - S.x) / t2,
            y: S.y + (v1.y - S.y) / t2
        }, nc2 = {
            x: E.x + (v2.x - E.x) / (1 - t2),
            y: E.y + (v2.y - E.y) / (1 - t2)
        };
        return new _Bezier(S, nc1, nc2, E);
    }
    static getUtils() {
        return $2edc1eef02a7c199$var$utils;
    }
    getUtils() {
        return _Bezier.getUtils();
    }
    static get PolyBezier() {
        return $2edc1eef02a7c199$var$PolyBezier;
    }
    valueOf() {
        return this.toString();
    }
    toString() {
        return $2edc1eef02a7c199$var$utils.pointsToString(this.points);
    }
    toSVG() {
        if (this._3d) return false;
        const p = this.points, x = p[0].x, y = p[0].y, s = [
            "M",
            x,
            y,
            this.order === 2 ? "Q" : "C"
        ];
        for(let i = 1, last = p.length; i < last; i++){
            s.push(p[i].x);
            s.push(p[i].y);
        }
        return s.join(" ");
    }
    setRatios(ratios) {
        if (ratios.length !== this.points.length) throw new Error("incorrect number of ratio values");
        this.ratios = ratios;
        this._lut = [];
    }
    verify() {
        const print = this.coordDigest();
        if (print !== this._print) {
            this._print = print;
            this.update();
        }
    }
    coordDigest() {
        return this.points.map(function(c, pos) {
            return "" + pos + c.x + c.y + (c.z ? c.z : 0);
        }).join("");
    }
    update() {
        this._lut = [];
        this.dpoints = $2edc1eef02a7c199$var$utils.derive(this.points, this._3d);
        this.computedirection();
    }
    computedirection() {
        const points = this.points;
        const angle = $2edc1eef02a7c199$var$utils.angle(points[0], points[this.order], points[1]);
        this.clockwise = angle > 0;
    }
    length() {
        return $2edc1eef02a7c199$var$utils.length(this.derivative.bind(this));
    }
    static getABC(order = 2, S, B, E, t2 = 0.5) {
        const u = $2edc1eef02a7c199$var$utils.projectionratio(t2, order), um = 1 - u, C = {
            x: u * S.x + um * E.x,
            y: u * S.y + um * E.y
        }, s = $2edc1eef02a7c199$var$utils.abcratio(t2, order), A = {
            x: B.x + (B.x - C.x) / s,
            y: B.y + (B.y - C.y) / s
        };
        return {
            A: A,
            B: B,
            C: C,
            S: S,
            E: E
        };
    }
    getABC(t2, B) {
        B = B || this.get(t2);
        let S = this.points[0];
        let E = this.points[this.order];
        return _Bezier.getABC(this.order, S, B, E, t2);
    }
    getLUT(steps) {
        this.verify();
        steps = steps || 100;
        if (this._lut.length === steps + 1) return this._lut;
        this._lut = [];
        steps++;
        this._lut = [];
        for(let i = 0, p, t2; i < steps; i++){
            t2 = i / (steps - 1);
            p = this.compute(t2);
            p.t = t2;
            this._lut.push(p);
        }
        return this._lut;
    }
    on(point, error) {
        error = error || 5;
        const lut = this.getLUT(), hits = [];
        for(let i = 0, c, t2 = 0; i < lut.length; i++){
            c = lut[i];
            if ($2edc1eef02a7c199$var$utils.dist(c, point) < error) {
                hits.push(c);
                t2 += i / lut.length;
            }
        }
        if (!hits.length) return false;
        return t /= hits.length;
    }
    project(point) {
        const LUT = this.getLUT(), l = LUT.length - 1, closest = $2edc1eef02a7c199$var$utils.closest(LUT, point), mpos = closest.mpos, t1 = (mpos - 1) / l, t2 = (mpos + 1) / l, step = 0.1 / l;
        let mdist = closest.mdist, t3 = t1, ft = t3, p;
        mdist += 1;
        for(let d; t3 < t2 + step; t3 += step){
            p = this.compute(t3);
            d = $2edc1eef02a7c199$var$utils.dist(point, p);
            if (d < mdist) {
                mdist = d;
                ft = t3;
            }
        }
        ft = ft < 0 ? 0 : ft > 1 ? 1 : ft;
        p = this.compute(ft);
        p.t = ft;
        p.d = mdist;
        return p;
    }
    get(t2) {
        return this.compute(t2);
    }
    point(idx) {
        return this.points[idx];
    }
    compute(t2) {
        if (this.ratios) return $2edc1eef02a7c199$var$utils.computeWithRatios(t2, this.points, this.ratios, this._3d);
        return $2edc1eef02a7c199$var$utils.compute(t2, this.points, this._3d, this.ratios);
    }
    raise() {
        const p = this.points, np = [
            p[0]
        ], k = p.length;
        for(let i = 1, pi4, pim; i < k; i++){
            pi4 = p[i];
            pim = p[i - 1];
            np[i] = {
                x: (k - i) / k * pi4.x + i / k * pim.x,
                y: (k - i) / k * pi4.y + i / k * pim.y
            };
        }
        np[k] = p[k - 1];
        return new _Bezier(np);
    }
    derivative(t2) {
        return $2edc1eef02a7c199$var$utils.compute(t2, this.dpoints[0], this._3d);
    }
    dderivative(t2) {
        return $2edc1eef02a7c199$var$utils.compute(t2, this.dpoints[1], this._3d);
    }
    align() {
        let p = this.points;
        return new _Bezier($2edc1eef02a7c199$var$utils.align(p, {
            p1: p[0],
            p2: p[p.length - 1]
        }));
    }
    curvature(t2) {
        return $2edc1eef02a7c199$var$utils.curvature(t2, this.dpoints[0], this.dpoints[1], this._3d);
    }
    inflections() {
        return $2edc1eef02a7c199$var$utils.inflections(this.points);
    }
    normal(t2) {
        return this._3d ? this.__normal3(t2) : this.__normal2(t2);
    }
    __normal2(t2) {
        const d = this.derivative(t2);
        const q = $2edc1eef02a7c199$var$sqrt3(d.x * d.x + d.y * d.y);
        return {
            t: t2,
            x: -d.y / q,
            y: d.x / q
        };
    }
    __normal3(t2) {
        const r1 = this.derivative(t2), r2 = this.derivative(t2 + 0.01), q1 = $2edc1eef02a7c199$var$sqrt3(r1.x * r1.x + r1.y * r1.y + r1.z * r1.z), q2 = $2edc1eef02a7c199$var$sqrt3(r2.x * r2.x + r2.y * r2.y + r2.z * r2.z);
        r1.x /= q1;
        r1.y /= q1;
        r1.z /= q1;
        r2.x /= q2;
        r2.y /= q2;
        r2.z /= q2;
        const c = {
            x: r2.y * r1.z - r2.z * r1.y,
            y: r2.z * r1.x - r2.x * r1.z,
            z: r2.x * r1.y - r2.y * r1.x
        };
        const m = $2edc1eef02a7c199$var$sqrt3(c.x * c.x + c.y * c.y + c.z * c.z);
        c.x /= m;
        c.y /= m;
        c.z /= m;
        const R = [
            c.x * c.x,
            c.x * c.y - c.z,
            c.x * c.z + c.y,
            c.x * c.y + c.z,
            c.y * c.y,
            c.y * c.z - c.x,
            c.x * c.z - c.y,
            c.y * c.z + c.x,
            c.z * c.z
        ];
        const n = {
            t: t2,
            x: R[0] * r1.x + R[1] * r1.y + R[2] * r1.z,
            y: R[3] * r1.x + R[4] * r1.y + R[5] * r1.z,
            z: R[6] * r1.x + R[7] * r1.y + R[8] * r1.z
        };
        return n;
    }
    hull(t2) {
        let p = this.points, _p = [], q = [], idx = 0;
        q[idx++] = p[0];
        q[idx++] = p[1];
        q[idx++] = p[2];
        if (this.order === 3) q[idx++] = p[3];
        while(p.length > 1){
            _p = [];
            for(let i = 0, pt, l = p.length - 1; i < l; i++){
                pt = $2edc1eef02a7c199$var$utils.lerp(t2, p[i], p[i + 1]);
                q[idx++] = pt;
                _p.push(pt);
            }
            p = _p;
        }
        return q;
    }
    split(t1, t2) {
        if (t1 === 0 && !!t2) return this.split(t2).left;
        if (t2 === 1) return this.split(t1).right;
        const q = this.hull(t1);
        const result = {
            left: this.order === 2 ? new _Bezier([
                q[0],
                q[3],
                q[5]
            ]) : new _Bezier([
                q[0],
                q[4],
                q[7],
                q[9]
            ]),
            right: this.order === 2 ? new _Bezier([
                q[5],
                q[4],
                q[2]
            ]) : new _Bezier([
                q[9],
                q[8],
                q[6],
                q[3]
            ]),
            span: q
        };
        result.left._t1 = $2edc1eef02a7c199$var$utils.map(0, 0, 1, this._t1, this._t2);
        result.left._t2 = $2edc1eef02a7c199$var$utils.map(t1, 0, 1, this._t1, this._t2);
        result.right._t1 = $2edc1eef02a7c199$var$utils.map(t1, 0, 1, this._t1, this._t2);
        result.right._t2 = $2edc1eef02a7c199$var$utils.map(1, 0, 1, this._t1, this._t2);
        if (!t2) return result;
        t2 = $2edc1eef02a7c199$var$utils.map(t2, t1, 1, 0, 1);
        return result.right.split(t2).left;
    }
    extrema() {
        const result = {};
        let roots = [];
        this.dims.forEach((function(dim) {
            let mfn = function(v) {
                return v[dim];
            };
            let p = this.dpoints[0].map(mfn);
            result[dim] = $2edc1eef02a7c199$var$utils.droots(p);
            if (this.order === 3) {
                p = this.dpoints[1].map(mfn);
                result[dim] = result[dim].concat($2edc1eef02a7c199$var$utils.droots(p));
            }
            result[dim] = result[dim].filter(function(t2) {
                return t2 >= 0 && t2 <= 1;
            });
            roots = roots.concat(result[dim].sort($2edc1eef02a7c199$var$utils.numberSort));
        }).bind(this));
        result.values = roots.sort($2edc1eef02a7c199$var$utils.numberSort).filter(function(v, idx) {
            return roots.indexOf(v) === idx;
        });
        return result;
    }
    bbox() {
        const extrema = this.extrema(), result = {};
        this.dims.forEach((function(d) {
            result[d] = $2edc1eef02a7c199$var$utils.getminmax(this, d, extrema[d]);
        }).bind(this));
        return result;
    }
    overlaps(curve) {
        const lbbox = this.bbox(), tbbox = curve.bbox();
        return $2edc1eef02a7c199$var$utils.bboxoverlap(lbbox, tbbox);
    }
    offset(t2, d) {
        if (typeof d !== "undefined") {
            const c = this.get(t2), n = this.normal(t2);
            const ret = {
                c: c,
                n: n,
                x: c.x + n.x * d,
                y: c.y + n.y * d
            };
            if (this._3d) ret.z = c.z + n.z * d;
            return ret;
        }
        if (this._linear) {
            const nv = this.normal(0), coords = this.points.map(function(p) {
                const ret = {
                    x: p.x + t2 * nv.x,
                    y: p.y + t2 * nv.y
                };
                if (p.z && nv.z) ret.z = p.z + t2 * nv.z;
                return ret;
            });
            return [
                new _Bezier(coords)
            ];
        }
        return this.reduce().map(function(s) {
            if (s._linear) return s.offset(t2)[0];
            return s.scale(t2);
        });
    }
    simple() {
        if (this.order === 3) {
            const a1 = $2edc1eef02a7c199$var$utils.angle(this.points[0], this.points[3], this.points[1]);
            const a2 = $2edc1eef02a7c199$var$utils.angle(this.points[0], this.points[3], this.points[2]);
            if (a1 > 0 && a2 < 0 || a1 < 0 && a2 > 0) return false;
        }
        const n1 = this.normal(0);
        const n2 = this.normal(1);
        let s = n1.x * n2.x + n1.y * n2.y;
        if (this._3d) s += n1.z * n2.z;
        return $2edc1eef02a7c199$var$abs3($2edc1eef02a7c199$var$acos2(s)) < $2edc1eef02a7c199$var$pi3 / 3;
    }
    reduce() {
        let i, t1 = 0, t2 = 0, step = 0.01, segment, pass1 = [], pass2 = [];
        let extrema = this.extrema().values;
        if (extrema.indexOf(0) === -1) extrema = [
            0
        ].concat(extrema);
        if (extrema.indexOf(1) === -1) extrema.push(1);
        for(t1 = extrema[0], i = 1; i < extrema.length; i++){
            t2 = extrema[i];
            segment = this.split(t1, t2);
            segment._t1 = t1;
            segment._t2 = t2;
            pass1.push(segment);
            t1 = t2;
        }
        pass1.forEach(function(p1) {
            t1 = 0;
            t2 = 0;
            while(t2 <= 1)for(t2 = t1 + step; t2 <= 1 + step; t2 += step){
                segment = p1.split(t1, t2);
                if (!segment.simple()) {
                    t2 -= step;
                    if ($2edc1eef02a7c199$var$abs3(t1 - t2) < step) return [];
                    segment = p1.split(t1, t2);
                    segment._t1 = $2edc1eef02a7c199$var$utils.map(t1, 0, 1, p1._t1, p1._t2);
                    segment._t2 = $2edc1eef02a7c199$var$utils.map(t2, 0, 1, p1._t1, p1._t2);
                    pass2.push(segment);
                    t1 = t2;
                    break;
                }
            }
            if (t1 < 1) {
                segment = p1.split(t1, 1);
                segment._t1 = $2edc1eef02a7c199$var$utils.map(t1, 0, 1, p1._t1, p1._t2);
                segment._t2 = p1._t2;
                pass2.push(segment);
            }
        });
        return pass2;
    }
    translate(v, d1, d2) {
        d2 = typeof d2 === "number" ? d2 : d1;
        const o = this.order;
        let d = this.points.map((_, i)=>(1 - i / o) * d1 + i / o * d2);
        return new _Bezier(this.points.map((p, i)=>({
                x: p.x + v.x * d[i],
                y: p.y + v.y * d[i]
            })));
    }
    scale(d) {
        const order = this.order;
        let distanceFn = false;
        if (typeof d === "function") distanceFn = d;
        if (distanceFn && order === 2) return this.raise().scale(distanceFn);
        const clockwise = this.clockwise;
        const points = this.points;
        if (this._linear) return this.translate(this.normal(0), distanceFn ? distanceFn(0) : d, distanceFn ? distanceFn(1) : d);
        const r1 = distanceFn ? distanceFn(0) : d;
        const r2 = distanceFn ? distanceFn(1) : d;
        const v = [
            this.offset(0, 10),
            this.offset(1, 10)
        ];
        const np = [];
        const o = $2edc1eef02a7c199$var$utils.lli4(v[0], v[0].c, v[1], v[1].c);
        if (!o) throw new Error("cannot scale this curve. Try reducing it first.");
        [
            0,
            1
        ].forEach(function(t2) {
            const p = np[t2 * order] = $2edc1eef02a7c199$var$utils.copy(points[t2 * order]);
            p.x += (t2 ? r2 : r1) * v[t2].n.x;
            p.y += (t2 ? r2 : r1) * v[t2].n.y;
        });
        if (!distanceFn) {
            [
                0,
                1
            ].forEach((t2)=>{
                if (order === 2 && !!t2) return;
                const p = np[t2 * order];
                const d2 = this.derivative(t2);
                const p2 = {
                    x: p.x + d2.x,
                    y: p.y + d2.y
                };
                np[t2 + 1] = $2edc1eef02a7c199$var$utils.lli4(p, p2, o, points[t2 + 1]);
            });
            return new _Bezier(np);
        }
        [
            0,
            1
        ].forEach(function(t2) {
            if (order === 2 && !!t2) return;
            var p = points[t2 + 1];
            var ov = {
                x: p.x - o.x,
                y: p.y - o.y
            };
            var rc = distanceFn ? distanceFn((t2 + 1) / order) : d;
            if (distanceFn && !clockwise) rc = -rc;
            var m = $2edc1eef02a7c199$var$sqrt3(ov.x * ov.x + ov.y * ov.y);
            ov.x /= m;
            ov.y /= m;
            np[t2 + 1] = {
                x: p.x + rc * ov.x,
                y: p.y + rc * ov.y
            };
        });
        return new _Bezier(np);
    }
    outline(d1, d2, d3, d4) {
        d2 = d2 === void 0 ? d1 : d2;
        if (this._linear) {
            const n = this.normal(0);
            const start = this.points[0];
            const end = this.points[this.points.length - 1];
            let s, mid, e;
            if (d3 === void 0) {
                d3 = d1;
                d4 = d2;
            }
            s = {
                x: start.x + n.x * d1,
                y: start.y + n.y * d1
            };
            e = {
                x: end.x + n.x * d3,
                y: end.y + n.y * d3
            };
            mid = {
                x: (s.x + e.x) / 2,
                y: (s.y + e.y) / 2
            };
            const fline = [
                s,
                mid,
                e
            ];
            s = {
                x: start.x - n.x * d2,
                y: start.y - n.y * d2
            };
            e = {
                x: end.x - n.x * d4,
                y: end.y - n.y * d4
            };
            mid = {
                x: (s.x + e.x) / 2,
                y: (s.y + e.y) / 2
            };
            const bline = [
                e,
                mid,
                s
            ];
            const ls2 = $2edc1eef02a7c199$var$utils.makeline(bline[2], fline[0]);
            const le2 = $2edc1eef02a7c199$var$utils.makeline(fline[2], bline[0]);
            const segments2 = [
                ls2,
                new _Bezier(fline),
                le2,
                new _Bezier(bline)
            ];
            return new $2edc1eef02a7c199$var$PolyBezier(segments2);
        }
        const reduced = this.reduce(), len = reduced.length, fcurves = [];
        let bcurves = [], p, alen = 0, tlen = this.length();
        const graduated = typeof d3 !== "undefined" && typeof d4 !== "undefined";
        function linearDistanceFunction(s, e, tlen2, alen2, slen) {
            return function(v) {
                const f1 = alen2 / tlen2, f2 = (alen2 + slen) / tlen2, d = e - s;
                return $2edc1eef02a7c199$var$utils.map(v, 0, 1, s + f1 * d, s + f2 * d);
            };
        }
        reduced.forEach(function(segment) {
            const slen = segment.length();
            if (graduated) {
                fcurves.push(segment.scale(linearDistanceFunction(d1, d3, tlen, alen, slen)));
                bcurves.push(segment.scale(linearDistanceFunction(-d2, -d4, tlen, alen, slen)));
            } else {
                fcurves.push(segment.scale(d1));
                bcurves.push(segment.scale(-d2));
            }
            alen += slen;
        });
        bcurves = bcurves.map(function(s) {
            p = s.points;
            if (p[3]) s.points = [
                p[3],
                p[2],
                p[1],
                p[0]
            ];
            else s.points = [
                p[2],
                p[1],
                p[0]
            ];
            return s;
        }).reverse();
        const fs = fcurves[0].points[0], fe = fcurves[len - 1].points[fcurves[len - 1].points.length - 1], bs = bcurves[len - 1].points[bcurves[len - 1].points.length - 1], be = bcurves[0].points[0], ls = $2edc1eef02a7c199$var$utils.makeline(bs, fs), le = $2edc1eef02a7c199$var$utils.makeline(fe, be), segments = [
            ls
        ].concat(fcurves).concat([
            le
        ]).concat(bcurves);
        return new $2edc1eef02a7c199$var$PolyBezier(segments);
    }
    outlineshapes(d1, d2, curveIntersectionThreshold) {
        d2 = d2 || d1;
        const outline = this.outline(d1, d2).curves;
        const shapes = [];
        for(let i = 1, len = outline.length; i < len / 2; i++){
            const shape = $2edc1eef02a7c199$var$utils.makeshape(outline[i], outline[len - i], curveIntersectionThreshold);
            shape.startcap.virtual = i > 1;
            shape.endcap.virtual = i < len / 2 - 1;
            shapes.push(shape);
        }
        return shapes;
    }
    intersects(curve, curveIntersectionThreshold) {
        if (!curve) return this.selfintersects(curveIntersectionThreshold);
        if (curve.p1 && curve.p2) return this.lineIntersects(curve);
        if (curve instanceof _Bezier) curve = curve.reduce();
        return this.curveintersects(this.reduce(), curve, curveIntersectionThreshold);
    }
    lineIntersects(line2) {
        const mx = $2edc1eef02a7c199$var$min4(line2.p1.x, line2.p2.x), my = $2edc1eef02a7c199$var$min4(line2.p1.y, line2.p2.y), MX = $2edc1eef02a7c199$var$max3(line2.p1.x, line2.p2.x), MY = $2edc1eef02a7c199$var$max3(line2.p1.y, line2.p2.y);
        return $2edc1eef02a7c199$var$utils.roots(this.points, line2).filter((t2)=>{
            var p = this.get(t2);
            return $2edc1eef02a7c199$var$utils.between(p.x, mx, MX) && $2edc1eef02a7c199$var$utils.between(p.y, my, MY);
        });
    }
    selfintersects(curveIntersectionThreshold) {
        const reduced = this.reduce(), len = reduced.length - 2, results = [];
        for(let i = 0, result, left, right; i < len; i++){
            left = reduced.slice(i, i + 1);
            right = reduced.slice(i + 2);
            result = this.curveintersects(left, right, curveIntersectionThreshold);
            results.push(...result);
        }
        return results;
    }
    curveintersects(c1, c2, curveIntersectionThreshold) {
        const pairs = [];
        c1.forEach(function(l) {
            c2.forEach(function(r) {
                if (l.overlaps(r)) pairs.push({
                    left: l,
                    right: r
                });
            });
        });
        let intersections2 = [];
        pairs.forEach(function(pair) {
            const result = $2edc1eef02a7c199$var$utils.pairiteration(pair.left, pair.right, curveIntersectionThreshold);
            if (result.length > 0) intersections2 = intersections2.concat(result);
        });
        return intersections2;
    }
    arcs(errorThreshold) {
        errorThreshold = errorThreshold || 0.5;
        return this._iterate(errorThreshold, []);
    }
    _error(pc, np1, s, e) {
        const q = (e - s) / 4, c1 = this.get(s + q), c2 = this.get(e - q), ref = $2edc1eef02a7c199$var$utils.dist(pc, np1), d1 = $2edc1eef02a7c199$var$utils.dist(pc, c1), d2 = $2edc1eef02a7c199$var$utils.dist(pc, c2);
        return $2edc1eef02a7c199$var$abs3(d1 - ref) + $2edc1eef02a7c199$var$abs3(d2 - ref);
    }
    _iterate(errorThreshold, circles) {
        let t_s = 0, t_e = 1, safety;
        do {
            safety = 0;
            t_e = 1;
            let np1 = this.get(t_s), np2, np3, arc, prev_arc;
            let curr_good = false, prev_good = false, done;
            let t_m = t_e, prev_e = 1, step = 0;
            do {
                prev_good = curr_good;
                prev_arc = arc;
                t_m = (t_s + t_e) / 2;
                step++;
                np2 = this.get(t_m);
                np3 = this.get(t_e);
                arc = $2edc1eef02a7c199$var$utils.getccenter(np1, np2, np3);
                arc.interval = {
                    start: t_s,
                    end: t_e
                };
                let error = this._error(arc, np1, t_s, t_e);
                curr_good = error <= errorThreshold;
                done = prev_good && !curr_good;
                if (!done) prev_e = t_e;
                if (curr_good) {
                    if (t_e >= 1) {
                        arc.interval.end = prev_e = 1;
                        prev_arc = arc;
                        if (t_e > 1) {
                            let d = {
                                x: arc.x + arc.r * $2edc1eef02a7c199$var$cos3(arc.e),
                                y: arc.y + arc.r * $2edc1eef02a7c199$var$sin3(arc.e)
                            };
                            arc.e += $2edc1eef02a7c199$var$utils.angle({
                                x: arc.x,
                                y: arc.y
                            }, d, this.get(1));
                        }
                        break;
                    }
                    t_e = t_e + (t_e - t_s) / 2;
                } else t_e = t_m;
            }while (!done && safety++ < 100);
            if (safety >= 100) break;
            prev_arc = prev_arc ? prev_arc : arc;
            circles.push(prev_arc);
            t_s = prev_e;
        }while (t_e < 1);
        return circles;
    }
};
// src/geometry/rect/FromTopLeft.ts
var $2edc1eef02a7c199$export$ebf8d3595f30628 = (origin, width, height)=>{
    $2edc1eef02a7c199$export$5caca1faed27694e(width, `width`);
    $2edc1eef02a7c199$export$5caca1faed27694e(height, `height`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(origin, `origin`);
    return {
        x: origin.x,
        y: origin.y,
        width: width,
        height: height
    };
};
// src/geometry/bezier/Guard.ts
var $2edc1eef02a7c199$export$9e33c9da719c393 = (path)=>path.quadratic !== void 0;
var $2edc1eef02a7c199$export$77290801a62f77a2 = (path)=>path.cubic1 !== void 0 && path.cubic2 !== void 0;
// src/geometry/bezier/index.ts
var $2edc1eef02a7c199$export$b1e639a4c61456b1 = (start, end, bend = 0)=>{
    if (Number.isNaN(bend)) throw new Error(`bend is NaN`);
    if (bend < -1 || bend > 1) throw new Error(`Expects bend range of -1 to 1`);
    const middle = $2edc1eef02a7c199$export$89e29e4ab65e70a9(0.5, start, end);
    let target = middle;
    if (end.y < start.y) target = bend > 0 ? {
        x: Math.min(start.x, end.x),
        y: Math.min(start.y, end.y)
    } : {
        x: Math.max(start.x, end.x),
        y: Math.max(start.y, end.y)
    };
    else target = bend > 0 ? {
        x: Math.max(start.x, end.x),
        y: Math.min(start.y, end.y)
    } : {
        x: Math.min(start.x, end.x),
        y: Math.max(start.y, end.y)
    };
    const handle = $2edc1eef02a7c199$export$89e29e4ab65e70a9(Math.abs(bend), middle, target);
    return $2edc1eef02a7c199$var$quadratic(start, end, handle);
};
var $2edc1eef02a7c199$var$interpolator = (q)=>{
    const bzr = $2edc1eef02a7c199$export$77290801a62f77a2(q) ? new $2edc1eef02a7c199$var$Bezier(q.a.x, q.a.y, q.cubic1.x, q.cubic1.y, q.cubic2.x, q.cubic2.y, q.b.x, q.b.y) : new $2edc1eef02a7c199$var$Bezier(q.a, q.quadratic, q.b);
    return (amount)=>bzr.compute(amount);
};
var $2edc1eef02a7c199$var$quadraticToSvgString = (start, end, handle)=>[
        `M ${start.x} ${start.y} Q ${handle.x} ${handle.y} ${end.x} ${end.y}`
    ];
var $2edc1eef02a7c199$export$440836a238ff8548 = (cubicOrQuadratic)=>{
    if ($2edc1eef02a7c199$export$77290801a62f77a2(cubicOrQuadratic)) return $2edc1eef02a7c199$var$cubicToPath(cubicOrQuadratic);
    else if ($2edc1eef02a7c199$export$9e33c9da719c393(cubicOrQuadratic)) return $2edc1eef02a7c199$var$quadratictoPath(cubicOrQuadratic);
    else throw new Error(`Unknown bezier type`);
};
var $2edc1eef02a7c199$var$cubic = (start, end, cubic1, cubic2)=>({
        a: Object.freeze(start),
        b: Object.freeze(end),
        cubic1: Object.freeze(cubic1),
        cubic2: Object.freeze(cubic2)
    });
var $2edc1eef02a7c199$var$cubicToPath = (cubic2)=>{
    const { a: a, cubic1: cubic1, cubic2: cubic22, b: b } = cubic2;
    const bzr = new $2edc1eef02a7c199$var$Bezier(a, cubic1, cubic22, b);
    return Object.freeze({
        ...cubic2,
        length: ()=>bzr.length(),
        interpolate: (t2)=>bzr.compute(t2),
        nearest: (_)=>{
            throw new Error(`not implemented`);
        },
        bbox: ()=>{
            const { x: x, y: y } = bzr.bbox();
            const xSize = x.size;
            const ySize = y.size;
            if (xSize === void 0) throw new Error(`x.size not present on calculated bbox`);
            if (ySize === void 0) throw new Error(`x.size not present on calculated bbox`);
            return $2edc1eef02a7c199$export$ebf8d3595f30628({
                x: x.min,
                y: y.min
            }, xSize, ySize);
        },
        relativePosition: (_point, _intersectionThreshold)=>{
            throw new Error(`Not implemented`);
        },
        distanceToPoint: (_point)=>{
            throw new Error(`Not implemented`);
        },
        toSvgString: ()=>[
                `brrup`
            ],
        kind: `bezier/cubic`
    });
};
var $2edc1eef02a7c199$var$quadratic = (start, end, handle)=>({
        a: Object.freeze(start),
        b: Object.freeze(end),
        quadratic: Object.freeze(handle)
    });
var $2edc1eef02a7c199$var$quadratictoPath = (quadraticBezier)=>{
    const { a: a, b: b, quadratic: quadratic2 } = quadraticBezier;
    const bzr = new $2edc1eef02a7c199$var$Bezier(a, quadratic2, b);
    return Object.freeze({
        ...quadraticBezier,
        length: ()=>bzr.length(),
        interpolate: (t2)=>bzr.compute(t2),
        nearest: (_)=>{
            throw new Error(`not implemented`);
        },
        bbox: ()=>{
            const { x: x, y: y } = bzr.bbox();
            const xSize = x.size;
            const ySize = y.size;
            if (xSize === void 0) throw new Error(`x.size not present on calculated bbox`);
            if (ySize === void 0) throw new Error(`x.size not present on calculated bbox`);
            return $2edc1eef02a7c199$export$ebf8d3595f30628({
                x: x.min,
                y: y.min
            }, xSize, ySize);
        },
        distanceToPoint: (_point)=>{
            throw new Error(`Not implemented`);
        },
        relativePosition: (_point, _intersectionThreshold)=>{
            throw new Error(`Not implemented`);
        },
        toString: ()=>bzr.toString(),
        toSvgString: ()=>$2edc1eef02a7c199$var$quadraticToSvgString(a, b, quadratic2),
        kind: `bezier/quadratic`
    });
};
// src/modulation/easing/Line.ts
var $2edc1eef02a7c199$var$line = (bend = 0, warp = 0)=>{
    const max5 = 1;
    const cubicB = {
        x: (0, $8a5cbeb1c6ae1b41$export$dcdf75081b88279d)(bend, -1, 1, 0, max5),
        y: (0, $8a5cbeb1c6ae1b41$export$dcdf75081b88279d)(bend, -1, 1, max5, 0)
    };
    let cubicA = $2edc1eef02a7c199$var$interpolate2(Math.abs(bend), $2edc1eef02a7c199$export$1f74963c34e8bfec, cubicB);
    if (bend !== 0 && warp > 0) {
        if (bend > 0) cubicA = $2edc1eef02a7c199$var$interpolate2(warp, cubicA, {
            x: 0,
            y: cubicB.x * 2
        });
        else cubicA = $2edc1eef02a7c199$var$interpolate2(warp, cubicA, {
            x: cubicB.y * 2,
            y: 0
        });
    }
    const bzr = $2edc1eef02a7c199$var$cubic($2edc1eef02a7c199$export$1f74963c34e8bfec, $2edc1eef02a7c199$var$Unit, cubicA, cubicB);
    const inter = $2edc1eef02a7c199$var$interpolator(bzr);
    return (value)=>inter(value);
};
// src/modulation/ModulatorTimed.ts
var $2edc1eef02a7c199$export$2da9be4cfdb689b1 = (fn, duration)=>{
    (0, $876c839e98abd7e2$export$5d7109937b0a2906)(fn, `fn`);
    let relative2;
    return ()=>{
        if (relative2 === void 0) relative2 = (0, $29a41e51920ca8b4$export$d46c4dddecc8fa49)(duration, {
            clampValue: true
        });
        return fn(relative2());
    };
};
var $2edc1eef02a7c199$export$819ea8fb0cfe1b24 = (fn, duration)=>{
    (0, $876c839e98abd7e2$export$5d7109937b0a2906)(fn, `fn`);
    const timer = (0, $29a41e51920ca8b4$export$14b940200a0da60a)();
    const durationMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(duration);
    if (durationMs === void 0) throw new Error(`Param 'duration' not provided`);
    const relativeTimer = (0, $29a41e51920ca8b4$export$f0e7d1106eeabbe6)(durationMs, {
        timer: timer,
        clampValue: true
    });
    return (0, $29a41e51920ca8b4$export$4dad9723f7b779bd)(fn, relativeTimer);
};
var $2edc1eef02a7c199$export$e8e6acc9efcde79f = (fn, totalTicks)=>{
    (0, $876c839e98abd7e2$export$5d7109937b0a2906)(fn, `fn`);
    let relative2;
    return ()=>{
        if (relative2 === void 0) relative2 = (0, $29a41e51920ca8b4$export$e37aa364174fb88f)(totalTicks, {
            clampValue: true
        });
        return fn(relative2());
    };
};
var $2edc1eef02a7c199$export$f906a528629f2e0c = (fn, durationTicks)=>{
    (0, $876c839e98abd7e2$export$5d7109937b0a2906)(fn, `fn`);
    const timer = (0, $29a41e51920ca8b4$export$8a83a8129259072d)();
    const relativeTimer = (0, $29a41e51920ca8b4$export$f0e7d1106eeabbe6)(durationTicks, {
        timer: timer,
        clampValue: true
    });
    return (0, $29a41e51920ca8b4$export$4dad9723f7b779bd)(fn, relativeTimer);
};
// src/modulation/easing/index.ts
var $2edc1eef02a7c199$var$create2 = (options)=>{
    let name = $2edc1eef02a7c199$var$resolveEasingName(options.name ?? `quintIn`);
    const fn = name ?? options.fn;
    if (!fn) throw new Error(`Either 'name' or 'fn' must be set`);
    if (`duration` in options) return $2edc1eef02a7c199$var$time2(fn, options.duration);
    else if (`ticks` in options) return $2edc1eef02a7c199$var$ticks2(fn, options.ticks);
    else throw new Error(`Expected 'duration' or 'ticks' in options`);
};
var $2edc1eef02a7c199$var$timeEasing = (nameOrFunction, duration)=>{
    const fn = $2edc1eef02a7c199$var$resolveEasingName(nameOrFunction);
    return $2edc1eef02a7c199$export$819ea8fb0cfe1b24(fn, duration);
};
var $2edc1eef02a7c199$var$time2 = (nameOrFunction, duration)=>{
    const fn = $2edc1eef02a7c199$var$resolveEasingName(nameOrFunction);
    return $2edc1eef02a7c199$export$2da9be4cfdb689b1(fn, duration);
};
var $2edc1eef02a7c199$var$ticks2 = (nameOrFunction, totalTicks)=>{
    const fn = $2edc1eef02a7c199$var$resolveEasingName(nameOrFunction);
    return $2edc1eef02a7c199$export$e8e6acc9efcde79f(fn, totalTicks);
};
var $2edc1eef02a7c199$var$tickEasing = (nameOrFunction, durationTicks)=>{
    const fn = $2edc1eef02a7c199$var$resolveEasingName(nameOrFunction);
    return $2edc1eef02a7c199$export$f906a528629f2e0c(fn, durationTicks);
};
var $2edc1eef02a7c199$var$resolveEasingName = (nameOrFunction)=>{
    const fn = typeof nameOrFunction === `function` ? nameOrFunction : $2edc1eef02a7c199$export$3988ae62b71be9a3(nameOrFunction);
    if (fn === void 0) {
        const error = typeof nameOrFunction === `string` ? new Error(`Easing function not found: '${nameOrFunction}'`) : new Error(`Easing function not found`);
        throw error;
    }
    return fn;
};
var $2edc1eef02a7c199$var$easingsMap;
var $2edc1eef02a7c199$export$3988ae62b71be9a3 = function(easingName) {
    (0, $876c839e98abd7e2$export$8eb398b02efaed4f)(easingName, `non-empty`, `easingName`);
    const found = $2edc1eef02a7c199$var$cacheEasings().get(easingName.toLowerCase());
    if (found === void 0) throw new Error(`Easing not found: '${easingName}'`);
    return found;
};
function $2edc1eef02a7c199$var$cacheEasings() {
    if ($2edc1eef02a7c199$var$easingsMap === void 0) {
        $2edc1eef02a7c199$var$easingsMap = /* @__PURE__ */ new Map();
        for (const [k, v] of Object.entries($2edc1eef02a7c199$var$EasingsNamed_exports))$2edc1eef02a7c199$var$easingsMap.set(k.toLowerCase(), v);
        return $2edc1eef02a7c199$var$easingsMap;
    } else return $2edc1eef02a7c199$var$easingsMap;
}
function* $2edc1eef02a7c199$var$getEasingNames() {
    const map3 = $2edc1eef02a7c199$var$cacheEasings();
    yield* map3.keys();
}
// src/numbers/Interpolate.ts
var $2edc1eef02a7c199$export$2c99c7b81f64b3e5 = Math.PI * 2;
function $2edc1eef02a7c199$export$4e4c1a907874f01(pos1, pos2, pos3, pos4) {
    let amountProcess;
    let limits = `clamp`;
    const handleAmount = (amount)=>{
        if (amountProcess) amount = amountProcess(amount);
        if (limits === void 0 || limits === `clamp`) amount = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(amount);
        else if (limits === `wrap`) {
            if (amount > 1) amount = amount % 1;
            else if (amount < 0) amount = 1 + amount % 1;
        }
        return amount;
    };
    const doTheEase = (_amt, _a, _b)=>{
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(_a, ``, `a`);
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(_b, ``, `b`);
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(_amt, ``, `amount`);
        _amt = handleAmount(_amt);
        return (1 - _amt) * _a + _amt * _b;
    };
    const readOpts = (o = {})=>{
        if (o.easing) {
            const easer = $2edc1eef02a7c199$export$3988ae62b71be9a3(o.easing);
            if (!easer) throw new Error(`Easing function '${o.easing}' not found`);
            amountProcess = easer;
        } else if (o.transform) {
            if (typeof o.transform !== `function`) throw new Error(`Param 'transform' is expected to be a function. Got: ${typeof o.transform}`);
            amountProcess = o.transform;
        }
        limits = o.limits ?? `clamp`;
    };
    const rawEase = (_amt, _a, _b)=>(1 - _amt) * _a + _amt * _b;
    if (typeof pos1 !== `number`) throw new TypeError(`First param is expected to be a number. Got: ${typeof pos1}`);
    if (typeof pos2 === `number`) {
        let a;
        let b;
        if (pos3 === void 0 || typeof pos3 === `object`) {
            a = pos1;
            b = pos2;
            readOpts(pos3);
            return (amount)=>doTheEase(amount, a, b);
        } else if (typeof pos3 === `number`) {
            a = pos2;
            b = pos3;
            readOpts(pos4);
            return doTheEase(pos1, a, b);
        } else throw new Error(`Values for 'a' and 'b' not defined`);
    } else if (pos2 === void 0 || typeof pos2 === `object`) {
        const amount = handleAmount(pos1);
        readOpts(pos2);
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(amount, ``, `amount`);
        return (aValue, bValue)=>rawEase(amount, aValue, bValue);
    }
}
var $2edc1eef02a7c199$export$c8b97d3b09cfcda6 = (incrementAmount, a = 0, b = 1, startInterpolationAt = 0, options)=>{
    let amount = startInterpolationAt;
    return (retargetB, retargetA)=>{
        if (retargetB !== void 0) b = retargetB;
        if (retargetA !== void 0) a = retargetA;
        if (amount >= 1) return b;
        const value = $2edc1eef02a7c199$export$4e4c1a907874f01(amount, a, b, options);
        amount += incrementAmount;
        return value;
    };
};
var $2edc1eef02a7c199$export$c71a20c38c3fd4e2 = (duration, a = 0, b = 1, options)=>{
    const durationProgression = (0, $29a41e51920ca8b4$export$d46c4dddecc8fa49)(duration, {
        clampValue: true
    });
    return (retargetB, retargetA)=>{
        const amount = durationProgression();
        if (retargetB !== void 0) b = retargetB;
        if (retargetA !== void 0) a = retargetA;
        if (amount >= 1) return b;
        const value = $2edc1eef02a7c199$export$4e4c1a907874f01(amount, a, b, options);
        return value;
    };
};
var $2edc1eef02a7c199$export$92c7c4f86cf692ac = (amount, aRadians, bRadians, options)=>{
    const t2 = $2edc1eef02a7c199$export$4997ffc0176396a6(bRadians - aRadians, 0, $2edc1eef02a7c199$export$2c99c7b81f64b3e5);
    return $2edc1eef02a7c199$export$4e4c1a907874f01(amount, aRadians, aRadians + (t2 > Math.PI ? t2 - $2edc1eef02a7c199$export$2c99c7b81f64b3e5 : t2), options);
};
// src/rx/ops/Interpolate.ts
function $2edc1eef02a7c199$export$402e16690d69fb88(input, options = {}) {
    const amount = options.amount ?? 0.1;
    const snapAt = options.snapAt ?? 0.99;
    const i = $2edc1eef02a7c199$export$4e4c1a907874f01(amount, options);
    return $2edc1eef02a7c199$export$9be32a0a2ad8b67(input, (previous, target)=>{
        const v = i(previous, target);
        if (target > previous) {
            if (v / target >= snapAt) return target;
        }
        return v;
    });
}
// src/rx/ops/Math.ts
function $2edc1eef02a7c199$export$22cda90bd12095a9(input, options) {
    const p = $2edc1eef02a7c199$export$8960430cfd85939f();
    return $2edc1eef02a7c199$var$process(p, `max`, input, options);
}
function $2edc1eef02a7c199$export$b393be5a551404be(input, options) {
    const p = $2edc1eef02a7c199$export$96ec731ed4dcb222();
    return $2edc1eef02a7c199$var$process(p, `min`, input, options);
}
function $2edc1eef02a7c199$export$5c3bbf40eb9d4622(input, options) {
    const p = $2edc1eef02a7c199$export$cc6710ee5f037d57();
    return $2edc1eef02a7c199$var$process(p, `average`, input, options);
}
function $2edc1eef02a7c199$export$8cb7414e874a9718(input, options) {
    const p = $2edc1eef02a7c199$export$8a63f25cc62965f1();
    return $2edc1eef02a7c199$var$process(p, `sum`, input, options);
}
function $2edc1eef02a7c199$export$7ed03ecedcf10c1(input, options = {}) {
    const countArrayItems = options.countArrayItems ?? true;
    const p = $2edc1eef02a7c199$export$344c33cac828114d(countArrayItems);
    return $2edc1eef02a7c199$var$process(p, `tally`, input, options);
}
function $2edc1eef02a7c199$export$7bfb89b13199fa43(input, rank3, options) {
    const p = $2edc1eef02a7c199$export$fbc8bcd33b574fbc(rank3, options);
    return $2edc1eef02a7c199$var$process(p, `rank`, input, options);
}
function $2edc1eef02a7c199$var$process(processor, annotationField, input, options = {}) {
    const annotate2 = options.annotate;
    let previous;
    const skipUndefined = options.skipUndefined ?? true;
    const skipIdentical = options.skipIdentical ?? true;
    const upstream = $2edc1eef02a7c199$var$initUpstream(input, {
        ...options,
        onValue (value) {
            const x = processor(value);
            if (x === void 0 && skipUndefined) return;
            if (skipIdentical && x === previous) return;
            previous = x;
            if (annotate2) {
                const ret = {
                    value: value
                };
                ret[annotationField] = x;
                upstream.set(ret);
            } else upstream.set(x);
        }
    });
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
// src/rx/ops/Pipe.ts
var $2edc1eef02a7c199$export$a4627e546088548d = (...streams)=>{
    const event2 = $2edc1eef02a7c199$var$initStream();
    const unsubs = [];
    const performDispose = (reason)=>{
        for (const s of streams)if (!s.isDisposed) s.dispose(reason);
        for (const s of unsubs)s();
        event2.dispose(reason);
    };
    for(let index = 0; index < streams.length; index++)unsubs.push(streams[index].on((message)=>{
        const isLast = index === streams.length - 1;
        if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
            if (isLast) event2.set(message.value);
            else streams[index + 1].set(message.value);
        } else if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) performDispose(`Upstream disposed`);
    }));
    return {
        on: event2.on,
        onValue: event2.onValue,
        dispose (reason) {
            performDispose(reason);
        },
        isDisposed () {
            return event2.isDisposed();
        }
    };
};
// src/rx/ops/SingleFromArray.ts
function $2edc1eef02a7c199$export$a5a4a5cffa78c0a4(source, options = {}) {
    const order = options.order ?? `default`;
    if (!options.at && !options.predicate) throw new Error(`Options must have 'predicate' or 'at' fields`);
    let preprocess = (values)=>values;
    if (order === `random`) preprocess = (0, $7b02fea154055fc0$export$448332262467e042);
    else if (typeof order === `function`) preprocess = (values)=>values.toSorted(order);
    const upstream = $2edc1eef02a7c199$var$initUpstream(source, {
        onValue (values) {
            values = preprocess(values);
            if (options.predicate) {
                for (const v of values)if (options.predicate(v)) upstream.set(v);
            } else if (options.at) upstream.set(values.at(options.at));
        }
    });
    return upstream;
}
// src/rx/ops/Split.ts
var $2edc1eef02a7c199$export$65980d18b75784e2 = (rxOrSource, options = {})=>{
    const quantity = options.quantity ?? 2;
    const outputs = [];
    const source = $2edc1eef02a7c199$export$6b1de85efae8a879(rxOrSource);
    for(let index = 0; index < quantity; index++)outputs.push($2edc1eef02a7c199$var$initUpstream(source, {
        disposeIfSourceDone: true,
        lazy: `initial`
    }));
    return outputs;
};
var $2edc1eef02a7c199$export$ecb39c0370b0b52d = (rxOrSource, labels)=>{
    const source = $2edc1eef02a7c199$export$6b1de85efae8a879(rxOrSource);
    const t2 = {};
    for (const label of labels)t2[label] = $2edc1eef02a7c199$var$initUpstream(source, {
        lazy: `initial`,
        disposeIfSourceDone: true
    });
    return t2;
};
// src/rx/ops/Switcher.ts
var $2edc1eef02a7c199$export$8987e38cfd004b13 = (reactiveOrSource, cases, options = {})=>{
    const match = options.match ?? `first`;
    const source = $2edc1eef02a7c199$export$6b1de85efae8a879(reactiveOrSource);
    let disposed = false;
    const t2 = {};
    for (const label of Object.keys(cases))t2[label] = $2edc1eef02a7c199$var$initStream();
    const performDispose = ()=>{
        if (disposed) return;
        unsub();
        disposed = true;
        for (const stream of Object.values(t2))stream.dispose(`switcher source dispose`);
    };
    const unsub = source.on((message)=>{
        if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
            for (const [lbl, pred] of Object.entries(cases))if (pred(message.value)) {
                t2[lbl].set(message.value);
                if (match === `first`) break;
            }
        } else if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) performDispose();
    });
    return t2;
};
// src/rx/ops/SyncToArray.ts
function $2edc1eef02a7c199$export$5eb154d8c1f8350(reactiveSources, options = {}) {
    const onSourceDone = options.onSourceDone ?? `break`;
    const finalValue = options.finalValue ?? `undefined`;
    const maximumWait = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.maximumWait, 2e3);
    let watchdog;
    const data = [];
    const states = reactiveSources.map((source)=>({
            finalData: void 0,
            done: false,
            source: $2edc1eef02a7c199$export$6b1de85efae8a879(source),
            unsub: ()=>{}
        }));
    const unsubscribe = ()=>{
        for (const s of states){
            s.unsub();
            s.unsub = ()=>{};
        }
    };
    const isDataSetComplete = ()=>{
        for(let index = 0; index < data.length; index++){
            if (onSourceDone === `allow` && states[index].done) continue;
            if (data[index] === void 0) return false;
        }
        return true;
    };
    const hasIncompleteSource = ()=>states.some((s)=>!s.done);
    const resetDataSet = ()=>{
        for(let index = 0; index < data.length; index++){
            if (finalValue === `last` && states[index].done) continue;
            data[index] = void 0;
        }
    };
    const onWatchdog = ()=>{
        done(`Sync timeout exceeded (${maximumWait.toString()})`);
    };
    const done = (reason)=>{
        if (watchdog) clearTimeout(watchdog);
        unsubscribe();
        event2.dispose(reason);
    };
    const init = ()=>{
        watchdog = setTimeout(onWatchdog, maximumWait);
        for (const [index, state] of states.entries()){
            data[index] = void 0;
            state.unsub = state.source.on((valueChanged)=>{
                if ((0, $f53657e65b61d2bb$export$3851969427163052)(valueChanged)) {
                    if (valueChanged.signal === `done`) {
                        state.finalData = data[index];
                        state.unsub();
                        state.done = true;
                        state.unsub = ()=>{};
                        if (finalValue === `undefined`) data[index] = void 0;
                        if (onSourceDone === `break`) {
                            done(`Source '${index.toString()}' done, and onSourceDone:'break' is set`);
                            return;
                        }
                        if (!hasIncompleteSource()) {
                            done(`All sources done`);
                            return;
                        }
                    }
                    return;
                }
                data[index] = valueChanged.value;
                if (isDataSetComplete()) {
                    event2.set([
                        ...data
                    ]);
                    resetDataSet();
                    if (watchdog) clearTimeout(watchdog);
                    watchdog = setTimeout(onWatchdog, maximumWait);
                }
            });
        }
    };
    const event2 = $2edc1eef02a7c199$var$initStream({
        onFirstSubscribe () {
            unsubscribe();
            init();
        },
        onNoSubscribers () {
            if (watchdog) clearTimeout(watchdog);
            unsubscribe();
        }
    });
    return {
        dispose: event2.dispose,
        isDisposed: event2.isDisposed,
        on: event2.on,
        onValue: event2.onValue
    };
}
// src/rx/ops/SyncToObject.ts
function $2edc1eef02a7c199$export$b32b2cebf6eb1280(reactiveSources, options = {}) {
    const keys = Object.keys(reactiveSources);
    const values = Object.values(reactiveSources);
    const s = $2edc1eef02a7c199$export$5eb154d8c1f8350(values, options);
    const st = $2edc1eef02a7c199$export$51186ad6e864892a(s, (streamValues)=>{
        return (0, $3ffa4b3bf3c5db47$export$c2d6f401933fc426)(keys, streamValues);
    });
    return st;
}
// src/rx/ops/Tap.ts
function $2edc1eef02a7c199$export$b6175151fde1dc87(input, ...processors) {
    const inputStream = $2edc1eef02a7c199$export$6b1de85efae8a879(input);
    const chain = $2edc1eef02a7c199$var$flow(...processors);
    inputStream.onValue((value)=>{
        chain(value);
    });
    return inputStream;
}
function $2edc1eef02a7c199$export$bedfced534e7bc06(input, diverged) {
    const inputStream = $2edc1eef02a7c199$export$6b1de85efae8a879(input);
    inputStream.onValue((value)=>{
        diverged.set(value);
    });
    return inputStream;
}
var $2edc1eef02a7c199$export$b6abe60b3da98fc9 = (input, ...ops)=>{
    for (const op of ops)input = op(input);
    return input;
};
// src/rx/ops/Throttle.ts
function $2edc1eef02a7c199$export$de363e709c412c8a(throttleSource, options = {}) {
    const elapsed2 = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.elapsed, 0);
    let lastFire = performance.now();
    let lastValue;
    const upstream = $2edc1eef02a7c199$var$initUpstream(throttleSource, {
        ...options,
        onValue (value) {
            lastValue = value;
            trigger();
        }
    });
    const trigger = ()=>{
        const now = performance.now();
        if (elapsed2 > 0 && now - lastFire > elapsed2) {
            lastFire = now;
            if (lastValue !== void 0) upstream.set(lastValue);
        }
    };
    return $2edc1eef02a7c199$var$toReadable(upstream);
}
// src/rx/ops/TimeoutValue.ts
function $2edc1eef02a7c199$export$8862a6a079f688d3(source, options) {
    let timer;
    const immediate = options.immediate ?? true;
    const repeat2 = options.repeat ?? false;
    const timeoutMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.interval, 1e3);
    if (!(0, $f53657e65b61d2bb$export$e5ddfc48b47912c)(options)) throw new Error(`Param 'options' does not contain trigger 'value' or 'fn' fields`);
    const sendFallback = ()=>{
        const [value, done] = (0, $f53657e65b61d2bb$export$17d169adcb1dceb3)(options);
        if (done) events.dispose(`Trigger completed`);
        else {
            if (events.isDisposed()) return;
            events.set(value);
            if (repeat2) timer = setTimeout(sendFallback, timeoutMs);
        }
    };
    const events = $2edc1eef02a7c199$var$initUpstream(source, {
        disposeIfSourceDone: true,
        // Received a value from upstream source
        onValue (v) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(sendFallback, timeoutMs);
            events.set(v);
        },
        onDispose () {
            if (timer) clearTimeout(timer);
        }
    });
    if (immediate && !timer) timer = setTimeout(sendFallback, timeoutMs);
    return events;
}
// src/rx/ops/TimeoutPing.ts
function $2edc1eef02a7c199$export$23da8b73b6fbb5b7(source, options) {
    let timer;
    const rx = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
    const abort = options.abort;
    const timeoutMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options, 1e3);
    const sendPing = ()=>{
        if (abort?.aborted || rx.isDisposed()) {
            off();
            return;
        }
        if ((0, $f53657e65b61d2bb$export$85c51e1e5198ecb8)(rx)) rx.ping();
        timer = setTimeout(sendPing, timeoutMs);
    };
    const cancel = ()=>{
        if (timer) clearTimeout(timer);
    };
    const off = rx.on((msg)=>{
        if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(msg)) {
            cancel();
            timer = setTimeout(sendPing, timeoutMs);
        } else if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(msg)) {
            off();
            cancel();
        }
    });
    timer = setTimeout(sendPing, timeoutMs);
    return rx;
}
// src/rx/ops/ValueToPing.ts
function $2edc1eef02a7c199$export$12a06accaa98bb2f(source, target, options = {}) {
    const lazy = options.lazy ?? `initial`;
    const signal = options.signal;
    const sourceRx = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
    const gate = options.gate ?? ((value)=>true);
    let upstreamOff;
    let downstreamOff;
    if (signal) signal.addEventListener(`abort`, ()=>{
        done(`Abort signal ${signal.reason}`);
    }, {
        once: true
    });
    const events = $2edc1eef02a7c199$var$initStream({
        onFirstSubscribe () {
            if (lazy !== `never` && upstreamOff === void 0) start();
        },
        onNoSubscribers () {
            if (lazy === `very` && upstreamOff !== void 0) {
                upstreamOff();
                upstreamOff = void 0;
            }
        }
    });
    const start = ()=>{
        upstreamOff = sourceRx.on((message)=>{
            if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) done(`Upstream closed`);
            else if ((0, $f53657e65b61d2bb$export$3851969427163052)(message)) events.signal(message.signal);
            else if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
                if (gate(message.value)) target.ping();
            }
        });
        downstreamOff = target.on((message)=>{
            if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) done(`Downstream closed`);
            else if ((0, $f53657e65b61d2bb$export$3851969427163052)(message)) events.signal(message.signal, message.context);
            else if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) events.set(message.value);
        });
    };
    const done = (reason)=>{
        events.dispose(reason);
        if (upstreamOff) upstreamOff();
        if (downstreamOff) downstreamOff();
    };
    if (lazy === `never`) start();
    return events;
}
// src/rx/ops/WithValue.ts
function $2edc1eef02a7c199$export$3a92ed5088d25bc6(input, options) {
    let lastValue = options.initial;
    const upstream = $2edc1eef02a7c199$var$initUpstream(input, {
        ...options,
        onValue (value) {
            lastValue = value;
            upstream.set(value);
        }
    });
    const readable = $2edc1eef02a7c199$var$toReadable(upstream);
    return {
        ...readable,
        last () {
            return lastValue;
        }
    };
}
// src/collections/graphs/DirectedGraph.ts
var $2edc1eef02a7c199$export$956d6c90d074b61e = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$956d6c90d074b61e, {
    adjacentVertices: ()=>$2edc1eef02a7c199$var$adjacentVertices,
    areAdjacent: ()=>$2edc1eef02a7c199$var$areAdjacent,
    bfs: ()=>$2edc1eef02a7c199$var$bfs,
    clone: ()=>$2edc1eef02a7c199$var$clone,
    connect: ()=>$2edc1eef02a7c199$var$connect,
    connectTo: ()=>$2edc1eef02a7c199$var$connectTo,
    connectWithEdges: ()=>$2edc1eef02a7c199$var$connectWithEdges,
    createVertex: ()=>$2edc1eef02a7c199$var$createVertex,
    dfs: ()=>$2edc1eef02a7c199$var$dfs,
    disconnect: ()=>$2edc1eef02a7c199$var$disconnect,
    distance: ()=>$2edc1eef02a7c199$var$distance2,
    distanceDefault: ()=>$2edc1eef02a7c199$var$distanceDefault,
    dumpGraph: ()=>$2edc1eef02a7c199$var$dumpGraph,
    edges: ()=>$2edc1eef02a7c199$var$edges,
    get: ()=>$2edc1eef02a7c199$var$get2,
    getCycles: ()=>$2edc1eef02a7c199$var$getCycles,
    getOrCreate: ()=>$2edc1eef02a7c199$var$getOrCreate,
    getOrFail: ()=>$2edc1eef02a7c199$var$getOrFail,
    graph: ()=>$2edc1eef02a7c199$var$graph,
    graphFromVertices: ()=>$2edc1eef02a7c199$var$graphFromVertices,
    hasKey: ()=>$2edc1eef02a7c199$var$hasKey,
    hasNoOuts: ()=>$2edc1eef02a7c199$var$hasNoOuts,
    hasOnlyOuts: ()=>$2edc1eef02a7c199$var$hasOnlyOuts,
    hasOut: ()=>$2edc1eef02a7c199$var$hasOut,
    isAcyclic: ()=>$2edc1eef02a7c199$var$isAcyclic,
    pathDijkstra: ()=>$2edc1eef02a7c199$var$pathDijkstra,
    toAdjacencyMatrix: ()=>$2edc1eef02a7c199$var$toAdjacencyMatrix,
    topologicalSort: ()=>$2edc1eef02a7c199$var$topologicalSort,
    transitiveReduction: ()=>$2edc1eef02a7c199$var$transitiveReduction,
    updateGraphVertex: ()=>$2edc1eef02a7c199$var$updateGraphVertex,
    vertexHasOut: ()=>$2edc1eef02a7c199$var$vertexHasOut,
    vertices: ()=>$2edc1eef02a7c199$var$vertices
});
// src/collections/queue/PriorityMutable.ts
var $2edc1eef02a7c199$export$70b565fa5666e9db = class extends (0, $3f856c338f7c6dcb$export$24f44af47d707e8e) {
    constructor(opts = {}){
        if (opts.eq === void 0) opts = {
            ...opts,
            eq: (a, b)=>{
                return (0, $847987b26b102cb8$export$22f6c405afa58f6b)(a.item, b.item);
            }
        };
        super(opts);
    }
    /**
   * Adds an item with a given priority
   * @param item Item
   * @param priority Priority (higher numeric value means higher priority)
   */ enqueueWithPriority(item, priority2) {
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(priority2, `positive`);
        super.enqueue({
            item: item,
            priority: priority2
        });
    }
    changePriority(item, priority2, addIfMissing = false, eq) {
        if (item === void 0) throw new Error(`Item cannot be undefined`);
        let toDelete;
        for (const d of this.data){
            if (eq) {
                if (eq(d.item, item)) {
                    toDelete = d;
                    break;
                }
            } else if (this.eq(d, {
                item: item,
                priority: 0
            })) {
                toDelete = d;
                break;
            }
        }
        if (toDelete === void 0 && !addIfMissing) throw new Error(`Item not found in priority queue. Item: ${JSON.stringify(item)}`);
        if (toDelete !== void 0) this.removeWhere((item2)=>toDelete === item2);
        this.enqueueWithPriority(item, priority2);
    }
    dequeueMax() {
        const m = (0, $a67c984aa26c5d8f$export$39bc47f2f22de526)(this.data, (v)=>v.priority);
        if (m === void 0) return;
        this.removeWhere((item)=>item === m);
        return m.item;
    }
    dequeueMin() {
        const m = (0, $a67c984aa26c5d8f$export$96ec731ed4dcb222)(this.data, (v)=>v.priority);
        if (m === void 0) return;
        this.removeWhere((item)=>item === m);
        return m.item;
    }
    peekMax() {
        const m = (0, $a67c984aa26c5d8f$export$39bc47f2f22de526)(this.data, (v)=>v.priority);
        if (m === void 0) return;
        return m.item;
    }
    peekMin() {
        const m = (0, $a67c984aa26c5d8f$export$96ec731ed4dcb222)(this.data, (v)=>v.priority);
        if (m === void 0) return;
        return m.item;
    }
};
function $2edc1eef02a7c199$export$a5dca36e9379b9de(opts = {}) {
    return new $2edc1eef02a7c199$export$70b565fa5666e9db(opts);
}
// src/collections/Table.ts
var $2edc1eef02a7c199$export$54ec01a60f47d33d = class {
    constructor(){
        this.rows = [];
        this.rowLabels = [];
        this.colLabels = [];
    }
    labelColumns(...labels) {
        this.colLabels = labels;
    }
    labelColumn(columnNumber, label) {
        this.colLabels[columnNumber] = label;
    }
    getColumnLabelIndex(label) {
        for (const [index, l] of this.colLabels.entries()){
            if (l === label) return index;
        }
    }
    print() {
        console.table([
            ...this.rowsWithLabelsObject()
        ]);
    }
    *rowsWithLabelsArray() {
        for(let index = 0; index < this.rows.length; index++){
            const labelledRow = this.getRowWithLabelsArray(index);
            yield labelledRow;
        }
    }
    /**
   * Return a copy of table as nested array
   * ```js
   * const t = new Table();
   * // add stuff
   * // ...
   * const m = t.asArray();
   * for (const row of m) {
   *  for (const colValue of row) {
   *    // iterate over all column values for this row
   *  }
   * }
   * ```
   * 
   * Alternative: get value at row Y and column X
   * ```js
   * const value = m[y][x];
   * ```
   * @returns 
   */ asArray() {
        const r = [];
        for (const row of this.rows)if (row === void 0) r.push([]);
        else r.push([
            ...row
        ]);
        return r;
    }
    /**
   * Return the number of rows
   */ get rowCount() {
        return this.rows.length;
    }
    /**
   * Return the maximum number of columns in any row
   */ get columnCount() {
        const lengths = this.rows.map((row)=>row.length);
        return Math.max(...lengths);
    }
    *rowsWithLabelsObject() {
        for(let index = 0; index < this.rows.length; index++){
            const labelledRow = this.getRowWithLabelsObject(index);
            yield labelledRow;
        }
    }
    labelRows(...labels) {
        this.rowLabels = labels;
    }
    appendRow(...data) {
        this.rows.push(data);
    }
    getRowWithLabelsArray(rowNumber) {
        const row = this.rows.at(rowNumber);
        if (row === void 0) return void 0;
        return row.map((value, index)=>[
                this.colLabels.at(index),
                value
            ]);
    }
    /**
   * Return a row of objects. Keys use the column labels.
   * 
   * ```js
   * const row = table.getRowWithLabelsObject(10);
   * // eg:
   * // [{ colour: red, size: 10}, { colour: blue, size: 20 }]
   * ```
   * @param rowNumber 
   * @returns 
   */ getRowWithLabelsObject(rowNumber) {
        const row = this.rows.at(rowNumber);
        if (row === void 0) return void 0;
        const object2 = {};
        for(let index = 0; index < this.colLabels.length; index++){
            const label = this.colLabels.at(index) ?? index.toString();
            object2[label] = row[index];
        }
        return object2;
    }
    /**
   * Gets or creates a row at `rowNumber`.
   * @param rowNumber 
   * @returns 
   */ getOrCreateRow(rowNumber) {
        let row = this.rows.at(rowNumber);
        if (row === void 0) {
            row = [];
            this.rows[rowNumber] = row;
        }
        return row;
    }
    /**
   * Gets the values at `rowNumber`
   * @param rowNumber 
   * @returns 
   */ row(rowNumber) {
        return this.rows.at(rowNumber);
    }
    /**
   * Set the value of row,column to `value`
   * @param rowNumber 
   * @param columnNumber 
   * @param value 
   */ set(rowNumber, columnNumber, value) {
        const row = this.getOrCreateRow(rowNumber);
        row[columnNumber] = value;
    }
    get(rowNumber, column) {
        const row = this.getOrCreateRow(rowNumber);
        const index = typeof column === `number` ? column : this.getColumnLabelIndex(column);
        if (index === void 0) throw new Error(`Column not found: ${column}`);
        return row[index];
    }
    /**
   * For a given row number, set all the columns to `value`.
   * `cols` gives the number of columns to set
   * @param rowNumber 
   * @param cols 
   * @param value 
   */ setRow(rowNumber, cols, value) {
        const row = this.getOrCreateRow(rowNumber);
        for(let columnNumber = 0; columnNumber < cols; columnNumber++)row[columnNumber] = value;
    }
};
// src/collections/graphs/DirectedGraph.ts
var $2edc1eef02a7c199$var$createVertex = (id)=>{
    return {
        id: id,
        out: []
    };
};
function $2edc1eef02a7c199$var$hasKey(graph2, key) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    return graph2.vertices.has(key);
}
function $2edc1eef02a7c199$var$get2(graph2, key) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    (0, $876c839e98abd7e2$export$8eb398b02efaed4f)(key, `non-empty`, `key`);
    return graph2.vertices.get(key);
}
function $2edc1eef02a7c199$var$toAdjacencyMatrix(graph2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const v = [
        ...graph2.vertices.values()
    ];
    const table = new $2edc1eef02a7c199$export$54ec01a60f47d33d();
    table.labelColumns(...v.map((vv)=>vv.id));
    table.labelRows(...v.map((vv)=>vv.id));
    for(let i = 0; i < v.length; i++){
        table.setRow(i, v.length, false);
        const ii = v[i];
        for (const [j, jj] of v.entries())if (ii.out.some((o)=>o.id === jj.id)) table.set(i, j, true);
    }
    return table;
}
var $2edc1eef02a7c199$var$dumpGraph = (graph2)=>{
    const lines = $2edc1eef02a7c199$var$debugGraphToArray(graph2);
    return lines.join(`
`);
};
var $2edc1eef02a7c199$var$debugGraphToArray = (graph2)=>{
    const r = [];
    const vertices2 = `vertices` in graph2 ? graph2.vertices.values() : graph2;
    for (const v of vertices2){
        const str = $2edc1eef02a7c199$var$debugDumpVertex(v);
        r.push(...str.map((line2)=>` ${line2}`));
    }
    return r;
};
var $2edc1eef02a7c199$var$distance2 = (graph2, edge)=>{
    if (edge.weight !== void 0) return edge.weight;
    return 1;
};
function* $2edc1eef02a7c199$var$edges(graph2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const vertices2 = [
        ...graph2.vertices.values()
    ];
    for (const vertex of vertices2)for (const edge of vertex.out)yield edge;
}
function* $2edc1eef02a7c199$var$vertices(graph2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const vertices2 = [
        ...graph2.vertices.values()
    ];
    for (const vertex of vertices2)yield vertex;
}
function $2edc1eef02a7c199$var$testGraph(g, paramName = `graph`) {
    if (g === void 0) return [
        false,
        `Param '${paramName}' is undefined. Expected Graph`
    ];
    if (g === null) return [
        false,
        `Param '${paramName}' is null. Expected Graph`
    ];
    if (typeof g === `object`) {
        if (!(`vertices` in g)) return [
            false,
            `Param '${paramName}.vertices' does not exist. Is it a Graph type?`
        ];
    } else return [
        false,
        `Param '${paramName} is type '${typeof g}'. Expected an object Graph`
    ];
    return [
        true
    ];
}
function $2edc1eef02a7c199$var$throwGraphTest(g, paramName = `graph`) {
    const r = $2edc1eef02a7c199$var$testGraph(g, paramName);
    if (r[0]) return;
    throw new Error(r[1]);
}
function* $2edc1eef02a7c199$var$adjacentVertices(graph2, context) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    if (context === void 0) return;
    const vertex = typeof context === `string` ? graph2.vertices.get(context) : context;
    if (vertex === void 0) throw new Error(`Vertex not found ${JSON.stringify(context)}`);
    for (const edge of vertex.out){
        const edgeV = graph2.vertices.get(edge.id);
        if (edgeV === void 0) throw new Error(`Could not find vertex: ${edge.id}`);
        yield edgeV;
    }
}
var $2edc1eef02a7c199$var$vertexHasOut = (vertex, outIdOrVertex)=>{
    if (vertex === void 0) return false;
    const outId = typeof outIdOrVertex === `string` ? outIdOrVertex : outIdOrVertex.id;
    return vertex.out.some((edge)=>edge.id === outId);
};
var $2edc1eef02a7c199$var$hasNoOuts = (graph2, vertex)=>{
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const context = typeof vertex === `string` ? graph2.vertices.get(vertex) : vertex;
    if (context === void 0) return false;
    return context.out.length === 0;
};
var $2edc1eef02a7c199$var$hasOnlyOuts = (graph2, vertex, ...outIdOrVertex)=>{
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const context = $2edc1eef02a7c199$var$resolveVertex(graph2, vertex);
    const outs = outIdOrVertex.map((o)=>$2edc1eef02a7c199$var$resolveVertex(graph2, o));
    if (outs.length !== context.out.length) return false;
    for (const out of outs){
        if (!$2edc1eef02a7c199$var$hasOut(graph2, context, out)) return false;
    }
    return true;
};
var $2edc1eef02a7c199$var$hasOut = (graph2, vertex, outIdOrVertex)=>{
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const context = $2edc1eef02a7c199$var$resolveVertex(graph2, vertex);
    const outId = typeof outIdOrVertex === `string` ? outIdOrVertex : outIdOrVertex.id;
    return context.out.some((edge)=>edge.id === outId);
};
var $2edc1eef02a7c199$var$getOrCreate = (graph2, id)=>{
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const v = graph2.vertices.get(id);
    if (v !== void 0) return {
        graph: graph2,
        vertex: v
    };
    const vv = $2edc1eef02a7c199$var$createVertex(id);
    const gg = $2edc1eef02a7c199$var$updateGraphVertex(graph2, vv);
    return {
        graph: gg,
        vertex: vv
    };
};
var $2edc1eef02a7c199$var$getOrFail = (graph2, id)=>{
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const v = graph2.vertices.get(id);
    if (v === void 0) throw new Error(`Vertex '${id}' not found in graph`);
    return v;
};
var $2edc1eef02a7c199$var$updateGraphVertex = (graph2, vertex)=>{
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const gr = {
        ...graph2,
        vertices: graph2.vertices.set(vertex.id, vertex)
    };
    return gr;
};
var $2edc1eef02a7c199$var$distanceDefault = (graph2, edge)=>{
    if (edge.weight !== void 0) return edge.weight;
    return 1;
};
function $2edc1eef02a7c199$var$disconnect(graph2, from2, to2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const fromV = $2edc1eef02a7c199$var$resolveVertex(graph2, from2);
    const toV = $2edc1eef02a7c199$var$resolveVertex(graph2, to2);
    return $2edc1eef02a7c199$var$hasOut(graph2, fromV, toV) ? $2edc1eef02a7c199$var$updateGraphVertex(graph2, {
        ...fromV,
        out: fromV.out.filter((t2)=>t2.id !== toV.id)
    }) : graph2;
}
function $2edc1eef02a7c199$var$connectTo(graph2, from2, to2, weight2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const fromResult = $2edc1eef02a7c199$var$getOrCreate(graph2, from2);
    graph2 = fromResult.graph;
    const toResult = $2edc1eef02a7c199$var$getOrCreate(graph2, to2);
    graph2 = toResult.graph;
    const edge = {
        id: to2,
        weight: weight2
    };
    if (!$2edc1eef02a7c199$var$hasOut(graph2, fromResult.vertex, toResult.vertex)) graph2 = $2edc1eef02a7c199$var$updateGraphVertex(graph2, {
        ...fromResult.vertex,
        // Add new edge to list of edges for this node
        out: [
            ...fromResult.vertex.out,
            edge
        ]
    });
    return {
        graph: graph2,
        edge: edge
    };
}
function $2edc1eef02a7c199$var$connect(graph2, options) {
    const result = $2edc1eef02a7c199$var$connectWithEdges(graph2, options);
    return result.graph;
}
function $2edc1eef02a7c199$var$connectWithEdges(graph2, options) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const { to: to2, weight: weight2, from: from2 } = options;
    const bidi = options.bidi ?? false;
    const toList = Array.isArray(to2) ? to2 : [
        to2
    ];
    let edges2 = [];
    for (const toSingle of toList){
        const result = $2edc1eef02a7c199$var$connectTo(graph2, from2, toSingle, weight2);
        graph2 = result.graph;
        edges2.push(result.edge);
    }
    if (!bidi) return {
        graph: graph2,
        edges: edges2
    };
    for (const toSingle of toList){
        const result = $2edc1eef02a7c199$var$connectTo(graph2, toSingle, from2, weight2);
        graph2 = result.graph;
        edges2.push(result.edge);
    }
    return {
        graph: graph2,
        edges: edges2
    };
}
var $2edc1eef02a7c199$var$debugDumpVertex = (v)=>{
    const r = [
        v.id
    ];
    const stringForEdge = (edge)=>edge.weight === void 0 ? edge.id : `${edge.id} (${edge.weight})`;
    for (const edge of v.out)r.push(` -> ${stringForEdge(edge)}`);
    if (v.out.length === 0) r[0] += ` (terminal)`;
    return r;
};
function $2edc1eef02a7c199$var$areAdjacent(graph2, a, b) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    if ($2edc1eef02a7c199$var$hasOut(graph2, a, b.id)) return true;
    if ($2edc1eef02a7c199$var$hasOut(graph2, b, a.id)) return true;
}
function $2edc1eef02a7c199$var$resolveVertex(graph2, idOrVertex) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    if (idOrVertex === void 0) throw new Error(`Param 'idOrVertex' is undefined. Expected string or Vertex`);
    const v = typeof idOrVertex === `string` ? graph2.vertices.get(idOrVertex) : idOrVertex;
    if (v === void 0) throw new Error(`Id not found ${idOrVertex}`);
    return v;
}
function* $2edc1eef02a7c199$var$bfs(graph2, startIdOrVertex, targetIdOrVertex) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const start = $2edc1eef02a7c199$var$resolveVertex(graph2, startIdOrVertex);
    const target = targetIdOrVertex === void 0 ? void 0 : $2edc1eef02a7c199$var$resolveVertex(graph2, targetIdOrVertex);
    const queue = new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)();
    const seen = /* @__PURE__ */ new Set();
    queue.enqueue(start);
    while(!queue.isEmpty){
        const v = queue.dequeue();
        yield v;
        if (target !== void 0 && target === v) return;
        for (const edge of $2edc1eef02a7c199$var$adjacentVertices(graph2, v))if (!seen.has(edge.id)) {
            seen.add(edge.id);
            queue.enqueue($2edc1eef02a7c199$var$resolveVertex(graph2, edge.id));
        }
    }
}
function* $2edc1eef02a7c199$var$dfs(graph2, startIdOrVertex) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const source = $2edc1eef02a7c199$var$resolveVertex(graph2, startIdOrVertex);
    const s = new (0, $eca7f6cd1c865161$export$54718c36d7236b27)();
    const seen = /* @__PURE__ */ new Set();
    s.push(source);
    while(!s.isEmpty){
        const v = s.pop();
        if (v === void 0) continue;
        if (!seen.has(v.id)) {
            seen.add(v.id);
            yield v;
            for (const edge of v.out){
                const destination = graph2.vertices.get(edge.id);
                if (destination) s.push(destination);
            }
        }
    }
}
var $2edc1eef02a7c199$var$pathDijkstra = (graph2, sourceOrId)=>{
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const source = typeof sourceOrId === `string` ? graph2.vertices.get(sourceOrId) : sourceOrId;
    if (source === void 0) throw new Error(`source vertex not found`);
    const distances = /* @__PURE__ */ new Map();
    const previous = /* @__PURE__ */ new Map();
    distances.set(source.id, 0);
    const pq = new $2edc1eef02a7c199$export$70b565fa5666e9db();
    const vertices2 = [
        ...graph2.vertices.values()
    ];
    for (const v of vertices2){
        if (v.id !== source.id) {
            distances.set(v.id, Number.MAX_SAFE_INTEGER);
            previous.set(v.id, null);
        }
        pq.enqueueWithPriority(v.id, Number.MAX_SAFE_INTEGER);
    }
    while(!pq.isEmpty){
        const u = pq.dequeueMin();
        if (u === void 0) throw new Error(`Bug. Queue unexpectedly empty`);
        const vertexU = graph2.vertices.get(u);
        for (const neighbour of vertexU.out){
            const alt = distances.get(u) + $2edc1eef02a7c199$var$distance2(graph2, neighbour);
            if (alt < distances.get(neighbour.id)) {
                distances.set(neighbour.id, alt);
                previous.set(neighbour.id, vertexU);
                pq.changePriority(neighbour.id, alt, true);
            }
        }
    }
    const pathTo = (id)=>{
        const path = [];
        while(true){
            if (id === source.id) break;
            const v = previous.get(id);
            if (v === void 0 || v === null) throw new Error(`Id not present: ${id}`);
            path.push({
                id: id,
                weight: distances.get(id)
            });
            id = v.id;
        }
        return path;
    };
    return {
        distances: distances,
        previous: previous,
        pathTo: pathTo
    };
};
var $2edc1eef02a7c199$var$clone = (graph2)=>{
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const g = {
        vertices: (0, $70e9cec26f7f4191$export$fc3a40dec7b33bf)([
            ...graph2.vertices.entries()
        ])
    };
    return g;
};
var $2edc1eef02a7c199$var$graph = (...initialConnections)=>{
    let g = {
        vertices: (0, $70e9cec26f7f4191$export$fc3a40dec7b33bf)()
    };
    for (const ic of initialConnections)g = $2edc1eef02a7c199$var$connect(g, ic);
    return g;
};
function $2edc1eef02a7c199$var$isAcyclic(graph2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const cycles = $2edc1eef02a7c199$var$getCycles(graph2);
    return cycles.length === 0;
}
function $2edc1eef02a7c199$var$topologicalSort(graph2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    const indegrees = new (0, $70e9cec26f7f4191$export$8f8eb378cefe093d)(0);
    for (const edge of $2edc1eef02a7c199$var$edges(graph2))indegrees.add(edge.id, 1);
    const queue = new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)();
    let vertexCount = 0;
    for (const vertex of $2edc1eef02a7c199$var$vertices(graph2)){
        if (indegrees.get(vertex.id) === 0) queue.enqueue(vertex);
        vertexCount++;
    }
    const topOrder = [];
    while(!queue.isEmpty){
        const u = queue.dequeue();
        topOrder.push(u);
        for (const neighbour of u.out){
            const result = indegrees.subtract(neighbour.id, 1);
            if (result === 0) queue.enqueue(graph2.vertices.get(neighbour.id));
        }
    }
    if (topOrder.length !== vertexCount) throw new Error(`Graph contains cycles`);
    return $2edc1eef02a7c199$var$graphFromVertices(topOrder);
}
function $2edc1eef02a7c199$var$graphFromVertices(vertices2) {
    const keyValues = (0, $eca7f6cd1c865161$export$871de8747c9eaa88)(vertices2, (f)=>{
        return [
            f.id,
            f
        ];
    });
    const m = (0, $70e9cec26f7f4191$export$fc3a40dec7b33bf)([
        ...keyValues
    ]);
    return {
        vertices: m
    };
}
function $2edc1eef02a7c199$var$getCycles(graph2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    let index = 0;
    const stack = new (0, $eca7f6cd1c865161$export$54718c36d7236b27)();
    const vertices2 = /* @__PURE__ */ new Map();
    const scc = [];
    for (const v of graph2.vertices.values())vertices2.set(v.id, {
        ...v,
        lowlink: Number.NaN,
        index: Number.NaN,
        onStack: false
    });
    const strongConnect = (vertex)=>{
        vertex.index = index;
        vertex.lowlink = index;
        index++;
        stack.push(vertex);
        vertex.onStack = true;
        for (const edge of vertex.out){
            const edgeV = vertices2.get(edge.id);
            if (Number.isNaN(edgeV.index)) {
                strongConnect(edgeV);
                vertex.lowlink = Math.min(vertex.lowlink, edgeV.lowlink);
            } else if (edgeV.onStack) vertex.lowlink = Math.min(vertex.lowlink, edgeV.lowlink);
        }
        if (vertex.lowlink === vertex.index) {
            const stronglyConnected = [];
            let w;
            while(vertex !== w){
                w = stack.pop();
                w.onStack = false;
                stronglyConnected.push({
                    id: w.id,
                    out: w.out
                });
            }
            if (stronglyConnected.length > 1) scc.push(stronglyConnected);
        }
    };
    for (const v of vertices2.values())if (Number.isNaN(v.index)) strongConnect(v);
    return scc;
}
function $2edc1eef02a7c199$var$transitiveReduction(graph2) {
    $2edc1eef02a7c199$var$throwGraphTest(graph2);
    for (const u of $2edc1eef02a7c199$var$vertices(graph2)){
        for (const v of $2edc1eef02a7c199$var$adjacentVertices(graph2, u))for (const v1 of $2edc1eef02a7c199$var$dfs(graph2, v)){
            if (v.id === v1.id) continue;
            if ($2edc1eef02a7c199$var$hasOut(graph2, u, v1)) {
                const g = $2edc1eef02a7c199$var$disconnect(graph2, u, v1);
                return $2edc1eef02a7c199$var$transitiveReduction(g);
            }
        }
    }
    return graph2;
}
// src/rx/Graph.ts
function $2edc1eef02a7c199$export$18298bb220d85216(_rx) {
    let g = $2edc1eef02a7c199$var$graph();
    const nodes = /* @__PURE__ */ new Map();
    const events = $2edc1eef02a7c199$var$initStream();
    const process2 = (o, path)=>{
        for (const [key, value] of Object.entries(o)){
            const subPath = path + `.` + key;
            g = $2edc1eef02a7c199$var$connect(g, {
                from: path,
                to: subPath
            });
            if ((0, $f53657e65b61d2bb$export$352205f445242f02)(value)) {
                nodes.set(subPath, {
                    value: value,
                    type: `rx`
                });
                value.on((v)=>{
                    console.log(`Rx.prepare value: ${JSON.stringify(v)} path: ${subPath}`);
                });
            } else {
                const valueType = typeof value;
                if (valueType === `bigint` || valueType === `boolean` || valueType === `number` || valueType === `string`) nodes.set(subPath, {
                    type: `primitive`,
                    value: value
                });
                else if (valueType === `object`) process2(value, subPath);
                else if (valueType === `function`) console.log(`Rx.process - not handling functions`);
            }
        }
    };
    const returnValue = {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        dispose: events.dispose,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        isDisposed: events.isDisposed,
        graph: g,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        on: events.on,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        onValue: events.onValue
    };
    return returnValue;
}
// src/rx/Types.ts
var $2edc1eef02a7c199$export$8f701197936bc2a6 = Symbol(`Rx`);
// src/rx/ToArray.ts
async function $2edc1eef02a7c199$export$85fdf2f290cd8da1(source, options = {}) {
    const limit = options.limit ?? Number.MAX_SAFE_INTEGER;
    const maximumWait = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.maximumWait, 10000);
    const underThreshold = options.underThreshold ?? `partial`;
    const read = [];
    const rx = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
    const promise = new Promise((resolve3, reject)=>{
        const done = ()=>{
            clearTimeout(maxWait);
            unsub();
            if (read.length < limit && underThreshold === `throw`) {
                reject(new Error(`Threshold not reached. Wanted: ${limit} got: ${read.length}. Maximum wait: ${maximumWait}`));
                return;
            }
            if (read.length < limit && underThreshold === `fill`) {
                for(let index = 0; index < limit; index++)if (read[index] === void 0) read[index] = options.fillValue;
            }
            resolve3(read);
        };
        const maxWait = setTimeout(()=>{
            done();
        }, maximumWait);
        const unsub = rx.on((message)=>{
            if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) done();
            else if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
                read.push(message.value);
                if (read.length === limit) done();
            }
        });
    });
    return promise;
}
async function $2edc1eef02a7c199$export$a830f0e6169c5d5f(source, options = {}) {
    const limit = options.limit ?? Number.MAX_SAFE_INTEGER;
    const maximumWait = options.maximumWait ?? 5000;
    const v = await $2edc1eef02a7c199$export$85fdf2f290cd8da1(source, {
        limit: limit,
        maximumWait: maximumWait,
        underThreshold: `partial`
    });
    if (options.limit && v.length < options.limit) throw new Error(`Threshold not reached. Wanted: ${options.limit}, got ${v.length}`);
    return v;
}
// src/rx/ToGenerator.ts
async function* $2edc1eef02a7c199$export$597d2615a33e50cf(source) {
    const s = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
    let promiseResolve = (_)=>{};
    let promiseReject = (_)=>{};
    const promiseInit = ()=>new Promise((resolve3, reject)=>{
            promiseResolve = resolve3;
            promiseReject = reject;
        });
    let promise = promiseInit();
    let keepRunning = true;
    s.on((message)=>{
        if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
            promiseResolve(message.value);
            promise = promiseInit();
        } else if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) {
            keepRunning = false;
            promiseReject(`Source has completed`);
        }
    });
    while(keepRunning)yield await promise;
}
// src/rx/Wrap.ts
function $2edc1eef02a7c199$export$df323ceab6412a9a(source) {
    return {
        source: $2edc1eef02a7c199$export$6b1de85efae8a879(source),
        enacts: {
            setHtmlText: (options)=>{
                return $2edc1eef02a7c199$export$a6c95c2b8a92aa27(source, options);
            }
        },
        annotate: (transformer)=>{
            const a = $2edc1eef02a7c199$export$1012f5f00ec31870(source, transformer);
            return $2edc1eef02a7c199$export$df323ceab6412a9a(a);
        },
        annotateWithOp: (op)=>{
            const a = $2edc1eef02a7c199$export$be3adf485fb3cad4(source, op);
            return $2edc1eef02a7c199$export$df323ceab6412a9a(a);
        },
        chunk: (options)=>{
            const w = $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$5f7ec48d69707ddd(source, options));
            return w;
        },
        debounce: (options = {})=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$61fc7d43ac8f84b0(source, options));
        },
        field: (fieldName, options = {})=>{
            const f = $2edc1eef02a7c199$export$e0f35d825088c098(source, fieldName, options);
            return $2edc1eef02a7c199$export$df323ceab6412a9a(f);
        },
        filter: (predicate, options)=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$5f7dfb0a65ac6c(source, predicate, options));
        },
        combineLatestToArray: (sources, options = {})=>{
            const srcs = [
                source,
                ...sources
            ];
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$b5235d9cdb97b833(srcs, options));
        },
        combineLatestToObject: (sources, options)=>{
            const name = options.name ?? `source`;
            const o = {
                ...sources
            };
            o[name] = source;
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$75430b411d43dc3f(o, options));
        },
        min: (options = {})=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$b393be5a551404be(source, options));
        },
        max: (options = {})=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$22cda90bd12095a9(source, options));
        },
        average: (options = {})=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$5c3bbf40eb9d4622(source, options));
        },
        sum: (options = {})=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$8cb7414e874a9718(source, options));
        },
        tally: (options = {})=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$7ed03ecedcf10c1(source, options));
        },
        split: (options = {})=>{
            const streams = $2edc1eef02a7c199$export$65980d18b75784e2(source, options).map((v)=>$2edc1eef02a7c199$export$df323ceab6412a9a(v));
            return streams;
        },
        splitLabelled: (...labels)=>{
            const l = $2edc1eef02a7c199$export$ecb39c0370b0b52d(source, labels);
            const m = $2edc1eef02a7c199$export$3e53a9d8791790c9(l, (args)=>$2edc1eef02a7c199$export$df323ceab6412a9a(args.value));
            return m;
        },
        switcher: (cases, options = {})=>{
            const s = $2edc1eef02a7c199$export$8987e38cfd004b13(source, cases, options);
            const m = $2edc1eef02a7c199$export$3e53a9d8791790c9(s, (args)=>$2edc1eef02a7c199$export$df323ceab6412a9a(args.value));
            return m;
        },
        syncToArray: (additionalSources, options = {})=>{
            const unwrapped = [
                source,
                ...additionalSources
            ].map((v)=>$2edc1eef02a7c199$export$6b1de85efae8a879(v));
            const x = $2edc1eef02a7c199$export$5eb154d8c1f8350(unwrapped, options);
            return $2edc1eef02a7c199$export$df323ceab6412a9a(x);
        },
        syncToObject: (sources, options = {})=>{
            const name = options.name ?? `source`;
            const o = {
                ...sources
            };
            o[name] = source;
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$b32b2cebf6eb1280(o, options));
        },
        tapProcess: (...processors)=>{
            $2edc1eef02a7c199$export$b6175151fde1dc87(source, ...processors);
            return $2edc1eef02a7c199$export$df323ceab6412a9a(source);
        },
        tapStream: (divergedStream)=>{
            $2edc1eef02a7c199$export$bedfced534e7bc06(source, divergedStream);
            return $2edc1eef02a7c199$export$df323ceab6412a9a(source);
        },
        tapOps: (source2, ...ops)=>{
            $2edc1eef02a7c199$export$b6abe60b3da98fc9(source2, ...ops);
            return $2edc1eef02a7c199$export$df323ceab6412a9a(source2);
        },
        throttle: (options = {})=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$de363e709c412c8a(source, options));
        },
        transform: (transformer, options = {})=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$51186ad6e864892a(source, transformer, options));
        },
        timeoutValue: (options)=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$8862a6a079f688d3(source, options));
        },
        timeoutPing: (options)=>{
            return $2edc1eef02a7c199$export$df323ceab6412a9a($2edc1eef02a7c199$export$23da8b73b6fbb5b7(source, options));
        },
        toArray: (options)=>{
            return $2edc1eef02a7c199$export$85fdf2f290cd8da1(source, options);
        },
        toArrayOrThrow: (options)=>{
            return $2edc1eef02a7c199$export$a830f0e6169c5d5f(source, options);
        },
        onValue: (callback)=>{
            const s = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
            s.on((message)=>{
                if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) callback(message.value);
            });
        }
    };
}
// src/rx/Dom.ts
var $2edc1eef02a7c199$export$e02548a286707272 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$e02548a286707272, {
    bind: ()=>$2edc1eef02a7c199$var$bind,
    bindDiffUpdate: ()=>$2edc1eef02a7c199$var$bindDiffUpdate,
    bindElement: ()=>$2edc1eef02a7c199$var$bindElement,
    bindHtml: ()=>$2edc1eef02a7c199$var$bindHtml,
    bindText: ()=>$2edc1eef02a7c199$var$bindText,
    bindUpdate: ()=>$2edc1eef02a7c199$var$bindUpdate,
    bindValueText: ()=>$2edc1eef02a7c199$var$bindValueText,
    elements: ()=>$2edc1eef02a7c199$var$elements,
    fromDomQuery: ()=>$2edc1eef02a7c199$var$fromDomQuery,
    win: ()=>$2edc1eef02a7c199$var$win
});
// src/text/Segments.ts
function* $2edc1eef02a7c199$var$stringSegmentsWholeToEnd(source, delimiter = `.`) {
    while(source.length > 0){
        yield source;
        const trimmed = (0, $ae8f83c19bfd8110$export$ece7822811de3aeb)(source, delimiter);
        if (trimmed === source) break;
        source = trimmed;
    }
}
function* $2edc1eef02a7c199$var$stringSegmentsWholeToFirst(source, delimiter = `.`) {
    while(source.length > 0){
        yield source;
        const b = (0, $ae8f83c19bfd8110$export$b1d9c5188d32d22a)(source, delimiter, {
            ifNoMatch: `original`,
            fromEnd: true
        });
        if (b === source) break;
        source = b;
    }
}
// src/rx/Dom.ts
function $2edc1eef02a7c199$var$fromDomQuery(query) {
    const elements2 = [
        ...document.querySelectorAll(query)
    ];
    return $2edc1eef02a7c199$var$object(elements2);
}
var $2edc1eef02a7c199$var$bindText = (source, elOrQuery, bindOpts = {})=>{
    return $2edc1eef02a7c199$var$bindElement(source, elOrQuery, {
        ...bindOpts,
        elField: `textContent`
    });
};
var $2edc1eef02a7c199$var$bindValueText = (source, elOrQuery, bindOpts = {})=>{
    return $2edc1eef02a7c199$var$bindElement(source, elOrQuery, {
        ...bindOpts,
        elField: `value`,
        attribName: `value`
    });
};
var $2edc1eef02a7c199$var$bindHtml = (source, elOrQuery, bindOpts = {})=>{
    return $2edc1eef02a7c199$var$bindElement(source, elOrQuery, {
        ...bindOpts,
        elField: `innerHTML`
    });
};
var $2edc1eef02a7c199$var$bindElement = (source, elOrQuery, ...binds)=>{
    if (elOrQuery === null) throw new Error(`Param 'elOrQuery' is null`);
    if (elOrQuery === void 0) throw new Error(`Param 'elOrQuery' is undefined`);
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elOrQuery);
    let b = [];
    if (binds.length === 0) b.push({
        elField: `textContent`
    });
    else b = [
        ...binds
    ];
    const bb = b.map((bind2)=>{
        if (`element` in bind2) return bind2;
        return {
            ...bind2,
            element: el
        };
    });
    return $2edc1eef02a7c199$var$bind(source, ...bb);
};
var $2edc1eef02a7c199$var$resolveBindUpdater = (bind2, element)=>{
    const b = $2edc1eef02a7c199$var$resolveBindUpdaterBase(bind2);
    return (value)=>{
        b(value, element);
    };
};
var $2edc1eef02a7c199$var$resolveBindUpdaterBase = (bind2)=>{
    if (bind2.elField !== void 0 || bind2.cssVariable === void 0 && bind2.attribName === void 0 && bind2.cssProperty === void 0 && bind2.textContent === void 0 && bind2.htmlContent === void 0) {
        const field2 = bind2.elField ?? `textContent`;
        return (v, element)=>{
            element[field2] = v;
        };
    }
    if (bind2.attribName !== void 0) {
        const attrib = bind2.attribName;
        return (v, element)=>{
            element.setAttribute(attrib, v);
        };
    }
    if (bind2.textContent) return (v, element)=>{
        element.textContent = v;
    };
    if (bind2.htmlContent) return (v, element)=>{
        element.innerHTML = v;
    };
    if (bind2.cssVariable !== void 0) {
        let css = bind2.cssVariable;
        if (!css.startsWith(`--`)) css = `--` + css;
        return (v, element)=>{
            element.style.setProperty(css, v);
        };
    }
    if (bind2.cssProperty !== void 0) return (v, element)=>{
        element.style[bind2.cssProperty] = v;
    };
    return (_, _element)=>{};
};
var $2edc1eef02a7c199$var$resolveTransform = (bind2)=>{
    if (!bind2.transform && !bind2.transformValue) return;
    if (bind2.transformValue) {
        if (bind2.sourceField === void 0) throw new Error(`Expects 'sourceField' to be set when 'transformValue' is set`);
        return (value)=>{
            const fieldValue = value[bind2.sourceField];
            return bind2.transformValue(fieldValue);
        };
    } else if (bind2.transform) {
        if (bind2.sourceField !== void 0) throw new Error(`If 'transform' is set, 'sourceField' is ignored`);
        return (value)=>bind2.transform(value);
    }
};
var $2edc1eef02a7c199$var$bind = (source, ...bindsUnresolvedElements)=>{
    const binds = bindsUnresolvedElements.map((bind2)=>{
        if (bind2.element && bind2.element !== void 0) return bind2;
        if (bind2.query) return {
            ...bind2,
            element: (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(bind2.query)
        };
        throw new Error(`Unable to resolve element. Missing 'element' or 'query' values on bind. ${JSON.stringify(bind2)}`);
    });
    const bindsResolved = binds.map((bind2)=>({
            update: $2edc1eef02a7c199$var$resolveBindUpdater(bind2, bind2.element),
            transformer: $2edc1eef02a7c199$var$resolveTransform(bind2),
            sourceField: bind2.sourceField
        }));
    const update = (value)=>{
        for (const bind2 of bindsResolved)if (bind2.transformer) bind2.update(bind2.transformer(value));
        else {
            const v = bind2.sourceField ? value[bind2.sourceField] : value;
            if (typeof v === `object`) {
                if (bind2.sourceField) bind2.update(JSON.stringify(v));
                else bind2.update(JSON.stringify(v));
            } else bind2.update(v);
        }
    };
    const unsub = source.on((message)=>{
        if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) update(message.value);
        else if ((0, $f53657e65b61d2bb$export$3851969427163052)(message)) console.warn(message);
    });
    if ((0, $f53657e65b61d2bb$export$792719627301184c)(source)) update(source.last());
    return {
        remove: (removeElements)=>{
            unsub();
            if (removeElements) for (const bind2 of binds)bind2.element.remove();
        }
    };
};
var $2edc1eef02a7c199$var$bindUpdate = (source, elOrQuery, updater)=>{
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elOrQuery);
    const update = (value)=>{
        updater(value, el);
    };
    const unsub = source.on((message)=>{
        if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
            console.log(message);
            update(message.value);
        } else console.warn(message);
    });
    if ((0, $f53657e65b61d2bb$export$792719627301184c)(source)) update(source.last());
    return {
        remove: (removeElement)=>{
            unsub();
            if (removeElement) el.remove();
        }
    };
};
var $2edc1eef02a7c199$var$bindDiffUpdate = (source, elOrQuery, updater, opts = {})=>{
    if (elOrQuery === null) throw new Error(`Param 'elOrQuery' is null`);
    if (elOrQuery === void 0) throw new Error(`Param 'elOrQuery' is undefined`);
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elOrQuery);
    const update = (value)=>{
        updater(value, el);
    };
    const unsub = source.onDiff((value)=>{
        update(value);
    });
    const init = ()=>{
        if ((0, $f53657e65b61d2bb$export$792719627301184c)(source) && opts.initial) opts.initial(source.last(), el);
    };
    init();
    return {
        refresh: ()=>{
            init();
        },
        remove: (removeElement)=>{
            unsub();
            if (removeElement) el.remove();
        }
    };
};
var $2edc1eef02a7c199$var$elements = (source, options)=>{
    const containerEl = options.container ? (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(options.container) : document.body;
    const defaultTag = options.defaultTag ?? `div`;
    const elByField = /* @__PURE__ */ new Map();
    const binds = /* @__PURE__ */ new Map();
    for (const [key, value] of Object.entries(options.binds ?? {})){
        const tagName = value.tagName ?? defaultTag;
        binds.set(key, {
            ...value,
            update: $2edc1eef02a7c199$var$resolveBindUpdaterBase(value),
            transform: $2edc1eef02a7c199$var$resolveTransform(value),
            tagName: tagName,
            path: key
        });
    }
    const findBind = (path)=>{
        const bind2 = (0, $3ffa4b3bf3c5db47$export$d9154ce654446643)(binds, $2edc1eef02a7c199$var$stringSegmentsWholeToEnd(path));
        if (bind2 !== void 0) return bind2;
        if (!path.includes(`.`)) return binds.get(`_root`);
    };
    function* ancestorBinds(path) {
        for (const p of $2edc1eef02a7c199$var$stringSegmentsWholeToFirst(path))if (binds.has(p)) yield binds.get(p);
        if (binds.has(`_root`) && path.includes(`.`)) yield binds.get(`_root`);
    }
    const create3 = (path, value)=>{
        const rootedPath = $2edc1eef02a7c199$var$getRootedPath(path);
        console.log(`Rx.Dom.elements.create: ${path} rooted: ${rootedPath} value: ${JSON.stringify(value)}`);
        const bind2 = findBind($2edc1eef02a7c199$var$getRootedPath(path));
        let tagName = defaultTag;
        if (bind2?.tagName) tagName = bind2.tagName;
        const el = document.createElement(tagName);
        el.setAttribute(`data-path`, path);
        update(path, el, value);
        let parentForEl;
        for (const b of ancestorBinds(rootedPath))if (b?.nestChildren) {
            const absoluteRoot = (0, $ae8f83c19bfd8110$export$b1d9c5188d32d22a)(path, `.`);
            const findBy = b.path.replace(`_root`, absoluteRoot);
            parentForEl = elByField.get(findBy);
            if (parentForEl === void 0) ;
            else break;
        }
        (parentForEl ?? containerEl).append(el);
        elByField.set(path, el);
        console.log(`Added el: ${path}`);
    };
    const update = (path, el, value)=>{
        console.log(`Rx.dom.update path: ${path} value:`, value);
        const bind2 = findBind($2edc1eef02a7c199$var$getRootedPath(path));
        if (bind2 === void 0) {
            if (typeof value === `object`) value = JSON.stringify(value);
            el.textContent = value;
        } else {
            if (bind2.transform) value = bind2.transform(value);
            bind2.update(value, el);
        }
    };
    const changes = (changes2)=>{
        const queue = new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)({}, changes2);
        let d = queue.dequeue();
        const seenPaths = /* @__PURE__ */ new Set();
        while(d !== void 0){
            const path = d.path;
            if (!(`previous` in d) || d.previous === void 0) {
                console.log(`Rx.Dom.elements.changes no previous. path: ${path}`);
                create3(path, d.value);
                const subdata = [
                    ...$2edc1eef02a7c199$var$getPathsAndData(d.value, false, Number.MAX_SAFE_INTEGER, path)
                ];
                console.log(subdata);
                for (const dd of subdata)if (!seenPaths.has(dd.path)) {
                    queue.enqueue(dd);
                    seenPaths.add(dd.path);
                }
            } else if (d.value === void 0) {
                const el = elByField.get(path);
                if (el === void 0) console.warn(`No element to delete? ${path} `);
                else {
                    console.log(`Rx.Dom.elements.changes delete ${path}`);
                    el.remove();
                }
            } else {
                const el = elByField.get(path);
                if (el === void 0) {
                    console.warn(`Rx.Dom.elements.changes No element to update ? ${path} `);
                    create3(path, d.value);
                } else update(path, el, d.value);
            }
            d = queue.dequeue();
        }
    };
    source.onDiff((value)=>{
        changes(value);
    });
    if ((0, $f53657e65b61d2bb$export$792719627301184c)(source)) {
        const last = source.last();
        changes([
            ...$2edc1eef02a7c199$var$getPathsAndData(last, false, 1)
        ]);
    }
};
var $2edc1eef02a7c199$var$getRootedPath = (path)=>{
    const after = (0, $ae8f83c19bfd8110$export$ece7822811de3aeb)(path, `.`);
    return after === path ? `_root` : `_root.` + after;
};
function $2edc1eef02a7c199$var$win() {
    const generateRect = ()=>({
            width: window.innerWidth,
            height: window.innerHeight
        });
    const size = $2edc1eef02a7c199$export$db4e272a145fb195.event(window, `resize`, {
        lazy: `very`,
        transform: ()=>generateRect()
    });
    const pointer = $2edc1eef02a7c199$export$db4e272a145fb195.event(window, `pointermove`, {
        lazy: `very`,
        transform: (args)=>{
            if (args === void 0) return {
                x: 0,
                y: 0
            };
            const pe = args;
            return {
                x: pe.x,
                y: pe.y
            };
        }
    });
    const dispose = (reason = `Reactive.win.dispose`)=>{
        size.dispose(reason);
        pointer.dispose(reason);
    };
    return {
        dispose: dispose,
        size: size,
        pointer: pointer
    };
}
// src/rx/sources/index.ts
var $2edc1eef02a7c199$export$db4e272a145fb195 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($2edc1eef02a7c199$export$db4e272a145fb195, {
    array: ()=>$2edc1eef02a7c199$var$array,
    arrayObject: ()=>$2edc1eef02a7c199$var$arrayObject,
    arrayProxy: ()=>$2edc1eef02a7c199$var$arrayProxy,
    boolean: ()=>$2edc1eef02a7c199$var$boolean,
    colour: ()=>$2edc1eef02a7c199$var$colour,
    count: ()=>$2edc1eef02a7c199$var$count,
    derived: ()=>$2edc1eef02a7c199$var$derived,
    domForm: ()=>$2edc1eef02a7c199$var$domForm,
    domHslInputValue: ()=>$2edc1eef02a7c199$var$domHslInputValue,
    domInputValue: ()=>$2edc1eef02a7c199$var$domInputValue,
    domNumberInputValue: ()=>$2edc1eef02a7c199$var$domNumberInputValue,
    event: ()=>$2edc1eef02a7c199$var$event,
    eventField: ()=>$2edc1eef02a7c199$var$eventField,
    eventTrigger: ()=>$2edc1eef02a7c199$var$eventTrigger,
    func: ()=>$2edc1eef02a7c199$var$func,
    iterator: ()=>$2edc1eef02a7c199$var$iterator,
    merged: ()=>$2edc1eef02a7c199$var$merged,
    mergedWithOptions: ()=>$2edc1eef02a7c199$var$mergedWithOptions,
    number: ()=>$2edc1eef02a7c199$var$number,
    object: ()=>$2edc1eef02a7c199$var$object,
    objectProxy: ()=>$2edc1eef02a7c199$var$objectProxy,
    objectProxySymbol: ()=>$2edc1eef02a7c199$var$objectProxySymbol,
    observable: ()=>$2edc1eef02a7c199$var$observable,
    observableWritable: ()=>$2edc1eef02a7c199$var$observableWritable,
    of: ()=>$2edc1eef02a7c199$var$of,
    string: ()=>$2edc1eef02a7c199$var$string
});
// src/rx/sources/Array.ts
var $2edc1eef02a7c199$var$of = (source, options = {})=>{
    if (Array.isArray(source)) return $2edc1eef02a7c199$var$array(source, options);
};
var $2edc1eef02a7c199$var$array = (sourceArray, options = {})=>{
    const lazy = options.lazy ?? `initial`;
    const signal = options.signal;
    const whenStopped = options.whenStopped ?? `continue`;
    const debugLifecycle = options.debugLifecycle ?? false;
    const array3 = [
        ...sourceArray
    ];
    if (lazy !== `very` && whenStopped === `reset`) throw new Error(`whenStopped:'reset' has no effect with 'lazy:${lazy}'. Use lazy:'very' instead.`);
    const intervalMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.interval, 5);
    let index = 0;
    let lastValue = array3[0];
    const s = $2edc1eef02a7c199$var$initLazyStream({
        ...options,
        lazy: lazy,
        onStart () {
            if (debugLifecycle) console.log(`Rx.readFromArray:onStart`);
            c.start();
        },
        onStop () {
            if (debugLifecycle) console.log(`Rx.readFromArray:onStop. whenStopped: ${whenStopped} index: ${index}`);
            c.cancel();
            if (whenStopped === `reset`) index = 0;
        }
    });
    const c = (0, $f53657e65b61d2bb$export$5df75b4acf95a98a)(()=>{
        if (signal?.aborted) {
            s.dispose(`Signalled (${signal.reason})`);
            return false;
        }
        lastValue = array3[index];
        index++;
        s.set(lastValue);
        if (index === array3.length) {
            s.dispose(`Source array complete`);
            return false;
        }
    }, intervalMs);
    if (!lazy) c.start();
    return {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        dispose: s.dispose,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        isDisposed: s.isDisposed,
        isDone () {
            return index === array3.length;
        },
        last () {
            return lastValue;
        },
        // eslint-disable-next-line @typescript-eslint/unbound-method
        on: s.on,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        onValue: s.onValue
    };
};
// src/rx/sources/ArrayObject.ts
function $2edc1eef02a7c199$var$arrayObject(initialValue = [], options = {}) {
    const eq = options.eq ?? (0, $847987b26b102cb8$export$a8a61f8380f29e3a);
    const setEvent = $2edc1eef02a7c199$var$initStream();
    const arrayEvent = $2edc1eef02a7c199$var$initStream();
    let value = initialValue;
    let disposed = false;
    const set = (replacement)=>{
        const diff = (0, $a67c984aa26c5d8f$export$fc16749c794bf6ff)(value, replacement, eq);
        value = replacement;
        setEvent.set([
            ...replacement
        ]);
    };
    const setAt = (index, v)=>{
        value[index] = v;
        setEvent.set([
            ...value
        ]);
    };
    const push = (v)=>{
        value = [
            ...value,
            v
        ];
        setEvent.set([
            ...value
        ]);
        const cr = [
            `add`,
            value.length - 1,
            v
        ];
        arrayEvent.set([
            cr
        ]);
    };
    const deleteAt = (index)=>{
        const valueChanged = (0, $b63753f448317b08$export$cd7f480d6b8286c3)(value, index);
        if (valueChanged.length === value.length) return;
        const diff = (0, $a67c984aa26c5d8f$export$fc16749c794bf6ff)(value, valueChanged, eq);
        value = valueChanged;
        setEvent.set([
            ...value
        ]);
        arrayEvent.set(diff.summary);
    };
    const deleteWhere = (filter4)=>{
        const valueChanged = value.filter((v)=>!filter4(v));
        const count2 = value.length - valueChanged.length;
        const diff = (0, $a67c984aa26c5d8f$export$fc16749c794bf6ff)(value, valueChanged, eq);
        value = valueChanged;
        setEvent.set([
            ...value
        ]);
        arrayEvent.set(diff.summary);
        return count2;
    };
    const insertAt2 = (index, v)=>{
        const valueChanged = (0, $b63753f448317b08$export$9f200c4466975173)(value, index, v);
        const diff = (0, $a67c984aa26c5d8f$export$fc16749c794bf6ff)(value, valueChanged, eq);
        value = valueChanged;
        setEvent.set([
            ...value
        ]);
        arrayEvent.set(diff.summary);
    };
    const dispose = (reason)=>{
        if (disposed) return;
        setEvent.dispose(reason);
        disposed = true;
    };
    const r = {
        dispose: dispose,
        isDisposed () {
            return disposed;
        },
        last: ()=>value,
        on: setEvent.on,
        onArray: arrayEvent.on,
        onValue: setEvent.onValue,
        setAt: setAt,
        push: push,
        deleteAt: deleteAt,
        deleteWhere: deleteWhere,
        insertAt: insertAt2,
        set: /**
     * Set the whole object
     */ set
    };
    return r;
}
// src/rx/sources/Boolean.ts
function $2edc1eef02a7c199$var$boolean(initialValue) {
    let value = initialValue;
    const events = $2edc1eef02a7c199$var$initStream();
    const set = (v)=>{
        value = v;
        events.set(v);
    };
    return {
        dispose: events.dispose,
        isDisposed: events.isDisposed,
        last: ()=>value,
        on: events.on,
        onValue: events.onValue,
        set: set
    };
}
// src/rx/sources/Colour.ts
function $2edc1eef02a7c199$var$colour(initialValue) {
    let value = initialValue;
    const events = $2edc1eef02a7c199$var$initStream();
    const set = (v)=>{
        value = v;
        events.set(v);
    };
    return {
        dispose: events.dispose,
        isDisposed: events.isDisposed,
        last: ()=>value,
        on: events.on,
        onValue: events.onValue,
        set: set,
        setHsl: (hsl)=>{
            set((0, $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03)(hsl));
        }
    };
}
// src/rx/sources/Count.ts
function $2edc1eef02a7c199$var$count(options = {}) {
    const lazy = options.lazy ?? `initial`;
    const interval = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.interval, 1e3);
    const amount = options.amount ?? 1;
    const offset = options.offset ?? 0;
    let produced = 0;
    let value = offset;
    const done = (reason)=>{
        events.dispose(reason);
    };
    const timer = (0, $f53657e65b61d2bb$export$5df75b4acf95a98a)(()=>{
        if (options.signal?.aborted) {
            done(`Aborted (${options.signal.reason})`);
            return false;
        }
        events.set(value);
        value += 1;
        produced++;
        if (produced >= amount) {
            done(`Limit reached`);
            return false;
        }
    }, interval);
    const events = $2edc1eef02a7c199$var$initLazyStream({
        onStart () {
            timer.start();
        },
        onStop () {
            timer.cancel();
        },
        onDispose () {
            timer.cancel();
        },
        lazy: lazy
    });
    return events;
}
// src/rx/sources/Derived.ts
function $2edc1eef02a7c199$var$derived(fn, reactiveSources, options = {}) {
    const ignoreIdentical = options.ignoreIdentical ?? true;
    const eq = options.eq ?? (0, $847987b26b102cb8$export$a8a61f8380f29e3a);
    const sources = $2edc1eef02a7c199$export$75430b411d43dc3f(reactiveSources);
    const handle = (v)=>{
        const last = output.last();
        const vv = fn(v);
        if (vv !== void 0) {
            if (ignoreIdentical && last !== void 0) {
                if (eq(vv, last)) return vv;
            }
            output.set(vv);
        }
        return vv;
    };
    const s = $2edc1eef02a7c199$var$initUpstream(sources, {
        ...options,
        onValue (v) {
            handle(v);
        }
    });
    const output = $2edc1eef02a7c199$var$cache(s, fn(sources.last()));
    return output;
}
// src/rx/sources/Event.ts
function $2edc1eef02a7c199$var$eventField(targetOrQuery, eventName, fieldName, initialValue, options = {}) {
    const initial = {};
    initial[fieldName] = initialValue;
    const rxField = $2edc1eef02a7c199$export$e0f35d825088c098($2edc1eef02a7c199$var$event(targetOrQuery, eventName, initial, options), fieldName, options);
    return rxField;
}
function $2edc1eef02a7c199$var$event(targetOrQuery, name, initialValue, options = {}) {
    let target;
    if (typeof targetOrQuery === `string`) {
        target = document.querySelector(targetOrQuery);
        if (target === null) throw new Error(`Target query did not resolve to an element. Query: '${targetOrQuery}'`);
    } else target = targetOrQuery;
    if (target === null) throw new Error(`Param 'targetOrQuery' is null`);
    const debugLifecycle = options.debugLifecycle ?? false;
    const debugFiring = options.debugFiring ?? false;
    const lazy = options.lazy ?? false;
    if (initialValue === void 0) initialValue = {};
    const rxObject = $2edc1eef02a7c199$var$object(initialValue, {
        deepEntries: true
    });
    let eventAdded = false;
    let disposed = false;
    const callback = (args)=>{
        if (debugFiring) console.log(`Reactive.event '${name}' firing '${JSON.stringify(args)}`);
        rxObject.set(args);
    };
    const remove2 = ()=>{
        if (!eventAdded) return;
        eventAdded = false;
        target.removeEventListener(name, callback);
        if (debugLifecycle) console.log(`Rx.From.event remove '${name}'`);
    };
    const add = ()=>{
        if (eventAdded) return;
        eventAdded = true;
        target.addEventListener(name, callback);
        if (debugLifecycle) console.log(`Rx.From.event add '${name}'`);
    };
    if (!lazy) add();
    return {
        last: ()=>{
            if (lazy) add();
            return rxObject.last();
        },
        dispose: (reason)=>{
            if (disposed) return;
            disposed = true;
            remove2();
            rxObject.dispose(reason);
        },
        isDisposed () {
            return disposed;
        },
        on: (handler)=>{
            if (lazy) add();
            return rxObject.on(handler);
        },
        onValue: (handler)=>{
            if (lazy) add();
            return rxObject.onValue(handler);
        }
    };
}
function $2edc1eef02a7c199$var$eventTrigger(targetOrQuery, name, options = {}) {
    let target;
    if (typeof targetOrQuery === `string`) {
        target = document.querySelector(targetOrQuery);
        if (target === null) throw new Error(`Target query did not resolve to an element. Query: '${targetOrQuery}'`);
    } else target = targetOrQuery;
    if (target === null) throw new Error(`Param 'targetOrQuery' is null`);
    const debugLifecycle = options.debugLifecycle ?? false;
    const debugFiring = options.debugFiring ?? false;
    const fireInitial = options.fireInitial ?? false;
    let count2 = 0;
    const elapsed2 = (0, $29a41e51920ca8b4$export$ae56a3c442de3c6a).interval();
    const stream = $2edc1eef02a7c199$var$initLazyStream({
        lazy: options.lazy ?? `very`,
        onStart () {
            target.addEventListener(name, callback);
            if (debugLifecycle) console.log(`Rx.From.eventTrigger add '${name}'`);
            if (fireInitial && count2 === 0) {
                if (debugLifecycle || debugFiring) console.log(`Rx.From.eventTrigger: firing initial`);
                callback();
            }
        },
        onStop () {
            target.removeEventListener(name, callback);
            if (debugLifecycle) console.log(`Rx.From.eventTrigger remove '${name}'`);
        }
    });
    const callback = (_args)=>{
        if (debugFiring) console.log(`Rx.From.eventTrigger '${name}' triggered'`);
        stream.set({
            sinceLast: elapsed2(),
            total: ++count2
        });
    };
    return stream;
}
// src/rx/sources/Dom.ts
function $2edc1eef02a7c199$var$domNumberInputValue(targetOrQuery, options = {}) {
    const input = $2edc1eef02a7c199$var$domInputValue(targetOrQuery, options);
    const el = input.el;
    const relative2 = options.relative ?? false;
    const inverted = options.inverted ?? false;
    const rx = $2edc1eef02a7c199$export$51186ad6e864892a(input, (v)=>{
        return Number.parseFloat(v);
    });
    if (relative2) {
        el.max = inverted ? "0" : "1";
        el.min = inverted ? "1" : "0";
        if (!el.hasAttribute(`step`)) el.step = "0.1";
    }
    if (el.getAttribute(`type`) === null) el.type = `range`;
    const set = (value)=>{
        input.set(value.toString());
    };
    return {
        ...rx,
        last () {
            return Number.parseFloat(input.last());
        },
        set: set
    };
}
function $2edc1eef02a7c199$var$domHslInputValue(targetOrQuery, options = {}) {
    const input = $2edc1eef02a7c199$var$domInputValue(targetOrQuery, {
        ...options,
        upstreamFilter (value) {
            return typeof value === `object` ? (0, $8a5cbeb1c6ae1b41$export$7ea66e3774a60b67)(value) : value;
        }
    });
    const rx = $2edc1eef02a7c199$export$51186ad6e864892a(input, (v)=>{
        return (0, $8a5cbeb1c6ae1b41$export$3dae994ede898e09)(v, true);
    });
    return {
        ...rx,
        last () {
            return (0, $8a5cbeb1c6ae1b41$export$3dae994ede898e09)(input.last(), true);
        },
        set (value) {
            input.set((0, $8a5cbeb1c6ae1b41$export$7ea66e3774a60b67)(value));
        }
    };
}
function $2edc1eef02a7c199$var$domInputValue(targetOrQuery, options = {}) {
    const target = typeof targetOrQuery === `string` ? document.querySelector(targetOrQuery) : targetOrQuery;
    if (target === null && typeof targetOrQuery === `string`) throw new Error(`Element query could not be resolved '${targetOrQuery}'`);
    if (target === null) throw new Error(`targetOrQuery is null`);
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(targetOrQuery);
    const when = options.when ?? `changed`;
    const eventName = when === `changed` ? `change` : `input`;
    const emitInitialValue = options.emitInitialValue ?? false;
    const fallbackValue = options.fallbackValue ?? ``;
    const upstreamSource = options.upstreamSource;
    let upstreamSourceUnsub = ()=>{};
    let attribName = options.attributeName;
    let fieldName = options.fieldName;
    if (fieldName === void 0 && attribName === void 0) attribName = fieldName = `value`;
    const readValue = ()=>{
        let value;
        if (attribName) value = el.getAttribute(attribName);
        if (fieldName) value = el[fieldName];
        if (value === void 0 || value === null) value = fallbackValue;
        return value;
    };
    const setValue = (value)=>{
        if (attribName) el.setAttribute(attribName, value);
        if (fieldName) el[fieldName] = value;
    };
    const setUpstream = (v)=>{
        v = options.upstreamFilter ? options.upstreamFilter(v) : v;
        setValue(v);
    };
    if (upstreamSource) {
        upstreamSourceUnsub = upstreamSource.onValue(setUpstream);
        if ((0, $f53657e65b61d2bb$export$792719627301184c)(upstreamSource)) setUpstream(upstreamSource.last());
    }
    const rxEvents = $2edc1eef02a7c199$var$eventTrigger(el, eventName, {
        fireInitial: emitInitialValue,
        debugFiring: options.debugFiring ?? false,
        debugLifecycle: options.debugLifecycle ?? false
    });
    const rxValues = $2edc1eef02a7c199$export$51186ad6e864892a(rxEvents, (_trigger)=>readValue());
    return {
        ...rxValues,
        el: el,
        last () {
            return readValue();
        },
        set (value) {
            setValue(value);
        },
        dispose (reason) {
            upstreamSourceUnsub();
            rxValues.dispose(reason);
            rxEvents.dispose(reason);
        }
    };
}
function $2edc1eef02a7c199$var$domForm(formElOrQuery, options = {}) {
    const formEl = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(formElOrQuery);
    const when = options.when ?? `changed`;
    const eventName = when === `changed` ? `change` : `input`;
    const emitInitialValue = options.emitInitialValue ?? false;
    const upstreamSource = options.upstreamSource;
    const typeHints = /* @__PURE__ */ new Map();
    let upstreamSourceUnsub = ()=>{};
    const readValue = ()=>{
        const fd = new FormData(formEl);
        const entries = [];
        for (const [k, v] of fd.entries()){
            const vStr = v.toString();
            let typeHint = typeHints.get(k);
            if (!typeHint) {
                const el = getFormElement(k, vStr);
                if (el) {
                    if (el.type === `range` || el.type === `number`) typeHint = `number`;
                    else if (el.type === `color`) typeHint = `colour`;
                    else if (el.type === `checkbox` && (v === `true` || v === `on`)) typeHint = `boolean`;
                    else typeHint = `string`;
                    typeHints.set(k, typeHint);
                }
            }
            if (typeHint === `number`) entries.push([
                k,
                Number.parseFloat(vStr)
            ]);
            else if (typeHint === `boolean`) {
                const vBool = vStr === `true` ? true : false;
                entries.push([
                    k,
                    vBool
                ]);
            } else if (typeHint === `colour`) {
                const vRgb = (0, $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03)(vStr, true);
                entries.push([
                    k,
                    (0, $8a5cbeb1c6ae1b41$export$593768a1c887fc17)(vRgb)
                ]);
            } else entries.push([
                k,
                v.toString()
            ]);
        }
        for (const el of formEl.querySelectorAll(`input[type="checkbox"]`))if (!el.checked && el.value === `true`) entries.push([
            el.name,
            false
        ]);
        const asObj = Object.fromEntries(entries);
        return asObj;
    };
    const getFormElement = (name, value)=>{
        const el = formEl.querySelector(`[name="${name}"]`);
        if (!el) {
            console.warn(`Form does not contain an element with name="${name}"`);
            return;
        }
        if (el.type === `radio`) {
            const radioEl = formEl.querySelector(`[name="${name}"][value="${value}"]`);
            if (!radioEl) {
                console.warn(`Form does not contain radio option for name=${name} value=${value}`);
                return;
            }
            return radioEl;
        }
        return el;
    };
    const setNamedValue = (name, value)=>{
        const el = getFormElement(name, value);
        if (!el) return;
        if (el.nodeName === `INPUT` || el.nodeName === `SELECT`) {
            if (el.type === `color`) {
                if (typeof value === `object`) {
                    const c = (0, $8a5cbeb1c6ae1b41$export$f7ad0328861e2f03)(value, true);
                    value = (0, $8a5cbeb1c6ae1b41$export$7ea66e3774a60b67)(c);
                }
            } else if (el.type === `checkbox`) {
                if (typeof value === `boolean`) {
                    el.checked = value;
                    return;
                } else console.warn(`Rx.Sources.domForm: Trying to set non boolean type to a checkbox. Name: ${name} Value: ${value} (${typeof value})`);
            } else if (el.type === `radio`) {
                el.checked = true;
                return;
            }
            el.value = value;
        }
    };
    const setFromUpstream = (value)=>{
        for (const [name, v] of Object.entries(value)){
            let hint = typeHints.get(name);
            if (!hint) {
                hint = typeof v;
                if (hint === `object`) {
                    const rgb = (0, $8a5cbeb1c6ae1b41$export$5dcc4524a470324)(v);
                    if (rgb.success) hint = `colour`;
                }
                typeHints.set(name, hint);
            }
            const valueFiltered = options.upstreamFilter ? options.upstreamFilter(name, v) : v;
            setNamedValue(name, valueFiltered);
        }
    };
    if (upstreamSource) {
        upstreamSourceUnsub = upstreamSource.onValue(setFromUpstream);
        if ((0, $f53657e65b61d2bb$export$792719627301184c)(upstreamSource)) setFromUpstream(upstreamSource.last());
    }
    const rxEvents = $2edc1eef02a7c199$var$eventTrigger(formEl, eventName, {
        fireInitial: emitInitialValue,
        debugFiring: options.debugFiring ?? false,
        debugLifecycle: options.debugLifecycle ?? false
    });
    const rxValues = $2edc1eef02a7c199$export$51186ad6e864892a(rxEvents, (_trigger)=>readValue());
    return {
        ...rxValues,
        el: formEl,
        last () {
            return readValue();
        },
        set: setFromUpstream,
        setNamedValue: setNamedValue,
        dispose (reason) {
            upstreamSourceUnsub();
            rxValues.dispose(reason);
            rxEvents.dispose(reason);
        }
    };
}
// src/rx/sources/Merged.ts
function $2edc1eef02a7c199$var$merged(...sources) {
    return $2edc1eef02a7c199$var$mergedWithOptions(sources);
}
function $2edc1eef02a7c199$var$mergedWithOptions(sources, options = {}) {
    let unsubs = [];
    const stream = $2edc1eef02a7c199$var$initLazyStream({
        ...options,
        onStart () {
            for (const s of sources)unsubs.push(s.onValue((v)=>{
                stream.set(v);
            }));
        },
        onStop () {
            for (const un of unsubs)un();
            unsubs = [];
        }
    });
    return stream;
}
// src/rx/sources/Number.ts
function $2edc1eef02a7c199$var$number(initialValue) {
    let value = initialValue;
    const events = $2edc1eef02a7c199$var$initStream();
    const set = (v)=>{
        value = v;
        events.set(v);
    };
    return {
        dispose: events.dispose,
        isDisposed: events.isDisposed,
        last: ()=>value,
        on: events.on,
        onValue: events.onValue,
        set: set
    };
}
// src/rx/sources/ObjectProxy.ts
var $2edc1eef02a7c199$var$objectProxy = (target)=>{
    const rx = $2edc1eef02a7c199$var$object(target);
    const proxy = new Proxy(target, {
        set (target2, p, newValue, _receiver) {
            const isArray = Array.isArray(target2);
            console.log(`Rx.Sources.object set. Target: ${JSON.stringify(target2)} (${typeof target2} array: ${Array.isArray(target2)}) p: ${JSON.stringify(p)} (${typeof p}) newValue: ${JSON.stringify(newValue)} recv: ${_receiver}`);
            if (isArray && p === `length`) return true;
            if (typeof p === `string`) rx.updateField(p, newValue);
            if (isArray && typeof p === `string`) {
                const pAsNumber = Number.parseInt(p);
                if (!Number.isNaN(pAsNumber)) {
                    target2[pAsNumber] = newValue;
                    return true;
                }
            }
            target2[p] = newValue;
            return true;
        }
    });
    return {
        proxy: proxy,
        rx: rx
    };
};
var $2edc1eef02a7c199$var$arrayProxy = (target)=>{
    const rx = $2edc1eef02a7c199$var$arrayObject(target);
    const proxy = new Proxy(target, {
        set (target2, p, newValue, _receiver) {
            if (p === `length`) return true;
            if (typeof p !== `string`) throw new Error(`Expected numeric index, got type: ${typeof p} value: ${JSON.stringify(p)}`);
            const pAsNumber = Number.parseInt(p);
            if (!Number.isNaN(pAsNumber)) {
                rx.setAt(pAsNumber, newValue);
                target2[pAsNumber] = newValue;
                return true;
            } else throw new Error(`Expected numeric index, got: '${p}'`);
        }
    });
    return {
        proxy: proxy,
        rx: rx
    };
};
var $2edc1eef02a7c199$var$objectProxySymbol = (target)=>{
    const { proxy: proxy, rx: rx } = $2edc1eef02a7c199$var$objectProxy(target);
    const p = proxy;
    p[$2edc1eef02a7c199$export$8f701197936bc2a6] = rx;
    return p;
};
// src/rx/sources/Observable.ts
function $2edc1eef02a7c199$var$observable(init) {
    const ow = $2edc1eef02a7c199$var$observableWritable(init);
    return {
        dispose: ow.dispose,
        isDisposed: ow.isDisposed,
        on: ow.on,
        onValue: ow.onValue
    };
}
function $2edc1eef02a7c199$var$observableWritable(init) {
    let onCleanup = ()=>{};
    const ow = $2edc1eef02a7c199$export$d5db38ffe1f43b01({
        onFirstSubscribe () {
            onCleanup = init(ow);
        },
        onNoSubscribers () {
            if (onCleanup) onCleanup();
        }
    });
    return {
        ...ow,
        onValue: (callback)=>{
            return ow.on((message)=>{
                if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) callback(message.value);
            });
        }
    };
}
// src/rx/sources/String.ts
function $2edc1eef02a7c199$var$string(initialValue) {
    let value = initialValue;
    const events = $2edc1eef02a7c199$var$initStream();
    const set = (v)=>{
        value = v;
        events.set(v);
    };
    return {
        dispose: events.dispose,
        isDisposed: events.isDisposed,
        last: ()=>value,
        on: events.on,
        onValue: events.onValue,
        set: set
    };
}
// src/rx/index.ts
function $2edc1eef02a7c199$export$889ea624f2cb2c57(source, ...ops) {
    let s = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
    for (const op of ops)s = op(s);
    return s;
}
function $2edc1eef02a7c199$export$e6d3eada50a007b1(source, ...ops) {
    let s = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
    const head = s;
    for (const op of ops)s = op(s);
    const ss = s;
    return {
        ...ss,
        set (value) {
            if ((0, $f53657e65b61d2bb$export$cc2b2f0230460456)(head)) head.set(value);
            else throw new Error(`Original source is not writable`);
        }
    };
}
function $2edc1eef02a7c199$export$d5db38ffe1f43b01(options = {}) {
    const events = $2edc1eef02a7c199$var$initStream(options);
    return {
        dispose: events.dispose,
        isDisposed: events.isDisposed,
        set (value) {
            events.set(value);
        },
        on: events.on,
        onValue: events.onValue
    };
}
var $2edc1eef02a7c199$export$3ac4f45559bd5a90 = {
    setHtmlText: (options)=>{
        return (source)=>{
            $2edc1eef02a7c199$export$a6c95c2b8a92aa27(source, options);
        };
    }
};
var $2edc1eef02a7c199$export$2655e45458bc48f3 = {
    /**
  * Annotates values with the result of a function.
  * The input value needs to be an object.
  * 
  * For every value `input` emits, run it through `annotator`, which should
  * return the original value with additional fields.
  * 
  * Conceptually the same as `transform`, just with typing to enforce result
  * values are V & TAnnotation
  * @param annotator 
  * @returns 
  */ annotate: (annotator)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$1012f5f00ec31870, annotator),
    /**
   * Annotates the input stream using {@link ReactiveOp} as the source of annotations.
   * The output values will have the shape of `{ value: TIn, annotation: TAnnotation }`.
   * Meaning that the original value is stored under `.value`, and the annotation under `.annotation`.
   * 
   * ```js
   * // Emit values from an array
   * const r1 = Rx.run(
   *  Rx.From.array([ 1, 2, 3 ]),
   *  Rx.Ops.annotateWithOp(
   *    // Add the 'max' operator to emit the largest-seen value
   *    Rx.Ops.sum()
   *  )
   * );
   * const data = await Rx.toArray(r1);
   * // Data =  [ { value: 1, annotation: 1 }, { value: 2, annotation: 3 }, { value: 3, annotation: 6 } ]
   * ```
   * @param annotatorOp 
   * @returns 
   */ annotateWithOp: (annotatorOp)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$be3adf485fb3cad4, annotatorOp),
    /**
   * Takes a stream of values and chunks them up (by quantity or time elapsed),
   * emitting them as an array.
   * @param options 
   * @returns 
   */ chunk: (options)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$5f7ec48d69707ddd(source, options);
        };
    },
    cloneFromFields: ()=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$794074063fcf8125(source);
        };
    },
    /**
  * Merges values from several sources into a single source that emits values as an array.
  * @param options 
  * @returns 
  */ combineLatestToArray: (options = {})=>{
        return (sources)=>{
            return $2edc1eef02a7c199$export$b5235d9cdb97b833(sources, options);
        };
    },
    /**
   * Merges values from several sources into a single source that emits values as an object.
   * @param options
   * @returns 
   */ combineLatestToObject: (options = {})=>{
        return (reactiveSources)=>{
            return $2edc1eef02a7c199$export$75430b411d43dc3f(reactiveSources, options);
        };
    },
    /**
  * Debounce values from the stream. It will wait until a certain time
  * has elapsed before emitting latest value.
  * 
  * Effect is that no values are emitted if input emits faster than the provided
  * timeout.
  * 
  * See also: throttle
  * @param options 
  * @returns 
  */ debounce: (options)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$61fc7d43ac8f84b0(source, options);
        };
    },
    /**
   * Drops values from the input stream that match `predicate`
   * @param predicate If it returns _true_ value is ignored
   * @returns 
   */ drop: (predicate)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$663103110d94aac9, predicate),
    /**
   * Every upstream value is considered the target for interpolation.
   * Output value interpolates by a given amount toward the target.
   * @returns 
   */ elapsed: ()=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$e04aa69d28450d55),
    /**
   * Yields the value of a field from an input stream of values.
   * Eg if the source reactive emits `{ colour: string, size: number }`,
   * we might use `field` to pluck out the `colour` field, thus returning
   * a stream of string values.
   * @param fieldName 
   * @param options 
   * @returns 
   */ field: (fieldName, options)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$e0f35d825088c098(source, fieldName, options);
        };
    },
    /**
   * Filters the input stream, only re-emitting values that pass the predicate
   * @param predicate If it returns _true_ value is allowed through
   * @returns 
   */ filter: (predicate)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$5f7dfb0a65ac6c, predicate),
    /**
   * Every upstream value is considered the target for interpolation.
   * Output value interpolates by a given amount toward the target.
   * @param options 
   * @returns 
   */ interpolate: (options)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$402e16690d69fb88, options),
    /**
  * Outputs the minimum numerical value of the stream.
  * A value is only emitted when minimum decreases.
  * @returns 
  */ min: (options)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$b393be5a551404be, options),
    /**
   * Outputs the maxium numerical value of the stream.
   * A value is only emitted when maximum increases.
   * @returns 
   */ max: (options)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$22cda90bd12095a9, options),
    sum: (options)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$8cb7414e874a9718, options),
    average: (options)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$5c3bbf40eb9d4622, options),
    tally: (options)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$7ed03ecedcf10c1, options),
    rank: (rank3, options)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$7bfb89b13199fa43, rank3, options),
    pipe: (...streams)=>{
        return (source)=>{
            const resolved = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
            const s = [
                resolved,
                ...streams
            ];
            return $2edc1eef02a7c199$export$a4627e546088548d(...s);
        };
    },
    singleFromArray: (options = {})=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$a5a4a5cffa78c0a4(source, options);
        };
    },
    split: (options = {})=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$65980d18b75784e2(source, options);
        };
    },
    splitLabelled: (labels)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$ecb39c0370b0b52d(source, labels);
        };
    },
    switcher: (cases, options = {})=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$8987e38cfd004b13(source, cases, options);
        };
    },
    syncToArray: (options = {})=>{
        return (reactiveSources)=>{
            return $2edc1eef02a7c199$export$5eb154d8c1f8350(reactiveSources, options);
        };
    },
    syncToObject: (options = {})=>{
        return (reactiveSources)=>{
            return $2edc1eef02a7c199$export$b32b2cebf6eb1280(reactiveSources, options);
        };
    },
    tapProcess: (processor)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$b6175151fde1dc87(source, processor);
        };
    },
    tapStream: (divergedStream)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$bedfced534e7bc06(source, divergedStream);
        };
    },
    tapOps: (...ops)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$b6abe60b3da98fc9(source, ...ops);
        };
    },
    /**
  * Throttle values from the stream.
  * Only emits a value if some minimum time has elapsed.
  * @param options 
  * @returns 
  */ throttle: (options)=>(0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$de363e709c412c8a, options),
    /**
   * Trigger a value if 'source' does not emit a value within an interval.
   * Trigger value can be a fixed value, result of function, or step through an iterator.
   * @param options 
   * @returns 
   */ timeoutValue: (options)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$8862a6a079f688d3(source, options);
        };
    },
    timeoutPing: (options)=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$23da8b73b6fbb5b7(source, options);
        };
    },
    transform: (transformer, options = {})=>{
        return (source)=>{
            return $2edc1eef02a7c199$export$51186ad6e864892a(source, transformer, options);
        };
    },
    /**
  * Reactive where last (or a given initial) value is available to read
  * @param opts 
  * @returns 
  */ withValue: (opts)=>{
        return (0, $f53657e65b61d2bb$export$fd14f74bcdfcca7f)($2edc1eef02a7c199$export$3a92ed5088d25bc6, opts);
    }
};
async function $2edc1eef02a7c199$export$df6ae744d7e44e30(source, maximumWait = 1e3) {
    const rx = $2edc1eef02a7c199$export$6b1de85efae8a879(source);
    let off = ()=>{};
    let watchdog;
    const p = new Promise((resolve3, reject)=>{
        off = rx.on((message)=>{
            if (watchdog) clearTimeout(watchdog);
            if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
                off();
                resolve3(message.value);
            } else if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) {
                reject(new Error(`Source closed. ${message.context ?? ``}`));
                off();
            }
        });
        watchdog = setTimeout(()=>{
            watchdog = void 0;
            off();
            reject(new Error(`Timeout waiting for value (${JSON.stringify(maximumWait)})`));
        }, (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(maximumWait));
    });
    return p;
}
var $2edc1eef02a7c199$export$2c618a4308a30424 = (a, b, transform2, closeBonA = false)=>{
    const unsub = a.on((message)=>{
        if ((0, $f53657e65b61d2bb$export$dd622c303f54f474)(message)) {
            const value = transform2 ? transform2(message.value) : message.value;
            b.set(value);
        } else if ((0, $f53657e65b61d2bb$export$49fb011922c314de)(message)) {
            unsub();
            if (closeBonA) b.dispose(`Source closed (${message.context ?? ``})`);
        }
    });
    return unsub;
};





// src/numbers/Bipolar.ts
var $50567df4f0caddad$export$f1bd9a12526fa60c = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($50567df4f0caddad$export$f1bd9a12526fa60c, {
    clamp: ()=>$50567df4f0caddad$export$7d15b64cf5a3a4c4,
    fromScalar: ()=>$50567df4f0caddad$var$fromScalar,
    immutable: ()=>$50567df4f0caddad$var$immutable,
    random: ()=>$50567df4f0caddad$var$random,
    randomSource: ()=>$50567df4f0caddad$var$randomSource,
    scale: ()=>$50567df4f0caddad$var$scale,
    scaleUnclamped: ()=>$50567df4f0caddad$var$scaleUnclamped,
    toScalar: ()=>$50567df4f0caddad$var$toScalar,
    towardZero: ()=>$50567df4f0caddad$var$towardZero
});
var $50567df4f0caddad$var$immutable = (startingValueOrBipolar = 0)=>{
    if (typeof startingValueOrBipolar === `undefined`) throw new Error(`Start value is undefined`);
    const startingValue = typeof startingValueOrBipolar === `number` ? startingValueOrBipolar : startingValueOrBipolar.value;
    if (startingValue > 1) throw new Error(`Start value cannot be larger than 1`);
    if (startingValue < -1) throw new Error(`Start value cannot be smaller than -1`);
    if (Number.isNaN(startingValue)) throw new Error(`Start value is NaN`);
    const v = startingValue;
    return {
        [Symbol.toPrimitive] (hint) {
            if (hint === `number`) return v;
            else if (hint === `string`) return v.toString();
            return true;
        },
        value: v,
        towardZero: (amt)=>{
            return $50567df4f0caddad$var$immutable($50567df4f0caddad$var$towardZero(v, amt));
        },
        add: (amt)=>{
            return $50567df4f0caddad$var$immutable($50567df4f0caddad$export$7d15b64cf5a3a4c4(v + amt));
        },
        multiply: (amt)=>{
            return $50567df4f0caddad$var$immutable($50567df4f0caddad$export$7d15b64cf5a3a4c4(v * amt));
        },
        inverse: ()=>{
            return $50567df4f0caddad$var$immutable(-v);
        },
        interpolate: (amt, b)=>{
            return $50567df4f0caddad$var$immutable($50567df4f0caddad$export$7d15b64cf5a3a4c4((0, $2edc1eef02a7c199$export$4e4c1a907874f01)(amt, v, b)));
        },
        asScalar: ()=>{
            return $50567df4f0caddad$var$toScalar(v);
        }
    };
};
var $50567df4f0caddad$var$toScalar = (bipolarValue)=>{
    if (typeof bipolarValue !== `number`) throw new Error(`Expected v to be a number. Got: ${typeof bipolarValue}`);
    if (Number.isNaN(bipolarValue)) throw new Error(`Parameter is NaN`);
    return (bipolarValue + 1) / 2;
};
var $50567df4f0caddad$var$fromScalar = (scalarValue)=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(scalarValue, `percentage`, `v`);
    return scalarValue * 2 - 1;
};
var $50567df4f0caddad$var$scale = (inputValue, inMin, inMax)=>{
    return $50567df4f0caddad$export$7d15b64cf5a3a4c4((0, $8a5cbeb1c6ae1b41$export$392c70347f2a027f)(inMin, inMax, -1, 1)(inputValue));
};
var $50567df4f0caddad$var$scaleUnclamped = (inputValue, inMin, inMax)=>{
    return (0, $8a5cbeb1c6ae1b41$export$392c70347f2a027f)(inMin, inMax, -1, 1)(inputValue);
};
var $50567df4f0caddad$var$randomSource = (maxOrOptions)=>{
    const source = (0, $ecc9b4c6822e4e6b$export$a627116c255f4dc3)(maxOrOptions);
    return ()=>source() * 2 - 1;
};
var $50567df4f0caddad$var$random = (maxOrOptions)=>{
    const source = $50567df4f0caddad$var$randomSource(maxOrOptions);
    return source();
};
var $50567df4f0caddad$export$7d15b64cf5a3a4c4 = (bipolarValue)=>{
    if (typeof bipolarValue !== `number`) throw new Error(`Param 'bipolarValue' must be a number. Got: ${typeof bipolarValue}`);
    if (Number.isNaN(bipolarValue)) throw new Error(`Param 'bipolarValue' is NaN`);
    if (bipolarValue > 1) return 1;
    if (bipolarValue < -1) return -1;
    return bipolarValue;
};
var $50567df4f0caddad$var$towardZero = (bipolarValue, amount)=>{
    if (typeof bipolarValue !== `number`) throw new Error(`Parameter 'v' must be a number. Got: ${typeof bipolarValue}`);
    if (typeof amount !== `number`) throw new Error(`Parameter 'amt' must be a number. Got: ${typeof amount}`);
    if (amount < 0) throw new Error(`Parameter 'amt' must be positive`);
    if (bipolarValue < 0) {
        bipolarValue += amount;
        if (bipolarValue > 0) bipolarValue = 0;
    } else if (bipolarValue > 0) {
        bipolarValue -= amount;
        if (bipolarValue < 0) bipolarValue = 0;
    }
    return bipolarValue;
};





// src/numbers/LinearSpace.ts
function* $abbd9d7515dff109$export$421842365e70382c(start, end, steps, precision) {
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(start, ``, `start`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(end, ``, `end`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(steps, ``, `steps`);
    const r = precision ? (0, $42f472314cb088f7$export$2077e0241d6afd3c)(precision) : (v)=>v;
    const step = (end - start) / (steps - 1);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(step, ``, `step`);
    if (!Number.isFinite(step)) throw new TypeError(`Calculated step value is infinite`);
    for(let index = 0; index < steps; index++){
        const v = start + step * index;
        yield r(v);
    }
}










// src/numbers/index.ts
var $76636d93853b923d$export$bcbe6393efc8ae1f = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($76636d93853b923d$export$bcbe6393efc8ae1f, {
    Bipolar: ()=>(0, $50567df4f0caddad$export$f1bd9a12526fa60c),
    Normalise: ()=>$76636d93853b923d$export$fc2777cddbef22c6,
    applyToValues: ()=>$76636d93853b923d$export$25ffd0d93c5aa8ba,
    average: ()=>(0, $36aa4387660da012$export$cc6710ee5f037d57),
    averageWeighted: ()=>(0, $2edc1eef02a7c199$export$bbd5ff27d45679),
    clamp: ()=>(0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4),
    clampIndex: ()=>(0, $ab835bc9d61bae68$export$cdbb71092bf28e30),
    clamper: ()=>(0, $ab835bc9d61bae68$export$fc151c03e1fcd7c),
    count: ()=>(0, $ecc9b4c6822e4e6b$export$85b9a36db797e02b),
    differenceFromFixed: ()=>$76636d93853b923d$export$e8e8fb51a3d4e8fe,
    differenceFromLast: ()=>$76636d93853b923d$export$d9cb11fdb0d885ac,
    dotProduct: ()=>(0, $36aa4387660da012$export$2dfa5a136446eaca),
    filter: ()=>$76636d93853b923d$export$3dea766d36a8935f,
    flip: ()=>$76636d93853b923d$export$8a83211c878a3f1f,
    interpolate: ()=>(0, $2edc1eef02a7c199$export$4e4c1a907874f01),
    interpolateAngle: ()=>(0, $2edc1eef02a7c199$export$92c7c4f86cf692ac),
    interpolatorInterval: ()=>(0, $2edc1eef02a7c199$export$c71a20c38c3fd4e2),
    interpolatorStepped: ()=>(0, $2edc1eef02a7c199$export$c8b97d3b09cfcda6),
    isApprox: ()=>$76636d93853b923d$export$bd058bf002c0540e,
    isValid: ()=>$76636d93853b923d$export$1ea939691cdc45b8,
    linearSpace: ()=>(0, $abbd9d7515dff109$export$421842365e70382c),
    max: ()=>(0, $36aa4387660da012$export$8960430cfd85939f),
    maxFast: ()=>(0, $36aa4387660da012$export$f41fc95ce818cf3e),
    maxIndex: ()=>(0, $36aa4387660da012$export$6e0413888cd9bad3),
    min: ()=>(0, $36aa4387660da012$export$96ec731ed4dcb222),
    minFast: ()=>(0, $36aa4387660da012$export$70f363b986c8e811),
    minIndex: ()=>(0, $36aa4387660da012$export$e410eba367ce792b),
    minMaxAvg: ()=>(0, $9364ac8ced0e518d$export$24ad9025a0be0d69),
    movingAverage: ()=>(0, $2edc1eef02a7c199$export$e0ccbd22a5b3aab6),
    movingAverageLight: ()=>(0, $2edc1eef02a7c199$export$a5d561de29dbfedf),
    movingAverageTimed: ()=>(0, $2edc1eef02a7c199$export$89050dda36d62cd2),
    noiseFilter: ()=>(0, $2edc1eef02a7c199$export$4ab932ba473f741c),
    numericPercent: ()=>$76636d93853b923d$export$6aa9e71c0b90896f,
    numericRange: ()=>$76636d93853b923d$export$f6692d3e37bae10d,
    numericRangeRaw: ()=>$76636d93853b923d$export$e9cee18aa2c8c979,
    piPi: ()=>(0, $2edc1eef02a7c199$export$2c99c7b81f64b3e5),
    proportion: ()=>$76636d93853b923d$export$5a14da41381fe262,
    quantiseEvery: ()=>(0, $2edc1eef02a7c199$export$c0481193539b5c4e),
    round: ()=>(0, $42f472314cb088f7$export$2077e0241d6afd3c),
    scale: ()=>(0, $8a5cbeb1c6ae1b41$export$dcdf75081b88279d),
    scaleClamped: ()=>(0, $8a5cbeb1c6ae1b41$export$9d3e539142ae65ac),
    scalePercent: ()=>(0, $8a5cbeb1c6ae1b41$export$14499786dedefe2f),
    scalePercentages: ()=>(0, $8a5cbeb1c6ae1b41$export$b609727d97245517),
    scaler: ()=>(0, $8a5cbeb1c6ae1b41$export$392c70347f2a027f),
    scalerPercent: ()=>(0, $8a5cbeb1c6ae1b41$export$a2e4f19528ae6b43),
    scalerTwoWay: ()=>(0, $8a5cbeb1c6ae1b41$export$eb38615a970f20ed),
    softmax: ()=>$76636d93853b923d$export$e008137e76238601,
    total: ()=>(0, $36aa4387660da012$export$9086bb9c16b2b5b),
    totalFast: ()=>(0, $36aa4387660da012$export$cf1a774fd7314f92),
    validNumbers: ()=>(0, $36aa4387660da012$export$dbc711cdddce94af),
    weight: ()=>(0, $36aa4387660da012$export$89a2d5e3ba94fe8a),
    wrap: ()=>(0, $2edc1eef02a7c199$export$4997ffc0176396a6),
    wrapInteger: ()=>(0, $2edc1eef02a7c199$export$39360f24a1bae86c),
    wrapRange: ()=>(0, $2edc1eef02a7c199$export$4fa93d78fefc051b)
});
// src/numbers/ApplyToValues.ts
var $76636d93853b923d$export$25ffd0d93c5aa8ba = (object, apply)=>{
    const o = {
        ...object
    };
    for (const [key, value] of Object.entries(object))if (typeof value === `number`) o[key] = apply(value);
    else o[key] = value;
    return o;
};
// src/numbers/Guard.ts
var $76636d93853b923d$export$1ea939691cdc45b8 = (possibleNumber)=>{
    if (typeof possibleNumber !== `number`) return false;
    if (Number.isNaN(possibleNumber)) return false;
    return true;
};
// src/numbers/Filter.ts
function* $76636d93853b923d$export$3dea766d36a8935f(it) {
    for (const v of it)if ($76636d93853b923d$export$1ea939691cdc45b8(v)) yield v;
}
// src/numbers/Flip.ts
var $76636d93853b923d$export$8a83211c878a3f1f = (v)=>{
    if (typeof v === `function`) v = v();
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(v, `percentage`, `v`);
    return 1 - v;
};
// src/numbers/Generate.ts
var $76636d93853b923d$export$e9cee18aa2c8c979 = function*(interval, start = 0, end, repeating = false) {
    if (interval <= 0) throw new Error(`Interval is expected to be above zero`);
    if (end === void 0) end = Number.MAX_SAFE_INTEGER;
    let v = start;
    do while(v < end){
        yield v;
        v += interval;
    }
    while (repeating);
};
var $76636d93853b923d$export$f6692d3e37bae10d = function*(interval, start = 0, end, repeating = false, rounding) {
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(interval, `nonZero`);
    const negativeInterval = interval < 0;
    if (end === void 0) ;
    else {
        if (negativeInterval && start < end) throw new Error(`Interval of ${interval} will never go from ${start} to ${end}`);
        if (!negativeInterval && start > end) throw new Error(`Interval of ${interval} will never go from ${start} to ${end}`);
    }
    rounding = rounding ?? 1e3;
    if (end === void 0) end = Number.MAX_SAFE_INTEGER;
    else end *= rounding;
    interval = interval * rounding;
    do {
        let v = start * rounding;
        while(!negativeInterval && v <= end || negativeInterval && v >= end){
            yield v / rounding;
            v += interval;
        }
    }while (repeating);
};
var $76636d93853b923d$export$6aa9e71c0b90896f = function(interval = 0.01, repeating = false, start = 0, end = 1) {
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(interval, `percentage`, `interval`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(start, `percentage`, `start`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(end, `percentage`, `end`);
    return $76636d93853b923d$export$f6692d3e37bae10d(interval, start, end, repeating);
};
// src/numbers/IsApprox.ts
function $76636d93853b923d$export$bd058bf002c0540e(rangePercent, baseValue, v) {
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(rangePercent, `percentage`, `rangePercent`);
    const range = Math.floor(rangePercent * 100);
    const test = (base, value)=>{
        try {
            if (typeof value !== `number`) return false;
            if (Number.isNaN(value)) return false;
            if (!Number.isFinite(value)) return false;
            const diff = Math.abs(value - base);
            const relative = base === 0 ? Math.floor(diff * 100) : Math.floor(diff / base * 100);
            return relative <= range;
        } catch  {
            return false;
        }
    };
    if (baseValue === void 0) return test;
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(baseValue, ``, `baseValue`);
    if (v === void 0) return (value)=>test(baseValue, value);
    else return test(baseValue, v);
}
// src/numbers/Normalise.ts
var $76636d93853b923d$export$fc2777cddbef22c6 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($76636d93853b923d$export$fc2777cddbef22c6, {
    array: ()=>$76636d93853b923d$var$array,
    stream: ()=>$76636d93853b923d$var$stream
});
var $76636d93853b923d$var$stream = (minDefault, maxDefault)=>{
    let min2 = minDefault ?? Number.MAX_SAFE_INTEGER;
    let max2 = maxDefault ?? Number.MIN_SAFE_INTEGER;
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(min2);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(max2);
    return (v)=>{
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(v);
        min2 = Math.min(min2, v);
        max2 = Math.max(max2, v);
        return (0, $8a5cbeb1c6ae1b41$export$dcdf75081b88279d)(v, min2, max2);
    };
};
var $76636d93853b923d$var$array = (values, minForced, maxForced)=>{
    if (!Array.isArray(values)) throw new TypeError(`Param 'values' should be an array. Got: ${typeof values}`);
    const mma = (0, $9364ac8ced0e518d$export$24ad9025a0be0d69)(values);
    const min2 = minForced ?? mma.min;
    const max2 = maxForced ?? mma.max;
    return values.map((v)=>(0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)((0, $8a5cbeb1c6ae1b41$export$dcdf75081b88279d)(v, min2, max2)));
};
// src/numbers/Proportion.ts
var $76636d93853b923d$export$5a14da41381fe262 = (v, t)=>{
    if (typeof v === `function`) v = v();
    if (typeof t === `function`) t = t();
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(v, `percentage`, `v`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(t, `percentage`, `t`);
    return v * t;
};
// src/numbers/Difference.ts
var $76636d93853b923d$export$e8e8fb51a3d4e8fe = (initial, kind = `absolute`)=>(value)=>$76636d93853b923d$var$differenceFrom(kind, value, initial);
var $76636d93853b923d$export$d9cb11fdb0d885ac = (kind = `absolute`, initialValue = Number.NaN)=>{
    let lastValue = initialValue;
    return (value)=>{
        const x = $76636d93853b923d$var$differenceFrom(kind, value, lastValue);
        lastValue = value;
        return x;
    };
};
var $76636d93853b923d$var$differenceFrom = (kind = `absolute`, value, from)=>{
    if (Number.isNaN(from)) return 0;
    const d = value - from;
    let r = 0;
    if (kind === `absolute`) r = Math.abs(d);
    else if (kind === `numerical`) r = d;
    else if (kind === `relative`) r = Math.abs(d / from);
    else if (kind === `relativeSigned`) r = d / from;
    else throw new TypeError(`Unknown kind: '${kind}' Expected: 'absolute', 'relative', 'relativeSigned' or 'numerical'`);
    return r;
};
// src/numbers/Softmax.ts
var $76636d93853b923d$export$e008137e76238601 = (logits)=>{
    const maxLogit = logits.reduce((a, b)=>Math.max(a, b), Number.NEGATIVE_INFINITY);
    const scores = logits.map((l)=>Math.exp(l - maxLogit));
    const denom = scores.reduce((a, b)=>a + b);
    return scores.map((s)=>s / denom);
};













// src/debug/index.ts
var $05b0ec3d1054f5d9$export$921ccba1b7c34f19 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($05b0ec3d1054f5d9$export$921ccba1b7c34f19, {
    fpsCounter: ()=>$05b0ec3d1054f5d9$export$b4c24f164807ccf5,
    getErrorMessage: ()=>(0, $96302e292290d7c3$export$82f46aa4e6535a45),
    logColours: ()=>(0, $c40eb93fec8b01a3$export$bab3e120901ceec2),
    logSet: ()=>(0, $c40eb93fec8b01a3$export$84ef0e73991701e2),
    logger: ()=>(0, $c40eb93fec8b01a3$export$af88d00dbe7f521),
    resolveLogOption: ()=>(0, $c40eb93fec8b01a3$export$9b88029edfd31073)
});
// src/debug/FpsCounter.ts
var $05b0ec3d1054f5d9$export$b4c24f164807ccf5 = (autoDisplay = true, computeAfterFrames = 500)=>{
    let count = 0;
    let lastFps = 0;
    let countStart = performance.now();
    return ()=>{
        if (count++ >= computeAfterFrames) {
            const elapsed = performance.now() - countStart;
            countStart = performance.now();
            count = 0;
            lastFps = Math.floor(computeAfterFrames / elapsed * 1e3);
            if (autoDisplay) console.log(`fps: ${lastFps}`);
        }
        return lastFps;
    };
};































// src/geometry/line/FromPoints.ts
var $3beaef080eb52aa9$export$188c3cd07b4129dd = (a, b)=>{
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(a, `a`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(b, `b`);
    a = Object.freeze({
        ...a
    });
    b = Object.freeze({
        ...b
    });
    return Object.freeze({
        a: a,
        b: b
    });
};
// src/geometry/line/FromNumbers.ts
var $3beaef080eb52aa9$export$c2b110734982f150 = (x1, y1, x2, y2)=>{
    if (Number.isNaN(x1)) throw new Error(`x1 is NaN`);
    if (Number.isNaN(x2)) throw new Error(`x2 is NaN`);
    if (Number.isNaN(y1)) throw new Error(`y1 is NaN`);
    if (Number.isNaN(y2)) throw new Error(`y2 is NaN`);
    const a = {
        x: x1,
        y: y1
    };
    const b = {
        x: x2,
        y: y2
    };
    return $3beaef080eb52aa9$export$188c3cd07b4129dd(a, b);
};






// src/collections/set/index.ts
var $297664b1c3fbdd1f$export$8428685b19a2228 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($297664b1c3fbdd1f$export$8428685b19a2228, {
    MassiveSet: ()=>$297664b1c3fbdd1f$export$fdddf8c96aae36d3,
    immutable: ()=>$297664b1c3fbdd1f$export$fc3a40dec7b33bf,
    mutable: ()=>$297664b1c3fbdd1f$export$9cc7a411a0b9bd72
});
// src/collections/set/SetMutable.ts
var $297664b1c3fbdd1f$export$9cc7a411a0b9bd72 = (keyString)=>new $297664b1c3fbdd1f$export$c14919a124a31507(keyString);
var $297664b1c3fbdd1f$export$c14919a124a31507 = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    /**
   * Constructor
   * @param keyString Function which returns a string version of added items. If unspecified `JSON.stringify`
   */ constructor(keyString){
        super();
        // ✔ UNIT TESTED
        /* eslint-disable functional/prefer-readonly-type */ this.store = /* @__PURE__ */ new Map();
        this.keyString = keyString ?? (0, $96f72d8c52c10ae7$export$8ccc4b0affe653ec);
    }
    /**
   * Number of items stored in set
   */ get size() {
        return this.store.size;
    }
    /**
   * Adds one or more items to set. `add` event is fired for each item
   * @param values items to add
   */ add(...values) {
        let somethingAdded = false;
        for (const value of values){
            const isUpdated = this.has(value);
            this.store.set(this.keyString(value), value);
            super.fireEvent(`add`, {
                value: value,
                updated: isUpdated
            });
            if (!isUpdated) somethingAdded = true;
        }
        return somethingAdded;
    }
    /**
   * Returns values from set as an iterable
   * @returns
   */ //eslint-disable-next-line functional/prefer-tacit
    values() {
        return this.store.values();
    }
    /**
   * Clear items from set
   */ clear() {
        this.store.clear();
        super.fireEvent(`clear`, true);
    }
    /**
   * Delete value from set.
   * @param v Value to delete
   * @returns _True_ if item was found and removed
   */ delete(v) {
        const isDeleted = this.store.delete(this.keyString(v));
        if (isDeleted) super.fireEvent(`delete`, v);
        return isDeleted;
    }
    /**
   * Returns _true_ if item exists in set
   * @param v
   * @returns
   */ has(v) {
        return this.store.has(this.keyString(v));
    }
    /**
   * Returns array copy of set
   * @returns Array copy of set
   */ toArray() {
        return [
            ...this.store.values()
        ];
    }
};
// src/collections/set/SetImmutable.ts
var $297664b1c3fbdd1f$export$4d5b007639646df9 = class _SetStringImmutable {
    //eslint-disable-next-line functional/prefer-immutable-types
    constructor(keyString, map){
        this.store = map ?? /* @__PURE__ */ new Map();
        this.keyString = keyString ?? (0, $96f72d8c52c10ae7$export$8ccc4b0affe653ec);
    }
    get size() {
        return this.store.size;
    }
    add(...values) {
        const s = new Map(this.store);
        for (const v of values){
            const key = this.keyString(v);
            s.set(key, v);
        }
        return new _SetStringImmutable(this.keyString, s);
    }
    delete(v) {
        const s = new Map(this.store);
        const key = this.keyString(v);
        if (s.delete(key)) return new _SetStringImmutable(this.keyString, s);
        return this;
    }
    has(v) {
        const key = this.keyString(v);
        return this.store.has(key);
    }
    toArray() {
        return [
            ...this.store.values()
        ];
    }
    *values() {
        yield* this.store.values();
    }
};
var $297664b1c3fbdd1f$export$fc3a40dec7b33bf = (keyString = (0, $847987b26b102cb8$export$f5a6f2033c1996c8))=>new $297664b1c3fbdd1f$export$4d5b007639646df9(keyString);
// src/collections/set/MassiveSet.ts
var $297664b1c3fbdd1f$export$fdddf8c96aae36d3 = class _MassiveSet {
    constructor(maxDepth = 1, depth = 0){
        this.children = /* @__PURE__ */ new Map();
        this.values = [];
        this.#depth = depth;
        this.#maxDepth = maxDepth;
    }
    #depth;
    #maxDepth;
    /**
   * Returns the number of values stored in just this level of the set
   * @returns 
   */ sizeLocal() {
        return this.values.length;
    }
    /**
   * Returns the number of branches at this node
   * Use {@link sizeChildrenDeep} to count all branches recursively
   * @returns 
   */ sizeChildren() {
        return [
            ...this.children.values()
        ].length;
    }
    sizeChildrenDeep() {
        let t = this.sizeChildren();
        for (const c of this.children.values())t += c.sizeChildrenDeep();
        return t;
    }
    /**
   * Returns the total number of values stored in the set
   */ size() {
        let x = this.values.length;
        for (const set of this.children.values())x += set.size();
        return x;
    }
    add(value) {
        if (typeof value !== `string`) throw new Error(`Param 'value' must be a string. Got: ${typeof value}`);
        if (value.length === 0) throw new Error(`Param 'value' is empty`);
        const destination = this.#getChild(value, true);
        if (destination === this) {
            if (!this.hasLocal(value)) this.values.push(value);
            return;
        }
        if (!destination) throw new Error(`Could not create child set for: ${value}`);
        destination.add(value);
    }
    remove(value) {
        if (typeof value !== `string`) throw new Error(`Param 'value' must be a string. Got: ${typeof value}`);
        if (value.length === 0) throw new Error(`Param 'value' is empty`);
        const destination = this.#getChild(value, false);
        if (destination === void 0) return false;
        if (destination === this) {
            if (this.hasLocal(value)) {
                this.values = this.values.filter((v)=>v !== value);
                return true;
            }
            return false;
        }
        return destination.remove(value);
    }
    debugDump() {
        const r = this.#dumpToArray();
        for (const rr of r)console.log(rr);
    }
    #dumpToArray(depth = 0) {
        const r = [];
        r.push(`Depth: ${this.#depth} Max: ${this.#maxDepth}`);
        for (const [key, value] of this.children.entries()){
            const dumped = value.#dumpToArray(depth + 1);
            r.push(` key: ${key}`);
            for (const d of dumped)r.push(` `.repeat(depth + 1) + d);
        }
        r.push(`Values: (${this.values.length})`);
        for (const v of this.values)r.push(` ${v}`);
        return r.map((line)=>` `.repeat(depth) + line);
    }
    #getChild(value, create) {
        if (value === void 0) throw new Error(`Param 'value' undefined`);
        if (this.#depth === this.#maxDepth) return this;
        if (value.length <= this.#depth) return this;
        const k = value[this.#depth];
        if (k === void 0) throw new Error(`Logic error. Depth: ${this.#depth} Len: ${value.length}`);
        let child = this.children.get(k);
        if (child === void 0 && create) {
            child = new _MassiveSet(this.#maxDepth, this.#depth + 1);
            this.children.set(k, child);
        }
        return child;
    }
    /**
   * Returns _true_ if `value` stored on this node
   * @param value 
   * @returns 
   */ hasLocal(value) {
        for (const v of this.values){
            if (v === value) return true;
        }
        return false;
    }
    has(value) {
        if (typeof value !== `string`) return false;
        const destination = this.#getChild(value, false);
        if (destination === void 0) return false;
        if (destination === this) return this.hasLocal(value);
        return destination.has(value);
    }
};












// src/geometry/index.ts
var $da7bbf79b162d05c$export$71b1a1afd51bc7eb = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$71b1a1afd51bc7eb, {
    Arcs: ()=>$da7bbf79b162d05c$export$eecff1bbfbd2dfdd,
    Beziers: ()=>(0, $2edc1eef02a7c199$export$2219b47b432bbc78),
    Circles: ()=>$da7bbf79b162d05c$export$15beefeae76985d5,
    Compound: ()=>$da7bbf79b162d05c$export$58cca3917bf916af,
    Convolve2d: ()=>$da7bbf79b162d05c$export$c4a559353abe3b18,
    CurveSimplification: ()=>$da7bbf79b162d05c$export$c9593da9d193b09d,
    Ellipses: ()=>$da7bbf79b162d05c$export$b8cb64530ccf11c4,
    Grids: ()=>$da7bbf79b162d05c$export$e929600bc3c2764b,
    Layouts: ()=>$da7bbf79b162d05c$export$f3f3ecca1886fcb1,
    Lines: ()=>$da7bbf79b162d05c$export$ac0eb7b0d2fd21a,
    Paths: ()=>$da7bbf79b162d05c$export$4a455666aaa3b016,
    Points: ()=>(0, $2edc1eef02a7c199$export$686cad0ec81705cb),
    Polar: ()=>(0, $2edc1eef02a7c199$export$c20c3ae8c54a7e6a),
    QuadTree: ()=>$da7bbf79b162d05c$export$a544ded366bdbcda,
    Rects: ()=>$da7bbf79b162d05c$export$40726222f7ec099b,
    Scaler: ()=>$da7bbf79b162d05c$export$635358aeaf898680,
    Shapes: ()=>$da7bbf79b162d05c$export$634b7c338114ff6d,
    SurfacePoints: ()=>$da7bbf79b162d05c$export$cd2417363469b959,
    Triangles: ()=>$da7bbf79b162d05c$export$295ac55e84320fb3,
    Vectors: ()=>$da7bbf79b162d05c$export$19c6138bf36917b8,
    Waypoints: ()=>$da7bbf79b162d05c$export$5227a1c4ed164917,
    degreeArc: ()=>(0, $2edc1eef02a7c199$export$2b1e3480567b14b8),
    degreeToRadian: ()=>(0, $2edc1eef02a7c199$export$4f2c4f194778dcbb),
    degreesSum: ()=>(0, $2edc1eef02a7c199$export$bf711920567cfd9),
    radianArc: ()=>(0, $2edc1eef02a7c199$export$cfbb66a3a90db1a8),
    radianInvert: ()=>(0, $2edc1eef02a7c199$export$57ad4b75fcab2ed3),
    radianToDegree: ()=>(0, $2edc1eef02a7c199$export$1c20e104e3e29a0a),
    radiansFromAxisX: ()=>(0, $2edc1eef02a7c199$export$425ef84e46bc63f9),
    radiansSum: ()=>(0, $2edc1eef02a7c199$export$781dc0a0f963c01e)
});
// src/geometry/Waypoint.ts
var $da7bbf79b162d05c$export$5227a1c4ed164917 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$5227a1c4ed164917, {
    fromPoints: ()=>$da7bbf79b162d05c$var$fromPoints2,
    init: ()=>$da7bbf79b162d05c$var$init
});
// src/geometry/line/JoinPointsToLines.ts
var $da7bbf79b162d05c$export$9e1b37f7e15343fa = (...points)=>{
    const lines = [];
    let start = points[0];
    for(let index = 1; index < points.length; index++){
        lines.push((0, $3beaef080eb52aa9$export$188c3cd07b4129dd)(start, points[index]));
        start = points[index];
    }
    return lines;
};
// src/geometry/line/Angles.ts
var $da7bbf79b162d05c$var$directionVector = (line)=>({
        x: line.b.x - line.a.x,
        y: line.b.y - line.a.y
    });
var $da7bbf79b162d05c$var$directionVectorNormalised = (line)=>{
    const l = (0, $2edc1eef02a7c199$export$f24224f1c91d8156)(line);
    const v = $da7bbf79b162d05c$var$directionVector(line);
    return {
        x: v.x / l,
        y: v.y / l
    };
};
var $da7bbf79b162d05c$var$parallel = (line, distance3)=>{
    const dv = $da7bbf79b162d05c$var$directionVector(line);
    const dvn = $da7bbf79b162d05c$var$directionVectorNormalised(line);
    const a = {
        x: line.a.x - dvn.y * distance3,
        y: line.a.y + dvn.x * distance3
    };
    return {
        a: a,
        b: {
            x: a.x + dv.x,
            y: a.y + dv.y
        }
    };
};
var $da7bbf79b162d05c$var$perpendicularPoint = (line, distance3, amount = 0)=>{
    const origin = (0, $2edc1eef02a7c199$export$89e29e4ab65e70a9)(amount, line);
    const dvn = $da7bbf79b162d05c$var$directionVectorNormalised(line);
    return {
        x: origin.x - dvn.y * distance3,
        y: origin.y + dvn.x * distance3
    };
};
// src/geometry/line/Midpoint.ts
var $da7bbf79b162d05c$var$midpoint = (aOrLine, pointB)=>{
    const [a, b] = (0, $2edc1eef02a7c199$export$ee879d4500fa8b5d)(aOrLine, pointB);
    return (0, $2edc1eef02a7c199$export$89e29e4ab65e70a9)(0.5, a, b);
};
// src/geometry/line/index.ts
var $da7bbf79b162d05c$export$ac0eb7b0d2fd21a = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$ac0eb7b0d2fd21a, {
    Empty: ()=>$da7bbf79b162d05c$export$1f74963c34e8bfec,
    Placeholder: ()=>$da7bbf79b162d05c$var$Placeholder,
    angleRadian: ()=>$da7bbf79b162d05c$var$angleRadian2,
    apply: ()=>$da7bbf79b162d05c$var$apply,
    asPoints: ()=>$da7bbf79b162d05c$var$asPoints,
    bbox: ()=>$da7bbf79b162d05c$var$bbox2,
    distance: ()=>$da7bbf79b162d05c$var$distance2,
    distanceSingleLine: ()=>$da7bbf79b162d05c$var$distanceSingleLine,
    divide: ()=>$da7bbf79b162d05c$var$divide2,
    extendFromA: ()=>$da7bbf79b162d05c$var$extendFromA,
    fromFlatArray: ()=>$da7bbf79b162d05c$var$fromFlatArray,
    fromNumbers: ()=>(0, $3beaef080eb52aa9$export$c2b110734982f150),
    fromPivot: ()=>$da7bbf79b162d05c$var$fromPivot,
    fromPoints: ()=>(0, $3beaef080eb52aa9$export$188c3cd07b4129dd),
    fromPointsToPath: ()=>$da7bbf79b162d05c$var$fromPointsToPath,
    getPointParameter: ()=>(0, $2edc1eef02a7c199$export$ee879d4500fa8b5d),
    guard: ()=>(0, $2edc1eef02a7c199$export$c1206aca6ae0febb),
    interpolate: ()=>(0, $2edc1eef02a7c199$export$89e29e4ab65e70a9),
    isEmpty: ()=>$da7bbf79b162d05c$var$isEmpty3,
    isEqual: ()=>$da7bbf79b162d05c$var$isEqual3,
    isLine: ()=>(0, $2edc1eef02a7c199$export$36082bc57fd6e7b6),
    isPlaceholder: ()=>$da7bbf79b162d05c$var$isPlaceholder3,
    isPolyLine: ()=>(0, $2edc1eef02a7c199$export$ed7bbaf3881693af),
    joinPointsToLines: ()=>$da7bbf79b162d05c$export$9e1b37f7e15343fa,
    length: ()=>(0, $2edc1eef02a7c199$export$f24224f1c91d8156),
    midpoint: ()=>$da7bbf79b162d05c$var$midpoint,
    multiply: ()=>$da7bbf79b162d05c$var$multiply2,
    nearest: ()=>$da7bbf79b162d05c$var$nearest,
    normaliseByRect: ()=>$da7bbf79b162d05c$var$normaliseByRect2,
    parallel: ()=>$da7bbf79b162d05c$var$parallel,
    perpendicularPoint: ()=>$da7bbf79b162d05c$var$perpendicularPoint,
    pointAtX: ()=>$da7bbf79b162d05c$var$pointAtX,
    pointsOf: ()=>$da7bbf79b162d05c$var$pointsOf,
    relativePosition: ()=>$da7bbf79b162d05c$var$relativePosition,
    rotate: ()=>$da7bbf79b162d05c$var$rotate2,
    scaleFromMidpoint: ()=>$da7bbf79b162d05c$var$scaleFromMidpoint,
    slope: ()=>$da7bbf79b162d05c$var$slope,
    subtract: ()=>$da7bbf79b162d05c$var$subtract2,
    sum: ()=>$da7bbf79b162d05c$var$sum2,
    toFlatArray: ()=>$da7bbf79b162d05c$var$toFlatArray,
    toPath: ()=>$da7bbf79b162d05c$var$toPath,
    toString: ()=>$da7bbf79b162d05c$var$toString3,
    toSvgString: ()=>$da7bbf79b162d05c$var$toSvgString,
    withinRange: ()=>$da7bbf79b162d05c$var$withinRange
});
// src/geometry/line/Nearest.ts
var $da7bbf79b162d05c$var$nearest = (line, point2)=>{
    const n = (line2)=>{
        const { a: a, b: b } = line2;
        const atob = {
            x: b.x - a.x,
            y: b.y - a.y
        };
        const atop = {
            x: point2.x - a.x,
            y: point2.y - a.y
        };
        const length4 = atob.x * atob.x + atob.y * atob.y;
        let dot = atop.x * atob.x + atop.y * atob.y;
        const t = Math.min(1, Math.max(0, dot / length4));
        dot = (b.x - a.x) * (point2.y - a.y) - (b.y - a.y) * (point2.x - a.x);
        return {
            x: a.x + atob.x * t,
            y: a.y + atob.y * t
        };
    };
    if (Array.isArray(line)) {
        const pts = line.map((l)=>n(l));
        const dists = pts.map((p)=>(0, $2edc1eef02a7c199$export$9f17032d917177de)(p, point2));
        return Object.freeze(pts[(0, $36aa4387660da012$export$e410eba367ce792b)(...dists)]);
    } else return Object.freeze(n(line));
};
// src/geometry/line/DistanceSingleLine.ts
var $da7bbf79b162d05c$var$distanceSingleLine = (line, point2)=>{
    (0, $2edc1eef02a7c199$export$c1206aca6ae0febb)(line, `line`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(point2, `point`);
    if ((0, $2edc1eef02a7c199$export$f24224f1c91d8156)(line) === 0) return (0, $2edc1eef02a7c199$export$f24224f1c91d8156)(line.a, point2);
    const near = $da7bbf79b162d05c$var$nearest(line, point2);
    return (0, $2edc1eef02a7c199$export$f24224f1c91d8156)(near, point2);
};
// src/geometry/line/Bbox.ts
var $da7bbf79b162d05c$var$bbox2 = (line)=>(0, $2edc1eef02a7c199$export$bf67010aacbe66fa)(line.a, line.b);
// src/geometry/line/Divide.ts
var $da7bbf79b162d05c$var$divide2 = (line, point2)=>Object.freeze({
        ...line,
        a: (0, $2edc1eef02a7c199$export$cd007d971a5a2143)(line.a, point2),
        b: (0, $2edc1eef02a7c199$export$cd007d971a5a2143)(line.b, point2)
    });
// src/geometry/line/FromFlatArray.ts
var $da7bbf79b162d05c$var$fromFlatArray = (array)=>{
    if (!Array.isArray(array)) throw new Error(`arr parameter is not an array`);
    if (array.length !== 4) throw new Error(`array is expected to have length four`);
    return (0, $3beaef080eb52aa9$export$c2b110734982f150)(array[0], array[1], array[2], array[3]);
};
// src/geometry/line/FromPivot.ts
var $da7bbf79b162d05c$var$fromPivot = (origin = {
    x: 0.5,
    y: 0.5
}, length4 = 1, angleRadian3 = 0, balance = 0.5)=>{
    const left = length4 * balance;
    const right = length4 * (1 - balance);
    const a = (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(left, (0, $2edc1eef02a7c199$export$57ad4b75fcab2ed3)(angleRadian3), origin);
    const b = (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(right, angleRadian3, origin);
    return Object.freeze({
        a: a,
        b: b
    });
};
// src/geometry/line/FromPointsToPath.ts
var $da7bbf79b162d05c$var$fromPointsToPath = (a, b)=>$da7bbf79b162d05c$var$toPath((0, $3beaef080eb52aa9$export$188c3cd07b4129dd)(a, b));
// src/geometry/line/IsEqual.ts
var $da7bbf79b162d05c$var$isEqual3 = (a, b)=>(0, $2edc1eef02a7c199$export$248d38f6296296c5)(a.a, b.a) && (0, $2edc1eef02a7c199$export$248d38f6296296c5)(a.b, b.b);
// src/geometry/line/Multiply.ts
var $da7bbf79b162d05c$var$multiply2 = (line, point2)=>Object.freeze({
        ...line,
        a: (0, $2edc1eef02a7c199$export$2060d2db72cce88f)(line.a, point2),
        b: (0, $2edc1eef02a7c199$export$2060d2db72cce88f)(line.b, point2)
    });
// src/geometry/line/RelativePosition.ts
var $da7bbf79b162d05c$var$relativePosition = (line, pt)=>{
    const fromStart = (0, $2edc1eef02a7c199$export$9f17032d917177de)(line.a, pt);
    const total = (0, $2edc1eef02a7c199$export$f24224f1c91d8156)(line);
    return fromStart / total;
};
// src/geometry/line/Rotate.ts
var $da7bbf79b162d05c$var$rotate2 = (line, amountRadian, origin)=>{
    if (amountRadian === void 0 || amountRadian === 0) return line;
    if (origin === void 0) origin = 0.5;
    if (typeof origin === `number`) origin = (0, $2edc1eef02a7c199$export$89e29e4ab65e70a9)(origin, line.a, line.b);
    return Object.freeze({
        ...line,
        a: (0, $2edc1eef02a7c199$export$bb628a54ab399bc9)(line.a, amountRadian, origin),
        b: (0, $2edc1eef02a7c199$export$bb628a54ab399bc9)(line.b, amountRadian, origin)
    });
};
// src/geometry/line/Subtract.ts
var $da7bbf79b162d05c$var$subtract2 = (line, point2)=>Object.freeze({
        ...line,
        a: (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(line.a, point2),
        b: (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(line.b, point2)
    });
// src/geometry/line/Sum.ts
var $da7bbf79b162d05c$var$sum2 = (line, point2)=>Object.freeze({
        ...line,
        a: (0, $2edc1eef02a7c199$export$97b149eb05063bd8)(line.a, point2),
        b: (0, $2edc1eef02a7c199$export$97b149eb05063bd8)(line.b, point2)
    });
// src/geometry/line/ToString.ts
function $da7bbf79b162d05c$var$toString3(a, b) {
    if ((0, $2edc1eef02a7c199$export$36082bc57fd6e7b6)(a)) {
        (0, $2edc1eef02a7c199$export$c1206aca6ae0febb)(a, `a`);
        b = a.b;
        a = a.a;
    } else if (b === void 0) throw new Error(`Expect second point if first is a point`);
    return (0, $2edc1eef02a7c199$export$eaaba333dd67ec2a)(a) + `-` + (0, $2edc1eef02a7c199$export$eaaba333dd67ec2a)(b);
}
// src/geometry/line/index.ts
var $da7bbf79b162d05c$export$1f74963c34e8bfec = Object.freeze({
    a: Object.freeze({
        x: 0,
        y: 0
    }),
    b: Object.freeze({
        x: 0,
        y: 0
    })
});
var $da7bbf79b162d05c$var$Placeholder = Object.freeze({
    a: Object.freeze({
        x: Number.NaN,
        y: Number.NaN
    }),
    b: Object.freeze({
        x: Number.NaN,
        y: Number.NaN
    })
});
var $da7bbf79b162d05c$var$isEmpty3 = (l)=>(0, $8a5cbeb1c6ae1b41$export$dd1bc94b04021eeb)(l.a) && (0, $8a5cbeb1c6ae1b41$export$dd1bc94b04021eeb)(l.b);
var $da7bbf79b162d05c$var$isPlaceholder3 = (l)=>(0, $8a5cbeb1c6ae1b41$export$2047bcc885291b3f)(l.a) && (0, $8a5cbeb1c6ae1b41$export$2047bcc885291b3f)(l.b);
var $da7bbf79b162d05c$var$apply = (line, fn)=>Object.freeze({
        ...line,
        a: fn(line.a),
        b: fn(line.b)
    });
var $da7bbf79b162d05c$var$angleRadian2 = (lineOrPoint, b)=>{
    let a;
    if ((0, $2edc1eef02a7c199$export$36082bc57fd6e7b6)(lineOrPoint)) {
        a = lineOrPoint.a;
        b = lineOrPoint.b;
    } else {
        a = lineOrPoint;
        if (b === void 0) throw new Error(`b point must be provided`);
    }
    return Math.atan2(b.y - a.y, b.x - a.x);
};
var $da7bbf79b162d05c$var$normaliseByRect2 = (line, width, height4)=>Object.freeze({
        ...line,
        a: (0, $2edc1eef02a7c199$export$6c3af93e8b0137fa)(line.a, width, height4),
        b: (0, $2edc1eef02a7c199$export$6c3af93e8b0137fa)(line.b, width, height4)
    });
var $da7bbf79b162d05c$var$withinRange = (line, point2, maxRange)=>{
    const calculatedDistance = $da7bbf79b162d05c$var$distance2(line, point2);
    return calculatedDistance <= maxRange;
};
var $da7bbf79b162d05c$var$slope = (lineOrPoint, b)=>{
    let a;
    if ((0, $2edc1eef02a7c199$export$36082bc57fd6e7b6)(lineOrPoint)) {
        a = lineOrPoint.a;
        b = lineOrPoint.b;
    } else {
        a = lineOrPoint;
        if (b === void 0) throw new Error(`b parameter required`);
    }
    if (b === void 0) throw new TypeError(`Second point missing`);
    else return (b.y - a.y) / (b.x - a.x);
};
var $da7bbf79b162d05c$var$scaleFromMidpoint = (line, factor)=>{
    const a = (0, $2edc1eef02a7c199$export$89e29e4ab65e70a9)(factor / 2, line);
    const b = (0, $2edc1eef02a7c199$export$89e29e4ab65e70a9)(0.5 + factor / 2, line);
    return {
        a: a,
        b: b
    };
};
var $da7bbf79b162d05c$var$pointAtX = (line, x)=>{
    const y = line.a.y + (x - line.a.x) * $da7bbf79b162d05c$var$slope(line);
    return Object.freeze({
        x: x,
        y: y
    });
};
var $da7bbf79b162d05c$var$extendFromA = (line, distance3)=>{
    const calculatedLength = (0, $2edc1eef02a7c199$export$f24224f1c91d8156)(line);
    return Object.freeze({
        ...line,
        a: line.a,
        b: Object.freeze({
            x: line.b.x + (line.b.x - line.a.x) / calculatedLength * distance3,
            y: line.b.y + (line.b.y - line.a.y) / calculatedLength * distance3
        })
    });
};
function* $da7bbf79b162d05c$var$pointsOf(line) {
    const { a: a, b: b } = line;
    let x0 = Math.floor(a.x);
    let y0 = Math.floor(a.y);
    const x1 = Math.floor(b.x);
    const y1 = Math.floor(b.y);
    const dx = Math.abs(x1 - x0);
    const dy = -Math.abs(y1 - y0);
    const sx = x0 < x1 ? 1 : -1;
    const sy = y0 < y1 ? 1 : -1;
    let err = dx + dy;
    while(true){
        yield {
            x: x0,
            y: y0
        };
        if (x0 === x1 && y0 === y1) break;
        const e2 = 2 * err;
        if (e2 >= dy) {
            err += dy;
            x0 += sx;
        }
        if (e2 <= dx) {
            err += dx;
            y0 += sy;
        }
    }
}
var $da7bbf79b162d05c$var$distance2 = (line, point2)=>{
    if (Array.isArray(line)) {
        const distances = line.map((l)=>$da7bbf79b162d05c$var$distanceSingleLine(l, point2));
        return (0, $36aa4387660da012$export$70f363b986c8e811)(distances);
    } else return $da7bbf79b162d05c$var$distanceSingleLine(line, point2);
};
var $da7bbf79b162d05c$var$toFlatArray = (a, b)=>{
    if ((0, $2edc1eef02a7c199$export$36082bc57fd6e7b6)(a)) return [
        a.a.x,
        a.a.y,
        a.b.x,
        a.b.y
    ];
    else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a) && (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b)) return [
        a.x,
        a.y,
        b.x,
        b.y
    ];
    else throw new Error(`Expected single line parameter, or a and b points`);
};
function* $da7bbf79b162d05c$var$asPoints(lines) {
    for (const l of lines){
        yield l.a;
        yield l.b;
    }
}
var $da7bbf79b162d05c$var$toSvgString = (a, b)=>[
        `M${a.x} ${a.y} L ${b.x} ${b.y}`
    ];
// src/geometry/line/ToPath.ts
var $da7bbf79b162d05c$var$toPath = (line)=>{
    const { a: a, b: b } = line;
    return Object.freeze({
        ...line,
        length: ()=>(0, $2edc1eef02a7c199$export$f24224f1c91d8156)(a, b),
        interpolate: (amount)=>(0, $2edc1eef02a7c199$export$89e29e4ab65e70a9)(amount, a, b),
        relativePosition: (point2)=>$da7bbf79b162d05c$var$relativePosition(line, point2),
        bbox: ()=>$da7bbf79b162d05c$var$bbox2(line),
        toString: ()=>$da7bbf79b162d05c$var$toString3(a, b),
        toFlatArray: ()=>$da7bbf79b162d05c$var$toFlatArray(a, b),
        toSvgString: ()=>$da7bbf79b162d05c$var$toSvgString(a, b),
        toPoints: ()=>[
                a,
                b
            ],
        rotate: (amountRadian, origin)=>$da7bbf79b162d05c$var$toPath($da7bbf79b162d05c$var$rotate2(line, amountRadian, origin)),
        nearest: (point2)=>$da7bbf79b162d05c$var$nearest(line, point2),
        sum: (point2)=>$da7bbf79b162d05c$var$toPath($da7bbf79b162d05c$var$sum2(line, point2)),
        divide: (point2)=>$da7bbf79b162d05c$var$toPath($da7bbf79b162d05c$var$divide2(line, point2)),
        multiply: (point2)=>$da7bbf79b162d05c$var$toPath($da7bbf79b162d05c$var$multiply2(line, point2)),
        subtract: (point2)=>$da7bbf79b162d05c$var$toPath($da7bbf79b162d05c$var$subtract2(line, point2)),
        midpoint: ()=>$da7bbf79b162d05c$var$midpoint(a, b),
        distanceToPoint: (point2)=>$da7bbf79b162d05c$var$distanceSingleLine(line, point2),
        parallel: (distance3)=>$da7bbf79b162d05c$var$parallel(line, distance3),
        perpendicularPoint: (distance3, amount)=>$da7bbf79b162d05c$var$perpendicularPoint(line, distance3, amount),
        slope: ()=>$da7bbf79b162d05c$var$slope(line),
        withinRange: (point2, maxRange)=>$da7bbf79b162d05c$var$withinRange(line, point2, maxRange),
        isEqual: (otherLine)=>$da7bbf79b162d05c$var$isEqual3(line, otherLine),
        apply: (fn)=>$da7bbf79b162d05c$var$toPath($da7bbf79b162d05c$var$apply(line, fn)),
        kind: `line`
    });
};
// src/geometry/Waypoint.ts
var $da7bbf79b162d05c$var$fromPoints2 = (waypoints, opts = {})=>{
    const lines = $da7bbf79b162d05c$export$9e1b37f7e15343fa(...waypoints);
    return $da7bbf79b162d05c$var$init(lines.map((l)=>$da7bbf79b162d05c$var$toPath(l)), opts);
};
var $da7bbf79b162d05c$var$init = (paths, opts = {})=>{
    const maxDistanceFromLine = opts.maxDistanceFromLine ?? 0.1;
    const checkUnordered = (pt)=>{
        const results = paths.map((p, index)=>{
            const nearest3 = p.nearest(pt);
            const distance3 = (0, $2edc1eef02a7c199$export$9f17032d917177de)(pt, nearest3);
            const positionRelative = p.relativePosition(nearest3, maxDistanceFromLine);
            return {
                positionRelative: positionRelative,
                path: p,
                index: index,
                nearest: nearest3,
                distance: distance3,
                rank: Number.MAX_SAFE_INTEGER
            };
        });
        const filtered = results.filter((v)=>v.distance <= maxDistanceFromLine);
        const sorted = (0, $b63753f448317b08$export$def566e6b50bc276)(filtered, `distance`);
        for(let rank = 0; rank < sorted.length; rank++)sorted[rank].rank = rank;
        return sorted;
    };
    return checkUnordered;
};
// src/geometry/Layout.ts
var $da7bbf79b162d05c$export$f3f3ecca1886fcb1 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$f3f3ecca1886fcb1, {
    CirclePacking: ()=>$da7bbf79b162d05c$var$CirclePacking_exports
});
// src/geometry/CirclePacking.ts
var $da7bbf79b162d05c$var$CirclePacking_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$CirclePacking_exports, {
    random: ()=>$da7bbf79b162d05c$var$random2
});
// src/geometry/shape/index.ts
var $da7bbf79b162d05c$export$634b7c338114ff6d = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$634b7c338114ff6d, {
    arrow: ()=>$da7bbf79b162d05c$var$arrow,
    center: ()=>$da7bbf79b162d05c$var$center3,
    isIntersecting: ()=>$da7bbf79b162d05c$var$isIntersecting3,
    randomPoint: ()=>$da7bbf79b162d05c$var$randomPoint3,
    starburst: ()=>$da7bbf79b162d05c$var$starburst
});
// src/geometry/rect/Corners.ts
var $da7bbf79b162d05c$export$389cfe57f7c9dd77 = (rect, origin)=>{
    const r = (0, $2edc1eef02a7c199$export$7d980350c5bbfbdd)(rect, origin);
    return [
        {
            x: r.x,
            y: r.y
        },
        {
            x: r.x + r.width,
            y: r.y
        },
        {
            x: r.x + r.width,
            y: r.y + r.height
        },
        {
            x: r.x,
            y: r.y + r.height
        }
    ];
};
// src/geometry/circle/IsContainedBy.ts
var $da7bbf79b162d05c$var$isContainedBy = (a, b, c)=>{
    const d = (0, $2edc1eef02a7c199$export$42bba38af02b837f)(a, b);
    if ((0, $2edc1eef02a7c199$export$777046f736854c19)(b)) return d < Math.abs(a.radius - b.radius);
    else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b)) {
        if (c === void 0) return d <= a.radius;
        else return d < Math.abs(a.radius - c);
    } else throw new Error(`b parameter is expected to be CirclePositioned or Point`);
};
// src/geometry/circle/Intersecting.ts
var $da7bbf79b162d05c$var$isIntersecting2 = (a, b, c)=>{
    if ((0, $2edc1eef02a7c199$export$248d38f6296296c5)(a, b)) return true;
    if ($da7bbf79b162d05c$var$isContainedBy(a, b, c)) return true;
    if ((0, $2edc1eef02a7c199$export$777046f736854c19)(b)) return (0, $2edc1eef02a7c199$export$b85ee8633cdf5ab6)(a, b);
    else if ((0, $2edc1eef02a7c199$export$5dc6ff369cea976c)(b)) return (0, $2edc1eef02a7c199$export$e629676a0f9e1c8c)(a, b);
    else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b) && c !== void 0) return (0, $2edc1eef02a7c199$export$b85ee8633cdf5ab6)(a, {
        ...b,
        radius: c
    });
    return false;
};
// src/geometry/circle/Random.ts
var $da7bbf79b162d05c$var$piPi = Math.PI * 2;
var $da7bbf79b162d05c$var$randomPoint = (within, opts = {})=>{
    const offset2 = (0, $2edc1eef02a7c199$export$e5d02b282a20f571)(within) ? within : {
        x: 0,
        y: 0
    };
    const strategy = opts.strategy ?? `uniform`;
    const margin = opts.margin ?? 0;
    const radius = within.radius - margin;
    const rand = opts.randomSource ?? Math.random;
    switch(strategy){
        case `naive`:
            return (0, $2edc1eef02a7c199$export$97b149eb05063bd8)(offset2, (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(rand() * radius, rand() * $da7bbf79b162d05c$var$piPi));
        case `uniform`:
            return (0, $2edc1eef02a7c199$export$97b149eb05063bd8)(offset2, (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(Math.sqrt(rand()) * radius, rand() * $da7bbf79b162d05c$var$piPi));
        default:
            throw new Error(`Unknown strategy '${strategy}'. Expects 'uniform' or 'naive'`);
    }
};
// src/geometry/circle/Center.ts
var $da7bbf79b162d05c$var$center2 = (circle)=>{
    return (0, $2edc1eef02a7c199$export$e5d02b282a20f571)(circle) ? Object.freeze({
        x: circle.x,
        y: circle.y
    }) : Object.freeze({
        x: circle.radius,
        y: circle.radius
    });
};
// src/geometry/rect/Random.ts
var $da7bbf79b162d05c$var$random = (rando)=>{
    if (rando === void 0) rando = (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    return Object.freeze({
        x: rando(),
        y: rando(),
        width: rando(),
        height: rando()
    });
};
var $da7bbf79b162d05c$var$randomPoint2 = (within, options = {})=>{
    const rand = options.randomSource ?? (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    const margin = options.margin ?? {
        x: 0,
        y: 0
    };
    const x = rand() * (within.width - margin.x - margin.x);
    const y = rand() * (within.height - margin.y - margin.y);
    const pos = {
        x: x + margin.x,
        y: y + margin.y
    };
    return (0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(within) ? (0, $2edc1eef02a7c199$export$97b149eb05063bd8)(pos, within) : Object.freeze(pos);
};
// src/geometry/shape/index.ts
var $da7bbf79b162d05c$var$isIntersecting3 = (a, b)=>{
    if ((0, $2edc1eef02a7c199$export$e5d02b282a20f571)(a)) return $da7bbf79b162d05c$var$isIntersecting2(a, b);
    else if ((0, $2edc1eef02a7c199$export$5dc6ff369cea976c)(a)) return (0, $2edc1eef02a7c199$export$8d3dd0be5eb9f11f)(a, b);
    throw new Error(`a or b are unknown shapes. a: ${JSON.stringify(a)} b: ${JSON.stringify(b)}`);
};
var $da7bbf79b162d05c$var$randomPoint3 = (shape, opts = {})=>{
    if ((0, $2edc1eef02a7c199$export$e5d02b282a20f571)(shape)) return $da7bbf79b162d05c$var$randomPoint(shape, opts);
    else if ((0, $2edc1eef02a7c199$export$5dc6ff369cea976c)(shape)) return $da7bbf79b162d05c$var$randomPoint2(shape, opts);
    throw new Error(`Unknown shape. Only CirclePositioned and RectPositioned are supported.`);
};
var $da7bbf79b162d05c$var$center3 = (shape)=>{
    if (shape === void 0) return Object.freeze({
        x: 0.5,
        y: 0.5
    });
    else if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(shape)) return (0, $2edc1eef02a7c199$export$3481c78889e8fbe8)(shape);
    else if ($da7bbf79b162d05c$export$295ac55e84320fb3.isTriangle(shape)) return $da7bbf79b162d05c$export$295ac55e84320fb3.centroid(shape);
    else if ((0, $2edc1eef02a7c199$export$777046f736854c19)(shape)) return $da7bbf79b162d05c$var$center2(shape);
    else throw new Error(`Unknown shape: ${JSON.stringify(shape)}`);
};
var $da7bbf79b162d05c$var$starburst = (outerRadius, points = 5, innerRadius, origin = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, opts)=>{
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(points, `positive`, `points`);
    const angle = Math.PI * 2 / points;
    const angleHalf = angle / 2;
    const initialAngle = opts?.initialAngleRadian ?? -Math.PI / 2;
    if (innerRadius === void 0) innerRadius = outerRadius / 2;
    let a = initialAngle;
    const pts = [];
    for(let index = 0; index < points; index++){
        const peak = (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(outerRadius, a, origin);
        const left = (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(innerRadius, a - angleHalf, origin);
        const right = (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(innerRadius, a + angleHalf, origin);
        pts.push(left, peak);
        if (index + 1 < points) pts.push(right);
        a += angle;
    }
    return pts;
};
var $da7bbf79b162d05c$var$arrow = (origin, from, opts = {})=>{
    const tailLength = opts.tailLength ?? 10;
    const tailThickness = opts.tailThickness ?? Math.max(tailLength / 5, 5);
    const angleRadian3 = opts.angleRadian ?? 0;
    const arrowSize = opts.arrowSize ?? Math.max(tailLength / 5, 15);
    const triAngle = Math.PI / 2;
    let tri;
    let tailPoints;
    if (from === `tip`) {
        tri = $da7bbf79b162d05c$export$295ac55e84320fb3.equilateralFromVertex(origin, arrowSize, triAngle);
        tailPoints = $da7bbf79b162d05c$export$389cfe57f7c9dd77((0, $2edc1eef02a7c199$export$ebf8d3595f30628)({
            x: tri.a.x - tailLength,
            y: origin.y - tailThickness / 2
        }, tailLength, tailThickness));
    } else if (from === `middle`) {
        const midX = tailLength + arrowSize / 2;
        const midY = tailThickness / 2;
        tri = $da7bbf79b162d05c$export$295ac55e84320fb3.equilateralFromVertex({
            x: origin.x + arrowSize * 1.2,
            y: origin.y
        }, arrowSize, triAngle);
        tailPoints = $da7bbf79b162d05c$export$389cfe57f7c9dd77((0, $2edc1eef02a7c199$export$ebf8d3595f30628)({
            x: origin.x - midX,
            y: origin.y - midY
        }, tailLength + arrowSize, tailThickness));
    } else {
        tailPoints = $da7bbf79b162d05c$export$389cfe57f7c9dd77((0, $2edc1eef02a7c199$export$ebf8d3595f30628)({
            x: origin.x,
            y: origin.y - tailThickness / 2
        }, tailLength, tailThickness));
        tri = $da7bbf79b162d05c$export$295ac55e84320fb3.equilateralFromVertex({
            x: origin.x + tailLength + arrowSize * 0.7,
            y: origin.y
        }, arrowSize, triAngle);
    }
    const arrow2 = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).rotate([
        tailPoints[0],
        tailPoints[1],
        tri.a,
        tri.b,
        tri.c,
        tailPoints[2],
        tailPoints[3]
    ], angleRadian3, origin);
    return arrow2;
};
// src/geometry/CirclePacking.ts
var $da7bbf79b162d05c$var$random2 = (circles, container, opts = {})=>{
    if (!Array.isArray(circles)) throw new Error(`Parameter 'circles' is not an array`);
    const attempts = opts.attempts ?? 2e3;
    const sorted = (0, $b63753f448317b08$export$def566e6b50bc276)(circles, `radius`);
    const positionedCircles = [];
    const willHit = (b, radius)=>positionedCircles.some((v)=>$da7bbf79b162d05c$var$isIntersecting2(v, b, radius));
    while(sorted.length > 0){
        const circle = sorted.pop();
        if (!circle) break;
        const randomPointOpts = {
            ...opts,
            margin: {
                x: circle.radius,
                y: circle.radius
            }
        };
        for(let index = 0; index < attempts; index++){
            const position = $da7bbf79b162d05c$var$randomPoint3(container, randomPointOpts);
            if (!willHit(position, circle.radius)) {
                positionedCircles.push(Object.freeze({
                    ...circle,
                    ...position
                }));
                break;
            }
        }
    }
    return positionedCircles;
};
// src/geometry/circle/index.ts
var $da7bbf79b162d05c$export$15beefeae76985d5 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$15beefeae76985d5, {
    area: ()=>$da7bbf79b162d05c$var$area,
    bbox: ()=>$da7bbf79b162d05c$var$bbox3,
    center: ()=>$da7bbf79b162d05c$var$center2,
    circumference: ()=>$da7bbf79b162d05c$var$circumference,
    distanceCenter: ()=>(0, $2edc1eef02a7c199$export$42bba38af02b837f),
    distanceFromExterior: ()=>(0, $2edc1eef02a7c199$export$73f895ad8864ed4c),
    exteriorIntegerPoints: ()=>$da7bbf79b162d05c$var$exteriorIntegerPoints,
    guard: ()=>(0, $2edc1eef02a7c199$export$864d727b48066337),
    guardPositioned: ()=>(0, $2edc1eef02a7c199$export$8592c2ea033f4712),
    interiorIntegerPoints: ()=>$da7bbf79b162d05c$var$interiorIntegerPoints,
    interpolate: ()=>$da7bbf79b162d05c$var$interpolate2,
    intersectionLine: ()=>(0, $2edc1eef02a7c199$export$27d113dcd5f4d891),
    intersections: ()=>(0, $2edc1eef02a7c199$export$1eab5cf80b02390a),
    isCircle: ()=>(0, $2edc1eef02a7c199$export$777046f736854c19),
    isCirclePositioned: ()=>(0, $2edc1eef02a7c199$export$e5d02b282a20f571),
    isContainedBy: ()=>$da7bbf79b162d05c$var$isContainedBy,
    isEqual: ()=>(0, $2edc1eef02a7c199$export$cc13405da3dca563),
    isIntersecting: ()=>$da7bbf79b162d05c$var$isIntersecting2,
    isNaN: ()=>(0, $2edc1eef02a7c199$export$c9f5652083b8129d),
    isPositioned: ()=>(0, $2edc1eef02a7c199$export$6c86b85491191ecd),
    length: ()=>$da7bbf79b162d05c$var$length2,
    multiplyScalar: ()=>$da7bbf79b162d05c$var$multiplyScalar2,
    nearest: ()=>$da7bbf79b162d05c$var$nearest2,
    pointOnPerimeter: ()=>$da7bbf79b162d05c$var$pointOnPerimeter,
    randomPoint: ()=>$da7bbf79b162d05c$var$randomPoint,
    toPath: ()=>$da7bbf79b162d05c$var$toPath2,
    toPositioned: ()=>$da7bbf79b162d05c$var$toPositioned,
    toSvg: ()=>$da7bbf79b162d05c$var$toSvg
});
// src/geometry/circle/Area.ts
var $da7bbf79b162d05c$var$area = (circle)=>{
    (0, $2edc1eef02a7c199$export$864d727b48066337)(circle);
    return Math.PI * circle.radius * circle.radius;
};
// src/geometry/rect/FromCenter.ts
var $da7bbf79b162d05c$var$fromCenter = (origin, width, height4)=>{
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(origin, `origin`);
    (0, $2edc1eef02a7c199$export$5caca1faed27694e)(width, `width`);
    (0, $2edc1eef02a7c199$export$5caca1faed27694e)(height4, `height`);
    const halfW = width / 2;
    const halfH = height4 / 2;
    return {
        x: origin.x - halfW,
        y: origin.y - halfH,
        width: width,
        height: height4
    };
};
// src/geometry/circle/Bbox.ts
var $da7bbf79b162d05c$var$bbox3 = (circle)=>{
    return (0, $2edc1eef02a7c199$export$e5d02b282a20f571)(circle) ? $da7bbf79b162d05c$var$fromCenter(circle, circle.radius * 2, circle.radius * 2) : {
        width: circle.radius * 2,
        height: circle.radius * 2,
        x: 0,
        y: 0
    };
};
// src/geometry/circle/ExteriorPoints.ts
function* $da7bbf79b162d05c$var$exteriorIntegerPoints(circle) {
    const { x: x, y: y, radius: radius } = circle;
    let xx = radius;
    let yy = 0;
    let radiusError = 1 - x;
    while(xx >= yy){
        yield {
            x: xx + x,
            y: yy + y
        };
        yield {
            x: yy + x,
            y: xx + y
        };
        yield {
            x: -xx + x,
            y: yy + y
        };
        yield {
            x: -yy + x,
            y: xx + y
        };
        yield {
            x: -xx + x,
            y: -yy + y
        };
        yield {
            x: -yy + x,
            y: -xx + y
        };
        yield {
            x: xx + x,
            y: -yy + y
        };
        yield {
            x: yy + x,
            y: -xx + y
        };
        yy++;
        if (radiusError < 0) radiusError += 2 * yy + 1;
        else {
            xx--;
            radiusError += 2 * (yy - xx + 1);
        }
    }
}
// src/geometry/circle/InteriorPoints.ts
function* $da7bbf79b162d05c$var$interiorIntegerPoints(circle) {
    const xMin = circle.x - circle.radius;
    const xMax = circle.x + circle.radius;
    const yMin = circle.y - circle.radius;
    const yMax = circle.y + circle.radius;
    for(let x = xMin; x < xMax; x++)for(let y = yMin; y < yMax; y++){
        const r = Math.abs((0, $2edc1eef02a7c199$export$9f17032d917177de)(circle, x, y));
        if (r <= circle.radius) yield {
            x: x,
            y: y
        };
    }
}
// src/geometry/circle/Perimeter.ts
var $da7bbf79b162d05c$var$piPi2 = Math.PI * 2;
var $da7bbf79b162d05c$var$nearest2 = (circle, point2)=>{
    const n = (a)=>{
        const l = Math.sqrt(Math.pow(point2.x - a.x, 2) + Math.pow(point2.y - a.y, 2));
        const x = a.x + a.radius * ((point2.x - a.x) / l);
        const y = a.y + a.radius * ((point2.y - a.y) / l);
        return {
            x: x,
            y: y
        };
    };
    if (Array.isArray(circle)) {
        const pts = circle.map((l)=>n(l));
        const dists = pts.map((p)=>(0, $2edc1eef02a7c199$export$9f17032d917177de)(p, point2));
        return Object.freeze(pts[(0, $36aa4387660da012$export$e410eba367ce792b)(...dists)]);
    } else return Object.freeze(n(circle));
};
var $da7bbf79b162d05c$var$pointOnPerimeter = (circle, angleRadian3, origin)=>{
    if (origin === void 0) origin = (0, $2edc1eef02a7c199$export$e5d02b282a20f571)(circle) ? circle : {
        x: 0,
        y: 0
    };
    return {
        x: Math.cos(-angleRadian3) * circle.radius + origin.x,
        y: Math.sin(-angleRadian3) * circle.radius + origin.y
    };
};
var $da7bbf79b162d05c$var$circumference = (circle)=>{
    (0, $2edc1eef02a7c199$export$864d727b48066337)(circle);
    return $da7bbf79b162d05c$var$piPi2 * circle.radius;
};
var $da7bbf79b162d05c$var$length2 = (circle)=>$da7bbf79b162d05c$var$circumference(circle);
// src/geometry/circle/Interpolate.ts
var $da7bbf79b162d05c$var$piPi3 = Math.PI * 2;
var $da7bbf79b162d05c$var$interpolate2 = (circle, t)=>$da7bbf79b162d05c$var$pointOnPerimeter(circle, t * $da7bbf79b162d05c$var$piPi3);
// src/geometry/circle/Multiply.ts
function $da7bbf79b162d05c$var$multiplyScalar2(a, value) {
    if ((0, $2edc1eef02a7c199$export$e5d02b282a20f571)(a)) {
        const pt = (0, $2edc1eef02a7c199$export$c697bed75648cdb7)(a, value);
        return Object.freeze({
            ...a,
            ...pt,
            radius: a.radius * value
        });
    } else return Object.freeze({
        ...a,
        radius: a.radius * value
    });
}
// src/geometry/circle/Svg.ts
var $da7bbf79b162d05c$var$toSvg = (a, sweep, origin)=>{
    if ((0, $2edc1eef02a7c199$export$777046f736854c19)(a)) {
        if (origin !== void 0) return $da7bbf79b162d05c$var$toSvgFull(a.radius, origin, sweep);
        if ((0, $2edc1eef02a7c199$export$e5d02b282a20f571)(a)) return $da7bbf79b162d05c$var$toSvgFull(a.radius, a, sweep);
        else throw new Error(`origin parameter needed for non-positioned circle`);
    } else {
        if (origin === void 0) throw new Error(`origin parameter needed`);
        else return $da7bbf79b162d05c$var$toSvgFull(a, origin, sweep);
    }
};
var $da7bbf79b162d05c$var$toSvgFull = (radius, origin, sweep)=>{
    const { x: x, y: y } = origin;
    const s = sweep ? `1` : `0`;
    return `
    M ${x}, ${y}
    m -${radius}, 0
    a ${radius},${radius} 0 1,${s} ${radius * 2},0
    a ${radius},${radius} 0 1,${s} -${radius * 2},0
  `.split(`
`);
};
// src/geometry/circle/ToPath.ts
var $da7bbf79b162d05c$var$toPath2 = (circle)=>{
    (0, $2edc1eef02a7c199$export$864d727b48066337)(circle);
    return {
        ...circle,
        nearest: (point2)=>$da7bbf79b162d05c$var$nearest2(circle, point2),
        /**
     * Returns a relative (0.0-1.0) point on a circle. 0=3 o'clock, 0.25=6 o'clock, 0.5=9 o'clock, 0.75=12 o'clock etc.
     * @param {t} Relative (0.0-1.0) point
     * @returns {Point} X,y
     */ interpolate: (t)=>$da7bbf79b162d05c$var$interpolate2(circle, t),
        bbox: ()=>$da7bbf79b162d05c$var$bbox3(circle),
        length: ()=>$da7bbf79b162d05c$var$circumference(circle),
        toSvgString: (sweep = true)=>$da7bbf79b162d05c$var$toSvg(circle, sweep),
        relativePosition: (_point, _intersectionThreshold)=>{
            throw new Error(`Not implemented`);
        },
        distanceToPoint: (_point)=>{
            throw new Error(`Not implemented`);
        },
        kind: `circular`
    };
};
// src/geometry/circle/ToPositioned.ts
var $da7bbf79b162d05c$var$toPositioned = (circle, defaultPositionOrX, y)=>{
    if ((0, $2edc1eef02a7c199$export$e5d02b282a20f571)(circle)) return circle;
    const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(defaultPositionOrX, y);
    return Object.freeze({
        ...circle,
        ...pt
    });
};
// src/geometry/rect/index.ts
var $da7bbf79b162d05c$export$40726222f7ec099b = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$40726222f7ec099b, {
    Empty: ()=>$da7bbf79b162d05c$export$2744bceee07c71e5,
    EmptyPositioned: ()=>$da7bbf79b162d05c$export$54af435d56f017ce,
    Placeholder: ()=>$da7bbf79b162d05c$export$84712d0562a614b8,
    PlaceholderPositioned: ()=>$da7bbf79b162d05c$export$87dcead6234101be,
    applyDim: ()=>$da7bbf79b162d05c$var$applyDim,
    applyFields: ()=>$da7bbf79b162d05c$var$applyFields,
    applyMerge: ()=>$da7bbf79b162d05c$var$applyMerge,
    applyScalar: ()=>$da7bbf79b162d05c$var$applyScalar,
    area: ()=>$da7bbf79b162d05c$var$area2,
    cardinal: ()=>$da7bbf79b162d05c$export$5f042bbf49ec661b,
    center: ()=>(0, $2edc1eef02a7c199$export$3481c78889e8fbe8),
    corners: ()=>$da7bbf79b162d05c$export$389cfe57f7c9dd77,
    distanceFromCenter: ()=>(0, $2edc1eef02a7c199$export$1ba1d731b131b9aa),
    distanceFromExterior: ()=>(0, $2edc1eef02a7c199$export$1d7fc3f9c9c3404e),
    divide: ()=>$da7bbf79b162d05c$var$divide3,
    divideDim: ()=>$da7bbf79b162d05c$var$divideDim,
    divideScalar: ()=>$da7bbf79b162d05c$var$divideScalar,
    dividerByLargestDimension: ()=>$da7bbf79b162d05c$var$dividerByLargestDimension,
    edges: ()=>$da7bbf79b162d05c$var$edges,
    encompass: ()=>$da7bbf79b162d05c$var$encompass,
    fromCenter: ()=>$da7bbf79b162d05c$var$fromCenter,
    fromElement: ()=>$da7bbf79b162d05c$var$fromElement,
    fromNumbers: ()=>$da7bbf79b162d05c$var$fromNumbers3,
    fromTopLeft: ()=>(0, $2edc1eef02a7c199$export$ebf8d3595f30628),
    getEdgeX: ()=>$da7bbf79b162d05c$export$f8b1c50419d0fa91,
    getEdgeY: ()=>$da7bbf79b162d05c$export$7f8a29eecdd471e1,
    getRectPositioned: ()=>(0, $2edc1eef02a7c199$export$7d980350c5bbfbdd),
    getRectPositionedParameter: ()=>$da7bbf79b162d05c$var$getRectPositionedParameter,
    guard: ()=>(0, $2edc1eef02a7c199$export$290a3749c7970426),
    guardDim: ()=>(0, $2edc1eef02a7c199$export$5caca1faed27694e),
    guardPositioned: ()=>(0, $2edc1eef02a7c199$export$cafbc58a575a627c),
    intersectsPoint: ()=>(0, $2edc1eef02a7c199$export$5723c514448bc2af),
    isEmpty: ()=>(0, $2edc1eef02a7c199$export$dd1bc94b04021eeb),
    isEqual: ()=>$da7bbf79b162d05c$var$isEqual4,
    isEqualSize: ()=>$da7bbf79b162d05c$export$35093e90dece5c82,
    isIntersecting: ()=>(0, $2edc1eef02a7c199$export$8d3dd0be5eb9f11f),
    isPlaceholder: ()=>(0, $2edc1eef02a7c199$export$2047bcc885291b3f),
    isPositioned: ()=>(0, $2edc1eef02a7c199$export$db5736f7047b4d1f),
    isRect: ()=>(0, $2edc1eef02a7c199$export$707a34ba392ff427),
    isRectPositioned: ()=>(0, $2edc1eef02a7c199$export$5dc6ff369cea976c),
    lengths: ()=>$da7bbf79b162d05c$var$lengths,
    maxFromCorners: ()=>(0, $2edc1eef02a7c199$export$f17e239f3c38bb6),
    multiply: ()=>$da7bbf79b162d05c$var$multiply3,
    multiplyDim: ()=>$da7bbf79b162d05c$var$multiplyDim,
    multiplyScalar: ()=>$da7bbf79b162d05c$export$c697bed75648cdb7,
    nearestInternal: ()=>$da7bbf79b162d05c$var$nearestInternal,
    random: ()=>$da7bbf79b162d05c$var$random,
    randomPoint: ()=>$da7bbf79b162d05c$var$randomPoint2,
    subtract: ()=>$da7bbf79b162d05c$var$subtract3,
    subtractOffset: ()=>$da7bbf79b162d05c$var$subtractOffset,
    subtractSize: ()=>$da7bbf79b162d05c$var$subtractSize,
    sum: ()=>$da7bbf79b162d05c$var$sum3,
    sumOffset: ()=>$da7bbf79b162d05c$var$sumOffset,
    toArray: ()=>$da7bbf79b162d05c$var$toArray
});
// src/geometry/rect/Area.ts
var $da7bbf79b162d05c$var$area2 = (rect)=>{
    (0, $2edc1eef02a7c199$export$290a3749c7970426)(rect);
    return rect.height * rect.width;
};
// src/geometry/rect/Apply.ts
function $da7bbf79b162d05c$var$applyFields(op, rectOrWidth, heightValue) {
    let width = typeof rectOrWidth === `number` ? rectOrWidth : rectOrWidth.width;
    let height4 = typeof rectOrWidth === `number` ? heightValue : rectOrWidth.height;
    if (width === void 0) throw new Error(`Param 'width' undefined`);
    if (height4 === void 0) throw new Error(`Param 'height' undefined`);
    width = op(width, `width`);
    height4 = op(height4, `height`);
    if (typeof rectOrWidth === `object`) {
        if ((0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(rectOrWidth)) {
            const x = op(rectOrWidth.x, `x`);
            const y = op(rectOrWidth.y, `y`);
            return {
                ...rectOrWidth,
                width: width,
                height: height4,
                x: x,
                y: y
            };
        } else return {
            ...rectOrWidth,
            width: width,
            height: height4
        };
    }
    return {
        width: width,
        height: height4
    };
}
function $da7bbf79b162d05c$var$applyMerge(op, a, b, c) {
    (0, $2edc1eef02a7c199$export$290a3749c7970426)(a, `a`);
    if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(b)) return (0, $2edc1eef02a7c199$export$5dc6ff369cea976c)(a) ? Object.freeze({
        ...a,
        x: op(a.x, b.width),
        y: op(a.y, b.height),
        width: op(a.width, b.width),
        height: op(a.height, b.height)
    }) : Object.freeze({
        ...a,
        width: op(a.width, b.width),
        height: op(a.height, b.height)
    });
    else {
        if (typeof b !== `number`) throw new TypeError(`Expected second parameter of type Rect or number. Got ${JSON.stringify(b)}`);
        if (typeof c !== `number`) throw new Error(`Expected third param as height. Got ${JSON.stringify(c)}`);
        return (0, $2edc1eef02a7c199$export$5dc6ff369cea976c)(a) ? Object.freeze({
            ...a,
            x: op(a.x, b),
            y: op(a.y, c),
            width: op(a.width, b),
            height: op(a.height, c)
        }) : Object.freeze({
            ...a,
            width: op(a.width, b),
            height: op(a.height, c)
        });
    }
}
function $da7bbf79b162d05c$var$applyScalar(op, rect, parameter) {
    return (0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(rect) ? Object.freeze({
        ...rect,
        x: op(rect.x, parameter),
        y: op(rect.y, parameter),
        width: op(rect.width, parameter),
        height: op(rect.height, parameter)
    }) : Object.freeze({
        ...rect,
        width: op(rect.width, parameter),
        height: op(rect.height, parameter)
    });
}
function $da7bbf79b162d05c$var$applyDim(op, rect, parameter) {
    return Object.freeze({
        ...rect,
        width: op(rect.width, parameter),
        height: op(rect.height, parameter)
    });
}
// src/geometry/rect/Cardinal.ts
var $da7bbf79b162d05c$export$5f042bbf49ec661b = (rect, card)=>{
    const { x: x, y: y, width: width, height: height4 } = rect;
    switch(card){
        case `nw`:
            return Object.freeze({
                x: x,
                y: y
            });
        case `n`:
            return Object.freeze({
                x: x + width / 2,
                y: y
            });
        case `ne`:
            return Object.freeze({
                x: x + width,
                y: y
            });
        case `sw`:
            return Object.freeze({
                x: x,
                y: y + height4
            });
        case `s`:
            return Object.freeze({
                x: x + width / 2,
                y: y + height4
            });
        case `se`:
            return Object.freeze({
                x: x + width,
                y: y + height4
            });
        case `w`:
            return Object.freeze({
                x: x,
                y: y + height4 / 2
            });
        case `e`:
            return Object.freeze({
                x: x + width,
                y: y + height4 / 2
            });
        case `center`:
            return Object.freeze({
                x: x + width / 2,
                y: y + height4 / 2
            });
        default:
            throw new Error(`Unknown direction: ${card}`);
    }
};
// src/geometry/rect/Divide.ts
var $da7bbf79b162d05c$var$divideOp = (a, b)=>a / b;
function $da7bbf79b162d05c$var$divide3(a, b, c) {
    return $da7bbf79b162d05c$var$applyMerge($da7bbf79b162d05c$var$divideOp, a, b, c);
}
function $da7bbf79b162d05c$var$divideScalar(rect, amount) {
    return $da7bbf79b162d05c$var$applyScalar($da7bbf79b162d05c$var$divideOp, rect, amount);
}
function $da7bbf79b162d05c$var$divideDim(rect, amount) {
    return $da7bbf79b162d05c$var$applyDim($da7bbf79b162d05c$var$divideOp, rect, amount);
}
// src/geometry/rect/Edges.ts
var $da7bbf79b162d05c$var$edges = (rect, origin)=>{
    const c = $da7bbf79b162d05c$export$389cfe57f7c9dd77(rect, origin);
    return $da7bbf79b162d05c$export$9e1b37f7e15343fa(...c, c[0]);
};
var $da7bbf79b162d05c$export$f8b1c50419d0fa91 = (rect, edge)=>{
    (0, $2edc1eef02a7c199$export$290a3749c7970426)(rect);
    switch(edge){
        case `top`:
            return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect) ? rect.x : 0;
        case `bottom`:
            return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect) ? rect.x : 0;
        case `left`:
            return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect) ? rect.y : 0;
        case `right`:
            return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect) ? rect.x + rect.width : rect.width;
    }
};
var $da7bbf79b162d05c$export$7f8a29eecdd471e1 = (rect, edge)=>{
    (0, $2edc1eef02a7c199$export$290a3749c7970426)(rect);
    switch(edge){
        case `top`:
            return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect) ? rect.y : 0;
        case `bottom`:
            return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect) ? rect.y + rect.height : rect.height;
        case `left`:
            return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect) ? rect.y : 0;
        case `right`:
            return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(rect) ? rect.y : 0;
    }
};
// src/geometry/rect/Empty.ts
var $da7bbf79b162d05c$export$2744bceee07c71e5 = Object.freeze({
    width: 0,
    height: 0
});
var $da7bbf79b162d05c$export$54af435d56f017ce = Object.freeze({
    x: 0,
    y: 0,
    width: 0,
    height: 0
});
// src/geometry/rect/Encompass.ts
var $da7bbf79b162d05c$var$encompass = (rect, ...points)=>{
    const x = points.map((p)=>p.x);
    const y = points.map((p)=>p.y);
    let minX = Math.min(...x, rect.x);
    let minY = Math.min(...y, rect.y);
    let maxX = Math.max(...x, rect.x + rect.width);
    let maxY = Math.max(...y, rect.y + rect.height);
    let rectW = Math.max(rect.width, maxX - minX);
    let rectH = Math.max(rect.height, maxY - minY);
    return Object.freeze({
        ...rect,
        x: minX,
        y: minY,
        width: rectW,
        height: rectH
    });
};
// src/geometry/rect/FromElement.ts
var $da7bbf79b162d05c$var$fromElement = (el)=>({
        width: el.clientWidth,
        height: el.clientHeight
    });
// src/geometry/rect/FromNumbers.ts
function $da7bbf79b162d05c$var$fromNumbers3(xOrWidth, yOrHeight, width, height4) {
    if (width === void 0 || height4 === void 0) {
        if (typeof xOrWidth !== `number`) throw new Error(`width is not an number`);
        if (typeof yOrHeight !== `number`) throw new TypeError(`height is not an number`);
        return Object.freeze({
            width: xOrWidth,
            height: yOrHeight
        });
    }
    if (typeof xOrWidth !== `number`) throw new Error(`x is not an number`);
    if (typeof yOrHeight !== `number`) throw new Error(`y is not an number`);
    if (typeof width !== `number`) throw new Error(`width is not an number`);
    if (typeof height4 !== `number`) throw new Error(`height is not an number`);
    return Object.freeze({
        x: xOrWidth,
        y: yOrHeight,
        width: width,
        height: height4
    });
}
// src/geometry/rect/GetRectPositionedParameter.ts
function $da7bbf79b162d05c$var$getRectPositionedParameter(a, b, c, d) {
    if (typeof a === `number`) {
        if (typeof b === `number`) {
            if (typeof c === `number` && typeof d === `number`) return {
                x: a,
                y: b,
                width: c,
                height: d
            };
            else if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(c)) return {
                x: a,
                y: b,
                width: c.width,
                height: c.height
            };
            else throw new TypeError(`If params 'a' & 'b' are numbers, expect following parameters to be x,y or Rect`);
        } else throw new TypeError(`If parameter 'a' is a number, expect following parameters to be: y,w,h`);
    } else if ((0, $2edc1eef02a7c199$export$5dc6ff369cea976c)(a)) return a;
    else if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(a)) {
        if (typeof b === `number` && typeof c === `number`) return {
            width: a.width,
            height: a.height,
            x: b,
            y: c
        };
        else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b)) return {
            width: a.width,
            height: a.height,
            x: b.x,
            y: b.y
        };
        else throw new TypeError(`If param 'a' is a Rect, expects following parameters to be x,y`);
    } else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a)) {
        if (typeof b === `number` && typeof c === `number`) return {
            x: a.x,
            y: a.y,
            width: b,
            height: c
        };
        else if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(b)) return {
            x: a.x,
            y: a.y,
            width: b.width,
            height: b.height
        };
        else throw new TypeError(`If parameter 'a' is a Point, expect following params to be: Rect or width,height`);
    }
    throw new TypeError(`Expect a first parameter to be x,RectPositioned,Rect or Point`);
}
// src/geometry/rect/IsEqual.ts
var $da7bbf79b162d05c$export$35093e90dece5c82 = (a, b)=>{
    if (a === void 0) throw new Error(`a undefined`);
    if (b === void 0) throw new Error(`b undefined`);
    return a.width === b.width && a.height === b.height;
};
var $da7bbf79b162d05c$var$isEqual4 = (a, b)=>{
    if ((0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(a) && (0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(b)) {
        if (!(0, $2edc1eef02a7c199$export$248d38f6296296c5)(a, b)) return false;
        return a.width === b.width && a.height === b.height;
    } else if (!(0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(a) && !(0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(b)) return a.width === b.width && a.height === b.height;
    else return false;
};
// src/geometry/rect/Lengths.ts
var $da7bbf79b162d05c$var$lengths = (rect)=>{
    (0, $2edc1eef02a7c199$export$cafbc58a575a627c)(rect, `rect`);
    return $da7bbf79b162d05c$var$edges(rect).map((l)=>(0, $2edc1eef02a7c199$export$f24224f1c91d8156)(l));
};
// src/geometry/rect/Multiply.ts
var $da7bbf79b162d05c$var$multiplyOp = (a, b)=>a * b;
function $da7bbf79b162d05c$var$multiply3(a, b, c) {
    return $da7bbf79b162d05c$var$applyMerge($da7bbf79b162d05c$var$multiplyOp, a, b, c);
}
function $da7bbf79b162d05c$export$c697bed75648cdb7(rect, amount) {
    return $da7bbf79b162d05c$var$applyScalar($da7bbf79b162d05c$var$multiplyOp, rect, amount);
}
function $da7bbf79b162d05c$var$multiplyDim(rect, amount) {
    return $da7bbf79b162d05c$var$applyDim($da7bbf79b162d05c$var$multiplyOp, rect, amount);
}
// src/geometry/rect/Nearest.ts
var $da7bbf79b162d05c$var$nearestInternal = (rect, p)=>{
    let { x: x, y: y } = p;
    if (x < rect.x) x = rect.x;
    else if (x > rect.x + rect.width) x = rect.x + rect.width;
    if (y < rect.y) y = rect.y;
    else if (y > rect.y + rect.height) y = rect.y + rect.height;
    return Object.freeze({
        ...p,
        x: x,
        y: y
    });
};
// src/geometry/rect/Placeholder.ts
var $da7bbf79b162d05c$export$84712d0562a614b8 = Object.freeze({
    width: Number.NaN,
    height: Number.NaN
});
var $da7bbf79b162d05c$export$87dcead6234101be = Object.freeze({
    x: Number.NaN,
    y: Number.NaN,
    width: Number.NaN,
    height: Number.NaN
});
// src/geometry/rect/NormaliseByRect.ts
var $da7bbf79b162d05c$var$dividerByLargestDimension = (rect)=>{
    const largest = Math.max(rect.width, rect.height);
    return (value)=>{
        if (typeof value === `number`) return value / largest;
        else if ((0, $8a5cbeb1c6ae1b41$export$dfc736aa30714ce2)(value)) return Object.freeze({
            ...value,
            x: value.x / largest,
            y: value.y / largest,
            z: value.x / largest
        });
        else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(value)) return Object.freeze({
            ...value,
            x: value.x / largest,
            y: value.y / largest
        });
        else throw new Error(`Param 'value' is neither number nor Point`);
    };
};
// src/geometry/rect/Subtract.ts
var $da7bbf79b162d05c$var$subtractOp = (a, b)=>a - b;
function $da7bbf79b162d05c$var$subtract3(a, b, c) {
    return $da7bbf79b162d05c$var$applyMerge($da7bbf79b162d05c$var$subtractOp, a, b, c);
}
function $da7bbf79b162d05c$var$subtractSize(a, b, c) {
    const w = typeof b === `number` ? b : b.width;
    const h = typeof b === `number` ? c : b.height;
    if (h === void 0) throw new Error(`Expected height as third parameter`);
    const r = {
        ...a,
        width: a.width - w,
        height: a.height - h
    };
    return r;
}
function $da7bbf79b162d05c$var$subtractOffset(a, b) {
    let x = 0;
    let y = 0;
    if ((0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(a)) {
        x = a.x;
        y = a.y;
    }
    let xB = 0;
    let yB = 0;
    if ((0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(b)) {
        xB = b.x;
        yB = b.y;
    }
    return Object.freeze({
        ...a,
        x: x - xB,
        y: y - yB,
        width: a.width - b.width,
        height: a.height - b.height
    });
}
// src/geometry/rect/Sum.ts
var $da7bbf79b162d05c$var$sumOp = (a, b)=>a + b;
function $da7bbf79b162d05c$var$sum3(a, b, c) {
    return $da7bbf79b162d05c$var$applyMerge($da7bbf79b162d05c$var$sumOp, a, b, c);
}
function $da7bbf79b162d05c$var$sumOffset(a, b) {
    let x = 0;
    let y = 0;
    if ((0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(a)) {
        x = a.x;
        y = a.y;
    }
    let xB = 0;
    let yB = 0;
    if ((0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(b)) {
        xB = b.x;
        yB = b.y;
    }
    return Object.freeze({
        ...a,
        x: x + xB,
        y: y + yB,
        width: a.width + b.width,
        height: a.height + b.height
    });
}
// src/geometry/rect/ToArray.ts
function $da7bbf79b162d05c$var$toArray(rect) {
    if ((0, $2edc1eef02a7c199$export$db5736f7047b4d1f)(rect)) return [
        rect.x,
        rect.y,
        rect.width,
        rect.height
    ];
    else if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(rect)) return [
        rect.width,
        rect.height
    ];
    else throw new Error(`Param 'rect' is not a rectangle. Got: ${JSON.stringify(rect)}`);
}
// src/geometry/path/index.ts
var $da7bbf79b162d05c$export$4a455666aaa3b016 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$4a455666aaa3b016, {
    getEnd: ()=>$da7bbf79b162d05c$var$getEnd,
    getStart: ()=>$da7bbf79b162d05c$var$getStart
});
var $da7bbf79b162d05c$var$getStart = function(path) {
    if ((0, $2edc1eef02a7c199$export$9e33c9da719c393)(path)) return path.a;
    else if ((0, $2edc1eef02a7c199$export$36082bc57fd6e7b6)(path)) return path.a;
    else throw new Error(`Unknown path type ${JSON.stringify(path)}`);
};
var $da7bbf79b162d05c$var$getEnd = function(path) {
    if ((0, $2edc1eef02a7c199$export$9e33c9da719c393)(path)) return path.b;
    else if ((0, $2edc1eef02a7c199$export$36082bc57fd6e7b6)(path)) return path.b;
    else throw new Error(`Unknown path type ${JSON.stringify(path)}`);
};
// src/geometry/grid/index.ts
var $da7bbf79b162d05c$export$e929600bc3c2764b = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$e929600bc3c2764b, {
    Array1d: ()=>$da7bbf79b162d05c$var$Array1d_exports,
    Array2d: ()=>$da7bbf79b162d05c$var$Array2d_exports,
    As: ()=>$da7bbf79b162d05c$var$As_exports,
    By: ()=>$da7bbf79b162d05c$var$enumerators_exports,
    Visit: ()=>$da7bbf79b162d05c$var$visitors_exports,
    allDirections: ()=>$da7bbf79b162d05c$var$allDirections,
    applyBounds: ()=>$da7bbf79b162d05c$var$applyBounds,
    asRectangles: ()=>$da7bbf79b162d05c$var$asRectangles,
    cellAtPoint: ()=>$da7bbf79b162d05c$var$cellAtPoint,
    cellEquals: ()=>$da7bbf79b162d05c$var$cellEquals,
    cellFromIndex: ()=>$da7bbf79b162d05c$var$cellFromIndex,
    cellKeyString: ()=>$da7bbf79b162d05c$var$cellKeyString,
    cellMiddle: ()=>$da7bbf79b162d05c$var$cellMiddle,
    crossDirections: ()=>$da7bbf79b162d05c$var$crossDirections,
    getLine: ()=>$da7bbf79b162d05c$var$getLine,
    getVectorFromCardinal: ()=>$da7bbf79b162d05c$var$getVectorFromCardinal,
    guardCell: ()=>$da7bbf79b162d05c$var$guardCell,
    guardGrid: ()=>$da7bbf79b162d05c$var$guardGrid,
    indexFromCell: ()=>$da7bbf79b162d05c$var$indexFromCell,
    inside: ()=>$da7bbf79b162d05c$var$inside,
    isCell: ()=>$da7bbf79b162d05c$var$isCell,
    isEqual: ()=>$da7bbf79b162d05c$var$isEqual5,
    neighbourList: ()=>$da7bbf79b162d05c$var$neighbourList,
    neighbours: ()=>$da7bbf79b162d05c$var$neighbours,
    offset: ()=>$da7bbf79b162d05c$var$offset,
    offsetCardinals: ()=>$da7bbf79b162d05c$var$offsetCardinals,
    randomNeighbour: ()=>$da7bbf79b162d05c$var$randomNeighbour,
    rectangleForCell: ()=>$da7bbf79b162d05c$var$rectangleForCell,
    simpleLine: ()=>$da7bbf79b162d05c$var$simpleLine,
    toArray2d: ()=>$da7bbf79b162d05c$var$toArray2d,
    values: ()=>$da7bbf79b162d05c$var$values
});
// src/geometry/grid/Inside.ts
var $da7bbf79b162d05c$var$inside = (grid2, cell)=>{
    if (cell.x < 0 || cell.y < 0) return false;
    if (cell.x >= grid2.cols || cell.y >= grid2.rows) return false;
    return true;
};
// src/geometry/grid/Guards.ts
var $da7bbf79b162d05c$var$isCell = (cell)=>{
    if (cell === void 0) return false;
    return `x` in cell && `y` in cell;
};
var $da7bbf79b162d05c$var$guardCell = (cell, parameterName = `Param`, grid2)=>{
    if (cell === void 0) throw new Error(parameterName + ` is undefined. Expecting {x,y}`);
    if (cell.x === void 0) throw new Error(parameterName + `.x is undefined`);
    if (cell.y === void 0) throw new Error(parameterName + `.y is undefined`);
    if (Number.isNaN(cell.x)) throw new Error(parameterName + `.x is NaN`);
    if (Number.isNaN(cell.y)) throw new Error(parameterName + `.y is NaN`);
    if (!Number.isInteger(cell.x)) throw new TypeError(parameterName + `.x is non-integer`);
    if (!Number.isInteger(cell.y)) throw new TypeError(parameterName + `.y is non-integer`);
    if (grid2 !== void 0 && !$da7bbf79b162d05c$var$inside(grid2, cell)) throw new Error(`${parameterName} is outside of grid. Cell: ${cell.x},${cell.y} Grid: ${grid2.cols}, ${grid2.rows}`);
};
var $da7bbf79b162d05c$var$guardGrid = (grid2, parameterName = `Param`)=>{
    if (grid2 === void 0) throw new Error(`${parameterName} is undefined. Expecting grid.`);
    if (!(`rows` in grid2)) throw new Error(`${parameterName}.rows is undefined`);
    if (!(`cols` in grid2)) throw new Error(`${parameterName}.cols is undefined`);
    if (!Number.isInteger(grid2.rows)) throw new TypeError(`${parameterName}.rows is not an integer`);
    if (!Number.isInteger(grid2.cols)) throw new TypeError(`${parameterName}.cols is not an integer`);
};
// src/geometry/grid/ApplyBounds.ts
var $da7bbf79b162d05c$var$applyBounds = function(grid2, cell, wrap4 = `undefined`) {
    $da7bbf79b162d05c$var$guardGrid(grid2, `grid`);
    $da7bbf79b162d05c$var$guardCell(cell, `cell`);
    let x = cell.x;
    let y = cell.y;
    switch(wrap4){
        case `wrap`:
            x = x % grid2.cols;
            y = y % grid2.rows;
            if (x < 0) x = grid2.cols + x;
            else if (x >= grid2.cols) x -= grid2.cols;
            if (y < 0) y = grid2.rows + y;
            else if (y >= grid2.rows) y -= grid2.rows;
            x = Math.abs(x);
            y = Math.abs(y);
            break;
        case `stop`:
            x = (0, $ab835bc9d61bae68$export$cdbb71092bf28e30)(x, grid2.cols);
            y = (0, $ab835bc9d61bae68$export$cdbb71092bf28e30)(y, grid2.rows);
            break;
        case `undefined`:
            if (x < 0 || y < 0) return;
            if (x >= grid2.cols || y >= grid2.rows) return;
            break;
        case `unbounded`:
            break;
        default:
            throw new Error(`Unknown BoundsLogic '${wrap4}'. Expected: wrap, stop, undefined or unbounded`);
    }
    return Object.freeze({
        x: x,
        y: y
    });
};
// src/geometry/grid/Array1d.ts
var $da7bbf79b162d05c$var$Array1d_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$Array1d_exports, {
    access: ()=>$da7bbf79b162d05c$var$access,
    createArray: ()=>$da7bbf79b162d05c$var$createArray,
    createMutable: ()=>$da7bbf79b162d05c$var$createMutable,
    set: ()=>$da7bbf79b162d05c$var$set,
    setMutate: ()=>$da7bbf79b162d05c$var$setMutate,
    wrap: ()=>$da7bbf79b162d05c$var$wrap,
    wrapMutable: ()=>$da7bbf79b162d05c$var$wrapMutable
});
var $da7bbf79b162d05c$var$access = (array, cols)=>{
    const grid2 = $da7bbf79b162d05c$var$gridFromArrayDimensions(array, cols);
    const fn = (cell, wrap4 = `undefined`)=>$da7bbf79b162d05c$var$accessWithGrid(grid2, array, cell, wrap4);
    return fn;
};
var $da7bbf79b162d05c$var$accessWithGrid = (grid2, array, cell, wrap4)=>{
    const index = $da7bbf79b162d05c$var$indexFromCell(grid2, cell, wrap4);
    if (index === void 0) return void 0;
    return array[index];
};
var $da7bbf79b162d05c$var$setMutate = (array, cols)=>{
    const grid2 = $da7bbf79b162d05c$var$gridFromArrayDimensions(array, cols);
    return (value, cell, wrap4 = `undefined`)=>$da7bbf79b162d05c$var$setMutateWithGrid(grid2, array, value, cell, wrap4);
};
var $da7bbf79b162d05c$var$setMutateWithGrid = (grid2, array, value, cell, wrap4)=>{
    const index = $da7bbf79b162d05c$var$indexFromCell(grid2, cell, wrap4);
    if (index === void 0) throw new RangeError(`Cell (${cell.x},${cell.y}) is out of range of grid cols: ${grid2.cols} rows: ${grid2.rows}`);
    array[index] = value;
    return array;
};
var $da7bbf79b162d05c$var$set = (array, cols)=>{
    const grid2 = $da7bbf79b162d05c$var$gridFromArrayDimensions(array, cols);
    return (value, cell, wrap4)=>$da7bbf79b162d05c$var$setWithGrid(grid2, array, value, cell, wrap4);
};
var $da7bbf79b162d05c$var$setWithGrid = (grid2, array, value, cell, wrap4)=>{
    const index = $da7bbf79b162d05c$var$indexFromCell(grid2, cell, wrap4);
    if (index === void 0) throw new RangeError(`Cell (${cell.x},${cell.y}) is out of range of grid cols: ${grid2.cols} rows: ${grid2.rows}`);
    let copy = [
        ...array
    ];
    copy[index] = value;
    array = copy;
    return copy;
};
var $da7bbf79b162d05c$var$gridFromArrayDimensions = (array, cols)=>{
    const grid2 = {
        cols: cols,
        rows: Math.ceil(array.length / cols)
    };
    return grid2;
};
var $da7bbf79b162d05c$var$wrapMutable = (array, cols)=>{
    const grid2 = $da7bbf79b162d05c$var$gridFromArrayDimensions(array, cols);
    return {
        ...grid2,
        get: $da7bbf79b162d05c$var$access(array, cols),
        set: $da7bbf79b162d05c$var$setMutate(array, cols),
        get array () {
            return array;
        }
    };
};
var $da7bbf79b162d05c$var$wrap = (array, cols)=>{
    const grid2 = $da7bbf79b162d05c$var$gridFromArrayDimensions(array, cols);
    return {
        ...grid2,
        get: (cell, boundsLogic = `undefined`)=>$da7bbf79b162d05c$var$accessWithGrid(grid2, array, cell, boundsLogic),
        set: (value, cell, boundsLogic = `undefined`)=>{
            array = $da7bbf79b162d05c$var$setWithGrid(grid2, array, value, cell, boundsLogic);
            return $da7bbf79b162d05c$var$wrap(array, cols);
        },
        get array () {
            return array;
        }
    };
};
var $da7bbf79b162d05c$var$createArray = (initialValue, rowsOrGrid, columns2)=>{
    const rows2 = typeof rowsOrGrid === `number` ? rowsOrGrid : rowsOrGrid.rows;
    const cols = typeof rowsOrGrid === `object` ? rowsOrGrid.cols : columns2;
    if (!cols) throw new Error(`Parameter 'columns' missing`);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(rows2, `aboveZero`, `rows`);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(cols, `aboveZero`, `cols`);
    let t = [];
    let total = rows2 * cols;
    for(let i = 0; i < total; i++)t[i] = initialValue;
    return t;
};
var $da7bbf79b162d05c$var$createMutable = (initialValue, rowsOrGrid, columns2)=>{
    const rows2 = typeof rowsOrGrid === `number` ? rowsOrGrid : rowsOrGrid.rows;
    const cols = typeof rowsOrGrid === `object` ? rowsOrGrid.cols : columns2;
    if (!cols) throw new Error(`Parameter 'columns' missing`);
    const arr = $da7bbf79b162d05c$var$createArray(initialValue, rows2, cols);
    return $da7bbf79b162d05c$var$wrapMutable(arr, cols);
};
// src/geometry/grid/Array2d.ts
var $da7bbf79b162d05c$var$Array2d_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$Array2d_exports, {
    access: ()=>$da7bbf79b162d05c$var$access2,
    create: ()=>$da7bbf79b162d05c$var$create,
    set: ()=>$da7bbf79b162d05c$var$set2,
    setMutate: ()=>$da7bbf79b162d05c$var$setMutate2,
    wrap: ()=>$da7bbf79b162d05c$var$wrap2,
    wrapMutable: ()=>$da7bbf79b162d05c$var$wrapMutable2
});
var $da7bbf79b162d05c$var$create = (array)=>{
    let colLen = NaN;
    for (const row of array)if (Number.isNaN(colLen)) colLen = row.length;
    else {
        if (colLen !== row.length) throw new Error(`Array does not have uniform column length`);
    }
    return {
        rows: array.length,
        cols: colLen
    };
};
var $da7bbf79b162d05c$var$setMutate2 = (array)=>{
    const grid2 = $da7bbf79b162d05c$var$create(array);
    return (value, cell, wrap4 = `undefined`)=>$da7bbf79b162d05c$var$setMutateWithGrid2(grid2, array, value, cell, wrap4);
};
var $da7bbf79b162d05c$var$setMutateWithGrid2 = (grid2, array, value, cell, bounds)=>{
    let boundCell = $da7bbf79b162d05c$var$applyBounds(grid2, cell, bounds);
    if (boundCell === void 0) throw new RangeError(`Cell (${cell.x},${cell.y}) is out of range of grid cols: ${grid2.cols} rows: ${grid2.rows}`);
    array[boundCell.y][boundCell.x] = value;
    return array;
};
var $da7bbf79b162d05c$var$access2 = (array)=>{
    const grid2 = $da7bbf79b162d05c$var$create(array);
    const fn = (cell, wrap4 = `undefined`)=>$da7bbf79b162d05c$var$accessWithGrid2(grid2, array, cell, wrap4);
    return fn;
};
var $da7bbf79b162d05c$var$accessWithGrid2 = (grid2, array, cell, wrap4)=>{
    let boundCell = $da7bbf79b162d05c$var$applyBounds(grid2, cell, wrap4);
    if (boundCell === void 0) return void 0;
    return array[boundCell.y][boundCell.x];
};
var $da7bbf79b162d05c$var$wrapMutable2 = (array)=>{
    const grid2 = $da7bbf79b162d05c$var$create(array);
    return {
        ...grid2,
        get: $da7bbf79b162d05c$var$access2(array),
        set: $da7bbf79b162d05c$var$setMutate2(array),
        get array () {
            return array;
        }
    };
};
var $da7bbf79b162d05c$var$set2 = (array)=>{
    const grid2 = $da7bbf79b162d05c$var$create(array);
    return (value, cell, wrap4)=>$da7bbf79b162d05c$var$setWithGrid2(grid2, array, value, cell, wrap4);
};
var $da7bbf79b162d05c$var$setWithGrid2 = (grid2, array, value, cell, wrap4)=>{
    let boundCell = $da7bbf79b162d05c$var$applyBounds(grid2, cell, wrap4);
    if (boundCell === void 0) throw new RangeError(`Cell (${cell.x},${cell.y}) is out of range of grid cols: ${grid2.cols} rows: ${grid2.rows}`);
    let copyWhole = [
        ...array
    ];
    let copyRow = [
        ...copyWhole[boundCell.y]
    ];
    copyRow[boundCell.x] = value;
    copyWhole[boundCell.y] = copyRow;
    array = copyWhole;
    return copyWhole;
};
var $da7bbf79b162d05c$var$wrap2 = (array)=>{
    const grid2 = $da7bbf79b162d05c$var$create(array);
    return {
        ...grid2,
        get: (cell, boundsLogic = `undefined`)=>$da7bbf79b162d05c$var$accessWithGrid2(grid2, array, cell, boundsLogic),
        set: (value, cell, boundsLogic = `undefined`)=>{
            array = $da7bbf79b162d05c$var$setWithGrid2(grid2, array, value, cell, boundsLogic);
            return $da7bbf79b162d05c$var$wrap2(array);
        },
        get array () {
            return array;
        }
    };
};
// src/geometry/grid/As.ts
var $da7bbf79b162d05c$var$As_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$As_exports, {
    columns: ()=>$da7bbf79b162d05c$var$columns,
    rows: ()=>$da7bbf79b162d05c$var$rows
});
// src/geometry/grid/Values.ts
function* $da7bbf79b162d05c$var$values(grid2, iter) {
    for (const d of iter)if (Array.isArray(d)) yield d.map((v)=>grid2.get(v, `undefined`));
    else yield grid2.get(d, `undefined`);
}
// src/geometry/grid/enumerators/Cells.ts
function* $da7bbf79b162d05c$var$cells(grid2, start, wrap4 = true) {
    if (!start) start = {
        x: 0,
        y: 0
    };
    $da7bbf79b162d05c$var$guardGrid(grid2, `grid`);
    $da7bbf79b162d05c$var$guardCell(start, `start`, grid2);
    let { x: x, y: y } = start;
    let canMove = true;
    do {
        yield {
            x: x,
            y: y
        };
        x++;
        if (x === grid2.cols) {
            y++;
            x = 0;
        }
        if (y === grid2.rows) {
            if (wrap4) {
                y = 0;
                x = 0;
            } else canMove = false;
        }
        if (x === start.x && y === start.y) canMove = false;
    }while (canMove);
}
function* $da7bbf79b162d05c$var$cellValues(grid2, start, wrap4 = true) {
    yield* $da7bbf79b162d05c$var$values(grid2, $da7bbf79b162d05c$var$cells(grid2, start, wrap4));
}
function* $da7bbf79b162d05c$var$cellsAndValues(grid2, start, wrap4 = true) {
    for (const cell of $da7bbf79b162d05c$var$cells(grid2, start, wrap4))yield {
        cell: cell,
        value: grid2.get(cell)
    };
}
// src/geometry/grid/As.ts
var $da7bbf79b162d05c$var$rows = function*(grid2, start) {
    if (!start) start = {
        x: 0,
        y: 0
    };
    let row = start.y;
    let rowCells = [];
    for (const c of $da7bbf79b162d05c$var$cells(grid2, start))if (c.y === row) rowCells.push(c);
    else {
        yield rowCells;
        rowCells = [
            c
        ];
        row = c.y;
    }
    if (rowCells.length > 0) yield rowCells;
};
function* $da7bbf79b162d05c$var$columns(grid2, start) {
    if (!start) start = {
        x: 0,
        y: 0
    };
    for(let x = start.x; x < grid2.cols; x++){
        let colCells = [];
        for(let y = start.y; y < grid2.rows; y++)colCells.push({
            x: x,
            y: y
        });
        yield colCells;
    }
}
// src/geometry/grid/Offset.ts
var $da7bbf79b162d05c$var$offset = function(grid2, start, vector, bounds = `undefined`) {
    return $da7bbf79b162d05c$var$applyBounds(grid2, {
        x: start.x + vector.x,
        y: start.y + vector.y
    }, bounds);
};
// src/geometry/grid/Directions.ts
var $da7bbf79b162d05c$var$allDirections = Object.freeze([
    `n`,
    `ne`,
    `nw`,
    `e`,
    `s`,
    `se`,
    `sw`,
    `w`
]);
var $da7bbf79b162d05c$var$crossDirections = Object.freeze([
    `n`,
    `e`,
    `s`,
    `w`
]);
var $da7bbf79b162d05c$var$offsetCardinals = (grid2, start, steps, bounds = `stop`)=>{
    $da7bbf79b162d05c$var$guardGrid(grid2, `grid`);
    $da7bbf79b162d05c$var$guardCell(start, `start`);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(steps, `aboveZero`, `steps`);
    const directions = $da7bbf79b162d05c$var$allDirections;
    const vectors = directions.map((d)=>$da7bbf79b162d05c$var$getVectorFromCardinal(d, steps));
    const cells2 = directions.map((d, index)=>$da7bbf79b162d05c$var$offset(grid2, start, vectors[index], bounds));
    return (0, $3ffa4b3bf3c5db47$export$c2d6f401933fc426)(directions, cells2);
};
var $da7bbf79b162d05c$var$getVectorFromCardinal = (cardinal2, multiplier = 1)=>{
    let v;
    switch(cardinal2){
        case `n`:
            v = {
                x: 0,
                y: -1 * multiplier
            };
            break;
        case `ne`:
            v = {
                x: 1 * multiplier,
                y: -1 * multiplier
            };
            break;
        case `e`:
            v = {
                x: 1 * multiplier,
                y: 0
            };
            break;
        case `se`:
            v = {
                x: 1 * multiplier,
                y: 1 * multiplier
            };
            break;
        case `s`:
            v = {
                x: 0,
                y: 1 * multiplier
            };
            break;
        case `sw`:
            v = {
                x: -1 * multiplier,
                y: 1 * multiplier
            };
            break;
        case `w`:
            v = {
                x: -1 * multiplier,
                y: 0
            };
            break;
        case `nw`:
            v = {
                x: -1 * multiplier,
                y: -1 * multiplier
            };
            break;
        default:
            v = {
                x: 0,
                y: 0
            };
    }
    return Object.freeze(v);
};
// src/geometry/grid/enumerators/index.ts
var $da7bbf79b162d05c$var$enumerators_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$enumerators_exports, {
    cellValues: ()=>$da7bbf79b162d05c$var$cellValues,
    cells: ()=>$da7bbf79b162d05c$var$cells,
    cellsAndValues: ()=>$da7bbf79b162d05c$var$cellsAndValues
});
// src/geometry/grid/Geometry.ts
var $da7bbf79b162d05c$var$getLine = (start, end)=>{
    $da7bbf79b162d05c$var$guardCell(start);
    $da7bbf79b162d05c$var$guardCell(end);
    let startX = start.x;
    let startY = start.y;
    const dx = Math.abs(end.x - startX);
    const dy = Math.abs(end.y - startY);
    const sx = startX < end.x ? 1 : -1;
    const sy = startY < end.y ? 1 : -1;
    let error = dx - dy;
    const cells2 = [];
    while(true){
        cells2.push(Object.freeze({
            x: startX,
            y: startY
        }));
        if (startX === end.x && startY === end.y) break;
        const error2 = 2 * error;
        if (error2 > -dy) {
            error -= dy;
            startX += sx;
        }
        if (error2 < dx) {
            error += dx;
            startY += sy;
        }
    }
    return cells2;
};
var $da7bbf79b162d05c$var$simpleLine = function(start, end, endInclusive = false) {
    const cells2 = [];
    if (start.x === end.x) {
        const lastY = endInclusive ? end.y + 1 : end.y;
        for(let y = start.y; y < lastY; y++)cells2.push({
            x: start.x,
            y: y
        });
    } else if (start.y === end.y) {
        const lastX = endInclusive ? end.x + 1 : end.x;
        for(let x = start.x; x < lastX; x++)cells2.push({
            x: x,
            y: start.y
        });
    } else throw new Error(`Only does vertical and horizontal: ${start.x},${start.y} - ${end.x},${end.y}`);
    return cells2;
};
// src/geometry/grid/Indexing.ts
var $da7bbf79b162d05c$var$indexFromCell = (grid2, cell, wrap4)=>{
    $da7bbf79b162d05c$var$guardGrid(grid2, `grid`);
    if (cell.x < 0) switch(wrap4){
        case `stop`:
            cell = {
                ...cell,
                x: 0
            };
            break;
        case `unbounded`:
            throw new Error(`unbounded not supported`);
        case `undefined`:
            return void 0;
        case `wrap`:
            cell = $da7bbf79b162d05c$var$offset(grid2, {
                x: 0,
                y: cell.y
            }, {
                x: cell.x,
                y: 0
            }, `wrap`);
            break;
    }
    if (cell.y < 0) switch(wrap4){
        case `stop`:
            cell = {
                ...cell,
                y: 0
            };
            break;
        case `unbounded`:
            throw new Error(`unbounded not supported`);
        case `undefined`:
            return void 0;
        case `wrap`:
            cell = {
                ...cell,
                y: grid2.rows + cell.y
            };
            break;
    }
    if (cell.x >= grid2.cols) switch(wrap4){
        case `stop`:
            cell = {
                ...cell,
                x: grid2.cols - 1
            };
            break;
        case `unbounded`:
            throw new Error(`unbounded not supported`);
        case `undefined`:
            return void 0;
        case `wrap`:
            cell = {
                ...cell,
                x: cell.x % grid2.cols
            };
            break;
    }
    if (cell.y >= grid2.rows) switch(wrap4){
        case `stop`:
            cell = {
                ...cell,
                y: grid2.rows - 1
            };
            break;
        case `unbounded`:
            throw new Error(`unbounded not supported`);
        case `undefined`:
            return void 0;
        case `wrap`:
            cell = {
                ...cell,
                y: cell.y % grid2.rows
            };
            break;
    }
    const index = cell.y * grid2.cols + cell.x;
    return index;
};
var $da7bbf79b162d05c$var$cellFromIndex = (colsOrGrid, index)=>{
    let cols = 0;
    cols = typeof colsOrGrid === `number` ? colsOrGrid : colsOrGrid.cols;
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(cols, `aboveZero`, `colsOrGrid`);
    return {
        x: index % cols,
        y: Math.floor(index / cols)
    };
};
// src/geometry/grid/IsEqual.ts
var $da7bbf79b162d05c$var$isEqual5 = (a, b)=>{
    if (b === void 0) return false;
    if (a === void 0) return false;
    if (`rows` in a && `cols` in a) {
        if (`rows` in b && `cols` in b) {
            if (a.rows !== b.rows || a.cols !== b.cols) return false;
        } else return false;
    }
    if (`size` in a) {
        if (`size` in b) {
            if (a.size !== b.size) return false;
        } else return false;
    }
    return true;
};
var $da7bbf79b162d05c$var$cellEquals = (a, b)=>{
    if (b === void 0) return false;
    if (a === void 0) return false;
    return a.x === b.x && a.y === b.y;
};
// src/geometry/grid/Neighbour.ts
var $da7bbf79b162d05c$var$randomNeighbour = (nbos)=>(0, $7b02fea154055fc0$export$d3d80cee07107776)(nbos);
var $da7bbf79b162d05c$var$isNeighbour = (n)=>{
    if (n === void 0) return false;
    if (n[1] === void 0) return false;
    return true;
};
var $da7bbf79b162d05c$var$neighbourList = (grid2, cell, directions, bounds)=>{
    const cellNeighbours = $da7bbf79b162d05c$var$neighbours(grid2, cell, bounds, directions);
    const entries = Object.entries(cellNeighbours);
    return entries.filter((n)=>$da7bbf79b162d05c$var$isNeighbour(n));
};
var $da7bbf79b162d05c$var$neighbours = (grid2, cell, bounds = `undefined`, directions)=>{
    const directories = directions ?? $da7bbf79b162d05c$var$allDirections;
    const points = directories.map((c)=>$da7bbf79b162d05c$var$offset(grid2, cell, $da7bbf79b162d05c$var$getVectorFromCardinal(c), bounds));
    return (0, $3ffa4b3bf3c5db47$export$c2d6f401933fc426)(directories, points);
};
// src/geometry/grid/ToArray.ts
var $da7bbf79b162d05c$var$toArray2d = (grid2, initialValue)=>{
    const returnValue = [];
    for(let row = 0; row < grid2.rows; row++){
        returnValue[row] = Array.from({
            length: grid2.cols
        });
        if (initialValue) for(let col = 0; col < grid2.cols; col++)returnValue[row][col] = initialValue;
    }
    return returnValue;
};
// src/geometry/grid/ToString.ts
var $da7bbf79b162d05c$var$cellKeyString = (v)=>`Cell{${v.x},${v.y}}`;
// src/geometry/grid/Visual.ts
function* $da7bbf79b162d05c$var$asRectangles(grid2) {
    for (const c of $da7bbf79b162d05c$var$cells(grid2))yield $da7bbf79b162d05c$var$rectangleForCell(grid2, c);
}
var $da7bbf79b162d05c$var$cellAtPoint = (grid2, position)=>{
    const size = grid2.size;
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(size, `positive`, `grid.size`);
    if (position.x < 0 || position.y < 0) return;
    const x = Math.floor(position.x / size);
    const y = Math.floor(position.y / size);
    if (x >= grid2.cols) return;
    if (y >= grid2.rows) return;
    return {
        x: x,
        y: y
    };
};
var $da7bbf79b162d05c$var$rectangleForCell = (grid2, cell)=>{
    $da7bbf79b162d05c$var$guardCell(cell);
    const size = grid2.size;
    const x = cell.x * size;
    const y = cell.y * size;
    const r = (0, $2edc1eef02a7c199$export$ebf8d3595f30628)({
        x: x,
        y: y
    }, size, size);
    return r;
};
var $da7bbf79b162d05c$var$cellMiddle = (grid2, cell)=>{
    $da7bbf79b162d05c$var$guardCell(cell);
    const size = grid2.size;
    const x = cell.x * size;
    const y = cell.y * size;
    return Object.freeze({
        x: x + size / 2,
        y: y + size / 2
    });
};
// src/geometry/grid/visitors/index.ts
var $da7bbf79b162d05c$var$visitors_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$visitors_exports, {
    breadthLogic: ()=>$da7bbf79b162d05c$var$breadthLogic,
    columnLogic: ()=>$da7bbf79b162d05c$var$columnLogic,
    create: ()=>$da7bbf79b162d05c$var$create2,
    depthLogic: ()=>$da7bbf79b162d05c$var$depthLogic,
    neighboursLogic: ()=>$da7bbf79b162d05c$var$neighboursLogic,
    randomContiguousLogic: ()=>$da7bbf79b162d05c$var$randomContiguousLogic,
    randomLogic: ()=>$da7bbf79b162d05c$var$randomLogic,
    rowLogic: ()=>$da7bbf79b162d05c$var$rowLogic,
    stepper: ()=>$da7bbf79b162d05c$var$stepper,
    visitByNeighbours: ()=>$da7bbf79b162d05c$var$visitByNeighbours,
    withLogic: ()=>$da7bbf79b162d05c$var$withLogic
});
// src/geometry/grid/visitors/Breadth.ts
var $da7bbf79b162d05c$var$breadthLogic = ()=>{
    return {
        select: (nbos)=>nbos[0]
    };
};
// src/geometry/grid/visitors/CellNeighbours.ts
var $da7bbf79b162d05c$var$neighboursLogic = ()=>{
    return {
        select: (neighbours2)=>{
            return neighbours2.at(0);
        },
        getNeighbours: (grid2, cell)=>{
            return $da7bbf79b162d05c$var$neighbourList(grid2, cell, $da7bbf79b162d05c$var$allDirections, `undefined`);
        }
    };
};
// src/geometry/grid/visitors/Columns.ts
var $da7bbf79b162d05c$var$columnLogic = (opts = {})=>{
    const reversed = opts.reversed ?? false;
    return {
        select: (nbos)=>nbos.find((n)=>n[0] === (reversed ? `n` : `s`)),
        getNeighbours: (grid2, cell)=>{
            if (reversed) {
                if (cell.y > 0) cell = {
                    x: cell.x,
                    y: cell.y - 1
                };
                else if (cell.x === 0) cell = {
                    x: grid2.cols - 1,
                    y: grid2.rows - 1
                };
                else cell = {
                    x: cell.x - 1,
                    y: grid2.rows - 1
                };
            } else {
                if (cell.y < grid2.rows - 1) cell = {
                    x: cell.x,
                    y: cell.y + 1
                };
                else if (cell.x < grid2.cols - 1) cell = {
                    x: cell.x + 1,
                    y: 0
                };
                else cell = {
                    x: 0,
                    y: 0
                };
            }
            return [
                [
                    reversed ? `n` : `s`,
                    cell
                ]
            ];
        }
    };
};
// src/geometry/grid/visitors/Depth.ts
var $da7bbf79b162d05c$var$depthLogic = ()=>{
    return {
        select: (nbos)=>nbos.at(-1)
    };
};
// src/geometry/grid/visitors/Random.ts
var $da7bbf79b162d05c$var$randomLogic = ()=>{
    return {
        getNeighbours: (grid2, cell)=>{
            const t = [];
            for (const c of $da7bbf79b162d05c$var$cells(grid2, cell))t.push([
                `n`,
                c
            ]);
            return t;
        },
        select: $da7bbf79b162d05c$var$randomNeighbour
    };
};
// src/geometry/grid/visitors/RandomContiguous.ts
var $da7bbf79b162d05c$var$randomContiguousLogic = ()=>{
    return {
        select: $da7bbf79b162d05c$var$randomNeighbour
    };
};
// src/geometry/grid/visitors/Rows.ts
var $da7bbf79b162d05c$var$rowLogic = (opts = {})=>{
    const reversed = opts.reversed ?? false;
    return {
        select: (nbos)=>nbos.find((n)=>n[0] === (reversed ? `w` : `e`)),
        getNeighbours: (grid2, cell)=>{
            if (reversed) {
                if (cell.x > 0) cell = {
                    x: cell.x - 1,
                    y: cell.y
                };
                else if (cell.y > 0) cell = {
                    x: grid2.cols - 1,
                    y: cell.y - 1
                };
                else cell = {
                    x: grid2.cols - 1,
                    y: grid2.rows - 1
                };
            } else {
                if (cell.x < grid2.rows - 1) cell = {
                    x: cell.x + 1,
                    y: cell.y
                };
                else if (cell.y < grid2.rows - 1) cell = {
                    x: 0,
                    y: cell.y + 1
                };
                else cell = {
                    x: 0,
                    y: 0
                };
            }
            return [
                [
                    reversed ? `w` : `e`,
                    cell
                ]
            ];
        }
    };
};
// src/geometry/grid/visitors/Visitor.ts
function* $da7bbf79b162d05c$var$visitByNeighbours(logic, grid2, opts = {}) {
    $da7bbf79b162d05c$var$guardGrid(grid2, `grid`);
    const start = opts.start ?? {
        x: 0,
        y: 0
    };
    $da7bbf79b162d05c$var$guardCell(start, `opts.start`, grid2);
    const v = opts.visited ?? (0, $297664b1c3fbdd1f$export$9cc7a411a0b9bd72)($da7bbf79b162d05c$var$cellKeyString);
    const possibleNeighbours = logic.getNeighbours ?? ((g, c)=>$da7bbf79b162d05c$var$neighbourList(g, c, $da7bbf79b162d05c$var$crossDirections, `undefined`));
    let cellQueue = [
        start
    ];
    let moveQueue = [];
    let current = void 0;
    while(cellQueue.length > 0){
        if (current === void 0) {
            const nv = cellQueue.pop();
            if (nv === void 0) break;
            current = nv;
        }
        if (!v.has(current)) {
            v.add(current);
            yield current;
            const nextSteps = possibleNeighbours(grid2, current).filter((step)=>{
                if (step[1] === void 0) return false;
                return !v.has(step[1]);
            });
            if (nextSteps.length === 0) {
                if (current !== void 0) cellQueue = cellQueue.filter((cq)=>$da7bbf79b162d05c$var$cellEquals(cq, current));
            } else for (const n of nextSteps){
                if (n === void 0) continue;
                if (n[1] === void 0) continue;
                moveQueue.push(n);
            }
        }
        moveQueue = moveQueue.filter((step)=>!v.has(step[1]));
        if (moveQueue.length === 0) current = void 0;
        else {
            const potential = logic.select(moveQueue);
            if (potential !== void 0) {
                cellQueue.push(potential[1]);
                current = potential[1];
            }
        }
    }
}
// src/geometry/grid/visitors/Step.ts
var $da7bbf79b162d05c$var$stepper = (grid2, createVisitor, start = {
    x: 0,
    y: 0
}, resolution = 1)=>{
    $da7bbf79b162d05c$var$guardGrid(grid2, `grid`);
    $da7bbf79b162d05c$var$guardCell(start, `start`);
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(resolution, ``, `resolution`);
    const steps = [];
    let count = 0;
    let position = 0;
    for (const c of createVisitor(grid2, {
        start: start,
        boundsWrap: `undefined`
    })){
        count++;
        if (count % resolution !== 0) continue;
        steps.push(c);
    }
    return (step, fromStart = false)=>{
        (0, $984cc5641d701af3$export$a4ff393eb12b0888)(step, ``, `step`);
        if (fromStart) position = step;
        else position += step;
        return steps.at(position % steps.length);
    };
};
// src/geometry/grid/visitors/index.ts
var $da7bbf79b162d05c$var$create2 = (type, opts = {})=>{
    switch(type){
        case `random-contiguous`:
            return $da7bbf79b162d05c$var$withLogic($da7bbf79b162d05c$var$randomContiguousLogic(), opts);
        case `random`:
            return $da7bbf79b162d05c$var$withLogic($da7bbf79b162d05c$var$randomLogic(), opts);
        case `depth`:
            return $da7bbf79b162d05c$var$withLogic($da7bbf79b162d05c$var$depthLogic(), opts);
        case `breadth`:
            return $da7bbf79b162d05c$var$withLogic($da7bbf79b162d05c$var$breadthLogic(), opts);
        case `neighbours`:
            return $da7bbf79b162d05c$var$withLogic($da7bbf79b162d05c$var$neighboursLogic(), opts);
        case `row`:
            return $da7bbf79b162d05c$var$withLogic($da7bbf79b162d05c$var$rowLogic(opts), opts);
        case `column`:
            return $da7bbf79b162d05c$var$withLogic($da7bbf79b162d05c$var$columnLogic(opts), opts);
        default:
            throw new TypeError(`Param 'type' unknown. Value: ${type}`);
    }
};
var $da7bbf79b162d05c$var$withLogic = (logic, options = {})=>{
    return (grid2, optionsOverride = {})=>{
        return $da7bbf79b162d05c$var$visitByNeighbours(logic, grid2, {
            ...options,
            ...optionsOverride
        });
    };
};
// src/geometry/path/CompoundPath.ts
var $da7bbf79b162d05c$export$58cca3917bf916af = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$58cca3917bf916af, {
    bbox: ()=>$da7bbf79b162d05c$var$bbox4,
    computeDimensions: ()=>$da7bbf79b162d05c$var$computeDimensions,
    distanceToPoint: ()=>$da7bbf79b162d05c$var$distanceToPoint,
    fromPaths: ()=>$da7bbf79b162d05c$var$fromPaths,
    guardContinuous: ()=>$da7bbf79b162d05c$var$guardContinuous,
    interpolate: ()=>$da7bbf79b162d05c$var$interpolate3,
    relativePosition: ()=>$da7bbf79b162d05c$var$relativePosition2,
    setSegment: ()=>$da7bbf79b162d05c$var$setSegment,
    toString: ()=>$da7bbf79b162d05c$var$toString4,
    toSvgString: ()=>$da7bbf79b162d05c$var$toSvgString2
});
var $da7bbf79b162d05c$var$setSegment = (compoundPath, index, path)=>{
    const existing = [
        ...compoundPath.segments
    ];
    existing[index] = path;
    return $da7bbf79b162d05c$var$fromPaths(...existing);
};
var $da7bbf79b162d05c$var$interpolate3 = (paths, t, useWidth, dimensions)=>{
    if (dimensions === void 0) dimensions = $da7bbf79b162d05c$var$computeDimensions(paths);
    const expected = t * (useWidth ? dimensions.totalWidth : dimensions.totalLength);
    let soFar = 0;
    const l = useWidth ? dimensions.widths : dimensions.lengths;
    for (const [index, element] of l.entries())if (soFar + element >= expected) {
        const relative = expected - soFar;
        let amt = relative / element;
        if (amt > 1) amt = 1;
        return paths[index].interpolate(amt);
    } else soFar += element;
    return {
        x: 0,
        y: 0
    };
};
var $da7bbf79b162d05c$var$distanceToPoint = (paths, point2)=>{
    if (paths.length === 0) return 0;
    let distances = paths.map((p, index)=>({
            path: p,
            index: index,
            distance: p.distanceToPoint(point2)
        }));
    distances = (0, $b63753f448317b08$export$def566e6b50bc276)(distances, `distance`);
    if (distances.length === 0) throw new Error(`Could not look up distances`);
    return distances[0].distance;
};
var $da7bbf79b162d05c$var$relativePosition2 = (paths, point2, intersectionThreshold, dimensions)=>{
    if (dimensions === void 0) dimensions = $da7bbf79b162d05c$var$computeDimensions(paths);
    let distances = paths.map((p, index)=>({
            path: p,
            index: index,
            distance: p.distanceToPoint(point2)
        }));
    distances = (0, $b63753f448317b08$export$def566e6b50bc276)(distances, `distance`);
    if (distances.length < 0) throw new Error(`Point does not intersect with path`);
    const d = distances[0];
    if (d.distance > intersectionThreshold) throw new Error(`Point does not intersect with path. Minimum distance: ${d.distance}, threshold: ${intersectionThreshold}`);
    const relativePositionOnPath = d.path.relativePosition(point2, intersectionThreshold);
    let accumulated = 0;
    for(let index = 0; index < d.index; index++)accumulated += dimensions.lengths[index];
    accumulated += dimensions.lengths[d.index] * relativePositionOnPath;
    const accumulatedRel = accumulated / dimensions.totalLength;
    console.log(`acc: ${accumulated} rel: ${accumulatedRel} on path: ${relativePositionOnPath} path: ${d.index}`);
    return accumulatedRel;
};
var $da7bbf79b162d05c$var$computeDimensions = (paths)=>{
    const widths = paths.map((l)=>l.bbox().width);
    const lengths3 = paths.map((l)=>l.length());
    let totalLength = 0;
    let totalWidth = 0;
    for (const length4 of lengths3)totalLength += length4;
    for (const width of widths)totalWidth += width;
    return {
        totalLength: totalLength,
        totalWidth: totalWidth,
        widths: widths,
        lengths: lengths3
    };
};
var $da7bbf79b162d05c$var$bbox4 = (paths)=>{
    const boxes = paths.map((p)=>p.bbox());
    const corners3 = boxes.flatMap((b)=>$da7bbf79b162d05c$export$389cfe57f7c9dd77(b));
    return (0, $2edc1eef02a7c199$export$bf67010aacbe66fa)(...corners3);
};
var $da7bbf79b162d05c$var$toString4 = (paths)=>paths.map((p)=>p.toString()).join(`, `);
var $da7bbf79b162d05c$var$guardContinuous = (paths)=>{
    let lastPos = $da7bbf79b162d05c$var$getEnd(paths[0]);
    for(let index = 1; index < paths.length; index++){
        const start = $da7bbf79b162d05c$var$getStart(paths[index]);
        if (!(0, $2edc1eef02a7c199$export$248d38f6296296c5)(start, lastPos)) throw new Error(`Path index ${index} does not start at prior path end. Start: ${start.x},${start.y} expected: ${lastPos.x},${lastPos.y}`);
        lastPos = $da7bbf79b162d05c$var$getEnd(paths[index]);
    }
};
var $da7bbf79b162d05c$var$toSvgString2 = (paths)=>paths.flatMap((p)=>p.toSvgString());
var $da7bbf79b162d05c$var$fromPaths = (...paths)=>{
    $da7bbf79b162d05c$var$guardContinuous(paths);
    const dims = $da7bbf79b162d05c$var$computeDimensions(paths);
    return Object.freeze({
        segments: paths,
        length: ()=>dims.totalLength,
        nearest: (_)=>{
            throw new Error(`not implemented`);
        },
        interpolate: (t, useWidth = false)=>$da7bbf79b162d05c$var$interpolate3(paths, t, useWidth, dims),
        relativePosition: (point2, intersectionThreshold)=>$da7bbf79b162d05c$var$relativePosition2(paths, point2, intersectionThreshold, dims),
        distanceToPoint: (point2)=>$da7bbf79b162d05c$var$distanceToPoint(paths, point2),
        bbox: ()=>$da7bbf79b162d05c$var$bbox4(paths),
        toString: ()=>$da7bbf79b162d05c$var$toString4(paths),
        toSvgString: ()=>$da7bbf79b162d05c$var$toSvgString2(paths),
        kind: `compound`
    });
};
// src/geometry/Ellipse.ts
var $da7bbf79b162d05c$export$b8cb64530ccf11c4 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$b8cb64530ccf11c4, {
    fromDegrees: ()=>$da7bbf79b162d05c$var$fromDegrees
});
var $da7bbf79b162d05c$var$fromDegrees = (radiusX, radiusY, rotationDeg = 0, startAngleDeg = 0, endAngleDeg = 360)=>({
        radiusX: radiusX,
        radiusY: radiusY,
        rotation: (0, $2edc1eef02a7c199$export$4f2c4f194778dcbb)(rotationDeg),
        startAngle: (0, $2edc1eef02a7c199$export$4f2c4f194778dcbb)(startAngleDeg),
        endAngle: (0, $2edc1eef02a7c199$export$4f2c4f194778dcbb)(endAngleDeg)
    });
// src/geometry/CurveSimplification.ts
var $da7bbf79b162d05c$export$c9593da9d193b09d = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$c9593da9d193b09d, {
    rdpPerpendicularDistance: ()=>$da7bbf79b162d05c$var$rdpPerpendicularDistance,
    rdpShortestDistance: ()=>$da7bbf79b162d05c$var$rdpShortestDistance
});
var $da7bbf79b162d05c$var$rdpShortestDistance = (points, epsilon = 0.1)=>{
    const firstPoint = points[0];
    const lastPoint = points.at(-1);
    if (points.length < 3) return points;
    let index = -1;
    let distribution = 0;
    for(let index_ = 1; index_ < points.length - 1; index_++){
        const cDistribution = $da7bbf79b162d05c$var$distanceFromPointToLine(points[index_], firstPoint, lastPoint);
        if (cDistribution > distribution) {
            distribution = cDistribution;
            index = index_;
        }
    }
    if (distribution > epsilon) {
        const l1 = points.slice(0, index + 1);
        const l2 = points.slice(index);
        const r1 = $da7bbf79b162d05c$var$rdpShortestDistance(l1, epsilon);
        const r2 = $da7bbf79b162d05c$var$rdpShortestDistance(l2, epsilon);
        const rs = [
            ...r1.slice(0, -1),
            ...r2
        ];
        return rs;
    } else return [
        firstPoint,
        lastPoint
    ];
};
var $da7bbf79b162d05c$var$rdpPerpendicularDistance = (points, epsilon = 0.1)=>{
    const firstPoint = points[0];
    const lastPoint = points.at(-1);
    if (points.length < 3) return points;
    let index = -1;
    let distribution = 0;
    for(let index_ = 1; index_ < points.length - 1; index_++){
        const cDistribution = $da7bbf79b162d05c$var$findPerpendicularDistance(points[index_], firstPoint, lastPoint);
        if (cDistribution > distribution) {
            distribution = cDistribution;
            index = index_;
        }
    }
    if (distribution > epsilon) {
        const l1 = points.slice(0, index + 1);
        const l2 = points.slice(index);
        const r1 = $da7bbf79b162d05c$var$rdpPerpendicularDistance(l1, epsilon);
        const r2 = $da7bbf79b162d05c$var$rdpPerpendicularDistance(l2, epsilon);
        const rs = [
            ...r1.slice(0, -1),
            ...r2
        ];
        return rs;
    } else return [
        firstPoint,
        lastPoint
    ];
};
function $da7bbf79b162d05c$var$findPerpendicularDistance(p, p1, p2) {
    let result;
    let slope2;
    let intercept;
    if (p1.x == p2.x) result = Math.abs(p.x - p1.x);
    else {
        slope2 = (p2.y - p1.y) / (p2.x - p1.x);
        intercept = p1.y - slope2 * p1.x;
        result = Math.abs(slope2 * p.x - p.y + intercept) / Math.sqrt(Math.pow(slope2, 2) + 1);
    }
    return result;
}
var $da7bbf79b162d05c$var$distanceFromPointToLine = (p, index, index_)=>{
    const lineLength = (0, $2edc1eef02a7c199$export$9f17032d917177de)(index, index_);
    if (lineLength == 0) return (0, $2edc1eef02a7c199$export$9f17032d917177de)(p, index);
    const t = ((p.x - index.x) * (index_.x - index.x) + (p.y - index.y) * (index_.y - index.y)) / lineLength;
    if (t < 0) return (0, $2edc1eef02a7c199$export$9f17032d917177de)(p, index);
    if (t > 1) return (0, $2edc1eef02a7c199$export$9f17032d917177de)(p, index_);
    return (0, $2edc1eef02a7c199$export$9f17032d917177de)(p, {
        x: index.x + t * (index_.x - index.x),
        y: index.y + t * (index_.y - index.y)
    });
};
// src/geometry/QuadTree.ts
var $da7bbf79b162d05c$export$a544ded366bdbcda = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$a544ded366bdbcda, {
    Direction: ()=>$da7bbf79b162d05c$var$Direction,
    QuadTreeNode: ()=>$da7bbf79b162d05c$var$QuadTreeNode,
    quadTree: ()=>$da7bbf79b162d05c$var$quadTree
});
var $da7bbf79b162d05c$var$Direction = /* @__PURE__ */ ((Direction2)=>{
    Direction2[Direction2["Nw"] = 0] = "Nw";
    Direction2[Direction2["Ne"] = 1] = "Ne";
    Direction2[Direction2["Sw"] = 2] = "Sw";
    Direction2[Direction2["Se"] = 3] = "Se";
    return Direction2;
})($da7bbf79b162d05c$var$Direction || {});
var $da7bbf79b162d05c$var$quadTree = (bounds, initialData = [], opts = {})=>{
    const o = {
        maxItems: opts.maxItems ?? 4,
        maxLevels: opts.maxLevels ?? 4
    };
    const n = new $da7bbf79b162d05c$var$QuadTreeNode(void 0, bounds, 0, o);
    for (const d of initialData)n.add(d);
    return n;
};
var $da7bbf79b162d05c$var$QuadTreeNode = class _QuadTreeNode {
    /**
   * Constructor
   * @param boundary
   * @param level
   * @param opts
   */ constructor(parent, boundary, level, opts){
        this.boundary = boundary;
        this.level = level;
        this.opts = opts;
        this.#parent = parent;
    }
    #items = [];
    #children = [];
    #parent;
    getLengthChildren() {
        return this.#children.length;
    }
    *parents() {
        let n = this;
        while(n.#parent !== void 0){
            yield n.#parent;
            n = n.#parent;
        }
    }
    getParent() {
        return this.#parent;
    }
    /**
   * Iterates over immediate children
   */ *children() {
        for (const c of this.#children)yield c;
    }
    /**
   * Array of QuadTreeItem
   * @returns
   */ getValue() {
        return this.#items;
    }
    getIdentity() {
        return this;
    }
    /**
   * Get a descendant node in a given direction
   * @param d
   * @returns
   */ direction(d) {
        return this.#children[d];
    }
    /**
   * Add an item to the quadtree
   * @param p
   * @returns False if item is outside of boundary, True if item was added
   */ add(p) {
        if (!$da7bbf79b162d05c$var$isIntersecting3(this.boundary, p)) return false;
        if (this.#children.length > 0) {
            for (const d of this.#children)d.add(p);
            return true;
        }
        this.#items.push(p);
        if (this.#items.length > this.opts.maxItems && this.level < this.opts.maxLevels) {
            if (this.#children.length === 0) this.#subdivide();
            for (const item of this.#items)for (const d of this.#children)d.add(item);
            this.#items = [];
        }
        return true;
    }
    /**
   * Returns true if point is inside node's boundary
   * @param p
   * @returns
   */ couldHold(p) {
        return (0, $2edc1eef02a7c199$export$5723c514448bc2af)(this.boundary, p);
    }
    #subdivide() {
        const w = this.boundary.width / 2;
        const h = this.boundary.height / 2;
        const x = this.boundary.x;
        const y = this.boundary.y;
        const coords = (0, $2edc1eef02a7c199$export$c2b110734982f150)(x + w, y, x, y, x, y + h, x + w, y + h);
        const rects = coords.map((p)=>(0, $2edc1eef02a7c199$export$ebf8d3595f30628)(p, w, h));
        this.#children = rects.map((r)=>new _QuadTreeNode(this, r, this.level + 1, this.opts));
    }
};
// src/geometry/Scaler.ts
var $da7bbf79b162d05c$export$635358aeaf898680 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$635358aeaf898680, {
    scaler: ()=>$da7bbf79b162d05c$export$392c70347f2a027f
});
var $da7bbf79b162d05c$export$392c70347f2a027f = (scaleBy = `both`, defaultRect)=>{
    const defaultBounds = defaultRect ?? $da7bbf79b162d05c$export$84712d0562a614b8;
    let sw = 1;
    let sh = 1;
    let s = {
        x: 1,
        y: 1
    };
    const computeScale = ()=>{
        switch(scaleBy){
            case `height`:
                return {
                    x: sh,
                    y: sh
                };
            case `width`:
                return {
                    x: sw,
                    y: sw
                };
            case `min`:
                return {
                    x: Math.min(sw, sh),
                    y: Math.min(sw, sh)
                };
            case `max`:
                return {
                    x: Math.max(sw, sh),
                    y: Math.max(sw, sh)
                };
            default:
                return {
                    x: sw,
                    y: sh
                };
        }
    };
    const normalise4 = (a, b, c, d)=>{
        let inX = Number.NaN;
        let inY = Number.NaN;
        let outW = defaultBounds.width;
        let outH = defaultBounds.height;
        if (typeof a === `number`) {
            inX = a;
            if (typeof b === `number`) {
                inY = b;
                if (c === void 0) return [
                    inX,
                    inY,
                    outW,
                    outH
                ];
                if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(c)) {
                    outW = c.width;
                    outH = c.height;
                } else if (typeof c === `number`) {
                    outW = c;
                    if (typeof d === `number`) outH = d;
                    else throw new TypeError(`Missing final height value`);
                } else throw new Error(`Missing valid output range`);
            } else if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(b)) {
                outW = b.width;
                outH = b.height;
            } else throw new Error(`Expected input y or output Rect to follow first number parameter`);
        } else if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a)) {
            inX = a.x;
            inY = a.y;
            if (b === void 0) return [
                inX,
                inY,
                outW,
                outH
            ];
            if ((0, $2edc1eef02a7c199$export$707a34ba392ff427)(b)) {
                outW = b.width;
                outH = b.height;
            } else if (typeof b === `number`) {
                outW = b;
                if (typeof c === `number`) outH = c;
                else throw new TypeError(`Expected height as third parameter after Point and output width`);
            } else throw new TypeError(`Expected Rect or width as second parameter when first parameter is a Point`);
        } else throw new Error(`Expected input Point or x value as first parameter`);
        return [
            inX,
            inY,
            outW,
            outH
        ];
    };
    const scaleAbs = (a, b, c, d)=>{
        const n = normalise4(a, b, c, d);
        return scaleNormalised(true, ...n);
    };
    const scaleRel = (a, b, c, d)=>{
        const n = normalise4(a, b, c, d);
        return scaleNormalised(false, ...n);
    };
    const scaleNormalised = (abs, x, y, w, h)=>{
        if (Number.isNaN(w)) throw new Error(`Output width range missing`);
        if (Number.isNaN(h)) throw new Error(`Output height range missing`);
        if (w !== sw || h !== sh) {
            sw = w;
            sh = h;
            s = computeScale();
        }
        return abs ? {
            x: x * s.x,
            y: y * s.y
        } : {
            x: x / s.x,
            y: y / s.y
        };
    };
    return {
        computeScale: computeScale,
        rel: scaleRel,
        abs: scaleAbs,
        width: defaultBounds.width,
        height: defaultBounds.height
    };
};
// src/geometry/Convolve2d.ts
var $da7bbf79b162d05c$export$c4a559353abe3b18 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$c4a559353abe3b18, {
    boxBlurKernel: ()=>$da7bbf79b162d05c$var$boxBlurKernel,
    convolve: ()=>$da7bbf79b162d05c$var$convolve,
    convolveCell: ()=>$da7bbf79b162d05c$var$convolveCell,
    convolveImage: ()=>$da7bbf79b162d05c$var$convolveImage,
    edgeDetectionKernel: ()=>$da7bbf79b162d05c$var$edgeDetectionKernel,
    gaussianBlur3Kernel: ()=>$da7bbf79b162d05c$var$gaussianBlur3Kernel,
    gaussianBlur5Kernel: ()=>$da7bbf79b162d05c$var$gaussianBlur5Kernel,
    identityKernel: ()=>$da7bbf79b162d05c$var$identityKernel,
    kernel2dToArray: ()=>$da7bbf79b162d05c$var$kernel2dToArray,
    multiply: ()=>$da7bbf79b162d05c$var$multiply4,
    rgbReducer: ()=>$da7bbf79b162d05c$var$rgbReducer,
    sharpenKernel: ()=>$da7bbf79b162d05c$var$sharpenKernel,
    unsharpMasking5Kernel: ()=>$da7bbf79b162d05c$var$unsharpMasking5Kernel
});
// src/visual/ImageDataGrid.ts
var $da7bbf79b162d05c$export$c051a4d1797a311f = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$c051a4d1797a311f, {
    accessor: ()=>$da7bbf79b162d05c$var$accessor,
    byColumn: ()=>$da7bbf79b162d05c$var$byColumn,
    byRow: ()=>$da7bbf79b162d05c$var$byRow,
    grid: ()=>$da7bbf79b162d05c$var$grid,
    setter: ()=>$da7bbf79b162d05c$var$setter,
    wrap: ()=>$da7bbf79b162d05c$var$wrap3
});
var $da7bbf79b162d05c$var$grid = (image)=>{
    const g = {
        rows: image.width,
        cols: image.height
    };
    return g;
};
var $da7bbf79b162d05c$var$wrap3 = (image)=>{
    return {
        ...$da7bbf79b162d05c$var$grid(image),
        get: $da7bbf79b162d05c$var$accessor(image),
        set: $da7bbf79b162d05c$var$setter(image)
    };
};
var $da7bbf79b162d05c$var$accessor = (image)=>{
    const g = $da7bbf79b162d05c$var$grid(image);
    const data = image.data;
    const fn = (cell, bounds = `undefined`)=>{
        const index = $da7bbf79b162d05c$var$indexFromCell(g, cell, bounds);
        if (index === void 0) return;
        const pxIndex = index * 4;
        return {
            r: data[pxIndex],
            g: data[pxIndex + 1],
            b: data[pxIndex + 2],
            opacity: data[pxIndex + 3],
            unit: `8bit`,
            space: `srgb`
        };
    };
    return fn;
};
var $da7bbf79b162d05c$var$setter = (image)=>{
    const g = $da7bbf79b162d05c$var$grid(image);
    const data = image.data;
    const fn = (value, cell, bounds = `undefined`)=>{
        const index = $da7bbf79b162d05c$var$indexFromCell(g, cell, bounds);
        if (index === void 0) throw new Error(`Cell out of range. ${cell.x},${cell.y}`);
        const pixel = (0, $8a5cbeb1c6ae1b41$export$550846ee437f5547)(value);
        const pxIndex = index * 4;
        data[pxIndex] = pixel.r;
        data[pxIndex + 1] = pixel.g;
        data[pxIndex + 2] = pixel.b;
        data[pxIndex + 3] = pixel.opacity ?? 255;
    };
    return fn;
};
function* $da7bbf79b162d05c$var$byRow(image) {
    const a = $da7bbf79b162d05c$var$accessor(image);
    const g = $da7bbf79b162d05c$var$grid(image);
    const v = $da7bbf79b162d05c$var$As_exports.rows(g, {
        x: 0,
        y: 0
    });
    for (const row of v){
        const pixels = row.map((p)=>a(p, `undefined`));
        yield pixels;
    }
}
function* $da7bbf79b162d05c$var$byColumn(image) {
    const a = $da7bbf79b162d05c$var$accessor(image);
    const g = $da7bbf79b162d05c$var$grid(image);
    for(let x = 0; x < g.cols; x++){
        const col = [];
        for(let y = 0; y < g.rows; y++){
            const p = a({
                x: x,
                y: y
            }, `undefined`);
            if (p) col.push(p);
        }
        yield col;
    }
}
// src/geometry/Convolve2d.ts
var $da7bbf79b162d05c$var$multiply4 = (kernel, scalar)=>{
    const rows2 = kernel.length;
    const cols = kernel[0].length;
    const copy = [];
    for(let row = 0; row < rows2; row++){
        copy[row] = [];
        for(let col = 0; col < cols; col++)copy[row][col] = kernel[row][col] * scalar;
    }
    return copy;
};
function $da7bbf79b162d05c$var$convolveCell(cell, kernel, source, reduce2) {
    const valuesAtKernelPos = kernel.map((o)=>{
        const pos = $da7bbf79b162d05c$var$offset(source, cell, o.cell, `stop`);
        let kernelValue;
        let sourceValue;
        if (pos) {
            sourceValue = source.get(pos, `undefined`);
            kernelValue = o.value;
        }
        return {
            cell: o.cell,
            value: sourceValue,
            kernel: o.value
        };
    });
    return reduce2(valuesAtKernelPos);
}
function* $da7bbf79b162d05c$var$convolveImage(kernel, image) {
    const imageDataAsGrid = $da7bbf79b162d05c$var$wrap3(image);
    yield* $da7bbf79b162d05c$var$convolve(kernel, imageDataAsGrid, $da7bbf79b162d05c$var$enumerators_exports.cells(imageDataAsGrid), $da7bbf79b162d05c$var$rgbReducer);
}
function* $da7bbf79b162d05c$var$convolve(kernel, source, visitor, reduce2, origin) {
    if (!origin) {
        const kernelRows = kernel.length;
        const kernelCols = kernel[0].length;
        origin = {
            x: Math.floor(kernelRows / 2),
            y: Math.floor(kernelCols / 2)
        };
    }
    const asArray = $da7bbf79b162d05c$var$kernel2dToArray(kernel, origin);
    for (const cell of visitor){
        const value = $da7bbf79b162d05c$var$convolveCell(cell, asArray, source, reduce2);
        yield {
            cell: cell,
            value: value
        };
    }
}
var $da7bbf79b162d05c$var$kernel2dToArray = (kernel, origin)=>{
    const offsets = [];
    const rows2 = kernel.length;
    const cols = kernel[0].length;
    if (!origin) origin = {
        x: Math.floor(rows2 / 2),
        y: Math.floor(cols / 2)
    };
    for(let xx = 0; xx < rows2; xx++)for(let yy = 0; yy < cols; yy++){
        const v = {
            cell: {
                x: xx - origin.x,
                y: yy - origin.y
            },
            value: kernel[xx][yy]
        };
        offsets.push(v);
    }
    return offsets;
};
var $da7bbf79b162d05c$var$rgbReducer = (values2)=>{
    let r = 0;
    let g = 0;
    let b = 0;
    let opacity = 0;
    for (const value of values2){
        const rgb = value.value;
        const kernelValue = value.kernel;
        if (!rgb) continue;
        if (rgb.opacity === 0) continue;
        if (kernelValue === 0) continue;
        r += rgb.r * kernelValue;
        g += rgb.g * kernelValue;
        b += rgb.b * kernelValue;
        opacity += (rgb.opacity ?? 1) * kernelValue;
    }
    const result = {
        r: r,
        g: g,
        b: b,
        unit: `8bit`,
        space: `srgb`,
        opacity: opacity
    };
    return result;
};
var $da7bbf79b162d05c$var$identityKernel = [
    [
        0,
        0,
        0
    ],
    [
        0,
        1,
        0
    ],
    [
        0,
        0,
        0
    ]
];
var $da7bbf79b162d05c$var$edgeDetectionKernel = [
    [
        0,
        -1,
        0
    ],
    [
        -1,
        4,
        -1
    ],
    [
        0,
        -1,
        0
    ]
];
var $da7bbf79b162d05c$var$sharpenKernel = [
    [
        0,
        -1,
        0
    ],
    [
        -1,
        5,
        -1
    ],
    [
        0,
        -1,
        0
    ]
];
var $da7bbf79b162d05c$var$boxBlurKernel = $da7bbf79b162d05c$var$multiply4([
    [
        1,
        1,
        1
    ],
    [
        1,
        1,
        1
    ],
    [
        1,
        1,
        1
    ]
], 1 / 9);
var $da7bbf79b162d05c$var$gaussianBlur3Kernel = $da7bbf79b162d05c$var$multiply4([
    [
        1,
        2,
        1
    ],
    [
        2,
        4,
        2
    ],
    [
        1,
        2,
        1
    ]
], 1 / 16);
var $da7bbf79b162d05c$var$gaussianBlur5Kernel = $da7bbf79b162d05c$var$multiply4([
    [
        1,
        4,
        6,
        4,
        1
    ],
    [
        4,
        16,
        24,
        16,
        4
    ],
    [
        6,
        24,
        36,
        24,
        6
    ],
    [
        4,
        16,
        24,
        16,
        4
    ],
    [
        1,
        4,
        6,
        4,
        1
    ]
], 1 / 256);
var $da7bbf79b162d05c$var$unsharpMasking5Kernel = $da7bbf79b162d05c$var$multiply4([
    [
        1,
        4,
        6,
        4,
        1
    ],
    [
        4,
        16,
        24,
        16,
        4
    ],
    [
        6,
        24,
        -476,
        24,
        6
    ],
    [
        4,
        16,
        24,
        16,
        4
    ],
    [
        1,
        4,
        6,
        4,
        1
    ]
], -1 / 256);
// src/geometry/arc/index.ts
var $da7bbf79b162d05c$export$eecff1bbfbd2dfdd = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$eecff1bbfbd2dfdd, {
    angularSize: ()=>$da7bbf79b162d05c$var$angularSize,
    bbox: ()=>$da7bbf79b162d05c$var$bbox5,
    distanceCenter: ()=>$da7bbf79b162d05c$var$distanceCenter2,
    fromCircle: ()=>$da7bbf79b162d05c$var$fromCircle,
    fromCircleAmount: ()=>$da7bbf79b162d05c$var$fromCircleAmount,
    fromDegrees: ()=>$da7bbf79b162d05c$var$fromDegrees2,
    getStartEnd: ()=>$da7bbf79b162d05c$var$getStartEnd,
    guard: ()=>$da7bbf79b162d05c$var$guard5,
    interpolate: ()=>$da7bbf79b162d05c$var$interpolate4,
    isArc: ()=>$da7bbf79b162d05c$var$isArc,
    isEqual: ()=>$da7bbf79b162d05c$var$isEqual6,
    isPositioned: ()=>$da7bbf79b162d05c$var$isPositioned3,
    length: ()=>$da7bbf79b162d05c$var$length3,
    point: ()=>$da7bbf79b162d05c$var$point,
    toLine: ()=>$da7bbf79b162d05c$var$toLine,
    toPath: ()=>$da7bbf79b162d05c$var$toPath3,
    toSvg: ()=>$da7bbf79b162d05c$var$toSvg2
});
var $da7bbf79b162d05c$var$isArc = (p)=>p.startRadian !== void 0 && p.endRadian !== void 0 && p.clockwise !== void 0;
var $da7bbf79b162d05c$var$isPositioned3 = (p)=>p.x !== void 0 && p.y !== void 0;
var $da7bbf79b162d05c$var$piPi4 = Math.PI * 2;
function $da7bbf79b162d05c$var$fromDegrees2(radius, startDegrees, endDegrees, clockwise, origin) {
    const a = {
        radius: radius,
        startRadian: (0, $2edc1eef02a7c199$export$4f2c4f194778dcbb)(startDegrees),
        endRadian: (0, $2edc1eef02a7c199$export$4f2c4f194778dcbb)(endDegrees),
        clockwise: clockwise
    };
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(origin)) {
        (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(origin);
        const ap = {
            ...a,
            x: origin.x,
            y: origin.y
        };
        return Object.freeze(ap);
    } else return Object.freeze(a);
}
var $da7bbf79b162d05c$var$toLine = (arc)=>(0, $3beaef080eb52aa9$export$188c3cd07b4129dd)($da7bbf79b162d05c$var$point(arc, arc.startRadian), $da7bbf79b162d05c$var$point(arc, arc.endRadian));
var $da7bbf79b162d05c$var$getStartEnd = (arc, origin)=>{
    $da7bbf79b162d05c$var$guard5(arc);
    const start = $da7bbf79b162d05c$var$point(arc, arc.startRadian, origin);
    const end = $da7bbf79b162d05c$var$point(arc, arc.endRadian, origin);
    return [
        start,
        end
    ];
};
var $da7bbf79b162d05c$var$point = (arc, angleRadian3, origin)=>{
    if (origin === void 0) origin = $da7bbf79b162d05c$var$isPositioned3(arc) ? arc : {
        x: 0,
        y: 0
    };
    return {
        x: Math.cos(angleRadian3) * arc.radius + origin.x,
        y: Math.sin(angleRadian3) * arc.radius + origin.y
    };
};
var $da7bbf79b162d05c$var$guard5 = (arc)=>{
    if (arc === void 0) throw new TypeError(`Arc is undefined`);
    if ($da7bbf79b162d05c$var$isPositioned3(arc)) (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(arc, `arc`);
    if (arc.radius === void 0) throw new TypeError(`Arc radius is undefined (${JSON.stringify(arc)})`);
    if (typeof arc.radius !== `number`) throw new TypeError(`Radius must be a number`);
    if (Number.isNaN(arc.radius)) throw new TypeError(`Radius is NaN`);
    if (arc.radius <= 0) throw new TypeError(`Radius must be greater than zero`);
    if (arc.startRadian === void 0) throw new TypeError(`Arc is missing 'startRadian' field`);
    if (arc.endRadian === void 0) throw new TypeError(`Arc is missing 'startRadian' field`);
    if (Number.isNaN(arc.endRadian)) throw new TypeError(`Arc endRadian is NaN`);
    if (Number.isNaN(arc.startRadian)) throw new TypeError(`Arc endRadian is NaN`);
    if (arc.clockwise === void 0) throw new TypeError(`Arc is missing 'clockwise field`);
    if (arc.startRadian >= arc.endRadian) throw new TypeError(`startRadian is expected to be les than endRadian`);
};
var $da7bbf79b162d05c$var$interpolate4 = (amount, arc, allowOverflow, origin)=>{
    $da7bbf79b162d05c$var$guard5(arc);
    const overflowOk = allowOverflow ?? false;
    if (!overflowOk) {
        if (amount < 0) throw new Error(`Param 'amount' is under zero, and overflow is not allowed`);
        if (amount > 1) throw new Error(`Param 'amount' is above 1 and overflow is not allowed`);
    }
    const span = $da7bbf79b162d05c$var$angularSize(arc);
    const rel = span * amount;
    const angle = (0, $2edc1eef02a7c199$export$781dc0a0f963c01e)(arc.startRadian, rel, arc.clockwise);
    return $da7bbf79b162d05c$var$point(arc, angle, origin);
};
var $da7bbf79b162d05c$var$angularSize = (arc)=>(0, $2edc1eef02a7c199$export$cfbb66a3a90db1a8)(arc.startRadian, arc.endRadian, arc.clockwise);
var $da7bbf79b162d05c$var$toPath3 = (arc)=>{
    $da7bbf79b162d05c$var$guard5(arc);
    return Object.freeze({
        ...arc,
        nearest: (point2)=>{
            throw new Error(`not implemented`);
        },
        interpolate: (amount)=>$da7bbf79b162d05c$var$interpolate4(amount, arc),
        bbox: ()=>$da7bbf79b162d05c$var$bbox5(arc),
        length: ()=>$da7bbf79b162d05c$var$length3(arc),
        toSvgString: ()=>$da7bbf79b162d05c$var$toSvg2(arc),
        relativePosition: (_point, _intersectionThreshold)=>{
            throw new Error(`Not implemented`);
        },
        distanceToPoint: (_point)=>{
            throw new Error(`Not implemented`);
        },
        kind: `arc`
    });
};
var $da7bbf79b162d05c$var$fromCircle = (circle, startRadian, endRadian, clockwise = true)=>{
    const a = Object.freeze({
        ...circle,
        endRadian: endRadian,
        startRadian: startRadian,
        clockwise: clockwise
    });
    return a;
};
var $da7bbf79b162d05c$var$fromCircleAmount = (circle, startRadian, sizeRadian, clockwise = true)=>{
    const endRadian = (0, $2edc1eef02a7c199$export$781dc0a0f963c01e)(startRadian, sizeRadian, clockwise);
    return $da7bbf79b162d05c$var$fromCircle(circle, startRadian, endRadian);
};
var $da7bbf79b162d05c$var$length3 = (arc)=>$da7bbf79b162d05c$var$piPi4 * arc.radius * ((arc.startRadian - arc.endRadian) / $da7bbf79b162d05c$var$piPi4);
var $da7bbf79b162d05c$var$bbox5 = (arc)=>{
    if ($da7bbf79b162d05c$var$isPositioned3(arc)) {
        const middle = $da7bbf79b162d05c$var$interpolate4(0.5, arc);
        const asLine = $da7bbf79b162d05c$var$toLine(arc);
        return (0, $2edc1eef02a7c199$export$bf67010aacbe66fa)(middle, asLine.a, asLine.b);
    } else return {
        width: arc.radius * 2,
        height: arc.radius * 2
    };
};
var $da7bbf79b162d05c$var$toSvg2 = (a, b, c, d, e)=>{
    if ($da7bbf79b162d05c$var$isArc(a)) {
        if ($da7bbf79b162d05c$var$isPositioned3(a)) {
            if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b)) return $da7bbf79b162d05c$var$toSvgFull2(b, a.radius, a.startRadian, a.endRadian, c);
            else return $da7bbf79b162d05c$var$toSvgFull2(a, a.radius, a.startRadian, a.endRadian, b);
        } else return (0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(b) ? $da7bbf79b162d05c$var$toSvgFull2(b, a.radius, a.startRadian, a.endRadian, c) : $da7bbf79b162d05c$var$toSvgFull2({
            x: 0,
            y: 0
        }, a.radius, a.startRadian, a.endRadian);
    } else {
        if (c === void 0) throw new Error(`startAngle undefined`);
        if (d === void 0) throw new Error(`endAngle undefined`);
        if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(a)) {
            if (typeof b === `number` && typeof c === `number` && typeof d === `number`) return $da7bbf79b162d05c$var$toSvgFull2(a, b, c, d, e);
            else throw new TypeError(`Expected (point, number, number, number). Missing a number param.`);
        } else throw new Error(`Expected (point, number, number, number). Missing first point.`);
    }
};
var $da7bbf79b162d05c$var$toSvgFull2 = (origin, radius, startRadian, endRadian, opts)=>{
    if (opts === void 0 || typeof opts !== `object`) opts = {};
    const isFullCircle = endRadian - startRadian === 360;
    const start = (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(radius, endRadian - 0.01, origin);
    const end = (0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(radius, startRadian, origin);
    const { largeArc: largeArc = false, sweep: sweep = false } = opts;
    const d = [
        `
    M ${start.x} ${start.y}
    A ${radius} ${radius} 0 ${largeArc ? `1` : `0`} ${sweep ? `1` : `0`} ${end.x} ${end.y},
  `
    ];
    if (isFullCircle) d.push(`z`);
    return d;
};
var $da7bbf79b162d05c$var$distanceCenter2 = (a, b)=>(0, $2edc1eef02a7c199$export$9f17032d917177de)(a, b);
var $da7bbf79b162d05c$var$isEqual6 = (a, b)=>{
    if (a.radius !== b.radius) return false;
    if (a.endRadian !== b.endRadian) return false;
    if (a.startRadian !== b.startRadian) return false;
    if (a.clockwise !== b.clockwise) return false;
    if ($da7bbf79b162d05c$var$isPositioned3(a) && $da7bbf79b162d05c$var$isPositioned3(b)) {
        if (a.x !== b.x) return false;
        if (a.y !== b.y) return false;
        if (a.z !== b.z) return false;
    } else if (!$da7bbf79b162d05c$var$isPositioned3(a) && !$da7bbf79b162d05c$var$isPositioned3(b)) ;
    else return false;
    return true;
};
// src/geometry/Vector.ts
var $da7bbf79b162d05c$export$19c6138bf36917b8 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$19c6138bf36917b8, {
    clampMagnitude: ()=>$da7bbf79b162d05c$var$clampMagnitude3,
    divide: ()=>$da7bbf79b162d05c$var$divide4,
    dotProduct: ()=>$da7bbf79b162d05c$var$dotProduct3,
    fromLineCartesian: ()=>$da7bbf79b162d05c$var$fromLineCartesian,
    fromLinePolar: ()=>$da7bbf79b162d05c$var$fromLinePolar,
    fromPointPolar: ()=>$da7bbf79b162d05c$var$fromPointPolar,
    fromRadians: ()=>$da7bbf79b162d05c$var$fromRadians,
    multiply: ()=>$da7bbf79b162d05c$var$multiply5,
    normalise: ()=>$da7bbf79b162d05c$var$normalise3,
    quadrantOffsetAngle: ()=>$da7bbf79b162d05c$var$quadrantOffsetAngle,
    subtract: ()=>$da7bbf79b162d05c$var$subtract4,
    sum: ()=>$da7bbf79b162d05c$var$sum4,
    toCartesian: ()=>$da7bbf79b162d05c$var$toCartesian2,
    toPolar: ()=>$da7bbf79b162d05c$var$toPolar,
    toRadians: ()=>$da7bbf79b162d05c$var$toRadians,
    toString: ()=>$da7bbf79b162d05c$var$toString5
});
var $da7bbf79b162d05c$var$EmptyCartesian = Object.freeze({
    x: 0,
    y: 0
});
var $da7bbf79b162d05c$var$piPi5 = Math.PI * 2;
var $da7bbf79b162d05c$var$pi = Math.PI;
var $da7bbf79b162d05c$var$fromRadians = (radians)=>{
    return Object.freeze({
        x: Math.cos(radians),
        y: Math.sin(radians)
    });
};
var $da7bbf79b162d05c$var$toRadians = (point2)=>{
    return Math.atan2(point2.y, point2.x);
};
var $da7bbf79b162d05c$var$fromPointPolar = (pt, angleNormalisation = ``, origin = $da7bbf79b162d05c$var$EmptyCartesian)=>{
    pt = (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(pt, origin);
    let direction = Math.atan2(pt.y, pt.x);
    if (angleNormalisation === `unipolar` && direction < 0) direction += $da7bbf79b162d05c$var$piPi5;
    else if (angleNormalisation === `bipolar`) {
        if (direction > $da7bbf79b162d05c$var$pi) direction -= $da7bbf79b162d05c$var$piPi5;
        else if (direction <= -$da7bbf79b162d05c$var$pi) direction += $da7bbf79b162d05c$var$piPi5;
    }
    return Object.freeze({
        distance: (0, $2edc1eef02a7c199$export$9f17032d917177de)(pt),
        angleRadian: direction
    });
};
var $da7bbf79b162d05c$var$fromLineCartesian = (line)=>(0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(line.b, line.a);
var $da7bbf79b162d05c$var$fromLinePolar = (line)=>{
    (0, $2edc1eef02a7c199$export$c1206aca6ae0febb)(line, `line`);
    const pt = (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(line.b, line.a);
    return $da7bbf79b162d05c$var$fromPointPolar(pt);
};
var $da7bbf79b162d05c$var$isPolar = (v)=>{
    if ((0, $2edc1eef02a7c199$export$9517f709836def0c)(v)) return true;
    return false;
};
var $da7bbf79b162d05c$var$isCartesian = (v)=>{
    if ((0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(v)) return true;
    return false;
};
var $da7bbf79b162d05c$var$normalise3 = (v)=>{
    if ($da7bbf79b162d05c$var$isPolar(v)) return (0, $2edc1eef02a7c199$export$d07f4a5006fe85de)(v);
    else if ($da7bbf79b162d05c$var$isCartesian(v)) return (0, $2edc1eef02a7c199$export$40f4ec979313550f)(v);
    throw new Error(`Expected polar/cartesian vector. Got: ${v}`);
};
var $da7bbf79b162d05c$var$quadrantOffsetAngle = (p)=>{
    if (p.x >= 0 && p.y >= 0) return 0;
    if (p.x < 0 && p.y >= 0) return $da7bbf79b162d05c$var$pi;
    if (p.x < 0 && p.y < 0) return $da7bbf79b162d05c$var$pi;
    return $da7bbf79b162d05c$var$piPi5;
};
var $da7bbf79b162d05c$var$toPolar = (v, origin = (0, $2edc1eef02a7c199$export$1f74963c34e8bfec))=>{
    if ($da7bbf79b162d05c$var$isPolar(v)) return v;
    else if ($da7bbf79b162d05c$var$isCartesian(v)) return (0, $2edc1eef02a7c199$export$42bfa0bfc1a1a94)(v, origin);
    throw new Error(`Expected polar/cartesian vector. Got: ${v}`);
};
var $da7bbf79b162d05c$var$toCartesian2 = (v)=>{
    if ($da7bbf79b162d05c$var$isPolar(v)) return (0, $2edc1eef02a7c199$export$b63cca88ddc558a9)(v);
    else if ($da7bbf79b162d05c$var$isCartesian(v)) return v;
    throw new Error(`Expected polar/cartesian vector. Got: ${v}`);
};
var $da7bbf79b162d05c$var$toString5 = (v, digits)=>{
    if ($da7bbf79b162d05c$var$isPolar(v)) return (0, $2edc1eef02a7c199$export$f84e8e69fd4488a5)(v, digits);
    else if ($da7bbf79b162d05c$var$isCartesian(v)) return (0, $2edc1eef02a7c199$export$eaaba333dd67ec2a)(v, digits);
    throw new Error(`Expected polar/cartesian vector. Got: ${v}`);
};
var $da7bbf79b162d05c$var$dotProduct3 = (a, b)=>{
    if ($da7bbf79b162d05c$var$isPolar(a) && $da7bbf79b162d05c$var$isPolar(b)) return (0, $2edc1eef02a7c199$export$cb831202f517eedd)(a, b);
    else if ($da7bbf79b162d05c$var$isCartesian(a) && $da7bbf79b162d05c$var$isCartesian(b)) return (0, $2edc1eef02a7c199$export$2dfa5a136446eaca)(a, b);
    throw new Error(`Expected two polar/Cartesian vectors.`);
};
var $da7bbf79b162d05c$var$clampMagnitude3 = (v, max = 1, min = 0)=>{
    if ($da7bbf79b162d05c$var$isPolar(v)) return (0, $2edc1eef02a7c199$export$ca9febc7c1cba526)(v, max, min);
    else if ($da7bbf79b162d05c$var$isCartesian(v)) return (0, $2edc1eef02a7c199$export$1552ac3ebb4a79b7)(v, max, min);
    throw new Error(`Expected either polar or Cartesian vector`);
};
var $da7bbf79b162d05c$var$sum4 = (a, b)=>{
    const polar = $da7bbf79b162d05c$var$isPolar(a);
    a = $da7bbf79b162d05c$var$toCartesian2(a);
    b = $da7bbf79b162d05c$var$toCartesian2(b);
    const c = (0, $2edc1eef02a7c199$export$97b149eb05063bd8)(a, b);
    return polar ? $da7bbf79b162d05c$var$toPolar(c) : c;
};
var $da7bbf79b162d05c$var$subtract4 = (a, b)=>{
    const polar = $da7bbf79b162d05c$var$isPolar(a);
    a = $da7bbf79b162d05c$var$toCartesian2(a);
    b = $da7bbf79b162d05c$var$toCartesian2(b);
    const c = (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(a, b);
    return polar ? $da7bbf79b162d05c$var$toPolar(c) : c;
};
var $da7bbf79b162d05c$var$multiply5 = (a, b)=>{
    const polar = $da7bbf79b162d05c$var$isPolar(a);
    a = $da7bbf79b162d05c$var$toCartesian2(a);
    b = $da7bbf79b162d05c$var$toCartesian2(b);
    const c = (0, $2edc1eef02a7c199$export$2060d2db72cce88f)(a, b);
    return polar ? $da7bbf79b162d05c$var$toPolar(c) : c;
};
var $da7bbf79b162d05c$var$divide4 = (a, b)=>{
    const polar = $da7bbf79b162d05c$var$isPolar(a);
    a = $da7bbf79b162d05c$var$toCartesian2(a);
    b = $da7bbf79b162d05c$var$toCartesian2(b);
    const c = (0, $2edc1eef02a7c199$export$cd007d971a5a2143)(a, b);
    return polar ? $da7bbf79b162d05c$var$toPolar(c) : c;
};
// src/geometry/SurfacePoints.ts
var $da7bbf79b162d05c$export$cd2417363469b959 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$cd2417363469b959, {
    circleRings: ()=>$da7bbf79b162d05c$var$circleRings,
    circleVogelSpiral: ()=>$da7bbf79b162d05c$var$circleVogelSpiral,
    sphereFibonacci: ()=>$da7bbf79b162d05c$var$sphereFibonacci
});
var $da7bbf79b162d05c$var$cos = Math.cos;
var $da7bbf79b162d05c$var$sin = Math.sin;
var $da7bbf79b162d05c$var$asin = Math.asin;
var $da7bbf79b162d05c$var$sqrt = Math.sqrt;
var $da7bbf79b162d05c$var$pow = Math.pow;
var $da7bbf79b162d05c$var$pi2 = Math.PI;
var $da7bbf79b162d05c$var$piPi6 = Math.PI * 2;
var $da7bbf79b162d05c$var$goldenAngle = $da7bbf79b162d05c$var$pi2 * (3 - $da7bbf79b162d05c$var$sqrt(5));
var $da7bbf79b162d05c$var$goldenSection = (1 + $da7bbf79b162d05c$var$sqrt(5)) / 2;
function* $da7bbf79b162d05c$var$circleVogelSpiral(circle, opts = {}) {
    const maxPoints = opts.maxPoints ?? 5e3;
    const density = opts.density ?? 0.95;
    const rotationOffset = opts.rotation ?? 0;
    const c = $da7bbf79b162d05c$var$toPositioned(circle ?? {
        radius: 1,
        x: 0,
        y: 0
    });
    const max = c.radius;
    let spacing = c.radius * (0, $8a5cbeb1c6ae1b41$export$dcdf75081b88279d)(density, 0, 1, 0.3, 0.01);
    if (opts.spacing) spacing = opts.spacing;
    let radius = 0;
    let count = 0;
    let angle = 0;
    while(count < maxPoints && radius < max){
        radius = spacing * count ** 0.5;
        angle = rotationOffset + count * 2 * $da7bbf79b162d05c$var$pi2 / $da7bbf79b162d05c$var$goldenSection;
        yield Object.freeze({
            x: c.x + radius * $da7bbf79b162d05c$var$cos(angle),
            y: c.y + radius * $da7bbf79b162d05c$var$sin(angle)
        });
        count++;
    }
}
function* $da7bbf79b162d05c$var$circleRings(circle, opts = {}) {
    const rings = opts.rings ?? 5;
    const c = $da7bbf79b162d05c$var$toPositioned(circle ?? {
        radius: 1,
        x: 0,
        y: 0
    });
    const ringR = 1 / rings;
    const rotationOffset = opts.rotation ?? 0;
    let ringCount = 1;
    yield Object.freeze({
        x: c.x,
        y: c.y
    });
    for(let r = ringR; r <= 1; r += ringR){
        const n = Math.round($da7bbf79b162d05c$var$pi2 / $da7bbf79b162d05c$var$asin(1 / (2 * ringCount)));
        for (const theta of (0, $abbd9d7515dff109$export$421842365e70382c)(0, $da7bbf79b162d05c$var$piPi6, n + 1))yield Object.freeze({
            x: c.x + r * $da7bbf79b162d05c$var$cos(theta + rotationOffset) * c.radius,
            y: c.y + r * $da7bbf79b162d05c$var$sin(theta + rotationOffset) * c.radius
        });
        ringCount++;
    }
}
function* $da7bbf79b162d05c$var$sphereFibonacci(samples = 100, rotationRadians = 0, sphere) {
    const offset2 = 2 / samples;
    const s = sphere ?? {
        x: 0,
        y: 0,
        z: 0,
        radius: 1
    };
    for(let index = 0; index < samples; index++){
        const y = index * offset2 - 1 + offset2 / 2;
        const r = $da7bbf79b162d05c$var$sqrt(1 - $da7bbf79b162d05c$var$pow(y, 2));
        const a = (index + 1) % samples * $da7bbf79b162d05c$var$goldenAngle + rotationRadians;
        const x = $da7bbf79b162d05c$var$cos(a) * r;
        const z = $da7bbf79b162d05c$var$sin(a) * r;
        yield Object.freeze({
            x: s.x + x * s.radius,
            y: s.y + y * s.radius,
            z: s.z + z * s.radius
        });
    }
}
// src/geometry/triangle/index.ts
var $da7bbf79b162d05c$export$295ac55e84320fb3 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$export$295ac55e84320fb3, {
    Empty: ()=>$da7bbf79b162d05c$var$Empty4,
    Equilateral: ()=>$da7bbf79b162d05c$var$Equilateral_exports,
    Isosceles: ()=>$da7bbf79b162d05c$var$Isosceles_exports,
    Placeholder: ()=>$da7bbf79b162d05c$var$Placeholder3,
    Right: ()=>$da7bbf79b162d05c$var$Right_exports,
    angles: ()=>$da7bbf79b162d05c$var$angles,
    anglesDegrees: ()=>$da7bbf79b162d05c$var$anglesDegrees,
    apply: ()=>$da7bbf79b162d05c$var$apply2,
    area: ()=>$da7bbf79b162d05c$var$area3,
    barycentricCoord: ()=>$da7bbf79b162d05c$var$barycentricCoord,
    barycentricToCartestian: ()=>$da7bbf79b162d05c$var$barycentricToCartestian,
    bbox: ()=>$da7bbf79b162d05c$var$bbox6,
    centroid: ()=>$da7bbf79b162d05c$var$centroid,
    corners: ()=>$da7bbf79b162d05c$export$16c38b1c25c91ba,
    edges: ()=>$da7bbf79b162d05c$var$edges2,
    equilateralFromVertex: ()=>$da7bbf79b162d05c$var$equilateralFromVertex,
    fromFlatArray: ()=>$da7bbf79b162d05c$var$fromFlatArray2,
    fromPoints: ()=>$da7bbf79b162d05c$var$fromPoints3,
    fromRadius: ()=>$da7bbf79b162d05c$var$fromRadius,
    guard: ()=>$da7bbf79b162d05c$var$guard6,
    innerCircle: ()=>$da7bbf79b162d05c$var$innerCircle,
    intersectsPoint: ()=>$da7bbf79b162d05c$var$intersectsPoint2,
    isAcute: ()=>$da7bbf79b162d05c$var$isAcute,
    isEmpty: ()=>$da7bbf79b162d05c$var$isEmpty4,
    isEqual: ()=>$da7bbf79b162d05c$var$isEqual7,
    isEquilateral: ()=>$da7bbf79b162d05c$var$isEquilateral,
    isIsosceles: ()=>$da7bbf79b162d05c$var$isIsosceles,
    isOblique: ()=>$da7bbf79b162d05c$var$isOblique,
    isObtuse: ()=>$da7bbf79b162d05c$var$isObtuse,
    isPlaceholder: ()=>$da7bbf79b162d05c$var$isPlaceholder4,
    isRightAngle: ()=>$da7bbf79b162d05c$var$isRightAngle,
    isTriangle: ()=>$da7bbf79b162d05c$var$isTriangle,
    lengths: ()=>$da7bbf79b162d05c$var$lengths2,
    outerCircle: ()=>$da7bbf79b162d05c$var$outerCircle,
    perimeter: ()=>$da7bbf79b162d05c$var$perimeter,
    rotate: ()=>$da7bbf79b162d05c$var$rotate3,
    rotateByVertex: ()=>$da7bbf79b162d05c$var$rotateByVertex,
    toFlatArray: ()=>$da7bbf79b162d05c$var$toFlatArray2
});
// src/geometry/triangle/Guard.ts
var $da7bbf79b162d05c$var$guard6 = (t, name = `t`)=>{
    if (t === void 0) throw new Error(`{$name} undefined`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(t.a, name + `.a`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(t.b, name + `.b`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(t.c, name + `.c`);
};
// src/geometry/triangle/Edges.ts
var $da7bbf79b162d05c$var$edges2 = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    return $da7bbf79b162d05c$export$9e1b37f7e15343fa(t.a, t.b, t.c, t.a);
};
// src/geometry/triangle/Area.ts
var $da7bbf79b162d05c$var$area3 = (t)=>{
    $da7bbf79b162d05c$var$guard6(t, `t`);
    const lengths3 = $da7bbf79b162d05c$var$edges2(t).map((l)=>(0, $2edc1eef02a7c199$export$f24224f1c91d8156)(l));
    const p = (lengths3[0] + lengths3[1] + lengths3[2]) / 2;
    return Math.sqrt(p * (p - lengths3[0]) * (p - lengths3[1]) * (p - lengths3[2]));
};
// src/geometry/triangle/Centroid.ts
var $da7bbf79b162d05c$var$centroid = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    const total = (0, $2edc1eef02a7c199$export$45ce22197e959b90)([
        t.a,
        t.b,
        t.c
    ], (p, accumulator)=>({
            x: p.x + accumulator.x,
            y: p.y + accumulator.y
        }));
    const div = {
        x: total.x / 3,
        y: total.y / 3
    };
    return div;
};
// src/geometry/triangle/Perimeter.ts
var $da7bbf79b162d05c$var$perimeter = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    return $da7bbf79b162d05c$var$edges2(t).reduce((accumulator, v)=>accumulator + (0, $2edc1eef02a7c199$export$f24224f1c91d8156)(v), 0);
};
// src/geometry/triangle/InnerCircle.ts
var $da7bbf79b162d05c$var$innerCircle = (t)=>{
    const c = $da7bbf79b162d05c$var$centroid(t);
    const p = $da7bbf79b162d05c$var$perimeter(t) / 2;
    const a = $da7bbf79b162d05c$var$area3(t);
    const radius = a / p;
    return {
        radius: radius,
        ...c
    };
};
// src/geometry/triangle/OuterCircle.ts
var $da7bbf79b162d05c$var$outerCircle = (t)=>{
    const [a, b, c] = $da7bbf79b162d05c$var$edges2(t).map((l)=>(0, $2edc1eef02a7c199$export$f24224f1c91d8156)(l));
    const cent = $da7bbf79b162d05c$var$centroid(t);
    const radius = a * b * c / Math.sqrt((a + b + c) * (-a + b + c) * (a - b + c) * (a + b - c));
    return {
        radius: radius,
        ...cent
    };
};
// src/geometry/triangle/Rotate.ts
var $da7bbf79b162d05c$var$rotate3 = (triangle, amountRadian, origin)=>{
    if (amountRadian === void 0 || amountRadian === 0) return triangle;
    if (origin === void 0) origin = $da7bbf79b162d05c$var$centroid(triangle);
    return Object.freeze({
        ...triangle,
        a: (0, $2edc1eef02a7c199$export$bb628a54ab399bc9)(triangle.a, amountRadian, origin),
        b: (0, $2edc1eef02a7c199$export$bb628a54ab399bc9)(triangle.b, amountRadian, origin),
        c: (0, $2edc1eef02a7c199$export$bb628a54ab399bc9)(triangle.c, amountRadian, origin)
    });
};
var $da7bbf79b162d05c$var$rotateByVertex = (triangle, amountRadian, vertex = `b`)=>{
    const origin = vertex === `a` ? triangle.a : vertex === `b` ? triangle.b : triangle.c;
    return Object.freeze({
        a: (0, $2edc1eef02a7c199$export$bb628a54ab399bc9)(triangle.a, amountRadian, origin),
        b: (0, $2edc1eef02a7c199$export$bb628a54ab399bc9)(triangle.b, amountRadian, origin),
        c: (0, $2edc1eef02a7c199$export$bb628a54ab399bc9)(triangle.c, amountRadian, origin)
    });
};
// src/geometry/triangle/Equilateral.ts
var $da7bbf79b162d05c$var$Equilateral_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$Equilateral_exports, {
    area: ()=>$da7bbf79b162d05c$var$area4,
    centerFromA: ()=>$da7bbf79b162d05c$var$centerFromA,
    centerFromB: ()=>$da7bbf79b162d05c$var$centerFromB,
    centerFromC: ()=>$da7bbf79b162d05c$var$centerFromC,
    circumcircle: ()=>$da7bbf79b162d05c$var$circumcircle,
    fromCenter: ()=>$da7bbf79b162d05c$var$fromCenter2,
    height: ()=>$da7bbf79b162d05c$var$height,
    incircle: ()=>$da7bbf79b162d05c$var$incircle,
    perimeter: ()=>$da7bbf79b162d05c$var$perimeter2
});
var $da7bbf79b162d05c$var$pi4over3 = Math.PI * 4 / 3;
var $da7bbf79b162d05c$var$pi2over3 = Math.PI * 2 / 3;
var $da7bbf79b162d05c$var$resolveLength = (t)=>{
    if (typeof t === `number`) return t;
    return t.length;
};
var $da7bbf79b162d05c$var$fromCenter2 = (t, origin, rotationRad)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const r = $da7bbf79b162d05c$var$resolveLength(t) / Math.sqrt(3);
    const rot = rotationRad ?? Math.PI * 1.5;
    const b = {
        x: r * Math.cos(rot) + origin.x,
        y: r * Math.sin(rot) + origin.y
    };
    const a = {
        x: r * Math.cos(rot + $da7bbf79b162d05c$var$pi4over3) + origin.x,
        y: r * Math.sin(rot + $da7bbf79b162d05c$var$pi4over3) + origin.y
    };
    const c = {
        x: r * Math.cos(rot + $da7bbf79b162d05c$var$pi2over3) + origin.x,
        y: r * Math.sin(rot + $da7bbf79b162d05c$var$pi2over3) + origin.y
    };
    return Object.freeze({
        a: a,
        b: b,
        c: c
    });
};
var $da7bbf79b162d05c$var$centerFromA = (t, ptA)=>{
    if (!ptA) ptA = Object.freeze({
        x: 0,
        y: 0
    });
    const r = $da7bbf79b162d05c$var$resolveLength(t);
    const { radius: radius } = $da7bbf79b162d05c$var$incircle(t);
    return {
        x: ptA.x + r / 2,
        y: ptA.y - radius
    };
};
var $da7bbf79b162d05c$var$centerFromB = (t, ptB)=>{
    if (!ptB) ptB = Object.freeze({
        x: 0,
        y: 0
    });
    const { radius: radius } = $da7bbf79b162d05c$var$incircle(t);
    return {
        x: ptB.x,
        y: ptB.y + radius * 2
    };
};
var $da7bbf79b162d05c$var$centerFromC = (t, ptC)=>{
    if (!ptC) ptC = Object.freeze({
        x: 0,
        y: 0
    });
    const r = $da7bbf79b162d05c$var$resolveLength(t);
    const { radius: radius } = $da7bbf79b162d05c$var$incircle(t);
    return {
        x: ptC.x - r / 2,
        y: ptC.y - radius
    };
};
var $da7bbf79b162d05c$var$height = (t)=>Math.sqrt(3) / 2 * $da7bbf79b162d05c$var$resolveLength(t);
var $da7bbf79b162d05c$var$perimeter2 = (t)=>$da7bbf79b162d05c$var$resolveLength(t) * 3;
var $da7bbf79b162d05c$var$area4 = (t)=>Math.pow($da7bbf79b162d05c$var$resolveLength(t), 2) * Math.sqrt(3) / 4;
var $da7bbf79b162d05c$var$circumcircle = (t)=>({
        radius: Math.sqrt(3) / 3 * $da7bbf79b162d05c$var$resolveLength(t)
    });
var $da7bbf79b162d05c$var$incircle = (t)=>({
        radius: Math.sqrt(3) / 6 * $da7bbf79b162d05c$var$resolveLength(t)
    });
// src/geometry/triangle/Right.ts
var $da7bbf79b162d05c$var$Right_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$Right_exports, {
    adjacentFromHypotenuse: ()=>$da7bbf79b162d05c$var$adjacentFromHypotenuse,
    adjacentFromOpposite: ()=>$da7bbf79b162d05c$var$adjacentFromOpposite,
    angleAtPointA: ()=>$da7bbf79b162d05c$var$angleAtPointA,
    angleAtPointB: ()=>$da7bbf79b162d05c$var$angleAtPointB,
    area: ()=>$da7bbf79b162d05c$var$area5,
    circumcircle: ()=>$da7bbf79b162d05c$var$circumcircle2,
    fromA: ()=>$da7bbf79b162d05c$var$fromA,
    fromB: ()=>$da7bbf79b162d05c$var$fromB,
    fromC: ()=>$da7bbf79b162d05c$var$fromC,
    height: ()=>$da7bbf79b162d05c$var$height2,
    hypotenuseFromAdjacent: ()=>$da7bbf79b162d05c$var$hypotenuseFromAdjacent,
    hypotenuseFromOpposite: ()=>$da7bbf79b162d05c$var$hypotenuseFromOpposite,
    hypotenuseSegments: ()=>$da7bbf79b162d05c$var$hypotenuseSegments,
    incircle: ()=>$da7bbf79b162d05c$var$incircle2,
    medians: ()=>$da7bbf79b162d05c$var$medians,
    oppositeFromAdjacent: ()=>$da7bbf79b162d05c$var$oppositeFromAdjacent,
    oppositeFromHypotenuse: ()=>$da7bbf79b162d05c$var$oppositeFromHypotenuse,
    perimeter: ()=>$da7bbf79b162d05c$var$perimeter3,
    resolveLengths: ()=>$da7bbf79b162d05c$var$resolveLengths
});
var $da7bbf79b162d05c$var$fromA = (t, origin)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    const seg = $da7bbf79b162d05c$var$hypotenuseSegments(t);
    const h = $da7bbf79b162d05c$var$height2(t);
    const a = {
        x: origin.x,
        y: origin.y
    };
    const b = {
        x: origin.x + tt.hypotenuse,
        y: origin.y
    };
    const c = {
        x: origin.x + seg[1],
        y: origin.y - h
    };
    return {
        a: a,
        b: b,
        c: c
    };
};
var $da7bbf79b162d05c$var$fromB = (t, origin)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    const seg = $da7bbf79b162d05c$var$hypotenuseSegments(t);
    const h = $da7bbf79b162d05c$var$height2(t);
    const b = {
        x: origin.x,
        y: origin.y
    };
    const a = {
        x: origin.x - tt.hypotenuse,
        y: origin.y
    };
    const c = {
        x: origin.x - seg[0],
        y: origin.y - h
    };
    return {
        a: a,
        b: b,
        c: c
    };
};
var $da7bbf79b162d05c$var$fromC = (t, origin)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const seg = $da7bbf79b162d05c$var$hypotenuseSegments(t);
    const h = $da7bbf79b162d05c$var$height2(t);
    const c = {
        x: origin.x,
        y: origin.y
    };
    const a = {
        x: origin.x - seg[1],
        y: origin.y + h
    };
    const b = {
        x: origin.x + seg[0],
        y: origin.y + h
    };
    return {
        a: a,
        b: b,
        c: c
    };
};
var $da7bbf79b162d05c$var$resolveLengths = (t)=>{
    const a = t.adjacent;
    const o = t.opposite;
    const h = t.hypotenuse;
    if (a !== void 0 && o !== void 0) return {
        ...t,
        adjacent: a,
        opposite: o,
        hypotenuse: Math.hypot(a, o)
    };
    else if (a && h) return {
        ...t,
        adjacent: a,
        hypotenuse: h,
        opposite: h * h - a * a
    };
    else if (o && h) return {
        ...t,
        hypotenuse: h,
        opposite: o,
        adjacent: h * h - o * o
    };
    else if (t.opposite && t.hypotenuse && t.adjacent) return t;
    throw new Error(`Missing at least two edges`);
};
var $da7bbf79b162d05c$var$height2 = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    const p = tt.opposite * tt.opposite / tt.hypotenuse;
    const q = tt.adjacent * tt.adjacent / tt.hypotenuse;
    return Math.sqrt(p * q);
};
var $da7bbf79b162d05c$var$hypotenuseSegments = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    const p = tt.opposite * tt.opposite / tt.hypotenuse;
    const q = tt.adjacent * tt.adjacent / tt.hypotenuse;
    return [
        p,
        q
    ];
};
var $da7bbf79b162d05c$var$perimeter3 = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    return tt.adjacent + tt.hypotenuse + tt.opposite;
};
var $da7bbf79b162d05c$var$area5 = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    return tt.opposite * tt.adjacent / 2;
};
var $da7bbf79b162d05c$var$angleAtPointA = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    return Math.acos((tt.adjacent * tt.adjacent + tt.hypotenuse * tt.hypotenuse - tt.opposite * tt.opposite) / (2 * tt.adjacent * tt.hypotenuse));
};
var $da7bbf79b162d05c$var$angleAtPointB = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    return Math.acos((tt.opposite * tt.opposite + tt.hypotenuse * tt.hypotenuse - tt.adjacent * tt.adjacent) / (2 * tt.opposite * tt.hypotenuse));
};
var $da7bbf79b162d05c$var$medians = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    const b = tt.adjacent * tt.adjacent;
    const c = tt.hypotenuse * tt.hypotenuse;
    const a = tt.opposite * tt.opposite;
    return [
        Math.sqrt(2 * (b + c) - a) / 2,
        Math.sqrt(2 * (c + a) - b) / 2,
        Math.sqrt(2 * (a + b) - c) / 2
    ];
};
var $da7bbf79b162d05c$var$circumcircle2 = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    return {
        radius: tt.hypotenuse / 2
    };
};
var $da7bbf79b162d05c$var$incircle2 = (t)=>{
    const tt = $da7bbf79b162d05c$var$resolveLengths(t);
    return {
        radius: (tt.adjacent + tt.opposite - tt.hypotenuse) / 2
    };
};
var $da7bbf79b162d05c$var$oppositeFromAdjacent = (angleRad, adjacent)=>Math.tan(angleRad) * adjacent;
var $da7bbf79b162d05c$var$oppositeFromHypotenuse = (angleRad, hypotenuse)=>Math.sin(angleRad) * hypotenuse;
var $da7bbf79b162d05c$var$adjacentFromHypotenuse = (angleRadian3, hypotenuse)=>Math.cos(angleRadian3) * hypotenuse;
var $da7bbf79b162d05c$var$adjacentFromOpposite = (angleRadian3, opposite)=>opposite / Math.tan(angleRadian3);
var $da7bbf79b162d05c$var$hypotenuseFromOpposite = (angleRadian3, opposite)=>opposite / Math.sin(angleRadian3);
var $da7bbf79b162d05c$var$hypotenuseFromAdjacent = (angleRadian3, adjacent)=>adjacent / Math.cos(angleRadian3);
// src/geometry/triangle/Isosceles.ts
var $da7bbf79b162d05c$var$Isosceles_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($da7bbf79b162d05c$var$Isosceles_exports, {
    apexAngle: ()=>$da7bbf79b162d05c$var$apexAngle,
    area: ()=>$da7bbf79b162d05c$var$area6,
    baseAngle: ()=>$da7bbf79b162d05c$var$baseAngle,
    circumcircle: ()=>$da7bbf79b162d05c$var$circumcircle3,
    fromA: ()=>$da7bbf79b162d05c$var$fromA2,
    fromB: ()=>$da7bbf79b162d05c$var$fromB2,
    fromC: ()=>$da7bbf79b162d05c$var$fromC2,
    fromCenter: ()=>$da7bbf79b162d05c$var$fromCenter3,
    height: ()=>$da7bbf79b162d05c$var$height3,
    incircle: ()=>$da7bbf79b162d05c$var$incircle3,
    legHeights: ()=>$da7bbf79b162d05c$var$legHeights,
    medians: ()=>$da7bbf79b162d05c$var$medians2,
    perimeter: ()=>$da7bbf79b162d05c$var$perimeter4
});
var $da7bbf79b162d05c$var$baseAngle = (t)=>Math.acos(t.base / (2 * t.legs));
var $da7bbf79b162d05c$var$apexAngle = (t)=>{
    const aa = t.legs * t.legs;
    const cc = t.base * t.base;
    return Math.acos((2 * aa - cc) / (2 * aa));
};
var $da7bbf79b162d05c$var$height3 = (t)=>{
    const aa = t.legs * t.legs;
    const cc = t.base * t.base;
    return Math.sqrt((4 * aa - cc) / 4);
};
var $da7bbf79b162d05c$var$legHeights = (t)=>{
    const b = $da7bbf79b162d05c$var$baseAngle(t);
    return t.base * Math.sin(b);
};
var $da7bbf79b162d05c$var$perimeter4 = (t)=>2 * t.legs + t.base;
var $da7bbf79b162d05c$var$area6 = (t)=>{
    const h = $da7bbf79b162d05c$var$height3(t);
    return h * t.base / 2;
};
var $da7bbf79b162d05c$var$circumcircle3 = (t)=>{
    const h = $da7bbf79b162d05c$var$height3(t);
    const hh = h * h;
    const cc = t.base * t.base;
    return {
        radius: (4 * hh + cc) / (8 * h)
    };
};
var $da7bbf79b162d05c$var$incircle3 = (t)=>{
    const h = $da7bbf79b162d05c$var$height3(t);
    return {
        radius: t.base * h / (2 * t.legs + t.base)
    };
};
var $da7bbf79b162d05c$var$medians2 = (t)=>{
    const aa = t.legs * t.legs;
    const cc = t.base * t.base;
    const medianAB = Math.sqrt(aa + 2 * cc) / 2;
    const medianC = Math.sqrt(4 * aa - cc) / 2;
    return [
        medianAB,
        medianAB,
        medianC
    ];
};
var $da7bbf79b162d05c$var$fromCenter3 = (t, origin)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const h = $da7bbf79b162d05c$var$height3(t);
    const incircleR = $da7bbf79b162d05c$var$incircle3(t).radius;
    const verticalToApex = h - incircleR;
    const a = {
        x: origin.x - t.base / 2,
        y: origin.y + incircleR
    };
    const b = {
        x: origin.x + t.base / 2,
        y: origin.y + incircleR
    };
    const c = {
        x: origin.x,
        y: origin.y - verticalToApex
    };
    return {
        a: a,
        b: b,
        c: c
    };
};
var $da7bbf79b162d05c$var$fromA2 = (t, origin)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const h = $da7bbf79b162d05c$var$height3(t);
    const a = {
        x: origin.x,
        y: origin.y
    };
    const b = {
        x: origin.x + t.base,
        y: origin.y
    };
    const c = {
        x: origin.x + t.base / 2,
        y: origin.y - h
    };
    return {
        a: a,
        b: b,
        c: c
    };
};
var $da7bbf79b162d05c$var$fromB2 = (t, origin)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const h = $da7bbf79b162d05c$var$height3(t);
    const b = {
        x: origin.x,
        y: origin.y
    };
    const a = {
        x: origin.x - t.base,
        y: origin.y
    };
    const c = {
        x: origin.x - t.base / 2,
        y: origin.y - h
    };
    return {
        a: a,
        b: b,
        c: c
    };
};
var $da7bbf79b162d05c$var$fromC2 = (t, origin)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const h = $da7bbf79b162d05c$var$height3(t);
    const c = {
        x: origin.x,
        y: origin.y
    };
    const a = {
        x: origin.x - t.base / 2,
        y: origin.y + h
    };
    const b = {
        x: origin.x + t.base / 2,
        y: origin.y + h
    };
    return {
        a: a,
        b: b,
        c: c
    };
};
// src/geometry/triangle/index.ts
var $da7bbf79b162d05c$var$piPi7 = Math.PI * 2;
var $da7bbf79b162d05c$var$Empty4 = Object.freeze({
    a: {
        x: 0,
        y: 0
    },
    b: {
        x: 0,
        y: 0
    },
    c: {
        x: 0,
        y: 0
    }
});
var $da7bbf79b162d05c$var$Placeholder3 = Object.freeze({
    a: {
        x: Number.NaN,
        y: Number.NaN
    },
    b: {
        x: Number.NaN,
        y: Number.NaN
    },
    c: {
        x: Number.NaN,
        y: Number.NaN
    }
});
var $da7bbf79b162d05c$var$isEmpty4 = (t)=>(0, $8a5cbeb1c6ae1b41$export$dd1bc94b04021eeb)(t.a) && (0, $8a5cbeb1c6ae1b41$export$dd1bc94b04021eeb)(t.b) && (0, $8a5cbeb1c6ae1b41$export$dd1bc94b04021eeb)(t.c);
var $da7bbf79b162d05c$var$isPlaceholder4 = (t)=>(0, $8a5cbeb1c6ae1b41$export$2047bcc885291b3f)(t.a) && (0, $8a5cbeb1c6ae1b41$export$2047bcc885291b3f)(t.b) && (0, $8a5cbeb1c6ae1b41$export$2047bcc885291b3f)(t.c);
var $da7bbf79b162d05c$var$apply2 = (t, fn)=>Object.freeze({
        ...t,
        a: fn(t.a, `a`),
        b: fn(t.b, `b`),
        c: fn(t.c, `c`)
    });
var $da7bbf79b162d05c$var$isTriangle = (p)=>{
    if (p === void 0) return false;
    const tri = p;
    if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(tri.a)) return false;
    if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(tri.b)) return false;
    if (!(0, $8a5cbeb1c6ae1b41$export$aff838a5553f2a92)(tri.c)) return false;
    return true;
};
var $da7bbf79b162d05c$var$isEqual7 = (a, b)=>(0, $2edc1eef02a7c199$export$248d38f6296296c5)(a.a, b.a) && (0, $2edc1eef02a7c199$export$248d38f6296296c5)(a.b, b.b) && (0, $2edc1eef02a7c199$export$248d38f6296296c5)(a.c, b.c);
var $da7bbf79b162d05c$export$16c38b1c25c91ba = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    return [
        t.a,
        t.b,
        t.c
    ];
};
var $da7bbf79b162d05c$var$lengths2 = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    return [
        (0, $2edc1eef02a7c199$export$9f17032d917177de)(t.a, t.b),
        (0, $2edc1eef02a7c199$export$9f17032d917177de)(t.b, t.c),
        (0, $2edc1eef02a7c199$export$9f17032d917177de)(t.c, t.a)
    ];
};
var $da7bbf79b162d05c$var$angles = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    return [
        (0, $2edc1eef02a7c199$export$8052d07eb1c2870e)(t.a, t.b),
        (0, $2edc1eef02a7c199$export$8052d07eb1c2870e)(t.b, t.c),
        (0, $2edc1eef02a7c199$export$8052d07eb1c2870e)(t.c, t.a)
    ];
};
var $da7bbf79b162d05c$var$anglesDegrees = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    return (0, $2edc1eef02a7c199$export$1c20e104e3e29a0a)($da7bbf79b162d05c$var$angles(t));
};
var $da7bbf79b162d05c$var$isEquilateral = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    const [a, b, c] = $da7bbf79b162d05c$var$lengths2(t);
    return a === b && b === c;
};
var $da7bbf79b162d05c$var$isIsosceles = (t)=>{
    const [a, b, c] = $da7bbf79b162d05c$var$lengths2(t);
    if (a === b) return true;
    if (b === c) return true;
    if (c === a) return true;
    return false;
};
var $da7bbf79b162d05c$var$isRightAngle = (t)=>$da7bbf79b162d05c$var$angles(t).includes(Math.PI / 2);
var $da7bbf79b162d05c$var$isOblique = (t)=>!$da7bbf79b162d05c$var$isRightAngle(t);
var $da7bbf79b162d05c$var$isAcute = (t)=>!$da7bbf79b162d05c$var$angles(t).some((v)=>v >= Math.PI / 2);
var $da7bbf79b162d05c$var$isObtuse = (t)=>$da7bbf79b162d05c$var$angles(t).some((v)=>v > Math.PI / 2);
var $da7bbf79b162d05c$var$fromRadius = (origin, radius, opts = {})=>{
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(radius, `positive`, `radius`);
    (0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(origin, `origin`);
    const initialAngleRadian = opts.initialAngleRadian ?? 0;
    const angles2 = [
        initialAngleRadian,
        initialAngleRadian + $da7bbf79b162d05c$var$piPi7 * 1 / 3,
        initialAngleRadian + $da7bbf79b162d05c$var$piPi7 * 2 / 3
    ];
    const points = angles2.map((a)=>(0, $2edc1eef02a7c199$export$24440bbdd34c95b6)(radius, a, origin));
    return $da7bbf79b162d05c$var$fromPoints3(points);
};
var $da7bbf79b162d05c$var$equilateralFromVertex = (origin, length4 = 10, angleRadian3 = Math.PI / 2)=>{
    if (!origin) origin = Object.freeze({
        x: 0,
        y: 0
    });
    const a = (0, $2edc1eef02a7c199$export$ab03b6763ed7026f)(origin, length4, Math.PI - -angleRadian3 / 2);
    const c = (0, $2edc1eef02a7c199$export$ab03b6763ed7026f)(origin, length4, Math.PI - angleRadian3 / 2);
    return {
        a: a,
        b: origin,
        c: c
    };
};
var $da7bbf79b162d05c$var$toFlatArray2 = (t)=>{
    $da7bbf79b162d05c$var$guard6(t);
    return [
        t.a.x,
        t.a.y,
        t.b.x,
        t.b.y,
        t.c.x,
        t.c.y
    ];
};
var $da7bbf79b162d05c$var$fromFlatArray2 = (coords)=>{
    if (!Array.isArray(coords)) throw new Error(`coords expected as array`);
    if (coords.length !== 6) throw new Error(`coords array expected with 6 elements. Got ${coords.length}`);
    return $da7bbf79b162d05c$var$fromPoints3((0, $2edc1eef02a7c199$export$c2b110734982f150)(...coords));
};
var $da7bbf79b162d05c$var$fromPoints3 = (points)=>{
    if (!Array.isArray(points)) throw new Error(`points expected as array`);
    if (points.length !== 3) throw new Error(`points array expected with 3 elements. Got ${points.length}`);
    const t = {
        a: points[0],
        b: points[1],
        c: points[2]
    };
    return t;
};
var $da7bbf79b162d05c$var$bbox6 = (t, inflation = 0)=>{
    const { a: a, b: b, c: c } = t;
    const xMin = Math.min(a.x, b.x, c.x) - inflation;
    const xMax = Math.max(a.x, b.x, c.x) + inflation;
    const yMin = Math.min(a.y, b.y, c.y) - inflation;
    const yMax = Math.max(a.y, b.y, c.y) + inflation;
    const r = {
        x: xMin,
        y: yMin,
        width: xMax - xMin,
        height: yMax - yMin
    };
    return r;
};
var $da7bbf79b162d05c$var$barycentricCoord = (t, a, b)=>{
    const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(a, b);
    const ab = (x, y, pa, pb)=>(pa.y - pb.y) * x + (pb.x - pa.x) * y + pa.x * pb.y - pb.x * pa.y;
    const alpha = ab(pt.x, pt.y, t.b, t.c) / ab(t.a.x, t.a.y, t.b, t.c);
    const theta = ab(pt.x, pt.y, t.c, t.a) / ab(t.b.x, t.b.y, t.c, t.a);
    const gamma = ab(pt.x, pt.y, t.a, t.b) / ab(t.c.x, t.c.y, t.a, t.b);
    return {
        a: alpha,
        b: theta,
        c: gamma
    };
};
var $da7bbf79b162d05c$var$barycentricToCartestian = (t, bc)=>{
    $da7bbf79b162d05c$var$guard6(t);
    const { a: a, b: b, c: c } = t;
    const x = a.x * bc.a + b.x * bc.b + c.x * bc.c;
    const y = a.y * bc.a + b.y * bc.b + c.y * bc.c;
    if (a.z && b.z && c.z) {
        const z = a.z * bc.a + b.z * bc.b + c.z * bc.c;
        return Object.freeze({
            x: x,
            y: y,
            z: z
        });
    } else return Object.freeze({
        x: x,
        y: y
    });
};
var $da7bbf79b162d05c$var$intersectsPoint2 = (t, a, b)=>{
    const box = $da7bbf79b162d05c$var$bbox6(t);
    const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(a, b);
    if (!(0, $2edc1eef02a7c199$export$5723c514448bc2af)(box, pt)) return false;
    const bc = $da7bbf79b162d05c$var$barycentricCoord(t, pt);
    return 0 <= bc.a && bc.a <= 1 && 0 <= bc.b && bc.b <= 1 && 0 <= bc.c && bc.c <= 1;
};











// src/modulation/index.ts
var $66bc0de6c34dec28$export$c1165f1173362ff5 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($66bc0de6c34dec28$export$c1165f1173362ff5, {
    Easings: ()=>(0, $2edc1eef02a7c199$export$892cfef512d4ea3d),
    Envelopes: ()=>$66bc0de6c34dec28$export$7cf1fdf73b527565,
    Forces: ()=>$66bc0de6c34dec28$export$49df93c94ae9fd2c,
    Oscillators: ()=>$66bc0de6c34dec28$export$d63c1d961d1b59a8,
    Sources: ()=>$66bc0de6c34dec28$export$876300996e33cf92,
    arcShape: ()=>$66bc0de6c34dec28$export$797af250190e49de,
    crossfade: ()=>$66bc0de6c34dec28$export$618ad1168ebb9138,
    cubicBezierShape: ()=>$66bc0de6c34dec28$export$a4a39e4c5e56a6b8,
    drift: ()=>$66bc0de6c34dec28$export$ae9098a159e3a138,
    gaussian: ()=>(0, $2edc1eef02a7c199$export$b2743cdc8f493e4c),
    jitter: ()=>$66bc0de6c34dec28$export$d27ca7ac6590c8cd,
    jitterAbsolute: ()=>$66bc0de6c34dec28$export$23f95e01ac56e524,
    mix: ()=>$66bc0de6c34dec28$export$2c9e8a9632a706b2,
    mixModulators: ()=>$66bc0de6c34dec28$export$c35acd190942e7ea,
    noop: ()=>$66bc0de6c34dec28$export$8793edee2d425525,
    pingPong: ()=>$66bc0de6c34dec28$export$df1cb0b78b1bba50,
    pingPongPercent: ()=>$66bc0de6c34dec28$export$8c87ac411787333c,
    sineBipolarShape: ()=>$66bc0de6c34dec28$export$7d357f1a913b486a,
    sineShape: ()=>$66bc0de6c34dec28$export$e1bb5181fba3eb65,
    spring: ()=>$66bc0de6c34dec28$export$b36281d89752ae66,
    springShape: ()=>$66bc0de6c34dec28$export$369244a33b71ee5b,
    springValue: ()=>$66bc0de6c34dec28$export$bfd6522fc1871e57,
    squareShape: ()=>$66bc0de6c34dec28$export$259f63e2ea91af28,
    tickModulator: ()=>(0, $2edc1eef02a7c199$export$f906a528629f2e0c),
    ticks: ()=>(0, $2edc1eef02a7c199$export$e8e6acc9efcde79f),
    time: ()=>(0, $2edc1eef02a7c199$export$2da9be4cfdb689b1),
    timeModulator: ()=>(0, $2edc1eef02a7c199$export$819ea8fb0cfe1b24),
    timingSourceFactory: ()=>$66bc0de6c34dec28$export$89116902dc8ea29a,
    triangleShape: ()=>$66bc0de6c34dec28$export$759c34781c6bf17c,
    wave: ()=>$66bc0de6c34dec28$export$3af1cb7633944de2,
    waveFromSource: ()=>$66bc0de6c34dec28$export$c67b33f511f2d0e7,
    weightedAverage: ()=>$66bc0de6c34dec28$export$ac406cb80381c5f9
});
// src/modulation/envelope/index.ts
var $66bc0de6c34dec28$export$7cf1fdf73b527565 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($66bc0de6c34dec28$export$7cf1fdf73b527565, {
    Adsr: ()=>$66bc0de6c34dec28$var$Adsr,
    AdsrBase: ()=>$66bc0de6c34dec28$var$AdsrBase,
    AdsrIterator: ()=>$66bc0de6c34dec28$var$AdsrIterator,
    adsr: ()=>$66bc0de6c34dec28$var$adsr,
    adsrIterable: ()=>$66bc0de6c34dec28$var$adsrIterable,
    adsrStateTransitions: ()=>$66bc0de6c34dec28$var$adsrStateTransitions,
    defaultAdsrOpts: ()=>$66bc0de6c34dec28$var$defaultAdsrOpts,
    defaultAdsrTimingOpts: ()=>$66bc0de6c34dec28$var$defaultAdsrTimingOpts
});
// src/modulation/envelope/Types.ts
var $66bc0de6c34dec28$var$adsrStateTransitions = Object.freeze({
    attack: [
        `decay`,
        `release`
    ],
    decay: [
        `sustain`,
        `release`
    ],
    sustain: [
        `release`
    ],
    release: [
        `complete`
    ],
    complete: null
});
// src/modulation/envelope/AdsrBase.ts
var $66bc0de6c34dec28$var$defaultAdsrTimingOpts = Object.freeze({
    attackDuration: 600,
    decayDuration: 200,
    releaseDuration: 800,
    shouldLoop: false
});
var $66bc0de6c34dec28$var$AdsrBase = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    #sm;
    #timeSource;
    #timer;
    #holding;
    #holdingInitial;
    #disposed = false;
    #triggered = false;
    constructor(opts = {}){
        super();
        this.attackDuration = opts.attackDuration ?? $66bc0de6c34dec28$var$defaultAdsrTimingOpts.attackDuration;
        this.decayDuration = opts.decayDuration ?? $66bc0de6c34dec28$var$defaultAdsrTimingOpts.decayDuration;
        this.releaseDuration = opts.releaseDuration ?? $66bc0de6c34dec28$var$defaultAdsrTimingOpts.releaseDuration;
        this.shouldLoop = opts.shouldLoop ?? $66bc0de6c34dec28$var$defaultAdsrTimingOpts.shouldLoop;
        this.#sm = new (0, $29a41e51920ca8b4$export$9b20b63dc5d1b3c0)($66bc0de6c34dec28$var$adsrStateTransitions, {
            initial: `attack`
        });
        this.#sm.addEventListener(`change`, (event)=>{
            if (event.newState === `release` && this.#holdingInitial) this.#timer?.reset();
            super.fireEvent(`change`, event);
        });
        this.#sm.addEventListener(`stop`, (event)=>{
            super.fireEvent(`complete`, event);
        });
        this.#timeSource = ()=>(0, $29a41e51920ca8b4$export$14b940200a0da60a)();
        this.#holding = this.#holdingInitial = false;
        this.decayDurationTotal = this.attackDuration + this.decayDuration;
    }
    dispose() {
        if (this.#disposed) return;
        this.#sm.dispose();
    }
    get isDisposed() {
        return this.#disposed;
    }
    /**
   * Changes state based on timer status
   * @returns _True_ if state was changed
   */ switchStateIfNeeded(allowLooping) {
        if (this.#timer === void 0) return false;
        let elapsed2 = this.#timer.elapsed;
        const wasHeld = this.#holdingInitial && !this.#holding;
        let hasChanged = false;
        let state = this.#sm.state;
        do {
            hasChanged = false;
            state = this.#sm.state;
            switch(state){
                case `attack`:
                    if (elapsed2 > this.attackDuration || wasHeld) {
                        this.#sm.next();
                        hasChanged = true;
                    }
                    break;
                case `decay`:
                    if (elapsed2 > this.decayDurationTotal || wasHeld) {
                        this.#sm.next();
                        hasChanged = true;
                    }
                    break;
                case `sustain`:
                    if (!this.#holding || wasHeld) {
                        elapsed2 = 0;
                        this.#sm.next();
                        this.#timer.reset();
                        hasChanged = true;
                    }
                    break;
                case `release`:
                    if (elapsed2 > this.releaseDuration) {
                        this.#sm.next();
                        hasChanged = true;
                    }
                    break;
                case `complete`:
                    if (this.shouldLoop && allowLooping) this.trigger(this.#holdingInitial);
            }
        }while (hasChanged && state !== `complete`);
        return hasChanged;
    }
    /**
   * Computes a stage's progress from 0-1
   * @param allowStateChange
   * @returns
   */ computeRaw(allowStateChange = true, allowLooping = true) {
        if (this.#timer === void 0) return [
            void 0,
            0,
            this.#sm.state
        ];
        if (allowStateChange) this.switchStateIfNeeded(allowLooping);
        const previousStage = this.#sm.state;
        const elapsed2 = this.#timer.elapsed;
        let relative = 0;
        const state = this.#sm.state;
        switch(state){
            case `attack`:
                relative = elapsed2 / this.attackDuration;
                break;
            case `decay`:
                relative = (elapsed2 - this.attackDuration) / this.decayDuration;
                break;
            case `sustain`:
                relative = 1;
                break;
            case `release`:
                relative = Math.min(elapsed2 / this.releaseDuration, 1);
                break;
            case `complete`:
                return [
                    `complete`,
                    1,
                    previousStage
                ];
            default:
                throw new Error(`State machine in unknown state: ${state}`);
        }
        return [
            state,
            relative,
            previousStage
        ];
    }
    /**
   * Returns _true_ if envelope has finished
   */ get isDone() {
        return this.#sm.isDone;
    }
    onTrigger() {}
    /**
   * Triggers envelope, optionally _holding_ it.
   * 
   * If `hold` is _false_ (default), envelope will run through all stages,
   * but sustain stage won't have an affect.
   * 
   * If `hold` is _true_, it will run to, and stay at the sustain stage. 
   * Use {@link release} to later release the envelope.
   *
   * If event is already trigged it will be _retriggered_. 
   * Initial value depends on `opts.retrigger`
   * * _false_ (default): envelope continues at current value.
   * * _true_: envelope value resets to `opts.initialValue`.
   *
   * @param hold If _true_ envelope will hold at sustain stage
   */ trigger(hold = false) {
        this.onTrigger();
        this.#triggered = true;
        this.#sm.reset();
        this.#timer = this.#timeSource();
        this.#holding = hold;
        this.#holdingInitial = hold;
    }
    get hasTriggered() {
        return this.#triggered;
    }
    compute() {}
    /**
   * Release if 'trigger(true)' was previouslly called.
   * Has no effect if not triggered or held.
   * @returns 
   */ release() {
        if (this.isDone || !this.#holdingInitial) return;
        this.#holding = false;
        this.compute();
    }
};
// src/modulation/envelope/Adsr.ts
var $66bc0de6c34dec28$var$defaultAdsrOpts = Object.freeze({
    attackBend: -1,
    decayBend: -0.3,
    releaseBend: -0.3,
    peakLevel: 1,
    initialLevel: 0,
    sustainLevel: 0.6,
    releaseLevel: 0,
    retrigger: false
});
var $66bc0de6c34dec28$var$AdsrIterator = class {
    constructor(adsr2){
        this.adsr = adsr2;
    }
    next(...args) {
        if (!this.adsr.hasTriggered) this.adsr.trigger();
        const c = this.adsr.compute();
        return {
            value: c[1],
            done: c[0] === `complete`
        };
    }
    get [Symbol.toStringTag]() {
        return `Generator`;
    }
};
var $66bc0de6c34dec28$var$Adsr = class extends $66bc0de6c34dec28$var$AdsrBase {
    constructor(opts = {}){
        super(opts);
        this.retrigger = opts.retrigger ?? $66bc0de6c34dec28$var$defaultAdsrOpts.retrigger;
        this.initialLevel = opts.initialLevel ?? $66bc0de6c34dec28$var$defaultAdsrOpts.initialLevel;
        this.peakLevel = opts.peakLevel ?? $66bc0de6c34dec28$var$defaultAdsrOpts.peakLevel;
        this.releaseLevel = opts.releaseLevel ?? $66bc0de6c34dec28$var$defaultAdsrOpts.releaseLevel;
        this.sustainLevel = opts.sustainLevel ?? $66bc0de6c34dec28$var$defaultAdsrOpts.sustainLevel;
        this.attackBend = opts.attackBend ?? $66bc0de6c34dec28$var$defaultAdsrOpts.attackBend;
        this.releaseBend = opts.releaseBend ?? $66bc0de6c34dec28$var$defaultAdsrOpts.releaseBend;
        this.decayBend = opts.decayBend ?? $66bc0de6c34dec28$var$defaultAdsrOpts.decayBend;
        const max = 1;
        this.attackPath = (0, $2edc1eef02a7c199$export$440836a238ff8548)((0, $2edc1eef02a7c199$export$b1e639a4c61456b1)({
            x: 0,
            y: this.initialLevel
        }, {
            x: max,
            y: this.peakLevel
        }, -this.attackBend));
        this.decayPath = (0, $2edc1eef02a7c199$export$440836a238ff8548)((0, $2edc1eef02a7c199$export$b1e639a4c61456b1)({
            x: 0,
            y: this.peakLevel
        }, {
            x: max,
            y: this.sustainLevel
        }, -this.decayBend));
        this.releasePath = (0, $2edc1eef02a7c199$export$440836a238ff8548)((0, $2edc1eef02a7c199$export$b1e639a4c61456b1)({
            x: 0,
            y: this.sustainLevel
        }, {
            x: max,
            y: this.releaseLevel
        }, -this.releaseBend));
    }
    onTrigger() {
        this.initialLevelOverride = void 0;
        if (!this.retrigger) {
            const [_stage, scaled, _raw] = this.compute(true, false);
            if (!Number.isNaN(scaled) && scaled > 0) this.initialLevelOverride = scaled;
        }
    }
    [Symbol.iterator]() {
        return new $66bc0de6c34dec28$var$AdsrIterator(this);
    }
    /**
   * Returns the scaled value
   * Same as .compute()[1]
   */ get value() {
        return this.compute(true)[1];
    }
    /**
   * Compute value of envelope at this point in time.
   *
   * Returns an array of [stage, scaled, raw]. Most likely you want to use {@link value} to just get the scaled value.
   * @param allowStateChange If true (default) envelope will be allowed to change state if necessary before returning value
   */ compute(allowStateChange = true, allowLooping = true) {
        const [stage, amt] = super.computeRaw(allowStateChange, allowLooping);
        if (stage === void 0) return [
            void 0,
            Number.NaN,
            Number.NaN
        ];
        let v;
        switch(stage){
            case `attack`:
                v = this.attackPath.interpolate(amt).y;
                if (this.initialLevelOverride !== void 0) v = (0, $8a5cbeb1c6ae1b41$export$dcdf75081b88279d)(v, 0, 1, this.initialLevelOverride, 1);
                this.releasedAt = v;
                break;
            case `decay`:
                v = this.decayPath.interpolate(amt).y;
                this.releasedAt = v;
                break;
            case `sustain`:
                v = this.sustainLevel;
                this.releasedAt = v;
                break;
            case `release`:
                v = this.releasePath.interpolate(amt).y;
                if (this.releasedAt !== void 0) v = (0, $8a5cbeb1c6ae1b41$export$dcdf75081b88279d)(v, 0, this.sustainLevel, 0, this.releasedAt);
                break;
            case `complete`:
                v = this.releaseLevel;
                this.releasedAt = void 0;
                break;
            default:
                throw new Error(`Unknown state: ${stage}`);
        }
        return [
            stage,
            v,
            amt
        ];
    }
};
// src/modulation/envelope/index.ts
var $66bc0de6c34dec28$var$adsr = (opts = {})=>{
    const envelope = new $66bc0de6c34dec28$var$Adsr(opts);
    const finalValue = envelope.releaseLevel;
    const iterator = envelope[Symbol.iterator]();
    return ()=>(0, $f53657e65b61d2bb$export$bf737119f3ba2592)(iterator, {
            overrideWithLast: true,
            value: finalValue
        });
};
async function* $66bc0de6c34dec28$var$adsrIterable(opts) {
    const envelope = new $66bc0de6c34dec28$var$Adsr(opts.env);
    const sampleRateMs = opts.sampleRateMs ?? 100;
    envelope.trigger();
    const r = (0, $f53657e65b61d2bb$export$76d90c956114f2c2)(()=>envelope.value, {
        while: ()=>!envelope.isDone,
        delay: sampleRateMs,
        signal: opts.signal
    });
    for await (const v of r)yield v;
}
// src/modulation/source/index.ts
var $66bc0de6c34dec28$export$876300996e33cf92 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($66bc0de6c34dec28$export$876300996e33cf92, {
    bpm: ()=>$66bc0de6c34dec28$var$bpm,
    elapsed: ()=>$66bc0de6c34dec28$var$elapsed,
    hertz: ()=>$66bc0de6c34dec28$var$hertz,
    perMinute: ()=>$66bc0de6c34dec28$var$perMinute,
    perSecond: ()=>$66bc0de6c34dec28$var$perSecond,
    ticks: ()=>$66bc0de6c34dec28$var$ticks2
});
// src/modulation/source/Ticks.ts
function $66bc0de6c34dec28$var$ticks2(totalTicks, options = {}) {
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(totalTicks, `aboveZero`, `totalTicks`);
    const exclusiveStart = options.exclusiveStart ?? false;
    const exclusiveEnd = options.exclusiveEnd ?? false;
    const cycleLimit = options.cycleLimit ?? Number.MAX_SAFE_INTEGER;
    const startPoint = exclusiveStart ? 1 : 0;
    const endPoint = exclusiveEnd ? totalTicks - 1 : totalTicks;
    let cycleCount = 0;
    let v = options.startAt ?? startPoint;
    if (options.startAtRelative) {
        let totalTicksForReal = totalTicks;
        if (exclusiveStart) totalTicksForReal--;
        if (exclusiveEnd) totalTicksForReal--;
        v = Math.round(options.startAtRelative * totalTicksForReal);
    }
    return (feedback)=>{
        if (feedback) {
            if (feedback.resetAt !== void 0) v = feedback.resetAt;
            if (feedback.resetAtRelative !== void 0) v = Math.floor(feedback.resetAtRelative * totalTicks);
        }
        if (cycleCount >= cycleLimit) return 1;
        let current = v / totalTicks;
        v++;
        if (v > endPoint) {
            cycleCount++;
            v = startPoint;
        }
        return current;
    };
}
// src/modulation/source/Time.ts
function $66bc0de6c34dec28$var$elapsed(interval, options = {}) {
    const cycleLimit = options.cycleLimit ?? Number.MAX_SAFE_INTEGER;
    const limitValue = 1;
    let start = options.startAt ?? performance.now();
    let cycleCount = 0;
    const intervalMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(interval, 1e3);
    if (options.startAtRelative) {
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(options.startAtRelative, `percentage`, `startAtRelative`);
        start = performance.now() - intervalMs * options.startAtRelative;
    }
    return (feedback)=>{
        if (feedback) {
            if (feedback.resetAt !== void 0) {
                start = feedback.resetAt;
                if (start === 0) start = performance.now();
            }
            if (feedback.resetAtRelative !== void 0) {
                (0, $984cc5641d701af3$export$d60fcb8dda779864)(feedback.resetAtRelative, `percentage`, `resetAtRelative`);
                start = performance.now() - intervalMs * feedback.resetAtRelative;
            }
        }
        if (cycleCount >= cycleLimit) return limitValue;
        const now = performance.now();
        const elapsedCycle = now - start;
        if (elapsedCycle >= intervalMs) {
            cycleCount += Math.floor(elapsedCycle / intervalMs);
            start = now;
            if (cycleCount >= cycleLimit) return limitValue;
        }
        return elapsedCycle % intervalMs / intervalMs;
    };
}
function $66bc0de6c34dec28$var$bpm(bpm2, options = {}) {
    const interval = 60000 / bpm2;
    return $66bc0de6c34dec28$var$elapsed(interval, options);
}
function $66bc0de6c34dec28$var$hertz(hz, options = {}) {
    const interval = 1e3 / hz;
    return $66bc0de6c34dec28$var$elapsed(interval, options);
}
// src/modulation/source/PerSecond.ts
var $66bc0de6c34dec28$var$perSecond = (amount, options = {})=>{
    const perMilli = amount / 1e3;
    let min = options.min ?? Number.MIN_SAFE_INTEGER;
    let max = options.max ?? Number.MAX_SAFE_INTEGER;
    const clamp2 = options.clamp ?? false;
    if (clamp2 && options.max) throw new Error(`Use either 'max' or 'clamp', not both.`);
    if (clamp2) max = amount;
    let called = performance.now();
    return ()=>{
        const now = performance.now();
        const elapsed2 = now - called;
        called = now;
        const x = perMilli * elapsed2;
        if (x > max) return max;
        if (x < min) return min;
        return x;
    };
};
var $66bc0de6c34dec28$var$perMinute = (amount, options = {})=>{
    return $66bc0de6c34dec28$var$perSecond(amount / 60, options);
};
// src/modulation/CubicBezier.ts
var $66bc0de6c34dec28$export$a4a39e4c5e56a6b8 = (b, d)=>(t)=>{
        const s = 1 - t;
        const s2 = s * s;
        const t2 = t * t;
        const t3 = t2 * t;
        return 3 * b * s2 * t + 3 * d * s * t2 + t3;
    };
// src/modulation/Drift.ts
var $66bc0de6c34dec28$export$ae9098a159e3a138 = (driftAmtPerMs)=>{
    let lastChange = performance.now();
    const update = (v = 1)=>{
        const elapsed2 = performance.now() - lastChange;
        const amt = driftAmtPerMs * elapsed2 % 1;
        lastChange = performance.now();
        const calc = (v + amt) % 1;
        return calc;
    };
    const reset = ()=>{
        lastChange = performance.now();
    };
    return {
        update: update,
        reset: reset
    };
};
// src/modulation/Forces.ts
var $66bc0de6c34dec28$export$49df93c94ae9fd2c = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($66bc0de6c34dec28$export$49df93c94ae9fd2c, {
    accelerationForce: ()=>$66bc0de6c34dec28$var$accelerationForce,
    angleFromAccelerationForce: ()=>$66bc0de6c34dec28$var$angleFromAccelerationForce,
    angleFromVelocityForce: ()=>$66bc0de6c34dec28$var$angleFromVelocityForce,
    angularForce: ()=>$66bc0de6c34dec28$var$angularForce,
    apply: ()=>$66bc0de6c34dec28$var$apply,
    attractionForce: ()=>$66bc0de6c34dec28$var$attractionForce,
    computeAccelerationToTarget: ()=>$66bc0de6c34dec28$var$computeAccelerationToTarget,
    computeAttractionForce: ()=>$66bc0de6c34dec28$var$computeAttractionForce,
    computePositionFromAngle: ()=>$66bc0de6c34dec28$var$computePositionFromAngle,
    computePositionFromVelocity: ()=>$66bc0de6c34dec28$var$computePositionFromVelocity,
    computeVelocity: ()=>$66bc0de6c34dec28$var$computeVelocity,
    constrainBounce: ()=>$66bc0de6c34dec28$var$constrainBounce,
    guard: ()=>$66bc0de6c34dec28$var$guard,
    magnitudeForce: ()=>$66bc0de6c34dec28$var$magnitudeForce,
    nullForce: ()=>$66bc0de6c34dec28$var$nullForce,
    orientationForce: ()=>$66bc0de6c34dec28$var$orientationForce,
    pendulumForce: ()=>$66bc0de6c34dec28$var$pendulumForce,
    springForce: ()=>$66bc0de6c34dec28$var$springForce,
    targetForce: ()=>$66bc0de6c34dec28$var$targetForce,
    velocityForce: ()=>$66bc0de6c34dec28$var$velocityForce
});
var $66bc0de6c34dec28$var$guard = (t, name = `t`)=>{
    if (t === void 0) throw new Error(`Parameter ${name} is undefined. Expected ForceAffected`);
    if (t === null) throw new Error(`Parameter ${name} is null. Expected ForceAffected`);
    if (typeof t !== `object`) throw new TypeError(`Parameter ${name} is type ${typeof t}. Expected object of shape ForceAffected`);
};
var $66bc0de6c34dec28$var$constrainBounce = (bounds, dampen = 1)=>{
    if (!bounds) bounds = {
        width: 1,
        height: 1
    };
    const minX = (0, $da7bbf79b162d05c$export$f8b1c50419d0fa91)(bounds, `left`);
    const maxX = (0, $da7bbf79b162d05c$export$f8b1c50419d0fa91)(bounds, `right`);
    const minY = (0, $da7bbf79b162d05c$export$7f8a29eecdd471e1)(bounds, `top`);
    const maxY = (0, $da7bbf79b162d05c$export$7f8a29eecdd471e1)(bounds, `bottom`);
    return (t)=>{
        const position = $66bc0de6c34dec28$var$computePositionFromVelocity(t.position ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, t.velocity ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty);
        let velocity = t.velocity ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty;
        let { x: x, y: y } = position;
        if (x > maxX) {
            x = maxX;
            velocity = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).invert((0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar(velocity, dampen), `x`);
        } else if (x < minX) {
            x = minX;
            velocity = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).invert((0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar(velocity, dampen), `x`);
        }
        if (y > maxY) {
            y = maxY;
            velocity = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar((0, $2edc1eef02a7c199$export$686cad0ec81705cb).invert(velocity, `y`), dampen);
        } else if (position.y < minY) {
            y = minY;
            velocity = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).invert((0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar(velocity, dampen), `y`);
        }
        return Object.freeze({
            ...t,
            position: {
                x: x,
                y: y
            },
            velocity: velocity
        });
    };
};
var $66bc0de6c34dec28$var$attractionForce = (attractors, gravity, distanceRange = {})=>(attractee)=>{
        let accel = attractee.acceleration ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty;
        for (const a of attractors){
            if (a === attractee) continue;
            const f = $66bc0de6c34dec28$var$computeAttractionForce(a, attractee, gravity, distanceRange);
            accel = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).sum(accel, f);
        }
        return {
            ...attractee,
            acceleration: accel
        };
    };
var $66bc0de6c34dec28$var$computeAttractionForce = (attractor, attractee, gravity, distanceRange = {})=>{
    if (attractor.position === void 0) throw new Error(`attractor.position not set`);
    if (attractee.position === void 0) throw new Error(`attractee.position not set`);
    const distributionRangeMin = distanceRange.min ?? 0.01;
    const distributionRangeMax = distanceRange.max ?? 0.7;
    const f = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).normalise((0, $2edc1eef02a7c199$export$686cad0ec81705cb).subtract(attractor.position, attractee.position));
    const d = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)((0, $2edc1eef02a7c199$export$686cad0ec81705cb).distance(f), distributionRangeMin, distributionRangeMax);
    return (0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar(f, gravity * (attractor.mass ?? 1) * (attractee.mass ?? 1) / (d * d));
};
var $66bc0de6c34dec28$var$targetForce = (targetPos, opts = {})=>{
    const fn = (t)=>{
        const accel = $66bc0de6c34dec28$var$computeAccelerationToTarget(targetPos, t.position ?? {
            x: 0.5,
            y: 0.5
        }, opts);
        return {
            ...t,
            acceleration: (0, $2edc1eef02a7c199$export$686cad0ec81705cb).sum(t.acceleration ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, accel)
        };
    };
    return fn;
};
var $66bc0de6c34dec28$var$apply = (t, ...accelForces)=>{
    if (t === void 0) throw new Error(`t parameter is undefined`);
    for (const f of accelForces){
        if (f === null || f === void 0) continue;
        t = typeof f === `function` ? f(t) : {
            ...t,
            acceleration: (0, $2edc1eef02a7c199$export$686cad0ec81705cb).sum(t.acceleration ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, f)
        };
    }
    const velo = $66bc0de6c34dec28$var$computeVelocity(t.acceleration ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, t.velocity ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty);
    const pos = $66bc0de6c34dec28$var$computePositionFromVelocity(t.position ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, velo);
    const ff = {
        ...t,
        position: pos,
        velocity: velo,
        // Clear accel, because it has been integrated into velocity
        acceleration: (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty
    };
    return ff;
};
var $66bc0de6c34dec28$var$accelerationForce = (vector, mass = `ignored`)=>(t)=>Object.freeze({
            ...t,
            acceleration: $66bc0de6c34dec28$var$massApplyAccel(vector, t, mass)
        });
var $66bc0de6c34dec28$var$massApplyAccel = (vector, thing, mass = `ignored`)=>{
    let op;
    switch(mass){
        case `dampen`:
            op = (mass2)=>(0, $2edc1eef02a7c199$export$cd007d971a5a2143)(vector, mass2, mass2);
            break;
        case `multiply`:
            op = (mass2)=>(0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiply(vector, mass2, mass2);
            break;
        case `ignored`:
            op = (_mass)=>vector;
            break;
        default:
            throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `Unknown 'mass' parameter '${mass}. Expected 'dampen', 'multiply' or 'ignored'`);
    }
    return (0, $2edc1eef02a7c199$export$686cad0ec81705cb).sum(thing.acceleration ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, op(thing.mass ?? 1));
};
var $66bc0de6c34dec28$var$magnitudeForce = (force, mass = `ignored`)=>(t)=>{
        if (t.velocity === void 0) return t;
        const mag = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).distance((0, $2edc1eef02a7c199$export$686cad0ec81705cb).normalise(t.velocity));
        const magSq = force * mag * mag;
        const vv = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar((0, $2edc1eef02a7c199$export$686cad0ec81705cb).invert(t.velocity), magSq);
        return Object.freeze({
            ...t,
            acceleration: $66bc0de6c34dec28$var$massApplyAccel(vv, t, mass)
        });
    };
var $66bc0de6c34dec28$var$nullForce = (t)=>t;
var $66bc0de6c34dec28$var$velocityForce = (force, mass)=>{
    const pipeline = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).pipeline(// Points.normalise,
    (0, $2edc1eef02a7c199$export$686cad0ec81705cb).invert, (v)=>(0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar(v, force));
    return (t)=>{
        if (t.velocity === void 0) return t;
        const v = pipeline(t.velocity);
        return Object.freeze({
            ...t,
            acceleration: $66bc0de6c34dec28$var$massApplyAccel(v, t, mass)
        });
    };
};
var $66bc0de6c34dec28$var$angularForce = ()=>(t)=>{
        const accumulator = t.angularAcceleration ?? 0;
        const vel = t.angularVelocity ?? 0;
        const angle = t.angle ?? 0;
        const v = vel + accumulator;
        const a = angle + v;
        return Object.freeze({
            ...t,
            angle: a,
            angularVelocity: v,
            angularAcceleration: 0
        });
    };
var $66bc0de6c34dec28$var$angleFromAccelerationForce = (scaling = 20)=>(t)=>{
        const accel = t.acceleration ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty;
        return Object.freeze({
            ...t,
            angularAcceleration: accel.x * scaling
        });
    };
var $66bc0de6c34dec28$var$angleFromVelocityForce = (interpolateAmt = 1)=>(t)=>{
        const a = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).angleRadian(t.velocity ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty);
        return Object.freeze({
            ...t,
            angle: interpolateAmt < 1 ? (0, $2edc1eef02a7c199$export$92c7c4f86cf692ac)(interpolateAmt, t.angle ?? 0, a) : a
        });
    };
var $66bc0de6c34dec28$var$springForce = (pinnedAt, restingLength = 0.5, k = 2e-4, damping = 0.999)=>(t)=>{
        const direction = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).subtract(t.position ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, pinnedAt);
        const mag = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).distance(direction);
        const stretch = Math.abs(restingLength - mag);
        const f = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).pipelineApply(direction, (0, $2edc1eef02a7c199$export$686cad0ec81705cb).normalise, (p)=>(0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar(p, -k * stretch));
        const accel = $66bc0de6c34dec28$var$massApplyAccel(f, t, `dampen`);
        const velo = $66bc0de6c34dec28$var$computeVelocity(accel ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty, t.velocity ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty);
        const veloDamped = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiply(velo, damping, damping);
        return {
            ...t,
            velocity: veloDamped,
            acceleration: (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty
        };
    };
var $66bc0de6c34dec28$var$pendulumForce = (pinnedAt, opts = {})=>(t)=>{
        if (!pinnedAt) pinnedAt = {
            x: 0,
            y: 0
        };
        const length = opts.length ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).distance(pinnedAt, t.position ?? (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty);
        const speed = opts.speed ?? 1e-3;
        const damping = opts.damping ?? 0.995;
        let angle = t.angle;
        if (angle === void 0) {
            if (t.position) angle = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).angleRadian(pinnedAt, t.position) - Math.PI / 2;
            else angle = 0;
        }
        const accel = -1 * speed / length * Math.sin(angle);
        const v = (t.angularVelocity ?? 0) + accel;
        angle += v;
        return Object.freeze({
            angularVelocity: v * damping,
            angle: angle,
            position: $66bc0de6c34dec28$var$computePositionFromAngle(length, angle + Math.PI / 2, pinnedAt)
        });
    };
var $66bc0de6c34dec28$var$computeVelocity = (acceleration, velocity, velocityMax)=>{
    const p = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).sum(velocity, acceleration);
    return velocityMax === void 0 ? p : (0, $2edc1eef02a7c199$export$686cad0ec81705cb).clampMagnitude(p, velocityMax);
};
var $66bc0de6c34dec28$var$computeAccelerationToTarget = (targetPos, currentPos, opts = {})=>{
    const diminishBy = opts.diminishBy ?? 1e-3;
    const direction = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).subtract(targetPos, currentPos);
    if (opts.range && // If direction is less than range, return { x: 0, y: 0}
    (0, $2edc1eef02a7c199$export$686cad0ec81705cb).compare((0, $2edc1eef02a7c199$export$686cad0ec81705cb).abs(direction), opts.range) === -2) return (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty;
    return (0, $2edc1eef02a7c199$export$686cad0ec81705cb).multiplyScalar(direction, diminishBy);
};
var $66bc0de6c34dec28$var$computePositionFromVelocity = (position, velocity)=>(0, $2edc1eef02a7c199$export$686cad0ec81705cb).sum(position, velocity);
var $66bc0de6c34dec28$var$computePositionFromAngle = (distance, angleRadians, origin)=>(0, $2edc1eef02a7c199$export$c20c3ae8c54a7e6a).toCartesian(distance, angleRadians, origin);
var $66bc0de6c34dec28$var$_angularForce = $66bc0de6c34dec28$var$angularForce();
var $66bc0de6c34dec28$var$_angleFromAccelerationForce = $66bc0de6c34dec28$var$angleFromAccelerationForce();
var $66bc0de6c34dec28$var$orientationForce = (interpolationAmt = 0.5)=>{
    const angleFromVel = $66bc0de6c34dec28$var$angleFromVelocityForce(interpolationAmt);
    return (t)=>{
        t = $66bc0de6c34dec28$var$_angularForce(t);
        t = $66bc0de6c34dec28$var$_angleFromAccelerationForce(t);
        t = angleFromVel(t);
        return t;
    };
};
// src/modulation/Jitter.ts
var $66bc0de6c34dec28$export$23f95e01ac56e524 = (options)=>{
    const { relative: relative, absolute: absolute } = options;
    const clamped = options.clamped ?? false;
    const source = options.source ?? (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    if (absolute !== void 0) return (value)=>{
        const abs = source() * absolute * 2 - absolute;
        const valueNew = value + abs;
        if (clamped) return (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(valueNew, 0, value);
        return valueNew;
    };
    if (relative !== void 0) return (value)=>{
        const rel = value * relative;
        const abs = source() * rel * 2 - rel;
        const valueNew = value + abs;
        if (clamped) return (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(valueNew, 0, value);
        return valueNew;
    };
    throw new Error(`Either absolute or relative fields expected`);
};
var $66bc0de6c34dec28$export$d27ca7ac6590c8cd = (options = {})=>{
    const clamped = options.clamped ?? true;
    let r = (_)=>0;
    if (options.absolute !== void 0) {
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(options.absolute, clamped ? `percentage` : `bipolar`, `opts.absolute`);
        const absRand = (0, $ecc9b4c6822e4e6b$export$a627116c255f4dc3)({
            min: -options.absolute,
            max: options.absolute,
            source: options.source
        });
        r = (v)=>v + absRand();
    } else if (options.relative === void 0) throw new TypeError(`Either absolute or relative jitter amount is required.`);
    else {
        const rel = options.relative ?? 0.1;
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(rel, clamped ? `percentage` : `bipolar`, `opts.relative`);
        r = (v)=>v + (0, $ecc9b4c6822e4e6b$export$6b5cd3983e3ee5ab)({
                min: -Math.abs(rel * v),
                max: Math.abs(rel * v),
                source: options.source
            });
    }
    const compute = (value)=>{
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(value, clamped ? `percentage` : `bipolar`, `value`);
        let v = r(value);
        if (clamped) v = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(v);
        return v;
    };
    return compute;
};
// src/modulation/Mix.ts
var $66bc0de6c34dec28$export$2c9e8a9632a706b2 = (amount, original, modulation)=>{
    const m = modulation * amount;
    const base = (1 - amount) * original;
    return base + original * m;
};
var $66bc0de6c34dec28$export$c35acd190942e7ea = (balance, a, b)=>(amt)=>(0, $2edc1eef02a7c199$export$4e4c1a907874f01)(balance, a(amt), b(amt));
var $66bc0de6c34dec28$export$618ad1168ebb9138 = (a, b)=>{
    return (amt)=>{
        const mixer = $66bc0de6c34dec28$export$c35acd190942e7ea(amt, a, b);
        return mixer(amt);
    };
};
// src/modulation/Noop.ts
var $66bc0de6c34dec28$export$8793edee2d425525 = (v)=>v;
// src/modulation/Oscillator.ts
var $66bc0de6c34dec28$export$d63c1d961d1b59a8 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($66bc0de6c34dec28$export$d63c1d961d1b59a8, {
    saw: ()=>$66bc0de6c34dec28$var$saw,
    sine: ()=>$66bc0de6c34dec28$var$sine,
    sineBipolar: ()=>$66bc0de6c34dec28$var$sineBipolar,
    square: ()=>$66bc0de6c34dec28$var$square,
    triangle: ()=>$66bc0de6c34dec28$var$triangle
});
var $66bc0de6c34dec28$var$piPi = Math.PI * 2;
function* $66bc0de6c34dec28$var$sine(timerOrFreq) {
    if (timerOrFreq === void 0) throw new TypeError(`Parameter 'timerOrFreq' is undefined`);
    if (typeof timerOrFreq === `number`) timerOrFreq = (0, $29a41e51920ca8b4$export$8c3ddf86ca88bc10)(timerOrFreq);
    while(true)yield (Math.sin(timerOrFreq.elapsed * $66bc0de6c34dec28$var$piPi) + 1) / 2;
}
function* $66bc0de6c34dec28$var$sineBipolar(timerOrFreq) {
    if (timerOrFreq === void 0) throw new TypeError(`Parameter 'timerOrFreq' is undefined`);
    if (typeof timerOrFreq === `number`) timerOrFreq = (0, $29a41e51920ca8b4$export$8c3ddf86ca88bc10)(timerOrFreq);
    while(true)yield Math.sin(timerOrFreq.elapsed * $66bc0de6c34dec28$var$piPi);
}
function* $66bc0de6c34dec28$var$triangle(timerOrFreq) {
    if (typeof timerOrFreq === `number`) timerOrFreq = (0, $29a41e51920ca8b4$export$8c3ddf86ca88bc10)(timerOrFreq);
    while(true){
        let v = timerOrFreq.elapsed;
        if (v < 0.5) v *= 2;
        else v = 2 - v * 2;
        yield v;
    }
}
function* $66bc0de6c34dec28$var$saw(timerOrFreq) {
    if (timerOrFreq === void 0) throw new TypeError(`Parameter 'timerOrFreq' is undefined`);
    if (typeof timerOrFreq === `number`) timerOrFreq = (0, $29a41e51920ca8b4$export$8c3ddf86ca88bc10)(timerOrFreq);
    while(true)yield timerOrFreq.elapsed;
}
function* $66bc0de6c34dec28$var$square(timerOrFreq) {
    if (typeof timerOrFreq === `number`) timerOrFreq = (0, $29a41e51920ca8b4$export$8c3ddf86ca88bc10)(timerOrFreq);
    while(true)yield timerOrFreq.elapsed < 0.5 ? 0 : 1;
}
// src/modulation/PingPong.ts
var $66bc0de6c34dec28$export$8c87ac411787333c = function(interval = 0.1, lower, upper, start, rounding) {
    if (lower === void 0) lower = 0;
    if (upper === void 0) upper = 1;
    if (start === void 0) start = lower;
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(interval, `bipolar`, `interval`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(upper, `bipolar`, `end`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(start, `bipolar`, `offset`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(lower, `bipolar`, `start`);
    return $66bc0de6c34dec28$export$df1cb0b78b1bba50(interval, lower, upper, start, rounding);
};
var $66bc0de6c34dec28$export$df1cb0b78b1bba50 = function*(interval, lower, upper, start, rounding) {
    if (lower === void 0) throw new Error(`Parameter 'lower' is undefined`);
    if (interval === void 0) throw new Error(`Parameter 'interval' is undefined`);
    if (upper === void 0) throw new Error(`Parameter 'upper' is undefined`);
    if (rounding === void 0 && interval <= 1 && interval >= 0) rounding = 10 / interval;
    else if (rounding === void 0) rounding = 1234;
    if (Number.isNaN(interval)) throw new Error(`interval parameter is NaN`);
    if (Number.isNaN(lower)) throw new Error(`lower parameter is NaN`);
    if (Number.isNaN(upper)) throw new Error(`upper parameter is NaN`);
    if (Number.isNaN(start)) throw new Error(`upper parameter is NaN`);
    if (lower >= upper) throw new Error(`lower must be less than upper`);
    if (interval === 0) throw new Error(`Interval cannot be zero`);
    const distance = upper - lower;
    if (Math.abs(interval) >= distance) throw new Error(`Interval should be between -${distance} and ${distance}`);
    let incrementing = interval > 0;
    upper = Math.floor(upper * rounding);
    lower = Math.floor(lower * rounding);
    interval = Math.floor(Math.abs(interval * rounding));
    if (interval === 0) throw new Error(`Interval is zero (rounding: ${rounding})`);
    start = start === void 0 ? lower : Math.floor(start * rounding);
    if (start > upper || start < lower) throw new Error(`Start (${start / rounding}) must be within lower (${lower / rounding}) and upper (${upper / rounding})`);
    let v = start;
    yield v / rounding;
    let firstLoop = true;
    while(true){
        v = v + (incrementing ? interval : -interval);
        if (incrementing && v >= upper) {
            incrementing = false;
            v = upper;
            if (v === upper && firstLoop) {
                v = lower;
                incrementing = true;
            }
        } else if (!incrementing && v <= lower) {
            incrementing = true;
            v = lower;
            if (v === lower && firstLoop) {
                v = upper;
                incrementing = false;
            }
        }
        yield v / rounding;
        firstLoop = false;
    }
};
// src/modulation/Spring.ts
function* $66bc0de6c34dec28$export$b36281d89752ae66(opts = {}, timerOrFreq) {
    if (timerOrFreq === void 0) timerOrFreq = (0, $29a41e51920ca8b4$export$14b940200a0da60a)();
    else if (typeof timerOrFreq === `number`) timerOrFreq = (0, $29a41e51920ca8b4$export$8c3ddf86ca88bc10)(timerOrFreq);
    const fn = $66bc0de6c34dec28$export$369244a33b71ee5b(opts);
    let doneCountdown = opts.countdown ?? 10;
    while(doneCountdown > 0){
        const s = fn(timerOrFreq.elapsed / 1e3);
        yield s;
        if (s === 1) doneCountdown--;
        else doneCountdown = 100;
    }
}
function $66bc0de6c34dec28$export$bfd6522fc1871e57(opts = {}, timerOrFreq) {
    const s = $66bc0de6c34dec28$export$b36281d89752ae66(opts, timerOrFreq);
    return ()=>{
        const v = s.next();
        if (v.done) return 1;
        return v.value;
    };
}
var $66bc0de6c34dec28$export$369244a33b71ee5b = (opts = {})=>{
    const from = 0;
    const to = 1;
    const mass = opts.mass ?? 1;
    const stiffness = opts.stiffness ?? 100;
    const soft = opts.soft ?? false;
    const damping = opts.damping ?? 10;
    const velocity = opts.velocity ?? 0.1;
    const delta = to - from;
    if (soft || 1 <= damping / (2 * Math.sqrt(stiffness * mass))) {
        const angularFrequency = -Math.sqrt(stiffness / mass);
        const leftover = -angularFrequency * delta - velocity;
        return (t)=>to - (delta + t * leftover) * Math.E ** (t * angularFrequency);
    } else {
        const dampingFrequency = Math.sqrt(4 * mass * stiffness - damping ** 2);
        const leftover = (damping * delta - 2 * mass * velocity) / dampingFrequency;
        const dfm = 0.5 * dampingFrequency / mass;
        const dm = -(0.5 * damping) / mass;
        return (t)=>to - (Math.cos(t * dfm) * delta + Math.sin(t * dfm) * leftover) * Math.E ** (t * dm);
    }
};
// src/modulation/TimingSourceFactory.ts
var $66bc0de6c34dec28$export$89116902dc8ea29a = (source, duration, options = {})=>{
    switch(source){
        case `elapsed`:
            return ()=>$66bc0de6c34dec28$var$elapsed(duration, options);
        case `bpm`:
            return ()=>$66bc0de6c34dec28$var$bpm(duration, options);
        case `hertz`:
            return ()=>$66bc0de6c34dec28$var$hertz(duration, options);
        default:
            throw new Error(`Unknown source '${source}'. Expected: 'elapsed', 'hertz' or 'bpm'`);
    }
};
// src/modulation/Waveforms.ts
function $66bc0de6c34dec28$export$759c34781c6bf17c(period = 1) {
    period = 1 / period;
    const halfPeriod = period / 2;
    return (t)=>{
        const v = Math.abs(t % period - halfPeriod);
        return v;
    };
}
function $66bc0de6c34dec28$export$259f63e2ea91af28(period = 1) {
    period = 1 / period;
    const halfPeriod = period / 2;
    return (t)=>{
        return t % period < halfPeriod ? 1 : 0;
    };
}
function $66bc0de6c34dec28$export$e1bb5181fba3eb65(period = 1) {
    period = period * (Math.PI * 2);
    return (t)=>{
        const v = (Math.sin(t * period) + 1) / 2;
        return v;
    };
}
function $66bc0de6c34dec28$export$797af250190e49de(period = 1) {
    period = period * (Math.PI * 2);
    return (t)=>Math.abs(Math.sin(t * period));
}
function $66bc0de6c34dec28$export$7d357f1a913b486a(period = 1) {
    period = period * (Math.PI * 2);
    return (t)=>Math.sin(t * period);
}
function $66bc0de6c34dec28$export$3af1cb7633944de2(options) {
    const shape = options.shape ?? `sine`;
    const invert = options.invert ?? false;
    const period = options.period ?? 1;
    let sourceFn;
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(period, `aboveZero`, `period`);
    const sourceOptions = {
        ...options
    };
    if (options.ticks) sourceFn = $66bc0de6c34dec28$var$ticks2(options.ticks, sourceOptions);
    else if (options.hertz) sourceFn = $66bc0de6c34dec28$var$hertz(options.hertz, sourceOptions);
    else if (options.millis) sourceFn = $66bc0de6c34dec28$var$elapsed(options.millis, sourceOptions);
    else if (options.source) sourceFn = options.source;
    else {
        const secs = options.secs ?? 5;
        sourceFn = $66bc0de6c34dec28$var$elapsed(secs * 1e3, sourceOptions);
    }
    let shaperFn;
    switch(shape){
        case `saw`:
            shaperFn = (v)=>v;
            break;
        case `sine`:
            shaperFn = $66bc0de6c34dec28$export$e1bb5181fba3eb65(period);
            break;
        case `sine-bipolar`:
            shaperFn = $66bc0de6c34dec28$export$7d357f1a913b486a(period);
            break;
        case `square`:
            shaperFn = $66bc0de6c34dec28$export$259f63e2ea91af28(period);
            break;
        case `triangle`:
            shaperFn = $66bc0de6c34dec28$export$759c34781c6bf17c(period);
            break;
        case `arc`:
            shaperFn = $66bc0de6c34dec28$export$797af250190e49de(period);
            break;
        default:
            throw new Error(`Unknown wave shape '${shape}'. Expected: sine, sine-bipolar, saw, triangle, arc or square`);
    }
    return $66bc0de6c34dec28$export$c67b33f511f2d0e7(sourceFn, shaperFn, invert);
}
function $66bc0de6c34dec28$export$c67b33f511f2d0e7(sourceFn, shaperFn, invert = false) {
    return (feedback)=>{
        let v = sourceFn(feedback?.clock);
        if (feedback?.override) v = feedback.override;
        v = shaperFn(v);
        if (invert) v = 1 - v;
        return v;
    };
}
// src/modulation/WeightedAverage.ts
var $66bc0de6c34dec28$export$ac406cb80381c5f9 = (currentValue, targetValue, slowDownFactor)=>{
    return (currentValue * (slowDownFactor - 1) + targetValue) / slowDownFactor;
};


// src/random/Guid.ts
var $3908e3e0730c98b2$export$310c142d2eb4f21b = (options = {})=>{
    const source = options.source ?? Math.random;
    const firstPart = Math.trunc(source() * 46656);
    const secondPart = Math.trunc(source() * 46656);
    const firstPartString = `000${firstPart.toString(36)}`.slice(-3);
    const secondPartString = `000${secondPart.toString(36)}`.slice(-3);
    return firstPartString + secondPartString;
};











// src/random/index.ts
var $b0a7efddca14ba20$export$a0af2c4246be0e92 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($b0a7efddca14ba20$export$a0af2c4246be0e92, {
    arrayElement: ()=>(0, $7b02fea154055fc0$export$d3d80cee07107776),
    arrayIndex: ()=>(0, $7b02fea154055fc0$export$23b1f9ce5361528e),
    calculateNonZero: ()=>$b0a7efddca14ba20$export$e0b0bf3bba600973,
    chance: ()=>$b0a7efddca14ba20$export$3c20c3b4fe44b7c5,
    float: ()=>(0, $ecc9b4c6822e4e6b$export$6b5cd3983e3ee5ab),
    floatSource: ()=>(0, $ecc9b4c6822e4e6b$export$a627116c255f4dc3),
    gaussian: ()=>$b0a7efddca14ba20$export$b2743cdc8f493e4c,
    gaussianSource: ()=>$b0a7efddca14ba20$export$59fe3d87a94b1b37,
    hue: ()=>(0, $8a5cbeb1c6ae1b41$export$d870adf6a93a40c),
    integer: ()=>$b0a7efddca14ba20$export$32744b5b3bba4764,
    integerSource: ()=>$b0a7efddca14ba20$export$f3d206fdebefb48a,
    integerUniqueGen: ()=>$b0a7efddca14ba20$export$f1366342e1a59c96,
    mersenneTwister: ()=>$b0a7efddca14ba20$export$9773339abeb8169e,
    minutesMs: ()=>$b0a7efddca14ba20$export$6445ef13ee09ed35,
    minutesMsSource: ()=>$b0a7efddca14ba20$export$2695e9494fdbac36,
    secondsMs: ()=>$b0a7efddca14ba20$export$e002e134944a55b0,
    secondsMsSource: ()=>$b0a7efddca14ba20$export$b82d7cfcc288ca2b,
    shortGuid: ()=>(0, $3908e3e0730c98b2$export$310c142d2eb4f21b),
    string: ()=>(0, $ae8f83c19bfd8110$export$22b082955e083ec3),
    weighted: ()=>$b0a7efddca14ba20$export$4f04228877afea7c,
    weightedIndex: ()=>(0, $7b02fea154055fc0$export$68443f7d8ee0abd1),
    weightedInteger: ()=>$b0a7efddca14ba20$export$2835e07a607f4b3c,
    weightedIntegerSource: ()=>$b0a7efddca14ba20$export$18244775060f5fe6,
    weightedSource: ()=>$b0a7efddca14ba20$export$726a54de6a0640da
});
// src/random/Chance.ts
var $b0a7efddca14ba20$export$3c20c3b4fe44b7c5 = (p, a, b, randomSource)=>{
    const source = randomSource ?? Math.random;
    const resolve = (x)=>{
        if (typeof x === `function`) return x();
        return x;
    };
    const pp = resolve(p);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(pp, `percentage`, `p`);
    if (source() <= pp) return resolve(b);
    else return resolve(a);
};
// src/random/NonZero.ts
var $b0a7efddca14ba20$export$e0b0bf3bba600973 = (source = Math.random)=>{
    let v = 0;
    while(v === 0)v = source();
    return v;
};
// src/random/Gaussian.ts
var $b0a7efddca14ba20$export$b2743cdc8f493e4c = (skew = 1)=>$b0a7efddca14ba20$export$59fe3d87a94b1b37(skew)();
var $b0a7efddca14ba20$export$59fe3d87a94b1b37 = (skew = 1)=>{
    const min = 0;
    const max = 1;
    const compute = ()=>{
        const u = $b0a7efddca14ba20$export$e0b0bf3bba600973();
        const v = $b0a7efddca14ba20$export$e0b0bf3bba600973();
        let result = Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
        result = result / 10 + 0.5;
        if (result > 1 || result < 0) result = compute();
        else {
            result = Math.pow(result, skew);
            result *= max - min;
            result += min;
        }
        return result;
    };
    return compute;
};
// src/random/Integer.ts
var $b0a7efddca14ba20$export$f3d206fdebefb48a = (maxOrOptions)=>{
    if (typeof maxOrOptions === `undefined`) throw new TypeError(`maxOrOptions is undefined`);
    const options = typeof maxOrOptions === `number` ? {
        max: maxOrOptions
    } : maxOrOptions;
    let max = Math.floor(options.max);
    let min = Math.floor(options.min ?? 0);
    if (!options.min && max < 0) {
        max = 1;
        min = options.max;
    }
    const randomSource = options.source ?? Math.random;
    if (min > max) throw new Error(`Min value is greater than max (min: ${min} max: ${max})`);
    (0, $984cc5641d701af3$export$3c71f17eb3232c2e)((0, $984cc5641d701af3$export$4e9798519a1d5a63)(min, ``, `min`));
    (0, $984cc5641d701af3$export$3c71f17eb3232c2e)((0, $984cc5641d701af3$export$4e9798519a1d5a63)(max, ``, `max`));
    if (max === min) throw new Error(`Max and min values cannot be the same (${max})`);
    const amt = Math.abs(max - min);
    return ()=>Math.floor(randomSource() * amt) + min;
};
var $b0a7efddca14ba20$export$32744b5b3bba4764 = (maxOrOptions)=>$b0a7efddca14ba20$export$f3d206fdebefb48a(maxOrOptions)();
function* $b0a7efddca14ba20$export$f1366342e1a59c96(maxOrOptions) {
    const options = typeof maxOrOptions === `number` ? {
        max: maxOrOptions
    } : maxOrOptions;
    const min = options.min ?? 0;
    const max = options.max;
    const source = options.source ?? Math.random;
    const loop = options.loop ?? false;
    (0, $984cc5641d701af3$export$3c71f17eb3232c2e)((0, $984cc5641d701af3$export$a92c1e031174f8ef)(min, ``, `min`));
    (0, $984cc5641d701af3$export$3c71f17eb3232c2e)((0, $984cc5641d701af3$export$a92c1e031174f8ef)(max, ``, `max`));
    if (min > max) throw new Error(`Min value is greater than max. Min: ${min} Max: ${max}`);
    const origRange = [
        ...(0, $ecc9b4c6822e4e6b$export$85b9a36db797e02b)(max - min, min)
    ];
    let numberRange = (0, $7b02fea154055fc0$export$448332262467e042)(origRange);
    let index = 0;
    while(true){
        if (index === numberRange.length) {
            if (loop) numberRange = (0, $7b02fea154055fc0$export$448332262467e042)(origRange, source);
            else return;
        }
        yield numberRange[index++];
    }
}
// src/random/Seeded.ts
function $b0a7efddca14ba20$export$9773339abeb8169e(seed) {
    if (!seed) seed = Math.random() * 4294967295;
    let mt = new Array(624);
    mt[0] = seed >>> 0;
    const n1 = 1812433253;
    for(let mti2 = 1; mti2 < 624; mti2++){
        const n2 = mt[mti2 - 1] ^ mt[mti2 - 1] >>> 30;
        mt[mti2] = ((n1 & 4294901760) * n2 >>> 0) + ((n1 & 65535) * n2 >>> 0) + mti2 >>> 0;
    }
    let mti = 624;
    const randomUint32 = ()=>{
        let y;
        if (mti >= 624) {
            for(let i = 0; i < 227; i++){
                y = (mt[i] & 2147483648 | mt[i + 1] & 2147483647) >>> 0;
                mt[i] = (mt[i + 397] ^ y >>> 1 ^ (y & 1 ? 2567483615 : 0)) >>> 0;
            }
            for(let i = 227; i < 623; i++){
                y = (mt[i] & 2147483648 | mt[i + 1] & 2147483647) >>> 0;
                mt[i] = (mt[i - 227] ^ y >>> 1 ^ (y & 1 ? 2567483615 : 0)) >>> 0;
            }
            y = (mt[623] & 2147483648 | mt[0] & 2147483647) >>> 0;
            mt[623] = (mt[396] ^ y >>> 1 ^ (y & 1 ? 2567483615 : 0)) >>> 0;
            mti = 0;
        }
        y = mt[mti++];
        y = (y ^ y >>> 11) >>> 0;
        y = (y ^ y << 7 & 2636928640) >>> 0;
        y = (y ^ y << 15 & 4022730752) >>> 0;
        y = (y ^ y >>> 18) >>> 0;
        return y;
    };
    const float2 = ()=>randomUint32() / 4294967296;
    const integer2 = (maxExclusive, minInclusive = 0)=>{
        if (maxExclusive < 1) throw new Error("Upper bound must be greater than or equal to 1");
        if (maxExclusive > 4294967296) throw new Error("Upper bound must not be greater than 4294967296");
        if (maxExclusive === 1) return 0;
        let range = maxExclusive - minInclusive;
        const bitsNeeded = Math.ceil(Math.log2(range)), bitMask = (1 << bitsNeeded) - 1;
        while(true){
            const int = randomUint32() & bitMask;
            if (int < range) return minInclusive + int;
        }
    };
    return {
        integer: integer2,
        float: float2
    };
}
// src/random/Time.ts
var $b0a7efddca14ba20$export$2695e9494fdbac36 = (maxMinutesOrOptions)=>{
    const options = typeof maxMinutesOrOptions === `number` ? {
        max: maxMinutesOrOptions
    } : maxMinutesOrOptions;
    const min = (options.min ?? 0) * 60000;
    const max = options.max * 60000;
    return $b0a7efddca14ba20$export$f3d206fdebefb48a({
        ...options,
        max: max,
        min: min
    });
};
var $b0a7efddca14ba20$export$6445ef13ee09ed35 = (maxMinutesOrOptions)=>$b0a7efddca14ba20$export$2695e9494fdbac36(maxMinutesOrOptions)();
var $b0a7efddca14ba20$export$b82d7cfcc288ca2b = (maxSecondsOrOptions)=>{
    const options = typeof maxSecondsOrOptions === `number` ? {
        max: maxSecondsOrOptions
    } : maxSecondsOrOptions;
    const min = (options.min ?? 0) * 1e3;
    const max = options.max * 1e3;
    return ()=>$b0a7efddca14ba20$export$32744b5b3bba4764({
            ...options,
            max: max,
            min: min
        });
};
var $b0a7efddca14ba20$export$e002e134944a55b0 = (maxSecondsOrOptions)=>$b0a7efddca14ba20$export$b82d7cfcc288ca2b(maxSecondsOrOptions)();
// src/random/Weighted.ts
var $b0a7efddca14ba20$export$4f04228877afea7c = (easingNameOrOptions = `quadIn`)=>$b0a7efddca14ba20$export$726a54de6a0640da(easingNameOrOptions)();
var $b0a7efddca14ba20$export$726a54de6a0640da = (easingNameOrOptions = `quadIn`)=>{
    const options = typeof easingNameOrOptions === `string` ? {
        easing: easingNameOrOptions
    } : easingNameOrOptions;
    const source = options.source ?? (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    const easingName = options.easing ?? `quadIn`;
    const easingFunction = (0, $2edc1eef02a7c199$export$3988ae62b71be9a3)(easingName);
    if (easingFunction === void 0) throw new Error(`Easing function '${easingName}' not found.`);
    const compute = ()=>{
        const r = source();
        return easingFunction(r);
    };
    return compute;
};
// src/random/WeightedInteger.ts
var $b0a7efddca14ba20$export$18244775060f5fe6 = (maxOrOptions)=>{
    const options = typeof maxOrOptions === `number` ? {
        max: maxOrOptions
    } : maxOrOptions;
    const source = options.source ?? (0, $a434a6e836fe5827$export$7b5b9f2074b71a21);
    const max = options.max;
    const min = options.min ?? 0;
    const easingName = options.easing ?? `quadIn`;
    if (typeof max === `undefined`) throw new Error(`max field is undefined`);
    if (typeof easingName !== `string`) throw new TypeError(`easing field expected to be string`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(max);
    const easingFunction = (0, $2edc1eef02a7c199$export$3988ae62b71be9a3)(easingName);
    if (easingFunction === void 0) throw new Error(`Easing '${easingName}' not found`);
    (0, $984cc5641d701af3$export$d60fcb8dda779864)(min);
    if (max <= min) throw new Error(`Max should be greater than min`);
    const compute = ()=>{
        const r = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(easingFunction(source()));
        return Math.floor(r * (max - min)) + min;
    };
    return compute;
};
var $b0a7efddca14ba20$export$2835e07a607f4b3c = (maxOrOptions)=>$b0a7efddca14ba20$export$18244775060f5fe6(maxOrOptions)();



























































// feel free to comment out anything to rollup
// a smaller chroma.js bundle
const { min: $736df1275014d0d7$var$min, max: $736df1275014d0d7$var$max } = Math;
var $736df1275014d0d7$export$2e2bcd8739ae039 = (x, low = 0, high = 1)=>{
    return $736df1275014d0d7$var$min($736df1275014d0d7$var$max(low, x), high);
};


var $12c6616da0b78d4a$export$2e2bcd8739ae039 = (rgb)=>{
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for(let i = 0; i <= 3; i++){
        if (i < 3) {
            if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
            rgb[i] = (0, $736df1275014d0d7$export$2e2bcd8739ae039)(rgb[i], 0, 255);
        } else if (i === 3) rgb[i] = (0, $736df1275014d0d7$export$2e2bcd8739ae039)(rgb[i], 0, 1);
    }
    return rgb;
};



// ported from jQuery's $.type
const $8d97f317ec52e7fe$var$classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
])$8d97f317ec52e7fe$var$classToType[`[object ${name}]`] = name.toLowerCase();
function $8d97f317ec52e7fe$export$2e2bcd8739ae039(obj) {
    return $8d97f317ec52e7fe$var$classToType[Object.prototype.toString.call(obj)] || 'object';
}



var $41afdaa7f10d2cae$export$2e2bcd8739ae039 = (args, keyOrder = null)=>{
    // if called with more than 3 arguments, we return the arguments
    if (args.length >= 3) return Array.prototype.slice.call(args);
    // with less than 3 args we check if first arg is object
    // and use the keyOrder string to extract and sort properties
    if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter((k)=>args[0][k] !== undefined).map((k)=>args[0][k]);
    // otherwise we just return the first argument
    // (which we suppose is an array of args)
    return args[0].slice(0);
};



var $80c5cc3ec282600e$export$2e2bcd8739ae039 = (args)=>{
    if (args.length < 2) return null;
    const l = args.length - 1;
    if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};


const { PI: $ea00eaabdb888821$export$6b5c1ceb16d01dc3, min: $ea00eaabdb888821$export$96ec731ed4dcb222, max: $ea00eaabdb888821$export$8960430cfd85939f } = Math;
const $ea00eaabdb888821$export$c6d486233e29f7d1 = (a)=>Math.round(a * 100) / 100;
const $ea00eaabdb888821$export$6ed426801b9660b8 = (a)=>Math.round(a * 100) / 100;
const $ea00eaabdb888821$export$af54f71c879f5ba9 = $ea00eaabdb888821$export$6b5c1ceb16d01dc3 * 2;
const $ea00eaabdb888821$export$e734282486210baf = $ea00eaabdb888821$export$6b5c1ceb16d01dc3 / 3;
const $ea00eaabdb888821$export$460c4029b1a54a2e = $ea00eaabdb888821$export$6b5c1ceb16d01dc3 / 180;
const $ea00eaabdb888821$export$914076c8150813e5 = 180 / $ea00eaabdb888821$export$6b5c1ceb16d01dc3;
/**
 * Reverse the first three elements of an array
 *
 * @param {any[]} arr
 * @returns {any[]}
 */ function $ea00eaabdb888821$export$d0e1128e52417073(arr) {
    return [
        ...arr.slice(0, 3).reverse(),
        ...arr.slice(3)
    ];
}


var $2e79d059439cfd2d$export$2e2bcd8739ae039 = {
    format: {},
    autodetect: []
};


class $148a45b941038e42$var$Color {
    constructor(...args){
        const me = this;
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        let mode = (0, $80c5cc3ec282600e$export$2e2bcd8739ae039)(args);
        let autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).sorted) {
                (0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect = (0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.sort((a, b)=>b.p - a.p);
                (0, $2e79d059439cfd2d$export$2e2bcd8739ae039).sorted = true;
            }
            // auto-detect format
            for (let chk of (0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect){
                mode = chk.test(...args);
                if (mode) break;
            }
        }
        if ((0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format[mode]) {
            const rgb = (0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = (0, $12c6616da0b78d4a$export$2e2bcd8739ae039)(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    }
    toString() {
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(this.hex) == 'function') return this.hex();
        return `[${this._rgb.join(',')}]`;
    }
}
var $148a45b941038e42$export$2e2bcd8739ae039 = $148a45b941038e42$var$Color;


// this gets updated automatically
const $5a9f66f885b83898$export$83d89fbfd8236492 = '3.1.2';


const $66b4ac44dd44053b$var$chroma = (...args)=>{
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args);
};
$66b4ac44dd44053b$var$chroma.version = (0, $5a9f66f885b83898$export$83d89fbfd8236492);
var $66b4ac44dd44053b$export$2e2bcd8739ae039 = $66b4ac44dd44053b$var$chroma;





/**
	X11 color names

	http://www.w3.org/TR/css3-color/#svg-color
*/ const $b35429e4d930afd2$var$w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
var $b35429e4d930afd2$export$2e2bcd8739ae039 = $b35429e4d930afd2$var$w3cx11;


const $fff1bd3e33bdad02$var$RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $fff1bd3e33bdad02$var$RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
const $fff1bd3e33bdad02$var$hex2rgb = (hex)=>{
    if (hex.match($fff1bd3e33bdad02$var$RE_HEX)) {
        // remove optional leading #
        if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
        // expand short-notation to full six-digit
        if (hex.length === 3) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const u = parseInt(hex, 16);
        const r = u >> 16;
        const g = u >> 8 & 0xff;
        const b = u & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    // match rgba hex format, eg #FF000077
    if (hex.match($fff1bd3e33bdad02$var$RE_HEXA)) {
        if (hex.length === 5 || hex.length === 9) // remove optional leading #
        hex = hex.substr(1);
        // expand short-notation to full eight-digit
        if (hex.length === 4) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
        }
        const u = parseInt(hex, 16);
        const r = u >> 24 & 0xff;
        const g = u >> 16 & 0xff;
        const b = u >> 8 & 0xff;
        const a = Math.round((u & 0xff) / 0xff * 100) / 100;
        return [
            r,
            g,
            b,
            a
        ];
    }
    // we used to check for css colors here
    // if _input.css? and rgb = _input.css hex
    //     return rgb
    throw new Error(`unknown hex color: ${hex}`);
};
var $fff1bd3e33bdad02$export$2e2bcd8739ae039 = $fff1bd3e33bdad02$var$hex2rgb;



const { round: $c950ee24ffcbc53c$var$round } = Math;
const $c950ee24ffcbc53c$var$rgb2hex = (...args)=>{
    let [r, g, b, a] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgba');
    let mode = (0, $80c5cc3ec282600e$export$2e2bcd8739ae039)(args) || 'auto';
    if (a === undefined) a = 1;
    if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
    r = $c950ee24ffcbc53c$var$round(r);
    g = $c950ee24ffcbc53c$var$round(g);
    b = $c950ee24ffcbc53c$var$round(b);
    const u = r << 16 | g << 8 | b;
    let str = '000000' + u.toString(16); //#.toUpperCase();
    str = str.substr(str.length - 6);
    let hxa = '0' + $c950ee24ffcbc53c$var$round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    switch(mode.toLowerCase()){
        case 'rgba':
            return `#${str}${hxa}`;
        case 'argb':
            return `#${hxa}${str}`;
        default:
            return `#${str}`;
    }
};
var $c950ee24ffcbc53c$export$2e2bcd8739ae039 = $c950ee24ffcbc53c$var$rgb2hex;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.name = function() {
    const hex = (0, $c950ee24ffcbc53c$export$2e2bcd8739ae039)(this._rgb, 'rgb');
    for (let n of Object.keys((0, $b35429e4d930afd2$export$2e2bcd8739ae039))){
        if ((0, $b35429e4d930afd2$export$2e2bcd8739ae039)[n] === hex) return n.toLowerCase();
    }
    return hex;
};
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.named = (name)=>{
    name = name.toLowerCase();
    if ((0, $b35429e4d930afd2$export$2e2bcd8739ae039)[name]) return (0, $fff1bd3e33bdad02$export$2e2bcd8739ae039)((0, $b35429e4d930afd2$export$2e2bcd8739ae039)[name]);
    throw new Error('unknown color name: ' + name);
};
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(h) === 'string' && (0, $b35429e4d930afd2$export$2e2bcd8739ae039)[h.toLowerCase()]) return 'named';
    }
});




(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.alpha = function(a, mutate = false) {
    if (a !== undefined && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(a) === 'number') {
        if (mutate) {
            this._rgb[3] = a;
            return this;
        }
        return new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ], 'rgb');
    }
    return this._rgb[3];
};



(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.clipped = function() {
    return this._rgb._clipped || false;
};






const $58cafc56806a922f$var$labConstants = {
    // Corresponds roughly to RGB brighter/darker
    Kn: 18,
    // D65 standard referent
    labWhitePoint: 'd65',
    Xn: 0.95047,
    Yn: 1,
    Zn: 1.08883,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452,
    kE: 216.0 / 24389.0,
    kKE: 8.0,
    kK: 24389.0 / 27.0,
    RefWhiteRGB: {
        // sRGB
        X: 0.95047,
        Y: 1,
        Z: 1.08883
    },
    MtxRGB2XYZ: {
        m00: 0.4124564390896922,
        m01: 0.21267285140562253,
        m02: 0.0193338955823293,
        m10: 0.357576077643909,
        m11: 0.715152155287818,
        m12: 0.11919202588130297,
        m20: 0.18043748326639894,
        m21: 0.07217499330655958,
        m22: 0.9503040785363679
    },
    MtxXYZ2RGB: {
        m00: 3.2404541621141045,
        m01: -0.9692660305051868,
        m02: 0.055643430959114726,
        m10: -1.5371385127977166,
        m11: 1.8760108454466942,
        m12: -0.2040259135167538,
        m20: -0.498531409556016,
        m21: 0.041556017530349834,
        m22: 1.0572251882231791
    },
    // used in rgb2xyz
    As: 0.9414285350000001,
    Bs: 1.040417467,
    Cs: 1.089532651,
    MtxAdaptMa: {
        m00: 0.8951,
        m01: -0.7502,
        m02: 0.0389,
        m10: 0.2664,
        m11: 1.7135,
        m12: -0.0685,
        m20: -0.1614,
        m21: 0.0367,
        m22: 1.0296
    },
    MtxAdaptMaI: {
        m00: 0.9869929054667123,
        m01: 0.43230526972339456,
        m02: -0.008528664575177328,
        m10: -0.14705425642099013,
        m11: 0.5183602715367776,
        m12: 0.04004282165408487,
        m20: 0.15996265166373125,
        m21: 0.0492912282128556,
        m22: 0.9684866957875502
    }
};
var $58cafc56806a922f$export$2e2bcd8739ae039 = $58cafc56806a922f$var$labConstants;
// taken from https://de.mathworks.com/help/images/ref/whitepoint.html
const $58cafc56806a922f$var$ILLUMINANTS = new Map([
    // ASTM E308-01
    [
        'a',
        [
            1.0985,
            0.35585
        ]
    ],
    // Wyszecki & Stiles, p. 769
    [
        'b',
        [
            1.0985,
            0.35585
        ]
    ],
    // C ASTM E308-01
    [
        'c',
        [
            0.98074,
            1.18232
        ]
    ],
    // D50 (ASTM E308-01)
    [
        'd50',
        [
            0.96422,
            0.82521
        ]
    ],
    // D55 (ASTM E308-01)
    [
        'd55',
        [
            0.95682,
            0.92149
        ]
    ],
    // D65 (ASTM E308-01)
    [
        'd65',
        [
            0.95047,
            1.08883
        ]
    ],
    // E (ASTM E308-01)
    [
        'e',
        [
            1,
            1,
            1
        ]
    ],
    // F2 (ASTM E308-01)
    [
        'f2',
        [
            0.99186,
            0.67393
        ]
    ],
    // F7 (ASTM E308-01)
    [
        'f7',
        [
            0.95041,
            1.08747
        ]
    ],
    // F11 (ASTM E308-01)
    [
        'f11',
        [
            1.00962,
            0.6435
        ]
    ],
    [
        'icc',
        [
            0.96422,
            0.82521
        ]
    ]
]);
function $58cafc56806a922f$export$23f27f4cae67c045(name) {
    const ill = $58cafc56806a922f$var$ILLUMINANTS.get(String(name).toLowerCase());
    if (!ill) throw new Error('unknown Lab illuminant ' + name);
    $58cafc56806a922f$var$labConstants.labWhitePoint = name;
    $58cafc56806a922f$var$labConstants.Xn = ill[0];
    $58cafc56806a922f$var$labConstants.Zn = ill[1];
}
function $58cafc56806a922f$export$922c3afbcbc31cb3() {
    return $58cafc56806a922f$var$labConstants.labWhitePoint;
}



/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $42529912c0955113$var$lab2rgb = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lab');
    const [L, a, b] = args;
    const [x, y, z] = $42529912c0955113$var$lab2xyz(L, a, b);
    const [r, g, b_] = $42529912c0955113$export$22cbacf088b0f5c6(x, y, z);
    return [
        r,
        g,
        b_,
        args.length > 3 ? args[3] : 1
    ];
};
const $42529912c0955113$var$lab2xyz = (L, a, b)=>{
    const { kE: kE, kK: kK, kKE: kKE, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $58cafc56806a922f$export$2e2bcd8739ae039);
    const fy = (L + 16.0) / 116.0;
    const fx = 0.002 * a + fy;
    const fz = fy - 0.005 * b;
    const fx3 = fx * fx * fx;
    const fz3 = fz * fz * fz;
    const xr = fx3 > kE ? fx3 : (116.0 * fx - 16.0) / kK;
    const yr = L > kKE ? Math.pow((L + 16.0) / 116.0, 3.0) : L / kK;
    const zr = fz3 > kE ? fz3 : (116.0 * fz - 16.0) / kK;
    const x = xr * Xn;
    const y = yr * Yn;
    const z = zr * Zn;
    return [
        x,
        y,
        z
    ];
};
const $42529912c0955113$var$compand = (linear)=>{
    /* sRGB */ const sign = Math.sign(linear);
    linear = Math.abs(linear);
    return (linear <= 0.0031308 ? linear * 12.92 : 1.055 * Math.pow(linear, 1.0 / 2.4) - 0.055) * sign;
};
const $42529912c0955113$export$22cbacf088b0f5c6 = (x, y, z)=>{
    const { MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, MtxXYZ2RGB: MtxXYZ2RGB, RefWhiteRGB: RefWhiteRGB, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $58cafc56806a922f$export$2e2bcd8739ae039);
    const As = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bs = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cs = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    const Ad = RefWhiteRGB.X * MtxAdaptMa.m00 + RefWhiteRGB.Y * MtxAdaptMa.m10 + RefWhiteRGB.Z * MtxAdaptMa.m20;
    const Bd = RefWhiteRGB.X * MtxAdaptMa.m01 + RefWhiteRGB.Y * MtxAdaptMa.m11 + RefWhiteRGB.Z * MtxAdaptMa.m21;
    const Cd = RefWhiteRGB.X * MtxAdaptMa.m02 + RefWhiteRGB.Y * MtxAdaptMa.m12 + RefWhiteRGB.Z * MtxAdaptMa.m22;
    const X1 = (x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20) * (Ad / As);
    const Y1 = (x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21) * (Bd / Bs);
    const Z1 = (x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22) * (Cd / Cs);
    const X2 = X1 * MtxAdaptMaI.m00 + Y1 * MtxAdaptMaI.m10 + Z1 * MtxAdaptMaI.m20;
    const Y2 = X1 * MtxAdaptMaI.m01 + Y1 * MtxAdaptMaI.m11 + Z1 * MtxAdaptMaI.m21;
    const Z2 = X1 * MtxAdaptMaI.m02 + Y1 * MtxAdaptMaI.m12 + Z1 * MtxAdaptMaI.m22;
    const r = $42529912c0955113$var$compand(X2 * MtxXYZ2RGB.m00 + Y2 * MtxXYZ2RGB.m10 + Z2 * MtxXYZ2RGB.m20);
    const g = $42529912c0955113$var$compand(X2 * MtxXYZ2RGB.m01 + Y2 * MtxXYZ2RGB.m11 + Z2 * MtxXYZ2RGB.m21);
    const b = $42529912c0955113$var$compand(X2 * MtxXYZ2RGB.m02 + Y2 * MtxXYZ2RGB.m12 + Z2 * MtxXYZ2RGB.m22);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
var $42529912c0955113$export$2e2bcd8739ae039 = $42529912c0955113$var$lab2rgb;




const $a7c31ff96b23b28a$var$rgb2lab = (...args)=>{
    const [r, g, b, ...rest] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    const [x, y, z] = $a7c31ff96b23b28a$export$fca6d690f89f5907(r, g, b);
    const [L, a, b_] = $a7c31ff96b23b28a$var$xyz2lab(x, y, z);
    return [
        L,
        a,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
function $a7c31ff96b23b28a$var$xyz2lab(x, y, z) {
    const { Xn: Xn, Yn: Yn, Zn: Zn, kE: kE, kK: kK } = (0, $58cafc56806a922f$export$2e2bcd8739ae039);
    const xr = x / Xn;
    const yr = y / Yn;
    const zr = z / Zn;
    const fx = xr > kE ? Math.pow(xr, 1.0 / 3.0) : (kK * xr + 16.0) / 116.0;
    const fy = yr > kE ? Math.pow(yr, 1.0 / 3.0) : (kK * yr + 16.0) / 116.0;
    const fz = zr > kE ? Math.pow(zr, 1.0 / 3.0) : (kK * zr + 16.0) / 116.0;
    return [
        116.0 * fy - 16.0,
        500.0 * (fx - fy),
        200.0 * (fy - fz)
    ];
}
function $a7c31ff96b23b28a$var$gammaAdjustSRGB(companded) {
    const sign = Math.sign(companded);
    companded = Math.abs(companded);
    const linear = companded <= 0.04045 ? companded / 12.92 : Math.pow((companded + 0.055) / 1.055, 2.4);
    return linear * sign;
}
const $a7c31ff96b23b28a$export$fca6d690f89f5907 = (r, g, b)=>{
    // normalize and gamma adjust
    r = $a7c31ff96b23b28a$var$gammaAdjustSRGB(r / 255);
    g = $a7c31ff96b23b28a$var$gammaAdjustSRGB(g / 255);
    b = $a7c31ff96b23b28a$var$gammaAdjustSRGB(b / 255);
    const { MtxRGB2XYZ: MtxRGB2XYZ, MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, Xn: Xn, Yn: Yn, Zn: Zn, As: As, Bs: Bs, Cs: Cs } = (0, $58cafc56806a922f$export$2e2bcd8739ae039);
    let x = r * MtxRGB2XYZ.m00 + g * MtxRGB2XYZ.m10 + b * MtxRGB2XYZ.m20;
    let y = r * MtxRGB2XYZ.m01 + g * MtxRGB2XYZ.m11 + b * MtxRGB2XYZ.m21;
    let z = r * MtxRGB2XYZ.m02 + g * MtxRGB2XYZ.m12 + b * MtxRGB2XYZ.m22;
    const Ad = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bd = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cd = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    let X = x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20;
    let Y = x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21;
    let Z = x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22;
    X *= Ad / As;
    Y *= Bd / Bs;
    Z *= Cd / Cs;
    x = X * MtxAdaptMaI.m00 + Y * MtxAdaptMaI.m10 + Z * MtxAdaptMaI.m20;
    y = X * MtxAdaptMaI.m01 + Y * MtxAdaptMaI.m11 + Z * MtxAdaptMaI.m21;
    z = X * MtxAdaptMaI.m02 + Y * MtxAdaptMaI.m12 + Z * MtxAdaptMaI.m22;
    return [
        x,
        y,
        z
    ];
};
var $a7c31ff96b23b28a$export$2e2bcd8739ae039 = $a7c31ff96b23b28a$var$rgb2lab;



(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.lab = function() {
    return (0, $a7c31ff96b23b28a$export$2e2bcd8739ae039)(this._rgb);
};
const $39fd4d03ad074168$export$c83fb8f9027a6338 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'lab');
Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    lab: $39fd4d03ad074168$export$c83fb8f9027a6338,
    getLabWhitePoint: $58cafc56806a922f$export$922c3afbcbc31cb3,
    setLabWhitePoint: $58cafc56806a922f$export$23f27f4cae67c045
});
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.lab = (0, $42529912c0955113$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lab');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'lab';
    }
});




(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.darken = function(amount = 1) {
    const me = this;
    const lab = me.lab();
    lab[0] -= (0, $58cafc56806a922f$export$2e2bcd8739ae039).Kn * amount;
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(lab, 'lab').alpha(me.alpha(), true);
};
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.brighten = function(amount = 1) {
    return this.darken(-amount);
};
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.darker = (0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.darken;
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.brighter = (0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.brighten;



(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.get = function(mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};




const { pow: $86bbbbd0093d3d1e$var$pow } = Math;
const $86bbbbd0093d3d1e$var$EPS = 1e-7;
const $86bbbbd0093d3d1e$var$MAX_ITER = 20;
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.luminance = function(lum, mode = 'rgb') {
    if (lum !== undefined && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(lum) === 'number') {
        if (lum === 0) // return pure black
        return new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
            0,
            0,
            0,
            this._rgb[3]
        ], 'rgb');
        if (lum === 1) // return pure white
        return new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
            255,
            255,
            255,
            this._rgb[3]
        ], 'rgb');
        // compute new color using...
        let cur_lum = this.luminance();
        let max_iter = $86bbbbd0093d3d1e$var$MAX_ITER;
        const test = (low, high)=>{
            const mid = low.interpolate(high, 0.5, mode);
            const lm = mid.luminance();
            if (Math.abs(lum - lm) < $86bbbbd0093d3d1e$var$EPS || !max_iter--) // close enough
            return mid;
            return lm > lum ? test(low, mid) : test(mid, high);
        };
        const rgb = (cur_lum > lum ? test(new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
            0,
            0,
            0
        ]), this) : test(this, new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
            255,
            255,
            255
        ]))).rgb();
        return new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
            ...rgb,
            this._rgb[3]
        ]);
    }
    return $86bbbbd0093d3d1e$var$rgb2luminance(...this._rgb.slice(0, 3));
};
const $86bbbbd0093d3d1e$var$rgb2luminance = (r, g, b)=>{
    // relative luminance
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    r = $86bbbbd0093d3d1e$var$luminance_x(r);
    g = $86bbbbd0093d3d1e$var$luminance_x(g);
    b = $86bbbbd0093d3d1e$var$luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $86bbbbd0093d3d1e$var$luminance_x = (x)=>{
    x /= 255;
    return x <= 0.03928 ? x / 12.92 : $86bbbbd0093d3d1e$var$pow((x + 0.055) / 1.055, 2.4);
};





var $6a042165d06e6ff4$export$2e2bcd8739ae039 = {};


var $4587e4758d36f610$export$2e2bcd8739ae039 = (col1, col2, f = 0.5, ...rest)=>{
    let mode = rest[0] || 'lrgb';
    if (!(0, $6a042165d06e6ff4$export$2e2bcd8739ae039)[mode] && !rest.length) // fall back to the first supported mode
    mode = Object.keys((0, $6a042165d06e6ff4$export$2e2bcd8739ae039))[0];
    if (!(0, $6a042165d06e6ff4$export$2e2bcd8739ae039)[mode]) throw new Error(`interpolation mode ${mode} is not defined`);
    if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(col1) !== 'object') col1 = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(col1);
    if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(col2) !== 'object') col2 = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(col2);
    return (0, $6a042165d06e6ff4$export$2e2bcd8739ae039)[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
};


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.mix = (0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.interpolate = function(col2, f = 0.5, ...rest) {
    return (0, $4587e4758d36f610$export$2e2bcd8739ae039)(this, col2, f, ...rest);
};



(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.premultiply = function(mutate = false) {
    const rgb = this._rgb;
    const a = rgb[3];
    if (mutate) {
        this._rgb = [
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ];
        return this;
    } else return new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
        rgb[0] * a,
        rgb[1] * a,
        rgb[2] * a,
        a
    ], 'rgb');
};








const { sin: $98b580e996b50876$var$sin, cos: $98b580e996b50876$var$cos } = Math;
const $98b580e996b50876$var$lch2lab = (...args)=>{
    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.

    A saturation multiplier was added by Gregor Aisch
    */ let [l, c, h] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lch');
    if (isNaN(h)) h = 0;
    h = h * (0, $ea00eaabdb888821$export$460c4029b1a54a2e);
    return [
        l,
        $98b580e996b50876$var$cos(h) * c,
        $98b580e996b50876$var$sin(h) * c
    ];
};
var $98b580e996b50876$export$2e2bcd8739ae039 = $98b580e996b50876$var$lch2lab;



const $b700aa6de263b4a4$var$lch2rgb = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $98b580e996b50876$export$2e2bcd8739ae039)(l, c, h);
    const [r, g, b] = (0, $42529912c0955113$export$2e2bcd8739ae039)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $b700aa6de263b4a4$export$2e2bcd8739ae039 = $b700aa6de263b4a4$var$lch2rgb;




const $62ada53dad8bc920$var$hcl2rgb = (...args)=>{
    const hcl = (0, $ea00eaabdb888821$export$d0e1128e52417073)((0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hcl'));
    return (0, $b700aa6de263b4a4$export$2e2bcd8739ae039)(...hcl);
};
var $62ada53dad8bc920$export$2e2bcd8739ae039 = $62ada53dad8bc920$var$hcl2rgb;





const { sqrt: $2b3cb66ec4705564$var$sqrt, atan2: $2b3cb66ec4705564$var$atan2, round: $2b3cb66ec4705564$var$round } = Math;
const $2b3cb66ec4705564$var$lab2lch = (...args)=>{
    const [l, a, b] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lab');
    const c = $2b3cb66ec4705564$var$sqrt(a * a + b * b);
    let h = ($2b3cb66ec4705564$var$atan2(b, a) * (0, $ea00eaabdb888821$export$914076c8150813e5) + 360) % 360;
    if ($2b3cb66ec4705564$var$round(c * 10000) === 0) h = Number.NaN;
    return [
        l,
        c,
        h
    ];
};
var $2b3cb66ec4705564$export$2e2bcd8739ae039 = $2b3cb66ec4705564$var$lab2lch;


const $7e0c7382aa3acf1e$var$rgb2lch = (...args)=>{
    const [r, g, b, ...rest] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    const [l, a, b_] = (0, $a7c31ff96b23b28a$export$2e2bcd8739ae039)(r, g, b);
    const [L, c, h] = (0, $2b3cb66ec4705564$export$2e2bcd8739ae039)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $7e0c7382aa3acf1e$export$2e2bcd8739ae039 = $7e0c7382aa3acf1e$var$rgb2lch;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.lch = function() {
    return (0, $7e0c7382aa3acf1e$export$2e2bcd8739ae039)(this._rgb);
};
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.hcl = function() {
    return (0, $ea00eaabdb888821$export$d0e1128e52417073)((0, $7e0c7382aa3acf1e$export$2e2bcd8739ae039)(this._rgb));
};
const $ee5d31ac0e5f4010$export$5a21418738164530 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'lch');
const $ee5d31ac0e5f4010$export$d0e870ba50062ff1 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'hcl');
Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    lch: $ee5d31ac0e5f4010$export$5a21418738164530,
    hcl: $ee5d31ac0e5f4010$export$d0e870ba50062ff1
});
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.lch = (0, $b700aa6de263b4a4$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.hcl = (0, $62ada53dad8bc920$export$2e2bcd8739ae039);
[
    'lch',
    'hcl'
].forEach((m)=>(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
        p: 2,
        test: (...args)=>{
            args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, m);
            if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return m;
        }
    }));




(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.saturate = function(amount = 1) {
    const me = this;
    const lch = me.lch();
    lch[1] += (0, $58cafc56806a922f$export$2e2bcd8739ae039).Kn * amount;
    if (lch[1] < 0) lch[1] = 0;
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(lch, 'lch').alpha(me.alpha(), true);
};
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.desaturate = function(amount = 1) {
    return this.saturate(-amount);
};




(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.set = function(mc, value, mutate = false) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) {
            if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(value) == 'string') switch(value.charAt(0)){
                case '+':
                    src[i] += +value;
                    break;
                case '-':
                    src[i] += +value;
                    break;
                case '*':
                    src[i] *= +value.substr(1);
                    break;
                case '/':
                    src[i] /= +value.substr(1);
                    break;
                default:
                    src[i] = +value;
            }
            else if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(value) === 'number') src[i] = value;
            else throw new Error(`unsupported value for Color.set`);
            const out = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(src, mode);
            if (mutate) {
                this._rgb = out._rgb;
                return this;
            }
            return out;
        }
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};





(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.tint = function(f = 0.5, ...rest) {
    return (0, $4587e4758d36f610$export$2e2bcd8739ae039)(this, 'white', f, ...rest);
};
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.shade = function(f = 0.5, ...rest) {
    return (0, $4587e4758d36f610$export$2e2bcd8739ae039)(this, 'black', f, ...rest);
};




const $397688d3cd50a563$var$rgb = (col1, col2, f)=>{
    const xyz0 = col1._rgb;
    const xyz1 = col2._rgb;
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).rgb = $397688d3cd50a563$var$rgb;
var $397688d3cd50a563$export$2e2bcd8739ae039 = $397688d3cd50a563$var$rgb;




const { sqrt: $680dd028141c6bc6$var$sqrt, pow: $680dd028141c6bc6$var$pow } = Math;
const $680dd028141c6bc6$var$lrgb = (col1, col2, f)=>{
    const [x1, y1, z1] = col1._rgb;
    const [x2, y2, z2] = col2._rgb;
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)($680dd028141c6bc6$var$sqrt($680dd028141c6bc6$var$pow(x1, 2) * (1 - f) + $680dd028141c6bc6$var$pow(x2, 2) * f), $680dd028141c6bc6$var$sqrt($680dd028141c6bc6$var$pow(y1, 2) * (1 - f) + $680dd028141c6bc6$var$pow(y2, 2) * f), $680dd028141c6bc6$var$sqrt($680dd028141c6bc6$var$pow(z1, 2) * (1 - f) + $680dd028141c6bc6$var$pow(z2, 2) * f), 'rgb');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).lrgb = $680dd028141c6bc6$var$lrgb;
var $680dd028141c6bc6$export$2e2bcd8739ae039 = $680dd028141c6bc6$var$lrgb;





const $df8e3f26847b41cd$var$lab = (col1, col2, f)=>{
    const xyz0 = col1.lab();
    const xyz1 = col2.lab();
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).lab = $df8e3f26847b41cd$var$lab;
var $df8e3f26847b41cd$export$2e2bcd8739ae039 = $df8e3f26847b41cd$var$lab;




var $5c2da9cfc53fbfef$export$2e2bcd8739ae039 = (col1, col2, f, m)=>{
    let xyz0, xyz1;
    if (m === 'hsl') {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
    } else if (m === 'hsv') {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
    } else if (m === 'hcg') {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
    } else if (m === 'hsi') {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
        m = 'hcl';
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
    } else if (m === 'oklch') {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
    }
    let hue0, hue1, sat0, sat1, lbv0, lbv1;
    if (m.substr(0, 1) === 'h' || m === 'oklch') {
        [hue0, sat0, lbv0] = xyz0;
        [hue1, sat1, lbv1] = xyz1;
    }
    let sat, hue, lbv, dh;
    if (!isNaN(hue0) && !isNaN(hue1)) {
        // both colors have hue
        if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
        else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
        else dh = hue1 - hue0;
        hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
    } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
    } else hue = Number.NaN;
    if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
    lbv = lbv0 + f * (lbv1 - lbv0);
    return m === 'oklch' ? new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
        lbv,
        sat,
        hue
    ], m) : new (0, $148a45b941038e42$export$2e2bcd8739ae039)([
        hue,
        sat,
        lbv
    ], m);
};



const $a7f9fb4a5188346f$var$lch = (col1, col2, f)=>{
    return (0, $5c2da9cfc53fbfef$export$2e2bcd8739ae039)(col1, col2, f, 'lch');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).lch = $a7f9fb4a5188346f$var$lch;
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).hcl = $a7f9fb4a5188346f$var$lch;
var $a7f9fb4a5188346f$export$2e2bcd8739ae039 = $a7f9fb4a5188346f$var$lch;







const $208fca971d561f6e$var$num2rgb = (num)=>{
    if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(num) == 'number' && num >= 0 && num <= 0xffffff) {
        const r = num >> 16;
        const g = num >> 8 & 0xff;
        const b = num & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    throw new Error('unknown num color: ' + num);
};
var $208fca971d561f6e$export$2e2bcd8739ae039 = $208fca971d561f6e$var$num2rgb;



const $522ff17c797362ca$var$rgb2num = (...args)=>{
    const [r, g, b] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};
var $522ff17c797362ca$export$2e2bcd8739ae039 = $522ff17c797362ca$var$rgb2num;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.num = function() {
    return (0, $522ff17c797362ca$export$2e2bcd8739ae039)(this._rgb);
};
const $2939ea0c9300d249$export$61cc6a0be4938a2a = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'num');
Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    num: $2939ea0c9300d249$export$61cc6a0be4938a2a
});
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.num = (0, $208fca971d561f6e$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (...args)=>{
        if (args.length === 1 && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xffffff) return 'num';
    }
});




const $75154ddbc761a79c$var$num = (col1, col2, f)=>{
    const c1 = col1.num();
    const c2 = col2.num();
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(c1 + f * (c2 - c1), 'num');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).num = $75154ddbc761a79c$var$num;
var $75154ddbc761a79c$export$2e2bcd8739ae039 = $75154ddbc761a79c$var$num;







const { floor: $ee13abbdce1dcc3d$var$floor } = Math;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */ const $ee13abbdce1dcc3d$var$hcg2rgb = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hcg');
    let [h, c, _g] = args;
    let r, g, b;
    _g = _g * 255;
    const _c = c * 255;
    if (c === 0) r = g = b = _g;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $ee13abbdce1dcc3d$var$floor(h);
        const f = h - i;
        const p = _g * (1 - c);
        const q = p + _c * (1 - f);
        const t = p + _c * f;
        const v = p + _c;
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $ee13abbdce1dcc3d$export$2e2bcd8739ae039 = $ee13abbdce1dcc3d$var$hcg2rgb;



const $43d46332ca4627d5$var$rgb2hcg = (...args)=>{
    const [r, g, b] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    const minRgb = (0, $ea00eaabdb888821$export$96ec731ed4dcb222)(r, g, b);
    const maxRgb = (0, $ea00eaabdb888821$export$8960430cfd85939f)(r, g, b);
    const delta = maxRgb - minRgb;
    const c = delta * 100 / 255;
    const _g = minRgb / (255 - delta) * 100;
    let h;
    if (delta === 0) h = Number.NaN;
    else {
        if (r === maxRgb) h = (g - b) / delta;
        if (g === maxRgb) h = 2 + (b - r) / delta;
        if (b === maxRgb) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        c,
        _g
    ];
};
var $43d46332ca4627d5$export$2e2bcd8739ae039 = $43d46332ca4627d5$var$rgb2hcg;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.hcg = function() {
    return (0, $43d46332ca4627d5$export$2e2bcd8739ae039)(this._rgb);
};
const $ef61b44762fb78c3$export$e588e1c8c259384c = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'hcg');
(0, $66b4ac44dd44053b$export$2e2bcd8739ae039).hcg = $ef61b44762fb78c3$export$e588e1c8c259384c;
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.hcg = (0, $ee13abbdce1dcc3d$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 1,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hcg');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hcg';
    }
});




const $dcb8b19bdf1a7d7e$var$hcg = (col1, col2, f)=>{
    return (0, $5c2da9cfc53fbfef$export$2e2bcd8739ae039)(col1, col2, f, 'hcg');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).hcg = $dcb8b19bdf1a7d7e$var$hcg;
var $dcb8b19bdf1a7d7e$export$2e2bcd8739ae039 = $dcb8b19bdf1a7d7e$var$hcg;







const { cos: $aeec1981cc4b1548$var$cos } = Math;
/*
 * hue [0..360]
 * saturation [0..1]
 * intensity [0..1]
 */ const $aeec1981cc4b1548$var$hsi2rgb = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
    */ args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hsi');
    let [h, s, i] = args;
    let r, g, b;
    if (isNaN(h)) h = 0;
    if (isNaN(s)) s = 0;
    // normalize hue
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 360;
    if (h < 1 / 3) {
        b = (1 - s) / 3;
        r = (1 + s * $aeec1981cc4b1548$var$cos((0, $ea00eaabdb888821$export$af54f71c879f5ba9) * h) / $aeec1981cc4b1548$var$cos((0, $ea00eaabdb888821$export$e734282486210baf) - (0, $ea00eaabdb888821$export$af54f71c879f5ba9) * h)) / 3;
        g = 1 - (b + r);
    } else if (h < 2 / 3) {
        h -= 1 / 3;
        r = (1 - s) / 3;
        g = (1 + s * $aeec1981cc4b1548$var$cos((0, $ea00eaabdb888821$export$af54f71c879f5ba9) * h) / $aeec1981cc4b1548$var$cos((0, $ea00eaabdb888821$export$e734282486210baf) - (0, $ea00eaabdb888821$export$af54f71c879f5ba9) * h)) / 3;
        b = 1 - (r + g);
    } else {
        h -= 2 / 3;
        g = (1 - s) / 3;
        b = (1 + s * $aeec1981cc4b1548$var$cos((0, $ea00eaabdb888821$export$af54f71c879f5ba9) * h) / $aeec1981cc4b1548$var$cos((0, $ea00eaabdb888821$export$e734282486210baf) - (0, $ea00eaabdb888821$export$af54f71c879f5ba9) * h)) / 3;
        r = 1 - (g + b);
    }
    r = (0, $736df1275014d0d7$export$2e2bcd8739ae039)(i * r * 3);
    g = (0, $736df1275014d0d7$export$2e2bcd8739ae039)(i * g * 3);
    b = (0, $736df1275014d0d7$export$2e2bcd8739ae039)(i * b * 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        args.length > 3 ? args[3] : 1
    ];
};
var $aeec1981cc4b1548$export$2e2bcd8739ae039 = $aeec1981cc4b1548$var$hsi2rgb;



const { min: $7caa353aede37506$var$min, sqrt: $7caa353aede37506$var$sqrt, acos: $7caa353aede37506$var$acos } = Math;
const $7caa353aede37506$var$rgb2hsi = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
    */ let [r, g, b] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    r /= 255;
    g /= 255;
    b /= 255;
    let h;
    const min_ = $7caa353aede37506$var$min(r, g, b);
    const i = (r + g + b) / 3;
    const s = i > 0 ? 1 - min_ / i : 0;
    if (s === 0) h = NaN;
    else {
        h = (r - g + (r - b)) / 2;
        h /= $7caa353aede37506$var$sqrt((r - g) * (r - g) + (r - b) * (g - b));
        h = $7caa353aede37506$var$acos(h);
        if (b > g) h = (0, $ea00eaabdb888821$export$af54f71c879f5ba9) - h;
        h /= (0, $ea00eaabdb888821$export$af54f71c879f5ba9);
    }
    return [
        h * 360,
        s,
        i
    ];
};
var $7caa353aede37506$export$2e2bcd8739ae039 = $7caa353aede37506$var$rgb2hsi;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.hsi = function() {
    return (0, $7caa353aede37506$export$2e2bcd8739ae039)(this._rgb);
};
const $ca69d5a97cdbda5a$export$ec0e0a10cc3c404a = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'hsi');
(0, $66b4ac44dd44053b$export$2e2bcd8739ae039).hsi = $ca69d5a97cdbda5a$export$ec0e0a10cc3c404a;
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.hsi = (0, $aeec1981cc4b1548$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hsi');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsi';
    }
});




const $b323ed53825477ce$var$hsi = (col1, col2, f)=>{
    return (0, $5c2da9cfc53fbfef$export$2e2bcd8739ae039)(col1, col2, f, 'hsi');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).hsi = $b323ed53825477ce$var$hsi;
var $b323ed53825477ce$export$2e2bcd8739ae039 = $b323ed53825477ce$var$hsi;







const $8e2e15f0a5a80897$var$hsl2rgb = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hsl');
    const [h, s, l] = args;
    let r, g, b;
    if (s === 0) r = g = b = l * 255;
    else {
        const t3 = [
            0,
            0,
            0
        ];
        const c = [
            0,
            0,
            0
        ];
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const h_ = h / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for(let i = 0; i < 3; i++){
            if (t3[i] < 0) t3[i] += 1;
            if (t3[i] > 1) t3[i] -= 1;
            if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
            else if (2 * t3[i] < 1) c[i] = t2;
            else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
            else c[i] = t1;
        }
        [r, g, b] = [
            c[0] * 255,
            c[1] * 255,
            c[2] * 255
        ];
    }
    if (args.length > 3) // keep alpha channel
    return [
        r,
        g,
        b,
        args[3]
    ];
    return [
        r,
        g,
        b,
        1
    ];
};
var $8e2e15f0a5a80897$export$2e2bcd8739ae039 = $8e2e15f0a5a80897$var$hsl2rgb;



/*
 * supported arguments:
 * - rgb2hsl(r,g,b)
 * - rgb2hsl(r,g,b,a)
 * - rgb2hsl([r,g,b])
 * - rgb2hsl([r,g,b,a])
 * - rgb2hsl({r,g,b,a})
 */ const $101fa7fd640572cf$var$rgb2hsl = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgba');
    let [r, g, b] = args;
    r /= 255;
    g /= 255;
    b /= 255;
    const minRgb = (0, $ea00eaabdb888821$export$96ec731ed4dcb222)(r, g, b);
    const maxRgb = (0, $ea00eaabdb888821$export$8960430cfd85939f)(r, g, b);
    const l = (maxRgb + minRgb) / 2;
    let s, h;
    if (maxRgb === minRgb) {
        s = 0;
        h = Number.NaN;
    } else s = l < 0.5 ? (maxRgb - minRgb) / (maxRgb + minRgb) : (maxRgb - minRgb) / (2 - maxRgb - minRgb);
    if (r == maxRgb) h = (g - b) / (maxRgb - minRgb);
    else if (g == maxRgb) h = 2 + (b - r) / (maxRgb - minRgb);
    else if (b == maxRgb) h = 4 + (r - g) / (maxRgb - minRgb);
    h *= 60;
    if (h < 0) h += 360;
    if (args.length > 3 && args[3] !== undefined) return [
        h,
        s,
        l,
        args[3]
    ];
    return [
        h,
        s,
        l
    ];
};
var $101fa7fd640572cf$export$2e2bcd8739ae039 = $101fa7fd640572cf$var$rgb2hsl;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.hsl = function() {
    return (0, $101fa7fd640572cf$export$2e2bcd8739ae039)(this._rgb);
};
const $3af78f2df85d514a$export$8f4a7c0bb78e6ea8 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'hsl');
(0, $66b4ac44dd44053b$export$2e2bcd8739ae039).hsl = $3af78f2df85d514a$export$8f4a7c0bb78e6ea8;
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.hsl = (0, $8e2e15f0a5a80897$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hsl');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsl';
    }
});




const $edc7c1abf244713d$var$hsl = (col1, col2, f)=>{
    return (0, $5c2da9cfc53fbfef$export$2e2bcd8739ae039)(col1, col2, f, 'hsl');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).hsl = $edc7c1abf244713d$var$hsl;
var $edc7c1abf244713d$export$2e2bcd8739ae039 = $edc7c1abf244713d$var$hsl;







const { floor: $4a63018035fa4369$var$floor } = Math;
const $4a63018035fa4369$var$hsv2rgb = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hsv');
    let [h, s, v] = args;
    let r, g, b;
    v *= 255;
    if (s === 0) r = g = b = v;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $4a63018035fa4369$var$floor(h);
        const f = h - i;
        const p = v * (1 - s);
        const q = v * (1 - s * f);
        const t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $4a63018035fa4369$export$2e2bcd8739ae039 = $4a63018035fa4369$var$hsv2rgb;



const { min: $eb1222de31bb8cfd$var$min, max: $eb1222de31bb8cfd$var$max } = Math;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */ const $eb1222de31bb8cfd$var$rgb2hsl = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    let [r, g, b] = args;
    const min_ = $eb1222de31bb8cfd$var$min(r, g, b);
    const max_ = $eb1222de31bb8cfd$var$max(r, g, b);
    const delta = max_ - min_;
    let h, s, v;
    v = max_ / 255.0;
    if (max_ === 0) {
        h = Number.NaN;
        s = 0;
    } else {
        s = delta / max_;
        if (r === max_) h = (g - b) / delta;
        if (g === max_) h = 2 + (b - r) / delta;
        if (b === max_) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        s,
        v
    ];
};
var $eb1222de31bb8cfd$export$2e2bcd8739ae039 = $eb1222de31bb8cfd$var$rgb2hsl;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.hsv = function() {
    return (0, $eb1222de31bb8cfd$export$2e2bcd8739ae039)(this._rgb);
};
const $82359960d0ffa062$export$a5d7c789f12d2213 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'hsv');
(0, $66b4ac44dd44053b$export$2e2bcd8739ae039).hsv = $82359960d0ffa062$export$a5d7c789f12d2213;
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.hsv = (0, $4a63018035fa4369$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hsv');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsv';
    }
});




const $a29e41bb11cb2ba2$var$hsv = (col1, col2, f)=>{
    return (0, $5c2da9cfc53fbfef$export$2e2bcd8739ae039)(col1, col2, f, 'hsv');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).hsv = $a29e41bb11cb2ba2$var$hsv;
var $a29e41bb11cb2ba2$export$2e2bcd8739ae039 = $a29e41bb11cb2ba2$var$hsv;







// from https://www.w3.org/TR/css-color-4/multiply-matrices.js
function $2515f72d6b41a40f$export$2e2bcd8739ae039(A, B) {
    let m = A.length;
    if (!Array.isArray(A[0])) // A is vector, convert to [[a, b, c, ...]]
    A = [
        A
    ];
    if (!Array.isArray(B[0])) // B is vector, convert to [[a], [b], [c], ...]]
    B = B.map((x)=>[
            x
        ]);
    let p = B[0].length;
    let B_cols = B[0].map((_, i)=>B.map((x)=>x[i])); // transpose B
    let product = A.map((row)=>B_cols.map((col)=>{
            if (!Array.isArray(row)) return col.reduce((a, c)=>a + c * row, 0);
            return row.reduce((a, c, i)=>a + c * (col[i] || 0), 0);
        }));
    if (m === 1) product = product[0]; // Avoid [[a, b, c, ...]]
    if (p === 1) return product.map((x)=>x[0]); // Avoid [[a], [b], [c], ...]]
    return product;
}



const $caf36ea7c9bf8bce$var$oklab2rgb = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lab');
    const [L, a, b, ...rest] = args;
    const [X, Y, Z] = $caf36ea7c9bf8bce$var$OKLab_to_XYZ([
        L,
        a,
        b
    ]);
    const [r, g, b_] = (0, $42529912c0955113$export$22cbacf088b0f5c6)(X, Y, Z);
    return [
        r,
        g,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $caf36ea7c9bf8bce$var$OKLab_to_XYZ(OKLab) {
    // Given OKLab, convert to XYZ relative to D65
    var LMStoXYZ = [
        [
            1.2268798758459243,
            -0.5578149944602171,
            0.2813910456659647
        ],
        [
            -0.0405757452148008,
            1.112286803280317,
            -0.0717110580655164
        ],
        [
            -0.0763729366746601,
            -0.4214933324022432,
            1.5869240198367816
        ]
    ];
    var OKLabtoLMS = [
        [
            1.0,
            0.3963377773761749,
            0.2158037573099136
        ],
        [
            1.0,
            -0.1055613458156586,
            -0.0638541728258133
        ],
        [
            1.0,
            -0.0894841775298119,
            -1.2914855480194092
        ]
    ];
    var LMSnl = (0, $2515f72d6b41a40f$export$2e2bcd8739ae039)(OKLabtoLMS, OKLab);
    return (0, $2515f72d6b41a40f$export$2e2bcd8739ae039)(LMStoXYZ, LMSnl.map((c)=>c ** 3));
}
var $caf36ea7c9bf8bce$export$2e2bcd8739ae039 = $caf36ea7c9bf8bce$var$oklab2rgb;





const $149f682f9eaba669$var$rgb2oklab = (...args)=>{
    const [r, g, b, ...rest] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    const xyz = (0, $a7c31ff96b23b28a$export$fca6d690f89f5907)(r, g, b);
    const oklab = $149f682f9eaba669$var$XYZ_to_OKLab(xyz);
    return [
        ...oklab,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $149f682f9eaba669$var$XYZ_to_OKLab(XYZ) {
    // Given XYZ relative to D65, convert to OKLab
    const XYZtoLMS = [
        [
            0.819022437996703,
            0.3619062600528904,
            -0.1288737815209879
        ],
        [
            0.0329836539323885,
            0.9292868615863434,
            0.0361446663506424
        ],
        [
            0.0481771893596242,
            0.2642395317527308,
            0.6335478284694309
        ]
    ];
    const LMStoOKLab = [
        [
            0.210454268309314,
            0.7936177747023054,
            -0.0040720430116193
        ],
        [
            1.9779985324311684,
            -2.42859224204858,
            0.450593709617411
        ],
        [
            0.0259040424655478,
            0.7827717124575296,
            -0.8086757549230774
        ]
    ];
    const LMS = (0, $2515f72d6b41a40f$export$2e2bcd8739ae039)(XYZtoLMS, XYZ);
    // JavaScript Math.cbrt returns a sign-matched cube root
    // beware if porting to other languages
    // especially if tempted to use a general power function
    return (0, $2515f72d6b41a40f$export$2e2bcd8739ae039)(LMStoOKLab, LMS.map((c)=>Math.cbrt(c)));
// L in range [0,1]. For use in CSS, multiply by 100 and add a percent
}
var $149f682f9eaba669$export$2e2bcd8739ae039 = $149f682f9eaba669$var$rgb2oklab;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.oklab = function() {
    return (0, $149f682f9eaba669$export$2e2bcd8739ae039)(this._rgb);
};
const $b472a1d72ca1b39b$export$b14b17e4e916d621 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'oklab');
Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    oklab: $b472a1d72ca1b39b$export$b14b17e4e916d621
});
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.oklab = (0, $caf36ea7c9bf8bce$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'oklab');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'oklab';
    }
});




const $f93ae83de289a003$var$oklab = (col1, col2, f)=>{
    const xyz0 = col1.oklab();
    const xyz1 = col2.oklab();
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).oklab = $f93ae83de289a003$var$oklab;
var $f93ae83de289a003$export$2e2bcd8739ae039 = $f93ae83de289a003$var$oklab;





const $17cfc39c1eebb59e$var$oklch = (col1, col2, f)=>{
    return (0, $5c2da9cfc53fbfef$export$2e2bcd8739ae039)(col1, col2, f, 'oklch');
};
// register interpolator
(0, $6a042165d06e6ff4$export$2e2bcd8739ae039).oklch = $17cfc39c1eebb59e$var$oklch;
var $17cfc39c1eebb59e$export$2e2bcd8739ae039 = $17cfc39c1eebb59e$var$oklch;




const { pow: $aa1c1d3594b8ba94$var$pow, sqrt: $aa1c1d3594b8ba94$var$sqrt, PI: $aa1c1d3594b8ba94$var$PI, cos: $aa1c1d3594b8ba94$var$cos, sin: $aa1c1d3594b8ba94$var$sin, atan2: $aa1c1d3594b8ba94$var$atan2 } = Math;
var $aa1c1d3594b8ba94$export$2e2bcd8739ae039 = (colors, mode = 'lrgb', weights = null)=>{
    const l = colors.length;
    if (!weights) weights = Array.from(new Array(l)).map(()=>1);
    // normalize weights
    const k = l / weights.reduce(function(a, b) {
        return a + b;
    });
    weights.forEach((w, i)=>{
        weights[i] *= k;
    });
    // convert colors to Color objects
    colors = colors.map((c)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(c));
    if (mode === 'lrgb') return $aa1c1d3594b8ba94$var$_average_lrgb(colors, weights);
    const first = colors.shift();
    const xyz = first.get(mode);
    const cnt = [];
    let dx = 0;
    let dy = 0;
    // initial color
    for(let i = 0; i < xyz.length; i++){
        xyz[i] = (xyz[i] || 0) * weights[0];
        cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
        if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
            const A = xyz[i] / 180 * $aa1c1d3594b8ba94$var$PI;
            dx += $aa1c1d3594b8ba94$var$cos(A) * weights[0];
            dy += $aa1c1d3594b8ba94$var$sin(A) * weights[0];
        }
    }
    let alpha = first.alpha() * weights[0];
    colors.forEach((c, ci)=>{
        const xyz2 = c.get(mode);
        alpha += c.alpha() * weights[ci + 1];
        for(let i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
            cnt[i] += weights[ci + 1];
            if (mode.charAt(i) === 'h') {
                const A = xyz2[i] / 180 * $aa1c1d3594b8ba94$var$PI;
                dx += $aa1c1d3594b8ba94$var$cos(A) * weights[ci + 1];
                dy += $aa1c1d3594b8ba94$var$sin(A) * weights[ci + 1];
            } else xyz[i] += xyz2[i] * weights[ci + 1];
        }
    });
    for(let i = 0; i < xyz.length; i++)if (mode.charAt(i) === 'h') {
        let A = $aa1c1d3594b8ba94$var$atan2(dy / cnt[i], dx / cnt[i]) / $aa1c1d3594b8ba94$var$PI * 180;
        while(A < 0)A += 360;
        while(A >= 360)A -= 360;
        xyz[i] = A;
    } else xyz[i] = xyz[i] / cnt[i];
    alpha /= l;
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
};
const $aa1c1d3594b8ba94$var$_average_lrgb = (colors, weights)=>{
    const l = colors.length;
    const xyz = [
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < colors.length; i++){
        const col = colors[i];
        const f = weights[i] / l;
        const rgb = col._rgb;
        xyz[0] += $aa1c1d3594b8ba94$var$pow(rgb[0], 2) * f;
        xyz[1] += $aa1c1d3594b8ba94$var$pow(rgb[1], 2) * f;
        xyz[2] += $aa1c1d3594b8ba94$var$pow(rgb[2], 2) * f;
        xyz[3] += rgb[3] * f;
    }
    xyz[0] = $aa1c1d3594b8ba94$var$sqrt(xyz[0]);
    xyz[1] = $aa1c1d3594b8ba94$var$sqrt(xyz[1]);
    xyz[2] = $aa1c1d3594b8ba94$var$sqrt(xyz[2]);
    if (xyz[3] > 0.9999999) xyz[3] = 1;
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)((0, $12c6616da0b78d4a$export$2e2bcd8739ae039)(xyz));
};


//
// interpolates between a set of colors uzing a bezier spline
//
// @requires utils lab


// minimal multi-purpose interface
// @requires utils color analyze


const { pow: $41e8c045f4e03768$var$pow } = Math;
function $41e8c045f4e03768$export$2e2bcd8739ae039(colors) {
    // constructor
    let _mode = 'rgb';
    let _nacol = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039)('#ccc');
    let _spread = 0;
    // const _fixed = false;
    let _domain = [
        0,
        1
    ];
    let _pos = [];
    let _padding = [
        0,
        0
    ];
    let _classes = false;
    let _colors = [];
    let _out = false;
    let _min = 0;
    let _max = 1;
    let _correctLightness = false;
    let _colorCache = {};
    let _useCache = true;
    let _gamma = 1;
    // private methods
    const setColors = function(colors) {
        colors = colors || [
            '#fff',
            '#000'
        ];
        if (colors && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(colors) === 'string' && (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).brewer && (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).brewer[colors.toLowerCase()]) colors = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).brewer[colors.toLowerCase()];
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(colors) === 'array') {
            // handle single color
            if (colors.length === 1) colors = [
                colors[0],
                colors[0]
            ];
            // make a copy of the colors
            colors = colors.slice(0);
            // convert to chroma classes
            for(let c = 0; c < colors.length; c++)colors[c] = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039)(colors[c]);
            // auto-fill color position
            _pos.length = 0;
            for(let c = 0; c < colors.length; c++)_pos.push(c / (colors.length - 1));
        }
        resetCache();
        return _colors = colors;
    };
    const getClass = function(value) {
        if (_classes != null) {
            const n = _classes.length - 1;
            let i = 0;
            while(i < n && value >= _classes[i])i++;
            return i - 1;
        }
        return 0;
    };
    let tMapLightness = (t)=>t;
    let tMapDomain = (t)=>t;
    // const classifyValue = function(value) {
    //     let val = value;
    //     if (_classes.length > 2) {
    //         const n = _classes.length-1;
    //         const i = getClass(value);
    //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
    //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
    //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
    //     }
    //     return val;
    // };
    const getColor = function(val, bypassMap) {
        let col, t;
        if (bypassMap == null) bypassMap = false;
        if (isNaN(val) || val === null) return _nacol;
        if (!bypassMap) {
            if (_classes && _classes.length > 2) {
                // find the class
                const c = getClass(val);
                t = c / (_classes.length - 2);
            } else if (_max !== _min) // just interpolate between min/max
            t = (val - _min) / (_max - _min);
            else t = 1;
        } else t = val;
        // domain map
        t = tMapDomain(t);
        if (!bypassMap) t = tMapLightness(t); // lightness correction
        if (_gamma !== 1) t = $41e8c045f4e03768$var$pow(t, _gamma);
        t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
        t = (0, $736df1275014d0d7$export$2e2bcd8739ae039)(t, 0, 1);
        const k = Math.floor(t * 10000);
        if (_useCache && _colorCache[k]) col = _colorCache[k];
        else {
            if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(_colors) === 'array') //for i in [0.._pos.length-1]
            for(let i = 0; i < _pos.length; i++){
                const p = _pos[i];
                if (t <= p) {
                    col = _colors[i];
                    break;
                }
                if (t >= p && i === _pos.length - 1) {
                    col = _colors[i];
                    break;
                }
                if (t > p && t < _pos[i + 1]) {
                    t = (t - p) / (_pos[i + 1] - p);
                    col = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).interpolate(_colors[i], _colors[i + 1], t, _mode);
                    break;
                }
            }
            else if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(_colors) === 'function') col = _colors(t);
            if (_useCache) _colorCache[k] = col;
        }
        return col;
    };
    var resetCache = ()=>_colorCache = {};
    setColors(colors);
    // public interface
    const f = function(v) {
        const c = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039)(getColor(v));
        if (_out && c[_out]) return c[_out]();
        else return c;
    };
    f.classes = function(classes) {
        if (classes != null) {
            if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(classes) === 'array') {
                _classes = classes;
                _domain = [
                    classes[0],
                    classes[classes.length - 1]
                ];
            } else {
                const d = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).analyze(_domain);
                if (classes === 0) _classes = [
                    d.min,
                    d.max
                ];
                else _classes = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).limits(d, 'e', classes);
            }
            return f;
        }
        return _classes;
    };
    f.domain = function(domain) {
        if (!arguments.length) return _domain;
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        const k = _colors.length;
        if (domain.length === k && _min !== _max) // update positions
        for (let d of Array.from(domain))_pos.push((d - _min) / (_max - _min));
        else {
            for(let c = 0; c < k; c++)_pos.push(c / (k - 1));
            if (domain.length > 2) {
                // set domain map
                const tOut = domain.map((d, i)=>i / (domain.length - 1));
                const tBreaks = domain.map((d)=>(d - _min) / (_max - _min));
                if (!tBreaks.every((val, i)=>tOut[i] === val)) tMapDomain = (t)=>{
                    if (t <= 0 || t >= 1) return t;
                    let i = 0;
                    while(t >= tBreaks[i + 1])i++;
                    const f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                    const out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                    return out;
                };
            }
        }
        _domain = [
            _min,
            _max
        ];
        return f;
    };
    f.mode = function(_m) {
        if (!arguments.length) return _mode;
        _mode = _m;
        resetCache();
        return f;
    };
    f.range = function(colors, _pos) {
        setColors(colors, _pos);
        return f;
    };
    f.out = function(_o) {
        _out = _o;
        return f;
    };
    f.spread = function(val) {
        if (!arguments.length) return _spread;
        _spread = val;
        return f;
    };
    f.correctLightness = function(v) {
        if (v == null) v = true;
        _correctLightness = v;
        resetCache();
        if (_correctLightness) tMapLightness = function(t) {
            const L0 = getColor(0, true).lab()[0];
            const L1 = getColor(1, true).lab()[0];
            const pol = L0 > L1;
            let L_actual = getColor(t, true).lab()[0];
            const L_ideal = L0 + (L1 - L0) * t;
            let L_diff = L_actual - L_ideal;
            let t0 = 0;
            let t1 = 1;
            let max_iter = 20;
            while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                if (pol) L_diff *= -1;
                if (L_diff < 0) {
                    t0 = t;
                    t += (t1 - t) * 0.5;
                } else {
                    t1 = t;
                    t += (t0 - t) * 0.5;
                }
                L_actual = getColor(t, true).lab()[0];
                return L_diff = L_actual - L_ideal;
            })();
            return t;
        };
        else tMapLightness = (t)=>t;
        return f;
    };
    f.padding = function(p) {
        if (p != null) {
            if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(p) === 'number') p = [
                p,
                p
            ];
            _padding = p;
            return f;
        } else return _padding;
    };
    f.colors = function(numColors, out) {
        // If no arguments are given, return the original colors that were provided
        if (arguments.length < 2) out = 'hex';
        let result = [];
        if (arguments.length === 0) result = _colors.slice(0);
        else if (numColors === 1) result = [
            f(0.5)
        ];
        else if (numColors > 1) {
            const dm = _domain[0];
            const dd = _domain[1] - dm;
            result = $41e8c045f4e03768$var$__range__(0, numColors, false).map((i)=>f(dm + i / (numColors - 1) * dd));
        } else {
            // returns all colors based on the defined classes
            colors = [];
            let samples = [];
            if (_classes && _classes.length > 2) for(let i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
            else samples = _domain;
            result = samples.map((v)=>f(v));
        }
        if ((0, $66b4ac44dd44053b$export$2e2bcd8739ae039)[out]) result = result.map((c)=>c[out]());
        return result;
    };
    f.cache = function(c) {
        if (c != null) {
            _useCache = c;
            return f;
        } else return _useCache;
    };
    f.gamma = function(g) {
        if (g != null) {
            _gamma = g;
            return f;
        } else return _gamma;
    };
    f.nodata = function(d) {
        if (d != null) {
            _nacol = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039)(d);
            return f;
        } else return _nacol;
    };
    return f;
}
function $41e8c045f4e03768$var$__range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
}


// nth row of the pascal triangle
const $63c0d44b5afdb6f5$var$binom_row = function(n) {
    let row = [
        1,
        1
    ];
    for(let i = 1; i < n; i++){
        let newrow = [
            1
        ];
        for(let j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
        row = newrow;
    }
    return row;
};
const $63c0d44b5afdb6f5$var$bezier = function(colors) {
    let I, lab0, lab1, lab2;
    colors = colors.map((c)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(c));
    if (colors.length === 2) {
        // linear interpolation
        [lab0, lab1] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>lab0[i] + t * (lab1[i] - lab0[i]));
            return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length === 3) {
        // quadratic bezier interpolation
        [lab0, lab1, lab2] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
            return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length === 4) {
        // cubic bezier interpolation
        let lab3;
        [lab0, lab1, lab2, lab3] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
            return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length >= 5) {
        // general case (degree n bezier)
        let labs, row, n;
        labs = colors.map((c)=>c.lab());
        n = colors.length - 1;
        row = $63c0d44b5afdb6f5$var$binom_row(n);
        I = function(t) {
            const u = 1 - t;
            const lab = [
                0,
                1,
                2
            ].map((i)=>labs.reduce((sum, el, j)=>sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
            return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else throw new RangeError('No point in running bezier with only one color.');
    return I;
};
var $63c0d44b5afdb6f5$export$2e2bcd8739ae039 = (colors)=>{
    const f = $63c0d44b5afdb6f5$var$bezier(colors);
    f.scale = ()=>(0, $41e8c045f4e03768$export$2e2bcd8739ae039)(f);
    return f;
};


/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */ 



const { round: $072aa5b74e3bb989$var$round } = Math;
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.rgb = function(rnd = true) {
    if (rnd === false) return this._rgb.slice(0, 3);
    return this._rgb.slice(0, 3).map($072aa5b74e3bb989$var$round);
};
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.rgba = function(rnd = true) {
    return this._rgb.slice(0, 4).map((v, i)=>{
        return i < 3 ? rnd === false ? v : $072aa5b74e3bb989$var$round(v) : v;
    });
};
const $072aa5b74e3bb989$export$8972dc0e6ad9238f = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'rgb');
Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    rgb: $072aa5b74e3bb989$export$8972dc0e6ad9238f
});
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.rgb = (...args)=>{
    const rgba = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgba');
    if (rgba[3] === undefined) rgba[3] = 1;
    return rgba;
};
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgba');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && (args.length === 3 || args.length === 4 && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
    }
});



const $77f223218eb0ed81$var$blend = (bottom, top, mode)=>{
    if (!$77f223218eb0ed81$var$blend[mode]) throw new Error('unknown blend mode ' + mode);
    return $77f223218eb0ed81$var$blend[mode](bottom, top);
};
const $77f223218eb0ed81$var$blend_f = (f)=>(bottom, top)=>{
        const c0 = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039)(top).rgb();
        const c1 = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039)(bottom).rgb();
        return (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).rgb(f(c0, c1));
    };
const $77f223218eb0ed81$var$each = (f)=>(c0, c1)=>{
        const out = [];
        out[0] = f(c0[0], c1[0]);
        out[1] = f(c0[1], c1[1]);
        out[2] = f(c0[2], c1[2]);
        return out;
    };
const $77f223218eb0ed81$var$normal = (a)=>a;
const $77f223218eb0ed81$var$multiply = (a, b)=>a * b / 255;
const $77f223218eb0ed81$var$darken = (a, b)=>a > b ? b : a;
const $77f223218eb0ed81$var$lighten = (a, b)=>a > b ? a : b;
const $77f223218eb0ed81$var$screen = (a, b)=>255 * (1 - (1 - a / 255) * (1 - b / 255));
const $77f223218eb0ed81$var$overlay = (a, b)=>b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
const $77f223218eb0ed81$var$burn = (a, b)=>255 * (1 - (1 - b / 255) / (a / 255));
const $77f223218eb0ed81$var$dodge = (a, b)=>{
    if (a === 255) return 255;
    a = 255 * (b / 255) / (1 - a / 255);
    return a > 255 ? 255 : a;
};
// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b
$77f223218eb0ed81$var$blend.normal = $77f223218eb0ed81$var$blend_f($77f223218eb0ed81$var$each($77f223218eb0ed81$var$normal));
$77f223218eb0ed81$var$blend.multiply = $77f223218eb0ed81$var$blend_f($77f223218eb0ed81$var$each($77f223218eb0ed81$var$multiply));
$77f223218eb0ed81$var$blend.screen = $77f223218eb0ed81$var$blend_f($77f223218eb0ed81$var$each($77f223218eb0ed81$var$screen));
$77f223218eb0ed81$var$blend.overlay = $77f223218eb0ed81$var$blend_f($77f223218eb0ed81$var$each($77f223218eb0ed81$var$overlay));
$77f223218eb0ed81$var$blend.darken = $77f223218eb0ed81$var$blend_f($77f223218eb0ed81$var$each($77f223218eb0ed81$var$darken));
$77f223218eb0ed81$var$blend.lighten = $77f223218eb0ed81$var$blend_f($77f223218eb0ed81$var$each($77f223218eb0ed81$var$lighten));
$77f223218eb0ed81$var$blend.dodge = $77f223218eb0ed81$var$blend_f($77f223218eb0ed81$var$each($77f223218eb0ed81$var$dodge));
$77f223218eb0ed81$var$blend.burn = $77f223218eb0ed81$var$blend_f($77f223218eb0ed81$var$each($77f223218eb0ed81$var$burn));
var // blend.add = blend_f(each(add));
$77f223218eb0ed81$export$2e2bcd8739ae039 = $77f223218eb0ed81$var$blend;


// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf


const { pow: $3f276b8b0a00e90a$var$pow, sin: $3f276b8b0a00e90a$var$sin, cos: $3f276b8b0a00e90a$var$cos } = Math;
function $3f276b8b0a00e90a$export$2e2bcd8739ae039(start = 300, rotations = -1.5, hue = 1, gamma = 1, lightness = [
    0,
    1
]) {
    let dh = 0, dl;
    if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(lightness) === 'array') dl = lightness[1] - lightness[0];
    else {
        dl = 0;
        lightness = [
            lightness,
            lightness
        ];
    }
    const f = function(fract) {
        const a = (0, $ea00eaabdb888821$export$af54f71c879f5ba9) * ((start + 120) / 360 + rotations * fract);
        const l = $3f276b8b0a00e90a$var$pow(lightness[0] + dl * fract, gamma);
        const h = dh !== 0 ? hue[0] + fract * dh : hue;
        const amp = h * l * (1 - l) / 2;
        const cos_a = $3f276b8b0a00e90a$var$cos(a);
        const sin_a = $3f276b8b0a00e90a$var$sin(a);
        const r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        const g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        const b = l + amp * (1.97294 * cos_a);
        return (0, $66b4ac44dd44053b$export$2e2bcd8739ae039)((0, $12c6616da0b78d4a$export$2e2bcd8739ae039)([
            r * 255,
            g * 255,
            b * 255,
            1
        ]));
    };
    f.start = function(s) {
        if (s == null) return start;
        start = s;
        return f;
    };
    f.rotations = function(r) {
        if (r == null) return rotations;
        rotations = r;
        return f;
    };
    f.gamma = function(g) {
        if (g == null) return gamma;
        gamma = g;
        return f;
    };
    f.hue = function(h) {
        if (h == null) return hue;
        hue = h;
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(hue) === 'array') {
            dh = hue[1] - hue[0];
            if (dh === 0) hue = hue[1];
        } else dh = 0;
        return f;
    };
    f.lightness = function(h) {
        if (h == null) return lightness;
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(h) === 'array') {
            lightness = h;
            dl = h[1] - h[0];
        } else {
            lightness = [
                h,
                h
            ];
            dl = 0;
        }
        return f;
    };
    f.scale = ()=>(0, $66b4ac44dd44053b$export$2e2bcd8739ae039).scale(f);
    f.hue(hue);
    return f;
}




const $532074361acbd897$var$digits = '0123456789abcdef';
const { floor: $532074361acbd897$var$floor, random: $532074361acbd897$var$random } = Math;
var $532074361acbd897$export$2e2bcd8739ae039 = ()=>{
    let code = '#';
    for(let i = 0; i < 6; i++)code += $532074361acbd897$var$digits.charAt($532074361acbd897$var$floor($532074361acbd897$var$random() * 16));
    return new (0, $148a45b941038e42$export$2e2bcd8739ae039)(code, 'hex');
};




const { log: $457821296abadcd0$var$log, pow: $457821296abadcd0$var$pow, floor: $457821296abadcd0$var$floor, abs: $457821296abadcd0$var$abs } = Math;
function $457821296abadcd0$export$7cbcccfbecde6416(data, key = null) {
    const r = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
    };
    if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(data) === 'object') data = Object.values(data);
    data.forEach((val)=>{
        if (key && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(val) === 'object') val = val[key];
        if (val !== undefined && val !== null && !isNaN(val)) {
            r.values.push(val);
            r.sum += val;
            if (val < r.min) r.min = val;
            if (val > r.max) r.max = val;
            r.count += 1;
        }
    });
    r.domain = [
        r.min,
        r.max
    ];
    r.limits = (mode, num)=>$457821296abadcd0$export$e331ca4ad6a82555(r, mode, num);
    return r;
}
function $457821296abadcd0$export$e331ca4ad6a82555(data, mode = 'equal', num = 7) {
    if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(data) == 'array') data = $457821296abadcd0$export$7cbcccfbecde6416(data);
    const { min: min, max: max } = data;
    const values = data.values.sort((a, b)=>a - b);
    if (num === 1) return [
        min,
        max
    ];
    const limits1 = [];
    if (mode.substr(0, 1) === 'c') {
        // continuous
        limits1.push(min);
        limits1.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
        // equal interval
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push(min + i / num * (max - min));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'l') {
        // log scale
        if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
        const min_log = Math.LOG10E * $457821296abadcd0$var$log(min);
        const max_log = Math.LOG10E * $457821296abadcd0$var$log(max);
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push($457821296abadcd0$var$pow(10, min_log + i / num * (max_log - min_log)));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'q') {
        // quantile scale
        limits1.push(min);
        for(let i = 1; i < num; i++){
            const p = (values.length - 1) * i / num;
            const pb = $457821296abadcd0$var$floor(p);
            if (pb === p) limits1.push(values[pb]);
            else {
                // p > pb
                const pr = p - pb;
                limits1.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
            }
        }
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'k') {
        // k-means clustering
        /*
        implementation based on
        http://code.google.com/p/figue/source/browse/trunk/figue.js#336
        simplified for 1-d input values
        */ let cluster;
        const n = values.length;
        const assignments = new Array(n);
        const clusterSizes = new Array(num);
        let repeat = true;
        let nb_iters = 0;
        let centroids = null;
        // get seed values
        centroids = [];
        centroids.push(min);
        for(let i = 1; i < num; i++)centroids.push(min + i / num * (max - min));
        centroids.push(max);
        while(repeat){
            // assignment step
            for(let j = 0; j < num; j++)clusterSizes[j] = 0;
            for(let i = 0; i < n; i++){
                const value = values[i];
                let mindist = Number.MAX_VALUE;
                let best;
                for(let j = 0; j < num; j++){
                    const dist = $457821296abadcd0$var$abs(centroids[j] - value);
                    if (dist < mindist) {
                        mindist = dist;
                        best = j;
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
            }
            // update centroids step
            const newCentroids = new Array(num);
            for(let j = 0; j < num; j++)newCentroids[j] = null;
            for(let i = 0; i < n; i++){
                cluster = assignments[i];
                if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                else newCentroids[cluster] += values[i];
            }
            for(let j = 0; j < num; j++)newCentroids[j] *= 1 / clusterSizes[j];
            // check convergence
            repeat = false;
            for(let j = 0; j < num; j++)if (newCentroids[j] !== centroids[j]) {
                repeat = true;
                break;
            }
            centroids = newCentroids;
            nb_iters++;
            if (nb_iters > 200) repeat = false;
        }
        // finished k-means clustering
        // the next part is borrowed from gabrielflor.it
        const kClusters = {};
        for(let j = 0; j < num; j++)kClusters[j] = [];
        for(let i = 0; i < n; i++){
            cluster = assignments[i];
            kClusters[cluster].push(values[i]);
        }
        let tmpKMeansBreaks = [];
        for(let j = 0; j < num; j++){
            tmpKMeansBreaks.push(kClusters[j][0]);
            tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort((a, b)=>a - b);
        limits1.push(tmpKMeansBreaks[0]);
        for(let i = 1; i < tmpKMeansBreaks.length; i += 2){
            const v = tmpKMeansBreaks[i];
            if (!isNaN(v) && limits1.indexOf(v) === -1) limits1.push(v);
        }
    }
    return limits1;
}




var $439fd9febf722664$export$2e2bcd8739ae039 = (a, b)=>{
    // WCAG contrast ratio
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    a = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(a);
    b = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(b);
    const l1 = a.luminance();
    const l2 = b.luminance();
    return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
};




/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */ // constants
const $04870bba6bd66329$var$W_offset = 0.027;
const $04870bba6bd66329$var$P_in = 0.0005;
const $04870bba6bd66329$var$P_out = 0.1;
const $04870bba6bd66329$var$R_scale = 1.14;
const $04870bba6bd66329$var$B_threshold = 0.022;
const $04870bba6bd66329$var$B_exp = 1.414;
var $04870bba6bd66329$export$2e2bcd8739ae039 = (text, bg)=>{
    // parse input colors
    text = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(text);
    bg = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(bg);
    // if text color has alpha, blend against background
    if (text.alpha() < 1) text = (0, $4587e4758d36f610$export$2e2bcd8739ae039)(bg, text, text.alpha(), 'rgb');
    const l_text = $04870bba6bd66329$var$lum(...text.rgb());
    const l_bg = $04870bba6bd66329$var$lum(...bg.rgb());
    // soft clamp black levels
    const Y_text = l_text >= $04870bba6bd66329$var$B_threshold ? l_text : l_text + Math.pow($04870bba6bd66329$var$B_threshold - l_text, $04870bba6bd66329$var$B_exp);
    const Y_bg = l_bg >= $04870bba6bd66329$var$B_threshold ? l_bg : l_bg + Math.pow($04870bba6bd66329$var$B_threshold - l_bg, $04870bba6bd66329$var$B_exp);
    // normal polarity (dark text on light background)
    const S_norm = Math.pow(Y_bg, 0.56) - Math.pow(Y_text, 0.57);
    // reverse polarity (light text on dark background)
    const S_rev = Math.pow(Y_bg, 0.65) - Math.pow(Y_text, 0.62);
    // clamp noise then scale
    const C = Math.abs(Y_bg - Y_text) < $04870bba6bd66329$var$P_in ? 0 : Y_text < Y_bg ? S_norm * $04870bba6bd66329$var$R_scale : S_rev * $04870bba6bd66329$var$R_scale;
    // clamp minimum contrast then offset
    const S_apc = Math.abs(C) < $04870bba6bd66329$var$P_out ? 0 : C > 0 ? C - $04870bba6bd66329$var$W_offset : C + $04870bba6bd66329$var$W_offset;
    // scale to 100
    return S_apc * 100;
};
function $04870bba6bd66329$var$lum(r, g, b) {
    return 0.2126729 * Math.pow(r / 255, 2.4) + 0.7151522 * Math.pow(g / 255, 2.4) + 0.072175 * Math.pow(b / 255, 2.4);
}



const { sqrt: $95acce2c0225b0c8$var$sqrt, pow: $95acce2c0225b0c8$var$pow, min: $95acce2c0225b0c8$var$min, max: $95acce2c0225b0c8$var$max, atan2: $95acce2c0225b0c8$var$atan2, abs: $95acce2c0225b0c8$var$abs, cos: $95acce2c0225b0c8$var$cos, sin: $95acce2c0225b0c8$var$sin, exp: $95acce2c0225b0c8$var$exp, PI: $95acce2c0225b0c8$var$PI } = Math;
function $95acce2c0225b0c8$export$2e2bcd8739ae039(a, b, Kl = 1, Kc = 1, Kh = 1) {
    // Delta E (CIE 2000)
    // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
    var rad2deg = function(rad) {
        return 360 * rad / (2 * $95acce2c0225b0c8$var$PI);
    };
    var deg2rad = function(deg) {
        return 2 * $95acce2c0225b0c8$var$PI * deg / 360;
    };
    a = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(a);
    b = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(b);
    const [L1, a1, b1] = Array.from(a.lab());
    const [L2, a2, b2] = Array.from(b.lab());
    const avgL = (L1 + L2) / 2;
    const C1 = $95acce2c0225b0c8$var$sqrt($95acce2c0225b0c8$var$pow(a1, 2) + $95acce2c0225b0c8$var$pow(b1, 2));
    const C2 = $95acce2c0225b0c8$var$sqrt($95acce2c0225b0c8$var$pow(a2, 2) + $95acce2c0225b0c8$var$pow(b2, 2));
    const avgC = (C1 + C2) / 2;
    const G = 0.5 * (1 - $95acce2c0225b0c8$var$sqrt($95acce2c0225b0c8$var$pow(avgC, 7) / ($95acce2c0225b0c8$var$pow(avgC, 7) + $95acce2c0225b0c8$var$pow(25, 7))));
    const a1p = a1 * (1 + G);
    const a2p = a2 * (1 + G);
    const C1p = $95acce2c0225b0c8$var$sqrt($95acce2c0225b0c8$var$pow(a1p, 2) + $95acce2c0225b0c8$var$pow(b1, 2));
    const C2p = $95acce2c0225b0c8$var$sqrt($95acce2c0225b0c8$var$pow(a2p, 2) + $95acce2c0225b0c8$var$pow(b2, 2));
    const avgCp = (C1p + C2p) / 2;
    const arctan1 = rad2deg($95acce2c0225b0c8$var$atan2(b1, a1p));
    const arctan2 = rad2deg($95acce2c0225b0c8$var$atan2(b2, a2p));
    const h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
    const h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
    const avgHp = $95acce2c0225b0c8$var$abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
    const T = 1 - 0.17 * $95acce2c0225b0c8$var$cos(deg2rad(avgHp - 30)) + 0.24 * $95acce2c0225b0c8$var$cos(deg2rad(2 * avgHp)) + 0.32 * $95acce2c0225b0c8$var$cos(deg2rad(3 * avgHp + 6)) - 0.2 * $95acce2c0225b0c8$var$cos(deg2rad(4 * avgHp - 63));
    let deltaHp = h2p - h1p;
    deltaHp = $95acce2c0225b0c8$var$abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
    deltaHp = 2 * $95acce2c0225b0c8$var$sqrt(C1p * C2p) * $95acce2c0225b0c8$var$sin(deg2rad(deltaHp) / 2);
    const deltaL = L2 - L1;
    const deltaCp = C2p - C1p;
    const sl = 1 + 0.015 * $95acce2c0225b0c8$var$pow(avgL - 50, 2) / $95acce2c0225b0c8$var$sqrt(20 + $95acce2c0225b0c8$var$pow(avgL - 50, 2));
    const sc = 1 + 0.045 * avgCp;
    const sh = 1 + 0.015 * avgCp * T;
    const deltaTheta = 30 * $95acce2c0225b0c8$var$exp(-$95acce2c0225b0c8$var$pow((avgHp - 275) / 25, 2));
    const Rc = 2 * $95acce2c0225b0c8$var$sqrt($95acce2c0225b0c8$var$pow(avgCp, 7) / ($95acce2c0225b0c8$var$pow(avgCp, 7) + $95acce2c0225b0c8$var$pow(25, 7)));
    const Rt = -Rc * $95acce2c0225b0c8$var$sin(2 * deg2rad(deltaTheta));
    const result = $95acce2c0225b0c8$var$sqrt($95acce2c0225b0c8$var$pow(deltaL / (Kl * sl), 2) + $95acce2c0225b0c8$var$pow(deltaCp / (Kc * sc), 2) + $95acce2c0225b0c8$var$pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
    return $95acce2c0225b0c8$var$max(0, $95acce2c0225b0c8$var$min(100, result));
}



function $daeadc3dba15cfde$export$2e2bcd8739ae039(a, b, mode = 'lab') {
    // Delta E (CIE 1976)
    // see http://www.brucelindbloom.com/index.html?Equations.html
    a = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(a);
    b = new (0, $148a45b941038e42$export$2e2bcd8739ae039)(b);
    const l1 = a.get(mode);
    const l2 = b.get(mode);
    let sum_sq = 0;
    for(let i in l1){
        const d = (l1[i] || 0) - (l2[i] || 0);
        sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
}



var $904ace407db067fd$export$2e2bcd8739ae039 = (...args)=>{
    try {
        new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args);
        return true;
    // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};



// some pre-defined color scales:



var $1a1daa6a5fb8a1ea$export$2e2bcd8739ae039 = {
    cool () {
        return (0, $41e8c045f4e03768$export$2e2bcd8739ae039)([
            (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).hsl(180, 1, 0.9),
            (0, $66b4ac44dd44053b$export$2e2bcd8739ae039).hsl(250, 0.7, 0.4)
        ]);
    },
    hot () {
        return (0, $41e8c045f4e03768$export$2e2bcd8739ae039)([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            0.25,
            0.75,
            1
        ]).mode('rgb');
    }
};



/**
    ColorBrewer colors for chroma.js

    Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
    Pennsylvania State University.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software distributed
    under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
    CONDITIONS OF ANY KIND, either express or implied. See the License for the
    specific language governing permissions and limitations under the License.
*/ const $20289ef9c8a6be3d$var$colorbrewer = {
    // sequential
    OrRd: [
        '#fff7ec',
        '#fee8c8',
        '#fdd49e',
        '#fdbb84',
        '#fc8d59',
        '#ef6548',
        '#d7301f',
        '#b30000',
        '#7f0000'
    ],
    PuBu: [
        '#fff7fb',
        '#ece7f2',
        '#d0d1e6',
        '#a6bddb',
        '#74a9cf',
        '#3690c0',
        '#0570b0',
        '#045a8d',
        '#023858'
    ],
    BuPu: [
        '#f7fcfd',
        '#e0ecf4',
        '#bfd3e6',
        '#9ebcda',
        '#8c96c6',
        '#8c6bb1',
        '#88419d',
        '#810f7c',
        '#4d004b'
    ],
    Oranges: [
        '#fff5eb',
        '#fee6ce',
        '#fdd0a2',
        '#fdae6b',
        '#fd8d3c',
        '#f16913',
        '#d94801',
        '#a63603',
        '#7f2704'
    ],
    BuGn: [
        '#f7fcfd',
        '#e5f5f9',
        '#ccece6',
        '#99d8c9',
        '#66c2a4',
        '#41ae76',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlOrBr: [
        '#ffffe5',
        '#fff7bc',
        '#fee391',
        '#fec44f',
        '#fe9929',
        '#ec7014',
        '#cc4c02',
        '#993404',
        '#662506'
    ],
    YlGn: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529'
    ],
    Reds: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d'
    ],
    RdPu: [
        '#fff7f3',
        '#fde0dd',
        '#fcc5c0',
        '#fa9fb5',
        '#f768a1',
        '#dd3497',
        '#ae017e',
        '#7a0177',
        '#49006a'
    ],
    Greens: [
        '#f7fcf5',
        '#e5f5e0',
        '#c7e9c0',
        '#a1d99b',
        '#74c476',
        '#41ab5d',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlGnBu: [
        '#ffffd9',
        '#edf8b1',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#253494',
        '#081d58'
    ],
    Purples: [
        '#fcfbfd',
        '#efedf5',
        '#dadaeb',
        '#bcbddc',
        '#9e9ac8',
        '#807dba',
        '#6a51a3',
        '#54278f',
        '#3f007d'
    ],
    GnBu: [
        '#f7fcf0',
        '#e0f3db',
        '#ccebc5',
        '#a8ddb5',
        '#7bccc4',
        '#4eb3d3',
        '#2b8cbe',
        '#0868ac',
        '#084081'
    ],
    Greys: [
        '#ffffff',
        '#f0f0f0',
        '#d9d9d9',
        '#bdbdbd',
        '#969696',
        '#737373',
        '#525252',
        '#252525',
        '#000000'
    ],
    YlOrRd: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026'
    ],
    PuRd: [
        '#f7f4f9',
        '#e7e1ef',
        '#d4b9da',
        '#c994c7',
        '#df65b0',
        '#e7298a',
        '#ce1256',
        '#980043',
        '#67001f'
    ],
    Blues: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b'
    ],
    PuBuGn: [
        '#fff7fb',
        '#ece2f0',
        '#d0d1e6',
        '#a6bddb',
        '#67a9cf',
        '#3690c0',
        '#02818a',
        '#016c59',
        '#014636'
    ],
    Viridis: [
        '#440154',
        '#482777',
        '#3f4a8a',
        '#31678e',
        '#26838f',
        '#1f9d8a',
        '#6cce5a',
        '#b6de2b',
        '#fee825'
    ],
    // diverging
    Spectral: [
        '#9e0142',
        '#d53e4f',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#e6f598',
        '#abdda4',
        '#66c2a5',
        '#3288bd',
        '#5e4fa2'
    ],
    RdYlGn: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837'
    ],
    RdBu: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061'
    ],
    PiYG: [
        '#8e0152',
        '#c51b7d',
        '#de77ae',
        '#f1b6da',
        '#fde0ef',
        '#f7f7f7',
        '#e6f5d0',
        '#b8e186',
        '#7fbc41',
        '#4d9221',
        '#276419'
    ],
    PRGn: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b'
    ],
    RdYlBu: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695'
    ],
    BrBG: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30'
    ],
    RdGy: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#ffffff',
        '#e0e0e0',
        '#bababa',
        '#878787',
        '#4d4d4d',
        '#1a1a1a'
    ],
    PuOr: [
        '#7f3b08',
        '#b35806',
        '#e08214',
        '#fdb863',
        '#fee0b6',
        '#f7f7f7',
        '#d8daeb',
        '#b2abd2',
        '#8073ac',
        '#542788',
        '#2d004b'
    ],
    // qualitative
    Set2: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3',
        '#a6d854',
        '#ffd92f',
        '#e5c494',
        '#b3b3b3'
    ],
    Accent: [
        '#7fc97f',
        '#beaed4',
        '#fdc086',
        '#ffff99',
        '#386cb0',
        '#f0027f',
        '#bf5b17',
        '#666666'
    ],
    Set1: [
        '#e41a1c',
        '#377eb8',
        '#4daf4a',
        '#984ea3',
        '#ff7f00',
        '#ffff33',
        '#a65628',
        '#f781bf',
        '#999999'
    ],
    Set3: [
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
    ],
    Dark2: [
        '#1b9e77',
        '#d95f02',
        '#7570b3',
        '#e7298a',
        '#66a61e',
        '#e6ab02',
        '#a6761d',
        '#666666'
    ],
    Paired: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928'
    ],
    Pastel2: [
        '#b3e2cd',
        '#fdcdac',
        '#cbd5e8',
        '#f4cae4',
        '#e6f5c9',
        '#fff2ae',
        '#f1e2cc',
        '#cccccc'
    ],
    Pastel1: [
        '#fbb4ae',
        '#b3cde3',
        '#ccebc5',
        '#decbe4',
        '#fed9a6',
        '#ffffcc',
        '#e5d8bd',
        '#fddaec',
        '#f2f2f2'
    ]
};
const $20289ef9c8a6be3d$var$colorbrewerTypes = Object.keys($20289ef9c8a6be3d$var$colorbrewer);
const $20289ef9c8a6be3d$var$typeMap = new Map($20289ef9c8a6be3d$var$colorbrewerTypes.map((key)=>[
        key.toLowerCase(),
        key
    ]));
// use Proxy to allow case-insensitive access to palettes
const $20289ef9c8a6be3d$var$colorbrewerProxy = typeof Proxy === 'function' ? new Proxy($20289ef9c8a6be3d$var$colorbrewer, {
    get (target, prop) {
        const lower = prop.toLowerCase();
        if ($20289ef9c8a6be3d$var$typeMap.has(lower)) return target[$20289ef9c8a6be3d$var$typeMap.get(lower)];
    },
    getOwnPropertyNames () {
        return Object.getOwnPropertyNames($20289ef9c8a6be3d$var$colorbrewerTypes);
    }
}) : $20289ef9c8a6be3d$var$colorbrewer;
var $20289ef9c8a6be3d$export$2e2bcd8739ae039 = $20289ef9c8a6be3d$var$colorbrewerProxy;








const $a4b381a257ad36fc$var$cmyk2rgb = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'cmyk');
    const [c, m, y, k] = args;
    const alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) return [
        0,
        0,
        0,
        alpha
    ];
    return [
        c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
        m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
        y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
        alpha
    ];
};
var $a4b381a257ad36fc$export$2e2bcd8739ae039 = $a4b381a257ad36fc$var$cmyk2rgb;



const { max: $468ac347f15f03c2$var$max } = Math;
const $468ac347f15f03c2$var$rgb2cmyk = (...args)=>{
    let [r, g, b] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const k = 1 - $468ac347f15f03c2$var$max(r, $468ac347f15f03c2$var$max(g, b));
    const f = k < 1 ? 1 / (1 - k) : 0;
    const c = (1 - r - k) * f;
    const m = (1 - g - k) * f;
    const y = (1 - b - k) * f;
    return [
        c,
        m,
        y,
        k
    ];
};
var $468ac347f15f03c2$export$2e2bcd8739ae039 = $468ac347f15f03c2$var$rgb2cmyk;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.cmyk = function() {
    return (0, $468ac347f15f03c2$export$2e2bcd8739ae039)(this._rgb);
};
const $eb81d0eb2fd6eb41$export$358b1a66a3c77756 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'cmyk');
Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    cmyk: $eb81d0eb2fd6eb41$export$358b1a66a3c77756
});
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.cmyk = (0, $a4b381a257ad36fc$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'cmyk');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 4) return 'cmyk';
    }
});








/*
 * supported arguments:
 * - hsl2css(h,s,l)
 * - hsl2css(h,s,l,a)
 * - hsl2css([h,s,l], mode)
 * - hsl2css([h,s,l,a], mode)
 * - hsl2css({h,s,l,a}, mode)
 */ const $dd6d0dd3d4bfb95c$var$hsl2css = (...args)=>{
    const hsla = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'hsla');
    let mode = (0, $80c5cc3ec282600e$export$2e2bcd8739ae039)(args) || 'lsa';
    hsla[0] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(hsla[0] || 0) + 'deg';
    hsla[1] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(hsla[1] * 100) + '%';
    hsla[2] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(hsla[2] * 100) + '%';
    if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
        hsla[3] = '/ ' + (hsla.length > 3 ? hsla[3] : 1);
        mode = 'hsla';
    } else hsla.length = 3;
    return `${mode.substr(0, 3)}(${hsla.join(' ')})`;
};
var $dd6d0dd3d4bfb95c$export$2e2bcd8739ae039 = $dd6d0dd3d4bfb95c$var$hsl2css;




/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $b054ebd17bd78ae2$var$lab2css = (...args)=>{
    const laba = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lab');
    let mode = (0, $80c5cc3ec282600e$export$2e2bcd8739ae039)(args) || 'lab';
    laba[0] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(laba[0]) + '%';
    laba[1] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(laba[1]);
    laba[2] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(laba[2]);
    if (mode === 'laba' || laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `lab(${laba.join(' ')})`;
};
var $b054ebd17bd78ae2$export$2e2bcd8739ae039 = $b054ebd17bd78ae2$var$lab2css;




/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $1ae0934dd71b9e87$var$lch2css = (...args)=>{
    const lcha = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lch');
    let mode = (0, $80c5cc3ec282600e$export$2e2bcd8739ae039)(args) || 'lab';
    lcha[0] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(lcha[0]) + '%';
    lcha[1] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(lcha[2]) + 'deg'; // add deg unit to hue
    if (mode === 'lcha' || lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `lch(${lcha.join(' ')})`;
};
var $1ae0934dd71b9e87$export$2e2bcd8739ae039 = $1ae0934dd71b9e87$var$lch2css;





const $47ad1371ba858210$var$oklab2css = (...args)=>{
    const laba = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lab');
    laba[0] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(laba[0] * 100) + '%';
    laba[1] = (0, $ea00eaabdb888821$export$6ed426801b9660b8)(laba[1]);
    laba[2] = (0, $ea00eaabdb888821$export$6ed426801b9660b8)(laba[2]);
    if (laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `oklab(${laba.join(' ')})`;
};
var $47ad1371ba858210$export$2e2bcd8739ae039 = $47ad1371ba858210$var$oklab2css;





const $f24dcdcc51b49518$var$rgb2oklch = (...args)=>{
    const [r, g, b, ...rest] = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    const [l, a, b_] = (0, $149f682f9eaba669$export$2e2bcd8739ae039)(r, g, b);
    const [L, c, h] = (0, $2b3cb66ec4705564$export$2e2bcd8739ae039)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $f24dcdcc51b49518$export$2e2bcd8739ae039 = $f24dcdcc51b49518$var$rgb2oklch;



const $99d6a1ddae7faf15$var$oklch2css = (...args)=>{
    const lcha = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lch');
    lcha[0] = (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(lcha[0] * 100) + '%';
    lcha[1] = (0, $ea00eaabdb888821$export$6ed426801b9660b8)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $ea00eaabdb888821$export$c6d486233e29f7d1)(lcha[2]) + 'deg'; // add deg unit to hue
    if (lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `oklch(${lcha.join(' ')})`;
};
var $99d6a1ddae7faf15$export$2e2bcd8739ae039 = $99d6a1ddae7faf15$var$oklch2css;



const { round: $8e5f454ae5993662$var$round } = Math;
/*
 * supported arguments:
 * - rgb2css(r,g,b)
 * - rgb2css(r,g,b,a)
 * - rgb2css([r,g,b], mode)
 * - rgb2css([r,g,b,a], mode)
 * - rgb2css({r,g,b,a}, mode)
 */ const $8e5f454ae5993662$var$rgb2css = (...args)=>{
    const rgba = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgba');
    let mode = (0, $80c5cc3ec282600e$export$2e2bcd8739ae039)(args) || 'rgb';
    if (mode.substr(0, 3) === 'hsl') return (0, $dd6d0dd3d4bfb95c$export$2e2bcd8739ae039)((0, $101fa7fd640572cf$export$2e2bcd8739ae039)(rgba), mode);
    if (mode.substr(0, 3) === 'lab') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $58cafc56806a922f$export$922c3afbcbc31cb3)();
        (0, $58cafc56806a922f$export$23f27f4cae67c045)('d50');
        const cssColor = (0, $b054ebd17bd78ae2$export$2e2bcd8739ae039)((0, $a7c31ff96b23b28a$export$2e2bcd8739ae039)(rgba), mode);
        (0, $58cafc56806a922f$export$23f27f4cae67c045)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 3) === 'lch') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $58cafc56806a922f$export$922c3afbcbc31cb3)();
        (0, $58cafc56806a922f$export$23f27f4cae67c045)('d50');
        const cssColor = (0, $1ae0934dd71b9e87$export$2e2bcd8739ae039)((0, $7e0c7382aa3acf1e$export$2e2bcd8739ae039)(rgba), mode);
        (0, $58cafc56806a922f$export$23f27f4cae67c045)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 5) === 'oklab') return (0, $47ad1371ba858210$export$2e2bcd8739ae039)((0, $149f682f9eaba669$export$2e2bcd8739ae039)(rgba));
    if (mode.substr(0, 5) === 'oklch') return (0, $99d6a1ddae7faf15$export$2e2bcd8739ae039)((0, $f24dcdcc51b49518$export$2e2bcd8739ae039)(rgba));
    rgba[0] = $8e5f454ae5993662$var$round(rgba[0]);
    rgba[1] = $8e5f454ae5993662$var$round(rgba[1]);
    rgba[2] = $8e5f454ae5993662$var$round(rgba[2]);
    if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
        rgba[3] = '/ ' + (rgba.length > 3 ? rgba[3] : 1);
        mode = 'rgba';
    }
    return `${mode.substr(0, 3)}(${rgba.slice(0, mode === 'rgb' ? 3 : 4).join(' ')})`;
};
var $8e5f454ae5993662$export$2e2bcd8739ae039 = $8e5f454ae5993662$var$rgb2css;









const $99c94d78c2818bed$var$oklch2rgb = (...args)=>{
    args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'lch');
    const [l, c, h, ...rest] = args;
    const [L, a, b_] = (0, $98b580e996b50876$export$2e2bcd8739ae039)(l, c, h);
    const [r, g, b] = (0, $caf36ea7c9bf8bce$export$2e2bcd8739ae039)(L, a, b_);
    return [
        r,
        g,
        b,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $99c94d78c2818bed$export$2e2bcd8739ae039 = $99c94d78c2818bed$var$oklch2rgb;





const $b596ffefc7b8ee43$var$INT_OR_PCT = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source;
const $b596ffefc7b8ee43$var$FLOAT_OR_PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source;
const $b596ffefc7b8ee43$var$PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source;
const $b596ffefc7b8ee43$var$RE_S = /\s*/.source;
const $b596ffefc7b8ee43$var$SEP = /\s+/.source;
const $b596ffefc7b8ee43$var$COMMA = /\s*,\s*/.source;
const $b596ffefc7b8ee43$var$ANLGE = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source;
const $b596ffefc7b8ee43$var$ALPHA = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source;
// e.g. rgb(250 20 0), rgb(100% 50% 20%), rgb(100% 50% 20% / 0.5)
const $b596ffefc7b8ee43$var$RE_RGB = new RegExp('^rgba?\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$INT_OR_PCT,
    $b596ffefc7b8ee43$var$INT_OR_PCT,
    $b596ffefc7b8ee43$var$INT_OR_PCT
].join($b596ffefc7b8ee43$var$SEP) + $b596ffefc7b8ee43$var$ALPHA + '\\)$');
const $b596ffefc7b8ee43$var$RE_RGB_LEGACY = new RegExp('^rgb\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$INT_OR_PCT,
    $b596ffefc7b8ee43$var$INT_OR_PCT,
    $b596ffefc7b8ee43$var$INT_OR_PCT
].join($b596ffefc7b8ee43$var$COMMA) + $b596ffefc7b8ee43$var$RE_S + '\\)$');
const $b596ffefc7b8ee43$var$RE_RGBA_LEGACY = new RegExp('^rgba\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$INT_OR_PCT,
    $b596ffefc7b8ee43$var$INT_OR_PCT,
    $b596ffefc7b8ee43$var$INT_OR_PCT,
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT
].join($b596ffefc7b8ee43$var$COMMA) + $b596ffefc7b8ee43$var$RE_S + '\\)$');
const $b596ffefc7b8ee43$var$RE_HSL = new RegExp('^hsla?\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$ANLGE,
    $b596ffefc7b8ee43$var$PCT,
    $b596ffefc7b8ee43$var$PCT
].join($b596ffefc7b8ee43$var$SEP) + $b596ffefc7b8ee43$var$ALPHA + '\\)$');
const $b596ffefc7b8ee43$var$RE_HSL_LEGACY = new RegExp('^hsl?\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$ANLGE,
    $b596ffefc7b8ee43$var$PCT,
    $b596ffefc7b8ee43$var$PCT
].join($b596ffefc7b8ee43$var$COMMA) + $b596ffefc7b8ee43$var$RE_S + '\\)$');
const $b596ffefc7b8ee43$var$RE_HSLA_LEGACY = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const $b596ffefc7b8ee43$var$RE_LAB = new RegExp('^lab\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT,
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT,
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT
].join($b596ffefc7b8ee43$var$SEP) + $b596ffefc7b8ee43$var$ALPHA + '\\)$');
const $b596ffefc7b8ee43$var$RE_LCH = new RegExp('^lch\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT,
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT,
    $b596ffefc7b8ee43$var$ANLGE
].join($b596ffefc7b8ee43$var$SEP) + $b596ffefc7b8ee43$var$ALPHA + '\\)$');
const $b596ffefc7b8ee43$var$RE_OKLAB = new RegExp('^oklab\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT,
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT,
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT
].join($b596ffefc7b8ee43$var$SEP) + $b596ffefc7b8ee43$var$ALPHA + '\\)$');
const $b596ffefc7b8ee43$var$RE_OKLCH = new RegExp('^oklch\\(' + $b596ffefc7b8ee43$var$RE_S + [
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT,
    $b596ffefc7b8ee43$var$FLOAT_OR_PCT,
    $b596ffefc7b8ee43$var$ANLGE
].join($b596ffefc7b8ee43$var$SEP) + $b596ffefc7b8ee43$var$ALPHA + '\\)$');
const { round: $b596ffefc7b8ee43$var$round } = Math;
const $b596ffefc7b8ee43$var$roundRGB = (rgb)=>{
    return rgb.map((v, i)=>i <= 2 ? (0, $736df1275014d0d7$export$2e2bcd8739ae039)($b596ffefc7b8ee43$var$round(v), 0, 255) : v);
};
const $b596ffefc7b8ee43$var$percentToAbsolute = (pct, min = 0, max = 100, signed = false)=>{
    if (typeof pct === 'string' && pct.endsWith('%')) {
        pct = parseFloat(pct.substring(0, pct.length - 1)) / 100;
        if (signed) // signed percentages are in the range -100% to 100%
        pct = min + (pct + 1) * 0.5 * (max - min);
        else pct = min + pct * (max - min);
    }
    return +pct;
};
const $b596ffefc7b8ee43$var$noneToValue = (v, noneValue)=>{
    return v === 'none' ? noneValue : v;
};
const $b596ffefc7b8ee43$var$css2rgb = (css)=>{
    css = css.toLowerCase().trim();
    if (css === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    let m;
    if ((0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.named) try {
        return (0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.named(css);
    // eslint-disable-next-line
    } catch (e) {}
    // rgb(250 20 0) or rgb(250,20,0)
    if ((m = css.match($b596ffefc7b8ee43$var$RE_RGB)) || (m = css.match($b596ffefc7b8ee43$var$RE_RGB_LEGACY))) {
        let rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = +$b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(rgb[i], 0), 0, 255);
        rgb = $b596ffefc7b8ee43$var$roundRGB(rgb);
        const alpha = m[4] !== undefined ? +$b596ffefc7b8ee43$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha; // default alpha
        return rgb;
    }
    // rgba(250,20,0,0.4)
    if (m = css.match($b596ffefc7b8ee43$var$RE_RGBA_LEGACY)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 4; i++)rgb[i] = +$b596ffefc7b8ee43$var$percentToAbsolute(rgb[i], 0, 255);
        return rgb;
    }
    // hsl(0,100%,50%)
    if ((m = css.match($b596ffefc7b8ee43$var$RE_HSL)) || (m = css.match($b596ffefc7b8ee43$var$RE_HSL_LEGACY))) {
        const hsl = m.slice(1, 4);
        hsl[0] = +$b596ffefc7b8ee43$var$noneToValue(hsl[0].replace('deg', ''), 0);
        hsl[1] = +$b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(hsl[1], 0), 0, 100) * 0.01;
        hsl[2] = +$b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(hsl[2], 0), 0, 100) * 0.01;
        const rgb = $b596ffefc7b8ee43$var$roundRGB((0, $8e2e15f0a5a80897$export$2e2bcd8739ae039)(hsl));
        const alpha = m[4] !== undefined ? +$b596ffefc7b8ee43$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    // hsla(0,100%,50%,0.5)
    if (m = css.match($b596ffefc7b8ee43$var$RE_HSLA_LEGACY)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $8e2e15f0a5a80897$export$2e2bcd8739ae039)(hsl);
        for(let i = 0; i < 3; i++)rgb[i] = $b596ffefc7b8ee43$var$round(rgb[i]);
        rgb[3] = +m[4]; // default alpha = 1
        return rgb;
    }
    if (m = css.match($b596ffefc7b8ee43$var$RE_LAB)) {
        const lab = m.slice(1, 4);
        lab[0] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(lab[0], 0), 0, 100);
        lab[1] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(lab[1], 0), -125, 125, true);
        lab[2] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(lab[2], 0), -125, 125, true);
        // convert to D50 Lab whitepoint
        const wp = (0, $58cafc56806a922f$export$922c3afbcbc31cb3)();
        (0, $58cafc56806a922f$export$23f27f4cae67c045)('d50');
        const rgb = $b596ffefc7b8ee43$var$roundRGB((0, $42529912c0955113$export$2e2bcd8739ae039)(lab));
        // convert back to original Lab whitepoint
        (0, $58cafc56806a922f$export$23f27f4cae67c045)(wp);
        const alpha = m[4] !== undefined ? +$b596ffefc7b8ee43$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($b596ffefc7b8ee43$var$RE_LCH)) {
        const lch = m.slice(1, 4);
        lch[0] = $b596ffefc7b8ee43$var$percentToAbsolute(lch[0], 0, 100);
        lch[1] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(lch[1], 0), 0, 150, false);
        lch[2] = +$b596ffefc7b8ee43$var$noneToValue(lch[2].replace('deg', ''), 0);
        // convert to D50 Lab whitepoint
        const wp = (0, $58cafc56806a922f$export$922c3afbcbc31cb3)();
        (0, $58cafc56806a922f$export$23f27f4cae67c045)('d50');
        const rgb = $b596ffefc7b8ee43$var$roundRGB((0, $b700aa6de263b4a4$export$2e2bcd8739ae039)(lch));
        // convert back to original Lab whitepoint
        (0, $58cafc56806a922f$export$23f27f4cae67c045)(wp);
        const alpha = m[4] !== undefined ? +$b596ffefc7b8ee43$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($b596ffefc7b8ee43$var$RE_OKLAB)) {
        const oklab = m.slice(1, 4);
        oklab[0] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(oklab[0], 0), 0, 1);
        oklab[1] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(oklab[1], 0), -0.4, 0.4, true);
        oklab[2] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(oklab[2], 0), -0.4, 0.4, true);
        const rgb = $b596ffefc7b8ee43$var$roundRGB((0, $caf36ea7c9bf8bce$export$2e2bcd8739ae039)(oklab));
        const alpha = m[4] !== undefined ? +$b596ffefc7b8ee43$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($b596ffefc7b8ee43$var$RE_OKLCH)) {
        const oklch = m.slice(1, 4);
        oklch[0] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(oklch[0], 0), 0, 1);
        oklch[1] = $b596ffefc7b8ee43$var$percentToAbsolute($b596ffefc7b8ee43$var$noneToValue(oklch[1], 0), 0, 0.4, false);
        oklch[2] = +$b596ffefc7b8ee43$var$noneToValue(oklch[2].replace('deg', ''), 0);
        const rgb = $b596ffefc7b8ee43$var$roundRGB((0, $99c94d78c2818bed$export$2e2bcd8739ae039)(oklch));
        const alpha = m[4] !== undefined ? +$b596ffefc7b8ee43$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
};
$b596ffefc7b8ee43$var$css2rgb.test = (s)=>{
    return(// modern
    $b596ffefc7b8ee43$var$RE_RGB.test(s) || $b596ffefc7b8ee43$var$RE_HSL.test(s) || $b596ffefc7b8ee43$var$RE_LAB.test(s) || $b596ffefc7b8ee43$var$RE_LCH.test(s) || $b596ffefc7b8ee43$var$RE_OKLAB.test(s) || $b596ffefc7b8ee43$var$RE_OKLCH.test(s) || // legacy
    $b596ffefc7b8ee43$var$RE_RGB_LEGACY.test(s) || $b596ffefc7b8ee43$var$RE_RGBA_LEGACY.test(s) || $b596ffefc7b8ee43$var$RE_HSL_LEGACY.test(s) || $b596ffefc7b8ee43$var$RE_HSLA_LEGACY.test(s) || s === 'transparent');
};
var $b596ffefc7b8ee43$export$2e2bcd8739ae039 = $b596ffefc7b8ee43$var$css2rgb;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.css = function(mode) {
    return (0, $8e5f454ae5993662$export$2e2bcd8739ae039)(this._rgb, mode);
};
const $bc93aa77f0da819a$export$dbf350e5966cf602 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'css');
(0, $66b4ac44dd44053b$export$2e2bcd8739ae039).css = $bc93aa77f0da819a$export$dbf350e5966cf602;
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.css = (0, $b596ffefc7b8ee43$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(h) === 'string' && (0, $b596ffefc7b8ee43$export$2e2bcd8739ae039).test(h)) return 'css';
    }
});






(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.gl = (...args)=>{
    const rgb = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgba');
    rgb[0] *= 255;
    rgb[1] *= 255;
    rgb[2] *= 255;
    return rgb;
};
const $04122976f07b8c35$export$5822a9d0880a5d82 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'gl');
(0, $66b4ac44dd44053b$export$2e2bcd8739ae039).gl = $04122976f07b8c35$export$5822a9d0880a5d82;
(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.gl = function() {
    const rgb = this._rgb;
    return [
        rgb[0] / 255,
        rgb[1] / 255,
        rgb[2] / 255,
        rgb[3]
    ];
};









(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.hex = function(mode) {
    return (0, $c950ee24ffcbc53c$export$2e2bcd8739ae039)(this._rgb, mode);
};
const $8368530067c12585$export$834dfc94dde4b3d8 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'hex');
(0, $66b4ac44dd44053b$export$2e2bcd8739ae039).hex = $8368530067c12585$export$834dfc94dde4b3d8;
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.hex = (0, $fff1bd3e33bdad02$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 4,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(h) === 'string' && [
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].indexOf(h.length) >= 0) return 'hex';
    }
});












/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 */ const { log: $776b4ed8cf53a3e0$var$log } = Math;
const $776b4ed8cf53a3e0$var$temperature2rgb = (kelvin)=>{
    const temp = kelvin / 100;
    let r, g, b;
    if (temp < 66) {
        r = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $776b4ed8cf53a3e0$var$log(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $776b4ed8cf53a3e0$var$log(b);
    } else {
        r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $776b4ed8cf53a3e0$var$log(r);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $776b4ed8cf53a3e0$var$log(g);
        b = 255;
    }
    return [
        r,
        g,
        b,
        1
    ];
};
var $776b4ed8cf53a3e0$export$2e2bcd8739ae039 = $776b4ed8cf53a3e0$var$temperature2rgb;


/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/ 

const { round: $e03f738c9e4b624e$var$round } = Math;
const $e03f738c9e4b624e$var$rgb2temperature = (...args)=>{
    const rgb = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'rgb');
    const r = rgb[0], b = rgb[2];
    let minTemp = 1000;
    let maxTemp = 40000;
    const eps = 0.4;
    let temp;
    while(maxTemp - minTemp > eps){
        temp = (maxTemp + minTemp) * 0.5;
        const rgb = (0, $776b4ed8cf53a3e0$export$2e2bcd8739ae039)(temp);
        if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
        else minTemp = temp;
    }
    return $e03f738c9e4b624e$var$round(temp);
};
var $e03f738c9e4b624e$export$2e2bcd8739ae039 = $e03f738c9e4b624e$var$rgb2temperature;


(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.temp = (0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.kelvin = (0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.temperature = function() {
    return (0, $e03f738c9e4b624e$export$2e2bcd8739ae039)(this._rgb);
};
const $277a09325a77b9a9$export$8d72b093afd1813e = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'temp');
Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    temp: $277a09325a77b9a9$export$8d72b093afd1813e,
    kelvin: $277a09325a77b9a9$export$8d72b093afd1813e,
    temperature: $277a09325a77b9a9$export$8d72b093afd1813e
});
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.temp = (0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.kelvin = (0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.temperature = (0, $776b4ed8cf53a3e0$export$2e2bcd8739ae039);









(0, $148a45b941038e42$export$2e2bcd8739ae039).prototype.oklch = function() {
    return (0, $f24dcdcc51b49518$export$2e2bcd8739ae039)(this._rgb);
};
const $f7b47b861419dbb9$export$c21b932a666e3753 = (...args)=>new (0, $148a45b941038e42$export$2e2bcd8739ae039)(...args, 'oklch');
Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    oklch: $f7b47b861419dbb9$export$c21b932a666e3753
});
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).format.oklch = (0, $99c94d78c2818bed$export$2e2bcd8739ae039);
(0, $2e79d059439cfd2d$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $41afdaa7f10d2cae$export$2e2bcd8739ae039)(args, 'oklch');
        if ((0, $8d97f317ec52e7fe$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'oklch';
    }
});


Object.assign((0, $66b4ac44dd44053b$export$2e2bcd8739ae039), {
    analyze: $457821296abadcd0$export$7cbcccfbecde6416,
    average: $aa1c1d3594b8ba94$export$2e2bcd8739ae039,
    bezier: $63c0d44b5afdb6f5$export$2e2bcd8739ae039,
    blend: $77f223218eb0ed81$export$2e2bcd8739ae039,
    brewer: $20289ef9c8a6be3d$export$2e2bcd8739ae039,
    Color: $148a45b941038e42$export$2e2bcd8739ae039,
    colors: $b35429e4d930afd2$export$2e2bcd8739ae039,
    contrast: $439fd9febf722664$export$2e2bcd8739ae039,
    contrastAPCA: $04870bba6bd66329$export$2e2bcd8739ae039,
    cubehelix: $3f276b8b0a00e90a$export$2e2bcd8739ae039,
    deltaE: $95acce2c0225b0c8$export$2e2bcd8739ae039,
    distance: $daeadc3dba15cfde$export$2e2bcd8739ae039,
    input: $2e79d059439cfd2d$export$2e2bcd8739ae039,
    interpolate: (0, $4587e4758d36f610$export$2e2bcd8739ae039),
    limits: $457821296abadcd0$export$e331ca4ad6a82555,
    mix: $4587e4758d36f610$export$2e2bcd8739ae039,
    random: $532074361acbd897$export$2e2bcd8739ae039,
    scale: $41e8c045f4e03768$export$2e2bcd8739ae039,
    scales: $1a1daa6a5fb8a1ea$export$2e2bcd8739ae039,
    valid: $904ace407db067fd$export$2e2bcd8739ae039
});
var $6fcd0133a3d1c5fc$export$2e2bcd8739ae039 = (0, $66b4ac44dd44053b$export$2e2bcd8739ae039);


// https://api.open-meteo.com/v1/forecast?latitude=55.6759&longitude=12.5655&current=wind_speed_10m,wind_direction_10m,wind_gusts_10m&hourly=wind_speed_10m,wind_direction_10m,wind_gusts_10m&daily=wind_speed_10m_max,wind_gusts_10m_max,wind_direction_10m_dominant&timezone=auto&past_days=7&forecast_days=1
var $44531b207f5b504a$exports = {};
$44531b207f5b504a$exports = JSON.parse('{"latitude":55.6785,"longitude":12.570435,"generationtime_ms":0.0528097152709961,"utc_offset_seconds":3600,"timezone":"Europe/Copenhagen","timezone_abbreviation":"GMT+1","elevation":11,"current_units":{"time":"iso8601","interval":"seconds","wind_speed_10m":"km/h","wind_direction_10m":"\xb0","wind_gusts_10m":"km/h"},"current":{"time":"2025-02-07T20:15","interval":900,"wind_speed_10m":20.9,"wind_direction_10m":86,"wind_gusts_10m":40.7},"hourly_units":{"time":"iso8601","wind_speed_10m":"km/h","wind_direction_10m":"\xb0","wind_gusts_10m":"km/h"},"hourly":{"time":["2025-01-31T00:00","2025-01-31T01:00","2025-01-31T02:00","2025-01-31T03:00","2025-01-31T04:00","2025-01-31T05:00","2025-01-31T06:00","2025-01-31T07:00","2025-01-31T08:00","2025-01-31T09:00","2025-01-31T10:00","2025-01-31T11:00","2025-01-31T12:00","2025-01-31T13:00","2025-01-31T14:00","2025-01-31T15:00","2025-01-31T16:00","2025-01-31T17:00","2025-01-31T18:00","2025-01-31T19:00","2025-01-31T20:00","2025-01-31T21:00","2025-01-31T22:00","2025-01-31T23:00","2025-02-01T00:00","2025-02-01T01:00","2025-02-01T02:00","2025-02-01T03:00","2025-02-01T04:00","2025-02-01T05:00","2025-02-01T06:00","2025-02-01T07:00","2025-02-01T08:00","2025-02-01T09:00","2025-02-01T10:00","2025-02-01T11:00","2025-02-01T12:00","2025-02-01T13:00","2025-02-01T14:00","2025-02-01T15:00","2025-02-01T16:00","2025-02-01T17:00","2025-02-01T18:00","2025-02-01T19:00","2025-02-01T20:00","2025-02-01T21:00","2025-02-01T22:00","2025-02-01T23:00","2025-02-02T00:00","2025-02-02T01:00","2025-02-02T02:00","2025-02-02T03:00","2025-02-02T04:00","2025-02-02T05:00","2025-02-02T06:00","2025-02-02T07:00","2025-02-02T08:00","2025-02-02T09:00","2025-02-02T10:00","2025-02-02T11:00","2025-02-02T12:00","2025-02-02T13:00","2025-02-02T14:00","2025-02-02T15:00","2025-02-02T16:00","2025-02-02T17:00","2025-02-02T18:00","2025-02-02T19:00","2025-02-02T20:00","2025-02-02T21:00","2025-02-02T22:00","2025-02-02T23:00","2025-02-03T00:00","2025-02-03T01:00","2025-02-03T02:00","2025-02-03T03:00","2025-02-03T04:00","2025-02-03T05:00","2025-02-03T06:00","2025-02-03T07:00","2025-02-03T08:00","2025-02-03T09:00","2025-02-03T10:00","2025-02-03T11:00","2025-02-03T12:00","2025-02-03T13:00","2025-02-03T14:00","2025-02-03T15:00","2025-02-03T16:00","2025-02-03T17:00","2025-02-03T18:00","2025-02-03T19:00","2025-02-03T20:00","2025-02-03T21:00","2025-02-03T22:00","2025-02-03T23:00","2025-02-04T00:00","2025-02-04T01:00","2025-02-04T02:00","2025-02-04T03:00","2025-02-04T04:00","2025-02-04T05:00","2025-02-04T06:00","2025-02-04T07:00","2025-02-04T08:00","2025-02-04T09:00","2025-02-04T10:00","2025-02-04T11:00","2025-02-04T12:00","2025-02-04T13:00","2025-02-04T14:00","2025-02-04T15:00","2025-02-04T16:00","2025-02-04T17:00","2025-02-04T18:00","2025-02-04T19:00","2025-02-04T20:00","2025-02-04T21:00","2025-02-04T22:00","2025-02-04T23:00","2025-02-05T00:00","2025-02-05T01:00","2025-02-05T02:00","2025-02-05T03:00","2025-02-05T04:00","2025-02-05T05:00","2025-02-05T06:00","2025-02-05T07:00","2025-02-05T08:00","2025-02-05T09:00","2025-02-05T10:00","2025-02-05T11:00","2025-02-05T12:00","2025-02-05T13:00","2025-02-05T14:00","2025-02-05T15:00","2025-02-05T16:00","2025-02-05T17:00","2025-02-05T18:00","2025-02-05T19:00","2025-02-05T20:00","2025-02-05T21:00","2025-02-05T22:00","2025-02-05T23:00","2025-02-06T00:00","2025-02-06T01:00","2025-02-06T02:00","2025-02-06T03:00","2025-02-06T04:00","2025-02-06T05:00","2025-02-06T06:00","2025-02-06T07:00","2025-02-06T08:00","2025-02-06T09:00","2025-02-06T10:00","2025-02-06T11:00","2025-02-06T12:00","2025-02-06T13:00","2025-02-06T14:00","2025-02-06T15:00","2025-02-06T16:00","2025-02-06T17:00","2025-02-06T18:00","2025-02-06T19:00","2025-02-06T20:00","2025-02-06T21:00","2025-02-06T22:00","2025-02-06T23:00","2025-02-07T00:00","2025-02-07T01:00","2025-02-07T02:00","2025-02-07T03:00","2025-02-07T04:00","2025-02-07T05:00","2025-02-07T06:00","2025-02-07T07:00","2025-02-07T08:00","2025-02-07T09:00","2025-02-07T10:00","2025-02-07T11:00","2025-02-07T12:00","2025-02-07T13:00","2025-02-07T14:00","2025-02-07T15:00","2025-02-07T16:00","2025-02-07T17:00","2025-02-07T18:00","2025-02-07T19:00","2025-02-07T20:00","2025-02-07T21:00","2025-02-07T22:00","2025-02-07T23:00"],"wind_speed_10m":[13.3,12.6,12.6,12.2,12.2,10.1,7.9,9.4,6.5,7.2,9.4,10.4,10.4,10.8,11.9,13.7,14.4,14.4,13.7,14,10.4,8.3,8.3,8.3,9,9,9.7,8.3,8.6,7.2,5.8,3.6,2.9,4,5.4,5,4.3,4,4,3.2,5.8,5.4,3.2,3.2,5.8,5.4,6.1,5.8,4,4,4.7,5,2.5,1.8,4.7,5,5.4,5.4,5.4,8.3,8.3,7.2,7.9,7.9,7.6,9,10.1,11.9,10.4,9.7,9,8.6,11.9,11.2,10.4,8.6,8.6,7.9,9,8.3,6.5,6.8,7.2,7.6,6.8,7.9,9.7,9,10.8,8.3,8.6,9.4,8.6,10.1,9.4,9,6.5,6.8,5.4,7.2,7.2,9.7,9.7,11.2,11.2,11.9,13.3,12.6,11.9,13.3,13,13,14.4,13.3,13.3,15.1,16.2,17.6,17.3,17.6,16.6,15.8,15.5,15.8,21.2,20.2,19.4,19.8,18.4,16.9,18,16.9,16.9,20.2,21.2,18.7,19.8,14.4,13,15.1,9.7,8.6,9.7,9.7,9.7,10.8,10.8,10.8,11.9,11.5,9.7,8.3,8.6,7.6,8.3,9,13.3,11.9,12.2,13,10.1,9.4,9.7,10.4,10.8,9.7,9,7.9,7.6,8.3,7.9,10.1,10.1,12.6,15.5,16.2,15.1,16.9,18,15.8,17.3,18,18.7,18.4,23,24.1,25.6,22.3,21.2,19.1,18.4,19.8],"wind_direction_10m":[269,270,267,268,274,266,248,250,242,250,258,286,302,294,283,280,295,305,305,309,301,296,290,283,285,290,286,285,282,287,292,293,277,248,304,323,57,48,48,43,48,35,341,330,356,348,321,327,303,300,323,307,317,187,230,246,243,232,232,247,253,272,279,275,269,272,277,280,284,270,268,263,274,281,274,255,260,247,249,252,240,221,242,238,230,203,192,186,188,184,182,212,210,214,242,245,236,215,221,248,214,225,226,232,209,216,220,233,224,218,221,213,213,216,221,212,207,210,214,211,208,211,213,218,227,222,220,233,239,237,239,248,261,277,286,283,285,281,285,282,285,274,278,283,288,284,283,290,291,299,301,305,310,320,11,3,10,15,23,18,6,7,22,57,51,50,63,87,97,77,58,65,89,94,93,85,58,66,58,59,61,62,64,66,67,60,72,74,86,89,116,101],"wind_gusts_10m":[24.8,24.1,24.8,23.4,22.7,22.7,16.9,16.2,15.8,12.6,18.7,21.6,22.7,24.1,24.5,26.3,28.1,28.1,27.4,26.6,26.6,18.7,15.8,14,15.8,18.7,17.6,18,15.8,16.2,13.7,11.9,7.2,7.9,13.3,13,10.8,10.4,10.1,9.4,10.8,11.5,10.4,7.6,11.9,12.6,11.9,12.2,10.1,10.8,10.4,11.9,11.5,5.8,8.6,10.4,10.8,11.2,11.5,16.6,17.3,15.5,16.9,16.6,16.9,17.3,19.1,26.6,22.7,19.8,16.6,15.8,22.3,24.8,21.6,20.2,18.7,16.6,16.6,16.9,15.8,14,16.6,16.9,18,17.6,20.5,20.5,23.4,20.2,15.5,17.3,17.6,18,18.7,17.3,15.5,12.6,10.8,17.3,15.1,18.4,18.4,21.6,22,24.5,26.6,27,25.6,27,27.7,26.3,27.4,27.4,25.9,29.2,31.3,33.5,35.3,34.9,33.1,32.4,29.9,30.2,41,40.3,38.9,38.9,37.4,34.6,37.1,35.6,34.9,41,42.8,43.6,39.6,37.8,27,32,28.1,18.7,19.4,18.4,18,19.8,20.2,20.2,22,22,21.2,17.6,14.4,14.4,17.3,18.7,27,24.8,24.8,27,26.3,19.4,16.6,17.3,20.2,18,16.2,15.5,14.8,15.8,15.8,18.7,19.4,24.1,29.2,30.6,30.2,31.7,34.2,33.8,34.6,35.3,39.6,39.2,43.6,45,47.9,47.9,41.4,40,42.5,39.6]},"daily_units":{"time":"iso8601","wind_speed_10m_max":"km/h","wind_gusts_10m_max":"km/h","wind_direction_10m_dominant":"\xb0"},"daily":{"time":["2025-01-31","2025-02-01","2025-02-02","2025-02-03","2025-02-04","2025-02-05","2025-02-06","2025-02-07"],"wind_speed_10m_max":[14.4,9.7,11.9,11.9,17.6,21.2,13.3,25.6],"wind_gusts_10m_max":[28.1,18.7,26.6,24.8,35.3,43.6,27,47.9],"wind_direction_10m_dominant":[281,317,269,231,218,251,351,75]}}');







































function $4d7a5afcd6e87c6d$export$8f10d66e8cd93f52(value, unit) {
    switch(unit){
        case "km/h":
            return Math.floor(value * 1000 / 3600);
        default:
            throw new Error(`Unknown unit: ${unit}`);
    }
}
function $4d7a5afcd6e87c6d$export$cba01ba138429a1d(value, unit) {
    switch(unit){
        case "\xb0":
            return (0, $2edc1eef02a7c199$export$4f2c4f194778dcbb)(value);
        default:
            throw new Error(`Unknown unit: ${unit}`);
    }
}


async function $e6aa4e40a3ab6eaf$export$8134c072fddab6a5(location) {
    const url = `https://api.open-meteo.com/v1/forecast?latitude=${location.latitude}&longitude=${location.longitude}&current=wind_speed_10m,wind_direction_10m,wind_gusts_10m&hourly=wind_speed_10m,wind_direction_10m,wind_gusts_10m&timezone=auto&past_days=7&forecast_days=1`;
    //throw new Error(`disabled`);
    const resp = await fetch(url);
    return await resp.json();
}
function $e6aa4e40a3ab6eaf$export$8391a228bef7e10d() {
    return 0, (/*@__PURE__*/$parcel$interopDefault($44531b207f5b504a$exports));
}
function $e6aa4e40a3ab6eaf$export$c7cb04e132c55f1c(d) {
    const hourly = d.hourly;
    const hourlyUnits = d.hourly_units;
    if (!hourly || !hourlyUnits) {
        console.warn(`Hourly data missing`);
        return [];
    }
    const count = hourly.time.length;
    const hourlyData = [];
    for(let i = 0; i < count; i++){
        const w = {
            direction: $4d7a5afcd6e87c6d$export$cba01ba138429a1d(hourly.wind_direction_10m[i], hourlyUnits.wind_direction_10m),
            gusts: $4d7a5afcd6e87c6d$export$8f10d66e8cd93f52(hourly.wind_gusts_10m[i], hourlyUnits.wind_gusts_10m),
            speed: $4d7a5afcd6e87c6d$export$8f10d66e8cd93f52(hourly.wind_speed_10m[i], hourlyUnits.wind_speed_10m),
            time: Date.parse(hourly.time[i]),
            height: 10,
            interval: 60
        };
        hourlyData.push(w);
    }
    return hourlyData;
}























function $c2bec1fda882e2c6$export$bc7e41628a29c739() {
    const data = $e6aa4e40a3ab6eaf$export$8391a228bef7e10d();
    return $e6aa4e40a3ab6eaf$export$c7cb04e132c55f1c(data);
}
async function $c2bec1fda882e2c6$export$7a171f172be0782e(location) {
    const data = await $e6aa4e40a3ab6eaf$export$8134c072fddab6a5(location);
    return $e6aa4e40a3ab6eaf$export$c7cb04e132c55f1c(data);
}
function $c2bec1fda882e2c6$export$90a84733300939d7(interval, data) {
    const periods = [];
    const ms = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(interval);
    let current = 0;
    let currentPeriod = [];
    for(let i = 0; i < data.length; i++)if (i === 0) current = data[i].time;
    else {
        const abs = Math.abs(data[i].time - current);
        if (abs >= ms) {
            currentPeriod = [];
            periods.push(currentPeriod);
            current = data[i].time;
        } else currentPeriod.push(data[i]);
    }
    return periods;
}





const $3d8103e633200965$export$24440bbdd34c95b6 = (ray, origin = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty)=>{
    const a = (0, $2edc1eef02a7c199$export$c20c3ae8c54a7e6a).toCartesian(ray.start, ray.angleRadian, origin);
    const b = (0, $2edc1eef02a7c199$export$c20c3ae8c54a7e6a).toCartesian(ray.start + ray.length, ray.angleRadian, origin);
    return {
        a: a,
        b: b
    };
};
const $3d8103e633200965$export$b45d53ee21146893 = (el, ray)=>{
    const l = $3d8103e633200965$export$24440bbdd34c95b6(ray);
    el.setAttribute(`x1`, l.a.x.toString());
    el.setAttribute(`y1`, l.a.y.toString());
    el.setAttribute(`x2`, l.b.x.toString());
    el.setAttribute(`y2`, l.b.y.toString());
};
const $3d8103e633200965$export$e97770d5bd5680bf = (el, origin)=>{
    const l = $3d8103e633200965$export$a9f065b44811fee1(el);
    return $3d8103e633200965$export$d2b1491e4450bf2c(l, origin);
};
const $3d8103e633200965$var$piPi = Math.PI * 2;
function $3d8103e633200965$var$getAngle(a, b) {
    let angle = Math.atan2(b.y - a.y, b.x - a.x); // * (180 / Math.PI) + 90;
    return angle; //return (angle < 0) ? scale(angle, -90, 0, 0, piPi) : angle;
}
const $3d8103e633200965$export$f84e8e69fd4488a5 = (ray)=>{
    return `PolarRay(angle: ${ray.angleRadian} start: ${ray.start} len: ${ray.length})`;
};
const $3d8103e633200965$export$d2b1491e4450bf2c = (l, origin)=>{
    return {
        angleRadian: (0, $da7bbf79b162d05c$export$ac0eb7b0d2fd21a).angleRadian(l.b, origin),
        start: (0, $2edc1eef02a7c199$export$686cad0ec81705cb).distance(l.a, origin),
        length: (0, $2edc1eef02a7c199$export$686cad0ec81705cb).distance(l.b, l.a)
    };
};
const $3d8103e633200965$export$a9f065b44811fee1 = (el)=>{
    const a = {
        x: el.x1.baseVal.value,
        y: el.y1.baseVal.value
    };
    const b = {
        x: el.x2.baseVal.value,
        y: el.y2.baseVal.value
    };
    return {
        a: a,
        b: b
    };
};



































const $15e15aeba6144f93$export$aeb2962556c43b13 = (f, elements)=>{
    let timer;
    let started = false;
    const start = ()=>{
        timer = f();
        started = true;
    };
    const tick = ()=>{
        if (!timer) start();
        if (!timer) return;
        const t = timer.elapsed;
        //console.log(`t: ${ t } done: ${ timer.isDone }`)
        for (const el of elements)el.tick(t);
    };
    const reset = ()=>{
        timer = undefined;
        started = false;
        for (const el of elements)if (`reset` in el) el.reset();
    };
    return {
        tick: tick,
        reset: reset,
        start: start,
        get isDone () {
            if (timer === undefined) return true;
            return timer.isDone;
        },
        get hasStarted () {
            return started;
        }
    };
};



const $2de7c93e5ce5e0c0$export$c36a889cded60e94 = (kind, total, opts = {})=>{
    switch(kind){
        case `elapsed`:
            return ()=>$29a41e51920ca8b4$export$f0e7d1106eeabbe6(total, {
                    ...opts,
                    timer: $29a41e51920ca8b4$export$14b940200a0da60a()
                });
        default:
            throw new Error(`Unknown kind: '${kind}'`);
    }
};


const $d3fa9eb7b85917ca$export$9498801aca2b282b = (f, delay, elements)=>{
    let timer;
    let delayMax = 0;
    let done = false;
    let started = false;
    const start = ()=>{
        timer = f();
        started = true;
    };
    const tick = ()=>{
        if (!timer) start();
        if (!timer) return;
        const t = timer.elapsed;
        //console.log(`staggered t: ${ t } done: ${ timer.isDone } max: ${ delayMax }`)
        let accumulatedDelay = 0;
        for (const el of elements){
            const v = t - accumulatedDelay;
            if (v >= 0) el.tick(v);
            //el.tick(Math.max(0, t - accumulatedDelay));
            accumulatedDelay += delay;
            delayMax = Math.max(delayMax, accumulatedDelay);
        }
        if (t >= 1 + delayMax) done = true;
    };
    const reset = ()=>{
        timer = undefined;
        started = false;
        for (const el of elements)if (`reset` in el) el.reset();
        else el.tick(0);
    };
    return {
        tick: tick,
        reset: reset,
        start: start,
        get isDone () {
            if (timer === undefined) return true;
            return done;
        },
        get hasStarted () {
            return started;
        }
    };
};



const $e2c63bbbd1664a35$export$f1f2b73c66cbbfe4 = (name, start, target, curve, el)=>{
    const opts = {
        limits: `ignore`
    };
    const tick = (progress)=>{
        const absoluteValue = (0, $2edc1eef02a7c199$export$4e4c1a907874f01)(progress, start, target, opts);
        el.setAttribute(name, absoluteValue.toString());
    };
    return {
        tick: tick
    };
};
const $e2c63bbbd1664a35$export$b7ce3eef51ba4d96 = (name, start, target, curve, el)=>{
    const opts = {
        limits: `ignore`
    };
    const tick = (progress)=>{
        const absoluteValue = (0, $2edc1eef02a7c199$export$4e4c1a907874f01)(progress, start, target, opts);
        el.style.setProperty(name, absoluteValue.toString());
    };
    return {
        tick: tick
    };
};
const $e2c63bbbd1664a35$export$666acc109f6734ac = (atoms)=>{
    const tick = (v)=>{
        for(let i = 0; i < atoms.length; i++)atoms[i].tick(v);
    };
    return {
        tick: tick
    };
};


const $5aad43d1050537ab$export$962d726ab254de43 = (f, thing)=>{
    let timer;
    let started = false;
    const start = ()=>{
        timer = f();
        started = true;
    };
    const tick = ()=>{
        if (!timer) start();
        if (!timer) return;
        const t = timer.elapsed;
        if (timer.isDone) thing.tick();
    };
    const reset = ()=>{
        timer = undefined;
        started = false;
    };
    return {
        tick: tick,
        reset: reset,
        start: start,
        get isDone () {
            if (timer === undefined) return true;
            if (!thing.hasStarted) return false;
            return thing.isDone;
        },
        get hasStarted () {
            return started;
        }
    };
};





function $d8209951d49845de$export$f559dee45e06cbc5(ringIndex, settings, ring) {
    const { svg: svg, origin: origin, barMaximum: pixelScale, gustThicknessScale: gustThicknessScale, minimumThickness: minimumThickness, strokeStyle: strokeStyle, speedScale: speedScale, gustScale: gustScale } = settings;
    const offset = ringIndex * (pixelScale + 15);
    const svgElements = [];
    const animationsTogether = [];
    const animationsStaggered = [];
    for (const r of ring){
        const speed = speedScale(r.speed);
        const gust = gustScale(r.gusts);
        // Swizzle angle a bit to match up with cardinal directions
        const direction = (r.direction - Math.PI / 2) % (0, $2edc1eef02a7c199$export$bd2071c7829e2c8f);
        const lengthSpeed = speed * pixelScale;
        const ray = {
            angleRadian: direction,
            length: lengthSpeed,
            start: offset
        };
        const line = $3d8103e633200965$export$24440bbdd34c95b6(ray, origin);
        const l = svg.line(line, {
            strokeWidth: minimumThickness + gustThicknessScale * gust,
            strokeStyle: strokeStyle,
            strokeLineCap: `round`
        });
        l.ray = ray;
        svgElements.push(l);
        l.innerHTML = `<title>${new Date(r.time).toLocaleString()} Speed: ${r.speed} Gusts: ${r.gusts} Direction: ${Math.floor((0, $2edc1eef02a7c199$export$1c20e104e3e29a0a)(r.direction))}</title>`;
        l.style.opacity = `0`;
        l.classList.add(`line`);
        animationsStaggered.push($e2c63bbbd1664a35$export$b7ce3eef51ba4d96(`opacity`, 0, 1, (0, $2edc1eef02a7c199$export$892cfef512d4ea3d).Named.expoOut, l));
    }
    //const ringGroup = Anim.staggeredProgress(Anim.timerFactory(`elapsed`, 10000), 0.01, animationsTogether);
    //const ringTogether = Anim.together(Anim.timerFactory(`elapsed`, 10_000), animationsTogether);
    const ringStaggered = $d3fa9eb7b85917ca$export$9498801aca2b282b($2de7c93e5ce5e0c0$export$c36a889cded60e94(`elapsed`, 5000), 0.05, animationsStaggered);
    const ringDelay = $5aad43d1050537ab$export$962d726ab254de43($2de7c93e5ce5e0c0$export$c36a889cded60e94(`elapsed`, 3000 * ringIndex), ringStaggered);
    return {
        elements: svgElements,
        group: ringDelay
    };
}
function $d8209951d49845de$export$371cab49ed4e1b88(settings, rings) {
    const { svg: svg } = settings;
    svg.clear();
    rings.reverse(); // So 0th index is now
    const visualRings = [];
    for(let i = 0; i < rings.length; i++){
        const r = $d8209951d49845de$export$f559dee45e06cbc5(i, settings, rings[i]);
        visualRings.push(r);
    }
    return visualRings;
}





// src/visual/Svg.ts
var $3818f2662e2a019f$export$e364262fc575d875 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($3818f2662e2a019f$export$e364262fc575d875, {
    Elements: ()=>$3818f2662e2a019f$export$d29d523433369b58,
    applyOpts: ()=>$3818f2662e2a019f$export$7b1e6a5873fd441c,
    applyPathOpts: ()=>$3818f2662e2a019f$export$8cc2921b9300337c,
    applyStrokeOpts: ()=>$3818f2662e2a019f$export$114026fd0ab42925,
    clear: ()=>$3818f2662e2a019f$export$42ffd38884aecdac,
    createEl: ()=>$3818f2662e2a019f$export$3d7cd8ed57263b30,
    createOrResolve: ()=>$3818f2662e2a019f$export$d1a98658dac5a035,
    getBounds: ()=>$3818f2662e2a019f$export$becd1e645219fa23,
    makeHelper: ()=>$3818f2662e2a019f$export$2760d834ea57cc3a,
    remove: ()=>$3818f2662e2a019f$export$cd7f480d6b8286c3,
    setBounds: ()=>$3818f2662e2a019f$export$c7e7ad288854879e
});
// src/visual/SvgMarkers.ts
var $3818f2662e2a019f$var$createMarker = (id, opts, childCreator)=>{
    const m = $3818f2662e2a019f$export$3d7cd8ed57263b30(`marker`, id);
    if (opts.markerWidth) m.setAttribute(`markerWidth`, opts.markerWidth?.toString());
    if (opts.markerHeight) m.setAttribute(`markerHeight`, opts.markerHeight?.toString());
    if (opts.orient) m.setAttribute(`orient`, opts.orient.toString());
    else m.setAttribute(`orient`, `auto-start-reverse`);
    if (opts.viewBox) m.setAttribute(`viewBox`, opts.viewBox.toString());
    if (opts.refX) m.setAttribute(`refX`, opts.refX.toString());
    if (opts.refY) m.setAttribute(`refY`, opts.refY.toString());
    if (childCreator) {
        const c = childCreator();
        m.appendChild(c);
    }
    return m;
};
var $3818f2662e2a019f$var$markerPrebuilt = (elem, opts, _context)=>{
    if (elem === null) return `(elem null)`;
    const parent = elem.ownerSVGElement;
    if (parent === null) throw new Error(`parent for elem is null`);
    const defsEl = $3818f2662e2a019f$export$d1a98658dac5a035(parent, `defs`, `defs`);
    let defEl = defsEl.querySelector(`#${opts.id}`);
    if (defEl !== null) return `url(#${opts.id})`;
    if (opts.id === `triangle`) {
        opts = {
            ...opts,
            strokeStyle: `transparent`
        };
        if (!opts.markerHeight) opts = {
            ...opts,
            markerHeight: 6
        };
        if (!opts.markerWidth) opts = {
            ...opts,
            markerWidth: 6
        };
        if (!opts.refX) opts = {
            ...opts,
            refX: opts.markerWidth
        };
        if (!opts.refY) opts = {
            ...opts,
            refY: opts.markerHeight
        };
        if (!opts.fillStyle || opts.fillStyle === `none`) opts = {
            ...opts,
            fillStyle: `black`
        };
        if (!opts.viewBox) opts = {
            ...opts,
            viewBox: `0 0 10 10`
        };
        defEl = $3818f2662e2a019f$var$createMarker(opts.id, opts, ()=>{
            const tri = $3818f2662e2a019f$export$3d7cd8ed57263b30(`path`);
            tri.setAttribute(`d`, `M 0 0 L 10 5 L 0 10 z`);
            if (opts) $3818f2662e2a019f$export$7b1e6a5873fd441c(tri, opts);
            return tri;
        });
    } else throw new Error(`Do not know how to make ${opts.id}`);
    defEl.id = opts.id;
    defsEl.appendChild(defEl);
    return `url(#${opts.id})`;
};
// src/visual/SvgElements.ts
var $3818f2662e2a019f$export$d29d523433369b58 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($3818f2662e2a019f$export$d29d523433369b58, {
    circle: ()=>$3818f2662e2a019f$var$circle,
    circleUpdate: ()=>$3818f2662e2a019f$var$circleUpdate,
    grid: ()=>$3818f2662e2a019f$var$grid,
    group: ()=>$3818f2662e2a019f$var$group,
    groupUpdate: ()=>$3818f2662e2a019f$var$groupUpdate,
    line: ()=>$3818f2662e2a019f$var$line,
    lineUpdate: ()=>$3818f2662e2a019f$var$lineUpdate,
    path: ()=>$3818f2662e2a019f$var$path,
    pathUpdate: ()=>$3818f2662e2a019f$var$pathUpdate,
    text: ()=>$3818f2662e2a019f$var$text,
    textPath: ()=>$3818f2662e2a019f$var$textPath,
    textPathUpdate: ()=>$3818f2662e2a019f$var$textPathUpdate,
    textUpdate: ()=>$3818f2662e2a019f$var$textUpdate
});
var $3818f2662e2a019f$var$numberOrPercentage = (v)=>{
    if (v >= 0 && v <= 1) return `${v * 100}%`;
    return v.toString();
};
var $3818f2662e2a019f$var$path = (svgOrArray, parent, opts, queryOrExisting)=>{
    const elem = $3818f2662e2a019f$export$d1a98658dac5a035(parent, `path`, queryOrExisting);
    const svg = typeof svgOrArray === `string` ? svgOrArray : svgOrArray.join(`
`);
    elem.setAttributeNS(null, `d`, svg);
    parent.append(elem);
    return $3818f2662e2a019f$var$pathUpdate(elem, opts);
};
var $3818f2662e2a019f$var$pathUpdate = (elem, opts)=>{
    if (opts) $3818f2662e2a019f$export$7b1e6a5873fd441c(elem, opts);
    if (opts) $3818f2662e2a019f$export$114026fd0ab42925(elem, opts);
    return elem;
};
var $3818f2662e2a019f$var$circleUpdate = (elem, circle2, opts)=>{
    elem.setAttributeNS(null, `cx`, circle2.x.toString());
    elem.setAttributeNS(null, `cy`, circle2.y.toString());
    elem.setAttributeNS(null, `r`, circle2.radius.toString());
    if (opts) $3818f2662e2a019f$export$7b1e6a5873fd441c(elem, opts);
    if (opts) $3818f2662e2a019f$export$114026fd0ab42925(elem, opts);
    return elem;
};
var $3818f2662e2a019f$var$circle = (circle2, parent, opts, queryOrExisting)=>{
    const p = $3818f2662e2a019f$export$d1a98658dac5a035(parent, `circle`, queryOrExisting);
    return $3818f2662e2a019f$var$circleUpdate(p, circle2, opts);
};
var $3818f2662e2a019f$var$group = (children, parent, queryOrExisting)=>{
    const p = $3818f2662e2a019f$export$d1a98658dac5a035(parent, `g`, queryOrExisting);
    return $3818f2662e2a019f$var$groupUpdate(p, children);
};
var $3818f2662e2a019f$var$groupUpdate = (elem, children)=>{
    for (const c of children)if (c.parentNode !== elem) elem.append(c);
    return elem;
};
var $3818f2662e2a019f$var$line = (line2, parent, opts, queryOrExisting)=>{
    const lineEl = $3818f2662e2a019f$export$d1a98658dac5a035(parent, `line`, queryOrExisting);
    return $3818f2662e2a019f$var$lineUpdate(lineEl, line2, opts);
};
var $3818f2662e2a019f$var$lineUpdate = (lineEl, line2, opts)=>{
    lineEl.setAttributeNS(null, `x1`, line2.a.x.toString());
    lineEl.setAttributeNS(null, `y1`, line2.a.y.toString());
    lineEl.setAttributeNS(null, `x2`, line2.b.x.toString());
    lineEl.setAttributeNS(null, `y2`, line2.b.y.toString());
    if (opts) $3818f2662e2a019f$export$7b1e6a5873fd441c(lineEl, opts);
    if (opts) $3818f2662e2a019f$export$8cc2921b9300337c(lineEl, opts);
    if (opts) $3818f2662e2a019f$export$114026fd0ab42925(lineEl, opts);
    return lineEl;
};
var $3818f2662e2a019f$var$textPathUpdate = (el, text2, opts)=>{
    if (opts?.method) el.setAttributeNS(null, `method`, opts.method);
    if (opts?.side) el.setAttributeNS(null, `side`, opts.side);
    if (opts?.spacing) el.setAttributeNS(null, `spacing`, opts.spacing);
    if (opts?.startOffset) el.setAttributeNS(null, `startOffset`, $3818f2662e2a019f$var$numberOrPercentage(opts.startOffset));
    if (opts?.textLength) el.setAttributeNS(null, `textLength`, $3818f2662e2a019f$var$numberOrPercentage(opts.textLength));
    if (text2) el.textContent = text2;
    if (opts) $3818f2662e2a019f$export$7b1e6a5873fd441c(el, opts);
    if (opts) $3818f2662e2a019f$export$114026fd0ab42925(el, opts);
    return el;
};
var $3818f2662e2a019f$var$textPath = (pathReference, text2, parent, opts, textQueryOrExisting, pathQueryOrExisting)=>{
    const textEl = $3818f2662e2a019f$export$d1a98658dac5a035(parent, `text`, textQueryOrExisting, `-text`);
    $3818f2662e2a019f$var$textUpdate(textEl, void 0, void 0, opts);
    const p = $3818f2662e2a019f$export$d1a98658dac5a035(textEl, `textPath`, pathQueryOrExisting);
    p.setAttributeNS(null, `href`, pathReference);
    return $3818f2662e2a019f$var$textPathUpdate(p, text2, opts);
};
var $3818f2662e2a019f$var$textUpdate = (el, pos, text2, opts)=>{
    if (pos) {
        el.setAttributeNS(null, `x`, pos.x.toString());
        el.setAttributeNS(null, `y`, pos.y.toString());
    }
    if (text2) el.textContent = text2;
    if (opts) {
        $3818f2662e2a019f$export$7b1e6a5873fd441c(el, opts);
        if (opts) $3818f2662e2a019f$export$114026fd0ab42925(el, opts);
        if (opts.anchor) el.setAttributeNS(null, `text-anchor`, opts.anchor);
        if (opts.align) el.setAttributeNS(null, `alignment-baseline`, opts.align);
        const userSelect = opts.userSelect ?? true;
        if (!userSelect) {
            el.style.userSelect = `none`;
            el.style.webkitUserSelect = `none`;
        }
    }
    return el;
};
var $3818f2662e2a019f$var$text = (text2, parent, pos, opts, queryOrExisting)=>{
    const p = $3818f2662e2a019f$export$d1a98658dac5a035(parent, `text`, queryOrExisting);
    return $3818f2662e2a019f$var$textUpdate(p, pos, text2, opts);
};
var $3818f2662e2a019f$var$grid = (parent, center, spacing, width1, height1, opts = {})=>{
    if (!opts.strokeStyle) opts = {
        ...opts,
        strokeStyle: (0, $8a5cbeb1c6ae1b41$export$246d3e180f7f2ea)(`bg-dim`, `silver`)
    };
    if (!opts.strokeWidth) opts = {
        ...opts,
        strokeWidth: 1
    };
    const g = $3818f2662e2a019f$export$3d7cd8ed57263b30(`g`);
    $3818f2662e2a019f$export$7b1e6a5873fd441c(g, opts);
    $3818f2662e2a019f$export$8cc2921b9300337c(g, opts);
    $3818f2662e2a019f$export$114026fd0ab42925(g, opts);
    let y = 0;
    while(y < height1){
        const horiz = (0, $3beaef080eb52aa9$export$c2b110734982f150)(0, y, width1, y);
        $3818f2662e2a019f$var$line(horiz, g);
        y += spacing;
    }
    let x = 0;
    while(x < width1){
        const vert = (0, $3beaef080eb52aa9$export$c2b110734982f150)(x, 0, x, height1);
        $3818f2662e2a019f$var$line(vert, g);
        x += spacing;
    }
    parent.append(g);
    return g;
};
// src/visual/Svg.ts
var $3818f2662e2a019f$export$d1a98658dac5a035 = (parent, type, queryOrExisting, suffix)=>{
    let existing = null;
    if (queryOrExisting !== void 0) existing = typeof queryOrExisting === `string` ? parent.querySelector(queryOrExisting) : queryOrExisting;
    if (existing === null) {
        const p = document.createElementNS(`http://www.w3.org/2000/svg`, type);
        parent.append(p);
        if (queryOrExisting && typeof queryOrExisting === `string` && queryOrExisting.startsWith(`#`)) p.id = suffix !== void 0 && !queryOrExisting.endsWith(suffix) ? queryOrExisting.slice(1) + suffix : queryOrExisting.slice(1);
        return p;
    }
    return existing;
};
var $3818f2662e2a019f$export$cd7f480d6b8286c3 = (parent, queryOrExisting)=>{
    if (typeof queryOrExisting === `string`) {
        const elem = parent.querySelector(queryOrExisting);
        if (elem === null) return;
        elem.remove();
    } else queryOrExisting.remove();
};
var $3818f2662e2a019f$export$42ffd38884aecdac = (parent)=>{
    let c = parent.lastElementChild;
    while(c){
        c.remove();
        c = parent.lastElementChild;
    }
};
var $3818f2662e2a019f$export$3d7cd8ed57263b30 = (type, id)=>{
    const m = document.createElementNS(`http://www.w3.org/2000/svg`, type);
    if (id) m.id = id;
    return m;
};
var $3818f2662e2a019f$export$8cc2921b9300337c = (elem, opts)=>{
    if (opts.markerEnd) elem.setAttribute(`marker-end`, $3818f2662e2a019f$var$markerPrebuilt(elem, opts.markerEnd, opts));
    if (opts.markerStart) elem.setAttribute(`marker-start`, $3818f2662e2a019f$var$markerPrebuilt(elem, opts.markerStart, opts));
    if (opts.markerMid) elem.setAttribute(`marker-mid`, $3818f2662e2a019f$var$markerPrebuilt(elem, opts.markerMid, opts));
};
var $3818f2662e2a019f$export$7b1e6a5873fd441c = (elem, opts)=>{
    if (opts.fillStyle) elem.setAttributeNS(null, `fill`, opts.fillStyle);
    if (opts.opacity) elem.setAttributeNS(null, `opacity`, opts.opacity.toString());
};
var $3818f2662e2a019f$export$114026fd0ab42925 = (elem, opts)=>{
    if (opts.strokeStyle) elem.setAttributeNS(null, `stroke`, opts.strokeStyle);
    if (opts.strokeWidth) elem.setAttributeNS(null, `stroke-width`, opts.strokeWidth.toString());
    if (opts.strokeDash) elem.setAttribute(`stroke-dasharray`, opts.strokeDash);
    if (opts.strokeLineCap) elem.setAttribute(`stroke-linecap`, opts.strokeLineCap);
};
var $3818f2662e2a019f$export$becd1e645219fa23 = (svg)=>{
    const w = svg.getAttributeNS(null, `width`);
    const width1 = w === null ? 0 : Number.parseFloat(w);
    const h = svg.getAttributeNS(null, `height`);
    const height1 = h === null ? 0 : Number.parseFloat(h);
    return {
        width: width1,
        height: height1
    };
};
var $3818f2662e2a019f$export$c7e7ad288854879e = (svg, bounds)=>{
    svg.setAttributeNS(null, `width`, bounds.width.toString());
    svg.setAttributeNS(null, `height`, bounds.height.toString());
};
var $3818f2662e2a019f$export$2760d834ea57cc3a = (parent, parentOpts)=>{
    if (parentOpts) {
        $3818f2662e2a019f$export$7b1e6a5873fd441c(parent, parentOpts);
        $3818f2662e2a019f$export$114026fd0ab42925(parent, parentOpts);
    }
    const o = {
        remove: (queryOrExisting)=>{
            $3818f2662e2a019f$export$cd7f480d6b8286c3(parent, queryOrExisting);
        },
        text: (text2, pos, opts, queryOrExisting)=>$3818f2662e2a019f$var$text(text2, parent, pos, opts, queryOrExisting),
        textPath: (pathReference, text2, opts, textQueryOrExisting, pathQueryOrExisting)=>$3818f2662e2a019f$var$textPath(pathReference, text2, parent, opts, textQueryOrExisting, pathQueryOrExisting),
        line: (line2, opts, queryOrExisting)=>$3818f2662e2a019f$var$line(line2, parent, opts, queryOrExisting),
        circle: (circle2, opts, queryOrExisting)=>$3818f2662e2a019f$var$circle(circle2, parent, opts, queryOrExisting),
        path: (svgString, opts, queryOrExisting)=>$3818f2662e2a019f$var$path(svgString, parent, opts, queryOrExisting),
        grid: (center, spacing, width1, height1, opts)=>$3818f2662e2a019f$var$grid(parent, center, spacing, width1, height1, opts),
        query: (selectors)=>parent.querySelector(selectors),
        get width () {
            const w = parent.getAttributeNS(null, `width`);
            if (w === null) return 0;
            return Number.parseFloat(w);
        },
        set width (width){
            parent.setAttributeNS(null, `width`, width.toString());
        },
        get parent () {
            return parent;
        },
        get height () {
            const w = parent.getAttributeNS(null, `height`);
            if (w === null) return 0;
            return Number.parseFloat(w);
        },
        set height (height){
            parent.setAttributeNS(null, `height`, height.toString());
        },
        clear: ()=>{
            while(parent.firstChild)parent.lastChild.remove();
        }
    };
    return o;
};




// src/visual/Video.ts
var $1babec5e26cea186$export$6b456564506e67b3 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($1babec5e26cea186$export$6b456564506e67b3, {
    capture: ()=>$1babec5e26cea186$var$capture,
    frames: ()=>$1babec5e26cea186$var$frames,
    manualCapture: ()=>$1babec5e26cea186$export$d7a9ca4bff3f3ec8
});
async function* $1babec5e26cea186$var$frames(sourceVideoEl, opts = {}) {
    const maxIntervalMs = opts.maxIntervalMs ?? 0;
    const showCanvas = opts.showCanvas ?? false;
    let canvasEl = opts.canvasEl;
    let w, h;
    w = h = 0;
    if (canvasEl === void 0) {
        canvasEl = document.createElement(`CANVAS`);
        canvasEl.classList.add(`ixfx-frames`);
        if (!showCanvas) canvasEl.style.display = `none`;
        document.body.appendChild(canvasEl);
    }
    const updateSize = ()=>{
        if (canvasEl === void 0) return;
        w = sourceVideoEl.videoWidth;
        h = sourceVideoEl.videoHeight;
        canvasEl.width = w;
        canvasEl.height = h;
    };
    let c = null;
    const looper = (0, $f53657e65b61d2bb$export$96448421370e6ebc)(maxIntervalMs);
    for await (const _ of looper){
        if (w === 0 || h === 0) updateSize();
        if (w === 0 || h === 0) continue;
        if (c === null) c = canvasEl.getContext(`2d`);
        if (c === null) return;
        c.drawImage(sourceVideoEl, 0, 0, w, h);
        const pixels = c.getImageData(0, 0, w, h);
        yield pixels;
    }
}
var $1babec5e26cea186$var$capture = (sourceVideoEl, opts = {})=>{
    const maxIntervalMs = opts.maxIntervalMs ?? 0;
    const showCanvas = opts.showCanvas ?? false;
    const onFrame = opts.onFrame;
    const w = sourceVideoEl.videoWidth;
    const h = sourceVideoEl.videoHeight;
    const canvasEl = document.createElement(`CANVAS`);
    canvasEl.classList.add(`ixfx-capture`);
    if (!showCanvas) canvasEl.style.display = `none`;
    canvasEl.width = w;
    canvasEl.height = h;
    let c = null;
    let worker;
    if (opts.workerScript) worker = new Worker(opts.workerScript);
    const getPixels = worker || onFrame;
    if (!getPixels && !showCanvas) console.warn(`Video will be captured to hidden element without any processing. Is this what you want?`);
    const loop = (0, $f53657e65b61d2bb$export$5df75b4acf95a98a)(()=>{
        if (c === null) c = canvasEl.getContext(`2d`);
        if (c === null) return;
        c.drawImage(sourceVideoEl, 0, 0, w, h);
        let pixels;
        if (getPixels) pixels = c.getImageData(0, 0, w, h);
        if (worker) worker.postMessage({
            pixels: pixels.data.buffer,
            width: w,
            height: h,
            channels: 4
        }, [
            pixels.data.buffer
        ]);
        if (onFrame) try {
            onFrame(pixels);
        } catch (e) {
            console.error(e);
        }
    }, maxIntervalMs);
    return {
        start: ()=>loop.start(),
        cancel: ()=>loop.cancel(),
        canvasEl: canvasEl
    };
};
var $1babec5e26cea186$export$d7a9ca4bff3f3ec8 = (sourceVideoEl, opts = {})=>{
    const showCanvas = opts.showCanvas ?? false;
    const w = sourceVideoEl.videoWidth;
    const h = sourceVideoEl.videoHeight;
    const definedCanvasEl = opts.canvasEl !== void 0;
    let canvasEl = opts.canvasEl;
    if (!canvasEl) {
        canvasEl = document.createElement(`CANVAS`);
        canvasEl.classList.add(`ixfx-capture`);
        document.body.append(canvasEl);
        if (!showCanvas) canvasEl.style.display = `none`;
    }
    canvasEl.width = w;
    canvasEl.height = h;
    const capture2 = ()=>{
        let c2;
        if (!c2) c2 = canvasEl?.getContext(`2d`, {
            willReadFrequently: true
        });
        if (!c2) throw new Error(`Could not create graphics context`);
        c2.drawImage(sourceVideoEl, 0, 0, w, h);
        const pixels = c2.getImageData(0, 0, w, h);
        pixels.currentTime = sourceVideoEl.currentTime;
        if (opts.postCaptureDraw) opts.postCaptureDraw(c2, w, h);
        return pixels;
    };
    const dispose = ()=>{
        if (definedCanvasEl) return;
        try {
            canvasEl?.remove();
        } catch (_) {}
    };
    const c = {
        canvasEl: canvasEl,
        capture: capture2,
        dispose: dispose
    };
    return c;
};









// src/collections/tree/index.ts
var $6976aa81111502b9$export$16d7dc734088cac = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($6976aa81111502b9$export$16d7dc734088cac, {
    FromObject: ()=>(0, $eca7f6cd1c865161$export$8e1e26c78c6458b6),
    Mutable: ()=>(0, $eca7f6cd1c865161$export$5d6199e7c538bbcf),
    Pathed: ()=>$6976aa81111502b9$export$5bcf239e15b1d3e,
    Traverse: ()=>$6976aa81111502b9$export$932872f4747e1ee6,
    compare: ()=>(0, $eca7f6cd1c865161$export$398604a469f7de9a),
    isTraversable: ()=>$6976aa81111502b9$export$c4687e64a6a2fbfc,
    isTreeNode: ()=>$6976aa81111502b9$export$1c189858aa1437d7,
    toTraversable: ()=>$6976aa81111502b9$export$79a456d41866cc0b
});
// src/collections/tree/Pathed.ts
var $6976aa81111502b9$export$5bcf239e15b1d3e = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($6976aa81111502b9$export$5bcf239e15b1d3e, {
    addValueByPath: ()=>$6976aa81111502b9$var$addValueByPath,
    childrenLengthByPath: ()=>$6976aa81111502b9$var$childrenLengthByPath,
    clearValuesByPath: ()=>$6976aa81111502b9$var$clearValuesByPath,
    create: ()=>$6976aa81111502b9$var$create,
    removeByPath: ()=>$6976aa81111502b9$var$removeByPath,
    valueByPath: ()=>$6976aa81111502b9$var$valueByPath,
    valuesByPath: ()=>$6976aa81111502b9$var$valuesByPath
});
var $6976aa81111502b9$var$create = (pathOpts = {})=>{
    let root;
    const add = (value, path)=>{
        const n = $6976aa81111502b9$var$addValueByPath(value, path, root, pathOpts);
        if (root === void 0) root = (0, $eca7f6cd1c865161$export$31e4419873013369)(n);
    };
    const prettyPrint = ()=>{
        if (root === void 0) return `(empty)`;
        return (0, $eca7f6cd1c865161$export$ae5510fdf995e281)(root);
    };
    const getValue = (path)=>{
        if (root === void 0) return;
        return $6976aa81111502b9$var$valueByPath(path, root, pathOpts);
    };
    const remove2 = (path)=>{
        if (root === void 0) return false;
        return $6976aa81111502b9$var$removeByPath(path, root, pathOpts);
    };
    const hasPath = (path)=>{
        if (root === void 0) return false;
        const c = $6976aa81111502b9$var$findChildByPath(path, root, pathOpts);
        return c !== void 0;
    };
    const getNode = (path)=>{
        if (root === void 0) return;
        const c = $6976aa81111502b9$var$findChildByPath(path, root, pathOpts);
        return c;
    };
    const childrenLength2 = (path)=>{
        if (root === void 0) return 0;
        const c = $6976aa81111502b9$var$findChildByPath(path, root, pathOpts);
        if (c === void 0) return 0;
        return c.childrenStore.length;
    };
    const getValues = (path)=>{
        if (root === void 0) return [];
        return $6976aa81111502b9$var$valuesByPath(path, root, pathOpts);
    };
    const getRoot2 = ()=>{
        return root;
    };
    const clearValues = (path)=>{
        if (root === void 0) return false;
        return $6976aa81111502b9$var$clearValuesByPath(path, root, pathOpts);
    };
    return {
        getRoot: getRoot2,
        add: add,
        prettyPrint: prettyPrint,
        remove: remove2,
        getValue: getValue,
        getValues: getValues,
        hasPath: hasPath,
        childrenLength: childrenLength2,
        getNode: getNode,
        clearValues: clearValues
    };
};
var $6976aa81111502b9$var$addValueByPath = (value, path, node, pathOpts = {})=>{
    const separator = pathOpts.separator ?? `.`;
    const duplicatePath = pathOpts.duplicates ?? `overwrite`;
    const split = path.split(separator);
    let count = 0;
    for (const p of split){
        const lastEntry = count === split.length - 1;
        const found = $6976aa81111502b9$var$findChildByLabel(p, node);
        if (found === void 0) {
            const labelled = {
                value: lastEntry ? value : void 0,
                label: p
            };
            node = (0, $eca7f6cd1c865161$export$270e7ba5936d3c48)(labelled, node);
        } else {
            node = found;
            if (lastEntry) switch(duplicatePath){
                case `ignore`:
                    break;
                case `allow`:
                    {
                        const existing = $6976aa81111502b9$var$getValuesFromNode(node);
                        node.value = {
                            values: [
                                ...existing,
                                value
                            ],
                            label: p
                        };
                        break;
                    }
                case `overwrite`:
                    node.value = {
                        value: value,
                        label: p
                    };
                    break;
            }
            else node = found;
        }
        count++;
    }
    if (node === void 0) throw new Error(`Could not create tree`);
    return node;
};
var $6976aa81111502b9$var$removeByPath = (path, root, pathOpts = {})=>{
    if (root === void 0) return false;
    const c = $6976aa81111502b9$var$findChildByPath(path, root, pathOpts);
    if (c === void 0) return false;
    (0, $eca7f6cd1c865161$export$cd7f480d6b8286c3)(c);
    return true;
};
var $6976aa81111502b9$var$clearValuesByPath = (path, root, pathOpts = {})=>{
    if (root === void 0) return false;
    const c = $6976aa81111502b9$var$findChildByPath(path, root, pathOpts);
    if (c === void 0) return false;
    c.value = {
        label: c.value?.label ?? ``,
        value: void 0
    };
    return true;
};
var $6976aa81111502b9$var$childrenLengthByPath = (path, node, pathOpts = {})=>{
    if (node === void 0) return 0;
    const c = $6976aa81111502b9$var$findChildByPath(path, node, pathOpts);
    if (c === void 0) return 0;
    return c.childrenStore.length;
};
var $6976aa81111502b9$var$findChildByLabel = (label, node)=>{
    if (node === void 0) return void 0;
    if (label === void 0) throw new Error(`Parameter 'label' cannot be undefined`);
    if (node.value?.label === label) return node;
    for (const c of node.childrenStore){
        if (c.value?.label === label) return c;
    }
};
var $6976aa81111502b9$var$valueByPath = (path, node, pathOpts = {})=>{
    const values = $6976aa81111502b9$var$valuesByPath(path, node, pathOpts);
    if (values.length === 0) return void 0;
    if (values.length > 1) throw new Error(`Multiple values at path. Use getValues instead`);
    return values[0];
};
var $6976aa81111502b9$var$getValuesFromNode = (c)=>{
    if (c.value === void 0) return [];
    if (`values` in c.value) return c.value.values;
    if (`value` in c.value) {
        if (c.value.value === void 0) return [];
        return [
            c.value.value
        ];
    }
    return [];
};
var $6976aa81111502b9$var$findChildByPath = (path, node, pathOpts = {})=>{
    const separator = pathOpts.separator ?? `.`;
    const split = path.split(separator);
    let c = node;
    for (const p of split){
        c = $6976aa81111502b9$var$findChildByLabel(p, c);
        if (c === void 0) return;
    }
    return c;
};
var $6976aa81111502b9$var$valuesByPath = (path, node, pathOpts = {})=>{
    const separator = pathOpts.separator ?? `.`;
    const split = path.split(separator);
    let c = node;
    for (const p of split){
        c = $6976aa81111502b9$var$findChildByLabel(p, c);
        if (c === void 0) return [];
    }
    return $6976aa81111502b9$var$getValuesFromNode(c);
};
// src/collections/tree/TraversableTree.ts
var $6976aa81111502b9$export$932872f4747e1ee6 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($6976aa81111502b9$export$932872f4747e1ee6, {
    breadthFirst: ()=>$6976aa81111502b9$var$breadthFirst,
    childrenLength: ()=>$6976aa81111502b9$var$childrenLength,
    couldAddChild: ()=>$6976aa81111502b9$var$couldAddChild,
    depthFirst: ()=>$6976aa81111502b9$var$depthFirst,
    find: ()=>$6976aa81111502b9$var$find,
    findAnyChildByValue: ()=>$6976aa81111502b9$var$findAnyChildByValue,
    findAnyParentByValue: ()=>$6976aa81111502b9$var$findAnyParentByValue,
    findByValue: ()=>$6976aa81111502b9$var$findByValue,
    findChildByValue: ()=>$6976aa81111502b9$var$findChildByValue,
    findParentByValue: ()=>$6976aa81111502b9$var$findParentByValue,
    followValue: ()=>$6976aa81111502b9$var$followValue,
    hasAnyChild: ()=>$6976aa81111502b9$var$hasAnyChild,
    hasAnyChildValue: ()=>$6976aa81111502b9$var$hasAnyChildValue,
    hasAnyParent: ()=>$6976aa81111502b9$var$hasAnyParent,
    hasAnyParentValue: ()=>$6976aa81111502b9$var$hasAnyParentValue,
    hasChild: ()=>$6976aa81111502b9$var$hasChild,
    hasChildValue: ()=>$6976aa81111502b9$var$hasChildValue,
    hasParent: ()=>$6976aa81111502b9$var$hasParent,
    hasParentValue: ()=>$6976aa81111502b9$var$hasParentValue,
    parents: ()=>$6976aa81111502b9$var$parents,
    siblings: ()=>$6976aa81111502b9$var$siblings,
    toString: ()=>$6976aa81111502b9$var$toString,
    toStringDeep: ()=>$6976aa81111502b9$var$toStringDeep2
});
var $6976aa81111502b9$var$childrenLength = (tree)=>{
    return [
        ...tree.children()
    ].length;
};
var $6976aa81111502b9$var$hasAnyParent = (child, possibleParent, eq)=>{
    return $6976aa81111502b9$var$hasParent(child, possibleParent, eq, Number.MAX_SAFE_INTEGER);
};
var $6976aa81111502b9$var$hasAnyParentValue = (child, possibleParentValue, eq)=>{
    return $6976aa81111502b9$var$hasParentValue(child, possibleParentValue, eq, Number.MAX_SAFE_INTEGER);
};
var $6976aa81111502b9$var$findAnyParentByValue = (child, possibleParentValue, eq)=>{
    return $6976aa81111502b9$var$findParentByValue(child, possibleParentValue, eq, Number.MAX_SAFE_INTEGER);
};
var $6976aa81111502b9$var$hasParent = (child, possibleParent, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b), maxDepth = 0)=>{
    if (maxDepth < 0) return false;
    const isChildTrav = $6976aa81111502b9$export$c4687e64a6a2fbfc(child);
    const isParentTrav = $6976aa81111502b9$export$c4687e64a6a2fbfc(possibleParent);
    const p = isChildTrav ? child.getParent() : child.parent;
    if (p === void 0) return false;
    if (eq(p, possibleParent)) return true;
    const pId = isChildTrav ? p.getIdentity() : p.value;
    const ppId = isParentTrav ? possibleParent.getIdentity() : possibleParent.value;
    if (eq(pId, ppId)) return true;
    return $6976aa81111502b9$var$hasParent(p, possibleParent, eq, maxDepth - 1);
};
var $6976aa81111502b9$var$hasParentValue = (child, possibleParentValue, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b), maxDepth = 0)=>{
    if (maxDepth < 0) return false;
    const p = `getParent` in child ? child.getParent() : child.parent;
    if (p === void 0) return false;
    const value = `getValue` in p ? p.getValue() : p.value;
    if (eq(value, possibleParentValue)) return true;
    return $6976aa81111502b9$var$hasParentValue(p, possibleParentValue, eq, maxDepth - 1);
};
var $6976aa81111502b9$var$findParentByValue = (child, possibleParentValue, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b), maxDepth = 0)=>{
    if (maxDepth < 0) return;
    const p = `getParent` in child ? child.getParent() : child.parent;
    if (p === void 0) return;
    const value = `getValue` in p ? p.getValue() : p.value;
    if (eq(value, possibleParentValue)) return p;
    return $6976aa81111502b9$var$findParentByValue(p, possibleParentValue, eq, maxDepth - 1);
};
var $6976aa81111502b9$var$couldAddChild = (parent, prospectiveChild, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    if (eq(parent, prospectiveChild)) throw new Error(`Child equals parent`);
    if ($6976aa81111502b9$var$hasAnyChild(parent, prospectiveChild, eq)) throw new Error(`Circular. Parent already has child`);
    if ($6976aa81111502b9$var$hasAnyChild(prospectiveChild, parent, eq)) throw new Error(`Prospective child has parent as child relation`);
};
var $6976aa81111502b9$var$hasAnyChild = (parent, possibleChild, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    return $6976aa81111502b9$var$hasChild(parent, possibleChild, eq, Number.MAX_SAFE_INTEGER);
};
var $6976aa81111502b9$var$hasAnyChildValue = (parent, possibleChildValue, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b))=>{
    return $6976aa81111502b9$var$hasChildValue(parent, possibleChildValue, eq, Number.MAX_SAFE_INTEGER);
};
var $6976aa81111502b9$var$hasChild = (parent, possibleChild, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b), maxDepth = 0)=>{
    if (maxDepth < 0) return false;
    if (eq(parent, possibleChild)) return true;
    const pId = `getIdentity` in parent ? parent.getIdentity() : parent.value;
    const pcId = `getIdentity` in possibleChild ? possibleChild.getIdentity() : possibleChild.value;
    if (eq(pId, pcId)) return true;
    for (const c of $6976aa81111502b9$var$breadthFirst(parent, maxDepth)){
        const cId = `getIdentity` in c ? c.getIdentity() : c.value;
        if (eq(c, possibleChild)) return true;
        if (eq(cId, pcId)) return true;
    }
    return false;
};
var $6976aa81111502b9$var$hasChildValue = (parent, possibleValue, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b), maxDepth = 0)=>{
    if (maxDepth < 0) return false;
    if (eq(parent.getValue(), possibleValue)) return true;
    for (const c of $6976aa81111502b9$var$breadthFirst(parent, maxDepth)){
        if (eq(c.getValue(), possibleValue)) return true;
    }
    return false;
};
function* $6976aa81111502b9$var$siblings(node) {
    const p = node.getParent();
    if (p === void 0) return;
    for (const s of p.children()){
        if (s === node) continue;
        yield s;
    }
}
function* $6976aa81111502b9$var$parents(node) {
    if ($6976aa81111502b9$export$c4687e64a6a2fbfc(node)) {
        let p = node.getParent();
        while(p !== void 0){
            yield p;
            p = p.getParent();
        }
    } else {
        let p = node.parent;
        while(p !== void 0){
            yield p;
            p = p.parent;
        }
    }
}
function $6976aa81111502b9$var$findAnyChildByValue(parent, possibleValue, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b)) {
    return $6976aa81111502b9$var$findChildByValue(parent, possibleValue, eq, Number.MAX_SAFE_INTEGER);
}
function $6976aa81111502b9$var$findChildByValue(parent, possibleValue, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b), maxDepth = 0) {
    if (maxDepth < 0) return;
    const isTraver = $6976aa81111502b9$export$c4687e64a6a2fbfc(parent);
    if (isTraver) {
        if (eq(parent.getValue(), possibleValue)) return parent;
    } else {
        if (eq(parent.value, possibleValue)) return parent;
    }
    for (const d of $6976aa81111502b9$var$breadthFirst(parent, maxDepth))if (isTraver) {
        if (eq(d.getValue(), possibleValue)) return d;
    } else {
        if (eq(d.value, possibleValue)) return d;
    }
    return;
}
function* $6976aa81111502b9$var$depthFirst(root) {
    if (!root) return;
    const stack = new (0, $eca7f6cd1c865161$export$54718c36d7236b27)();
    let entry = root;
    while(entry){
        const entries = $6976aa81111502b9$export$c4687e64a6a2fbfc(entry) ? [
            ...entry.children()
        ] : [
            ...entry.childrenStore
        ];
        stack.push(...entries);
        if (stack.isEmpty) break;
        entry = stack.pop();
        if (entry) yield entry;
    }
}
function* $6976aa81111502b9$var$breadthFirst(root, depth = Number.MAX_SAFE_INTEGER) {
    if (!root) return;
    const isTrav = $6976aa81111502b9$export$c4687e64a6a2fbfc(root);
    const queue = isTrav ? new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)() : new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)();
    let entry = root;
    while(entry){
        if (depth < 0) return;
        if (entry !== void 0) {
            const kids = `childrenStore` in entry ? entry.childrenStore : entry.children();
            for (const c of kids){
                yield c;
                queue.enqueue(c);
            }
        }
        entry = queue.dequeue();
        depth--;
    }
}
function $6976aa81111502b9$var$find(root, predicate, order = `breadth`) {
    if (predicate(root)) return root;
    const iter = order === `breadth` ? $6976aa81111502b9$var$breadthFirst : $6976aa81111502b9$var$depthFirst;
    for (const c of iter(root)){
        if (predicate(c)) return c;
    }
}
function $6976aa81111502b9$var$findByValue(root, predicate, order = `breadth`) {
    if (predicate(root.getValue())) return root;
    const iter = order === `breadth` ? $6976aa81111502b9$var$breadthFirst : $6976aa81111502b9$var$depthFirst;
    for (const c of iter(root)){
        if (predicate(c.getValue())) return c;
    }
}
function* $6976aa81111502b9$var$followValue(root, continuePredicate, depth = 1) {
    for (const c of root.children())if (continuePredicate(c.getValue(), depth)) {
        yield c.getValue();
        yield* $6976aa81111502b9$var$followValue(c, continuePredicate, depth + 1);
    }
}
function $6976aa81111502b9$var$toStringDeep2(node, depth = 0) {
    if (node === void 0) return `(undefined)`;
    if (node === null) return `(null)`;
    const v = node.getValue();
    let type = typeof v;
    if (Array.isArray(v)) type = `array`;
    let t = `  `.repeat(depth) + `value: ${JSON.stringify(v)} (${type})
`;
    for (const n of node.children())t += $6976aa81111502b9$var$toStringDeep2(n, depth + 1);
    return t;
}
function $6976aa81111502b9$var$toString(...nodes) {
    let t = ``;
    for (const node of nodes){
        const v = node.getValue();
        const vString = (0, $ae8f83c19bfd8110$export$a53336b0e6664704)(v);
        const children = [
            ...node.children()
        ];
        const parent = node.getParent();
        let type = typeof v;
        if (Array.isArray(v)) type = `array`;
        t += `value: ${vString} (${type}) kids: ${children.length} parented: ${parent ? `y` : `n`}
`;
    }
    return t;
}
// src/collections/tree/index.ts
var $6976aa81111502b9$export$79a456d41866cc0b = (node)=>{
    if ($6976aa81111502b9$export$c4687e64a6a2fbfc(node)) return node;
    if ($6976aa81111502b9$export$1c189858aa1437d7(node)) return (0, $eca7f6cd1c865161$export$29e468e556b9807e)(node);
    if (typeof node === `object`) return (0, $eca7f6cd1c865161$export$24081165d5606f1a)(node);
    throw new Error(`Parameter 'node' not convertible`);
};
var $6976aa81111502b9$export$1c189858aa1437d7 = (node)=>{
    if (`parent` in node && `childrenStore` in node && `value` in node) {
        if (Array.isArray(node.childrenStore)) return true;
    }
    return false;
};
var $6976aa81111502b9$export$c4687e64a6a2fbfc = (node)=>{
    return `children` in node && `getParent` in node && `getValue` in node && `getIdentity` in node;
};









// src/collections/Map/index.ts
var $66e1e45327700618$export$321bd8a5b2e7d10d = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($66e1e45327700618$export$321bd8a5b2e7d10d, {
    MapOfMutableImpl: ()=>$66e1e45327700618$export$647e32d15209d152,
    NumberMap: ()=>(0, $70e9cec26f7f4191$export$8f8eb378cefe093d),
    expiringMap: ()=>$66e1e45327700618$export$185802fd694ee1f5,
    immutable: ()=>(0, $70e9cec26f7f4191$export$fc3a40dec7b33bf),
    mapOfSimpleMutable: ()=>(0, $96f72d8c52c10ae7$export$37f12e23142dd83c),
    mutable: ()=>$66e1e45327700618$export$9cc7a411a0b9bd72,
    ofArrayMutable: ()=>$66e1e45327700618$export$f8d1dfa78a129756,
    ofCircularMutable: ()=>$66e1e45327700618$export$15828d04fb10f858,
    ofSetMutable: ()=>$66e1e45327700618$export$f9d65a401e2f6fdf
});
// src/collections/Map/ExpiringMap.ts
var $66e1e45327700618$export$185802fd694ee1f5 = (options = {})=>new $66e1e45327700618$export$85483ceb30353ef9(options);
var $66e1e45327700618$export$85483ceb30353ef9 = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    constructor(opts = {}){
        super();
        this.disposed = false;
        this.capacity = opts.capacity ?? -1;
        (0, $984cc5641d701af3$export$a4ff393eb12b0888)(this.capacity, `nonZero`, `capacity`);
        this.store = /* @__PURE__ */ new Map();
        if (opts.evictPolicy && this.capacity <= 0) throw new Error(`evictPolicy is set, but no capacity limit is set`);
        this.evictPolicy = opts.evictPolicy ?? `none`;
        this.autoDeleteElapsedMs = opts.autoDeleteElapsedMs ?? -1;
        this.autoDeletePolicy = opts.autoDeletePolicy ?? `none`;
        if (this.autoDeleteElapsedMs > 0) this.autoDeleteTimer = setInterval(()=>{
            this.#maintain();
        }, Math.max(1e3, this.autoDeleteElapsedMs * 2));
    }
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        if (this.autoDeleteTimer) {
            clearInterval(this.autoDeleteTimer);
            this.autoDeleteTimer = void 0;
        }
    }
    /**
   * Returns the number of keys being stored.
   */ get keyLength() {
        return this.store.size;
    }
    *entries() {
        for (const entry of this.store.entries())yield [
            entry[0],
            entry[1].value
        ];
    }
    *values() {
        for (const v of this.store.values())yield v.value;
    }
    *keys() {
        yield* this.store.keys();
    }
    /**
   * Returns the elapsed time since `key`
   * was set. Returns _undefined_ if `key`
   * does not exist
   */ elapsedSet(key) {
        const v = this.store.get(key);
        if (!v) return v;
        return Date.now() - v.lastSet;
    }
    /**
   * Returns the elapsed time since `key`
   * was accessed. Returns _undefined_ if `key`
   * does not exist
   */ elapsedGet(key) {
        const v = this.store.get(key);
        if (!v) return v;
        return Date.now() - v.lastGet;
    }
    /**
   * Returns true if `key` is stored.
   * Does not affect the key's last access time.
   * @param key
   * @returns
   */ has(key) {
        return this.store.has(key);
    }
    /**
   * Gets an item from the map by key, returning
   * undefined if not present
   * @param key Key
   * @returns Value, or undefined
   */ get(key) {
        const v = this.store.get(key);
        if (v) {
            if (this.autoDeletePolicy === `either` || this.autoDeletePolicy === `get`) this.store.set(key, {
                ...v,
                lastGet: performance.now()
            });
            return v.value;
        }
    }
    /**
   * Deletes the value under `key`, if present.
   *
   * Returns _true_ if something was removed.
   * @param key
   * @returns
   */ delete(key) {
        const value = this.store.get(key);
        if (!value) return false;
        const d = this.store.delete(key);
        this.fireEvent(`removed`, {
            key: key,
            value: value.value
        });
        return d;
    }
    /**
   * Clears the contents of the map.
   * Note: does not fire `removed` event
   */ clear() {
        this.store.clear();
    }
    /**
   * Updates the lastSet/lastGet time for a value
   * under `k`.
   *
   * Returns false if key was not found
   * @param key
   * @returns
   */ touch(key) {
        const v = this.store.get(key);
        if (!v) return false;
        this.store.set(key, {
            ...v,
            lastSet: Date.now(),
            lastGet: Date.now()
        });
        return true;
    }
    findEvicteeKey() {
        if (this.evictPolicy === `none`) return;
        let sortBy = ``;
        if (this.evictPolicy === `oldestGet`) sortBy = `lastGet`;
        else if (this.evictPolicy === `oldestSet`) sortBy = `lastSet`;
        else throw new Error(`Unknown eviction policy ${this.evictPolicy}`);
        const sorted = (0, $3ffa4b3bf3c5db47$export$96a66db6d6b0113)(this.store, sortBy);
        return sorted[0][0];
    }
    #maintain() {
        if (this.autoDeletePolicy === `none`) return;
        this.deleteWithElapsed(this.autoDeleteElapsedMs, this.autoDeletePolicy);
    }
    /**
   * Deletes all values where elapsed time has past
   * for get/set or either.
   * ```js
   * // Delete all keys (and associated values) not accessed for a minute
   * em.deleteWithElapsed({mins:1}, `get`);
   * // Delete things that were set 1s ago
   * em.deleteWithElapsed(1000, `set`);
   * ```
   * 
   * @param interval Interval
   * @param property Basis for deletion 'get','set' or 'either'
   * @returns Items removed
   */ deleteWithElapsed(interval, property) {
        const entries = [
            ...this.store.entries()
        ];
        const prune = [];
        const intervalMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(interval, 1e3);
        const now = performance.now();
        for (const entry of entries){
            const elapsedGet = now - entry[1].lastGet;
            const elapsedSet = now - entry[1].lastSet;
            const elapsed = property === `get` ? elapsedGet : property === `set` ? elapsedSet : Math.max(elapsedGet, elapsedSet);
            if (elapsed >= intervalMs) prune.push([
                entry[0],
                entry[1].value
            ]);
        }
        for (const entry of prune){
            this.store.delete(entry[0]);
            const eventArguments = {
                key: entry[0],
                value: entry[1]
            };
            this.fireEvent(`expired`, eventArguments);
            this.fireEvent(`removed`, eventArguments);
        }
        return prune;
    }
    /**
   * Sets the `key` to be `value`.
   *
   * If the key already exists, it is updated.
   *
   * If the map is full, according to its capacity,
   * another value is selected for removal.
   * @param key
   * @param value
   * @returns
   */ set(key, value) {
        const existing = this.store.get(key);
        if (existing) {
            this.store.set(key, {
                ...existing,
                lastSet: performance.now()
            });
            return;
        }
        if (this.keyLength === this.capacity && this.capacity > 0) {
            const key2 = this.findEvicteeKey();
            if (!key2) throw new Error(`ExpiringMap full (capacity: ${this.capacity})`);
            const existing2 = this.store.get(key2);
            this.store.delete(key2);
            if (existing2) {
                const eventArguments = {
                    key: key2,
                    value: existing2.value
                };
                this.fireEvent(`expired`, eventArguments);
                this.fireEvent(`removed`, eventArguments);
            }
        }
        this.store.set(key, {
            lastGet: 0,
            lastSet: performance.now(),
            value: value
        });
        this.fireEvent(`newKey`, {
            key: key,
            value: value
        });
    }
};
// src/collections/Map/MapMutable.ts
var $66e1e45327700618$export$9cc7a411a0b9bd72 = (...data)=>{
    let m = (0, $70e9cec26f7f4191$export$e16d8520af44a096)(/* @__PURE__ */ new Map(), ...data);
    return {
        add: (...data2)=>{
            m = (0, $70e9cec26f7f4191$export$e16d8520af44a096)(m, ...data2);
        },
        delete: (key)=>{
            m = (0, $70e9cec26f7f4191$export$1d2f21e549771e67)(m, key);
        },
        clear: ()=>{
            m = (0, $70e9cec26f7f4191$export$e16d8520af44a096)(/* @__PURE__ */ new Map());
        },
        set: (key, value)=>{
            m = (0, $70e9cec26f7f4191$export$adaa4cf7ef1b65be)(m, key, value);
        },
        get: (key)=>m.get(key),
        entries: ()=>m.entries(),
        values: ()=>m.values(),
        isEmpty: ()=>m.size === 0,
        has: (key)=>(0, $70e9cec26f7f4191$export$a4f4bb6b1453fff5)(m, key)
    };
};
// src/collections/Map/MapOfMultiImpl.ts
var $66e1e45327700618$export$647e32d15209d152 = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    /* eslint-disable-next-line functional/prefer-readonly-type */ #map = /* @__PURE__ */ new Map();
    constructor(type, opts = {}){
        super();
        this.type = type;
        this.groupBy = opts.groupBy ?? (0, $847987b26b102cb8$export$f5a6f2033c1996c8);
    }
    /**
   * Returns the type name. For in-built implementations, it will be one of: array, set or circular
   */ get typeName() {
        return this.type.name;
    }
    /**
   * Returns the number of keys
   */ get lengthKeys() {
        return this.#map.size;
    }
    /**
   * Returns the length of the longest child list
   */ get lengthMax() {
        let m = 0;
        for (const v of this.#map.values())m = Math.max(m, this.type.count(v));
        return m;
    }
    debugString() {
        const keys = [
            ...this.#map.keys()
        ];
        let r = `Keys: ${keys.join(`, `)}\r
`;
        for (const k of keys){
            const v = this.#map.get(k);
            if (v === void 0) r += ` - ${k} (undefined)\r
`;
            else {
                const asArray = this.type.toArray(v);
                if (asArray !== void 0) r += ` - ${k} (${this.type.count(v)}) = ${JSON.stringify(asArray)}\r
`;
            }
        }
        return r;
    }
    get isEmpty() {
        return this.#map.size === 0;
    }
    clear() {
        this.#map.clear();
        super.fireEvent(`clear`, true);
    }
    //eslint-disable-next-line functional/prefer-immutable-types
    addKeyedValues(key, ...values) {
        const set2 = this.#map.get(key);
        if (set2 === void 0) {
            this.#map.set(key, this.type.add(void 0, values));
            super.fireEvent(`addedKey`, {
                key: key
            });
            super.fireEvent(`addedValues`, {
                values: values
            });
        } else {
            this.#map.set(key, this.type.add(set2, values));
            super.fireEvent(`addedValues`, {
                values: values
            });
        }
    }
    //eslint-disable-next-line functional/prefer-immutable-types
    set(key, values) {
        this.addKeyedValues(key, ...values);
        return this;
    }
    addValue(...values) {
        for (const v of values)this.addKeyedValues(this.groupBy(v), v);
    }
    hasKeyValue(key, value, eq) {
        const m = this.#map.get(key);
        if (m === void 0) return false;
        return this.type.has(m, value, eq);
    }
    //eslint-disable-next-line functional/prefer-tacit
    has(key) {
        return this.#map.has(key);
    }
    deleteKeyValue(key, value) {
        const a = this.#map.get(key);
        if (a === void 0) return false;
        return this.deleteKeyValueFromMap(a, key, value);
    }
    deleteKeyValueFromMap(map, key, value) {
        const preCount = this.type.count(map);
        const filtered = this.type.without(map, value);
        const postCount = filtered.length;
        this.#map.set(key, this.type.add(void 0, filtered));
        return preCount > postCount;
    }
    deleteByValue(value) {
        let something = false;
        [
            ...this.#map.keys()
        ].filter((key)=>{
            const a = this.#map.get(key);
            if (!a) throw new Error(`Bug: map could not be accessed`);
            if (this.deleteKeyValueFromMap(a, key, value)) {
                something = true;
                if (this.count(key) === 0) this.delete(key);
            }
        });
        return something;
    }
    delete(key) {
        const a = this.#map.get(key);
        if (a === void 0) return false;
        this.#map.delete(key);
        this.fireEvent(`deleteKey`, {
            key: key
        });
        return true;
    }
    firstKeyByValue(value, eq = (0, $847987b26b102cb8$export$22f6c405afa58f6b)) {
        const keys = [
            ...this.#map.keys()
        ];
        const found = keys.find((key)=>{
            const a = this.#map.get(key);
            if (a === void 0) throw new Error(`Bug: map could not be accessed`);
            const r = this.type.has(a, value, eq);
            return r;
        });
        return found;
    }
    count(key) {
        const entry = this.#map.get(key);
        if (entry === void 0) return 0;
        return this.type.count(entry);
    }
    /**
   * Iterates over values stored under `key`
   * An empty array is returned if there are no values
   */ *get(key) {
        const m = this.#map.get(key);
        if (m === void 0) return;
        yield* this.type.iterable(m);
    }
    /**
   * Iterate over the values stored under `key`.
   * If key does not exist, iteration is essentially a no-op
   * @param key
   * @returns
   */ *valuesFor(key) {
        const m = this.#map.get(key);
        if (m === void 0) return;
        yield* this.type.iterable(m);
    }
    //eslint-disable-next-line functional/prefer-tacit
    getSource(key) {
        return this.#map.get(key);
    }
    /* eslint-disable-next-line functional/prefer-readonly-type */ *keys() {
        yield* this.#map.keys();
    }
    *entriesFlat() {
        for (const entry of this.#map.entries())for (const v of this.type.iterable(entry[1]))yield [
            entry[0],
            v
        ];
    }
    *valuesFlat() {
        for (const entry of this.#map.entries())yield* this.type.iterable(entry[1]);
    }
    *entries() {
        for (const [k, v] of this.#map.entries()){
            const temporary = [
                ...this.type.iterable(v)
            ];
            yield [
                k,
                temporary
            ];
        }
    }
    /* eslint-disable-next-line functional/prefer-readonly-type */ *keysAndCounts() {
        for (const key of this.keys())yield [
            key,
            this.count(key)
        ];
    }
    merge(other) {
        for (const key of other.keys()){
            const data = other.get(key);
            this.addKeyedValues(key, ...data);
        }
    }
    get size() {
        return this.#map.size;
    }
    get [Symbol.toStringTag]() {
        return this.#map[Symbol.toStringTag];
    }
};
// src/collections/Map/MapOfSetMutable.ts
var $66e1e45327700618$export$f9d65a401e2f6fdf = (options)=>{
    const hash = options?.hash ?? (0, $847987b26b102cb8$export$f5a6f2033c1996c8);
    const comparer = (a, b)=>hash(a) === hash(b);
    const t = {
        get name () {
            return `set`;
        },
        iterable: (source)=>source.values(),
        add: (dest, values)=>(0, $3ffa4b3bf3c5db47$export$702daf3d1fbfead1)(dest, hash, ...values),
        count: (source)=>source.size,
        find: (source, predicate)=>(0, $3ffa4b3bf3c5db47$export$71aa6c912b956294)(source, predicate),
        filter: (source, predicate)=>(0, $3ffa4b3bf3c5db47$export$3dea766d36a8935f)(source, predicate),
        toArray: (source)=>(0, $3ffa4b3bf3c5db47$export$45b10814cc054894)(source),
        has: (source, value)=>(0, $3ffa4b3bf3c5db47$export$d12a2b6ab14817dd)(source, value, comparer),
        without: (source, value)=>(0, $9364ac8ced0e518d$export$5d14bf425b37f49e)((0, $3ffa4b3bf3c5db47$export$45b10814cc054894)(source), value, comparer)
    };
    const m = new $66e1e45327700618$export$647e32d15209d152(t, options);
    return m;
};
// src/collections/CircularArray.ts
var $66e1e45327700618$var$CircularArray = class _CircularArray extends Array {
    // ✔ Class is unit tested!
    /* eslint-disable-next-line functional/prefer-readonly-type */ #capacity;
    /* eslint-disable-next-line functional/prefer-readonly-type */ #pointer;
    constructor(capacity = 0){
        super();
        (0, $984cc5641d701af3$export$a4ff393eb12b0888)(capacity, `positive`, `capacity`);
        this.#capacity = capacity;
        this.#pointer = 0;
    }
    /**
   * Add to array
   * @param value Thing to add
   * @returns 
   */ add(value) {
        const ca = _CircularArray.from(this);
        ca[this.#pointer] = value;
        ca.#capacity = this.#capacity;
        if (this.#capacity > 0) ca.#pointer = this.#pointer + 1 === this.#capacity ? 0 : this.#pointer + 1;
        else ca.#pointer = this.#pointer + 1;
        return ca;
    }
    get pointer() {
        return this.#pointer;
    }
    get isFull() {
        if (this.#capacity === 0) return false;
        return this.length === this.#capacity;
    }
};
var $66e1e45327700618$export$72a3ff02641d7b65 = (capacity)=>new $66e1e45327700618$var$CircularArray(capacity);
// src/collections/Map/MapOfCircularMutable.ts
var $66e1e45327700618$export$15828d04fb10f858 = (options)=>{
    const comparer = (0, $847987b26b102cb8$export$22f6c405afa58f6b);
    const t = {
        get name () {
            return `circular`;
        },
        add: (destination, values)=>{
            if (destination === void 0) destination = $66e1e45327700618$export$72a3ff02641d7b65(options.capacity);
            for (const v of values)destination = destination.add(v);
            return destination;
        },
        count: (source)=>source.length,
        find: (source, predicate)=>source.find(predicate),
        filter: (source, predicate)=>source.filter(predicate),
        toArray: (source)=>source,
        iterable: (source)=>source.values(),
        has: (source, value)=>source.find((v)=>comparer(v, value)) !== void 0,
        without: (source, value)=>source.filter((v)=>!comparer(v, value))
    };
    return new $66e1e45327700618$export$647e32d15209d152(t, options);
};
// src/collections/Map/MapOfArrayMutable.ts
var $66e1e45327700618$export$f8d1dfa78a129756 = (options = {})=>{
    const convertToString = options.convertToString;
    const toStringFunction = typeof convertToString === `undefined` ? (0, $847987b26b102cb8$export$22f6c405afa58f6b) : (a, b)=>convertToString(a) === convertToString(b);
    const comparer = options.comparer ?? toStringFunction;
    const t = {
        get name () {
            return `array`;
        },
        add: (destination, values)=>{
            if (destination === void 0) return [
                ...values
            ];
            return [
                ...destination,
                ...values
            ];
        },
        iterable: (source)=>source.values(),
        count: (source)=>source.length,
        find: (source, predicate)=>source.find((f)=>predicate(f)),
        filter: (source, predicate)=>source.filter((f)=>predicate(f)),
        toArray: (source)=>source,
        has: (source, value)=>source.some((v)=>comparer(v, value)),
        without: (source, value)=>source.filter((v)=>!comparer(v, value))
    };
    const m = new $66e1e45327700618$export$647e32d15209d152(t, options);
    return m;
};





// src/collections/queue/index.ts
var $afa7d8c33fbcfc09$export$2ddaa7a8f0593fce = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($afa7d8c33fbcfc09$export$2ddaa7a8f0593fce, {
    PriorityMutable: ()=>(0, $2edc1eef02a7c199$export$70b565fa5666e9db),
    asResponsive: ()=>$afa7d8c33fbcfc09$export$b8914c00f5589ea0,
    immutable: ()=>$afa7d8c33fbcfc09$export$fc3a40dec7b33bf,
    mutable: ()=>(0, $3f856c338f7c6dcb$export$9cc7a411a0b9bd72),
    priority: ()=>(0, $2edc1eef02a7c199$export$a5dca36e9379b9de)
});
// src/collections/queue/QueueImmutable.ts
var $afa7d8c33fbcfc09$export$8c4d82cdc064ebba = class _QueueImmutable {
    #data;
    /**
   * Creates an instance of Queue.
   * @param {QueueOpts} opts Options foor queue
   * @param {V[]} data Initial data. Index 0 is front of queue
   */ constructor(opts = {}, data = []){
        if (opts === void 0) throw new Error(`opts parameter undefined`);
        this.opts = opts;
        this.#data = data;
    }
    forEach(fn) {
        for(let index = this.#data.length - 1; index >= 0; index--)fn(this.#data[index]);
    }
    forEachFromFront(fn) {
        this.#data.forEach((item)=>{
            fn(item);
        });
    }
    enqueue(...toAdd) {
        return new _QueueImmutable(this.opts, (0, $3f856c338f7c6dcb$export$513072ba72100d9c)(this.opts, this.#data, ...toAdd));
    }
    dequeue() {
        return new _QueueImmutable(this.opts, (0, $3f856c338f7c6dcb$export$58dd174b2651c9b9)(this.opts, this.#data));
    }
    get isEmpty() {
        return (0, $3f856c338f7c6dcb$export$dd1bc94b04021eeb)(this.opts, this.#data);
    }
    get isFull() {
        return (0, $3f856c338f7c6dcb$export$491ce42b393aa93e)(this.opts, this.#data);
    }
    get length() {
        return this.#data.length;
    }
    get peek() {
        return (0, $3f856c338f7c6dcb$export$4d3fb11e950abb9e)(this.opts, this.#data);
    }
    toArray() {
        return [
            ...this.#data
        ];
    }
};
var $afa7d8c33fbcfc09$export$fc3a40dec7b33bf = (options = {}, ...startingItems)=>{
    options = {
        ...options
    };
    return new $afa7d8c33fbcfc09$export$8c4d82cdc064ebba(options, [
        ...startingItems
    ]);
};
// src/collections/queue/Responsive.ts
function $afa7d8c33fbcfc09$export$b8914c00f5589ea0(queue) {
    const events = (0, $2edc1eef02a7c199$export$d5db38ffe1f43b01)({
        onNoSubscribers () {
            queue.removeEventListener(`removed`, onRemoved);
            queue.removeEventListener(`enqueue`, onEnqueue);
        },
        onFirstSubscribe () {
            queue.addEventListener(`removed`, onRemoved);
            queue.addEventListener(`enqueue`, onEnqueue);
            events.set(queue.toArray());
        }
    });
    const onRemoved = (event)=>{
        events.set(event.finalData);
    };
    const onEnqueue = (event)=>{
        events.set(event.finalData);
    };
    const set = (data)=>{
        queue.enqueue(...data);
    };
    return {
        ...events,
        set: set
    };
}









// src/collections/index.ts
var $1f38cfeb1ba4494a$export$f8c87b2b43411943 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($1f38cfeb1ba4494a$export$f8c87b2b43411943, {
    ExpiringMap: ()=>(0, $66e1e45327700618$export$85483ceb30353ef9),
    Graphs: ()=>$1f38cfeb1ba4494a$export$fdb0cc218703fcec,
    MapOfSimpleMutable: ()=>(0, $96f72d8c52c10ae7$export$518c283e08c68164),
    Maps: ()=>(0, $66e1e45327700618$export$321bd8a5b2e7d10d),
    QueueImmutable: ()=>(0, $afa7d8c33fbcfc09$export$8c4d82cdc064ebba),
    QueueMutable: ()=>(0, $3f856c338f7c6dcb$export$24f44af47d707e8e),
    Queues: ()=>(0, $afa7d8c33fbcfc09$export$2ddaa7a8f0593fce),
    SetStringImmutable: ()=>(0, $297664b1c3fbdd1f$export$4d5b007639646df9),
    SetStringMutable: ()=>(0, $297664b1c3fbdd1f$export$c14919a124a31507),
    Sets: ()=>(0, $297664b1c3fbdd1f$export$8428685b19a2228),
    StackImmutable: ()=>$1f38cfeb1ba4494a$export$e3981ed5695202f2,
    StackMutable: ()=>(0, $eca7f6cd1c865161$export$54718c36d7236b27),
    Stacks: ()=>$1f38cfeb1ba4494a$export$ebc39c4e9a7e6f06,
    Table: ()=>(0, $2edc1eef02a7c199$export$54ec01a60f47d33d),
    Trees: ()=>(0, $6976aa81111502b9$export$16d7dc734088cac),
    circularArray: ()=>(0, $66e1e45327700618$export$72a3ff02641d7b65)
});
// src/collections/stack/index.ts
var $1f38cfeb1ba4494a$export$ebc39c4e9a7e6f06 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($1f38cfeb1ba4494a$export$ebc39c4e9a7e6f06, {
    immutable: ()=>$1f38cfeb1ba4494a$var$immutable2,
    mutable: ()=>(0, $eca7f6cd1c865161$export$9cc7a411a0b9bd72)
});
// src/collections/stack/StackImmutable.ts
var $1f38cfeb1ba4494a$export$e3981ed5695202f2 = class _StackImmutable {
    constructor(opts = {}, data = []){
        this.opts = opts;
        this.data = data;
    }
    push(...toAdd) {
        return new _StackImmutable(this.opts, (0, $eca7f6cd1c865161$export$4cbf152802aa238)(this.opts, this.data, ...toAdd));
    }
    pop() {
        return new _StackImmutable(this.opts, (0, $eca7f6cd1c865161$export$3e41007ebfff0e64)(this.opts, this.data));
    }
    forEach(fn) {
        this.data.forEach(fn);
    }
    forEachFromTop(fn) {
        [
            ...this.data
        ].reverse().forEach(fn);
    }
    get isEmpty() {
        return (0, $eca7f6cd1c865161$export$dd1bc94b04021eeb)(this.opts, this.data);
    }
    get isFull() {
        return (0, $eca7f6cd1c865161$export$491ce42b393aa93e)(this.opts, this.data);
    }
    get peek() {
        return (0, $eca7f6cd1c865161$export$4d3fb11e950abb9e)(this.opts, this.data);
    }
    get length() {
        return this.data.length;
    }
};
var $1f38cfeb1ba4494a$var$immutable2 = (options = {}, ...startingItems)=>new $1f38cfeb1ba4494a$export$e3981ed5695202f2({
        ...options
    }, [
        ...startingItems
    ]);
// src/collections/graphs/index.ts
var $1f38cfeb1ba4494a$export$fdb0cc218703fcec = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($1f38cfeb1ba4494a$export$fdb0cc218703fcec, {
    Directed: ()=>(0, $2edc1eef02a7c199$export$956d6c90d074b61e),
    Undirected: ()=>$1f38cfeb1ba4494a$var$UndirectedGraph_exports
});
// src/collections/graphs/UndirectedGraph.ts
var $1f38cfeb1ba4494a$var$UndirectedGraph_exports = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($1f38cfeb1ba4494a$var$UndirectedGraph_exports, {
    adjacentVertices: ()=>$1f38cfeb1ba4494a$var$adjacentVertices,
    connect: ()=>$1f38cfeb1ba4494a$var$connect,
    connectTo: ()=>$1f38cfeb1ba4494a$var$connectTo,
    connectWithEdges: ()=>$1f38cfeb1ba4494a$var$connectWithEdges,
    createVertex: ()=>$1f38cfeb1ba4494a$var$createVertex,
    dumpGraph: ()=>$1f38cfeb1ba4494a$var$dumpGraph,
    edgesForVertex: ()=>$1f38cfeb1ba4494a$var$edgesForVertex,
    getConnection: ()=>$1f38cfeb1ba4494a$var$getConnection,
    getOrCreate: ()=>$1f38cfeb1ba4494a$var$getOrCreate,
    graph: ()=>$1f38cfeb1ba4494a$var$graph,
    hasConnection: ()=>$1f38cfeb1ba4494a$var$hasConnection,
    toAdjacencyMatrix: ()=>$1f38cfeb1ba4494a$var$toAdjacencyMatrix,
    updateGraphVertex: ()=>$1f38cfeb1ba4494a$var$updateGraphVertex
});
var $1f38cfeb1ba4494a$var$createVertex = (id)=>{
    return {
        id: id
    };
};
var $1f38cfeb1ba4494a$var$updateGraphVertex = (graph2, vertex)=>{
    const gr = {
        ...graph2,
        vertices: graph2.vertices.set(vertex.id, vertex)
    };
    return gr;
};
var $1f38cfeb1ba4494a$var$getOrCreate = (graph2, id)=>{
    const v = graph2.vertices.get(id);
    if (v !== void 0) return {
        graph: graph2,
        vertex: v
    };
    const vv = $1f38cfeb1ba4494a$var$createVertex(id);
    const gg = $1f38cfeb1ba4494a$var$updateGraphVertex(graph2, vv);
    return {
        graph: gg,
        vertex: vv
    };
};
function $1f38cfeb1ba4494a$var$resolveVertex(graph2, idOrVertex) {
    if (idOrVertex === void 0) throw new Error(`Param 'idOrVertex' is undefined. Expected string or Vertex`);
    if (graph2 === void 0) throw new Error(`Param 'graph' is undefined. Expected Graph`);
    const v = typeof idOrVertex === `string` ? graph2.vertices.get(idOrVertex) : idOrVertex;
    if (v === void 0) throw new Error(`Id not found ${idOrVertex}`);
    return v;
}
var $1f38cfeb1ba4494a$var$hasConnection = (graph2, a, b)=>{
    const edge = $1f38cfeb1ba4494a$var$getConnection(graph2, a, b);
    return edge !== void 0;
};
var $1f38cfeb1ba4494a$var$getConnection = (graph2, a, b)=>{
    if (a === void 0) throw new Error(`Param 'a' is undefined. Expected string or Vertex`);
    if (b === void 0) throw new Error(`Param 'b' is undefined. Expected string or Vertex`);
    if (graph2 === void 0) throw new Error(`Param 'graph' is undefined. Expected Graph`);
    const aa = $1f38cfeb1ba4494a$var$resolveVertex(graph2, a);
    const bb = $1f38cfeb1ba4494a$var$resolveVertex(graph2, b);
    for (const edge of graph2.edges){
        if (edge.a == aa.id && edge.b === bb.id) return edge;
        if (edge.a == bb.id && edge.b === aa.id) return edge;
    }
    return;
};
function $1f38cfeb1ba4494a$var$connectTo(graph2, a, b, weight) {
    const aResult = $1f38cfeb1ba4494a$var$getOrCreate(graph2, a);
    graph2 = aResult.graph;
    const bResult = $1f38cfeb1ba4494a$var$getOrCreate(graph2, b);
    graph2 = bResult.graph;
    let edge = $1f38cfeb1ba4494a$var$getConnection(graph2, a, b);
    if (edge !== void 0) return {
        graph: graph2,
        edge: edge
    };
    edge = {
        a: a,
        b: b,
        weight: weight
    };
    const graphChanged = {
        ...graph2,
        edges: [
            ...graph2.edges,
            edge
        ]
    };
    return {
        graph: graphChanged,
        edge: edge
    };
}
function $1f38cfeb1ba4494a$var$connect(graph2, options) {
    const result = $1f38cfeb1ba4494a$var$connectWithEdges(graph2, options);
    return result.graph;
}
function $1f38cfeb1ba4494a$var$connectWithEdges(graph2, options) {
    const { a: a, weight: weight, b: b } = options;
    const destinations = Array.isArray(b) ? b : [
        b
    ];
    let edges = [];
    for (const destination of destinations){
        const result = $1f38cfeb1ba4494a$var$connectTo(graph2, a, destination, weight);
        graph2 = result.graph;
        edges.push(result.edge);
    }
    return {
        graph: graph2,
        edges: edges
    };
}
var $1f38cfeb1ba4494a$var$graph = (...initialConnections)=>{
    let g = {
        vertices: (0, $70e9cec26f7f4191$export$fc3a40dec7b33bf)(),
        edges: []
    };
    for (const ic of initialConnections)g = $1f38cfeb1ba4494a$var$connect(g, ic);
    return g;
};
function $1f38cfeb1ba4494a$var$toAdjacencyMatrix(graph2) {
    const v = [
        ...graph2.vertices.values()
    ];
    const table = new (0, $2edc1eef02a7c199$export$54ec01a60f47d33d)();
    table.labelColumns(...v.map((vv)=>vv.id));
    table.labelRows(...v.map((vv)=>vv.id));
    for(let i = 0; i < v.length; i++){
        table.setRow(i, v.length, false);
        const ii = v[i];
        for (const [j, jj] of v.entries()){
            const connected = $1f38cfeb1ba4494a$var$hasConnection(graph2, ii, jj);
            if (connected) table.set(i, j, true);
        }
    }
    return table;
}
var $1f38cfeb1ba4494a$var$dumpGraph = (graph2)=>{
    const lines = $1f38cfeb1ba4494a$var$debugGraphToArray(graph2);
    return lines.join(`
`);
};
var $1f38cfeb1ba4494a$var$debugGraphToArray = (graph2)=>{
    const r = [];
    r.push(`Vertices: ${[
        ...graph2.vertices.values()
    ].map((v)=>v.id).join(`, `)}`);
    r.push(`Edges:`);
    for (const edge of graph2.edges)r.push($1f38cfeb1ba4494a$var$stringForEdge(edge));
    return r;
};
var $1f38cfeb1ba4494a$var$stringForEdge = (edge)=>{
    const weight = edge.weight ? ` (${edge.weight})` : ``;
    return `${edge.a} <-> ${edge.b}${weight}`;
};
function* $1f38cfeb1ba4494a$var$adjacentVertices(graph2, context) {
    if (context === void 0) return;
    const vertex = typeof context === `string` ? graph2.vertices.get(context) : context;
    if (vertex === void 0) throw new Error(`Vertex not found ${JSON.stringify(context)}`);
    for (const edge of graph2.edges){
        if (edge.a === context) yield $1f38cfeb1ba4494a$var$resolveVertex(graph2, edge.b);
        else if (edge.b === context) yield $1f38cfeb1ba4494a$var$resolveVertex(graph2, edge.a);
    }
}
function* $1f38cfeb1ba4494a$var$edgesForVertex(graph2, context) {
    if (context === void 0) return;
    const vertex = typeof context === `string` ? graph2.vertices.get(context) : context;
    if (vertex === void 0) throw new Error(`Vertex not found ${JSON.stringify(context)}`);
    for (const edge of graph2.edges){
        if (edge.a === context) yield edge;
        else if (edge.b === context) yield edge;
    }
}













// src/visual/index.ts
var $4a5be75452a35244$export$c4d3ed51693e4b21 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($4a5be75452a35244$export$c4d3ed51693e4b21, {
    BipolarView: ()=>$4a5be75452a35244$export$2ed0aaca1d3f3267,
    CanvasRegion: ()=>$4a5be75452a35244$export$5d29fc4b64e933e0,
    CanvasSource: ()=>$4a5be75452a35244$export$ca65ccf5708c6a0c,
    CartesianCanvasPlot: ()=>$4a5be75452a35244$export$5e51109b6a1938ff,
    Colour: ()=>(0, $8a5cbeb1c6ae1b41$export$da5c41284313e6e3),
    Drawing: ()=>$4a5be75452a35244$export$f60f7d0f1cfead51,
    ImageDataGrid: ()=>(0, $da7bbf79b162d05c$export$c051a4d1797a311f),
    Palette: ()=>$4a5be75452a35244$export$509ba9b84018dca9,
    Plot: ()=>$4a5be75452a35244$export$894a0606fb744189,
    SceneGraph: ()=>$4a5be75452a35244$export$ac4e447d9c145a7a,
    Svg: ()=>(0, $3818f2662e2a019f$export$e364262fc575d875),
    Video: ()=>(0, $1babec5e26cea186$export$6b456564506e67b3),
    insert: ()=>$4a5be75452a35244$export$21a5ca8aa77d35ff
});
// src/visual/Drawing.ts
var $4a5be75452a35244$export$f60f7d0f1cfead51 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($4a5be75452a35244$export$f60f7d0f1cfead51, {
    arc: ()=>$4a5be75452a35244$var$arc,
    bezier: ()=>$4a5be75452a35244$var$bezier,
    circle: ()=>$4a5be75452a35244$var$circle,
    connectedPoints: ()=>$4a5be75452a35244$var$connectedPoints,
    copyToImg: ()=>$4a5be75452a35244$var$copyToImg,
    dot: ()=>$4a5be75452a35244$var$dot,
    drawingStack: ()=>$4a5be75452a35244$var$drawingStack,
    ellipse: ()=>$4a5be75452a35244$var$ellipse,
    getContext: ()=>$4a5be75452a35244$var$getContext,
    line: ()=>$4a5be75452a35244$var$line,
    lineThroughPoints: ()=>$4a5be75452a35244$var$lineThroughPoints,
    makeHelper: ()=>$4a5be75452a35244$export$2760d834ea57cc3a,
    paths: ()=>$4a5be75452a35244$var$paths,
    pointLabels: ()=>$4a5be75452a35244$var$pointLabels,
    rect: ()=>$4a5be75452a35244$var$rect,
    textBlock: ()=>$4a5be75452a35244$var$textBlock,
    textBlockAligned: ()=>$4a5be75452a35244$var$textBlockAligned,
    textHeight: ()=>$4a5be75452a35244$var$textHeight,
    textRect: ()=>$4a5be75452a35244$var$textRect,
    textWidth: ()=>$4a5be75452a35244$var$textWidth,
    translatePoint: ()=>$4a5be75452a35244$var$translatePoint,
    triangle: ()=>$4a5be75452a35244$var$triangle
});
var $4a5be75452a35244$var$PIPI = Math.PI * 2;
var $4a5be75452a35244$var$getContext = (canvasElementContextOrQuery)=>{
    if (canvasElementContextOrQuery === null) throw new Error(`canvasElCtxOrQuery null. Must be a 2d drawing context or Canvas element`);
    if (canvasElementContextOrQuery === void 0) throw new Error(`canvasElCtxOrQuery undefined. Must be a 2d drawing context or Canvas element`);
    const ctx = canvasElementContextOrQuery instanceof CanvasRenderingContext2D ? canvasElementContextOrQuery : canvasElementContextOrQuery instanceof HTMLCanvasElement ? canvasElementContextOrQuery.getContext(`2d`) : typeof canvasElementContextOrQuery === `string` ? (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(canvasElementContextOrQuery).getContext(`2d`) : canvasElementContextOrQuery;
    if (ctx === null) throw new Error(`Could not create 2d context for canvas`);
    return ctx;
};
var $4a5be75452a35244$export$2760d834ea57cc3a = (ctxOrCanvasEl, canvasBounds)=>{
    const ctx = $4a5be75452a35244$var$getContext(ctxOrCanvasEl);
    return {
        ctx: ctx,
        paths (pathsToDraw, opts) {
            $4a5be75452a35244$var$paths(ctx, pathsToDraw, opts);
        },
        line (lineToDraw, opts) {
            $4a5be75452a35244$var$line(ctx, lineToDraw, opts);
        },
        rect (rectsToDraw, opts) {
            $4a5be75452a35244$var$rect(ctx, rectsToDraw, opts);
        },
        bezier (bezierToDraw, opts) {
            $4a5be75452a35244$var$bezier(ctx, bezierToDraw, opts);
        },
        connectedPoints (pointsToDraw, opts) {
            $4a5be75452a35244$var$connectedPoints(ctx, pointsToDraw, opts);
        },
        pointLabels (pointsToDraw, opts) {
            $4a5be75452a35244$var$pointLabels(ctx, pointsToDraw, opts);
        },
        dot (dotPosition, opts) {
            $4a5be75452a35244$var$dot(ctx, dotPosition, opts);
        },
        circle (circlesToDraw, opts) {
            $4a5be75452a35244$var$circle(ctx, circlesToDraw, opts);
        },
        arc (arcsToDraw, opts) {
            $4a5be75452a35244$var$arc(ctx, arcsToDraw, opts);
        },
        textBlock (lines, opts) {
            if (opts.bounds === void 0 && canvasBounds !== void 0) opts = {
                ...opts,
                bounds: {
                    ...canvasBounds,
                    x: 0,
                    y: 0
                }
            };
            $4a5be75452a35244$var$textBlock(ctx, lines, opts);
        }
    };
};
var $4a5be75452a35244$var$optsOp = (opts)=>$4a5be75452a35244$var$coloringOp(opts.strokeStyle, opts.fillStyle);
var $4a5be75452a35244$var$applyOpts = (ctx, opts = {}, ...additionalOps)=>{
    if (ctx === void 0) throw new Error(`ctx undefined`);
    const stack = $4a5be75452a35244$var$drawingStack(ctx).push($4a5be75452a35244$var$optsOp(opts), ...additionalOps);
    stack.apply();
    return stack;
};
var $4a5be75452a35244$var$arc = (ctx, arcs, opts = {})=>{
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    const draw = (arc2)=>{
        ctx.beginPath();
        ctx.arc(arc2.x, arc2.y, arc2.radius, arc2.startRadian, arc2.endRadian);
        ctx.stroke();
    };
    const arcsArray = Array.isArray(arcs) ? arcs : [
        arcs
    ];
    for (const arc2 of arcsArray)draw(arc2);
};
var $4a5be75452a35244$var$coloringOp = (strokeStyle, fillStyle)=>{
    const apply = (ctx)=>{
        if (fillStyle) ctx.fillStyle = fillStyle;
        if (strokeStyle) ctx.strokeStyle = strokeStyle;
    };
    return apply;
};
var $4a5be75452a35244$var$lineOp = (lineWidth, lineJoin, lineCap)=>{
    const apply = (ctx)=>{
        if (lineWidth) ctx.lineWidth = lineWidth;
        if (lineJoin) ctx.lineJoin = lineJoin;
        if (lineCap) ctx.lineCap = lineCap;
    };
    return apply;
};
var $4a5be75452a35244$var$drawingStack = (ctx, stk)=>{
    if (stk === void 0) stk = new (0, $1f38cfeb1ba4494a$export$e3981ed5695202f2)();
    const push = (...ops)=>{
        if (stk === void 0) stk = new (0, $1f38cfeb1ba4494a$export$e3981ed5695202f2)();
        const s = stk.push(...ops);
        for (const o of ops)o(ctx);
        return $4a5be75452a35244$var$drawingStack(ctx, s);
    };
    const pop = ()=>{
        const s = stk?.pop();
        return $4a5be75452a35244$var$drawingStack(ctx, s);
    };
    const apply = ()=>{
        if (stk === void 0) return $4a5be75452a35244$var$drawingStack(ctx);
        for (const op of stk.data)op(ctx);
        return $4a5be75452a35244$var$drawingStack(ctx, stk);
    };
    return {
        push: push,
        pop: pop,
        apply: apply
    };
};
var $4a5be75452a35244$var$lineThroughPoints = (ctx, points, opts)=>{
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    ctx.moveTo(points[0].x, points[0].y);
    for (const [index, p] of points.entries()){
        if (index + 2 >= points.length) continue;
        const pNext = points[index + 1];
        const mid = {
            x: (p.x + pNext.x) / 2,
            y: (p.y + pNext.y) / 2
        };
        const cpX1 = (mid.x + p.x) / 2;
        const cpX2 = (mid.x + pNext.x) / 2;
        ctx.quadraticCurveTo(cpX1, pNext.y, mid.x, mid.y);
        ctx.quadraticCurveTo(cpX2, pNext.y, pNext.x, pNext.y);
    }
};
var $4a5be75452a35244$var$circle = (ctx, circlesToDraw, opts = {})=>{
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    const draw = (c)=>{
        ctx.beginPath();
        ctx.arc(c.x, c.y, c.radius, 0, $4a5be75452a35244$var$PIPI);
        if (opts.strokeStyle) ctx.stroke();
        if (opts.fillStyle) ctx.fill();
    };
    if (Array.isArray(circlesToDraw)) for (const c of circlesToDraw)draw(c);
    else draw(circlesToDraw);
};
var $4a5be75452a35244$var$ellipse = (ctx, ellipsesToDraw, opts = {})=>{
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    const draw = (ellipse2)=>{
        ctx.beginPath();
        const rotation = ellipse2.rotation ?? 0;
        const startAngle = ellipse2.startAngle ?? 0;
        const endAngle = ellipse2.endAngle ?? $4a5be75452a35244$var$PIPI;
        ctx.ellipse(ellipse2.x, ellipse2.y, ellipse2.radiusX, ellipse2.radiusY, rotation, startAngle, endAngle);
        if (opts.strokeStyle) ctx.stroke();
        if (opts.fillStyle) ctx.fill();
    };
    const ellipsesArray = Array.isArray(ellipsesToDraw) ? ellipsesToDraw : [
        ellipsesToDraw
    ];
    for (const ellipse2 of ellipsesArray)draw(ellipse2);
};
var $4a5be75452a35244$var$paths = (ctx, pathsToDraw, opts = {})=>{
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    const draw = (path)=>{
        if ((0, $2edc1eef02a7c199$export$9e33c9da719c393)(path)) $4a5be75452a35244$var$quadraticBezier(ctx, path, opts);
        else if ((0, $2edc1eef02a7c199$export$36082bc57fd6e7b6)(path)) $4a5be75452a35244$var$line(ctx, path, opts);
        else throw new Error(`Unknown path type ${JSON.stringify(path)}`);
    };
    if (Array.isArray(pathsToDraw)) for (const p of pathsToDraw)draw(p);
    else draw(pathsToDraw);
};
var $4a5be75452a35244$var$connectedPoints = (ctx, pts, opts = {})=>{
    const shouldLoop = opts.loop ?? false;
    (0, $876c839e98abd7e2$export$53aeea48e3d2445b)(pts);
    if (pts.length === 0) return;
    for (const [index, pt] of pts.entries())(0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `Index ${index}`);
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    if (opts.lineWidth) ctx.lineWidth = opts.lineWidth;
    ctx.beginPath();
    ctx.moveTo(pts[0].x, pts[0].y);
    for (const pt of pts)ctx.lineTo(pt.x, pt.y);
    if (shouldLoop) ctx.lineTo(pts[0].x, pts[0].y);
    if (opts.strokeStyle || opts.strokeStyle === void 0 && opts.fillStyle === void 0) ctx.stroke();
    if (opts.fillStyle) ctx.fill();
};
var $4a5be75452a35244$var$pointLabels = (ctx, pts, opts = {}, labels)=>{
    if (pts.length === 0) return;
    for (const [index, pt] of pts.entries())(0, $8a5cbeb1c6ae1b41$export$864d727b48066337)(pt, `Index ${index}`);
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    for (const [index, pt] of pts.entries()){
        const label = labels !== void 0 && index < labels.length ? labels[index] : index.toString();
        ctx.fillText(label.toString(), pt.x, pt.y);
    }
};
var $4a5be75452a35244$var$translatePoint = (ctx, point)=>{
    const m = ctx.getTransform();
    return {
        x: point.x * m.a + point.y * m.c + m.e,
        y: point.x * m.b + point.y * m.d + m.f
    };
};
var $4a5be75452a35244$var$copyToImg = (canvasEl)=>{
    const img = document.createElement(`img`);
    img.src = canvasEl.toDataURL(`image/jpeg`);
    return img;
};
var $4a5be75452a35244$var$dot = (ctx, pos, opts)=>{
    if (opts === void 0) opts = {};
    const radius = opts.radius ?? 10;
    const positions = Array.isArray(pos) ? pos : [
        pos
    ];
    const stroke = opts.stroke ? opts.stroke : opts.strokeStyle !== void 0;
    let filled = opts.filled ? opts.filled : opts.fillStyle !== void 0;
    if (!stroke && !filled) filled = true;
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    for (const pos2 of positions){
        ctx.beginPath();
        if (`radius` in pos2) ctx.arc(pos2.x, pos2.y, pos2.radius, 0, 2 * Math.PI);
        else ctx.arc(pos2.x, pos2.y, radius, 0, 2 * Math.PI);
        if (filled) ctx.fill();
        if (stroke) ctx.stroke();
    }
};
var $4a5be75452a35244$var$bezier = (ctx, bezierToDraw, opts)=>{
    if ((0, $2edc1eef02a7c199$export$9e33c9da719c393)(bezierToDraw)) $4a5be75452a35244$var$quadraticBezier(ctx, bezierToDraw, opts);
    else if ((0, $2edc1eef02a7c199$export$77290801a62f77a2)(bezierToDraw)) $4a5be75452a35244$var$cubicBezier(ctx, bezierToDraw, opts);
};
var $4a5be75452a35244$var$cubicBezier = (ctx, bezierToDraw, opts = {})=>{
    let stack = $4a5be75452a35244$var$applyOpts(ctx, opts);
    const { a: a, b: b, cubic1: cubic1, cubic2: cubic2 } = bezierToDraw;
    const isDebug = opts.debug ?? false;
    isDebug;
    ctx.beginPath();
    ctx.moveTo(a.x, a.y);
    ctx.bezierCurveTo(cubic1.x, cubic1.y, cubic2.x, cubic2.y, b.x, b.y);
    ctx.stroke();
    if (isDebug) {
        stack = stack.push($4a5be75452a35244$var$optsOp({
            ...opts,
            strokeStyle: (0, $8a5cbeb1c6ae1b41$export$876e3715299813be)(opts.strokeStyle ?? `silver`, 0.6),
            fillStyle: (0, $8a5cbeb1c6ae1b41$export$876e3715299813be)(opts.fillStyle ?? `yellow`, 0.4)
        }));
        stack.apply();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(cubic1.x, cubic1.y);
        ctx.stroke();
        ctx.moveTo(b.x, b.y);
        ctx.lineTo(cubic2.x, cubic2.y);
        ctx.stroke();
        ctx.fillText(`a`, a.x + 5, a.y);
        ctx.fillText(`b`, b.x + 5, b.y);
        ctx.fillText(`c1`, cubic1.x + 5, cubic1.y);
        ctx.fillText(`c2`, cubic2.x + 5, cubic2.y);
        $4a5be75452a35244$var$dot(ctx, cubic1, {
            radius: 3
        });
        $4a5be75452a35244$var$dot(ctx, cubic2, {
            radius: 3
        });
        $4a5be75452a35244$var$dot(ctx, a, {
            radius: 3
        });
        $4a5be75452a35244$var$dot(ctx, b, {
            radius: 3
        });
        stack = stack.pop();
        stack.apply();
    }
};
var $4a5be75452a35244$var$quadraticBezier = (ctx, bezierToDraw, opts = {})=>{
    const { a: a, b: b, quadratic: quadratic } = bezierToDraw;
    const isDebug = opts.debug ?? false;
    let stack = $4a5be75452a35244$var$applyOpts(ctx, opts);
    ctx.beginPath();
    ctx.moveTo(a.x, a.y);
    ctx.quadraticCurveTo(quadratic.x, quadratic.y, b.x, b.y);
    ctx.stroke();
    if (isDebug) {
        stack = stack.push($4a5be75452a35244$var$optsOp({
            ...opts,
            strokeStyle: (0, $8a5cbeb1c6ae1b41$export$876e3715299813be)(opts.strokeStyle ?? `silver`, 0.6),
            fillStyle: (0, $8a5cbeb1c6ae1b41$export$876e3715299813be)(opts.fillStyle ?? `yellow`, 0.4)
        }));
        $4a5be75452a35244$var$connectedPoints(ctx, [
            a,
            quadratic,
            b
        ]);
        ctx.fillText(`a`, a.x + 5, a.y);
        ctx.fillText(`b`, b.x + 5, b.y);
        ctx.fillText(`h`, quadratic.x + 5, quadratic.y);
        $4a5be75452a35244$var$dot(ctx, quadratic, {
            radius: 3
        });
        $4a5be75452a35244$var$dot(ctx, a, {
            radius: 3
        });
        $4a5be75452a35244$var$dot(ctx, b, {
            radius: 3
        });
        stack = stack.pop();
        stack.apply();
    }
};
var $4a5be75452a35244$var$line = (ctx, toDraw, opts = {})=>{
    const isDebug = opts.debug ?? false;
    const o = $4a5be75452a35244$var$lineOp(opts.lineWidth, opts.lineJoin, opts.lineCap);
    $4a5be75452a35244$var$applyOpts(ctx, opts, o);
    const draw = (d)=>{
        const { a: a, b: b } = d;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        if (isDebug) {
            ctx.fillText(`a`, a.x, a.y);
            ctx.fillText(`b`, b.x, b.y);
            $4a5be75452a35244$var$dot(ctx, a, {
                radius: 5,
                strokeStyle: `black`
            });
            $4a5be75452a35244$var$dot(ctx, b, {
                radius: 5,
                strokeStyle: `black`
            });
        }
        ctx.stroke();
    };
    if (Array.isArray(toDraw)) for (const t of toDraw)draw(t);
    else draw(toDraw);
};
var $4a5be75452a35244$var$triangle = (ctx, toDraw, opts = {})=>{
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    const draw = (t)=>{
        $4a5be75452a35244$var$connectedPoints(ctx, (0, $da7bbf79b162d05c$export$16c38b1c25c91ba)(t), {
            ...opts,
            loop: true
        });
        if (opts.debug) $4a5be75452a35244$var$pointLabels(ctx, (0, $da7bbf79b162d05c$export$16c38b1c25c91ba)(t), void 0, [
            `a`,
            `b`,
            `c`
        ]);
    };
    if (Array.isArray(toDraw)) for (const t of toDraw)draw(t);
    else draw(toDraw);
};
var $4a5be75452a35244$var$rect = (ctx, toDraw, opts = {})=>{
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    const filled = opts.filled ?? (opts.fillStyle === void 0 ? false : true);
    const stroke = opts.stroke ?? (opts.strokeStyle === void 0 ? false : true);
    const draw = (d)=>{
        const x = `x` in d ? d.x : 0;
        const y = `y` in d ? d.y : 0;
        if (filled) ctx.fillRect(x, y, d.width, d.height);
        if (stroke) {
            if (opts.strokeWidth) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeRect(x, y, d.width, d.height);
        }
        if (opts.crossed) {
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(d.width, d.height);
            ctx.stroke();
            ctx.moveTo(0, d.height);
            ctx.lineTo(d.width, 0);
            ctx.stroke();
        }
        if (opts.debug) $4a5be75452a35244$var$pointLabels(ctx, (0, $da7bbf79b162d05c$export$389cfe57f7c9dd77)(d), void 0, [
            `NW`,
            `NE`,
            `SE`,
            `SW`
        ]);
    };
    if (Array.isArray(toDraw)) for (const t of toDraw)draw(t);
    else draw(toDraw);
};
var $4a5be75452a35244$var$textWidth = (ctx, text, padding = 0, widthMultiple)=>{
    const rect2 = $4a5be75452a35244$var$textRect(ctx, text, padding, widthMultiple);
    return rect2.width;
};
var $4a5be75452a35244$var$textRect = (ctx, text, padding = 0, widthMultiple)=>{
    if (text === void 0 || text === null || text.length === 0) return 0, $da7bbf79b162d05c$export$2744bceee07c71e5;
    const m = ctx.measureText(text);
    const width = widthMultiple ? (0, $2edc1eef02a7c199$export$c0481193539b5c4e)(m.width, widthMultiple) + padding : m.width + padding;
    return {
        width: width,
        height: m.actualBoundingBoxAscent + m.actualBoundingBoxDescent + padding + padding
    };
};
var $4a5be75452a35244$var$textHeight = (ctx, text, padding = 0)=>{
    const rect2 = $4a5be75452a35244$var$textRect(ctx, text, padding);
    return rect2.height;
};
var $4a5be75452a35244$var$textBlock = (ctx, lines, opts)=>{
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    const anchorPadding = opts.anchorPadding ?? 0;
    const align = opts.align ?? `top`;
    const anchor = opts.anchor;
    const bounds = opts.bounds ?? {
        x: 0,
        y: 0,
        width: 1e6,
        height: 1e6
    };
    const blocks = lines.map((l)=>ctx.measureText(l));
    const widths = blocks.map((tm)=>tm.width);
    const heights = blocks.map((tm)=>tm.actualBoundingBoxAscent + tm.actualBoundingBoxDescent + 3);
    const maxWidth = Math.max(...widths);
    const totalHeight = heights.reduce((accumulator, value)=>accumulator + value, 0);
    let { x: x, y: y } = anchor;
    if (anchor.x + maxWidth > bounds.width) x = bounds.width - (maxWidth + anchorPadding);
    else x -= anchorPadding;
    if (x < bounds.x) x = bounds.x + anchorPadding;
    if (anchor.y + totalHeight > bounds.height) y = bounds.height - (totalHeight + anchorPadding);
    else y -= anchorPadding;
    if (y < bounds.y) y = bounds.y + anchorPadding;
    if (align === `top`) ctx.textBaseline = `top`;
    else ctx.textBaseline = `middle`;
    for (const [index, line2] of lines.entries()){
        ctx.fillText(line2, x, y);
        y += heights[index];
    }
};
var $4a5be75452a35244$var$textBlockAligned = (ctx, text, opts)=>{
    const { bounds: bounds } = opts;
    const { horiz: horiz = `left`, vert: vert = `top` } = opts;
    const lines = typeof text === `string` ? [
        text
    ] : text;
    $4a5be75452a35244$var$applyOpts(ctx, opts);
    ctx.save();
    ctx.translate(bounds.x, bounds.y);
    ctx.textAlign = `left`;
    ctx.textBaseline = `top`;
    const middleX = bounds.width / 2;
    const middleY = bounds.height / 2;
    const blocks = lines.map((l)=>ctx.measureText(l));
    const heights = blocks.map((tm)=>tm.actualBoundingBoxAscent + tm.actualBoundingBoxDescent);
    const totalHeight = heights.reduce((accumulator, value)=>accumulator + value, 0);
    let y = 0;
    if (vert === `center`) y = middleY - totalHeight / 2;
    else if (vert === `bottom`) y = bounds.height - totalHeight;
    for (const [index, line2] of lines.entries()){
        let x = 0;
        if (horiz === `center`) x = middleX - blocks[index].width / 2;
        else if (horiz === `right`) x = bounds.width - blocks[index].width;
        ctx.fillText(line2, x, y);
        y += heights[index];
    }
    ctx.restore();
};
// src/visual/Palette.ts
var $4a5be75452a35244$export$509ba9b84018dca9 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($4a5be75452a35244$export$509ba9b84018dca9, {
    create: ()=>$4a5be75452a35244$var$create
});
var $4a5be75452a35244$var$create = (fallbacks)=>new $4a5be75452a35244$var$PaletteImpl(fallbacks);
var $4a5be75452a35244$var$PaletteImpl = class {
    /* eslint-disable-next-line functional/prefer-readonly-type */ #store = /* @__PURE__ */ new Map();
    /* eslint-disable-next-line functional/prefer-readonly-type */ #aliases = /* @__PURE__ */ new Map();
    #lastFallback = 0;
    #elementBase;
    constructor(fallbacks){
        if (fallbacks !== void 0) this.fallbacks = fallbacks;
        else this.fallbacks = [
            `red`,
            `blue`,
            `green`,
            `orange`
        ];
        this.#elementBase = document.body;
    }
    setElementBase(el) {
        this.#elementBase = el;
    }
    add(key, colour) {
        this.#store.set(key, colour);
    }
    alias(from, to) {
        this.#aliases.set(from, to);
    }
    get(key, fallback) {
        const alias = this.#aliases.get(key);
        if (alias !== void 0) key = alias;
        const c = this.#store.get(key);
        if (c !== void 0) return c;
        const varName = `--` + key;
        let fromCss = getComputedStyle(this.#elementBase).getPropertyValue(varName).trim();
        if (fromCss === void 0 || fromCss.length === 0) {
            if (fallback !== void 0) return fallback;
            fromCss = this.fallbacks[this.#lastFallback];
            this.#lastFallback++;
            if (this.#lastFallback === this.fallbacks.length) this.#lastFallback = 0;
        }
        return fromCss;
    }
    getOrAdd(key, fallback) {
        if (this.has(key)) return this.get(key);
        const c = this.get(key, fallback);
        this.add(key, c);
        return c;
    }
    has(key) {
        return this.#store.has(key);
    }
};
// src/visual/SceneGraph.ts
var $4a5be75452a35244$export$ac4e447d9c145a7a = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($4a5be75452a35244$export$ac4e447d9c145a7a, {
    Box: ()=>$4a5be75452a35244$var$Box,
    CanvasBox: ()=>$4a5be75452a35244$var$CanvasBox,
    CanvasLayoutState: ()=>$4a5be75452a35244$var$CanvasLayoutState,
    CanvasMeasureState: ()=>$4a5be75452a35244$var$CanvasMeasureState,
    LayoutState: ()=>$4a5be75452a35244$var$LayoutState,
    MeasureState: ()=>$4a5be75452a35244$var$MeasureState,
    boxRectFromPx: ()=>$4a5be75452a35244$var$boxRectFromPx,
    boxRectFromRectPx: ()=>$4a5be75452a35244$var$boxRectFromRectPx,
    boxUnitFromPx: ()=>$4a5be75452a35244$var$boxUnitFromPx
});
// src/geometry/rect/Clamp.ts
var $4a5be75452a35244$var$clamp3 = (value, maximum)=>{
    return Object.freeze({
        ...value,
        width: Math.min(value.width, maximum.width),
        height: Math.min(value.height, maximum.height)
    });
};
// src/visual/SceneGraph.ts
var $4a5be75452a35244$var$boxUnitFromPx = (v)=>{
    return {
        type: `px`,
        value: v
    };
};
var $4a5be75452a35244$var$boxRectFromPx = (x, y, width, height)=>{
    return {
        x: $4a5be75452a35244$var$boxUnitFromPx(x),
        y: $4a5be75452a35244$var$boxUnitFromPx(y),
        width: $4a5be75452a35244$var$boxUnitFromPx(width),
        height: $4a5be75452a35244$var$boxUnitFromPx(height)
    };
};
var $4a5be75452a35244$var$boxRectFromRectPx = (r)=>{
    return {
        x: $4a5be75452a35244$var$boxUnitFromPx(r.x),
        y: $4a5be75452a35244$var$boxUnitFromPx(r.y),
        width: $4a5be75452a35244$var$boxUnitFromPx(r.width),
        height: $4a5be75452a35244$var$boxUnitFromPx(r.height)
    };
};
var $4a5be75452a35244$var$unitIsEqual = (a, b)=>{
    if (a.type === `px` && b.type === `px`) return a.value === b.value;
    return false;
};
var $4a5be75452a35244$var$boxRectIsEqual = (a, b)=>{
    if (a === void 0 && b === void 0) return true;
    if (a === void 0) return false;
    if (b === void 0) return false;
    if (a.x && b.x && !$4a5be75452a35244$var$unitIsEqual(a.x, b.x)) return false;
    if (a.y && b.y && !$4a5be75452a35244$var$unitIsEqual(a.y, b.y)) return false;
    if (a.width && b.width && !$4a5be75452a35244$var$unitIsEqual(a.width, b.width)) return false;
    if (a.height && b.height && !$4a5be75452a35244$var$unitIsEqual(a.height, b.height)) return false;
    return true;
};
var $4a5be75452a35244$var$BaseState = class {
    constructor(bounds){
        this.bounds = bounds;
        this.pass = 0;
    }
    resolveToPx(u, maxValue, defaultValue) {
        if (u === void 0 && defaultValue !== void 0) return defaultValue;
        if (u === void 0) return;
        if (u.type === void 0) throw new TypeError(`Expected 'type' and 'value' fields. Type is missing`);
        if (u.value === void 0) throw new TypeError(`Expected 'type' and 'value' fields. Value is missing`);
        if (u.type === `px`) return u.value;
        if (u.type === `pc`) return u.value * maxValue;
        throw new Error(`Unknown unit type: ${u.type}`);
    }
    resolveBox(box) {
        if (box === void 0) return void 0;
        const x = this.resolveToPx(box.x, this.bounds.width);
        const y = this.resolveToPx(box.y, this.bounds.height);
        const width = this.resolveToPx(box.width, this.bounds.width);
        const height = this.resolveToPx(box.height, this.bounds.height);
        if (!width || !height) throw new TypeError(`Expected width and height`);
        if (x === void 0 && y === void 0) return Object.freeze({
            width: width,
            height: height
        });
        else {
            if (!x || !y) throw new TypeError(`Expected x and y`);
            return Object.freeze({
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
    }
};
var $4a5be75452a35244$var$MeasureState = class extends $4a5be75452a35244$var$BaseState {
    constructor(bounds){
        super(bounds);
        this.measurements = /* @__PURE__ */ new Map();
    }
    getActualSize(id) {
        const s = this.measurements.get(id);
        if (s === void 0) return;
        if ((0, $2edc1eef02a7c199$export$2047bcc885291b3f)(s.actual)) return;
        return s.actual;
    }
    whatIsMeasured() {
        return [
            ...this.measurements.keys()
        ];
    }
};
var $4a5be75452a35244$var$LayoutState = class extends $4a5be75452a35244$var$BaseState {
    constructor(bounds){
        super(bounds);
        this.layouts = /* @__PURE__ */ new Map();
    }
};
var $4a5be75452a35244$var$Box = class {
    /**
   * Constructor.
   * 
   * If `parent` is provided, `parent.onChildAdded(this)` is called.
   * @param parent parent box 
   * @param id id of this box
   */ constructor(parent, id){
        /** Rectangle Box occupies in canvas/etc */ this.canvasRegion = (0, $da7bbf79b162d05c$export$87dcead6234101be);
        this.children = [];
        this._idMap = /* @__PURE__ */ new Map();
        this.debugLayout = false;
        this._visible = true;
        this._ready = true;
        this.takesSpaceWhenInvisible = false;
        this._needsMeasuring = true;
        this._needsLayoutX = true;
        this._needsDrawing = true;
        this.debugHue = (0, $8a5cbeb1c6ae1b41$export$d870adf6a93a40c)();
        this.id = id;
        this._parent = parent;
        parent?.onChildAdded(this);
    }
    /**
   * Returns _true_ if `box` is a child
   * @param box 
   * @returns 
   */ hasChild(box) {
        const byReference = this.children.find((c)=>c === box);
        const byId = this.children.find((c)=>c.id === box.id);
        return byReference !== void 0 || byId !== void 0;
    }
    /**
   * Sends a message to all child boxes.
   * 
   * This first calls `onNotify` on this instance,
   * before calling `notify()` on each child.
   * @param message 
   * @param source 
   */ notify(message, source) {
        this.onNotify(message, source);
        for (const c of this.children)c.notify(message, source);
    }
    *getChildren() {
        return this.children.entries();
    }
    /**
   * Handles a received message
   * @param _message 
   * @param _source 
   */ onNotify(_message, _source) {}
    /**
   * Notification a child box has been added
   * 
   * Throws if
   * - child has parent as its own child
   * - child is same as this
   * - child is already child of this
   * @param child 
   */ onChildAdded(child) {
        if (child.hasChild(this)) throw new Error(`Recursive`);
        if (child === this) throw new Error(`Cannot add self as child`);
        if (this.hasChild(child)) throw new Error(`Child already present`);
        this.children.push(child);
        this._idMap.set(child.id, child);
        this.layoutInvalidated(`Box.onChildAdded`);
    }
    /**
   * Sets `_ready` to `ready`. If `includeChildren` is _true_,
   * `setReady` is called on each child
   * @param ready 
   * @param includeChildren 
   */ setReady(ready, includeChildren = false) {
        this._ready = ready;
        if (includeChildren) for (const c of this.children)c.setReady(ready, includeChildren);
    }
    /**
   * Gets visible state
   */ get visible() {
        return this._visible;
    }
    /**
   * Sets visible state
   */ set visible(v) {
        if (this._visible === v) return;
        this._visible = v;
        this.layoutInvalidated(`Box.set visible`);
    }
    /**
   * Gets the box's desired region, or _undefined_
   */ get desiredRegion() {
        return this._desiredRect;
    }
    /**
   * Sets the box's desired region.
   * Calls `onLayoutNeeded()`
   */ set desiredRegion(v) {
        if ($4a5be75452a35244$var$boxRectIsEqual(v, this._desiredRect)) return;
        this._desiredRect = v;
        this.layoutInvalidated(`set desiredRegion`);
    }
    /**
   * Calls `notifyChildLayoutNeeded`
   */ layoutInvalidated(reason) {
        if (reason === void 0) debugger;
        this.debugLog(`layoutInvalidated ${reason}`);
        this._needsMeasuring = true;
        this._needsLayoutX = true;
        this._needsDrawing = true;
        this.notifyChildLayoutNeeded();
    }
    drawingInvalidated(_reason) {
        this._needsDrawing = true;
    }
    /**
   * Called from a child, notifying us that
   * its layout has changed
   * @returns 
   */ notifyChildLayoutNeeded() {
        this._needsDrawing = true;
        this._needsLayoutX = true;
        this._needsMeasuring = true;
        if (this._parent === void 0) return;
        this._parent.notifyChildLayoutNeeded();
    }
    /**
   * Returns the root box
   */ get root() {
        if (this._parent === void 0) return this;
        return this._parent.root;
    }
    /**
   * Prepare for measuring
   */ measurePreflight() {}
    /**
   * Applies actual size, returning _true_ if size is different than before
   * 
   * 1. Sets `_needsLayout` to _false_.
   * 2. Sets `visual` to `m`
   * 3. Calls `measureApply` on each child
   * 4. If there's a change or `force`, sets `needsDrawing` to _true_, and notifies root of `measureApplied`
   * @param m Measurement for box
   * @returns 
   */ measureApply(m) {
        this._needsMeasuring = false;
        const different = this._measuredSize === void 0 ? true : !(0, $da7bbf79b162d05c$export$35093e90dece5c82)(m.actual, this._measuredSize);
        if (different) this._needsLayoutX = true;
        this._measuredSize = {
            width: m.actual.width,
            height: m.actual.height
        };
        for (const c of m.children)if (c !== void 0) c.ref.measureApply(c);
        if (different) this.root.notify(`measureApplied`, this);
        return different;
    }
    layoutApply(l) {
        this._needsLayoutX = false;
        const different = this._layoutPosition === void 0 ? true : !(0, $2edc1eef02a7c199$export$248d38f6296296c5)(l.actual, this._layoutPosition);
        this._layoutPosition = {
            x: l.actual.x,
            y: l.actual.y
        };
        for (const c of l.children)if (c !== void 0) c.ref.layoutApply(c);
        if (different) this.root.notify(`layoutApplied`, this);
        return different;
    }
    /**
   * Debug log from this box context
   * @param m 
   */ debugLog(m) {
        if (!this.debugLayout) return;
        console.log(`SceneGraph[${this.id}]`, m);
    }
    layoutStart(measureState, layoutState, force, parent) {
        const m = {
            ref: this,
            actual: (0, $2edc1eef02a7c199$export$1f74963c34e8bfec),
            children: []
        };
        layoutState.layouts.set(this.id, m);
        const currentPosition = this.layoutSelf(measureState, layoutState, parent);
        this.root.notify(`laidout`, this);
        if (currentPosition === void 0) return;
        m.actual = currentPosition;
        m.children = this.children.map((c)=>c.layoutStart(measureState, layoutState, force, m));
        if ((0, $9364ac8ced0e518d$export$1ef67baf50ada97)(m.children).length < this.children.length) return void 0;
        return m;
    }
    layoutSelf(measureState, layoutState, _parent) {
        const box = layoutState.resolveBox(this._desiredRect);
        const x = box === void 0 ? 0 : `x` in box ? box.x : 0;
        const y = box === void 0 ? 0 : `y` in box ? box.y : 0;
        if (x === void 0) debugger;
        if (y === void 0) debugger;
        return {
            x: x,
            y: y
        };
    }
    /**
   * Start of measuring
   * 1. Keeps track of measurements in `opts.measurements`
   * 2. If this box takes space
   * 2.1. Measure itself if needed
   * 2.2. Use size
   * 2. Calls `measureStart` on each child
   * @param opts Options
   * @param force Force measurement
   * @param parent Parent's measurement 
   * @returns Measurement
   */ measureStart(opts, force, parent) {
        this.measurePreflight();
        const m = {
            ref: this,
            // So far no known measurement
            actual: (0, $da7bbf79b162d05c$export$84712d0562a614b8),
            children: []
        };
        opts.measurements.set(this.id, m);
        if (!this._visible && !this.takesSpaceWhenInvisible) m.actual = (0, $da7bbf79b162d05c$export$54af435d56f017ce);
        else {
            let currentMeasurement = this._measuredSize;
            if (this._needsMeasuring || this._measuredSize === void 0) {
                currentMeasurement = this.measureSelf(opts, parent);
                this.root.notify(`measured`, this);
            }
            if (typeof currentMeasurement === `string`) return;
            else if (currentMeasurement === void 0) return;
            m.actual = currentMeasurement;
        }
        m.children = this.children.map((c)=>c.measureStart(opts, force, m));
        if ((0, $9364ac8ced0e518d$export$1ef67baf50ada97)(m.children).length < this.children.length) return void 0;
        return m;
    }
    /**
   * Measure the box
   * 1. Uses desired rectangle, if possible
   * 2. Otherwise uses parent's size
   * @param opts Measure state
   * @param parent Parent size
   * @returns 
   */ measureSelf(opts, parent) {
        let size = (0, $da7bbf79b162d05c$export$84712d0562a614b8);
        const context = parent ? parent.actual : opts.bounds;
        const desired = opts.resolveBox(this._desiredRect);
        size = desired ? $4a5be75452a35244$var$clamp3(desired, context) : context;
        if ((0, $2edc1eef02a7c199$export$2047bcc885291b3f)(size)) return `Box.measureSelf - No size for box?`;
        return size;
    }
    // protected updateDone(state: MeasureState, force: boolean): void {
    //   this.onUpdateDone(state, force);
    //   for (const c of this.children) c.updateDone(state, force);
    // }
    /**
   * Update has completed
   * @param state 
   * @param force 
   */ //abstract onUpdateDone(state: MeasureState, force: boolean): void;
    /**
   * Update
   * 1. Calls `this.updateBegin()` to initialise measurement state
   * 2. In a loop, run `measureStart()` and then `measureApply` if possible
   * 3. Call `updateDone` when finished
   * @param force Force update
   * @returns 
   */ update(context, force = false) {
        if (context === void 0) throw new Error(`context is undefined`);
        if (!this._needsMeasuring && !this._needsLayoutX && !force) return;
        const [measureState, layoutState] = this.updateBegin(context);
        let attempts = 5;
        let measureApplied = false;
        let layoutApplied = false;
        if (this._needsMeasuring || force) {
            while(attempts--){
                const m = this.measureStart(measureState, force);
                if (m !== void 0) {
                    this.measureApply(m);
                    if (!this._ready) return;
                    measureApplied = true;
                }
            }
            if (!measureApplied) this.debugLog(`Ran out of measurement attempts`);
        }
        if (this._needsLayoutX || force) {
            const p = this.layoutStart(measureState, layoutState, force);
            if (p === void 0) this.debugLog(`Warning: could not layout`);
            else {
                this.layoutApply(p);
                layoutApplied = true;
            }
        }
        this.updateComplete(measureApplied, layoutApplied);
    }
};
var $4a5be75452a35244$var$CanvasMeasureState = class extends $4a5be75452a35244$var$MeasureState {
    constructor(bounds, ctx){
        super(bounds);
        this.ctx = ctx;
        if (ctx === void 0) throw new Error(`ctx is undefined`);
    }
};
var $4a5be75452a35244$var$CanvasLayoutState = class extends $4a5be75452a35244$var$LayoutState {
    constructor(bounds, ctx){
        super(bounds);
        this.ctx = ctx;
        if (ctx === void 0) throw new Error(`ctx is undefined`);
    }
};
var $4a5be75452a35244$var$CanvasBox = class _CanvasBox extends $4a5be75452a35244$var$Box {
    constructor(parent, id, bounds){
        super(parent, id);
        this.bounds = bounds;
        this.debugLog(`CanvasBox ctor bounds: ${JSON.stringify(bounds)}`);
    }
    static fromCanvas(canvasElement) {
        const box = new _CanvasBox(void 0, `canvas-box`, canvasElement.getBoundingClientRect());
        return box;
    }
    /**
   * Called if this is the parent Box
   */ addEventHandlers(element) {
        element.addEventListener(`pointermove`, (event)=>{
            const p = {
                x: event.offsetX,
                y: event.offsetY
            };
            this.notifyPointerMove(p);
        });
        element.addEventListener(`pointerleave`, (_event)=>{
            this.notifyPointerLeave();
        });
        element.addEventListener(`click`, (event)=>{
            const p = {
                x: event.offsetX,
                y: event.offsetY
            };
            this.notifyClick(p);
        });
    }
    onClick(_p) {}
    /**
   * Click event has happened on canvas
   * 1. If it's within our range, call `onClick` and pass to all children via `notifyClick`
   * @param p 
   * @returns 
   */ notifyClick(p) {
        if ((0, $2edc1eef02a7c199$export$2047bcc885291b3f)(this.canvasRegion)) return;
        if ((0, $2edc1eef02a7c199$export$5723c514448bc2af)(this.canvasRegion, p)) {
            const pp = (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(p, this.canvasRegion.x, this.canvasRegion.y);
            this.onClick(pp);
            for (const c of this.children)c.notifyClick(pp);
        }
    }
    /**
   * Pointer has left
   * 1. Pass notification to all children via `notifyPointerLeave`
   */ notifyPointerLeave() {
        this.onPointerLeave();
        for (const c of this.children)c.notifyPointerLeave();
    }
    /**
   * Pointer has moved
   * 1. If it's within range `onPointerMove` is called, and pass on to all children via `notifyPointerMove`
   * @param p 
   * @returns 
   */ notifyPointerMove(p) {
        if ((0, $2edc1eef02a7c199$export$2047bcc885291b3f)(this.canvasRegion)) return;
        if ((0, $2edc1eef02a7c199$export$5723c514448bc2af)(this.canvasRegion, p)) {
            const pp = (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(p, this.canvasRegion.x, this.canvasRegion.y);
            this.onPointerMove(pp);
            for (const c of this.children)c.notifyPointerMove(pp);
        }
    }
    /**
   * Handler when pointer has left
   */ onPointerLeave() {}
    /**
   * Handler when pointer moves within our region
   * @param _p 
   */ onPointerMove(_p) {}
    /**
   * Performs recalculations and drawing as necessary
   * If nothing needs to happen, function returns.
   * @param context 
   * @param force Force update
   */ update(context, force = false) {
        super.update(context, force);
        this.draw(context, force);
    }
    getBounds() {
        return this.bounds === void 0 && this._parent ? this._parent.bounds : this.bounds;
    }
    unsetBounds() {
        this.bounds = void 0;
    }
    /**
   * Update begins.
   * @returns MeasureState
   */ updateBegin(context) {
        if (context === void 0) throw new Error(`Context is undefined`);
        let bounds = this.getBounds();
        if (bounds === void 0) {
            this.debugLog(`No bounds for element or parent, using canvas bounds`);
            bounds = {
                x: 0,
                y: 0,
                width: context.canvas.width,
                height: context.canvas.height
            };
        }
        return [
            new $4a5be75452a35244$var$CanvasMeasureState(bounds, context),
            new $4a5be75452a35244$var$CanvasLayoutState(bounds, context)
        ];
    }
    updateComplete(_measureChanged, _layoutChanged) {
        this.canvasRegion = (0, $da7bbf79b162d05c$export$87dcead6234101be);
    }
    measureApply(m) {
        const different = super.measureApply(m);
        if (different) this.canvasRegion = (0, $da7bbf79b162d05c$export$87dcead6234101be);
        return different;
    }
    layoutApply(l) {
        const different = super.layoutApply(l);
        if (different) this.canvasRegion = (0, $da7bbf79b162d05c$export$87dcead6234101be);
        return different;
    }
    draw(ctx, force = false) {
        if (this._needsDrawing || force) {
            if ((0, $2edc1eef02a7c199$export$2047bcc885291b3f)(this.canvasRegion)) {
                if (this._layoutPosition === void 0) return;
                if (this._measuredSize === void 0) return;
                this.canvasRegion = {
                    x: this._layoutPosition.x,
                    y: this._layoutPosition.y,
                    width: this._measuredSize.width,
                    height: this._measuredSize.height
                };
            }
            this._needsLayoutX || this._needsMeasuring;
            ctx.save();
            const v = this.canvasRegion;
            ctx.translate(v.x, v.y);
            ctx.beginPath();
            ctx.rect(0, 0, v.width, v.height);
            ctx.clip();
            if (this.debugLayout) {
                ctx.lineWidth = 1;
                ctx.strokeStyle = `hsl(${this.debugHue}, 100%, 50%)`;
                ctx.strokeRect(0, 0, v.width, v.height);
                ctx.fillStyle = ctx.strokeStyle;
                ctx.fillText(this.id, 10, 10, v.width);
                ctx.beginPath();
                ctx.moveTo(0, 0);
                ctx.lineTo(v.width, v.height);
                ctx.stroke();
            }
            this.drawSelf(ctx);
            this._needsDrawing = false;
            ctx.restore();
        }
        for (const c of this.children)c.draw(ctx, force);
    }
    /**
   * Draw this object
   * @param _ctx 
   */ drawSelf(_ctx) {}
};
// src/visual/CanvasRegion.ts
var $4a5be75452a35244$export$ca65ccf5708c6a0c = class {
    #canvasEl;
    #ctx;
    #sizeBasis;
    #sizeScaler;
    #logicalSize;
    #pixelScaling;
    #regions = [];
    constructor(canvasElementOrQuery, sizeBasis = `min`){
        this.#canvasEl = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(canvasElementOrQuery);
        this.#sizeBasis = sizeBasis;
        this.#pixelScaling = window.devicePixelRatio || 1;
        this.#sizeScaler = this.#createSizeScaler();
        this.#logicalSize = this.setLogicalSize({
            width: this.#canvasEl.width,
            height: this.#canvasEl.height
        });
    }
    setLogicalSize(size) {
        this.#logicalSize = size;
        const el = this.#canvasEl;
        el.width = size.width * this.#pixelScaling;
        el.height = size.height * this.#pixelScaling;
        el.style.width = `${size.width.toString()}px`;
        el.style.height = `${size.height.toString()}px`;
        this.#sizeScaler = this.#createSizeScaler();
        this.invalidateContext();
        return size;
    }
    #createSizeScaler() {
        let inMax = 1;
        switch(this.#sizeBasis){
            case `min`:
                inMax = Math.min(this.#canvasEl.width, this.#canvasEl.height);
                break;
            case `max`:
                inMax = Math.max(this.#canvasEl.width, this.#canvasEl.height);
                break;
        }
        const s = (0, $8a5cbeb1c6ae1b41$export$eb38615a970f20ed)(0, inMax, 0, 1);
        return {
            abs: s.in,
            rel: s.out
        };
    }
    invalidateContext() {
        this.#ctx = void 0;
    }
    #add(region) {
        if (!region) throw new Error(`Param 'region' is undefined/null`);
        if (this.#regions.includes(region)) throw new Error(`Region already exists`);
        this.#regions.push(region);
        return region;
    }
    toAbsPoint(pt, kind = `independent`) {
        let { x: x, y: y } = pt;
        switch(kind){
            case `independent`:
                x *= this.width;
                y *= this.height;
        }
        return {
            x: x,
            y: y
        };
    }
    get offset() {
        const b = this.#canvasEl.getBoundingClientRect();
        return {
            x: b.left,
            y: b.top
        };
    }
    toRelPoint(pt, source, kind = `independent`, clamped = true) {
        let { x: x, y: y } = pt;
        if (source === `screen`) {
            const b = this.#canvasEl.getBoundingClientRect();
            x -= b.x;
            y -= b.y;
        }
        switch(kind){
            case `independent`:
                x /= this.width;
                y /= this.height;
                break;
            case `skip`:
                break;
        }
        if (clamped) {
            x = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(x);
            y = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(y);
        }
        return {
            x: x,
            y: y
        };
    }
    toAbsRect(rect2, kind = `independent`) {
        let { width: width, height: height } = rect2;
        switch(kind){
            case `independent`:
                width *= this.width;
                height *= this.height;
                if ((0, $da7bbf79b162d05c$export$40726222f7ec099b).isRectPositioned(rect2)) return {
                    ...this.toAbsPoint(rect2),
                    width: width,
                    height: height
                };
        }
        return {
            width: width,
            height: height
        };
    }
    /**
   * Creates a region
   * 
   * Absolute positioned. Uses source coordinates which don't change
   * ```js
   * source.createRegion({ 
   *  absPositioned: { x: 0, y: 0, width: 100, height: 100} 
   * });
   * ```
   * 
   * Relative positioned. Uses coordiantes relative to source dimensions.
   * Updated if source changes.
   * ```js
   * source.createRegion({
   *  relativePositioned: { x: 0, y:0, width: 1, height: 0.5 },
   *  scale: `independent`
   * });
   * ```
   * 
   * Relative sized. Uses size relative to source dimension. By default centers.
   * ```js
   * source.createRegion({
   *  relativeSize: { width: 0.5, height: 0.5 }
   *  position: `center`
   * })
   * ```
   * @param spec 
   * @returns 
   */ createRegion(spec) {
        const marginPx = spec.marginPx ?? 0;
        const marginPx2 = marginPx * 2;
        if (`absPositioned` in spec) {
            const rect2 = (0, $da7bbf79b162d05c$export$40726222f7ec099b).subtractSize(spec.absPositioned, marginPx, marginPx);
            return this.#add(new $4a5be75452a35244$export$5d29fc4b64e933e0(this, ()=>rect2));
        }
        if (`relativePositioned` in spec) {
            let compute;
            const rect2 = spec.relativePositioned;
            switch(spec.scale){
                case `independent`:
                    compute = (source)=>({
                            x: rect2.x * source.width + marginPx,
                            y: rect2.y * source.height + marginPx,
                            width: rect2.width * source.width - marginPx2,
                            height: rect2.height * source.height - marginPx2
                        });
                    break;
                default:
                    throw new Error(`Param 'kind' unknown (${spec.scale})`);
            }
            return this.#add(new $4a5be75452a35244$export$5d29fc4b64e933e0(this, compute));
        }
        if (`relativeSize` in spec) {
            let compute;
            const rect2 = spec.relativeSize;
            const position = spec.position;
            switch(spec.scale){
                case `independent`:
                    compute = (source)=>{
                        const width = rect2.width * source.width - marginPx2;
                        const height = rect2.height * source.height - marginPx2;
                        let x = source.width / 2 - width / 2;
                        let y = source.height / 2 - height / 2;
                        switch(position){
                            case `n`:
                                y = 0;
                                break;
                            case `s`:
                                y = source.height - height;
                                break;
                            default:
                        }
                        x += marginPx;
                        y += marginPx;
                        return {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        };
                    };
                    break;
                default:
                    throw new Error(`Param 'kind' unknown (${spec.scale})`);
            }
            return this.#add(new $4a5be75452a35244$export$5d29fc4b64e933e0(this, compute));
        }
        if (`match` in spec) {
            const result = (0, $35a128b42d0e06cd$export$832ddfb93b3cb5a2)(spec.match);
            if (!result.success) throw new Error(`Could not resolve match element. ${(0, $e8ad1dce15e1a2c0$export$99d5c87bcc0b582e)(result)}`);
            const compute = (_source)=>{
                const bounds = result.value.getBoundingClientRect();
                return {
                    x: bounds.x + marginPx,
                    y: bounds.y + marginPx,
                    width: bounds.width - marginPx2,
                    height: bounds.height - marginPx2
                };
            };
            return this.#add(new $4a5be75452a35244$export$5d29fc4b64e933e0(this, compute));
        }
        throw new Error(`Spec doesn't seem valid`);
    }
    clear() {
        const c = this.context;
        c.clearRect(0, 0, this.width, this.height);
    }
    get context() {
        if (this.#ctx) return this.#ctx;
        const c = this.#canvasEl.getContext(`2d`);
        if (!c) throw new Error(`Could not create 2d context`);
        c.setTransform(1, 0, 0, 1, 0, 0);
        c.scale(this.#pixelScaling, this.#pixelScaling);
        this.#ctx = c;
        for (const r of this.#regions)r.recomputeRegion();
        return this.#ctx;
    }
    get sizeScaler() {
        return this.#sizeScaler;
    }
    get width() {
        return this.#logicalSize.width;
    }
    get height() {
        return this.#logicalSize.height;
    }
};
var $4a5be75452a35244$export$5d29fc4b64e933e0 = class {
    #regionCompute;
    #r;
    /**
   * Creates, using coordinate in canvas coordinates
   */ constructor(source, regionCompute){
        this.source = source;
        this.#regionCompute = regionCompute;
        this.#r = regionCompute(source);
    }
    /**
   * Calls the original `regionCompute` function passed in to the constructor
   * to recompute the absolute region
   */ recomputeRegion() {
        this.#r = this.#regionCompute(this.source);
    }
    /**
   * Converts a region-relative point (0..1) to an absolute
   * point, which uses region-relative coordinates.
   * 
   * Eg if the region had an x,y of 100,100, `toAbsRegion({x:0,y:0})`
   * will return 0,0.
   *
   * @param regionRel 
   * @param scaleBy 
   * @returns 
   */ toAbsRegion(regionRel, scaleBy = `both`) {
        switch(scaleBy){
            case `both`:
                return {
                    x: regionRel.x * this.#r.width,
                    y: regionRel.y * this.#r.height
                };
        }
    }
    /**
   * Returns a copy of `p` offset by the region's x & y
   * @param p 
   * @returns 
   */ applyRegionOffset(p) {
        return {
            x: p.x + this.#r.x,
            y: p.y + this.#r.y
        };
    }
    /**
   * Draws a line from a series of points.
   * Assumes region-relative, % coordinates (ie 0..1 scale)
   * @param relativePoints Points to connect, in region-relative coordinates
   * @param strokeStyle Stroke style
   * @param lineWidth Line with
   */ drawConnectedPointsRelative(relativePoints, strokeStyle, lineWidth = 1) {
        const points = relativePoints.map((p)=>this.toAbsRegion(p));
        this.drawConnectedPoints(points, strokeStyle, lineWidth);
    }
    /**
   * Draws connected points in absolute coordinates,
   * however with 0,0 being the top-left of the region.
   * 
   * Thus, this will apply the region offset before drawing.
   * @param points Points to draw
   * @param strokeStyle Stroke style
   * @param lineWidth Line width
   */ drawConnectedPoints(points, strokeStyle, lineWidth = 1) {
        const c = this.context;
        c.save();
        c.translate(this.#r.x, this.#r.y);
        c.beginPath();
        c.strokeStyle = strokeStyle;
        c.lineWidth = lineWidth;
        for(let index = 0; index < points.length; index++)if (index === 0) c.moveTo(points[index].x, points[index].y);
        else c.lineTo(points[index].x, points[index].y);
        c.stroke();
        c.restore();
    }
    /**
   * Fills text at a relative position
   * @param text 
   * @param relPos Relative, meaning 0.5,0.5 is the middle of the region
   * @param fillStyle 
   * @param baseline 
   * @param align 
   */ fillTextRelative(text, relPos, fillStyle = `black`, font, baseline = `alphabetic`, align = `start`) {
        const point = this.toAbsRegion(relPos);
        this.fillTextRelative(text, point, fillStyle, font, baseline, align);
    }
    /**
   * Fills text at a region-relative position
   * @param text 
   * @param point Region relative, meaning 0,0 is top-left of region
   * @param fillStyle 
   * @param baseline 
   * @param align 
   */ fillText(text, point, fillStyle = `black`, font, baseline = `alphabetic`, align = `start`) {
        const c = this.context;
        c.save();
        c.translate(this.#r.x, this.#r.y);
        if (font.length > 0) c.font = font;
        c.textBaseline = baseline;
        c.textAlign = align;
        c.fillStyle = fillStyle;
        c.fillText(text, point.x, point.y);
        c.restore();
    }
    drawCircles(relativeCircles, fillStyle, strokeStyle = ``, lineWidth = 1) {
        const circles = relativeCircles.map((c2)=>{
            return {
                ...this.toAbsRegion(c2),
                radius: this.source.sizeScaler.abs(c2.radius)
            };
        });
        const c = this.context;
        c.save();
        c.translate(this.#r.x, this.#r.y);
        c.fillStyle = fillStyle;
        c.strokeStyle = strokeStyle;
        c.lineWidth = lineWidth;
        for (const circle2 of circles){
            c.beginPath();
            c.arc(circle2.x, circle2.y, circle2.radius, 0, (0, $2edc1eef02a7c199$export$bd2071c7829e2c8f));
            c.closePath();
            if (fillStyle.length > 0) c.fill();
            if (strokeStyle.length > 0) c.stroke();
        }
        c.restore();
    }
    clear() {
        const c = this.context;
        c.clearRect(this.#r.x, this.#r.y, this.#r.width, this.#r.height);
    }
    fill(fillStyle = `white`) {
        const c = this.context;
        c.fillStyle = fillStyle;
        c.fillRect(this.#r.x, this.#r.y, this.#r.width, this.#r.height);
    }
    drawBounds(strokeStyle, lineWidth = 1) {
        this.drawConnectedPointsRelative([
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 1,
                y: 1
            },
            {
                x: 0,
                y: 1
            },
            {
                x: 0,
                y: 0
            }
        ], strokeStyle, lineWidth);
        this.drawConnectedPointsRelative([
            {
                x: 0,
                y: 1
            },
            {
                x: 1,
                y: 0
            }
        ], strokeStyle, lineWidth);
        this.drawConnectedPointsRelative([
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 1
            }
        ], strokeStyle, lineWidth);
    }
    /**
   * Converts a  point to a region-relative one.
   * @param pt 
   * @param kind 
   * @returns 
   */ toRelPoint(pt, source = `screen`, kind = `independent`, clamped = true) {
        pt = this.source.toRelPoint(pt, source, `skip`, false);
        let { x: x, y: y } = pt;
        x -= this.x;
        y -= this.y;
        switch(kind){
            case `independent`:
                x /= this.width;
                y /= this.height;
        }
        if (clamped) {
            x = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(x);
            y = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(y);
        }
        return {
            x: x,
            y: y
        };
    }
    absToRegionPoint(pt, source, clamped) {
        if (source === `screen`) pt = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).subtract(pt, this.source.offset);
        let { x: x, y: y } = pt;
        x -= this.x;
        y -= this.y;
        if (clamped) {
            if (x < 0) x = 0;
            if (y < 0) y = 0;
            if (x > this.width + this.x) x = this.x + this.width;
            if (y > this.height + this.y) y = this.y + this.height;
        }
        return {
            x: x,
            y: y
        };
    }
    get center() {
        return (0, $da7bbf79b162d05c$export$40726222f7ec099b).center(this.#r);
    }
    get context() {
        return this.source.context;
    }
    set region(value) {
        this.#r = value;
    }
    get region() {
        return this.#r;
    }
    get width() {
        return this.#r.width;
    }
    get height() {
        return this.#r.height;
    }
    get x() {
        return this.#r.x;
    }
    get y() {
        return this.#r.y;
    }
    get dimensionMin() {
        return Math.min(this.#r.width, this.#r.height);
    }
};
// src/visual/BipolarView.ts
var $4a5be75452a35244$export$2ed0aaca1d3f3267 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($4a5be75452a35244$export$2ed0aaca1d3f3267, {
    init: ()=>$4a5be75452a35244$var$init
});
function $4a5be75452a35244$var$getNumericAttribute(el, name, defaultValue) {
    const a = el.getAttribute(name);
    if (a === null) return defaultValue;
    return Number.parseInt(a);
}
var $4a5be75452a35244$var$init = (elementQuery, options = {})=>{
    const element = document.querySelector(elementQuery);
    if (!element) throw new Error(`Element query could not be found (${elementQuery})`);
    const labels = options.labels ?? [
        `x`,
        `y`
    ];
    const labelPrecision = options.labelPrecision ?? 2;
    const asPercentages = options.asPercentages ?? false;
    const displayLastValues = options.displayLastValues ?? 0;
    const showWhiskers = options.showWhiskers ?? true;
    const showDot = options.showDot ?? true;
    const showLabels = options.showLabels ?? true;
    const yAxisBottomNegative = options.yAxisBottomNegative ?? true;
    const axisColour = (0, $8a5cbeb1c6ae1b41$export$23fa9a8c7e36c17)(options.axisColour, `silver`);
    const bgColour = (0, $8a5cbeb1c6ae1b41$export$23fa9a8c7e36c17)(options.bgColour, `white`);
    const whiskerColour = (0, $8a5cbeb1c6ae1b41$export$23fa9a8c7e36c17)(options.whiskerColour, `black`);
    const dotColour = (0, $8a5cbeb1c6ae1b41$export$23fa9a8c7e36c17)(options.dotColour, options.whiskerColour, `black`);
    const labelColour = (0, $8a5cbeb1c6ae1b41$export$23fa9a8c7e36c17)(options.labelColour, options.axisColour, `silver`);
    const axisWidth = options.axisWidth ?? 1 * window.devicePixelRatio;
    const dotRadius = options.dotRadius ?? 5 * window.devicePixelRatio;
    const pad = options.padding ?? 10 * window.devicePixelRatio;
    const whiskerSize = options.whiskerSize ?? 5 * window.devicePixelRatio;
    const width = options.width ?? $4a5be75452a35244$var$getNumericAttribute(element, `width`, 200) * window.devicePixelRatio;
    const height = options.height ?? $4a5be75452a35244$var$getNumericAttribute(element, `height`, 200) * window.devicePixelRatio;
    let lastValues;
    if (displayLastValues > 0) lastValues = (0, $afa7d8c33fbcfc09$export$fc3a40dec7b33bf)({
        capacity: displayLastValues,
        discardPolicy: `older`
    });
    element.width = width;
    element.height = height;
    element.style.width = `${width / window.devicePixelRatio}px`;
    element.style.height = `${height / window.devicePixelRatio}px`;
    const midY = height / 2;
    const midX = width / 2;
    const ctx = element.getContext(`2d`);
    if (!ctx) throw new Error(`Could not create drawing context`);
    if (window.devicePixelRatio >= 2) ctx.font = `20px sans-serif`;
    const percentageFormat = (v)=>`${Math.round(v * 100)}%`;
    const fixedFormat = (v)=>v.toFixed(labelPrecision);
    const valueFormat = asPercentages ? percentageFormat : fixedFormat;
    if (showLabels) {
        labels[0] = labels[0] + `:`;
        labels[1] = labels[1] + `:`;
    } else {
        labels[0] = ``;
        labels[1] = ``;
    }
    const renderBackground = options.renderBackground ?? ((ctx2, width2, height2)=>{
        if (options.bgColour === `transparent`) ctx2.clearRect(0, 0, width2, height2);
        else {
            ctx2.fillStyle = bgColour;
            ctx2.fillRect(0, 0, width2, height2);
        }
    });
    return (x, y)=>{
        x = (0, $50567df4f0caddad$export$7d15b64cf5a3a4c4)(x);
        y = (0, $50567df4f0caddad$export$7d15b64cf5a3a4c4)(y);
        renderBackground(ctx, width, height);
        ctx.fillStyle = labelColour;
        ctx.textBaseline = `top`;
        ctx.save();
        ctx.translate(midX, midY);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText((labels[1] + ` ` + valueFormat(y)).trim(), -midX + pad, 1);
        ctx.restore();
        ctx.fillText((labels[0] + ` ` + valueFormat(x)).trim(), pad, midX + 2);
        if (!yAxisBottomNegative) y *= -1;
        ctx.strokeStyle = axisColour;
        ctx.lineWidth = axisWidth;
        ctx.beginPath();
        ctx.moveTo(pad, midY);
        ctx.lineTo(width - pad, midY);
        ctx.moveTo(midX, pad);
        ctx.lineTo(midX, height - pad);
        ctx.stroke();
        ctx.closePath();
        const yy = (height - pad - pad) / 2 * -y;
        const xx = (width - pad - pad) / 2 * x;
        const dotPos = {
            x: xx,
            y: yy,
            radius: dotRadius
        };
        if (lastValues) lastValues = lastValues.enqueue(dotPos);
        ctx.save();
        ctx.translate(midX, midY);
        if (showDot) {
            if (lastValues) {
                const opacityStep = 1 / lastValues.length;
                let opacity = 1;
                lastValues.forEach((d)=>{
                    const colour = (0, $8a5cbeb1c6ae1b41$export$876e3715299813be)(dotColour, opacity);
                    $4a5be75452a35244$var$circle(ctx, d, {
                        fillStyle: colour
                    });
                    opacity -= opacityStep;
                });
            } else $4a5be75452a35244$var$circle(ctx, dotPos, {
                fillStyle: dotColour
            });
        }
        if (showWhiskers) {
            ctx.strokeStyle = whiskerColour;
            ctx.beginPath();
            ctx.moveTo(0, yy - whiskerSize);
            ctx.lineTo(0, yy + whiskerSize);
            ctx.moveTo(xx - whiskerSize, 0);
            ctx.lineTo(xx + whiskerSize, 0);
            ctx.stroke();
            ctx.closePath();
        }
        ctx.restore();
    };
};
// src/visual/plot/index.ts
var $4a5be75452a35244$export$894a0606fb744189 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($4a5be75452a35244$export$894a0606fb744189, {
    CartesianCanvasPlot: ()=>$4a5be75452a35244$export$5e51109b6a1938ff,
    DataSet: ()=>$4a5be75452a35244$var$DataSet,
    absoluteCompute: ()=>$4a5be75452a35244$var$absoluteCompute,
    computeAxisMark: ()=>$4a5be75452a35244$var$computeAxisMark,
    computeMinMax: ()=>$4a5be75452a35244$var$computeMinMax,
    insert: ()=>$4a5be75452a35244$export$21a5ca8aa77d35ff,
    relativeCompute: ()=>$4a5be75452a35244$var$relativeCompute
});
// src/visual/plot/Cartesian.ts
var $4a5be75452a35244$var$computeMinMax = (mm)=>{
    const x = mm.map((m)=>m.x);
    const y = mm.map((m)=>m.y);
    const minX = Math.min(...x);
    const maxX = Math.max(...x);
    const minY = Math.min(...y);
    const maxY = Math.max(...y);
    const width = maxX - minX;
    const height = maxY - minY;
    return {
        min: {
            x: minX,
            y: minY
        },
        max: {
            x: maxX,
            y: maxY
        },
        width: width,
        height: height,
        minDim: Math.min(width, height),
        maxDim: Math.max(width, height)
    };
};
var $4a5be75452a35244$var$relativeCompute = (minMax)=>{
    if (!Number.isFinite(minMax.height)) return (point)=>point;
    const xScale = (0, $8a5cbeb1c6ae1b41$export$392c70347f2a027f)(minMax.min.x, minMax.max.x);
    const yScale = (0, $8a5cbeb1c6ae1b41$export$392c70347f2a027f)(minMax.min.y, minMax.max.y);
    return (point)=>({
            x: xScale(point.x),
            y: yScale(point.y)
        });
};
var $4a5be75452a35244$var$absoluteCompute = (minMax)=>{
    const xScale = (0, $8a5cbeb1c6ae1b41$export$392c70347f2a027f)(0, 1, minMax.min.x, minMax.max.x);
    const yScale = (0, $8a5cbeb1c6ae1b41$export$392c70347f2a027f)(0, 1, minMax.min.y, minMax.max.y);
    return (point)=>({
            x: xScale(point.x),
            y: yScale(point.y)
        });
};
var $4a5be75452a35244$var$computeAxisMark = (mm, increments, major)=>{
    const xValues = [];
    let count = 0;
    for(let x = mm.min.x; x < mm.max.x; x += increments){
        const isMajor = count % major === 0;
        xValues.push({
            x: x,
            y: 0,
            major: isMajor
        });
        count++;
    }
    count = 0;
    const yValues = [];
    for(let y = mm.min.y; y < mm.max.y; y += increments){
        const isMajor = count % major === 0;
        yValues.push({
            x: 0,
            y: y,
            major: isMajor
        });
        count++;
    }
    return {
        x: xValues,
        y: yValues
    };
};
// src/visual/plot/DataSet.ts
var $4a5be75452a35244$var$DataSet = class {
    #data;
    #meta;
    constructor(){
        this.lastChange = performance.now();
        this.#data = new (0, $96f72d8c52c10ae7$export$518c283e08c68164)();
        this.#meta = /* @__PURE__ */ new Map();
    }
    get metaCount() {
        return this.#meta.size;
    }
    clear() {
        this.#data.clear();
        this.lastChange = performance.now();
    }
    set(series, data) {
        this.#data.setValues(series, data);
    }
    deleteBySeries(series) {
        const changed = this.#data.delete(series);
        if (changed) this.lastChange = performance.now();
        return changed;
    }
    setMeta(series, meta) {
        this.#meta.set(series, meta);
    }
    hasMeta(series) {
        return this.#meta.has(series);
    }
    getMeta(series) {
        return this.#meta.get(series);
    }
    *getValues() {
        yield* this.#data.valuesFlat();
    }
    *getEntries() {
        yield* this.#data.entries();
    }
    *getSeries() {
        yield* this.#data.values();
    }
    add(value, series = `default`) {
        this.#data.addKeyedValues(series, value);
        this.lastChange = performance.now();
    }
};
// src/dom/DomRx.ts
var $4a5be75452a35244$export$c9e4cf6f54a27e2b = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($4a5be75452a35244$export$c9e4cf6f54a27e2b, {
    resizeObservable: ()=>$4a5be75452a35244$var$resizeObservable,
    themeChange: ()=>$4a5be75452a35244$var$themeChange,
    windowResize: ()=>$4a5be75452a35244$var$windowResize
});
var $4a5be75452a35244$var$windowResize = (elapsed)=>(0, $2edc1eef02a7c199$export$2655e45458bc48f3).debounce({
        elapsed: elapsed ?? 100
    })((0, $2edc1eef02a7c199$export$db4e272a145fb195).event(window, `resize`, {
        innerWidth: 0,
        innerHeight: 0
    }));
var $4a5be75452a35244$var$themeChange = ()=>{
    const m = (0, $2edc1eef02a7c199$export$db4e272a145fb195).observable((stream)=>{
        const ro = new MutationObserver((entries)=>{
            stream.set(entries);
        });
        const opts = {
            attributeFilter: [
                `class`
            ],
            attributes: true
        };
        ro.observe(document.documentElement, opts);
        return ()=>{
            ro.disconnect();
        };
    });
    return m;
};
var $4a5be75452a35244$var$resizeObservable = (elem, interval)=>{
    if (elem === null) throw new Error(`elem parameter is null. Expected element to observe`);
    if (elem === void 0) throw new Error(`elem parameter is undefined. Expected element to observe`);
    const m = (0, $2edc1eef02a7c199$export$db4e272a145fb195).observable((stream)=>{
        const ro = new ResizeObserver((entries)=>{
            stream.set(entries);
        });
        ro.observe(elem);
        return ()=>{
            ro.unobserve(elem);
        };
    });
    return (0, $2edc1eef02a7c199$export$2655e45458bc48f3).debounce({
        elapsed: interval ?? 100
    })(m);
};
// src/dom/Css.ts
var $4a5be75452a35244$export$669a099a3b547e4c = (elOrQuery)=>{
    let el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elOrQuery);
    const size = el.getBoundingClientRect();
    if (el instanceof SVGElement) el = el.parentElement;
    const border = $4a5be75452a35244$export$4bb1175ba8ebc78e(el, `borderTopWidth`, `borderLeftWidth`, `borderRightWidth`, `borderBottomWidth`);
    return {
        x: size.x,
        y: size.y,
        width: size.width + border.borderLeftWidth + border.borderRightWidth,
        height: size.height + border.borderTopWidth + border.borderBottomWidth
    };
};
var $4a5be75452a35244$export$4bb1175ba8ebc78e = (elOrQuery, ...properties)=>{
    const s = getComputedStyle((0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elOrQuery));
    const returnValue = {};
    for (const property of properties){
        const v = s[property];
        if (typeof v === `string`) {
            if (v.endsWith(`px`)) returnValue[property] = Number.parseFloat(v.substring(0, v.length - 2));
            else throw new Error(`Property '${String(property)}' does not end in 'px'. Value: ${v}`);
        } else throw new Error(`Property '${String(property)}' is not type string. Got: ${typeof v} Value: ${v}`);
    }
    return returnValue;
};
var $4a5be75452a35244$export$1c335df6f02320a1 = (selectors, value, cssClass)=>{
    const elements = (0, $35a128b42d0e06cd$export$7c36a5fc73d4a4d3)(selectors);
    if (elements.length === 0) return;
    for (const element of elements)if (value) element.classList.add(cssClass);
    else element.classList.remove(cssClass);
};
var $4a5be75452a35244$export$322e3051a79d2f31 = (selectors, cssClass)=>{
    const elements = (0, $35a128b42d0e06cd$export$7c36a5fc73d4a4d3)(selectors);
    if (elements.length === 0) return;
    for (const element of elements)element.classList.toggle(cssClass);
};
var $4a5be75452a35244$export$62945816622b86ea = (selectors, value)=>{
    const elements = (0, $35a128b42d0e06cd$export$7c36a5fc73d4a4d3)(selectors);
    if (elements.length === 0) return;
    for (const element of elements)element.style.display = value;
};
// src/dom/ElementSizing.ts
var $4a5be75452a35244$export$6fdaa4e99cd13524 = class _ElementSizer {
    #stretch;
    #size;
    #naturalSize;
    #naturalRatio;
    #viewport;
    #onSetSize;
    #el;
    #containerEl;
    #disposed = false;
    #resizeObservable;
    constructor(elOrQuery, options){
        this.#el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elOrQuery);
        this.#containerEl = options.containerEl ? (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(options.containerEl) : this.#el.parentElement;
        this.#stretch = options.stretch ?? `none`;
        this.#onSetSize = options.onSetSize;
        this.#size = (0, $da7bbf79b162d05c$export$2744bceee07c71e5);
        let naturalSize = options.naturalSize;
        if (naturalSize === void 0) naturalSize = this.#el.getBoundingClientRect();
        this.#naturalRatio = 1;
        this.#naturalSize = naturalSize;
        this.setNaturalSize(naturalSize);
        this.#viewport = (0, $da7bbf79b162d05c$export$54af435d56f017ce);
        if (this.#containerEl === document.body) this.#byViewport();
        else this.#byContainer();
    }
    dispose(reason) {
        if (this.#disposed) return;
        this.#disposed = true;
        if (this.#resizeObservable) {
            this.#resizeObservable.dispose(`ElementSizing (${reason})`);
            this.#resizeObservable = void 0;
        }
    }
    static canvasParent(canvasElementOrQuery, options) {
        const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(canvasElementOrQuery);
        const er = new _ElementSizer(el, {
            ...options,
            onSetSize (size, el2) {
                el2.width = size.width;
                el2.height = size.height;
                if (options.onSetSize) options.onSetSize(size, el2);
            }
        });
        return er;
    }
    static canvasViewport(canvasElementOrQuery, options) {
        const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(canvasElementOrQuery);
        el.style.position = `absolute`;
        el.style.zIndex = (options.zIndex ?? 0).toString();
        el.style.left = `0px`;
        el.style.top = `0px`;
        const opts = {
            ...options,
            containerEl: document.body
        };
        return this.canvasParent(canvasElementOrQuery, opts);
    }
    static svgViewport(svg) {
        const er = new _ElementSizer(svg, {
            containerEl: document.body,
            stretch: `both`,
            onSetSize (size) {
                svg.setAttribute(`width`, size.width.toString());
                svg.setAttribute(`height`, size.height.toString());
            }
        });
        return er;
    }
    #byContainer() {
        const c = this.#containerEl;
        if (!c) throw new Error(`No container element`);
        const r = $4a5be75452a35244$var$resizeObservable(c);
        r.onValue((v)=>{
            this.#onParentResize(v);
        });
        const current = this.#computeSizeBasedOnParent(c.getBoundingClientRect());
        this.size = current;
        this.#resizeObservable = r;
    }
    #byViewport() {
        const r = $4a5be75452a35244$var$windowResize();
        r.onValue((v)=>{
            this.#onViewportResize();
        });
        this.#resizeObservable = r;
        this.#onViewportResize();
    }
    #onViewportResize() {
        this.size = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        this.#viewport = {
            x: 0,
            y: 0,
            ...this.size
        };
    }
    /**
   * Sets the 'natural' size of an element.
   * This can also be specified when creating ElementSizer.
   * @param size 
   */ setNaturalSize(size) {
        this.#naturalSize = size;
        this.#naturalRatio = size.width / size.height;
    }
    get naturalSize() {
        return this.#naturalSize;
    }
    get viewport() {
        return this.#viewport;
    }
    #computeSizeBasedOnParent(parentSize) {
        let { width: width, height: height } = parentSize;
        let stretch = this.#stretch;
        if (stretch === `min`) stretch = width < height ? `width` : `height`;
        else if (stretch === `max`) stretch = width > height ? `width` : `height`;
        if (stretch === `width`) height = width / this.#naturalRatio;
        else if (stretch === `height`) width = height * this.#naturalRatio;
        if (this.#el instanceof HTMLElement) {
            const b = $4a5be75452a35244$export$4bb1175ba8ebc78e(this.#el, `borderTopWidth`, `borderLeftWidth`, `borderRightWidth`, `borderBottomWidth`);
            width -= b.borderLeftWidth + b.borderRightWidth;
            height -= b.borderTopWidth + b.borderBottomWidth;
        }
        return {
            width: width,
            height: height
        };
    }
    #onParentResize(args) {
        const box = args[0].contentBoxSize[0];
        const parentSize = {
            width: box.inlineSize,
            height: box.blockSize
        };
        this.size = this.#computeSizeBasedOnParent(parentSize);
        this.#viewport = {
            x: 0,
            y: 0,
            width: parentSize.width,
            height: parentSize.height
        };
    }
    set size(size) {
        (0, $2edc1eef02a7c199$export$290a3749c7970426)(size, `size`);
        this.#size = size;
        this.#onSetSize(size, this.#el);
    }
    get size() {
        return this.#size;
    }
};
// src/visual/plot/CartesianCanvasPlot.ts
var $4a5be75452a35244$export$21a5ca8aa77d35ff = (insertOptions, options = {})=>{
    const parentEl = insertOptions.parent === void 0 ? document.body : (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(insertOptions.parent);
    const canvasEl = document.createElement(`canvas`);
    parentEl.prepend(canvasEl);
    const ds = new $4a5be75452a35244$var$DataSet();
    const source = new $4a5be75452a35244$export$ca65ccf5708c6a0c(canvasEl, `min`);
    const spec = insertOptions.region ?? {
        relativePositioned: {
            x: 0,
            y: 0,
            width: 1,
            height: 1
        }
    };
    const region = source.createRegion(spec);
    const p = new $4a5be75452a35244$export$5e51109b6a1938ff(region, ds, options);
    if (insertOptions.canvasResizeTo === `viewport`) $4a5be75452a35244$export$6fdaa4e99cd13524.canvasViewport(canvasEl, {
        onSetSize: (size, _el)=>{
            source.setLogicalSize(size);
            p.invalidateRange();
            p.draw();
        }
    });
    else $4a5be75452a35244$export$6fdaa4e99cd13524.canvasParent(canvasEl, {
        onSetSize: (size, _el)=>{
            source.setLogicalSize(size);
            p.invalidateRange();
            p.draw();
        }
    });
    return p;
};
var $4a5be75452a35244$export$5e51109b6a1938ff = class {
    constructor(cr, data, options = {}){
        this.actualDataRange = (0, $da7bbf79b162d05c$export$54af435d56f017ce);
        this.visibleRange = (0, $da7bbf79b162d05c$export$87dcead6234101be);
        this.axisRounder = (0, $42f472314cb088f7$export$2077e0241d6afd3c)(1, true);
        /**
     * List of lines to draw after drawing everything else.
     * Lines are given in value-coordinate space
     */ this.overlayLines = [];
        if (!data) throw new TypeError(`Param 'data' is undefined`);
        if (typeof data !== `object`) throw new TypeError(`Param 'data' is not an object. Got: ${typeof data}`);
        this.onInvalidated = options.onInvalidated;
        this.#data = data;
        this.#canvasRegion = cr;
        this.#lastDataChange = 0;
        this.#visualClear = options.clear ?? `region`;
        this.#rangeMode = options.range ?? `auto`;
        this.#valueStyle = options.valueStyle ?? `dot`;
        this.#connectStyle = options.connectStyle ?? ``;
        this.whiskerLength = options.whiskerLength ?? 5;
        this.#visualPadding = options.visualPadding ?? 20;
        this.show = {
            axes: true,
            axisValues: true,
            grid: true,
            whiskers: true,
            ...options.show
        };
        this.#axisStyle = {
            colour: `black`,
            width: 2,
            ...options.axisStyle
        };
        this.#textStyle = {
            colour: `black`,
            size: `1em`,
            font: `system-ui`,
            ...options.textStyle
        };
        this.#grid = {
            increments: 0.1,
            major: 5,
            colour: `whitesmoke`,
            width: 1,
            ...options.grid
        };
    }
    #data;
    #lastDataChange;
    #canvasRegion;
    #grid;
    #rangeMode;
    #currentRange;
    #axisStyle;
    #valueStyle;
    #connectStyle;
    #rangeManual;
    #textStyle;
    #visualPadding;
    #visualClear;
    getCurrentRange() {
        if (this.#data.lastChange === this.#lastDataChange && this.#currentRange) return this.#currentRange;
        this.#lastDataChange = this.#data.lastChange;
        const r = this.#createRange();
        this.#currentRange = r;
        if (this.onInvalidated) this.onInvalidated();
        return r;
    }
    invalidateRange() {
        this.#currentRange = void 0;
    }
    #createRange() {
        const range = this.getDataRange();
        const absDataToRelative = $4a5be75452a35244$var$relativeCompute(range);
        const relDataToAbs = $4a5be75452a35244$var$absoluteCompute(range);
        const cr = this.#canvasRegion;
        const padding = this.#visualPadding;
        let xOffset = cr.x + padding;
        let yOffset = cr.y + padding;
        const allowedHeight = cr.height - padding * 2;
        const allowedWidth = cr.width - padding * 2;
        const dimensionMin = Math.min(allowedHeight, allowedWidth);
        if (allowedWidth >= allowedHeight) xOffset += allowedWidth / 2 - dimensionMin / 2;
        else yOffset += allowedHeight / 2 - dimensionMin / 2;
        const relDataToCanvas = (pt)=>{
            let { x: x, y: y } = pt;
            if (x === Number.NEGATIVE_INFINITY) x = 0;
            else if (x === Number.POSITIVE_INFINITY) x = 1;
            if (y === Number.NEGATIVE_INFINITY) y = 0;
            else if (y === Number.POSITIVE_INFINITY) y = 1;
            x = x * dimensionMin;
            y = (1 - y) * dimensionMin;
            x += xOffset;
            y += yOffset;
            return {
                x: x,
                y: y
            };
        };
        const canvasToRelData = (pt)=>{
            let { x: x, y: y } = pt;
            x -= xOffset;
            y -= yOffset;
            x = x / dimensionMin;
            y = 1 - y / dimensionMin;
            return {
                x: x,
                y: y
            };
        };
        const regionSpaceToRelative = (pt)=>{
            let { x: x, y: y } = pt;
            x = x - cr.x + this.#visualPadding;
            y = dimensionMin + this.#visualPadding - y;
            x /= dimensionMin;
            y = y / dimensionMin;
            return {
                x: x,
                y: y
            };
        };
        return {
            absDataToRelative: absDataToRelative,
            relDataToCanvas: relDataToCanvas,
            canvasToRelData: canvasToRelData,
            regionSpaceToRelative: regionSpaceToRelative,
            relDataToAbs: relDataToAbs,
            range: range
        };
    }
    /**
   * Positions an element at the viewport location of `data` point.
   * Ensure the element has `position:absolute` set.
   * @param data 
   * @param elementToPosition 
   * @param by 
   */ positionElementAt(data, elementToPosition, by = `middle`, relativeToQuery) {
        const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elementToPosition);
        let { x: x, y: y } = this.valueToScreenSpace(data);
        if (by === `middle`) {
            const bounds = el.getBoundingClientRect();
            x -= bounds.width / 2;
            y -= bounds.height / 2;
        } else if (by === `top-left`) ;
        else throw new Error(`Param 'by' expected to be 'middle' or 'top-left'.`);
        if (relativeToQuery) {
            const relativeTo = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(relativeToQuery);
            const bounds = relativeTo.getBoundingClientRect();
            x -= bounds.x;
            y -= bounds.y;
        }
        el.style.left = `${x}px`;
        el.style.top = `${y}px`;
    }
    /**
   * When range is auto, returns the range of the data
   * Otherwise returns the user-provided range.
   * @returns 
   */ getDataRange() {
        if (this.#rangeMode === `auto`) return $4a5be75452a35244$var$computeMinMax([
            ...this.#data.getValues()
        ]);
        else {
            if (!this.#rangeManual) this.#rangeManual = $4a5be75452a35244$var$computeMinMax([
                this.#rangeMode.max,
                this.#rangeMode.min
            ]);
            return this.#rangeManual;
        }
    }
    valueToScreenSpace(dataPoint) {
        const region = this.valueToRegionSpace(dataPoint);
        const offset = this.canvasSource.offset;
        const scr = {
            x: region.x + offset.x,
            y: region.y + offset.y
        };
        return scr;
    }
    valueToRegionSpace(dataValue, debug = false) {
        const ds = this.getCurrentRange();
        const rel = ds.absDataToRelative(dataValue);
        const region = ds.relDataToCanvas(rel);
        if (debug) console.log(`orig: ${dataValue.x}x${dataValue.y} rel: ${rel.x}x${rel.y} region: ${region.x}x${region.y}`);
        return {
            ...dataValue,
            x: region.x,
            y: region.y
        };
    }
    // #regionSpaceToValue(scr: Point, clamped: boolean) {
    //   const ds = this.getCurrentRange();
    //   const rel = ds.regionSpaceToRelative(scr);
    //   //console.log(`regionSpaceToRelative ${ rel.x.toFixed(2) },${ rel.y.toFixed(2) }`);
    //   const value = ds.relDataToAbs(rel);
    //   //if (debug) console.log(`orig: ${ a.x }x${ a.y } rel: ${ rel.x }x${ rel.y } scr: ${ scr.x }x${ scr.y }`);
    //   const pt = {
    //     ...scr,
    //     x: value.x,
    //     y: value.y
    //   }
    //   if (clamped) return clamp(pt);
    //   return pt;
    // }
    /**
   * Converts a point in pixel coordinates to a value.
   * Useful for converting from user input coordinates.
   * @param point 
   * @returns 
   */ pointToValue(point, _source) {
        const ds = this.getCurrentRange();
        const canvasPoint = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).subtract(point, this.canvasSource.offset);
        const v = ds.canvasToRelData(canvasPoint);
        return ds.relDataToAbs(v);
    }
    // valueToScreen(a: Point) {
    //   const ds = this.getCurrentRange();
    //   const rel = ds.valueToRelative(a);
    //   const scr = ds.relativeToElementSpace(rel);
    //   const bounds = this.helper.el.getBoundingClientRect();
    //   return {
    //     x: scr.x + bounds.x,
    //     y: scr.y + bounds.y
    //   }
    // }
    // valueRectToScreen(a: Point, b: Point): RectPositioned {
    //   a = this.valueToScreen(a);
    //   b = this.valueToScreen(b);
    //   return {
    //     x: a.x,
    //     y: b.y,
    //     width: b.x - a.x,
    //     height: a.y - b.y
    //   }
    // }
    /**
   * Compute canvas-relative coordinates based on two points in value space
   * @param valueA 
   * @param valueB 
   */ #valueLineToCanvasSpace(valueA, valueB, debug = false) {
        valueA = this.valueToRegionSpace(valueA, debug);
        valueB = this.valueToRegionSpace(valueB, debug);
        return {
            a: valueA,
            b: valueB
        };
    }
    getDefaultMeta() {
        return {
            colour: (0, $8a5cbeb1c6ae1b41$export$da5c41284313e6e3).goldenAngleColour(this.#data.metaCount),
            lineWidth: 2,
            dotRadius: 5
        };
    }
    draw() {
        if (this.#visualClear === `region`) this.#canvasRegion.clear();
        else this.canvasSource.clear();
        this.#useGrid();
        if (this.show.axes) this.#drawAxes();
        for (const [k, v] of this.#data.getEntries()){
            let meta = this.#data.getMeta(k);
            if (!meta) {
                meta = this.getDefaultMeta();
                this.#data.setMeta(k, meta);
            }
            this.#drawSeries(k, v, meta);
        }
        for (const line2 of this.overlayLines)this.drawLine(line2, line2.colour, line2.width);
    }
    /**
   * Draws a line in value-coordinate space
   * @param line 
   * @param colour 
   * @param width 
   */ drawLine(line2, colour, width) {
        const l = this.#valueLineToCanvasSpace(line2.a, line2.b);
        this.#drawLineCanvasSpace(l, colour, width);
    }
    setMeta(series, meta) {
        this.#data.setMeta(series, {
            ...this.getDefaultMeta(),
            ...meta
        });
    }
    #drawAxes() {
        const { colour: colour, width: width } = this.#axisStyle;
        const yAxis = this.#valueLineToCanvasSpace({
            x: 0,
            y: Number.NEGATIVE_INFINITY
        }, {
            x: 0,
            y: Number.POSITIVE_INFINITY
        }, false);
        const xAxis = this.#valueLineToCanvasSpace({
            x: Number.NEGATIVE_INFINITY,
            y: 0
        }, {
            x: Number.POSITIVE_INFINITY,
            y: 0
        }, false);
        this.#drawLineCanvasSpace(xAxis, colour, width, false);
        this.#drawLineCanvasSpace(yAxis, colour, width, false);
    }
    #drawYAxisValues(yPoints) {
        const ctx = this.#canvasRegion.context;
        ctx.font = this.#textStyle.size + ` ` + this.#textStyle.font;
        ctx.fillStyle = this.#textStyle.colour;
        ctx.textBaseline = `middle`;
        for (const p of yPoints){
            if (p.x === 0 && p.y === 0) continue;
            const reg = this.valueToRegionSpace(p, false);
            const value = this.axisRounder(p.y);
            const label = value.toString();
            const measure = ctx.measureText(label);
            const x = reg.x - measure.width - this.whiskerLength / 2 - 5;
            const y = reg.y;
            ctx.fillText(label, x, y);
        }
    }
    #drawXAxisValues(xPoints) {
        const ctx = this.#canvasRegion.context;
        ctx.font = this.#textStyle.size + ` ` + this.#textStyle.font;
        ctx.fillStyle = this.#textStyle.colour;
        ctx.textBaseline = `top`;
        for (const p of xPoints){
            const reg = this.valueToRegionSpace(p, false);
            const value = this.axisRounder(p.x);
            const label = value.toString();
            const measure = ctx.measureText(label);
            const x = reg.x - measure.width / 2;
            const y = reg.y + measure.actualBoundingBoxAscent + measure.actualBoundingBoxDescent + this.whiskerLength / 2;
            ctx.fillText(label, x, y);
        }
    }
    #drawWhisker(p, vertical) {
        const whiskerHalfLength = this.whiskerLength / 2;
        const v = vertical ? {
            x: p.x,
            y: 0
        } : {
            y: p.y,
            x: 0
        };
        const reg = this.valueToRegionSpace(v, false);
        const line2 = vertical ? {
            a: {
                x: reg.x,
                y: reg.y - whiskerHalfLength
            },
            b: {
                x: reg.x,
                y: reg.y + whiskerHalfLength
            }
        } : {
            a: {
                y: reg.y,
                x: reg.x - whiskerHalfLength
            },
            b: {
                y: reg.y,
                x: reg.x + whiskerHalfLength
            }
        };
        this.#drawLineCanvasSpace(line2, this.#axisStyle.colour, this.#axisStyle.width, false);
    }
    #drawGridline(p, vertical) {
        const line2 = vertical ? this.#valueLineToCanvasSpace({
            x: p.x,
            y: Number.NEGATIVE_INFINITY
        }, {
            x: p.x,
            y: Number.POSITIVE_INFINITY
        }) : this.#valueLineToCanvasSpace({
            y: p.y,
            x: Number.NEGATIVE_INFINITY
        }, {
            y: p.y,
            x: Number.POSITIVE_INFINITY
        }, false);
        this.#drawLineCanvasSpace(line2, this.#grid.colour, p.major ? this.#grid.width * 2 : this.#grid.width);
    }
    #useGrid() {
        const g = this.#grid;
        const showGrid = this.show.grid;
        const showWhiskers = this.show.whiskers;
        const showValues = this.show.axisValues;
        const mm = this.getCurrentRange().range;
        const { increments: increments, major: major } = g;
        const axisMarks = $4a5be75452a35244$var$computeAxisMark(mm, increments, major);
        for (const p of axisMarks.x){
            if (showGrid) this.#drawGridline(p, true);
            if (showWhiskers && p.major) this.#drawWhisker(p, true);
        }
        for (const p of axisMarks.y){
            if (showGrid) this.#drawGridline(p, false);
            if (showWhiskers && p.major) this.#drawWhisker(p, false);
        }
        if (showValues) {
            this.#drawXAxisValues(axisMarks.x.filter((p)=>p.major));
            this.#drawYAxisValues(axisMarks.y.filter((p)=>p.major));
        }
    }
    #drawSeries(name, series, meta) {
        if (this.#connectStyle === `line`) this.#drawConnected(series, meta.colour, meta.lineWidth);
        if (this.#valueStyle === `dot`) for (const v of series)this.#drawDot(v, meta.colour, meta.dotRadius);
    }
    #drawConnected(dots, colour, width) {
        const ctx = this.#canvasRegion.context;
        ctx.beginPath();
        for (const [index, dot_] of dots.entries()){
            const dot2 = this.valueToRegionSpace(dot_, false);
            if (index === 0) ctx.moveTo(dot2.x, dot2.y);
            ctx.lineTo(dot2.x, dot2.y);
        }
        ctx.strokeStyle = (0, $8a5cbeb1c6ae1b41$export$da5c41284313e6e3).resolveToString(colour);
        ctx.lineWidth = width;
        ctx.stroke();
        ctx.closePath();
    }
    #drawDot(originalDot, fallbackColour, fallbackRadius) {
        const colour = (0, $8a5cbeb1c6ae1b41$export$da5c41284313e6e3).resolveToString(originalDot.fillStyle ?? fallbackColour);
        const pos = this.valueToRegionSpace(originalDot);
        const radius = originalDot.radius ?? fallbackRadius;
        this.#canvasRegion.drawCircles([
            {
                ...pos,
                radius: radius
            }
        ], colour);
    }
    #drawLineCanvasSpace(line2, colour, width, debug = false) {
        if (debug) console.log(line2);
        const ctx = this.#canvasRegion.context;
        colour = (0, $8a5cbeb1c6ae1b41$export$da5c41284313e6e3).resolveToString(colour);
        ctx.beginPath();
        ctx.moveTo(line2.a.x, line2.a.y);
        ctx.lineTo(line2.b.x, line2.b.y);
        ctx.strokeStyle = (0, $8a5cbeb1c6ae1b41$export$da5c41284313e6e3).resolveToString(colour);
        ctx.lineWidth = width;
        ctx.stroke();
        ctx.closePath();
    }
    get dataSet() {
        return this.#data;
    }
    get canvasRegion() {
        return this.#canvasRegion;
    }
    get canvasSource() {
        return this.#canvasRegion.source;
    }
};
// src/visual/index.ts
try {
    if (typeof window !== `undefined`) window.ixfx = {
        ...window.ixfx,
        Visuals: {
            SceneGraph: $4a5be75452a35244$export$ac4e447d9c145a7a,
            Drawing: $4a5be75452a35244$export$f60f7d0f1cfead51,
            Svg: (0, $3818f2662e2a019f$export$e364262fc575d875),
            Palette: $4a5be75452a35244$export$509ba9b84018dca9,
            Colour: (0, $8a5cbeb1c6ae1b41$export$da5c41284313e6e3),
            Video: (0, $1babec5e26cea186$export$6b456564506e67b3)
        }
    };
} catch  {}

















































const $1bed8721d717cfc5$var$settings = {
    el: document.querySelector(`#notify`)
};
function $1bed8721d717cfc5$export$57bf213be019eeb0(msg, autoRemove = false) {
    const { el: el } = $1bed8721d717cfc5$var$settings;
    el.classList.remove(`faded`);
    el.innerText = msg;
    if (autoRemove) setTimeout(()=>{
        if (el.innerText === msg) $1bed8721d717cfc5$export$fe8985bb6374093c();
    }, 5000);
}
function $1bed8721d717cfc5$export$fe8985bb6374093c() {
    const { el: el } = $1bed8721d717cfc5$var$settings;
    el.classList.add(`faded`);
}
function $1bed8721d717cfc5$export$e03c1c3201ee8bb7() {
    const { el: el } = $1bed8721d717cfc5$var$settings;
    el.classList.toggle(`faded`);
}
function $1bed8721d717cfc5$export$2cd8252107eb640b() {
    const { el: el } = $1bed8721d717cfc5$var$settings;
    el.addEventListener(`click`, $1bed8721d717cfc5$export$e03c1c3201ee8bb7);
    $1bed8721d717cfc5$export$fe8985bb6374093c();
}


const $54bc816a2f88fb52$var$settings = {
    btnLocate: document.querySelector(`#btnLocate`),
    btnVisit: document.querySelector(`#btnVisit`)
};
const $54bc816a2f88fb52$export$4bf9923669ad6c63 = new EventTarget();
const $54bc816a2f88fb52$export$8c09b2ec1ffe6005 = ()=>{
    const { btnLocate: btnLocate } = $54bc816a2f88fb52$var$settings;
    btnLocate.classList.remove(`hidden`); // show visit
};
const $54bc816a2f88fb52$export$e2531eaf53f82041 = ()=>{
    const { btnVisit: btnVisit } = $54bc816a2f88fb52$var$settings;
    btnVisit.classList.remove(`hidden`); // show visit
};
function $54bc816a2f88fb52$var$locateProbe() {
    const { btnLocate: btnLocate, btnVisit: btnVisit } = $54bc816a2f88fb52$var$settings;
    try {
        //throw new Error(`locateProbe`);
        navigator.permissions.query({
            name: `geolocation`
        }).then((result)=>{
            if (result.state === `granted`) {
                btnVisit.classList.remove(`hidden`); // show visit
                $54bc816a2f88fb52$var$locate();
            } else if (result.state === `prompt`) {
                $54bc816a2f88fb52$export$e2531eaf53f82041();
                $54bc816a2f88fb52$export$8c09b2ec1ffe6005();
                $54bc816a2f88fb52$export$4bf9923669ad6c63.dispatchEvent(new CustomEvent(`not-located`, {
                    detail: {}
                }));
            }
        });
    } catch (error) {
        $54bc816a2f88fb52$export$4bf9923669ad6c63.dispatchEvent(new CustomEvent(`not-located`, {
            detail: {}
        }));
        $54bc816a2f88fb52$export$e2531eaf53f82041();
        $54bc816a2f88fb52$export$8c09b2ec1ffe6005();
    }
}
function $54bc816a2f88fb52$var$locate() {
    const { btnLocate: btnLocate } = $54bc816a2f88fb52$var$settings;
    navigator.geolocation.getCurrentPosition((pos)=>{
        $1bed8721d717cfc5$export$57bf213be019eeb0(`Located!`, true);
        btnLocate.classList.add(`hidden`); // hide Locate
        $54bc816a2f88fb52$export$4bf9923669ad6c63.dispatchEvent(new CustomEvent(`located`, {
            detail: pos.coords
        }));
    }, (error)=>{
        $1bed8721d717cfc5$export$57bf213be019eeb0(error.message);
    }, {
        enableHighAccuracy: false,
        maximumAge: 60000
    });
}
function $54bc816a2f88fb52$export$2cd8252107eb640b() {
    const { btnLocate: btnLocate } = $54bc816a2f88fb52$var$settings;
    btnLocate.addEventListener(`click`, $54bc816a2f88fb52$var$locate);
    setTimeout(()=>$54bc816a2f88fb52$var$locateProbe(), 500);
}



const $7fe30c12d2da30ad$export$dccfe90fd0dcf5cf = [
    {
        latitude: 55.6759,
        longitude: 12.5655,
        title: `\u{1F1E9}\u{1F1F0} Copenhagen, Denmark`
    },
    {
        latitude: -27.470125,
        longitude: 153.021072,
        title: `\u{1F428} Brisbane, Australia`
    },
    {
        latitude: 55.47028,
        longitude: 8.45187,
        title: `\u{1F30A} Esbjerg, Denmark`
    },
    {
        latitude: 50.450001,
        longitude: 30.523333,
        title: `\u{270A}\u{1F3FD} Kyiv, Ukraine`
    },
    // --- chat gpt generated below
    {
        "title": "\uD83C\uDDE6\uD83C\uDDF7 Buenos Aires, Argentina",
        "longitude": -58.4438,
        "latitude": -34.6037
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDF7 Bras\xedlia, Brazil",
        "longitude": -47.9292,
        "latitude": -15.7801
    },
    {
        "title": "\uD83C\uDDE8\uD83C\uDDF1 Santiago, Chile",
        "longitude": -70.6483,
        "latitude": -33.4489
    },
    {
        "title": "\uD83C\uDDE8\uD83C\uDDF4 Bogot\xe1, Colombia",
        "longitude": -74.0721,
        "latitude": 4.7110
    },
    {
        "title": "\uD83C\uDDFB\uD83C\uDDEA Caracas, Venezuela",
        "longitude": -66.9036,
        "latitude": 10.4806
    },
    {
        "title": "\uD83C\uDDF5\uD83C\uDDEA Lima, Peru",
        "longitude": -77.0428,
        "latitude": -12.0464
    },
    {
        "title": "\uD83C\uDDE8\uD83C\uDDFE Asunci\xf3n, Paraguay",
        "longitude": -57.5759,
        "latitude": -25.2637
    },
    {
        "title": "\uD83C\uDDFA\uD83C\uDDFE Montevideo, Uruguay",
        "longitude": -56.1913,
        "latitude": -34.9011
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDF4 Sucre, Bolivia",
        "longitude": -65.2627,
        "latitude": -19.0333
    },
    {
        "title": "\uD83C\uDDEC\uD83C\uDDFE Georgetown, Guyana",
        "longitude": -58.1552,
        "latitude": 6.8013
    },
    {
        "title": "\uD83C\uDDF8\uD83C\uDDF7 Paramaribo, Suriname",
        "longitude": -55.2038,
        "latitude": 5.8663
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDF7 Salvador, Brazil",
        "longitude": -38.5013,
        "latitude": -12.9714
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDF7 Porto Alegre, Brazil",
        "longitude": -51.23,
        "latitude": -30.0331
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDF7 Fortaleza, Brazil",
        "longitude": -38.5226,
        "latitude": -3.7172
    },
    {
        "title": "\uD83C\uDDEA\uD83C\uDDE8 Quito, Ecuador",
        "longitude": -78.4678,
        "latitude": -0.1807
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDF7 Rio de Janeiro, Brazil",
        "longitude": -43.1729,
        "latitude": -22.9068
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDF7 Manaus, Brazil",
        "longitude": -60.65,
        "latitude": -3.119
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDFE La Paz, Bolivia",
        "longitude": -68.1193,
        "latitude": -16.5
    },
    {
        "title": "\uD83C\uDDE6\uD83C\uDDFA Canberra, Australia",
        "longitude": 149.1300,
        "latitude": -35.2809
    },
    {
        "title": "\uD83C\uDDEB\uD83C\uDDEF Suva, Fiji",
        "longitude": 178.0650,
        "latitude": -17.7134
    },
    {
        "title": "\uD83C\uDDF5\uD83C\uDDEC Port Moresby, Papua New Guinea",
        "longitude": 147.1803,
        "latitude": -9.4438
    },
    {
        "title": "\uD83C\uDDF3\uD83C\uDDFF Wellington, New Zealand",
        "longitude": 174.7762,
        "latitude": -41.2867
    },
    {
        "title": "\uD83C\uDDFC\uD83C\uDDF8 Apia, Samoa",
        "longitude": -172.1046,
        "latitude": -13.8333
    },
    {
        "title": "\uD83C\uDDFB\uD83C\uDDFA Port Vila, Vanuatu",
        "longitude": 168.3193,
        "latitude": -17.7333
    },
    {
        "title": "\uD83C\uDDF8\uD83C\uDDE7 Honiara, Solomon Islands",
        "longitude": 159.9500,
        "latitude": -9.4333
    },
    {
        "title": "\uD83C\uDDF5\uD83C\uDDFC Ngerulmud, Palau",
        "longitude": 134.6230,
        "latitude": 7.3667
    },
    {
        "title": "\uD83C\uDDF9\uD83C\uDDFB Funafuti, Tuvalu",
        "longitude": 179.1941,
        "latitude": -7.484
    },
    {
        "title": "\uD83C\uDDF2\uD83C\uDDED Majuro, Marshall Islands",
        "longitude": 171.3800,
        "latitude": 7.1000
    },
    {
        "title": "\uD83C\uDDF3\uD83C\uDDF7 Yaren, Nauru",
        "longitude": 166.9280,
        "latitude": -0.5477
    },
    {
        "title": "\uD83C\uDDF0\uD83C\uDDEE Tarawa, Kiribati",
        "longitude": 173.0000,
        "latitude": 1.3300
    },
    {
        "title": "\uD83C\uDDF9\uD83C\uDDF4 Nuku\u02BBalofa, Tonga",
        "longitude": -175.2,
        "latitude": -21.1394
    },
    {
        "title": "\uD83C\uDDEB\uD83C\uDDF7 Noum\xe9a, New Caledonia",
        "longitude": 166.4485,
        "latitude": -22.2763
    },
    {
        "title": "\uD83C\uDDE8\uD83C\uDDF0 Avarua, Cook Islands",
        "longitude": -159.7778,
        "latitude": -21.2072
    },
    {
        "title": "\uD83C\uDDF3\uD83C\uDDFA Funafuti, Tuvalu",
        "longitude": 179.1941,
        "latitude": -7.484
    },
    {
        "title": "\uD83C\uDDF5\uD83C\uDDEC Madang, Papua New Guinea",
        "longitude": 145.7895,
        "latitude": -5.2075
    },
    {
        "title": "\uD83C\uDDE6\uD83C\uDDFA Adelaide, Australia",
        "longitude": 138.6000,
        "latitude": -34.9285
    },
    {
        "title": "\uD83C\uDDFC\uD83C\uDDF8 Apia, Samoa",
        "longitude": -172.1046,
        "latitude": -13.8333
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDF3 New Delhi, India",
        "longitude": 77.2090,
        "latitude": 28.6139
    },
    {
        "title": "\uD83C\uDDE8\uD83C\uDDF3 Beijing, China",
        "longitude": 116.4074,
        "latitude": 39.9042
    },
    {
        "title": "\uD83C\uDDEF\uD83C\uDDF5 Tokyo, Japan",
        "longitude": 139.6917,
        "latitude": 35.6895
    },
    {
        "title": "\uD83C\uDDF0\uD83C\uDDF7 Seoul, South Korea",
        "longitude": 126.9780,
        "latitude": 37.5665
    },
    {
        "title": "\uD83C\uDDF9\uD83C\uDDF7 Ankara, Turkey",
        "longitude": 32.8597,
        "latitude": 39.9334
    },
    {
        "title": "\uD83C\uDDF9\uD83C\uDDED Bangkok, Thailand",
        "longitude": 100.5167,
        "latitude": 13.7563
    },
    {
        "title": "\uD83C\uDDE6\uD83C\uDDFA Yerevan, Armenia",
        "longitude": 40.1792,
        "latitude": 44.4991
    },
    {
        "title": "\uD83C\uDDF1\uD83C\uDDF8 Vientiane, Laos",
        "longitude": 102.6369,
        "latitude": 17.9757
    },
    {
        "title": "\uD83C\uDDFB\uD83C\uDDF3 Hanoi, Vietnam",
        "longitude": 105.8542,
        "latitude": 21.0285
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDE9 Jakarta, Indonesia",
        "longitude": 106.8650,
        "latitude": -6.1751
    },
    {
        "title": "\uD83C\uDDF9\uD83C\uDDEF Dushanbe, Tajikistan",
        "longitude": 68.7782,
        "latitude": 38.5598
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDF4 Kathmandu, Nepal",
        "longitude": 85.3240,
        "latitude": 27.7172
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDED Manama, Bahrain",
        "longitude": 50.5860,
        "latitude": 26.2235
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDF1 Jerusalem, Israel",
        "longitude": 35.2137,
        "latitude": 31.7683
    },
    {
        "title": "\uD83C\uDDF8\uD83C\uDDFE Damascus, Syria",
        "longitude": 36.3060,
        "latitude": 33.5138
    },
    {
        "title": "\uD83C\uDDEA\uD83C\uDDEC Cairo, Egypt",
        "longitude": 31.2357,
        "latitude": 30.0444
    },
    {
        "title": "\uD83C\uDDF2\uD83C\uDDFE Kuala Lumpur, Malaysia",
        "longitude": 101.6869,
        "latitude": 3.1390
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDF7 Tehran, Iran",
        "longitude": 51.3890,
        "latitude": 35.6892
    },
    {
        "title": "\uD83C\uDDF5\uD83C\uDDF0 Islamabad, Pakistan",
        "longitude": 73.0479,
        "latitude": 33.6844
    },
    {
        "title": "\uD83C\uDDF0\uD83C\uDDFC Kuwait City, Kuwait",
        "longitude": 47.9774,
        "latitude": 29.3759
    },
    {
        "title": "\uD83C\uDDEC\uD83C\uDDE7 London, United Kingdom",
        "longitude": -0.1276,
        "latitude": 51.5074
    },
    {
        "title": "\uD83C\uDDE9\uD83C\uDDEA Berlin, Germany",
        "longitude": 13.4050,
        "latitude": 52.5200
    },
    {
        "title": "\uD83C\uDDEB\uD83C\uDDF7 Paris, France",
        "longitude": 2.3522,
        "latitude": 48.8566
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDF9 Rome, Italy",
        "longitude": 12.4964,
        "latitude": 41.9028
    },
    {
        "title": "\uD83C\uDDEA\uD83C\uDDF8 Madrid, Spain",
        "longitude": -3.7038,
        "latitude": 40.4168
    },
    {
        "title": "\uD83C\uDDF3\uD83C\uDDF1 Amsterdam, Netherlands",
        "longitude": 4.9041,
        "latitude": 52.3676
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDEA Brussels, Belgium",
        "longitude": 4.3499,
        "latitude": 50.8503
    },
    {
        "title": "\uD83C\uDDF8\uD83C\uDDEA Stockholm, Sweden",
        "longitude": 18.0686,
        "latitude": 59.3293
    },
    {
        "title": "\uD83C\uDDF5\uD83C\uDDF9 Lisbon, Portugal",
        "longitude": -9.1395,
        "latitude": 38.7223
    },
    {
        "title": "\uD83C\uDDF3\uD83C\uDDF4 Oslo, Norway",
        "longitude": 10.7522,
        "latitude": 59.9139
    },
    {
        "title": "\uD83C\uDDEC\uD83C\uDDF7 Athens, Greece",
        "longitude": 23.7275,
        "latitude": 37.9838
    },
    {
        "title": "\uD83C\uDDE8\uD83C\uDDED Bern, Switzerland",
        "longitude": 7.4474,
        "latitude": 46.9481
    },
    {
        "title": "\uD83C\uDDF7\uD83C\uDDF4 Bucharest, Romania",
        "longitude": 26.1025,
        "latitude": 44.4268
    },
    {
        "title": "\uD83C\uDDF7\uD83C\uDDF8 Belgrade, Serbia",
        "longitude": 20.4633,
        "latitude": 44.8176
    },
    {
        "title": "\uD83C\uDDE7\uD83C\uDDEC Sofia, Bulgaria",
        "longitude": 23.3219,
        "latitude": 42.6977
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDF8 Reykjavik, Iceland",
        "longitude": -21.8954,
        "latitude": 64.1355
    },
    {
        "title": "\uD83C\uDDE6\uD83C\uDDF9 Vienna, Austria",
        "longitude": 16.3730,
        "latitude": 48.2082
    },
    {
        "title": "\uD83C\uDDF5\uD83C\uDDF1 Warsaw, Poland",
        "longitude": 21.0122,
        "latitude": 52.2298
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDEA Dublin, Ireland",
        "longitude": -6.2603,
        "latitude": 53.3498
    },
    {
        "title": "\uD83C\uDDF1\uD83C\uDDF9 Vilnius, Lithuania",
        "longitude": 25.2798,
        "latitude": 54.6892
    },
    {
        "title": "\uD83C\uDDEA\uD83C\uDDEC Cairo, Egypt",
        "longitude": 31.2357,
        "latitude": 30.0444
    },
    {
        "title": "\uD83C\uDDFF\uD83C\uDDE6 Pretoria, South Africa",
        "longitude": 28.2293,
        "latitude": -25.746
    },
    {
        "title": "\uD83C\uDDF3\uD83C\uDDEC Abuja, Nigeria",
        "longitude": 7.4951,
        "latitude": 9.0579
    },
    {
        "title": "\uD83C\uDDF0\uD83C\uDDEA Nairobi, Kenya",
        "longitude": 36.8219,
        "latitude": -1.2921
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDE9 Addis Ababa, Ethiopia",
        "longitude": 38.7578,
        "latitude": 9.0316
    },
    {
        "title": "\uD83C\uDDF2\uD83C\uDDF7 Nouakchott, Mauritania",
        "longitude": -15.978,
        "latitude": 18.0797
    },
    {
        "title": "\uD83C\uDDFF\uD83C\uDDF2 Lusaka, Zambia",
        "longitude": 28.2871,
        "latitude": -15.3875
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDF6 Tunis, Tunisia",
        "longitude": 10.1585,
        "latitude": 36.8065
    },
    {
        "title": "\uD83C\uDDF2\uD83C\uDDFF Maputo, Mozambique",
        "longitude": 32.6080,
        "latitude": -25.9655
    },
    {
        "title": "\uD83C\uDDF2\uD83C\uDDF7 Nouakchott, Mauritania",
        "longitude": -15.978,
        "latitude": 18.0797
    },
    {
        "title": "\uD83C\uDDF3\uD83C\uDDEE Accra, Ghana",
        "longitude": -0.205,
        "latitude": 5.6037
    },
    {
        "title": "\uD83C\uDDE9\uD83C\uDDFF Algiers, Algeria",
        "longitude": 3.0588,
        "latitude": 36.7538
    },
    {
        "title": "\uD83C\uDDF0\uD83C\uDDF2 Moroni, Comoros",
        "longitude": 43.2577,
        "latitude": -11.702
    },
    {
        "title": "\uD83C\uDDEE\uD83C\uDDE8 Nairobi, Kenya",
        "longitude": 36.8219,
        "latitude": -1.2921
    },
    {
        "title": "\uD83C\uDDFF\uD83C\uDDE6 Cape Town, South Africa",
        "longitude": 18.4232,
        "latitude": -33.9249
    },
    {
        "title": "\uD83C\uDDF9\uD83C\uDDFF Dodoma, Tanzania",
        "longitude": 35.7392,
        "latitude": -6.1639
    },
    {
        "title": "\uD83C\uDDE8\uD83C\uDDE9 Kinshasa, Democratic Republic of the Congo",
        "longitude": 15.3136,
        "latitude": -4.4419
    },
    {
        "title": "\uD83C\uDDF7\uD83C\uDDFC Kigali, Rwanda",
        "longitude": 30.0583,
        "latitude": -1.9441
    },
    {
        "title": "\uD83C\uDDFF\uD83C\uDDE6 Pretoria, South Africa",
        "longitude": 28.2293,
        "latitude": -25.746
    }
];


// Credit:

// https://2colors.colorion.co/
const $f361755a1171f8e6$var$bidi = [
    ` #50586C #DCE2F0`,
    ` #815854 #F9EBDE`,
    ` #1E4174 #DDA94B`,
    ` #A4193D #FFDFB9`,
    ` #1AAFBC #80634C`,
    ` #FFDFDE #6A7BA2`,
    ` #3B1877 #DA5A2A`,
    ` #5F4B8B #E69A8D`,
    ` #000000 #FFFFFF`,
    ` #00203F #ADEFD1`,
    ` #606060 #D6ED17`,
    ` #2C5F2D #97BC62`,
    ` #00539C #EEA47F`,
    ` #0063B2 #9CC3D5`,
    ` #101820 #FEE715`,
    ` #CBCE91 #d3687f`,
    ` #B1624E #5CC8D7`,
    ` #7b9acc #FCF6F5`,
    ` #101820 #F2AA4C`,
    ` #A07855 #D4B996`,
    ` #195190 #A2A2A1`,
    ` #603F83 #C7D3D4`,
    ` #FAD0C9 #6E6E6D`,
    ` #2D2926 #ed6f63`,
    ` #DAA03D #616247`,
    ` #990011 #FCF6F5`,
    ` #364b44 #D64161`,
    ` #CBCE91 #76528B`,
    ` #FAEBEF #333D79`,
    ` #c72d1b #FDD20E`,
    ` #F2EDD7 #755139`,
    ` #1a7a4c #101820`,
    ` #F95700 #FFFFFF`,
    ` #FFD662 #00539C`,
    ` #D7C49E #D7C49E`,
    ` #cf8360 #F5C7B8`,
    ` #DF6589 #3C1053`,
    ` #FFE77A #2C5F2D`,
    ` #e9877e #9E1030`,
    ` #FCF951 #422057`,
    ` #4B878B #921416`,
    ` #1C1C1B #CE4A7E`,
    ` #00B1D2 #FDDB27`,
    ` #558600 #ff9967`,
    ` #BD7F37 #A13941`,
    ` #eedfe2 #9FC131`,
    ` #00239C #ed6a66`,
    ` #F96167 #FCE77D`,
    ` #F9D142 #292826`,
    ` #DF678C #3D155F`,
    ` #CCF381 #4831D4`,
    ` #4A274F #F0A07B`,
    ` #02343F #F0EDCC`,
    ` #331B3F #ACC7B4`,
    ` #0A174E #F5D042`,
    ` #07553B #CED46A`,
    ` #50586C #DCE2F0`,
    ` #815854 #F9EBDE`,
    ` #1E4174 #DDA94B`,
    ` #A4193D #FFDFB9`,
    ` #1AAFBC #80634C`,
    ` #FFDFDE #6A7BA2`,
    ` #3B1877 #DA5A2A`,
    ` #5F4B8B #E69A8D`,
    ` #00203F #ADEFD1`,
    ` #606060 #D6ED17`,
    ` #2C5F2D #97BC62`,
    ` #00539C #EEA47F`,
    ` #0063B2 #9CC3D5`,
    ` #101820 #FEE715`,
    ` #CBCE91 #d3687f`,
    ` #B1624E #5CC8D7`,
    ` #7b9acc #FCF6F5`,
    ` #101820 #F2AA4C`,
    ` #A07855 #D4B996`,
    ` #195190 #A2A2A1`,
    ` #603F83 #C7D3D4`,
    ` #2BAE66 #FCF6F5`,
    ` #FAD0C9 #6E6E6D`,
    ` #2D2926 #ed6f63`,
    ` #DAA03D #616247`
];
const $f361755a1171f8e6$export$fb397405d3486b2 = ()=>{
    const selected = (0, $b63753f448317b08$export$da86460d40002d1f).randomElement($f361755a1171f8e6$var$bidi);
    const split = selected.trim().split(` `);
    return split.map((v)=>v.trim());
};



// src/trackers/TrackerBase.ts
var $a31d1195ac5264a9$export$20a0bbf0f684f1f8 = class {
    constructor(opts = {}){
        this.id = opts.id ?? `tracker`;
        this.debug = opts.debug ?? false;
        this.sampleLimit = opts.sampleLimit ?? -1;
        this.resetAfterSamples = opts.resetAfterSamples ?? -1;
        this.storeIntermediate = opts.storeIntermediate ?? (this.sampleLimit > -1 || this.resetAfterSamples > -1);
        this.seenCount = 0;
        if (this.debug) console.log(`TrackerBase: sampleLimit: ${this.sampleLimit} resetAfter: ${this.resetAfterSamples} store: ${this.storeIntermediate}`);
    }
    /**
   * Reset tracker
   */ reset() {
        this.seenCount = 0;
        this.onReset();
    }
    /**
   * Adds a value, returning computed result.
   *  
   * At this point, we check if the buffer is larger than `resetAfterSamples`. If so, `reset()` is called.
   * If not, we check `sampleLimit`. If the buffer is twice as large as sample limit, `trimStore()` is
   * called to take it down to sample limit, and `onTrimmed()` is called.
   * @param p 
   * @returns 
   */ seen(...p) {
        if (this.resetAfterSamples > 0 && this.seenCount > this.resetAfterSamples) this.reset();
        else if (this.sampleLimit > 0 && this.seenCount > this.sampleLimit * 2) {
            this.seenCount = this.trimStore(this.sampleLimit);
            this.onTrimmed(`resize`);
        }
        this.seenCount += p.length;
        const t = this.filterData(p);
        return this.computeResults(t);
    }
};
// src/trackers/TrackedValue.ts
var $a31d1195ac5264a9$export$27fa49008f51af6e = class {
    constructor(creator){
        this.store = /* @__PURE__ */ new Map();
        this.gog = (0, $c40eb93fec8b01a3$export$8f4691274895b97)(this.store, creator);
    }
    /**
   * Number of named values being tracked
   */ get size() {
        return this.store.size;
    }
    /**
   * Returns _true_ if `id` is stored
   * @param id
   * @returns
   */ has(id) {
        return this.store.has(id);
    }
    /**
   * For a given id, note that we have seen one or more values.
   * @param id Id
   * @param values Values(s)
   * @returns Information about start to last value
   */ //eslint-disable-next-line @typescript-eslint/no-explicit-any
    //eslint-disable-next-line functional/prefer-immutable-types
    async seen(id, ...values) {
        const trackedValue = await this.getTrackedValue(id, ...values);
        const result = trackedValue.seen(...values);
        return result;
    }
    /**
   * Creates or returns a TrackedValue instance for `id`.
   * @param id
   * @param values
   * @returns
   */ //eslint-disable-next-line functional/prefer-immutable-types
    async getTrackedValue(id, ...values) {
        if (id === null) throw new Error(`id parameter cannot be null`);
        if (id === void 0) throw new Error(`id parameter cannot be undefined`);
        const trackedValue = await this.gog(id, values[0]);
        return trackedValue;
    }
    /**
   * Remove a tracked value by id.
   * Use {@link reset} to clear them all.
   * @param id
   */ delete(id) {
        this.store.delete(id);
    }
    /**
   * Remove all tracked values.
   * Use {@link delete} to remove a single value by id.
   */ reset() {
        this.store = /* @__PURE__ */ new Map();
    }
    /**
   * Enumerate ids
   */ *ids() {
        yield* this.store.keys();
    }
    /**
   * Enumerate tracked values
   */ *tracked() {
        yield* this.store.values();
    }
    /**
   * Iterates TrackedValues ordered with oldest first
   * @returns
   */ *trackedByAge() {
        const tp = [
            ...this.store.values()
        ];
        tp.sort((a, b)=>{
            const aa = a.elapsed;
            const bb = b.elapsed;
            if (aa === bb) return 0;
            if (aa > bb) return -1;
            return 1;
        });
        for (const t of tp)yield t;
    }
    /**
   * Iterates underlying values, ordered by age (oldest first)
   * First the named values are sorted by their `elapsed` value, and then
   * we return the last value for that group.
   */ *valuesByAge() {
        for (const tb of this.trackedByAge())yield tb.last;
    }
    /**
   * Enumerate last received values
   *
   * @example Calculate centroid of latest-received values
   * ```js
   * const pointers = pointTracker();
   * const c = Points.centroid(...Array.from(pointers.lastPoints()));
   * ```
   */ *last() {
        for (const p of this.store.values())yield p.last;
    }
    /**
   * Enumerate starting values
   */ *initialValues() {
        for (const p of this.store.values())yield p.initial;
    }
    /**
   * Returns a tracked value by id, or undefined if not found
   * @param id
   * @returns
   */ get(id) {
        return this.store.get(id);
    }
};





// src/trackers/ObjectTracker.ts
var $2f2ba87902101909$export$13649ba9bf278783 = class extends (0, $a31d1195ac5264a9$export$20a0bbf0f684f1f8) {
    constructor(opts = {}){
        super(opts);
        this.values = [];
    }
    onTrimmed(reason) {}
    /**
   * Reduces size of value store to `limit`. 
   * Returns number of remaining items
   * @param limit
   */ trimStore(limit) {
        if (limit >= this.values.length) return this.values.length;
        this.values = this.values.slice(-limit);
        return this.values.length;
    }
    /**
   * Allows sub-classes to be notified when a reset happens
   * @ignore
   */ onReset() {
        this.values = [];
    }
    /**
   * Tracks a value
   * @ignore
   */ filterData(p) {
        const ts = p.map((v)=>`at` in v ? v : {
                ...v,
                at: Date.now()
            });
        const last = ts.at(-1);
        if (this.storeIntermediate) this.values.push(...ts);
        else switch(this.values.length){
            case 0:
                this.values.push(last);
                break;
            case 1:
                this.values.push(last);
                break;
            case 2:
                this.values[1] = last;
                break;
        }
        return ts;
    }
    /**
   * Last seen value. If no values have been added, it will return the initial value
   */ get last() {
        if (this.values.length === 1) return this.values[0];
        return this.values.at(-1);
    }
    /**
   * Returns the oldest value in the buffer
   */ get initial() {
        return this.values.at(0);
    }
    /**
   * Returns number of recorded values (includes the initial value in the count)
   */ get size() {
        return this.values.length;
    }
    /**
   * Returns the elapsed time, in milliseconds since the initial value
   */ get elapsed() {
        return Date.now() - this.values[0].at;
    }
};
// src/trackers/PointTracker.ts
var $2f2ba87902101909$export$ef4185b0af72d58e = class extends $2f2ba87902101909$export$13649ba9bf278783 {
    constructor(opts = {}){
        super(opts);
    }
    /**
   * Notification that buffer has been knocked down to `sampleLimit`.
   * 
   * This will reset the `initialRelation`, which will use the new oldest value.
   */ onTrimmed(reason) {
        this.initialRelation = void 0;
    }
    /**
   * @ignore
   */ onReset() {
        super.onReset();
        this.lastResult = void 0;
        this.initialRelation = void 0;
        this.markRelation = void 0;
    }
    /**
   * Adds a PointerEvent along with its
   * coalesced events, if available.
   * @param p 
   * @returns 
   */ seenEvent(p) {
        if (`getCoalescedEvents` in p) {
            const events = p.getCoalescedEvents();
            const asPoints = events.map((event)=>({
                    x: event.clientX,
                    y: event.clientY
                }));
            return this.seen(...asPoints);
        } else return this.seen({
            x: p.clientX,
            y: p.clientY
        });
    }
    /**
   * Makes a 'mark' in the tracker, allowing you to compare values
   * to this point.
   */ mark() {
        this.markRelation = (0, $2edc1eef02a7c199$export$c7330cd8359b642f)(this.last);
    }
    /**
   * Tracks a point, returning data on its relation to the
   * initial point and the last received point.
   * 
   * Use {@link seenEvent} to track a raw `PointerEvent`.
   * 
   * @param _p Point
   */ computeResults(_p) {
        const currentLast = this.last;
        const previousLast = this.values.at(-2);
        if (this.initialRelation === void 0 && this.initial) this.initialRelation = (0, $2edc1eef02a7c199$export$c7330cd8359b642f)(this.initial);
        else if (this.initialRelation === void 0) throw new Error(`Bug: No initialRelation, and this.inital is undefined?`);
        const lastRelation = previousLast === void 0 ? (0, $2edc1eef02a7c199$export$c7330cd8359b642f)(currentLast) : (0, $2edc1eef02a7c199$export$c7330cd8359b642f)(previousLast);
        const initialRel = this.initialRelation(currentLast);
        const markRel = this.markRelation !== void 0 ? this.markRelation(currentLast) : void 0;
        const speed = previousLast === void 0 ? 0 : (0, $2edc1eef02a7c199$export$f24224f1c91d8156)(previousLast, currentLast) / (currentLast.at - previousLast.at);
        const lastRel = {
            ...lastRelation(currentLast),
            speed: speed
        };
        const r = {
            fromInitial: initialRel,
            fromLast: lastRel,
            fromMark: markRel,
            values: [
                ...this.values
            ]
        };
        this.lastResult = r;
        return r;
    }
    /**
   * Returns a polyline representation of stored points.
   * Returns an empty array if points were not saved, or there's only one.
   */ get line() {
        if (this.values.length === 1) return [];
        return (0, $da7bbf79b162d05c$export$9e1b37f7e15343fa)(...this.values);
    }
    /**
   * Returns a vector of the initial/last points of the tracker.
   * Returns as a polar coordinate
   */ get vectorPolar() {
        return (0, $da7bbf79b162d05c$export$19c6138bf36917b8).fromLinePolar(this.lineStartEnd);
    }
    /**
   * Returns a vector of the initial/last points of the tracker.
   * Returns as a Cartesian coordinate
   */ get vectorCartesian() {
        return (0, $da7bbf79b162d05c$export$19c6138bf36917b8).fromLineCartesian(this.lineStartEnd);
    }
    /**
   * Returns a line from initial point to last point.
   *
   * If there are less than two points, Lines.Empty is returned
   */ get lineStartEnd() {
        const initial = this.initial;
        if (this.values.length < 2 || !initial) return 0, $da7bbf79b162d05c$export$1f74963c34e8bfec;
        return {
            a: initial,
            b: this.last
        };
    }
    /**
   * Returns distance from latest point to initial point.
   * If there are less than two points, zero is returned.
   *
   * This is the direct distance from initial to last,
   * not the accumulated length.
   * @returns Distance
   */ distanceFromStart() {
        const initial = this.initial;
        return this.values.length >= 2 && initial !== void 0 ? (0, $2edc1eef02a7c199$export$9f17032d917177de)(initial, this.last) : 0;
    }
    /**
   * Difference between last point and the initial point, calculated
   * as a simple subtraction of x,y & z.
   *
   * `Points.Placeholder` is returned if there's only one point so far.
   */ difference() {
        const initial = this.initial;
        return this.values.length >= 2 && initial !== void 0 ? (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(this.last, initial) : (0, $2edc1eef02a7c199$export$84712d0562a614b8);
    }
    /**
   * Returns angle (in radians) from latest point to the initial point
   * If there are less than two points, undefined is return.
   * @returns Angle in radians
   */ angleFromStart() {
        const initial = this.initial;
        if (initial !== void 0 && this.values.length > 2) return (0, $2edc1eef02a7c199$export$8052d07eb1c2870e)(initial, this.last);
    }
    /**
   * Returns the total length of accumulated points.
   * Returns 0 if points were not saved, or there's only one
   */ get length() {
        if (this.values.length === 1) return 0;
        const l = this.line;
        return (0, $2edc1eef02a7c199$export$f24224f1c91d8156)(l);
    }
    /**
  * Returns the last x coord
  */ get x() {
        return this.last.x;
    }
    /**
   * Returns the last y coord
   */ get y() {
        return this.last.y;
    }
    /**
   * Returns the last z coord (or _undefined_ if not available)
   */ get z() {
        return this.last.z;
    }
};
var $2f2ba87902101909$export$734eb71d5a0d0a92 = class extends (0, $a31d1195ac5264a9$export$27fa49008f51af6e) {
    constructor(opts = {}){
        super((key, start)=>{
            if (start === void 0) throw new Error(`Requires start point`);
            const p = new $2f2ba87902101909$export$ef4185b0af72d58e({
                ...opts,
                id: key
            });
            p.seen(start);
            return p;
        });
    }
    /**
   * Track a PointerEvent
   * @param event
   */ seenEvent(event) {
        if (`getCoalescedEvents` in event) {
            const events = event.getCoalescedEvents();
            const seens = events.map((subEvent)=>super.seen(subEvent.pointerId.toString(), subEvent));
            return Promise.all(seens);
        } else return Promise.all([
            super.seen(event.pointerId.toString(), event)
        ]);
    }
};
var $2f2ba87902101909$export$9f048bf86ee2e9d2 = (options = {})=>new $2f2ba87902101909$export$734eb71d5a0d0a92(options);
var $2f2ba87902101909$export$105684a3041cb6f3 = (opts = {})=>new $2f2ba87902101909$export$ef4185b0af72d58e(opts);
// src/trackers/TrackUnique.ts
var $2f2ba87902101909$export$7a5d5c156e7dc406 = (toString = (0, $847987b26b102cb8$export$f5a6f2033c1996c8))=>{
    const set = /* @__PURE__ */ new Set();
    return (value)=>{
        if (value === null) throw new TypeError(`Param 'value' cannot be null`);
        if (value === void 0) throw new TypeError(`Param 'value' cannot be undefined`);
        const asString = typeof value === `string` ? value : toString(value);
        if (set.has(asString)) return false;
        set.add(asString);
        return true;
    };
};
var $2f2ba87902101909$export$82a7086f6a71cb5c = ()=>{
    const set = /* @__PURE__ */ new Set();
    return (value)=>{
        if (value === null) throw new TypeError(`Param 'value' cannot be null`);
        if (value === void 0) throw new TypeError(`Param 'value' cannot be undefined`);
        if (set.has(value)) return false;
        set.add(value);
        return true;
    };
};




// src/dom/Forms.ts
var $369e8ba1b60a36f8$export$a2b919e21942588e = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($369e8ba1b60a36f8$export$a2b919e21942588e, {
    button: ()=>$369e8ba1b60a36f8$export$2ba01fb71ed41cb6,
    buttonCreate: ()=>$369e8ba1b60a36f8$export$8ca6707f9dc68029,
    checkbox: ()=>$369e8ba1b60a36f8$export$b07e517d22efa1ca,
    numeric: ()=>$369e8ba1b60a36f8$export$b7a508fa8dae59fc,
    select: ()=>$369e8ba1b60a36f8$export$2e6c959c16ff56b8,
    textAreaKeyboard: ()=>$369e8ba1b60a36f8$export$d6fb6117801f1343
});
var $369e8ba1b60a36f8$export$d6fb6117801f1343 = (el)=>{
    el.addEventListener(`keydown`, (event)=>{
        const elementValue = el.value;
        const start = el.selectionStart;
        const end = el.selectionEnd;
        if (event.key === `Tab` && event.shiftKey) {
            if (el.value.substring(start - 2, start) === `  `) el.value = elementValue.slice(0, Math.max(0, start - 2)) + elementValue.slice(Math.max(0, end));
            el.selectionStart = el.selectionEnd = start - 2;
            event.preventDefault();
            return false;
        } else if (event.key === `Tab`) {
            el.value = elementValue.slice(0, Math.max(0, start)) + `  ` + elementValue.slice(Math.max(0, end));
            el.selectionStart = el.selectionEnd = start + 2;
            event.preventDefault();
            return false;
        }
    });
};
var $369e8ba1b60a36f8$export$b07e517d22efa1ca = (domIdOrEl, onChanged)=>{
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domIdOrEl);
    if (onChanged) el.addEventListener(`change`, ()=>{
        onChanged(el.checked);
    });
    return {
        get checked () {
            return el.checked;
        },
        set checked (value){
            el.checked = value;
        }
    };
};
var $369e8ba1b60a36f8$export$b7a508fa8dae59fc = (domIdOrEl, onChanged, live)=>{
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domIdOrEl);
    const eventName = live ? `change` : `input`;
    if (onChanged) el.addEventListener(eventName, ()=>{
        onChanged(Number.parseInt(el.value));
    });
    return {
        get value () {
            return Number.parseInt(el.value);
        },
        set value (value){
            el.value = value.toString();
        }
    };
};
var $369e8ba1b60a36f8$export$2ba01fb71ed41cb6 = (domQueryOrEl, onClickHandler)=>{
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domQueryOrEl);
    const addEvent = ()=>{
        if (onClickHandler) el.addEventListener(`click`, onClickHandler);
    };
    const removeEvent = ()=>{
        if (onClickHandler) el.removeEventListener(`click`, onClickHandler);
    };
    addEvent();
    return {
        /**
     * Gets text content of button
     */ get title () {
            return el.textContent;
        },
        /**
     * Sets text content of button
     */ set title (value){
            el.textContent = value;
        },
        /**
     * Disposes the button.
     * Removes event handler and optionally removes from document
     * @param deleteElement 
     */ dispose (deleteElement = false) {
            removeEvent();
            if (deleteElement) el.remove();
        },
        /**
     * Sets the click handler, overwriting existing.
     * @param handler 
     */ onClick (handler) {
            removeEvent();
            onClickHandler = handler;
            addEvent();
        },
        /**
     * Trigger onClick handler
     */ click () {
            if (onClickHandler) onClickHandler();
        },
        /**
     * Sets disabled state of button
     */ set disabled (value){
            el.disabled = value;
        },
        /**
     * Gets the button element
     */ get el () {
            return el;
        }
    };
};
var $369e8ba1b60a36f8$export$8ca6707f9dc68029 = (title, onClick)=>{
    const el = document.createElement(`button`);
    const w = $369e8ba1b60a36f8$export$2ba01fb71ed41cb6(el, onClick);
    w.title = title;
    return w;
};
var $369e8ba1b60a36f8$export$2e6c959c16ff56b8 = (domQueryOrEl, onChanged, options = {})=>{
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domQueryOrEl);
    const { placeholderOpt: placeholderOpt, shouldAddChoosePlaceholder: shouldAddChoosePlaceholder = false, autoSelectAfterChoice: autoSelectAfterChoice = -1 } = options;
    const change = ()=>{
        if (onChanged !== void 0) onChanged(el.value);
        if (autoSelectAfterChoice >= 0) el.selectedIndex = autoSelectAfterChoice;
    };
    if (onChanged) el.addEventListener(`change`, (_event)=>{
        change();
    });
    return {
        set disabled (value){
            el.disabled = value;
        },
        get value () {
            return el.value;
        },
        get index () {
            return el.selectedIndex;
        },
        get isSelectedPlaceholder () {
            return (shouldAddChoosePlaceholder || options.placeholderOpt !== void 0) && el.selectedIndex === 0;
        },
        //eslint-disable-next-line functional/prefer-immutable-types
        setOpts (opts, preSelect) {
            el.options.length = 0;
            if (shouldAddChoosePlaceholder) opts = [
                `-- Choose --`,
                ...opts
            ];
            else if (placeholderOpt !== void 0) opts = [
                placeholderOpt,
                ...opts
            ];
            let toSelect = 0;
            for (const [index, o] of opts.entries()){
                const optEl = document.createElement(`option`);
                optEl.value = o;
                optEl.innerHTML = o;
                if (preSelect !== void 0 && o === preSelect) toSelect = index;
                el.options.add(optEl);
            }
            el.selectedIndex = toSelect;
        },
        select (index = 0, trigger = false) {
            el.selectedIndex = index;
            if (trigger && onChanged) change();
        }
    };
};







// src/dom/CanvasHelper.ts
var $322275c897c4eafb$export$2b23415a8d830e94 = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    #scaler;
    #scalerSize;
    #viewport = (0, $da7bbf79b162d05c$export$40726222f7ec099b).EmptyPositioned;
    #logicalSize = (0, $da7bbf79b162d05c$export$40726222f7ec099b).Empty;
    #ctx;
    #drawHelper;
    #resizer;
    #disposed = false;
    constructor(domQueryOrEl, opts = {}){
        super();
        if (!domQueryOrEl) throw new Error(`Param 'domQueryOrEl' is null or undefined`);
        this.el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domQueryOrEl);
        if (this.el.nodeName !== `CANVAS`) throw new Error(`Expected CANVAS HTML element. Got: ${this.el.nodeName}`);
        const size = this.el.getBoundingClientRect();
        this.opts = {
            resizeLogic: opts.resizeLogic ?? `none`,
            disablePointerEvents: opts.disablePointerEvents ?? false,
            pixelZoom: opts.pixelZoom ?? (window.devicePixelRatio || 1),
            height: opts.height ?? size.height,
            width: opts.width ?? size.width,
            zIndex: opts.zIndex ?? -1,
            coordinateScale: opts.coordinateScale ?? `both`,
            onResize: opts.onResize,
            clearOnResize: opts.clearOnResize ?? true,
            draw: opts.draw,
            skipCss: opts.skipCss ?? false,
            colourSpace: `srgb`
        };
        this.#scaler = (0, $da7bbf79b162d05c$export$392c70347f2a027f)(`both`);
        this.#scalerSize = (0, $da7bbf79b162d05c$export$392c70347f2a027f)(`both`, size);
        this.#init();
    }
    getRectangle() {
        return {
            x: 0,
            y: 0,
            ...this.#logicalSize
        };
    }
    dispose(reason) {
        if (this.#disposed) return;
        this.#disposed = true;
        if (this.#resizer) {
            this.#resizer.dispose(`CanvasHelper disposing ${reason}`.trim());
            this.#resizer = void 0;
        }
    }
    #getContext(reset = false) {
        if (this.#ctx === void 0 || reset) {
            const ratio = this.ratio;
            const c = this.el.getContext(`2d`);
            if (c === null) throw new Error(`Could not create drawing context`);
            this.#ctx = c;
            c.setTransform(1, 0, 0, 1, 0, 0);
            c.scale(ratio, ratio);
        }
        return this.#ctx;
    }
    /**
   * Gets the drawable area of the canvas.
   * This accounts for scaling due to high-DPI displays etc.
   * @returns 
   */ getPhysicalSize() {
        return {
            width: this.width * this.ratio,
            height: this.height * this.ratio
        };
    }
    /**
   * Creates a drawing helper for the canvas.
   * If one is already created it is reused.
   */ getDrawHelper() {
        if (!this.#drawHelper) this.#drawHelper = (0, $4a5be75452a35244$export$2760d834ea57cc3a)(this.#getContext(), {
            width: this.width,
            height: this.height
        });
    }
    setLogicalSize(logicalSize) {
        (0, $2edc1eef02a7c199$export$290a3749c7970426)(logicalSize, `logicalSize`);
        const logicalSizeInteger = (0, $da7bbf79b162d05c$export$40726222f7ec099b).applyFields((v)=>Math.floor(v), logicalSize);
        const ratio = this.opts.pixelZoom;
        this.#scaler = (0, $da7bbf79b162d05c$export$392c70347f2a027f)(this.opts.coordinateScale, logicalSize);
        this.#scalerSize = (0, $da7bbf79b162d05c$export$392c70347f2a027f)(`both`, logicalSize);
        const pixelScaled = (0, $da7bbf79b162d05c$export$c697bed75648cdb7)(logicalSize, ratio);
        this.el.width = pixelScaled.width;
        this.el.height = pixelScaled.height;
        this.el.style.width = logicalSizeInteger.width.toString() + `px`;
        this.el.style.height = logicalSizeInteger.height.toString() + `px`;
        this.#getContext(true);
        if (this.opts.clearOnResize) this.ctx.clearRect(0, 0, this.width, this.height);
        this.#logicalSize = logicalSizeInteger;
        const r = this.opts.onResize;
        if (r) setTimeout(()=>{
            r(this.ctx, this.size, this);
        }, 100);
        this.fireEvent(`resize`, {
            ctx: this.ctx,
            size: this.#logicalSize,
            helper: this
        });
    }
    #init() {
        console.log(`init`, this.opts);
        const d = this.opts.draw;
        if (d) {
            const sched = ()=>{
                d(this.ctx, this.#logicalSize, this);
                requestAnimationFrame(sched);
            };
            setTimeout(()=>{
                sched();
            }, 100);
        }
        if (!this.opts.disablePointerEvents) this.#handleEvents();
        const resizeLogic = this.opts.resizeLogic ?? `none`;
        if (resizeLogic === `none`) this.setLogicalSize({
            width: this.opts.width,
            height: this.opts.height
        });
        else {
            const resizerOptions = {
                onSetSize: (size)=>{
                    if ((0, $da7bbf79b162d05c$export$40726222f7ec099b).isEqual(this.#logicalSize, size)) return;
                    this.setLogicalSize(size);
                },
                naturalSize: {
                    width: this.opts.width,
                    height: this.opts.height
                },
                stretch: this.opts.resizeLogic ?? `none`
            };
            this.#resizer = new (0, $4a5be75452a35244$export$6fdaa4e99cd13524)(this.el, resizerOptions);
        }
        this.#getContext();
    }
    #handleEvents() {
        const handlePointerEvent = (event)=>{
            const { offsetX: offsetX, offsetY: offsetY } = event;
            const physicalX = offsetX * this.ratio;
            const physicalY = offsetY * this.ratio;
            event = (0, $2edc1eef02a7c199$export$12773f791ff2c9ff)(event);
            const eventData = {
                physicalX: physicalX,
                physicalY: physicalY,
                ...event
            };
            switch(event.type){
                case `pointerup`:
                    this.fireEvent(`pointerup`, eventData);
                    break;
                case `pointermove`:
                    this.fireEvent(`pointermove`, eventData);
                    break;
                case `pointerdown`:
                    this.fireEvent(`pointerup`, eventData);
                    break;
            }
        };
        this.el.addEventListener(`pointermove`, handlePointerEvent);
        this.el.addEventListener(`pointerdown`, handlePointerEvent);
        this.el.addEventListener(`pointerup`, handlePointerEvent);
    }
    /**
   * Clears the canvas.
   * 
   * Shortcut for:
   * `ctx.clearRect(0, 0, this.width, this.height)`
   */ clear() {
        if (!this.#ctx) return;
        this.#ctx.clearRect(0, 0, this.width, this.height);
    }
    /**
   * Fills the canvas with a given colour.
   * 
   * Shortcut for:
   * ```js
      * ctx.fillStyle = ``;
   * ctx.fillRect(0, 0, this.width, this.height);
   * ```
   * @param colour Colour
   */ fill(colour) {
        if (!this.#ctx) return;
        if (colour) this.#ctx.fillStyle = colour;
        this.#ctx.fillRect(0, 0, this.width, this.height);
    }
    /**
   * Gets the drawing context
   */ get ctx() {
        if (this.#ctx === void 0) throw new Error(`Context not available`);
        return this.#getContext();
    }
    get viewport() {
        return this.#viewport;
    }
    /**
   * Gets the logical width of the canvas
   * See also: {@link height}, {@link size}
   */ get width() {
        return this.#logicalSize.width;
    }
    /**
   * Gets the logical height of the canvas
   * See also: {@link width}, {@link size}
   */ get height() {
        return this.#logicalSize.height;
    }
    /**
   * Gets the logical size of the canvas
   * See also: {@link width}, {@link height}
   */ get size() {
        return this.#logicalSize;
    }
    /**
   * Gets the current scaling ratio being used
   * to compensate for high-DPI display
   */ get ratio() {
        return window.devicePixelRatio || 1;
    }
    /**
   * Returns the width or height, whichever is smallest
   */ get dimensionMin() {
        return Math.min(this.width, this.height);
    }
    /**
   * Returns the width or height, whichever is largest
   */ get dimensionMax() {
        return Math.max(this.width, this.height);
    }
    drawBounds(strokeStyle = `green`) {
        const ctx = this.#getContext();
        (0, $4a5be75452a35244$export$f60f7d0f1cfead51).rect(ctx, {
            x: 0,
            y: 0,
            width: this.width,
            height: this.height
        }, {
            crossed: true,
            strokeStyle: strokeStyle,
            strokeWidth: 1
        });
        (0, $4a5be75452a35244$export$f60f7d0f1cfead51).rect(ctx, this.#viewport, {
            crossed: true,
            strokeStyle: `silver`,
            strokeWidth: 3
        });
    }
    /**
   * Returns a Scaler that converts from absolute
   * to relative coordinates.
   * This is based on the canvas size.
   * 
   * ```js
      * // Assuming a canvas of 800x500
   * toRelative({ x: 800, y: 600 });  // { x: 1,   y: 1 }
   * toRelative({ x: 0, y: 0 });   // { x: 0,   y: 0 }
   * toRelative({ x: 400, y: 300 }); // { x: 0.5, y: 0.5 }
   * ```
   */ get toRelative() {
        return this.#scaler.rel;
    }
    /**
   * Returns a scaler for points based on width & height
   */ get toAbsoluteFixed() {
        return this.#scalerSize.abs;
    }
    /**
   * Returns a scaler for points based on width & height
   */ get toRelativeFixed() {
        return this.#scalerSize.rel;
    }
    get logicalCenter() {
        return {
            x: this.#logicalSize.width / 2,
            y: this.#logicalSize.height / 2
        };
    }
    /**
  * Returns a Scaler that converts from relative to absolute
  * coordinates.
  * This is based on the canvas size.
  * 
  * ```js
  * // Assuming a canvas of 800x600
  * toAbsolute({ x: 1, y: 1 });      // { x: 800, y: 600}
  * toAbsolute({ x: 0, y: 0 });      // { x: 0, y: 0}
  * toAbsolute({ x: 0.5, y: 0.5 });  // { x: 400, y: 300}
  * ```
  */ get toAbsolute() {
        return this.#scaler.abs;
    }
    /**
   * Gets the center coordinate of the canvas
   */ get center() {
        return {
            x: this.width / 2,
            y: this.height / 2
        };
    }
    /**
   * Gets the image data for the canvas.
   * Uses the 'physical' canvas size. Eg. A logical size of 400x400 might be
   * 536x536 with a high-DPI display.
   * @returns 
   */ getImageData() {
        const size = this.getPhysicalSize();
        const data = this.ctx.getImageData(0, 0, size.width, size.height, {
            colorSpace: this.opts.colourSpace
        });
        if (!data) throw new Error(`Could not get image data from context`);
        return data;
    }
    /**
   * Returns the canvas frame data as a writable grid.
   * When editing, make as many edits as needed before calling
   * `flip`, which writes buffer back to the canvas.
   * ```js
      * const g = helper.getWritableBuffer();
   * // Get {r,g,b,opacity} of pixel 10,10
   * const pixel = g.get({ x: 10, y: 10 });
   * 
   * // Set a colour to pixel 10,10
   * g.set({ r: 0.5, g: 1, b: 0, opacity: 0 }, { x: 10, y: 10 });
   * 
   * // Write buffer to canvas
   * g.flip();
   * ```
   * 
   * Uses 'physical' size of canvas. Eg with a high-DPI screen, this will
   * mean a higher number of rows and columns compared to the logical size.
   * @returns
   */ getWritableBuffer() {
        const ctx = this.ctx;
        const data = this.getImageData();
        const grid = (0, $da7bbf79b162d05c$export$c051a4d1797a311f).grid(data);
        const get = (0, $da7bbf79b162d05c$export$c051a4d1797a311f).accessor(data);
        const set = (0, $da7bbf79b162d05c$export$c051a4d1797a311f).setter(data);
        const flip = ()=>{
            ctx.putImageData(data, 0, 0);
        };
        return {
            grid: grid,
            get: get,
            set: set,
            flip: flip
        };
    }
};













// node_modules/json5/dist/index.js
var $5d8ef0ef429bc174$var$require_dist = (0, $f81dde33861c7f4f$export$c98acbe61b4a254a)({
    "node_modules/json5/dist/index.js" (exports, module) {
        "use strict";
        (function(global, factory) {
            typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : global.JSON5 = factory();
        })(exports, function() {
            "use strict";
            function createCommonjsModule(fn, module2) {
                return module2 = {
                    exports: {}
                }, fn(module2, module2.exports), module2.exports;
            }
            var _global = createCommonjsModule(function(module2) {
                var global = module2.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
                if (typeof __g == "number") __g = global;
            });
            var _core = createCommonjsModule(function(module2) {
                var core = module2.exports = {
                    version: "2.6.5"
                };
                if (typeof __e == "number") __e = core;
            });
            var _core_1 = _core.version;
            var _isObject = function(it) {
                return typeof it === "object" ? it !== null : typeof it === "function";
            };
            var _anObject = function(it) {
                if (!_isObject(it)) throw TypeError(it + " is not an object!");
                return it;
            };
            var _fails = function(exec) {
                try {
                    return !!exec();
                } catch (e) {
                    return true;
                }
            };
            var _descriptors = !_fails(function() {
                return Object.defineProperty({}, "a", {
                    get: function() {
                        return 7;
                    }
                }).a != 7;
            });
            var document2 = _global.document;
            var is = _isObject(document2) && _isObject(document2.createElement);
            var _domCreate = function(it) {
                return is ? document2.createElement(it) : {};
            };
            var _ie8DomDefine = !_descriptors && !_fails(function() {
                return Object.defineProperty(_domCreate("div"), "a", {
                    get: function() {
                        return 7;
                    }
                }).a != 7;
            });
            var _toPrimitive = function(it, S) {
                if (!_isObject(it)) return it;
                var fn, val;
                if (S && typeof (fn = it.toString) == "function" && !_isObject(val = fn.call(it))) return val;
                if (typeof (fn = it.valueOf) == "function" && !_isObject(val = fn.call(it))) return val;
                if (!S && typeof (fn = it.toString) == "function" && !_isObject(val = fn.call(it))) return val;
                throw TypeError("Can't convert object to primitive value");
            };
            var dP = Object.defineProperty;
            var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
                _anObject(O);
                P = _toPrimitive(P, true);
                _anObject(Attributes);
                if (_ie8DomDefine) try {
                    return dP(O, P, Attributes);
                } catch (e) {}
                if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
                if ("value" in Attributes) O[P] = Attributes.value;
                return O;
            };
            var _objectDp = {
                f: f
            };
            var _propertyDesc = function(bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };
            var _hide = _descriptors ? function(object, key2, value) {
                return _objectDp.f(object, key2, _propertyDesc(1, value));
            } : function(object, key2, value) {
                object[key2] = value;
                return object;
            };
            var hasOwnProperty = {}.hasOwnProperty;
            var _has = function(it, key2) {
                return hasOwnProperty.call(it, key2);
            };
            var id = 0;
            var px = Math.random();
            var _uid = function(key2) {
                return "Symbol(".concat(key2 === void 0 ? "" : key2, ")_", (++id + px).toString(36));
            };
            var _library = false;
            var _shared = createCommonjsModule(function(module2) {
                var SHARED = "__core-js_shared__";
                var store = _global[SHARED] || (_global[SHARED] = {});
                (module2.exports = function(key2, value) {
                    return store[key2] || (store[key2] = value !== void 0 ? value : {});
                })("versions", []).push({
                    version: _core.version,
                    mode: _library ? "pure" : "global",
                    copyright: "\xA9 2019 Denis Pushkarev (zloirock.ru)"
                });
            });
            var _functionToString = _shared("native-function-to-string", Function.toString);
            var _redefine = createCommonjsModule(function(module2) {
                var SRC = _uid("src");
                var TO_STRING = "toString";
                var TPL = ("" + _functionToString).split(TO_STRING);
                _core.inspectSource = function(it) {
                    return _functionToString.call(it);
                };
                (module2.exports = function(O, key2, val, safe) {
                    var isFunction = typeof val == "function";
                    if (isFunction) _has(val, "name") || _hide(val, "name", key2);
                    if (O[key2] === val) return;
                    if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key2] ? "" + O[key2] : TPL.join(String(key2)));
                    if (O === _global) O[key2] = val;
                    else if (!safe) {
                        delete O[key2];
                        _hide(O, key2, val);
                    } else if (O[key2]) O[key2] = val;
                    else _hide(O, key2, val);
                })(Function.prototype, TO_STRING, function toString() {
                    return typeof this == "function" && this[SRC] || _functionToString.call(this);
                });
            });
            var _aFunction = function(it) {
                if (typeof it != "function") throw TypeError(it + " is not a function!");
                return it;
            };
            var _ctx = function(fn, that, length) {
                _aFunction(fn);
                if (that === void 0) return fn;
                switch(length){
                    case 1:
                        return function(a) {
                            return fn.call(that, a);
                        };
                    case 2:
                        return function(a, b) {
                            return fn.call(that, a, b);
                        };
                    case 3:
                        return function(a, b, c2) {
                            return fn.call(that, a, b, c2);
                        };
                }
                return function() {
                    return fn.apply(that, arguments);
                };
            };
            var PROTOTYPE = "prototype";
            var $export = function(type, name, source2) {
                var IS_FORCED = type & $export.F;
                var IS_GLOBAL = type & $export.G;
                var IS_STATIC = type & $export.S;
                var IS_PROTO = type & $export.P;
                var IS_BIND = type & $export.B;
                var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
                var exports2 = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
                var expProto = exports2[PROTOTYPE] || (exports2[PROTOTYPE] = {});
                var key2, own, out, exp;
                if (IS_GLOBAL) source2 = name;
                for(key2 in source2){
                    own = !IS_FORCED && target && target[key2] !== void 0;
                    out = (own ? target : source2)[key2];
                    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == "function" ? _ctx(Function.call, out) : out;
                    if (target) _redefine(target, key2, out, type & $export.U);
                    if (exports2[key2] != out) _hide(exports2, key2, exp);
                    if (IS_PROTO && expProto[key2] != out) expProto[key2] = out;
                }
            };
            _global.core = _core;
            $export.F = 1;
            $export.G = 2;
            $export.S = 4;
            $export.P = 8;
            $export.B = 16;
            $export.W = 32;
            $export.U = 64;
            $export.R = 128;
            var _export = $export;
            var ceil = Math.ceil;
            var floor = Math.floor;
            var _toInteger = function(it) {
                return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
            };
            var _defined = function(it) {
                if (it == void 0) throw TypeError("Can't call method on  " + it);
                return it;
            };
            var _stringAt = function(TO_STRING) {
                return function(that, pos2) {
                    var s = String(_defined(that));
                    var i = _toInteger(pos2);
                    var l = s.length;
                    var a, b;
                    if (i < 0 || i >= l) return TO_STRING ? "" : void 0;
                    a = s.charCodeAt(i);
                    return a < 55296 || a > 56319 || i + 1 === l || (b = s.charCodeAt(i + 1)) < 56320 || b > 57343 ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 55296 << 10) + (b - 56320) + 65536;
                };
            };
            var $at = _stringAt(false);
            _export(_export.P, "String", {
                // 21.1.3.3 String.prototype.codePointAt(pos)
                codePointAt: function codePointAt2(pos2) {
                    return $at(this, pos2);
                }
            });
            var codePointAt = _core.String.codePointAt;
            var max = Math.max;
            var min = Math.min;
            var _toAbsoluteIndex = function(index, length) {
                index = _toInteger(index);
                return index < 0 ? max(index + length, 0) : min(index, length);
            };
            var fromCharCode = String.fromCharCode;
            var $fromCodePoint = String.fromCodePoint;
            _export(_export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), "String", {
                // 21.1.2.2 String.fromCodePoint(...codePoints)
                fromCodePoint: function fromCodePoint2(x) {
                    var arguments$1 = arguments;
                    var res = [];
                    var aLen = arguments.length;
                    var i = 0;
                    var code;
                    while(aLen > i){
                        code = +arguments$1[i++];
                        if (_toAbsoluteIndex(code, 1114111) !== code) throw RangeError(code + " is not a valid code point");
                        res.push(code < 65536 ? fromCharCode(code) : fromCharCode(((code -= 65536) >> 10) + 55296, code % 1024 + 56320));
                    }
                    return res.join("");
                }
            });
            var fromCodePoint = _core.String.fromCodePoint;
            var Space_Separator = /[\u1680\u2000-\u200A\u202F\u205F\u3000]/;
            var ID_Start = /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/;
            var ID_Continue = /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/;
            var unicode = {
                Space_Separator: Space_Separator,
                ID_Start: ID_Start,
                ID_Continue: ID_Continue
            };
            var util = {
                isSpaceSeparator: function isSpaceSeparator(c2) {
                    return typeof c2 === "string" && unicode.Space_Separator.test(c2);
                },
                isIdStartChar: function isIdStartChar(c2) {
                    return typeof c2 === "string" && (c2 >= "a" && c2 <= "z" || c2 >= "A" && c2 <= "Z" || c2 === "$" || c2 === "_" || unicode.ID_Start.test(c2));
                },
                isIdContinueChar: function isIdContinueChar(c2) {
                    return typeof c2 === "string" && (c2 >= "a" && c2 <= "z" || c2 >= "A" && c2 <= "Z" || c2 >= "0" && c2 <= "9" || c2 === "$" || c2 === "_" || c2 === "\u200C" || c2 === "\u200D" || unicode.ID_Continue.test(c2));
                },
                isDigit: function isDigit(c2) {
                    return typeof c2 === "string" && /[0-9]/.test(c2);
                },
                isHexDigit: function isHexDigit(c2) {
                    return typeof c2 === "string" && /[0-9A-Fa-f]/.test(c2);
                }
            };
            var source;
            var parseState;
            var stack;
            var pos;
            var line;
            var column;
            var token;
            var key;
            var root;
            var parse = function parse2(text, reviver) {
                source = String(text);
                parseState = "start";
                stack = [];
                pos = 0;
                line = 1;
                column = 0;
                token = void 0;
                key = void 0;
                root = void 0;
                do {
                    token = lex();
                    parseStates[parseState]();
                }while (token.type !== "eof");
                if (typeof reviver === "function") return internalize({
                    "": root
                }, "", reviver);
                return root;
            };
            function internalize(holder, name, reviver) {
                var value = holder[name];
                if (value != null && typeof value === "object") {
                    if (Array.isArray(value)) for(var i = 0; i < value.length; i++){
                        var key2 = String(i);
                        var replacement = internalize(value, key2, reviver);
                        if (replacement === void 0) delete value[key2];
                        else Object.defineProperty(value, key2, {
                            value: replacement,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        });
                    }
                    else for(var key$1 in value){
                        var replacement$1 = internalize(value, key$1, reviver);
                        if (replacement$1 === void 0) delete value[key$1];
                        else Object.defineProperty(value, key$1, {
                            value: replacement$1,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        });
                    }
                }
                return reviver.call(holder, name, value);
            }
            var lexState;
            var buffer;
            var doubleQuote;
            var sign;
            var c;
            function lex() {
                lexState = "default";
                buffer = "";
                doubleQuote = false;
                sign = 1;
                for(;;){
                    c = peek();
                    var token2 = lexStates[lexState]();
                    if (token2) return token2;
                }
            }
            function peek() {
                if (source[pos]) return String.fromCodePoint(source.codePointAt(pos));
            }
            function read() {
                var c2 = peek();
                if (c2 === "\n") {
                    line++;
                    column = 0;
                } else if (c2) column += c2.length;
                else column++;
                if (c2) pos += c2.length;
                return c2;
            }
            var lexStates = {
                default: function default$1() {
                    switch(c){
                        case "	":
                        case "\v":
                        case "\f":
                        case " ":
                        case "\xA0":
                        case "\uFEFF":
                        case "\n":
                        case "\r":
                        case "\u2028":
                        case "\u2029":
                            read();
                            return;
                        case "/":
                            read();
                            lexState = "comment";
                            return;
                        case void 0:
                            read();
                            return newToken("eof");
                    }
                    if (util.isSpaceSeparator(c)) {
                        read();
                        return;
                    }
                    return lexStates[parseState]();
                },
                comment: function comment() {
                    switch(c){
                        case "*":
                            read();
                            lexState = "multiLineComment";
                            return;
                        case "/":
                            read();
                            lexState = "singleLineComment";
                            return;
                    }
                    throw invalidChar(read());
                },
                multiLineComment: function multiLineComment() {
                    switch(c){
                        case "*":
                            read();
                            lexState = "multiLineCommentAsterisk";
                            return;
                        case void 0:
                            throw invalidChar(read());
                    }
                    read();
                },
                multiLineCommentAsterisk: function multiLineCommentAsterisk() {
                    switch(c){
                        case "*":
                            read();
                            return;
                        case "/":
                            read();
                            lexState = "default";
                            return;
                        case void 0:
                            throw invalidChar(read());
                    }
                    read();
                    lexState = "multiLineComment";
                },
                singleLineComment: function singleLineComment() {
                    switch(c){
                        case "\n":
                        case "\r":
                        case "\u2028":
                        case "\u2029":
                            read();
                            lexState = "default";
                            return;
                        case void 0:
                            read();
                            return newToken("eof");
                    }
                    read();
                },
                value: function value() {
                    switch(c){
                        case "{":
                        case "[":
                            return newToken("punctuator", read());
                        case "n":
                            read();
                            literal("ull");
                            return newToken("null", null);
                        case "t":
                            read();
                            literal("rue");
                            return newToken("boolean", true);
                        case "f":
                            read();
                            literal("alse");
                            return newToken("boolean", false);
                        case "-":
                        case "+":
                            if (read() === "-") sign = -1;
                            lexState = "sign";
                            return;
                        case ".":
                            buffer = read();
                            lexState = "decimalPointLeading";
                            return;
                        case "0":
                            buffer = read();
                            lexState = "zero";
                            return;
                        case "1":
                        case "2":
                        case "3":
                        case "4":
                        case "5":
                        case "6":
                        case "7":
                        case "8":
                        case "9":
                            buffer = read();
                            lexState = "decimalInteger";
                            return;
                        case "I":
                            read();
                            literal("nfinity");
                            return newToken("numeric", Infinity);
                        case "N":
                            read();
                            literal("aN");
                            return newToken("numeric", NaN);
                        case '"':
                        case "'":
                            doubleQuote = read() === '"';
                            buffer = "";
                            lexState = "string";
                            return;
                    }
                    throw invalidChar(read());
                },
                identifierNameStartEscape: function identifierNameStartEscape() {
                    if (c !== "u") throw invalidChar(read());
                    read();
                    var u = unicodeEscape();
                    switch(u){
                        case "$":
                        case "_":
                            break;
                        default:
                            if (!util.isIdStartChar(u)) throw invalidIdentifier();
                            break;
                    }
                    buffer += u;
                    lexState = "identifierName";
                },
                identifierName: function identifierName() {
                    switch(c){
                        case "$":
                        case "_":
                        case "\u200C":
                        case "\u200D":
                            buffer += read();
                            return;
                        case "\\":
                            read();
                            lexState = "identifierNameEscape";
                            return;
                    }
                    if (util.isIdContinueChar(c)) {
                        buffer += read();
                        return;
                    }
                    return newToken("identifier", buffer);
                },
                identifierNameEscape: function identifierNameEscape() {
                    if (c !== "u") throw invalidChar(read());
                    read();
                    var u = unicodeEscape();
                    switch(u){
                        case "$":
                        case "_":
                        case "\u200C":
                        case "\u200D":
                            break;
                        default:
                            if (!util.isIdContinueChar(u)) throw invalidIdentifier();
                            break;
                    }
                    buffer += u;
                    lexState = "identifierName";
                },
                sign: function sign$1() {
                    switch(c){
                        case ".":
                            buffer = read();
                            lexState = "decimalPointLeading";
                            return;
                        case "0":
                            buffer = read();
                            lexState = "zero";
                            return;
                        case "1":
                        case "2":
                        case "3":
                        case "4":
                        case "5":
                        case "6":
                        case "7":
                        case "8":
                        case "9":
                            buffer = read();
                            lexState = "decimalInteger";
                            return;
                        case "I":
                            read();
                            literal("nfinity");
                            return newToken("numeric", sign * Infinity);
                        case "N":
                            read();
                            literal("aN");
                            return newToken("numeric", NaN);
                    }
                    throw invalidChar(read());
                },
                zero: function zero() {
                    switch(c){
                        case ".":
                            buffer += read();
                            lexState = "decimalPoint";
                            return;
                        case "e":
                        case "E":
                            buffer += read();
                            lexState = "decimalExponent";
                            return;
                        case "x":
                        case "X":
                            buffer += read();
                            lexState = "hexadecimal";
                            return;
                    }
                    return newToken("numeric", sign * 0);
                },
                decimalInteger: function decimalInteger() {
                    switch(c){
                        case ".":
                            buffer += read();
                            lexState = "decimalPoint";
                            return;
                        case "e":
                        case "E":
                            buffer += read();
                            lexState = "decimalExponent";
                            return;
                    }
                    if (util.isDigit(c)) {
                        buffer += read();
                        return;
                    }
                    return newToken("numeric", sign * Number(buffer));
                },
                decimalPointLeading: function decimalPointLeading() {
                    if (util.isDigit(c)) {
                        buffer += read();
                        lexState = "decimalFraction";
                        return;
                    }
                    throw invalidChar(read());
                },
                decimalPoint: function decimalPoint() {
                    switch(c){
                        case "e":
                        case "E":
                            buffer += read();
                            lexState = "decimalExponent";
                            return;
                    }
                    if (util.isDigit(c)) {
                        buffer += read();
                        lexState = "decimalFraction";
                        return;
                    }
                    return newToken("numeric", sign * Number(buffer));
                },
                decimalFraction: function decimalFraction() {
                    switch(c){
                        case "e":
                        case "E":
                            buffer += read();
                            lexState = "decimalExponent";
                            return;
                    }
                    if (util.isDigit(c)) {
                        buffer += read();
                        return;
                    }
                    return newToken("numeric", sign * Number(buffer));
                },
                decimalExponent: function decimalExponent() {
                    switch(c){
                        case "+":
                        case "-":
                            buffer += read();
                            lexState = "decimalExponentSign";
                            return;
                    }
                    if (util.isDigit(c)) {
                        buffer += read();
                        lexState = "decimalExponentInteger";
                        return;
                    }
                    throw invalidChar(read());
                },
                decimalExponentSign: function decimalExponentSign() {
                    if (util.isDigit(c)) {
                        buffer += read();
                        lexState = "decimalExponentInteger";
                        return;
                    }
                    throw invalidChar(read());
                },
                decimalExponentInteger: function decimalExponentInteger() {
                    if (util.isDigit(c)) {
                        buffer += read();
                        return;
                    }
                    return newToken("numeric", sign * Number(buffer));
                },
                hexadecimal: function hexadecimal() {
                    if (util.isHexDigit(c)) {
                        buffer += read();
                        lexState = "hexadecimalInteger";
                        return;
                    }
                    throw invalidChar(read());
                },
                hexadecimalInteger: function hexadecimalInteger() {
                    if (util.isHexDigit(c)) {
                        buffer += read();
                        return;
                    }
                    return newToken("numeric", sign * Number(buffer));
                },
                string: function string() {
                    switch(c){
                        case "\\":
                            read();
                            buffer += escape();
                            return;
                        case '"':
                            if (doubleQuote) {
                                read();
                                return newToken("string", buffer);
                            }
                            buffer += read();
                            return;
                        case "'":
                            if (!doubleQuote) {
                                read();
                                return newToken("string", buffer);
                            }
                            buffer += read();
                            return;
                        case "\n":
                        case "\r":
                            throw invalidChar(read());
                        case "\u2028":
                        case "\u2029":
                            separatorChar(c);
                            break;
                        case void 0:
                            throw invalidChar(read());
                    }
                    buffer += read();
                },
                start: function start() {
                    switch(c){
                        case "{":
                        case "[":
                            return newToken("punctuator", read());
                    }
                    lexState = "value";
                },
                beforePropertyName: function beforePropertyName() {
                    switch(c){
                        case "$":
                        case "_":
                            buffer = read();
                            lexState = "identifierName";
                            return;
                        case "\\":
                            read();
                            lexState = "identifierNameStartEscape";
                            return;
                        case "}":
                            return newToken("punctuator", read());
                        case '"':
                        case "'":
                            doubleQuote = read() === '"';
                            lexState = "string";
                            return;
                    }
                    if (util.isIdStartChar(c)) {
                        buffer += read();
                        lexState = "identifierName";
                        return;
                    }
                    throw invalidChar(read());
                },
                afterPropertyName: function afterPropertyName() {
                    if (c === ":") return newToken("punctuator", read());
                    throw invalidChar(read());
                },
                beforePropertyValue: function beforePropertyValue() {
                    lexState = "value";
                },
                afterPropertyValue: function afterPropertyValue() {
                    switch(c){
                        case ",":
                        case "}":
                            return newToken("punctuator", read());
                    }
                    throw invalidChar(read());
                },
                beforeArrayValue: function beforeArrayValue() {
                    if (c === "]") return newToken("punctuator", read());
                    lexState = "value";
                },
                afterArrayValue: function afterArrayValue() {
                    switch(c){
                        case ",":
                        case "]":
                            return newToken("punctuator", read());
                    }
                    throw invalidChar(read());
                },
                end: function end() {
                    throw invalidChar(read());
                }
            };
            function newToken(type, value) {
                return {
                    type: type,
                    value: value,
                    line: line,
                    column: column
                };
            }
            function literal(s) {
                for(var i = 0, list = s; i < list.length; i += 1){
                    var c2 = list[i];
                    var p = peek();
                    if (p !== c2) throw invalidChar(read());
                    read();
                }
            }
            function escape() {
                var c2 = peek();
                switch(c2){
                    case "b":
                        read();
                        return "\b";
                    case "f":
                        read();
                        return "\f";
                    case "n":
                        read();
                        return "\n";
                    case "r":
                        read();
                        return "\r";
                    case "t":
                        read();
                        return "	";
                    case "v":
                        read();
                        return "\v";
                    case "0":
                        read();
                        if (util.isDigit(peek())) throw invalidChar(read());
                        return "\0";
                    case "x":
                        read();
                        return hexEscape();
                    case "u":
                        read();
                        return unicodeEscape();
                    case "\n":
                    case "\u2028":
                    case "\u2029":
                        read();
                        return "";
                    case "\r":
                        read();
                        if (peek() === "\n") read();
                        return "";
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        throw invalidChar(read());
                    case void 0:
                        throw invalidChar(read());
                }
                return read();
            }
            function hexEscape() {
                var buffer2 = "";
                var c2 = peek();
                if (!util.isHexDigit(c2)) throw invalidChar(read());
                buffer2 += read();
                c2 = peek();
                if (!util.isHexDigit(c2)) throw invalidChar(read());
                buffer2 += read();
                return String.fromCodePoint(parseInt(buffer2, 16));
            }
            function unicodeEscape() {
                var buffer2 = "";
                var count = 4;
                while(count-- > 0){
                    var c2 = peek();
                    if (!util.isHexDigit(c2)) throw invalidChar(read());
                    buffer2 += read();
                }
                return String.fromCodePoint(parseInt(buffer2, 16));
            }
            var parseStates = {
                start: function start() {
                    if (token.type === "eof") throw invalidEOF();
                    push();
                },
                beforePropertyName: function beforePropertyName() {
                    switch(token.type){
                        case "identifier":
                        case "string":
                            key = token.value;
                            parseState = "afterPropertyName";
                            return;
                        case "punctuator":
                            pop();
                            return;
                        case "eof":
                            throw invalidEOF();
                    }
                },
                afterPropertyName: function afterPropertyName() {
                    if (token.type === "eof") throw invalidEOF();
                    parseState = "beforePropertyValue";
                },
                beforePropertyValue: function beforePropertyValue() {
                    if (token.type === "eof") throw invalidEOF();
                    push();
                },
                beforeArrayValue: function beforeArrayValue() {
                    if (token.type === "eof") throw invalidEOF();
                    if (token.type === "punctuator" && token.value === "]") {
                        pop();
                        return;
                    }
                    push();
                },
                afterPropertyValue: function afterPropertyValue() {
                    if (token.type === "eof") throw invalidEOF();
                    switch(token.value){
                        case ",":
                            parseState = "beforePropertyName";
                            return;
                        case "}":
                            pop();
                    }
                },
                afterArrayValue: function afterArrayValue() {
                    if (token.type === "eof") throw invalidEOF();
                    switch(token.value){
                        case ",":
                            parseState = "beforeArrayValue";
                            return;
                        case "]":
                            pop();
                    }
                },
                end: function end() {}
            };
            function push() {
                var value;
                switch(token.type){
                    case "punctuator":
                        switch(token.value){
                            case "{":
                                value = {};
                                break;
                            case "[":
                                value = [];
                                break;
                        }
                        break;
                    case "null":
                    case "boolean":
                    case "numeric":
                    case "string":
                        value = token.value;
                        break;
                }
                if (root === void 0) root = value;
                else {
                    var parent = stack[stack.length - 1];
                    if (Array.isArray(parent)) parent.push(value);
                    else Object.defineProperty(parent, key, {
                        value: value,
                        writable: true,
                        enumerable: true,
                        configurable: true
                    });
                }
                if (value !== null && typeof value === "object") {
                    stack.push(value);
                    if (Array.isArray(value)) parseState = "beforeArrayValue";
                    else parseState = "beforePropertyName";
                } else {
                    var current = stack[stack.length - 1];
                    if (current == null) parseState = "end";
                    else if (Array.isArray(current)) parseState = "afterArrayValue";
                    else parseState = "afterPropertyValue";
                }
            }
            function pop() {
                stack.pop();
                var current = stack[stack.length - 1];
                if (current == null) parseState = "end";
                else if (Array.isArray(current)) parseState = "afterArrayValue";
                else parseState = "afterPropertyValue";
            }
            function invalidChar(c2) {
                if (c2 === void 0) return syntaxError("JSON5: invalid end of input at " + line + ":" + column);
                return syntaxError("JSON5: invalid character '" + formatChar(c2) + "' at " + line + ":" + column);
            }
            function invalidEOF() {
                return syntaxError("JSON5: invalid end of input at " + line + ":" + column);
            }
            function invalidIdentifier() {
                column -= 5;
                return syntaxError("JSON5: invalid identifier character at " + line + ":" + column);
            }
            function separatorChar(c2) {
                console.warn("JSON5: '" + formatChar(c2) + "' in strings is not valid ECMAScript; consider escaping");
            }
            function formatChar(c2) {
                var replacements = {
                    "'": "\\'",
                    '"': '\\"',
                    "\\": "\\\\",
                    "\b": "\\b",
                    "\f": "\\f",
                    "\n": "\\n",
                    "\r": "\\r",
                    "	": "\\t",
                    "\v": "\\v",
                    "\0": "\\0",
                    "\u2028": "\\u2028",
                    "\u2029": "\\u2029"
                };
                if (replacements[c2]) return replacements[c2];
                if (c2 < " ") {
                    var hexString = c2.charCodeAt(0).toString(16);
                    return "\\x" + ("00" + hexString).substring(hexString.length);
                }
                return c2;
            }
            function syntaxError(message) {
                var err = new SyntaxError(message);
                err.lineNumber = line;
                err.columnNumber = column;
                return err;
            }
            var stringify = function stringify2(value, replacer, space) {
                var stack2 = [];
                var indent = "";
                var propertyList;
                var replacerFunc;
                var gap = "";
                var quote;
                if (replacer != null && typeof replacer === "object" && !Array.isArray(replacer)) {
                    space = replacer.space;
                    quote = replacer.quote;
                    replacer = replacer.replacer;
                }
                if (typeof replacer === "function") replacerFunc = replacer;
                else if (Array.isArray(replacer)) {
                    propertyList = [];
                    for(var i = 0, list = replacer; i < list.length; i += 1){
                        var v = list[i];
                        var item = void 0;
                        if (typeof v === "string") item = v;
                        else if (typeof v === "number" || v instanceof String || v instanceof Number) item = String(v);
                        if (item !== void 0 && propertyList.indexOf(item) < 0) propertyList.push(item);
                    }
                }
                if (space instanceof Number) space = Number(space);
                else if (space instanceof String) space = String(space);
                if (typeof space === "number") {
                    if (space > 0) {
                        space = Math.min(10, Math.floor(space));
                        gap = "          ".substr(0, space);
                    }
                } else if (typeof space === "string") gap = space.substr(0, 10);
                return serializeProperty("", {
                    "": value
                });
                function serializeProperty(key2, holder) {
                    var value2 = holder[key2];
                    if (value2 != null) {
                        if (typeof value2.toJSON5 === "function") value2 = value2.toJSON5(key2);
                        else if (typeof value2.toJSON === "function") value2 = value2.toJSON(key2);
                    }
                    if (replacerFunc) value2 = replacerFunc.call(holder, key2, value2);
                    if (value2 instanceof Number) value2 = Number(value2);
                    else if (value2 instanceof String) value2 = String(value2);
                    else if (value2 instanceof Boolean) value2 = value2.valueOf();
                    switch(value2){
                        case null:
                            return "null";
                        case true:
                            return "true";
                        case false:
                            return "false";
                    }
                    if (typeof value2 === "string") return quoteString(value2, false);
                    if (typeof value2 === "number") return String(value2);
                    if (typeof value2 === "object") return Array.isArray(value2) ? serializeArray(value2) : serializeObject(value2);
                    return void 0;
                }
                function quoteString(value2) {
                    var quotes = {
                        "'": 0.1,
                        '"': 0.2
                    };
                    var replacements = {
                        "'": "\\'",
                        '"': '\\"',
                        "\\": "\\\\",
                        "\b": "\\b",
                        "\f": "\\f",
                        "\n": "\\n",
                        "\r": "\\r",
                        "	": "\\t",
                        "\v": "\\v",
                        "\0": "\\0",
                        "\u2028": "\\u2028",
                        "\u2029": "\\u2029"
                    };
                    var product = "";
                    for(var i2 = 0; i2 < value2.length; i2++){
                        var c2 = value2[i2];
                        switch(c2){
                            case "'":
                            case '"':
                                quotes[c2]++;
                                product += c2;
                                continue;
                            case "\0":
                                if (util.isDigit(value2[i2 + 1])) {
                                    product += "\\x00";
                                    continue;
                                }
                        }
                        if (replacements[c2]) {
                            product += replacements[c2];
                            continue;
                        }
                        if (c2 < " ") {
                            var hexString = c2.charCodeAt(0).toString(16);
                            product += "\\x" + ("00" + hexString).substring(hexString.length);
                            continue;
                        }
                        product += c2;
                    }
                    var quoteChar = quote || Object.keys(quotes).reduce(function(a, b) {
                        return quotes[a] < quotes[b] ? a : b;
                    });
                    product = product.replace(new RegExp(quoteChar, "g"), replacements[quoteChar]);
                    return quoteChar + product + quoteChar;
                }
                function serializeObject(value2) {
                    if (stack2.indexOf(value2) >= 0) throw TypeError("Converting circular structure to JSON5");
                    stack2.push(value2);
                    var stepback = indent;
                    indent = indent + gap;
                    var keys = propertyList || Object.keys(value2);
                    var partial = [];
                    for(var i2 = 0, list2 = keys; i2 < list2.length; i2 += 1){
                        var key2 = list2[i2];
                        var propertyString = serializeProperty(key2, value2);
                        if (propertyString !== void 0) {
                            var member = serializeKey(key2) + ":";
                            if (gap !== "") member += " ";
                            member += propertyString;
                            partial.push(member);
                        }
                    }
                    var final;
                    if (partial.length === 0) final = "{}";
                    else {
                        var properties;
                        if (gap === "") {
                            properties = partial.join(",");
                            final = "{" + properties + "}";
                        } else {
                            var separator = ",\n" + indent;
                            properties = partial.join(separator);
                            final = "{\n" + indent + properties + ",\n" + stepback + "}";
                        }
                    }
                    stack2.pop();
                    indent = stepback;
                    return final;
                }
                function serializeKey(key2) {
                    if (key2.length === 0) return quoteString(key2, true);
                    var firstChar = String.fromCodePoint(key2.codePointAt(0));
                    if (!util.isIdStartChar(firstChar)) return quoteString(key2, true);
                    for(var i2 = firstChar.length; i2 < key2.length; i2++){
                        if (!util.isIdContinueChar(String.fromCodePoint(key2.codePointAt(i2)))) return quoteString(key2, true);
                    }
                    return key2;
                }
                function serializeArray(value2) {
                    if (stack2.indexOf(value2) >= 0) throw TypeError("Converting circular structure to JSON5");
                    stack2.push(value2);
                    var stepback = indent;
                    indent = indent + gap;
                    var partial = [];
                    for(var i2 = 0; i2 < value2.length; i2++){
                        var propertyString = serializeProperty(String(i2), value2);
                        partial.push(propertyString !== void 0 ? propertyString : "null");
                    }
                    var final;
                    if (partial.length === 0) final = "[]";
                    else if (gap === "") {
                        var properties = partial.join(",");
                        final = "[" + properties + "]";
                    } else {
                        var separator = ",\n" + indent;
                        var properties$1 = partial.join(separator);
                        final = "[\n" + indent + properties$1 + ",\n" + stepback + "]";
                    }
                    stack2.pop();
                    indent = stepback;
                    return final;
                }
            };
            var JSON53 = {
                parse: parse,
                stringify: stringify
            };
            var lib = JSON53;
            var es5 = lib;
            return es5;
        });
    }
});
// src/dom/index.ts
var $5d8ef0ef429bc174$export$7d9e4051addf5b8d = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($5d8ef0ef429bc174$export$7d9e4051addf5b8d, {
    CanvasHelper: ()=>(0, $322275c897c4eafb$export$2b23415a8d830e94),
    DataDisplay: ()=>$5d8ef0ef429bc174$export$d5b77ddba114bfb8,
    DataTable: ()=>$5d8ef0ef429bc174$export$8a8e617cd83ed7e0,
    DragDrop: ()=>$5d8ef0ef429bc174$export$a6543eeb31c15f7f,
    ElementSizer: ()=>(0, $4a5be75452a35244$export$6fdaa4e99cd13524),
    Forms: ()=>(0, $369e8ba1b60a36f8$export$a2b919e21942588e),
    Rx: ()=>(0, $4a5be75452a35244$export$c9e4cf6f54a27e2b),
    Variables: ()=>$5d8ef0ef429bc174$export$3396301f4724b73c,
    byId: ()=>$5d8ef0ef429bc174$export$a1920133d5b0a75,
    cardinalPosition: ()=>$5d8ef0ef429bc174$export$f85c81e643478ca6,
    clear: ()=>$5d8ef0ef429bc174$export$42ffd38884aecdac,
    copyToClipboard: ()=>$5d8ef0ef429bc174$export$2cdf1b96a9f86d16,
    createAfter: ()=>$5d8ef0ef429bc174$export$9195f9e85a065d03,
    createIn: ()=>$5d8ef0ef429bc174$export$813161d69b531ae3,
    cycleCssClass: ()=>$5d8ef0ef429bc174$export$d89e377b3634a0e7,
    defaultErrorHandler: ()=>$5d8ef0ef429bc174$export$74226d5f34b9550e,
    el: ()=>$5d8ef0ef429bc174$export$c3da0dad1b44eea9,
    elRequery: ()=>$5d8ef0ef429bc174$export$1381dff7908b2f14,
    getBoundingClientRectWithBorder: ()=>(0, $4a5be75452a35244$export$669a099a3b547e4c),
    getComputedPixels: ()=>(0, $4a5be75452a35244$export$4bb1175ba8ebc78e),
    getTranslation: ()=>$5d8ef0ef429bc174$export$202e99f82f7f0395,
    inlineConsole: ()=>$5d8ef0ef429bc174$export$52841fb2b083e16,
    insertSorted: ()=>$5d8ef0ef429bc174$export$553682d44e5ecabb,
    log: ()=>$5d8ef0ef429bc174$export$bef1f36f5486a6a3,
    pointScaler: ()=>$5d8ef0ef429bc174$export$fe4944cdf69e425b,
    pointerVisualise: ()=>$5d8ef0ef429bc174$export$b39273c2e98cc766,
    positionFn: ()=>$5d8ef0ef429bc174$export$7d3a82dc3474e386,
    positionFromMiddle: ()=>$5d8ef0ef429bc174$export$cfefb408082ab9e6,
    positionRelative: ()=>$5d8ef0ef429bc174$export$fc51f1cf90283cd4,
    query: ()=>$5d8ef0ef429bc174$export$2fa187e846a241c4,
    reconcileChildren: ()=>$5d8ef0ef429bc174$export$46bb9d4f23154749,
    resolveEl: ()=>(0, $35a128b42d0e06cd$export$5c3b1267168ecce4),
    resolveElementTry: ()=>(0, $35a128b42d0e06cd$export$832ddfb93b3cb5a2),
    resolveEls: ()=>(0, $35a128b42d0e06cd$export$7c36a5fc73d4a4d3),
    setCssClass: ()=>(0, $4a5be75452a35244$export$1c335df6f02320a1),
    setCssDisplay: ()=>(0, $4a5be75452a35244$export$62945816622b86ea),
    setCssToggle: ()=>(0, $4a5be75452a35244$export$322e3051a79d2f31),
    setHtml: ()=>(0, $2edc1eef02a7c199$export$e9d3191caab19f4d),
    setProperty: ()=>(0, $2edc1eef02a7c199$export$a41c68a4eb5ff164),
    setText: ()=>(0, $2edc1eef02a7c199$export$cbe0d99836e1498f),
    tabSet: ()=>$5d8ef0ef429bc174$export$5e092a6a5325a8e4,
    viewportToSpace: ()=>$5d8ef0ef429bc174$export$c897787a1271b581
});
// src/dom/CssVariables.ts
var $5d8ef0ef429bc174$export$3396301f4724b73c = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($5d8ef0ef429bc174$export$3396301f4724b73c, {
    getFromStyles: ()=>$5d8ef0ef429bc174$var$getFromStyles,
    getWithFallback: ()=>$5d8ef0ef429bc174$var$getWithFallback,
    parseAsAttributes: ()=>$5d8ef0ef429bc174$var$parseAsAttributes,
    setFromVariables: ()=>$5d8ef0ef429bc174$var$setFromVariables,
    setVariables: ()=>$5d8ef0ef429bc174$var$setVariables
});
// src/dom/TsUtil.ts
function $5d8ef0ef429bc174$var$isHtmlElement(o) {
    return typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
    o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
}
// src/dom/CssVariables.ts
var $5d8ef0ef429bc174$var$parseAsAttributes = (options)=>{
    return options.map((opt)=>{
        let defaultValue;
        if (Array.isArray(opt)) {
            defaultValue = opt[1];
            opt = opt[0];
        }
        const dash = opt.indexOf(`-`);
        if (dash < 0) throw new Error(`Simple expression expects form of: 'elementid-attribute'`);
        return {
            variable: opt,
            attribute: opt.slice(dash + 1),
            id: opt.slice(0, dash),
            defaultValue: defaultValue
        };
    });
};
var $5d8ef0ef429bc174$var$setFromVariables = (context, ...options)=>{
    const contextEl = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(context);
    const style = window.getComputedStyle(contextEl);
    for (const opt of options){
        const variable = (0, $ae8f83c19bfd8110$export$ece7822811de3aeb)(opt.variable, `--`);
        let v = style.getPropertyValue(`--${variable}`);
        if (v === null || v.length === 0) {
            if (opt.defaultValue === void 0) continue;
            else v = opt.defaultValue;
        }
        let query2;
        let els;
        if (`query` in opt && opt.query !== void 0) query2 = opt.query;
        else if (`id` in opt && opt.id !== void 0) query2 = `#${opt.id}`;
        else if (`object` in opt && opt.object !== void 0) els = Array.isArray(opt.object) ? opt.object : [
            opt.object
        ];
        if (query2 === void 0) {
            if (els === void 0) throw new Error(`Missing 'query', 'id' or 'object' fields`);
        } else els = [
            ...contextEl.querySelectorAll(query2)
        ];
        if (els === null) continue;
        if (els === void 0) continue;
        if (opt.attribute) for (const el2 of els){
            if ($5d8ef0ef429bc174$var$isHtmlElement(el2)) el2.setAttribute(opt.attribute, v);
            else throw new Error(`Trying to set an attribute on something not a HTML element`, el2);
        }
        else if (opt.field) for (const el2 of els){
            if (typeof el2 === `object`) el2[opt.field] = v;
            else throw new Error(`Trying to set field on something that is not an object (${typeof el2})`, el2);
        }
        else throw new Error(`Neither 'attribute' or 'field' to set is defined in option (${JSON.stringify(opt)})`);
    }
};
function $5d8ef0ef429bc174$var$getWithFallback(fallback, elt) {
    const styles = getComputedStyle(elt ?? document.body);
    const entries = Object.entries(fallback);
    const filledEntries = entries.map((entry)=>{
        return [
            entry[0],
            $5d8ef0ef429bc174$var$getFromStyles(styles, entry[0], entry[1])
        ];
    });
    return Object.fromEntries(filledEntries);
}
function $5d8ef0ef429bc174$var$setVariables(variables, stylesOrEl) {
    const styles = stylesOrEl === void 0 ? document.body.style : $5d8ef0ef429bc174$var$isHtmlElement(stylesOrEl) ? stylesOrEl.style : stylesOrEl;
    for (const [key, value] of Object.entries(variables)){
        let variableName = key.replaceAll("_", "-");
        if (!variableName.startsWith(`--`)) variableName = `--` + variableName;
        styles.setProperty(variableName, value.toString());
    }
}
function $5d8ef0ef429bc174$var$getFromStyles(styles, name, fallback) {
    if (!name.startsWith(`--`)) name = `--` + name;
    name = name.replaceAll(`_`, `-`);
    const v = styles.getPropertyValue(name);
    if (v.length === 0) return fallback;
    if (typeof fallback === `number`) return parseFloat(v);
    if (typeof fallback === `boolean`) {
        if (v === `true`) return true;
        else if (v === `false`) return false;
    }
    return v;
}
// src/dom/DataTable.ts
var $5d8ef0ef429bc174$export$8a8e617cd83ed7e0 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($5d8ef0ef429bc174$export$8a8e617cd83ed7e0, {
    fromList: ()=>$5d8ef0ef429bc174$var$fromList,
    fromObject: ()=>$5d8ef0ef429bc174$var$fromObject
});
var $5d8ef0ef429bc174$var$import_json5 = (0, $f81dde33861c7f4f$export$82dec27a9dce9602)($5d8ef0ef429bc174$var$require_dist(), 1);
var $5d8ef0ef429bc174$var$padding = (v, options)=>{
    if (options.leftPadding) {
        if (v.length < options.leftPadding) return "&nbsp;".repeat(options.leftPadding - v.length) + v;
    }
    return v;
};
var $5d8ef0ef429bc174$var$convertNumber = (v, o)=>{
    v = o.roundNumbers !== void 0 ? (0, $42f472314cb088f7$export$2077e0241d6afd3c)(o.roundNumbers, v) : v;
    let asStr = o.precision !== void 0 ? v.toFixed(o.precision) : v.toString();
    asStr = $5d8ef0ef429bc174$var$padding(asStr.toString(), o);
    return asStr;
};
var $5d8ef0ef429bc174$var$toHtmlSimple = (v, options)=>{
    if (v === null) return `(null)`;
    if (v === void 0) return `(undefined)`;
    if (typeof v === `boolean`) return v ? `true` : `false`;
    if (typeof v === `string`) return `"${v}"`;
    if (typeof v === `number`) return $5d8ef0ef429bc174$var$convertNumber(v, options.numbers);
    if (typeof v === `object`) return $5d8ef0ef429bc174$var$toTableSimple(v, options);
    return $5d8ef0ef429bc174$var$import_json5.default.stringify(v);
};
var $5d8ef0ef429bc174$var$toTableSimple = (v, options)=>{
    let html = `<div style="display:grid; grid-template-columns: repeat(2, 1fr)">`;
    for (const entry of Object.entries(v)){
        const value = $5d8ef0ef429bc174$var$toHtmlSimple(entry[1], options);
        html += `<div class="label" style="display:table-cell">${entry[0]}</div>
      <div class="data" style="display:table-cell">${value}</div>`;
    }
    html += `</div>`;
    return html;
};
var $5d8ef0ef429bc174$var$fromList = (parentOrQuery, data)=>{
    const parent = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(parentOrQuery);
    let container = document.createElement(`DIV`);
    parent.append(container);
    const options = {
        numbers: {},
        objectsAsTables: true
    };
    const remove = ()=>{
        if (!container) return false;
        container.remove();
        container = void 0;
        return true;
    };
    const update = (data2)=>{
        const seenTables = /* @__PURE__ */ new Set();
        for (const [key, value] of data2){
            const tKey = `table-${key}`;
            seenTables.add(tKey);
            let t = parent.querySelector(`#${tKey}`);
            if (t === null) {
                t = document.createElement(`table`);
                if (!t) throw new Error(`Could not create table element`);
                t.id = tKey;
                parent.append(t);
            }
            $5d8ef0ef429bc174$var$updateElement(t, value, options);
        }
        const tables = Array.from(parent.querySelectorAll(`table`));
        for (const t of tables)if (!seenTables.has(t.id)) t.remove();
    };
    if (data) update(data);
    return {
        update: update,
        remove: remove
    };
};
var $5d8ef0ef429bc174$var$updateElement = (t, data, options)=>{
    const numberFormatting = options.numbers ?? {};
    const idPrefix = options.idPrefix ?? ``;
    const objectsAsTables = options.objectsAsTables ?? false;
    if (data === void 0) {
        t.innerHTML = ``;
        return;
    }
    const seenRows = /* @__PURE__ */ new Set();
    for (const [key, value] of Object.entries(data)){
        const domKey = `${idPrefix}-row-${key}`;
        seenRows.add(domKey);
        let rowEl = t.querySelector(`tr[data-key='${domKey}']`);
        if (rowEl === null) {
            rowEl = document.createElement(`tr`);
            t.append(rowEl);
            rowEl.setAttribute(`data-key`, domKey);
            const keyEl = document.createElement(`td`);
            keyEl.textContent = key;
            keyEl.classList.add(`label`);
            rowEl.append(keyEl);
        }
        let valEl = rowEl.querySelector(`td[data-key='${domKey}-val']`);
        if (valEl === null) {
            valEl = document.createElement(`td`);
            valEl.classList.add(`data`);
            valEl.setAttribute(`data-key`, `${domKey}-val`);
            rowEl.append(valEl);
        }
        let valueHTML;
        if (options.formatter) valueHTML = options.formatter(value, key);
        if (valueHTML === void 0) {
            if (typeof value === `object`) valueHTML = objectsAsTables ? $5d8ef0ef429bc174$var$toTableSimple(value, options) : $5d8ef0ef429bc174$var$import_json5.default.stringify(value);
            else if (typeof value === `number`) valueHTML = $5d8ef0ef429bc174$var$convertNumber(value, numberFormatting);
            else if (typeof value === `boolean`) valueHTML = value ? `true` : `false`;
            else if (typeof value === `string`) valueHTML = `"${value}"`;
            else valueHTML = JSON.stringify(value);
        }
        valEl.innerHTML = valueHTML;
    }
    const rows = Array.from(t.querySelectorAll(`tr`));
    for (const r of rows){
        const key = r.getAttribute(`data-key`);
        if (!seenRows.has(key)) r.remove();
    }
};
var $5d8ef0ef429bc174$var$fromObject = (parentOrQuery, data, opts = {})=>{
    const parent = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(parentOrQuery);
    const idPrefix = opts?.idPrefix ?? Math.floor(Math.random() * 1e3).toString();
    const options = {
        numbers: {},
        objectsAsTables: true,
        idPrefix: ``,
        ...opts
    };
    let t = document.createElement(`table`);
    parent.append(t);
    const remove = ()=>{
        if (!t) return false;
        t.remove();
        t = void 0;
        return true;
    };
    if (data) $5d8ef0ef429bc174$var$updateElement(t, data, options);
    const update = (d)=>{
        if (!t) throw new Error(`Table disposed`);
        $5d8ef0ef429bc174$var$updateElement(t, d, {
            ...options,
            idPrefix: idPrefix
        });
    };
    return {
        remove: remove,
        update: update
    };
};
// src/dom/DataDisplay.ts
var $5d8ef0ef429bc174$export$d5b77ddba114bfb8 = class {
    /**
   * Constructor
   * @param options Options
   */ constructor(options = {}){
        const theme = options.theme ?? `dark`;
        const existing = document.querySelector(`#ixfx-data-display`);
        if (existing !== null) throw new Error(`DataDisplay already loaded on this page`);
        const container = document.createElement(`div`);
        container.id = `ixfx-data-display`;
        container.classList.add(`theme-${theme}`);
        const css = document.createElement(`style`);
        css.textContent = `
    #ixfx-data-display {
      background: white;
      color: black;
      border: 2px solid hsl(0deg 0.61% 90%);
      border-radius: 4px;
      z-index: 1000;
      opacity: 40%;
      padding: 1em;
      font-family: monospace;
      position: fixed;
      right: 1em;
      top: 1em;
    }
    #ixfx-data-display.theme-dark {
      background: black;
      color: white;
      border: 2px solid hsl(0deg 0.61% 10%);
    }
    #ixfx-data-display:hover {
      opacity: 100%;
    }
    #ixfx-data-display table {
      border-collapse: collapse;
    }
    #ixfx-data-display tr:not(:last-child) {
      border-bottom: 2px solid hsl(0deg 0.61% 90%);
    }
    #ixfx-data-display.dark tr:not(:last-child) {
      border-bottom: 2px solid hsl(0deg 0.61% 10%);
    }
    #ixfx-data-display td {
      padding-bottom: 0.4em;
      padding-top: 0.4em;
    }
    #ixfx-data-display .label {
      color: hsl(0deg 0.61% 60%);
      text-align: right;
      padding-right: 0.5em;
    }
    #ixfx-data-display.theme-dark .label {
      color: gray;
    }
    `;
        container.style.display = `inline-block`;
        document.body.append(css);
        document.body.append(container);
        this.dataTable = $5d8ef0ef429bc174$var$fromObject(container, void 0, {
            objectsAsTables: true,
            ...options
        });
    }
    update(data) {
        this.dataTable.update(data);
    }
};
// src/dom/DragDrop.ts
var $5d8ef0ef429bc174$export$a6543eeb31c15f7f = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($5d8ef0ef429bc174$export$a6543eeb31c15f7f, {
    draggable: ()=>$5d8ef0ef429bc174$var$draggable
});
var $5d8ef0ef429bc174$var$draggable = (elemOrQuery, listener, options = {})=>{
    const elem = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elemOrQuery);
    let initialPointerPosition = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Placeholder;
    let token;
    const autoTranslate = options.autoTranslate ?? false;
    const quickDrag = options.quickDrag ?? false;
    const fence = options.fence ? (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(options.fence) : void 0;
    const fenceViewport = options.fenceViewport;
    let fenceOffset = (0, $da7bbf79b162d05c$export$40726222f7ec099b).PlaceholderPositioned;
    const relativePosition = window.getComputedStyle(elem).position === `relative`;
    const onParentClick = ()=>{
        const selected = elem.classList.contains(`drag-sel`);
        if (selected) elem.classList.remove(`drag-sel`);
    };
    const onElementClick = (event)=>{
        const selected = elem.classList.contains(`drag-sel`);
        if (selected) elem.classList.remove(`drag-sel`);
        else elem.classList.add(`drag-sel`);
        event.stopPropagation();
    };
    elem.ownerDocument.addEventListener(`click`, onParentClick);
    elem.addEventListener(`click`, onElementClick);
    const dragCleanup = ()=>{
        elem.classList.remove(`drag-progress`);
        elem.ownerDocument.removeEventListener(`pointermove`, onPointerMove);
        elem.ownerDocument.removeEventListener(`pointerup`, onPointerUp);
        elem.ownerDocument.removeEventListener(`pointercancel`, onDragCancel);
    };
    const dispose = ()=>{
        if (elem.classList.contains(`drag-progress`)) onDragCancel(void 0, `dispose`);
        else dragCleanup();
        elem.ownerDocument.removeEventListener(`click`, onParentClick);
        elem.removeEventListener(`click`, onElementClick);
    };
    const validateOffsetAndPoint = (offset, x, y)=>{
        if (!(0, $da7bbf79b162d05c$export$40726222f7ec099b).isPlaceholder(fenceOffset)) {
            offset = {
                x: (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(offset.x, fenceOffset.x, fenceOffset.width),
                y: (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(offset.y, fenceOffset.y, fenceOffset.height)
            };
            if (fenceViewport) {
                x = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(x, fenceViewport.x, fenceViewport.x + fenceViewport.width);
                y = (0, $ab835bc9d61bae68$export$7d15b64cf5a3a4c4)(y, fenceViewport.y, fenceViewport.y + fenceViewport.height);
            }
        }
        return [
            offset,
            {
                x: x,
                y: y
            }
        ];
    };
    let lastMoveOffset = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Empty;
    const onPointerMove = (moveEvent)=>{
        moveEvent.preventDefault();
        moveEvent.stopPropagation();
        let { x: x, y: y } = moveEvent;
        let offset = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).isPlaceholder(initialPointerPosition) ? {
            x: moveEvent.offsetX,
            y: moveEvent.offsetY
        } : {
            x: x - initialPointerPosition.x,
            y: y - initialPointerPosition.y
        };
        const r = validateOffsetAndPoint(offset, x, y);
        offset = r[0];
        const state = {
            delta: offset,
            initial: initialPointerPosition,
            token: token,
            viewport: r[1]
        };
        if (typeof listener.progress !== `undefined`) {
            const p = listener.progress(state);
            if (p.abort) return onDragCancel(void 0, `discontinued`);
            if (p.viewport) offset = {
                x: p.viewport.x - initialPointerPosition.x,
                y: p.viewport.y - initialPointerPosition.y
            };
        }
        lastMoveOffset = offset;
        if (autoTranslate) {
            let offsetX = offset.x;
            let offsetY = offset.y;
            elem.style.translate = `${offsetX}px ${offsetY}px`;
        }
    };
    const onPointerUp = (upEvent)=>{
        const bounds = elem.getBoundingClientRect();
        dragCleanup();
        let { x: x, y: y } = upEvent;
        const r = validateOffsetAndPoint(lastMoveOffset, x, y);
        const state = {
            initial: initialPointerPosition,
            token: token,
            delta: r[0],
            viewport: r[1]
        };
        if (autoTranslate) {
            elem.style.translate = `none`;
            if (relativePosition) {
                const parent = elem.parentElement?.getBoundingClientRect();
                elem.style.left = `${bounds.x - parent.left}px`;
                elem.style.top = `${bounds.y - parent.top}px`;
            } else {
                elem.style.left = `${bounds.x}px`;
                elem.style.top = `${bounds.y}px`;
            }
        }
        if (typeof listener.success !== `undefined`) listener.success(state);
    };
    const onDragCancel = (event, reason = `pointercancel`)=>{
        dragCleanup();
        let viewport = (0, $2edc1eef02a7c199$export$686cad0ec81705cb).Placeholder;
        if (event && `x` in event && `y` in event) viewport = {
            x: event.x,
            y: event.y
        };
        const state = {
            token: token,
            initial: initialPointerPosition,
            delta: {
                x: -1,
                y: -1
            },
            viewport: viewport
        };
        if (typeof listener.abort !== `undefined`) listener.abort(reason, state);
    };
    elem.addEventListener(`pointerdown`, (event)=>{
        const selected = elem.classList.contains(`drag-sel`);
        if (!selected && !quickDrag) return;
        const evt = event;
        initialPointerPosition = {
            x: evt.x,
            y: evt.y
        };
        const s = typeof listener.start === `undefined` ? {
            allow: true,
            token: token
        } : listener.start();
        if (!s.allow) return;
        token = s.token;
        if (fence) {
            const fenceBounds = fence.getBoundingClientRect();
            fenceOffset = {
                x: fenceBounds.x - initialPointerPosition.x,
                y: fenceBounds.y - initialPointerPosition.y,
                width: fenceBounds.x + fenceBounds.width - initialPointerPosition.x,
                height: fenceBounds.y + fenceBounds.height - initialPointerPosition.y
            };
        } else if (fenceViewport) fenceOffset = {
            x: fenceViewport.x - initialPointerPosition.x,
            y: fenceViewport.y - initialPointerPosition.y,
            width: fenceViewport.width + fenceViewport.x - initialPointerPosition.x,
            height: fenceViewport.height + fenceViewport.y - initialPointerPosition.y
        };
        elem.classList.add(`drag-progress`);
        elem.ownerDocument.addEventListener(`pointermove`, onPointerMove);
        elem.ownerDocument.addEventListener(`pointerup`, onPointerUp);
        elem.ownerDocument.addEventListener(`pointercancel`, onDragCancel);
    });
    return dispose;
};
// src/dom/El.ts
var $5d8ef0ef429bc174$export$c3da0dad1b44eea9 = (selectors)=>{
    const elements = (0, $35a128b42d0e06cd$export$7c36a5fc73d4a4d3)(selectors);
    const text = (0, $2edc1eef02a7c199$export$cbe0d99836e1498f)(elements);
    const html = (0, $2edc1eef02a7c199$export$e9d3191caab19f4d)(elements);
    return {
        text: text,
        html: html,
        cssDisplay: (value)=>{
            (0, $4a5be75452a35244$export$62945816622b86ea)(elements, value);
        },
        cssClass: (value, cssClass)=>{
            (0, $4a5be75452a35244$export$1c335df6f02320a1)(elements, value, cssClass);
        },
        cssToggle: (cssClass)=>{
            (0, $4a5be75452a35244$export$322e3051a79d2f31)(elements, cssClass);
        },
        el: ()=>elements[0],
        els: ()=>elements
    };
};
var $5d8ef0ef429bc174$export$1381dff7908b2f14 = (selectors)=>{};
// src/dom/ErrorHandler.ts
var $5d8ef0ef429bc174$export$74226d5f34b9550e = ()=>{
    let enabled = true;
    const container = document.createElement(`div`);
    container.style.color = `black`;
    container.style.border = `2px solid red`;
    container.style.backgroundColor = `hsl(0, 80%, 90%)`;
    container.style.padding = `1em`;
    container.style.display = `none`;
    container.style.top = `1em`;
    container.style.left = `1em`;
    container.style.position = `absolute`;
    container.style.fontFamily = `monospace`;
    const messageElement = document.createElement(`div`);
    messageElement.style.maxWidth = `50vw`;
    messageElement.style.maxHeight = `50vh`;
    messageElement.style.overflowY = `scroll`;
    container.innerHTML = `<h1>Error</h1>`;
    container.append(messageElement);
    const styleButton = (b)=>{
        b.style.padding = `0.3em`;
        b.style.marginTop = `1em`;
    };
    const buttonClose = document.createElement(`button`);
    buttonClose.textContent = `Close`;
    buttonClose.addEventListener(`click`, ()=>{
        hide();
    });
    const buttonStop = document.createElement(`button`);
    buttonStop.textContent = `Stop displaying errors`;
    buttonStop.addEventListener(`click`, ()=>{
        enabled = false;
        hide();
    });
    styleButton(buttonClose);
    styleButton(buttonStop);
    container.append(buttonClose);
    container.append(buttonStop);
    document.body.append(container);
    const show = (ex)=>{
        container.style.display = `inline`;
        messageElement.innerHTML += ex.stack ? `<pre>${ex.stack}</pre>` : `<p>${(0, $96302e292290d7c3$export$82f46aa4e6535a45)(ex)}</p>`;
    };
    const hide = ()=>{
        container.style.display = `none`;
    };
    window.onerror = (message, url, lineNo, colNo, error)=>{
        if (enabled) {
            if (error) {
                console.log(error);
                show(error);
            } else {
                console.log(message);
                show(message);
            }
        }
    };
    window.addEventListener(`unhandledrejection`, (event)=>{
        console.log(event.reason);
        if (enabled) show(event.reason);
    });
    return {
        show: show,
        hide: hide
    };
};
// src/dom/ShadowDom.ts
var $5d8ef0ef429bc174$var$addShadowCss = (parentEl, styles)=>{
    const styleEl = document.createElement(`style`);
    styleEl.textContent = styles;
    let shadowRoot;
    if (parentEl.shadowRoot) {
        shadowRoot = parentEl.shadowRoot;
        shadowRoot.innerHTML = ``;
    } else shadowRoot = parentEl.attachShadow({
        mode: `open`
    });
    shadowRoot.append(styleEl);
    return shadowRoot;
};
// src/dom/Log.ts
var $5d8ef0ef429bc174$export$bef1f36f5486a6a3 = (domQueryOrElement, opts = {})=>{
    const { capacity: capacity = 0, monospaced: monospaced = true, timestamp: timestamp = false, collapseDuplicates: collapseDuplicates = true, css: css = `` } = opts;
    let added = 0;
    let lastLog;
    let lastLogRepeats = 0;
    const parentElement = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domQueryOrElement);
    const fontFamily = monospaced ? `Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", Monaco, "Courier New", Courier, monospace` : `normal`;
    const shadowRoot = $5d8ef0ef429bc174$var$addShadowCss(parentElement, `
  .log {
    font-family: ${fontFamily};
    background-color: var(--code-background-color);
    padding: var(--padding1, 0.2em);
    overflow-y: auto;
    height:100%;
  }
  .timestamp {
    margin-right: 0.5em;
    opacity: 0.5;
    font-size: 70%;
    align-self: center;
  }
  .line {
    display: flex;
    padding-bottom: 0.1em;
    padding-top: 0.1em;
  }
  .line:hover {
  
  }
  .error {
    color: red;
  }
  .badge {
    border: 1px solid currentColor;
    align-self: center;
    font-size: 70%;
    padding-left: 0.2em;
    padding-right: 0.2em;
    border-radius: 1em;
    margin-left: 0.5em;
    margin-right: 0.5em;
  }
  .msg {
    flex: 1;
    word-break: break-word;
  }
  ${css}
  `);
    const el2 = document.createElement(`div`);
    el2.className = `log`;
    shadowRoot.append(el2);
    const error = (messageOrError)=>{
        const line = document.createElement(`div`);
        if (typeof messageOrError === `string`) line.innerHTML = messageOrError;
        else if (messageOrError instanceof Error) {
            const stack = messageOrError.stack;
            line.innerHTML = stack === void 0 ? messageOrError.toString() : stack.toString();
        } else line.innerHTML = messageOrError;
        line.classList.add(`error`);
        append(line);
        lastLog = void 0;
        lastLogRepeats = 0;
    };
    let lastLogTime = 0;
    const warn = (whatToLog = ``)=>{
        const element = log2(whatToLog);
        if (!element) return element;
        element.classList.add(`warning`);
        return element;
    };
    const log2 = (whatToLog = ``)=>{
        let message;
        const interval = window.performance.now() - lastLogTime;
        if (opts.minIntervalMs && interval < opts.minIntervalMs) return;
        lastLogTime = window.performance.now();
        if (typeof whatToLog === `object`) message = JSON.stringify(whatToLog);
        else if (whatToLog === void 0) message = `(undefined)`;
        else if (whatToLog === null) message = `(null)`;
        else if (typeof whatToLog === `number`) {
            if (Number.isNaN(message)) message = `(NaN)`;
            message = whatToLog.toString();
        } else message = whatToLog;
        if (message.length === 0) {
            const rule = document.createElement(`hr`);
            lastLog = void 0;
            append(rule);
        } else if (message === lastLog && collapseDuplicates) {
            const lastElement = el2.firstElementChild;
            let lastBadge = lastElement.querySelector(`.badge`);
            if (lastBadge === null) {
                lastBadge = document.createElement(`div`);
                lastBadge.className = `badge`;
                lastElement.insertAdjacentElement(`beforeend`, lastBadge);
            }
            if (lastElement !== null) lastBadge.textContent = (++lastLogRepeats).toString();
            return lastElement;
        } else {
            const line = document.createElement(`div`);
            line.textContent = message;
            append(line);
            lastLog = message;
            return line;
        }
    };
    const append = (line)=>{
        if (timestamp) {
            const wrapper = document.createElement(`div`);
            const timestamp2 = document.createElement(`div`);
            timestamp2.className = `timestamp`;
            timestamp2.textContent = /* @__PURE__ */ new Date().toLocaleTimeString();
            wrapper.append(timestamp2, line);
            line.classList.add(`msg`);
            wrapper.classList.add(`line`);
            line = wrapper;
        } else line.classList.add(`line`, `msg`);
        if (opts.reverse) el2.append(line);
        else el2.insertBefore(line, el2.firstChild);
        if (capacity > 0 && ++added > capacity * 2) while(added > capacity){
            el2.lastChild?.remove();
            added--;
        }
        if (opts.reverse) el2.scrollTop = el2.scrollHeight;
        lastLogRepeats = 0;
    };
    const clear2 = ()=>{
        el2.innerHTML = ``;
        lastLog = void 0;
        lastLogRepeats = 0;
        added = 0;
    };
    const dispose = ()=>{
        el2.remove();
    };
    return {
        error: error,
        log: log2,
        warn: warn,
        append: append,
        clear: clear2,
        dispose: dispose,
        get isEmpty () {
            return added === 0;
        }
    };
};
// src/dom/InlineConsole.ts
var $5d8ef0ef429bc174$export$52841fb2b083e16 = (options = {})=>{
    const original = {
        log: console.log,
        error: console.error,
        warn: console.warn
    };
    const logElement = document.createElement(`DIV`);
    logElement.id = `ixfx-log`;
    logElement.style.position = `fixed`;
    logElement.style.left = `0px`;
    logElement.style.top = `0px`;
    logElement.style.pointerEvents = `none`;
    logElement.style.display = `none`;
    document.body.prepend(logElement);
    const logger = $5d8ef0ef429bc174$export$bef1f36f5486a6a3(logElement, options);
    const visibility = (show)=>{
        logElement.style.display = show ? `block` : `none`;
    };
    console.error = (message, ...optionalParameters)=>{
        logger.error(message);
        if (optionalParameters.length > 0) logger.error(optionalParameters);
        original.error(message, ...optionalParameters);
        visibility(true);
    };
    console.warn = (message, ...optionalParameters)=>{
        logger.warn(message);
        if (optionalParameters.length > 0) logger.warn(optionalParameters);
        visibility(true);
    };
    console.log = (message, ...optionalParameters)=>{
        logger.log(message);
        if (optionalParameters.length > 0) logger.log(optionalParameters);
        original.log(message, ...optionalParameters);
        visibility(true);
    };
    window.onerror = (event, source, lineno, _colno, error)=>{
        const abbreviatedSource = source === void 0 ? `` : (0, $ae8f83c19bfd8110$export$ece7822811de3aeb)(source, `/`, {
            fromEnd: true
        });
        const eventString = (0, $96302e292290d7c3$export$82f46aa4e6535a45)(error);
        logger.error(eventString + ` (${abbreviatedSource}:${lineno})`);
        visibility(true);
    };
};
// src/dom/PointerVisualise.ts
var $5d8ef0ef429bc174$export$b39273c2e98cc766 = (elOrQuery, options = {})=>{
    const touchRadius = options.touchRadius ?? 45;
    const mouseRadius = options.touchRadius ?? 20;
    const trace = options.trace ?? false;
    const hue = options.hue ?? 100;
    const startFillStyle = `hsla(${hue}, 100%, 10%, 10%)`;
    let currentHue = hue;
    const el2 = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(elOrQuery);
    const tracker = (0, $2f2ba87902101909$export$9f048bf86ee2e9d2)({
        storeIntermediate: trace
    });
    const svg = document.createElementNS(`http://www.w3.org/2000/svg`, `svg`);
    svg.id = `pointerVis`;
    svg.style.zIndex = `-1000`;
    svg.style.position = `fixed`;
    svg.style.top = `0`;
    svg.style.left = `0`;
    svg.style.width = `100%`;
    svg.style.height = `100%`;
    svg.style.boxSizing = `border-box`;
    svg.style.border = `3px solid red`;
    svg.style.pointerEvents = `none`;
    svg.style.touchAction = `none`;
    const er = (0, $4a5be75452a35244$export$6fdaa4e99cd13524).svgViewport(svg);
    let pointerCount = 0;
    const lostPointer = (event)=>{
        const id = event.pointerId.toString();
        tracker.delete(id);
        currentHue = hue;
        svg.querySelector(`#pv-start-${id}`)?.remove();
        for(let index = 0; index < pointerCount + 10; index++)svg.querySelector(`#pv-progress-${id}-${index}`)?.remove();
        pointerCount = 0;
    };
    const trackPointer = async (event)=>{
        const id = event.pointerId.toString();
        const pt = {
            x: event.x,
            y: event.y
        };
        const type = event.pointerType;
        if (event.type === `pointermove` && !tracker.has(id)) return;
        const info = await tracker.seen(event.pointerId.toString(), {
            x: event.clientX,
            y: event.clientY
        });
        if (info.values.length === 1) {
            const el3 = (0, $3818f2662e2a019f$export$d29d523433369b58).circle({
                ...info.values[0],
                radius: type === `touch` ? touchRadius : mouseRadius
            }, svg, {
                fillStyle: startFillStyle
            }, `#pv-start-${id}`);
            el3.style.pointerEvents = `none`;
            el3.style.touchAction = `none`;
        }
        const fillStyle = `hsla(${currentHue}, 100%, 50%, 50%)`;
        const el22 = (0, $3818f2662e2a019f$export$d29d523433369b58).circle({
            ...pt,
            radius: type === `touch` ? touchRadius : mouseRadius
        }, svg, {
            fillStyle: fillStyle
        }, `#pv-progress-${id}-${info.values.length}`);
        el22.style.pointerEvents = `none`;
        el22.style.touchAction = `none`;
        currentHue += 1;
        pointerCount = info.values.length;
    };
    document.body.append(svg);
    el2.addEventListener(`pointerdown`, trackPointer);
    el2.addEventListener(`pointermove`, trackPointer);
    el2.addEventListener(`pointerup`, lostPointer);
    el2.addEventListener(`pointerleave`, lostPointer);
    el2.addEventListener(`contextmenu`, (event)=>{
        event.preventDefault();
    });
};
// src/dom/Query.ts
async function* $5d8ef0ef429bc174$export$2fa187e846a241c4(queryOrElement, options = {}) {
    if (typeof queryOrElement === `string`) return $5d8ef0ef429bc174$export$2fa187e846a241c4([
        queryOrElement
    ], options);
    else if (typeof queryOrElement === `object` && `nodeName` in queryOrElement) return $5d8ef0ef429bc174$export$2fa187e846a241c4([
        queryOrElement
    ], options);
    const ensureUnique = options ?? false;
    const isUnique = ensureUnique ? (0, $2f2ba87902101909$export$82a7086f6a71cb5c)() : (_)=>true;
    if (Array.isArray(queryOrElement)) for (const item of queryOrElement){
        if (typeof item === `string`) for (const element of document.querySelectorAll(item)){
            const elementProper = element;
            if (isUnique(elementProper)) yield elementProper;
        }
        else if (isUnique(item)) yield item;
    }
    else for await (const item of queryOrElement){
        if (typeof item === `string`) {
            for (const element of document.querySelectorAll(item))if (isUnique(element)) yield element;
        } else if (isUnique(item)) yield item;
    }
}
// src/dom/TabbedPanels.ts
var $5d8ef0ef429bc174$export$5e092a6a5325a8e4 = (options)=>{
    const panels = options.panels;
    const preselectId = options.preselectId ?? panels[0].id;
    const guid = `tabset-${(0, $3908e3e0730c98b2$export$310c142d2eb4f21b)()}`;
    const parentEl = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(options.parent);
    const switcher = `
  <div class="ixfx-tabset" id="${guid}">
    <fieldset class="ixfx-tabset-controls">
    ${panels.map((p)=>{
        const panelId = `${guid}-${p.id}-select`;
        return `<input type="radio" name="${guid}-tabs" id="${panelId}" data-tabset="${p.id}"><label for="${panelId}">${p.label}</label>`;
    }).join(``)}
    </fieldset>
    <div class="ixfx-tabset-host" id="${guid}-host"></div>
  </div>
  `;
    parentEl.innerHTML = switcher;
    const hostEl = document.getElementById(`${guid}-host`);
    const tabSetEl = document.getElementById(guid);
    tabSetEl.querySelector(`fieldset`)?.addEventListener(`change`, (event)=>{
        const el2 = event.target;
        select(el2.getAttribute(`data-tabset`));
    });
    let currentPanel;
    const select = (id)=>{
        const newPanel = panels.find((p)=>p.id === id);
        const priorPanel = currentPanel;
        if (options.onPanelChanging) {
            const allow = options.onPanelChanging(priorPanel, newPanel);
            if (typeof allow === `boolean` && !allow) return;
        }
        if (priorPanel) priorPanel.dismount();
        currentPanel = newPanel;
        if (newPanel) {
            newPanel.mount(hostEl);
            const domId = `#${guid}-${id}-select`;
            const inputEl = tabSetEl.querySelector(domId);
            if (inputEl) inputEl.checked = true;
            else console.warn(`Could not find INPUT element for panel id: ${id} (${domId})`);
        }
        if (options.onPanelChange) options.onPanelChange(priorPanel, newPanel);
    };
    select(preselectId);
    let warned = false;
    const notify = (name, args)=>{
        if (!currentPanel) return;
        if (currentPanel.notify) currentPanel.notify(name, args);
        else if (!warned) {
            warned = true;
            console.warn(`TabbedPanel.notify dropping notification '${name}'. Panel implementation is missing 'notify' function`);
        }
    };
    return {
        select: select,
        panels: panels,
        hostEl: hostEl,
        tabSetEl: tabSetEl,
        notify: notify
    };
};
// src/dom/Util.ts
var $5d8ef0ef429bc174$var$import_json52 = (0, $f81dde33861c7f4f$export$82dec27a9dce9602)($5d8ef0ef429bc174$var$require_dist(), 1);
var $5d8ef0ef429bc174$export$fe4944cdf69e425b = (reference = `viewport`)=>{
    switch(reference){
        case `viewport`:
            return (a, b)=>{
                const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(a, b);
                return Object.freeze({
                    x: pt.x / window.innerWidth,
                    y: pt.y / window.innerHeight
                });
            };
        case `screen`:
            return (a, b)=>{
                const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(a, b);
                return Object.freeze({
                    x: pt.x / screen.width,
                    y: pt.y / screen.height
                });
            };
        case `document`:
            return (a, b)=>{
                const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(a, b);
                return Object.freeze({
                    x: pt.x / document.body.scrollWidth,
                    y: pt.y / document.body.scrollHeight
                });
            };
        default:
            throw new Error(`Unknown 'reference' parameter: ${JSON.stringify(reference)}`);
    }
};
var $5d8ef0ef429bc174$export$7d3a82dc3474e386 = (domQueryOrEl, options = {})=>{
    const targetSpace = options.target ?? `viewport`;
    const relative = options.relative ?? false;
    const anchor = options.anchor ?? `nw`;
    const el2 = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domQueryOrEl);
    const vpToSpace = $5d8ef0ef429bc174$export$c897787a1271b581(targetSpace);
    if (relative) {
        const s = $5d8ef0ef429bc174$export$fe4944cdf69e425b(targetSpace);
        return ()=>s(vpToSpace((0, $da7bbf79b162d05c$export$5f042bbf49ec661b)(el2.getBoundingClientRect(), anchor)));
    } else return ()=>vpToSpace((0, $da7bbf79b162d05c$export$5f042bbf49ec661b)(el2.getBoundingClientRect(), anchor));
};
var $5d8ef0ef429bc174$export$f85c81e643478ca6 = (domQueryOrEl, anchor = `nw`)=>{
    const el2 = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domQueryOrEl);
    return (0, $da7bbf79b162d05c$export$5f042bbf49ec661b)(el2.getBoundingClientRect(), anchor);
};
var $5d8ef0ef429bc174$export$fc51f1cf90283cd4 = (domQueryOrEl, target = `viewport`)=>{
    const f = $5d8ef0ef429bc174$export$7d3a82dc3474e386(domQueryOrEl, {
        relative: true,
        target: target
    });
    return f();
};
var $5d8ef0ef429bc174$export$c897787a1271b581 = (targetSpace = `viewport`)=>{
    switch(targetSpace){
        case `screen`:
            return (a, b)=>{
                const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(a, b);
                return Object.freeze({
                    x: pt.x + window.screenX,
                    y: pt.y + window.screenY
                });
            };
        case `document`:
            return (a, b)=>{
                const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(a, b);
                return Object.freeze({
                    x: pt.x + window.scrollX,
                    y: pt.y + window.scrollY
                });
            };
        case `viewport`:
            return (a, b)=>{
                const pt = (0, $2edc1eef02a7c199$export$fe216fb4d5cb9144)(a, b);
                return Object.freeze({
                    x: pt.x,
                    y: pt.y
                });
            };
        default:
            throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `Unexpected target coordinate space: ${targetSpace}. Expected: viewport, document or screen`);
    }
};
var $5d8ef0ef429bc174$export$cfefb408082ab9e6 = (domQueryOrEl, relativePos, relativeTo = `window`)=>{
    if (!domQueryOrEl) throw new Error(`domQueryOrEl is null or undefined`);
    const el2 = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domQueryOrEl);
    const absPosition = (0, $2edc1eef02a7c199$export$2060d2db72cce88f)(relativePos, window.innerWidth, window.innerHeight);
    const thingRect = el2.getBoundingClientRect();
    const offsetPos = (0, $2edc1eef02a7c199$export$4e2d2ead65e5f7e3)(absPosition, thingRect.width / 2, thingRect.height / 2);
    el2.style.transform = `translate(${offsetPos.x}px, ${offsetPos.y}px)`;
};
var $5d8ef0ef429bc174$export$d89e377b3634a0e7 = (el2, list)=>{
    if (el2 === null || !el2) return;
    if (!Array.isArray(list)) throw new TypeError(`List should be an array of strings`);
    for(let index = 0; index < list.length; index++)if (el2.classList.contains(list[index])) {
        el2.classList.remove(list[index]);
        if (index + 1 < list.length) el2.classList.add(list[index + 1]);
        else el2.classList.add(list[0]);
        return;
    }
    el2.classList.add(list[0]);
};
var $5d8ef0ef429bc174$export$202e99f82f7f0395 = (domQueryOrEl)=>{
    const el2 = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(domQueryOrEl);
    const style = window.getComputedStyle(el2);
    const matrix = style.transform;
    if (matrix === `none` || typeof matrix === `undefined`) return {
        x: 0,
        y: 0,
        z: 0
    };
    const matrixType = matrix.includes(`3d`) ? `3d` : `2d`;
    const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(`, `);
    if (matrixType === `2d`) return {
        x: Number.parseFloat(matrixValues[4]),
        y: Number.parseFloat(matrixValues[5]),
        z: 0
    };
    if (matrixType === `3d`) return {
        x: Number.parseFloat(matrixValues[12]),
        y: Number.parseFloat(matrixValues[13]),
        z: Number.parseFloat(matrixValues[14])
    };
    return {
        x: 0,
        y: 0,
        z: 0
    };
};
var $5d8ef0ef429bc174$export$9195f9e85a065d03 = (sibling, tagName)=>{
    const el2 = document.createElement(tagName);
    sibling.parentElement?.insertBefore(el2, sibling.nextSibling);
    return el2;
};
var $5d8ef0ef429bc174$export$813161d69b531ae3 = (parent, tagName)=>{
    const el2 = document.createElement(tagName);
    parent.append(el2);
    return el2;
};
var $5d8ef0ef429bc174$export$42ffd38884aecdac = (parent)=>{
    let c = parent.lastElementChild;
    while(c){
        c.remove();
        c = parent.lastElementChild;
    }
};
var $5d8ef0ef429bc174$export$2cdf1b96a9f86d16 = (object)=>{
    const p = new Promise((resolve, reject)=>{
        const string_ = $5d8ef0ef429bc174$var$import_json52.default.stringify(object);
        navigator.clipboard.writeText(JSON.stringify(string_)).then(()=>{
            resolve(true);
        }, (error)=>{
            console.warn(`Could not copy to clipboard`);
            console.log(string_);
            reject(new Error(error));
        });
    });
    return p;
};
var $5d8ef0ef429bc174$export$553682d44e5ecabb = (parent, element)=>{
    const elSort = element.getAttribute(`data-sort`) ?? ``;
    let elAfter;
    let elBefore;
    for (const c of parent.children){
        const sort = c.getAttribute(`data-sort`) ?? ``;
        if (elSort >= sort) elAfter = c;
        if (elSort <= sort) elBefore = c;
        if (elAfter !== void 0 && elBefore !== void 0) break;
    }
    if (elAfter !== void 0) elAfter.insertAdjacentElement(`afterend`, element);
    else if (elBefore === void 0) parent.append(element);
    else elBefore.insertAdjacentElement(`beforebegin`, element);
};
var $5d8ef0ef429bc174$export$46bb9d4f23154749 = (parentEl, list, createUpdate)=>{
    if (parentEl === null) throw new Error(`parentEl is null`);
    if (parentEl === void 0) throw new Error(`parentEl is undefined`);
    const seen = /* @__PURE__ */ new Set();
    for (const [key, value] of list){
        const id = `c-${key}`;
        const el2 = parentEl.querySelector(`#${id}`);
        const finalEl = createUpdate(value, el2);
        if (el2 !== finalEl) {
            finalEl.id = id;
            parentEl.append(finalEl);
        }
        seen.add(id);
    }
    const prune = [];
    for (const child of parentEl.children)if (!seen.has(child.id)) prune.push(child);
    for (const p of prune)p.remove();
};
var $5d8ef0ef429bc174$export$a1920133d5b0a75 = (id)=>{
    const element = document.getElementById(id);
    if (element === null) throw new Error(`HTML element with id '${id}' not found`);
    return element;
};
























































// src/trackers/PrimitiveTracker.ts
var $092e49f6457554a9$export$28b08297fa74dda3 = class extends (0, $a31d1195ac5264a9$export$20a0bbf0f684f1f8) {
    constructor(opts){
        super(opts);
        this.values = [];
        this.timestamps = [];
    }
    /**
   * Reduces size of value store to `limit`. Returns
   * number of remaining items
   * @param limit
   */ trimStore(limit) {
        if (limit >= this.values.length) return this.values.length;
        this.values = this.values.slice(-limit);
        this.timestamps = this.timestamps.slice(-limit);
        return this.values.length;
    }
    onTrimmed(reason) {}
    get last() {
        return this.values.at(-1);
    }
    get initial() {
        return this.values.at(0);
    }
    /**
   * Returns number of recorded values (this can include the initial value)
   */ get size() {
        return this.values.length;
    }
    /**
   * Returns the elapsed time, in milliseconds since the instance was created
   */ get elapsed() {
        if (this.values.length < 0) throw new Error(`No values seen yet`);
        return Date.now() - this.timestamps[0];
    }
    onReset() {
        this.values = [];
        this.timestamps = [];
    }
    /**
   * Tracks a value
   */ filterData(rawValues) {
        const lastValue = rawValues.at(-1);
        const last = {
            value: lastValue,
            at: performance.now()
        };
        const values = rawValues.map((value)=>({
                at: performance.now(),
                value: value
            }));
        if (this.storeIntermediate) {
            this.values.push(...rawValues);
            this.timestamps.push(...values.map((v)=>v.at));
        } else switch(this.values.length){
            case 0:
                this.values.push(last.value);
                this.timestamps.push(last.at);
                break;
            case 2:
                this.values[1] = last.value;
                this.timestamps[1] = last.at;
                break;
            case 1:
                this.values.push(last.value);
                this.timestamps.push(last.at);
                break;
        }
        return values;
    }
};
// src/trackers/NumberTracker.ts
var $092e49f6457554a9$export$f757fdb79256a0f5 = class extends $092e49f6457554a9$export$28b08297fa74dda3 {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(opts){
        super(opts);
        this.total = 0;
        this.min = Number.MAX_SAFE_INTEGER;
        this.max = Number.MIN_SAFE_INTEGER;
    }
    get avg() {
        return this.total / this.seenCount;
    }
    /**
   * Difference between last value and initial.
   * Eg. if last value was 10 and initial value was 5, 5 is returned (10 - 5)
   * If either of those is missing, undefined is returned
   */ difference() {
        if (this.last === void 0) return;
        if (this.initial === void 0) return;
        return this.last - this.initial;
    }
    /**
   * Relative difference between last value and initial.
   * Eg if last value was 10 and initial value was 5, 2 is returned (200%)
   */ relativeDifference() {
        if (this.last === void 0) return;
        if (this.initial === void 0) return;
        return this.last / this.initial;
    }
    onReset() {
        this.min = Number.MAX_SAFE_INTEGER;
        this.max = Number.MIN_SAFE_INTEGER;
        this.total = 0;
        super.onReset();
    }
    /**
   * When trimmed, recomputes to set total/min/max to be based on
   * current values.
   * @param reason 
   */ onTrimmed(reason) {
        this.min = (0, $36aa4387660da012$export$70f363b986c8e811)(this.values);
        this.max = (0, $36aa4387660da012$export$f41fc95ce818cf3e)(this.values);
        this.total = (0, $36aa4387660da012$export$cf1a774fd7314f92)(this.values);
    }
    computeResults(values) {
        if (values.some((v)=>Number.isNaN(v))) throw new Error(`Cannot add NaN`);
        const numbers = values.map((value)=>value.value);
        this.total = numbers.reduce((accumulator, v)=>accumulator + v, this.total);
        this.min = Math.min(...numbers, this.min);
        this.max = Math.max(...numbers, this.max);
        const r = {
            max: this.max,
            min: this.min,
            total: this.total,
            avg: this.avg
        };
        return r;
    }
    getMinMaxAvg() {
        return {
            min: this.min,
            max: this.max,
            avg: this.avg
        };
    }
};
var $092e49f6457554a9$export$98e628dec113755e = (opts = {})=>new $092e49f6457554a9$export$f757fdb79256a0f5(opts);








// src/trackers/index.ts
var $dbd5be4deea2784c$export$b9c63bc81ed14392 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($dbd5be4deea2784c$export$b9c63bc81ed14392, {
    FrequencyTracker: ()=>$dbd5be4deea2784c$export$c0d37079ed5523c,
    IntervalTracker: ()=>$dbd5be4deea2784c$export$5930f06efdd0c7b8,
    NumberTracker: ()=>(0, $092e49f6457554a9$export$f757fdb79256a0f5),
    ObjectTracker: ()=>(0, $2f2ba87902101909$export$13649ba9bf278783),
    PointTracker: ()=>(0, $2f2ba87902101909$export$ef4185b0af72d58e),
    PrimitiveTracker: ()=>(0, $092e49f6457554a9$export$28b08297fa74dda3),
    RateTracker: ()=>$dbd5be4deea2784c$export$87c87eba2c80f6bf,
    TrackedPointMap: ()=>(0, $2f2ba87902101909$export$734eb71d5a0d0a92),
    TrackedValueMap: ()=>(0, $a31d1195ac5264a9$export$27fa49008f51af6e),
    TrackerBase: ()=>(0, $a31d1195ac5264a9$export$20a0bbf0f684f1f8),
    frequency: ()=>$dbd5be4deea2784c$export$7ca27958f28e2974,
    interval: ()=>$dbd5be4deea2784c$export$3174cdbf0a0cbc84,
    number: ()=>(0, $092e49f6457554a9$export$98e628dec113755e),
    point: ()=>(0, $2f2ba87902101909$export$105684a3041cb6f3),
    points: ()=>(0, $2f2ba87902101909$export$9f048bf86ee2e9d2),
    rate: ()=>$dbd5be4deea2784c$export$e8435ed7e8ba58fa,
    unique: ()=>(0, $2f2ba87902101909$export$7a5d5c156e7dc406),
    uniqueInstances: ()=>(0, $2f2ba87902101909$export$82a7086f6a71cb5c)
});
// src/trackers/FrequencyMutable.ts
var $dbd5be4deea2784c$export$c0d37079ed5523c = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    #store;
    #keyString;
    /**
   * Constructor
   * @param keyString Function to key items. Uses JSON.stringify by default
   */ constructor(keyString){
        super();
        this.#store = /* @__PURE__ */ new Map();
        if (keyString === void 0) keyString = (a)=>{
            if (a === void 0) throw new Error(`Cannot create key for undefined`);
            return typeof a === `string` ? a : JSON.stringify(a);
        };
        this.#keyString = keyString;
    }
    /**
   * Clear data. Fires `change` event
   */ clear() {
        this.#store.clear();
        this.fireEvent(`change`, {
            context: this
        });
    }
    /**
   * @returns Iterator over keys (ie. groups)
   */ keys() {
        return this.#store.keys();
    }
    /**
   * @returns Iterator over frequency counts
   */ values() {
        return this.#store.values();
    }
    /**
   * @returns Copy of entries as an array of `[key, count]`
   */ toArray() {
        return [
            ...this.#store.entries()
        ];
    }
    /**
   * Returns a string with keys and counts, useful for debugging.
   * @returns
   */ debugString() {
        let t = ``;
        for (const [key, count] of this.#store.entries())t += `${key}: ${count}, `;
        if (t.endsWith(`, `)) return t.slice(0, Math.max(0, t.length - 2));
        return t;
    }
    /**
   *
   * @param value Value to count
   * @returns Frequency of value, or _undefined_ if it does not exist
   */ frequencyOf(value) {
        if (typeof value === `string`) return this.#store.get(value);
        const key = this.#keyString(value);
        return this.#store.get(key);
    }
    /**
   *
   * @param value Value to count
   * @returns Relative frequency of `value`, or _undefined_ if it does not exist
   */ relativeFrequencyOf(value) {
        let freq;
        if (typeof value === `string`) freq = this.#store.get(value);
        else {
            const key = this.#keyString(value);
            freq = this.#store.get(key);
        }
        if (freq === void 0) return;
        const mma = this.minMaxAvg();
        return freq / mma.total;
    }
    /**
   * @returns Copy of entries as an array
   */ entries() {
        return [
            ...this.#store.entries()
        ];
    }
    /**
   *
   * @returns Returns `{min,max,avg,total}`
   */ minMaxAvg() {
        return (0, $9364ac8ced0e518d$export$d35fee1eaae8d066)(this.entries());
    }
    /**
   *
   * @param sortStyle Sorting style (default: _value_, ie. count)
   * @returns Sorted array of [key,frequency]
   */ entriesSorted(sortStyle = `value`) {
        const s = (0, $9364ac8ced0e518d$export$914380f37b1845f7)(sortStyle);
        return s(this.entries());
    }
    /**
   *
   * @param values Values to add. Fires _change_ event after adding item(s)
   */ //eslint-disable-next-line functional/prefer-immutable-types
    add(...values) {
        if (values === void 0) throw new Error(`value parameter is undefined`);
        const keys = values.map((v)=>this.#keyString(v));
        for (const key of keys){
            const score = this.#store.get(key) ?? 0;
            this.#store.set(key, score + 1);
        }
        this.fireEvent(`change`, {
            context: this
        });
    }
};
var $dbd5be4deea2784c$export$7ca27958f28e2974 = (keyString)=>new $dbd5be4deea2784c$export$c0d37079ed5523c(keyString);
// src/trackers/IntervalTracker.ts
var $dbd5be4deea2784c$export$5930f06efdd0c7b8 = class extends (0, $092e49f6457554a9$export$f757fdb79256a0f5) {
    constructor(){
        super(...arguments);
        this.lastMark = 0;
    }
    mark() {
        if (this.lastMark > 0) this.seen(performance.now() - this.lastMark);
        this.lastMark = performance.now();
    }
};
var $dbd5be4deea2784c$export$3174cdbf0a0cbc84 = (options)=>new $dbd5be4deea2784c$export$5930f06efdd0c7b8(options);
// src/trackers/RateTracker.ts
var $dbd5be4deea2784c$export$87c87eba2c80f6bf = class {
    #events = [];
    #fromTime;
    #resetAfterSamples;
    #sampleLimit;
    #resetTimer;
    constructor(opts = {}){
        this.#resetAfterSamples = opts.resetAfterSamples ?? Number.MAX_SAFE_INTEGER;
        this.#sampleLimit = opts.sampleLimit ?? Number.MAX_SAFE_INTEGER;
        if (opts.timeoutInterval) this.#resetTimer = (0, $f53657e65b61d2bb$export$83e74882c5df8fe1)(()=>{
            this.reset();
        }, opts.timeoutInterval);
        this.#fromTime = performance.now();
    }
    /**
   * Mark that an event has happened
   */ mark() {
        if (this.#events.length >= this.#resetAfterSamples) this.reset();
        else if (this.#events.length >= this.#sampleLimit) {
            this.#events = this.#events.slice(1);
            this.#fromTime = this.#events[0];
        }
        this.#events.push(performance.now());
        if (this.#resetTimer) this.#resetTimer.start();
    }
    /**
   * Compute {min,max,avg} for the interval _between_ events.
   * @returns 
   */ computeIntervals() {
        let intervals = [];
        let min = Number.MAX_SAFE_INTEGER;
        let max = Number.MIN_SAFE_INTEGER;
        let total = 0;
        let count = 0;
        let start = 0;
        for (let e of this.#events){
            if (count > 0) {
                const i = e - start;
                min = Math.min(i, min);
                max = Math.max(i, max);
                total += i;
                intervals.push(i);
            }
            start = e;
            count++;
        }
        let avg = total / count;
        return {
            min: min,
            max: max,
            avg: avg
        };
    }
    /**
   * Returns the time period (in milliseconds) that encompasses
   * the data set. Eg, a result of 1000 means there's data that
   * covers a one second period.
   */ get elapsed() {
        return performance.now() - this.#fromTime;
    }
    /**
   * Resets the tracker.
   */ reset() {
        this.#events = [];
        this.#fromTime = performance.now();
    }
    /**
   * Get the number of events per second
   */ get perSecond() {
        return this.#events.length / (this.elapsed / 1e3);
    }
    /**
   * Get the number of events per minute
   */ get perMinute() {
        return this.#events.length / (this.elapsed / 1e3 / 60);
    }
};
var $dbd5be4deea2784c$export$e8435ed7e8ba58fa = (opts = {})=>new $dbd5be4deea2784c$export$87c87eba2c80f6bf(opts);
















// src/io/index.ts
var $367b84d0d2a414aa$export$5b8892dc413e1914 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($367b84d0d2a414aa$export$5b8892dc413e1914, {
    Audio: ()=>$367b84d0d2a414aa$export$21ad9753439f4739,
    Bluetooth: ()=>$367b84d0d2a414aa$export$11d91ff38c2b168f,
    Camera: ()=>$367b84d0d2a414aa$export$558ce0eb0d28d98b,
    Codec: ()=>$367b84d0d2a414aa$export$a111e9ced3f1d2d0,
    Espruino: ()=>$367b84d0d2a414aa$export$c8c3369655bc5c65,
    FrameProcessor: ()=>$367b84d0d2a414aa$export$1d7e16ee15e61187,
    Serial: ()=>$367b84d0d2a414aa$export$a9bbb9c706f2bf62,
    StringReceiveBuffer: ()=>$367b84d0d2a414aa$export$fe9a3929a3a2427f,
    StringWriteBuffer: ()=>$367b84d0d2a414aa$export$2fcd064f08f54e20,
    VideoFile: ()=>$367b84d0d2a414aa$export$59bf13843ffda7df,
    genericStateTransitionsInstance: ()=>$367b84d0d2a414aa$export$f7446a661cc02f10,
    reconnectingWebsocket: ()=>$367b84d0d2a414aa$export$3e85abc04cb3cc35
});
// src/io/NordicBleDevice.ts
var $367b84d0d2a414aa$export$11d91ff38c2b168f = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($367b84d0d2a414aa$export$11d91ff38c2b168f, {
    NordicBleDevice: ()=>$367b84d0d2a414aa$var$NordicBleDevice,
    defaultOpts: ()=>$367b84d0d2a414aa$var$defaultOpts
});
// src/io/Codec.ts
var $367b84d0d2a414aa$export$a111e9ced3f1d2d0 = class {
    constructor(){
        this.enc = new TextEncoder();
        this.dec = new TextDecoder(`utf-8`);
    }
    /**
   * Convert string to Uint8Array buffer
   * @param str
   * @returns
   */ toBuffer(str) {
        return this.enc.encode(str);
    }
    /**
   * Returns a string from a provided buffer
   * @param buffer
   * @returns
   */ fromBuffer(buffer) {
        return this.dec.decode(buffer);
    }
};
// src/io/StringReceiveBuffer.ts
var $367b84d0d2a414aa$export$fe9a3929a3a2427f = class {
    constructor(onData, separator = `
`){
        this.onData = onData;
        this.separator = separator;
        this.buffer = ``;
    }
    async close() {
        const s = this.stream;
        if (!s) return;
        await s.abort();
        await s.close();
    }
    clear() {
        this.buffer = ``;
    }
    writable() {
        if (this.stream === void 0) this.stream = this.createWritable();
        return this.stream;
    }
    createWritable() {
        const b = this;
        return new WritableStream({
            write (chunk) {
                b.add(chunk);
            },
            close () {
                b.clear();
            }
        });
    }
    addImpl(str) {
        const pos = str.indexOf(this.separator);
        if (pos < 0) {
            this.buffer += str;
            return ``;
        }
        const part = str.substring(0, pos);
        try {
            this.onData(this.buffer + part);
            str = str.substring(part.length + this.separator.length);
        } catch (ex) {
            console.warn(ex);
        }
        this.buffer = ``;
        return str;
    }
    add(str) {
        while(str.length > 0)str = this.addImpl(str);
    }
};
// src/io/StringWriteBuffer.ts
var $367b84d0d2a414aa$export$2fcd064f08f54e20 = class {
    /**
   * Constructor
   * @param dataHandler Calback to 'send' data onwards
   * @param opts Options
   */ constructor(dataHandler, opts = {}){
        this.dataHandler = dataHandler;
        this.paused = false;
        this.queue = new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)();
        this.closed = false;
        this.chunkSize = opts.chunkSize ?? -1;
        this.writer = (0, $f53657e65b61d2bb$export$5df75b4acf95a98a)(async ()=>{
            await this.onWrite();
        }, opts.interval ?? 10);
    }
    /**
   * Close writer (async)
   */ async close() {
        if (this.closed) return;
        const w = this.stream?.getWriter();
        w?.releaseLock();
        await w?.close();
        this.closed = true;
    }
    /**
   * Clear queued data.
   *
   * Throws an error if {@link close} has been called.
   */ clear() {
        if (this.closed) throw new Error(`Buffer closed`);
        this.queue = new (0, $3f856c338f7c6dcb$export$24f44af47d707e8e)();
    }
    /**
   * Gets the buffer as a writable stream.
   *
   * Do not close stream directly, use .close on this class instead.
   *
   * Throws an error if .close() has been called.
   * @returns Underlying stream
   */ writable() {
        if (this.closed) throw new Error(`Buffer closed`);
        if (this.stream === void 0) this.stream = this.createWritable();
        return this.stream;
    }
    createWritable() {
        const b = this;
        return new WritableStream({
            write (chunk) {
                b.add(chunk);
            },
            close () {
                b.clear();
            }
        });
    }
    /**
   * Run in a `continunously` loop to process queued data
   * @returns _False_ if queue is empty and loop should stop. _True_ if it shoud continue.
   */ async onWrite() {
        if (this.queue.isEmpty) return false;
        if (this.paused) {
            console.warn(`WriteBuffer.onWrite: paused...`);
            return true;
        }
        const s = this.queue.dequeue();
        if (s === void 0) return false;
        await this.dataHandler(s);
        return true;
    }
    /**
   * Returns _true_ if {@link close} has been called.
   */ get isClosed() {
        return this.closed;
    }
    /**
   * Adds some queued data to send.
   * Longer strings are automatically chunked up according to the buffer's settings.
   *
   * Throws an error if {@link close} has been called.
   * @param stringToQueue
   */ add(stringToQueue) {
        if (this.closed) throw new Error(`Buffer closed`);
        if (this.chunkSize > 0) this.queue.enqueue(...(0, $ae8f83c19bfd8110$export$7a32dd8b629a0529)(stringToQueue, this.chunkSize));
        else this.queue.enqueue(stringToQueue);
        this.writer.start();
    }
};
// src/io/GenericStateTransitions.ts
var $367b84d0d2a414aa$export$f7446a661cc02f10 = Object.freeze({
    ready: `connecting`,
    connecting: [
        `connected`,
        `closed`
    ],
    connected: [
        `closed`
    ],
    closed: `connecting`
});
// src/io/BleDevice.ts
var $367b84d0d2a414aa$var$BleDevice = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    constructor(device, config){
        super();
        this.device = device;
        this.config = config;
        this.verboseLogging = false;
        this.verboseLogging = config.debug;
        this.txBuffer = new $367b84d0d2a414aa$export$2fcd064f08f54e20(async (data)=>{
            await this.writeInternal(data);
        }, config);
        this.rxBuffer = new $367b84d0d2a414aa$export$fe9a3929a3a2427f((line)=>{
            this.fireEvent(`data`, {
                data: line
            });
        });
        this.codec = new $367b84d0d2a414aa$export$a111e9ced3f1d2d0();
        this.states = new (0, $29a41e51920ca8b4$export$9b20b63dc5d1b3c0)($367b84d0d2a414aa$export$f7446a661cc02f10, {
            initial: `ready`
        });
        this.states.addEventListener(`change`, (event)=>{
            this.fireEvent(`change`, event);
            this.verbose(`${event.priorState} -> ${event.newState}`);
            if (event.priorState === `connected`) {
                this.rxBuffer.clear();
                this.txBuffer.clear();
            }
        });
        device.addEventListener(`gattserverdisconnected`, ()=>{
            if (this.isClosed) return;
            this.verbose(`GATT server disconnected`);
            this.states.state = `closed`;
        });
        this.verbose(`ctor ${device.name} ${device.id}`);
    }
    get isConnected() {
        return this.states.state === `connected`;
    }
    get isClosed() {
        return this.states.state === `closed`;
    }
    write(txt) {
        if (this.states.state !== `connected`) throw new Error(`Cannot write while state is ${this.states.state}`);
        this.txBuffer.add(txt);
    }
    async writeInternal(txt) {
        this.verbose(`writeInternal ${txt}`);
        const tx = this.tx;
        if (tx === void 0) throw new Error(`Unexpectedly without tx characteristic`);
        try {
            await tx.writeValue(this.codec.toBuffer(txt));
        } catch (error) {
            this.warn(error);
        }
    }
    disconnect() {
        if (this.states.state !== `connected`) return;
        this.gatt?.disconnect();
    }
    async connect() {
        const attempts = this.config.connectAttempts ?? 3;
        this.states.state = `connecting`;
        this.verbose(`connect`);
        const gatt = this.device.gatt;
        if (gatt === void 0) throw new Error(`Gatt not available on device`);
        await (0, $f53657e65b61d2bb$export$868bf35b6ef95abe)(async ()=>{
            this.verbose(`connect.retry`);
            const server = await gatt.connect();
            this.verbose(`Getting primary service`);
            const service = await server.getPrimaryService(this.config.service);
            this.verbose(`Getting characteristics`);
            const rx = await service.getCharacteristic(this.config.rxGattCharacteristic);
            const tx = await service.getCharacteristic(this.config.txGattCharacteristic);
            rx.addEventListener(`characteristicvaluechanged`, (event)=>{
                this.onRx(event);
            });
            this.rx = rx;
            this.tx = tx;
            this.gatt = gatt;
            this.states.state = `connected`;
            await rx.startNotifications();
            return true;
        }, {
            limitAttempts: attempts,
            startAt: 200
        });
    }
    onRx(event) {
        const rx = this.rx;
        if (rx === void 0) return;
        const view = event.target.value;
        if (view === void 0) return;
        let string_ = this.codec.fromBuffer(view.buffer);
        const plzStop = (0, $ae8f83c19bfd8110$export$98697ab6aa598b83)(string_, 19);
        const plzStart = (0, $ae8f83c19bfd8110$export$98697ab6aa598b83)(string_, 17);
        if (plzStart && plzStop < plzStart) {
            this.verbose(`Tx plz start`);
            string_ = (0, $ae8f83c19bfd8110$export$aafb194044d2a289)(string_, plzStart, 1);
            this.txBuffer.paused = false;
        }
        if (plzStop && plzStop > plzStart) {
            this.verbose(`Tx plz stop`);
            string_ = (0, $ae8f83c19bfd8110$export$aafb194044d2a289)(string_, plzStop, 1);
            this.txBuffer.paused = true;
        }
        this.rxBuffer.add(string_);
    }
    verbose(m) {
        if (this.verboseLogging) console.info(`${this.config.name}`, m);
    }
    log(m) {
        console.log(`${this.config.name}`, m);
    }
    warn(m) {
        console.warn(`${this.config.name}`, m);
    }
};
// src/io/NordicBleDevice.ts
var $367b84d0d2a414aa$var$defaultOpts = {
    chunkSize: 20,
    service: `6e400001-b5a3-f393-e0a9-e50e24dcca9e`,
    txGattCharacteristic: `6e400002-b5a3-f393-e0a9-e50e24dcca9e`,
    rxGattCharacteristic: `6e400003-b5a3-f393-e0a9-e50e24dcca9e`,
    name: `NordicDevice`,
    connectAttempts: 5,
    debug: false
};
var $367b84d0d2a414aa$var$NordicBleDevice = class extends $367b84d0d2a414aa$var$BleDevice {
    constructor(device, opts = {}){
        super(device, {
            ...$367b84d0d2a414aa$var$defaultOpts,
            ...opts
        });
    }
};
// src/io/audio/index.ts
var $367b84d0d2a414aa$export$21ad9753439f4739 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($367b84d0d2a414aa$export$21ad9753439f4739, {
    AudioAnalyser: ()=>$367b84d0d2a414aa$var$AudioAnalyser2,
    AudioElements: ()=>$367b84d0d2a414aa$var$AudioElements,
    AudioVisualiser: ()=>$367b84d0d2a414aa$var$AudioVisualiser,
    analyserBasic: ()=>$367b84d0d2a414aa$var$analyserBasic,
    analyserFrequency: ()=>$367b84d0d2a414aa$var$analyserFrequency,
    analyserPeakLevel: ()=>$367b84d0d2a414aa$var$analyserPeakLevel,
    createFromAudioElement: ()=>$367b84d0d2a414aa$var$createFromAudioElement,
    createOscillator: ()=>$367b84d0d2a414aa$var$createOscillator
});
// src/io/audio/Visualiser.ts
var $367b84d0d2a414aa$var$AudioVisualiser = class {
    constructor(parentElem, audio){
        this.freqMaxRange = 200;
        this.lastPointer = {
            x: 0,
            y: 0
        };
        this.pointerDown = false;
        this.pointerClicking = false;
        this.pointerClickDelayMs = 100;
        this.pointerDelaying = false;
        this.audio = audio;
        this.parent = parentElem;
        this.waveTracker = (0, $092e49f6457554a9$export$98e628dec113755e)();
        this.freqTracker = (0, $092e49f6457554a9$export$98e628dec113755e)();
        parentElem.innerHTML = `
    <section>
      <button id="rendererComponentToggle">\u{1F53C}</button>
      <div>
        <h1>Visualiser</h1>
        <div style="display:flex; flex-wrap: wrap">
          <div class="visPanel">
            <h2>Frequency distribution</h2>
            <br />
            <canvas id="rendererComponentFreqData" height="200" width="400"></canvas>
          </div>
          <div class="visPanel">
            <h2>Waveform</h2>
            <button id="rendererComponentWaveReset">Reset</button>
            <div>
              Press and hold on wave to measure
            </div>
            <br />
            <canvas id="rendererComponentWaveData" height="200" width="400"></canvas>
          </div>
        </div>
      </div>
    </section>
    `;
        this.el = parentElem.children[0];
        document.getElementById(`rendererComponentToggle`)?.addEventListener(`click`, ()=>{
            this.setExpanded(!this.isExpanded());
        });
        this.el.addEventListener(`pointermove`, (e)=>this.onPointer(e));
        this.el.addEventListener(`pointerup`, ()=>{
            this.pointerDelaying = false;
            this.pointerDown = false;
        });
        this.el.addEventListener(`pointerdown`, ()=>{
            this.pointerDelaying = true;
            setTimeout(()=>{
                if (this.pointerDelaying) {
                    this.pointerDelaying = false;
                    this.pointerDown = true;
                }
            }, this.pointerClickDelayMs);
        });
        this.el.addEventListener(`pointerleave`, ()=>{
            this.pointerDelaying = false;
            this.pointerDown = false;
        });
        document.getElementById(`rendererComponentWaveReset`)?.addEventListener(`click`, ()=>{
            this.clear();
        });
    }
    renderFreq(freq) {
        if (!this.isExpanded()) return;
        if (!freq) return;
        const canvas = document.getElementById(`rendererComponentFreqData`);
        if (canvas === null) throw new Error(`Cannot find canvas element`);
        const g = canvas.getContext(`2d`);
        if (g === null) throw new Error(`Cannot create drawing context`);
        const bins = freq.length;
        const canvasWidth = canvas.clientWidth;
        const canvasHeight = canvas.clientHeight;
        g.clearRect(0, 0, canvasWidth, canvasHeight);
        const pointer = this.getPointerRelativeTo(canvas);
        const width = canvasWidth / bins;
        const minMax = (0, $9364ac8ced0e518d$export$24ad9025a0be0d69)(freq);
        for(let i = 0; i < bins; i++){
            if (!Number.isFinite(freq[i])) continue;
            const value = freq[i] - minMax.min;
            const valueRelative = value / this.freqMaxRange;
            const height = Math.abs(canvasHeight * valueRelative);
            const offset = canvasHeight - height;
            const hue = i / bins * 360;
            const left = i * width;
            g.fillStyle = `hsl(` + hue + `, 100%, 50%)`;
            if (pointer.y > 0 && pointer.y <= canvasHeight && pointer.x >= left && pointer.x <= left + width) {
                if (this.freqTracker.id !== i.toString()) this.freqTracker = (0, $092e49f6457554a9$export$98e628dec113755e)({
                    id: i.toString()
                });
                this.freqTracker.seen(freq[i]);
                const freqMma = this.freqTracker.getMinMaxAvg();
                g.fillStyle = `black`;
                if (this.audio) g.fillText(`Frequency (${i}) at pointer: ${this.audio.getFrequencyAtIndex(i).toLocaleString(`en`)} - ${this.audio.getFrequencyAtIndex(i + 1).toLocaleString(`en`)}`, 2, 10);
                g.fillText(`Raw value: ${freq[i].toFixed(2)}`, 2, 20);
                g.fillText(`Min: ${freqMma.min.toFixed(2)}`, 2, 40);
                g.fillText(`Max: ${freqMma.max.toFixed(2)}`, 60, 40);
                g.fillText(`Avg: ${freqMma.avg.toFixed(2)}`, 120, 40);
            }
            g.fillRect(left, offset, width, height);
        }
    }
    isExpanded() {
        const contentsElem = this.el.querySelector(`div`);
        if (contentsElem === null) throw new Error(`contents div not found`);
        return contentsElem.style.display === ``;
    }
    setExpanded(value) {
        const contentsElem = this.el.querySelector(`div`);
        const button = this.el.querySelector(`button`);
        if (button === null) throw new Error(`Button element not found`);
        if (contentsElem === null) throw new Error(`Contents element not found`);
        if (value) {
            contentsElem.style.display = ``;
            button.innerText = `\u{1F53C}`;
        } else {
            contentsElem.style.display = `none`;
            button.innerText = `\u{1F53D}`;
        }
    }
    clear() {
        this.clearCanvas(document.getElementById(`rendererComponentFreqData`));
        this.clearCanvas(document.getElementById(`rendererComponentWaveData`));
    }
    // Clears a canvas to white
    clearCanvas(canvas) {
        if (canvas === null) throw new Error(`Canvas is null`);
        const g = canvas.getContext(`2d`);
        if (g === null) throw new Error(`Cannot create drawing context`);
        g.fillStyle = `white`;
        g.fillRect(0, 0, canvas.clientWidth, canvas.clientHeight);
    }
    // Renders waveform data.
    // Adapted from MDN's AnalyserNode.getFloatTimeDomainData() example
    renderWave(wave, bipolar = true) {
        if (!this.isExpanded()) return;
        if (!wave) return;
        const canvas = document.getElementById(`rendererComponentWaveData`);
        if (canvas === null) throw new Error(`Cannot find wave canvas`);
        const g = canvas.getContext(`2d`);
        if (g === null) throw new Error(`Cannot create drawing context for wave`);
        const canvasWidth = canvas.clientWidth;
        const canvasHeight = canvas.clientHeight;
        const pointer = this.getPointerRelativeTo(canvas);
        const infoAreaHeight = 20;
        const infoAreaWidth = 60;
        const bins = wave.length;
        g.fillStyle = `white`;
        g.fillRect(0, 0, infoAreaWidth, infoAreaHeight);
        const width = canvasWidth / bins;
        g.fillStyle = `rgba(255, 255, 255, 0.03)`;
        g.fillRect(0, 20, canvasWidth, canvasHeight);
        g.fillStyle = `red`;
        if (bipolar) g.fillRect(0, canvasHeight / 2, canvasWidth, 1);
        else g.fillRect(0, canvasHeight - 1, canvasWidth, 1);
        g.lineWidth = 1;
        g.strokeStyle = `black`;
        g.beginPath();
        let x = 0;
        for(let i = 0; i < bins; i++){
            const height = wave[i] * canvasHeight;
            const y = bipolar ? canvasHeight / 2 - height : canvasHeight - height;
            if (i === 0) g.moveTo(x, y);
            else g.lineTo(x, y);
            x += width;
            if (this.pointerDown) this.waveTracker.seen(wave[i]);
        }
        g.lineTo(canvasWidth, bipolar ? canvasHeight / 2 : canvasHeight);
        g.stroke();
        if (this.pointerDown) {
            const waveMma = this.waveTracker.getMinMaxAvg();
            g.fillStyle = `rgba(255,255,0,1)`;
            g.fillRect(infoAreaWidth, 0, 150, 20);
            g.fillStyle = `black`;
            g.fillText(`Min: ` + waveMma.min.toFixed(2), 60, 10);
            g.fillText(`Max: ` + waveMma.max.toFixed(2), 110, 10);
            g.fillText(`Avg: ` + waveMma.avg.toFixed(2), 160, 10);
        } else this.waveTracker.reset();
        if (pointer.y > 0 && pointer.y <= canvasHeight && pointer.x >= 0 && pointer.x <= canvasWidth) {
            g.fillStyle = `black`;
            g.fillText(`Level: ` + (1 - pointer.y / canvasHeight).toFixed(2), 2, 10);
        }
    }
    // Yields pointer position relative to given element
    getPointerRelativeTo(elem) {
        const rect = elem.getBoundingClientRect();
        return {
            x: this.lastPointer.x - rect.left - window.scrollX,
            //elem.offsetLeft + window.scrollX,
            y: this.lastPointer.y - rect.top - window.scrollY
        };
    }
    // Keeps track of last pointer position in page coordinate space
    onPointer(evt) {
        this.lastPointer = {
            x: evt.pageX,
            y: evt.pageY
        };
        evt.preventDefault();
    }
};
// src/io/audio/Analyser.ts
var $367b84d0d2a414aa$var$analyserBasic = (onData, opts = {})=>new $367b84d0d2a414aa$var$AudioAnalyser2((node, analyser)=>{
        const freq = new Float32Array(node.frequencyBinCount);
        const wave = new Float32Array(node.fftSize);
        node.getFloatFrequencyData(freq);
        node.getFloatTimeDomainData(wave);
        onData(freq, wave, analyser);
    }, opts);
var $367b84d0d2a414aa$var$analyserFrequency = (onData, opts = {})=>new $367b84d0d2a414aa$var$AudioAnalyser2((node, analyser)=>{
        const freq = new Float32Array(node.frequencyBinCount);
        node.getFloatFrequencyData(freq);
        onData(freq, analyser);
    }, opts);
var $367b84d0d2a414aa$var$analyserPeakLevel = (onData, opts = {})=>new $367b84d0d2a414aa$var$AudioAnalyser2((node, analyser)=>{
        const wave = new Float32Array(node.fftSize);
        node.getFloatTimeDomainData(wave);
        onData((0, $36aa4387660da012$export$f41fc95ce818cf3e)(wave), analyser);
    }, opts);
var $367b84d0d2a414aa$var$AudioAnalyser2 = class {
    #isPaused = false;
    #initInProgress = false;
    constructor(analyse, opts = {}){
        this.showVis = opts.showVis ?? false;
        this.fftSize = opts.fftSize ?? 1024;
        this.debug = opts.debug ?? false;
        this.smoothingTimeConstant = opts.smoothingTimeConstant ?? 0.8;
        (0, $984cc5641d701af3$export$a4ff393eb12b0888)(this.fftSize, `positive`, `opts.fftSize`);
        (0, $984cc5641d701af3$export$d60fcb8dda779864)(this.smoothingTimeConstant, `percentage`, `opts.smoothingTimeConstant`);
        if (!(0, $984cc5641d701af3$export$b9e43d1765415474)(this.fftSize)) throw new Error(`fftSize must be a power of two from 32 to 32768 (${this.fftSize})`);
        if (this.fftSize < 32) throw new Error(`fftSize must be at least 32`);
        if (this.fftSize > 32768) throw new Error(`fftSize must be no greater than 32768`);
        this.analyse = analyse;
        this.paused = false;
        this.init();
        const visualiserEl = document.querySelector(`#audio-visualiser`);
        if (visualiserEl) {
            const visualiser = new $367b84d0d2a414aa$var$AudioVisualiser(visualiserEl, this);
            visualiser.setExpanded(this.showVis);
            this.visualiser = visualiser;
        }
    }
    init() {
        if (this.#initInProgress) {
            if (this.debug) console.debug(`Init already in progress`);
            return;
        }
        this.#initInProgress = true;
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((stream)=>{
            this.onMicSuccess(stream);
        }).catch((error)=>{
            this.#initInProgress = false;
            console.error(error);
        });
    }
    get paused() {
        return this.#isPaused;
    }
    set paused(v) {
        if (v === this.#isPaused) return;
        this.#isPaused = v;
        if (v) {
            if (this.debug) console.log(`Paused`);
        } else {
            if (this.debug) console.log(`Unpaused`);
            window.requestAnimationFrame(this.analyseLoop.bind(this));
        }
    }
    setup(context, stream) {
        const analyser = context.createAnalyser();
        analyser.fftSize = this.fftSize;
        analyser.smoothingTimeConstant = this.smoothingTimeConstant;
        const micSource = context.createMediaStreamSource(stream);
        micSource.connect(analyser);
        return analyser;
    }
    // Microphone successfully initalised, now have access to audio data
    onMicSuccess(stream) {
        try {
            const context = new AudioContext();
            context.addEventListener(`statechange`, ()=>{
                if (this.debug) console.log(`Audio context state: ${context.state}`);
            });
            this.audioCtx = context;
            this.analyserNode = this.setup(context, stream);
            window.requestAnimationFrame(this.analyseLoop.bind(this));
        } catch (error) {
            this.#initInProgress = false;
            console.error(error);
        }
    }
    analyseLoop() {
        if (this.paused) {
            if (this.debug) console.log(`Paused`);
            return;
        }
        const a = this.analyserNode;
        if (a === void 0) {
            console.warn(`Analyser undefined`);
            return;
        }
        try {
            this.analyse(a, this);
        } catch (error) {
            console.error(error);
        }
        window.requestAnimationFrame(this.analyseLoop.bind(this));
    }
    // visualise(wave, freq) {
    //   if (!this.visualiser) return;
    //   this.visualiser.renderWave(wave, true);
    //   this.visualiser.renderFreq(freq);
    // }
    /**
   * Returns the maximum FFT value within the given frequency range
   */ getFrequencyRangeMax(lowFreq, highFreq, freqData) {
        const samples = this.sliceByFrequency(lowFreq, highFreq, freqData);
        return (0, $36aa4387660da012$export$8960430cfd85939f)(samples);
    }
    /**
   * Returns a sub-sampling of frequency analysis data that falls between
   * `lowFreq` and `highFreq`.
   * @param lowFreq Low frequency
   * @param highFreq High frequency
   * @param freqData Full-spectrum frequency data
   * @returns Sub-sampling of analysis
   */ sliceByFrequency(lowFreq, highFreq, freqData) {
        const lowIndex = this.getIndexForFrequency(lowFreq);
        const highIndex = this.getIndexForFrequency(highFreq);
        const samples = freqData.slice(lowIndex, highIndex);
        return samples;
    }
    /**
   * Returns the starting frequency for a given binned frequency index.
   * @param index Array index
   * @returns Sound frequency
   */ getFrequencyAtIndex(index) {
        const a = this.analyserNode;
        const ctx = this.audioCtx;
        if (a === void 0) throw new Error(`Analyser not available`);
        if (ctx === void 0) throw new Error(`Audio context not available`);
        (0, $984cc5641d701af3$export$a4ff393eb12b0888)(index, `positive`, `index`);
        if (index > a.frequencyBinCount) throw new Error(`Index ${index} exceeds frequency bin count ${a.frequencyBinCount}`);
        return index * ctx.sampleRate / (a.frequencyBinCount * 2);
    }
    /**
   * Returns a binned array index for a given frequency
   * @param freq Sound frequency
   * @returns Array index into frequency bins
   */ getIndexForFrequency(freq) {
        const a = this.analyserNode;
        if (a === void 0) throw new Error(`Analyser not available`);
        const nyquist = a.context.sampleRate / 2;
        const index = Math.round(freq / nyquist * a.frequencyBinCount);
        if (index < 0) return 0;
        if (index >= a.frequencyBinCount) return a.frequencyBinCount - 1;
        return index;
    }
};
// src/io/audio/FromAudioElement.ts
var $367b84d0d2a414aa$var$AudioElements = class {
    constructor(){
        this.#initialised = false;
        this.#sources = /* @__PURE__ */ new Map();
        this.filterType = `lowpass`;
    }
    #initialised;
    #sources;
    init() {
        if (this.#initialised) return;
        this.#initialised = true;
        for (const element of document.querySelectorAll(`audio`))this.#sources.set(element.id, $367b84d0d2a414aa$var$createFromAudioElement(element, this.filterType));
    }
    /**
   * Gets a BasicAudio instance by key
   * @param key 
   * @returns BasicAudio instance, or undefined
   */ get(key) {
        this.init();
        return this.#sources.get(key);
    }
};
function $367b84d0d2a414aa$var$createFromAudioElement(audioElementOrQuery, filterType = `lowpass`) {
    const el = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(audioElementOrQuery);
    const context = new AudioContext();
    const source = context.createMediaElementSource(el);
    const pan = context.createStereoPanner();
    const gain = context.createGain();
    const filter = context.createBiquadFilter();
    filter.type = filterType;
    source.connect(gain);
    gain.connect(pan);
    pan.connect(filter);
    filter.connect(context.destination);
    return {
        pan: pan,
        gain: gain,
        filter: filter,
        id: el.id,
        ctx: context,
        el: el
    };
}
// src/io/audio/FromOscillator.ts
function $367b84d0d2a414aa$var$createOscillator(oscillatorOptions = {}) {
    const context = new AudioContext();
    const oscType = oscillatorOptions.type ?? `sawtooth`;
    const oscFreq = oscillatorOptions.frequency ?? 440;
    const id = oscillatorOptions.id ?? (0, $3908e3e0730c98b2$export$310c142d2eb4f21b)();
    const source = context.createOscillator();
    source.type = oscType;
    source.frequency.setValueAtTime(oscFreq, context.currentTime);
    const pan = context.createStereoPanner();
    const gain = context.createGain();
    const filter = context.createBiquadFilter();
    source.connect(gain);
    gain.connect(pan);
    pan.connect(filter);
    filter.connect(context.destination);
    return {
        pan: pan,
        gain: gain,
        filter: filter,
        ctx: context,
        osc: source,
        id: id
    };
}
// src/io/Espruino.ts
var $367b84d0d2a414aa$export$c8c3369655bc5c65 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($367b84d0d2a414aa$export$c8c3369655bc5c65, {
    EspruinoBleDevice: ()=>$367b84d0d2a414aa$var$EspruinoBleDevice,
    EspruinoSerialDevice: ()=>$367b84d0d2a414aa$var$EspruinoSerialDevice,
    bangle: ()=>$367b84d0d2a414aa$var$bangle,
    connectBle: ()=>$367b84d0d2a414aa$var$connectBle,
    deviceEval: ()=>$367b84d0d2a414aa$var$deviceEval,
    puck: ()=>$367b84d0d2a414aa$var$puck,
    serial: ()=>$367b84d0d2a414aa$var$serial
});
// src/io/EspruinoBleDevice.ts
var $367b84d0d2a414aa$var$EspruinoBleDevice = class extends $367b84d0d2a414aa$var$NordicBleDevice {
    /**
   * Creates instance. You probably would rather use {@link puck} to create.
   * @param device
   * @param opts
   */ constructor(device, opts = {}){
        super(device, opts);
        this.evalReplyBluetooth = true;
        this.evalTimeoutMs = opts.evalTimeoutMs ?? 5000;
    }
    /**
   * Writes a script to Espruino.
   *
   * It will first send a CTRL+C to cancel any previous input, `reset()` to clear the board,
   * and then the provided `code` followed by a new line.
   *
   * Use {@link eval} instead to execute remote code and get the result back.
   *
   * ```js
   * // Eg from https://www.espruino.com/Web+Bluetooth
   * writeScript(`
   *  setInterval(() => Bluetooth.println(E.getTemperature()), 1000);
   *  NRF.on('disconnect',()=>reset());
   * `);
   * ```
   *
   * @param code Code to send. A new line is added automatically.
   */ // eslint-disable-next-line @typescript-eslint/require-await
    async writeScript(code) {
        this.write(`reset();
`);
        this.write(`${code}
`);
    }
    /**
   * Sends some code to be executed on the Espruino. The result
   * is packaged into JSON and sent back to your code. An exception is
   * thrown if code can't be executed for some reason.
   *
   * ```js
   * const sum = await e.eval(`2+2`);
   * ```
   *
   * It will wait for a period of time for a well-formed response from the
   * Espruino. This might not happen if there is a connection problem
   * or a syntax error in the code being evaled. In cases like the latter,
   * it will take up to `timeoutMs` (default 5 seconds) before we give up
   * waiting for a correct response and throw an error.
   *
   * Tweaking of the timeout may be required if `eval()` is giving up too quickly
   * or too slowly. A default timeout can be given when creating the class.
   *
   * Options:
   *  timeoutMs: Timeout for execution. 5 seconds by default
   *  assumeExclusive If true, eval assumes all replies from controller are in response to eval. True by default
   *  debug: If true, execution is traced via `warn` callback
   * @param code Code to run on the Espruino.
   * @param opts Options
   * @param warn Function to pass warning/trace messages to. If undefined, this.warn is used, printing to console.
   */ async eval(code, opts = {}, warn) {
        const debug = opts.debug ?? false;
        const warnCallback = warn ?? ((m)=>{
            this.warn(m);
        });
        return $367b84d0d2a414aa$var$deviceEval(code, opts, this, `Bluetooth.println`, debug, warnCallback);
    }
};
// src/io/Serial.ts
var $367b84d0d2a414aa$export$a9bbb9c706f2bf62 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($367b84d0d2a414aa$export$a9bbb9c706f2bf62, {
    Device: ()=>$367b84d0d2a414aa$var$Device
});
// src/io/JsonDevice.ts
var $367b84d0d2a414aa$var$JsonDevice = class extends (0, $96f72d8c52c10ae7$export$115762dd560f5323) {
    constructor(config = {}){
        super();
        this.verboseLogging = false;
        this.verboseLogging = config.debug ?? false;
        this.chunkSize = config.chunkSize ?? 1024;
        this.connectAttempts = config.connectAttempts ?? 3;
        this.name = config.name ?? `JsonDevice`;
        this.txBuffer = new $367b84d0d2a414aa$export$2fcd064f08f54e20(async (data)=>{
            await this.writeInternal(data);
        }, config);
        this.rxBuffer = new $367b84d0d2a414aa$export$fe9a3929a3a2427f((line)=>{
            this.fireEvent(`data`, {
                data: line
            });
        });
        this.codec = new $367b84d0d2a414aa$export$a111e9ced3f1d2d0();
        this.states = new (0, $29a41e51920ca8b4$export$9b20b63dc5d1b3c0)($367b84d0d2a414aa$export$f7446a661cc02f10, {
            initial: `ready`
        });
        this.states.addEventListener(`change`, (event)=>{
            this.fireEvent(`change`, event);
            this.verbose(`${event.priorState} -> ${event.newState}`);
            if (event.priorState === `connected`) {
                this.rxBuffer.clear();
                this.txBuffer.clear();
            }
        });
    }
    get isConnected() {
        return this.states.state === `connected`;
    }
    get isClosed() {
        return this.states.state === `closed`;
    }
    write(txt) {
        if (this.states.state !== `connected`) throw new Error(`Cannot write while state is ${this.states.state}`);
        this.txBuffer.add(txt);
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async close() {
        if (this.states.state !== `connected`) return;
        this.onClosed();
    }
    async connect() {
        const attempts = this.connectAttempts;
        this.states.state = `connecting`;
        await this.onPreConnect();
        await (0, $f53657e65b61d2bb$export$868bf35b6ef95abe)(async ()=>{
            await this.onConnectAttempt();
            this.states.state = `connected`;
            return true;
        }, {
            limitAttempts: attempts,
            startAt: 200
        });
    }
    onRx(event) {
        const view = event.target.value;
        if (view === void 0) return;
        let string_ = this.codec.fromBuffer(view.buffer);
        const plzStop = (0, $ae8f83c19bfd8110$export$98697ab6aa598b83)(string_, 19);
        const plzStart = (0, $ae8f83c19bfd8110$export$98697ab6aa598b83)(string_, 17);
        if (plzStart && plzStop < plzStart) {
            this.verbose(`Tx plz start`);
            string_ = (0, $ae8f83c19bfd8110$export$aafb194044d2a289)(string_, plzStart, 1);
            this.txBuffer.paused = false;
        }
        if (plzStop && plzStop > plzStart) {
            this.verbose(`Tx plz stop`);
            string_ = (0, $ae8f83c19bfd8110$export$aafb194044d2a289)(string_, plzStop, 1);
            this.txBuffer.paused = true;
        }
        this.rxBuffer.add(string_);
    }
    verbose(m) {
        if (this.verboseLogging) console.info(`${this.name}`, m);
    }
    log(m) {
        console.log(`${this.name}`, m);
    }
    warn(m) {
        console.warn(`${this.name}`, m);
    }
};
// src/io/Serial.ts
var $367b84d0d2a414aa$var$Device = class extends $367b84d0d2a414aa$var$JsonDevice {
    constructor(config = {}){
        super(config);
        this.config = config;
        this.abort = new AbortController();
        const eol = config.eol ?? `\r
`;
        this.baudRate = config.baudRate ?? 9600;
        if (config.name === void 0) this.name = `Serial.Device`;
        this.rxBuffer.separator = eol;
    }
    /**
   * Writes text collected in buffer
   * @param txt
   */ async writeInternal(txt) {
        if (this.tx === void 0) throw new Error(`tx not ready`);
        try {
            this.tx.write(txt);
        } catch (error) {
            this.warn(error);
        }
    }
    onClosed() {
        this.tx?.releaseLock();
        this.abort.abort(`closing port`);
        this.states.state = `closed`;
    }
    onPreConnect() {
        return Promise.resolve();
    }
    async onConnectAttempt() {
        let reqOpts = {};
        const openOpts = {
            baudRate: this.baudRate
        };
        if (this.config.filters) reqOpts = {
            filters: [
                ...this.config.filters
            ]
        };
        this.port = await navigator.serial.requestPort(reqOpts);
        this.port.addEventListener(`disconnect`, (_)=>{
            this.close();
        });
        await this.port.open(openOpts);
        const txW = this.port.writable;
        const txText = new TextEncoderStream();
        if (txW !== null) {
            txText.readable.pipeTo(txW, {
                signal: this.abort.signal
            }).catch((error)=>{
                console.log(`Serial.onConnectAttempt txText pipe:`);
                console.log(error);
            });
            this.tx = txText.writable.getWriter();
        }
        const rxR = this.port.readable;
        const rxText = new TextDecoderStream();
        if (rxR !== null) {
            rxR.pipeTo(rxText.writable, {
                signal: this.abort.signal
            }).catch((error)=>{
                console.log(`Serial.onConnectAttempt rxR pipe:`);
                console.log(error);
            });
            rxText.readable.pipeTo(this.rxBuffer.writable(), {
                signal: this.abort.signal
            }).catch((error)=>{
                console.log(`Serial.onConnectAttempt rxText pipe:`);
                console.log(error);
                try {
                    this.port?.close();
                } catch (error2) {
                    console.log(error2);
                }
            });
        }
    }
};
// src/io/EspruinoSerialDevice.ts
var $367b84d0d2a414aa$var$EspruinoSerialDevice = class extends $367b84d0d2a414aa$var$Device {
    constructor(opts){
        super(opts);
        this.evalReplyBluetooth = false;
        if (opts === void 0) opts = {};
        this.evalTimeoutMs = opts.evalTimeoutMs ?? 5000;
    }
    async disconnect() {
        return super.close();
    }
    /**
   * Writes a script to Espruino.
   *
   * It will first send a CTRL+C to cancel any previous input, `reset()` to clear the board,
   * and then the provided `code` followed by a new line.
   *
   * Use {@link eval} instead to execute remote code and get the result back.
   *
   * ```js
   * // Eg from https://www.espruino.com/Web+Bluetooth
   * writeScript(`
   *  setInterval(() => Bluetooth.println(E.getTemperature()), 1000);
   *  NRF.on('disconnect',()=>reset());
   * `);
   * ```
   *
   * @param code Code to send. A new line is added automatically.
   */ writeScript(code) {
        this.write(`reset();
`);
        this.write(`${code}
`);
    }
    /**
   * Sends some code to be executed on the Espruino. The result
   * is packaged into JSON and sent back to your code. An exception is
   * thrown if code can't be executed for some reason.
   *
   * ```js
   * const sum = await e.eval(`2+2`);
   * ```
   *
   * It will wait for a period of time for a well-formed response from the
   * Espruino. This might not happen if there is a connection problem
   * or a syntax error in the code being evaled. In cases like the latter,
   * it will take up to `timeoutMs` (default 5 seconds) before we give up
   * waiting for a correct response and throw an error.
   *
   * Tweaking of the timeout may be required if `eval()` is giving up too quickly
   * or too slowly. A default timeout can be given when creating the class.
   *
   * Options:
   *  timeoutMs: Timeout for execution. 5 seconds by default
   *  assumeExclusive: If true, eval assumes all replies from controller are in response to eval. True by default
   *  debug: If true, execution is traced via `warn` callback
   * @param code Code to run on the Espruino.
   * @param opts Options
   * @param warn Function to pass warning/trace messages to. If undefined, this.warn is used, printing to console.
   */ async eval(code, opts = {}, warn) {
        const debug = opts.debug ?? false;
        const warner = warn ?? ((m)=>{
            this.warn(m);
        });
        return $367b84d0d2a414aa$var$deviceEval(code, opts, this, `USB.println`, debug, warner);
    }
};
// src/io/Espruino.ts
var $367b84d0d2a414aa$var$puck = async (opts = {})=>{
    const name = opts.name ?? `Puck`;
    const debug = opts.debug ?? false;
    const device = await navigator.bluetooth.requestDevice({
        filters: $367b84d0d2a414aa$var$getFilters(opts, `Puck.js`),
        optionalServices: [
            $367b84d0d2a414aa$var$defaultOpts.service
        ]
    });
    if (opts.debug) console.info(`Espruino.puck device name: ${device.name}`);
    const d = new $367b84d0d2a414aa$var$EspruinoBleDevice(device, {
        name: name,
        debug: debug
    });
    await d.connect();
    return d;
};
var $367b84d0d2a414aa$var$bangle = async (opts = {})=>{
    const name = opts.name ?? `Bangle`;
    const debug = opts.debug ?? false;
    const device = await navigator.bluetooth.requestDevice({
        filters: $367b84d0d2a414aa$var$getFilters(opts, `Bangle.js`),
        optionalServices: [
            $367b84d0d2a414aa$var$defaultOpts.service
        ]
    });
    if (opts.debug) console.info(`Espruino.bangle device name: ${device.name}`);
    const d = new $367b84d0d2a414aa$var$EspruinoBleDevice(device, {
        name: name,
        debug: debug
    });
    await d.connect();
    return d;
};
var $367b84d0d2a414aa$var$serial = async (opts = {})=>{
    const d = new $367b84d0d2a414aa$var$EspruinoSerialDevice(opts);
    await d.connect();
    return d;
};
var $367b84d0d2a414aa$var$getFilters = (opts, defaultNamePrefix)=>{
    const filters = [];
    if (opts.filters) filters.push(...opts.filters);
    else if (opts.name) {
        filters.push({
            name: opts.name
        });
        console.info(`Filtering Bluetooth devices by name '${opts.name}'`);
    } else filters.push({
        namePrefix: defaultNamePrefix
    });
    return filters;
};
var $367b84d0d2a414aa$var$connectBle = async (opts = {})=>{
    const device = await navigator.bluetooth.requestDevice({
        filters: $367b84d0d2a414aa$var$getFilters(opts, `Puck.js`),
        optionalServices: [
            $367b84d0d2a414aa$var$defaultOpts.service
        ]
    });
    const d = new $367b84d0d2a414aa$var$EspruinoBleDevice(device, {
        name: `Espruino`,
        ...opts
    });
    await d.connect();
    return d;
};
var $367b84d0d2a414aa$var$deviceEval = async (code, opts = {}, device, evalReplyPrefix, debug, warn)=>{
    const timeoutMs = opts.timeoutMs ?? device.evalTimeoutMs;
    const assumeExclusive = opts.assumeExclusive ?? true;
    if (typeof code !== `string`) throw new TypeError(`Param 'code' should be a string. Got: ${typeof code}`);
    return new Promise((resolve, reject)=>{
        const id = (0, $ae8f83c19bfd8110$export$22b082955e083ec3)(5);
        const onData = (d)=>{
            try {
                let cleaned = d.data.trim();
                if (cleaned.startsWith(`>{`) && cleaned.endsWith(`}`)) cleaned = cleaned.slice(1);
                const dd = JSON.parse(cleaned);
                if (`reply` in dd) {
                    if (dd.reply === id) {
                        done();
                        if (`result` in dd) resolve(dd.result);
                    } else warn(`Expected reply ${id}, got ${dd.reply}`);
                } else warn(`Expected packet, missing 'reply' field. Got: ${d.data}`);
            } catch (error) {
                if (assumeExclusive) done(`Unexpected reply: ${d.data}. Error: ${(0, $96302e292290d7c3$export$82f46aa4e6535a45)(error)}`);
                else warn((0, $96302e292290d7c3$export$82f46aa4e6535a45)(error));
            }
        };
        const onStateChange = (event)=>{
            if (event.newState !== `connected`) done(`State changed to '${event.newState}', aborting`);
        };
        device.addEventListener(`data`, onData);
        device.addEventListener(`change`, onStateChange);
        const done = (0, $f53657e65b61d2bb$export$9bbfceb27f687c1b)(timeoutMs, (reason)=>{
            reject(new Error(reason));
        }, (_success)=>{
            device.removeEventListener(`data`, onData);
            device.removeEventListener(`change`, onStateChange);
        });
        const source = `${evalReplyPrefix}(JSON.stringify({reply:"${id}", result:JSON.stringify(${code})}))
`;
        if (debug) warn(source);
        device.write(source);
    });
};
// src/io/Camera.ts
var $367b84d0d2a414aa$export$558ce0eb0d28d98b = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($367b84d0d2a414aa$export$558ce0eb0d28d98b, {
    dumpDevices: ()=>$367b84d0d2a414aa$var$dumpDevices,
    start: ()=>$367b84d0d2a414aa$var$start
});
var $367b84d0d2a414aa$var$startTimeoutMs = 1e4;
var $367b84d0d2a414aa$var$dumpDevices = async (filterKind = `videoinput`)=>{
    const devices = await navigator.mediaDevices.enumerateDevices();
    for (const d of devices){
        if (d.kind !== filterKind) continue;
        console.log(d.label);
        console.log(` Kind: ${d.kind}`);
        console.log(` Device id: ${d.deviceId}`);
    }
};
var $367b84d0d2a414aa$var$start = async (constraints = {})=>{
    const videoEl = document.createElement(`VIDEO`);
    videoEl.style.display = `none`;
    videoEl.playsInline = true;
    videoEl.muted = true;
    videoEl.classList.add(`ixfx-camera`);
    document.body.append(videoEl);
    let stopVideo = ()=>{};
    const dispose = ()=>{
        try {
            stopVideo();
        } catch  {}
        videoEl.remove();
    };
    try {
        const r = await $367b84d0d2a414aa$var$startWithVideoEl(videoEl, constraints);
        stopVideo = r.dispose;
        return {
            videoEl: videoEl,
            dispose: dispose
        };
    } catch (error) {
        console.error(error);
        dispose();
        throw error;
    }
};
var $367b84d0d2a414aa$var$startWithVideoEl = async (videoEl, constraints = {})=>{
    if (videoEl === void 0) throw new Error(`videoEl undefined`);
    if (videoEl === null) throw new Error(`videoEl null`);
    const maxResolution = constraints.max;
    const minResolution = constraints.min;
    const idealResolution = constraints.ideal;
    const c = {
        audio: false,
        video: {
            width: {},
            height: {}
        }
    };
    if (constraints.facingMode === `front`) constraints = {
        ...constraints,
        facingMode: `user`
    };
    if (constraints.facingMode === `back`) constraints = {
        ...constraints,
        facingMode: `environment`
    };
    if (constraints.facingMode) c.video.facingMode = constraints.facingMode;
    if (constraints.deviceId) c.video.deviceId = constraints.deviceId;
    if (idealResolution) {
        c.video.width = {
            ...c.video.width,
            ideal: idealResolution.width
        };
        c.video.height = {
            ...c.video.height,
            ideal: idealResolution.height
        };
    }
    if (maxResolution) {
        c.video.width = {
            ...c.video.width,
            max: maxResolution.width
        };
        c.video.height = {
            ...c.video.height,
            max: maxResolution.height
        };
    }
    if (minResolution) {
        c.video.width = {
            ...c.video.width,
            min: minResolution.width
        };
        c.video.height = {
            ...c.video.height,
            min: minResolution.height
        };
    }
    const done = (0, $f53657e65b61d2bb$export$9bbfceb27f687c1b)(constraints.startTimeoutMs ?? $367b84d0d2a414aa$var$startTimeoutMs, (reason)=>{
        throw new Error(`Camera getUserMedia failed: ${reason}`);
    });
    try {
        const stream = await navigator.mediaDevices.getUserMedia(c);
        const dispose = ()=>{
            videoEl.pause();
            const t = stream.getTracks();
            for (const track of t)track.stop();
        };
        videoEl.srcObject = stream;
        done();
        const returnValue = {
            videoEl: videoEl,
            dispose: dispose
        };
        const p = new Promise((resolve, reject)=>{
            videoEl.addEventListener(`loadedmetadata`, ()=>{
                videoEl.play().then(()=>{
                    resolve(returnValue);
                }).catch((error)=>{
                    reject(error);
                });
            });
        });
        return p;
    } catch (error) {
        done((0, $96302e292290d7c3$export$82f46aa4e6535a45)(error));
        throw error;
    }
};
// src/io/VideoFile.ts
var $367b84d0d2a414aa$export$59bf13843ffda7df = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($367b84d0d2a414aa$export$59bf13843ffda7df, {
    start: ()=>$367b84d0d2a414aa$var$start2
});
var $367b84d0d2a414aa$var$start2 = async (file)=>{
    const videoEl = document.createElement(`VIDEO`);
    videoEl.style.display = `none`;
    videoEl.playsInline = true;
    videoEl.muted = true;
    videoEl.classList.add(`ixfx-video`);
    document.body.appendChild(videoEl);
    let stopVideo = ()=>{};
    const dispose = ()=>{
        try {
            stopVideo();
        } catch  {}
        videoEl.remove();
    };
    try {
        const r = await $367b84d0d2a414aa$var$startWithVideoEl2(videoEl, file);
        stopVideo = r.dispose;
        return {
            videoEl: videoEl,
            dispose: dispose
        };
    } catch (ex) {
        console.error(ex);
        dispose();
        throw ex;
    }
};
var $367b84d0d2a414aa$var$startWithVideoEl2 = async (videoEl, file)=>{
    if (videoEl === void 0) throw new Error(`videoEl undefined`);
    if (videoEl === null) throw new Error(`videoEl null`);
    const url = URL.createObjectURL(file);
    videoEl.src = url;
    videoEl.loop = true;
    const dispose = ()=>{
        videoEl.pause();
    };
    const ret = {
        videoEl: videoEl,
        dispose: dispose
    };
    const p = new Promise((resolve, reject)=>{
        videoEl.addEventListener(`loadedmetadata`, ()=>{
            videoEl.play().then(()=>{
                resolve(ret);
            }).catch((ex)=>{
                reject(ex);
            });
        });
    });
    return p;
};
// src/io/FrameProcessor.ts
var $367b84d0d2a414aa$export$1d7e16ee15e61187 = class {
    /**
   * Create a new frame processor
   * @param opts
   */ constructor(opts = {}){
        this._teardownNeeded = false;
        this._state = `ready`;
        this._source = ``;
        this._timer = performance.now();
        this._showCanvas = opts.showCanvas ?? false;
        this._showPreview = opts.showPreview ?? false;
        this._cameraConstraints = opts.cameraConstraints ?? void 0;
        this._captureCanvasEl = opts.captureCanvasEl ?? void 0;
        this._postCaptureDraw = opts.postCaptureDraw;
    }
    /**
   * Hides or shows the raw source in the DOM
   * @param enabled Preview enabled
   */ showPreview(enabled) {
        if (this._state === `disposed`) throw new Error(`Disposed`);
        let el;
        switch(this._source){
            case `camera`:
                el = this._cameraStartResult?.videoEl;
                if (el !== void 0) el.style.display = enabled ? `block` : `none`;
                break;
        }
        this._showPreview = enabled;
    }
    /**
   * Shows or hides the Canvas we're capturing to
   * @param enabled
   */ showCanvas(enabled) {
        if (this._state === `disposed`) throw new Error(`Disposed`);
        let el;
        if (this._source === `camera` || this._source === `video`) {
            el = this._videoSourceCapture?.canvasEl;
            if (el !== void 0) el.style.display = enabled ? `block` : `none`;
        } else throw new Error(`Source not implemented: ${this._source}`);
        this._showCanvas = enabled;
    }
    /**
   * Returns the current capturer instance
   * @returns
   */ getCapturer() {
        if (this._state === `disposed`) throw new Error(`Disposed`);
        if (this._source === `camera` || this._source === `video`) return this._videoSourceCapture;
        throw new Error(`Source kind not supported ${this._source}`);
    }
    /**
   * Grab frames from a video camera source and initialises
   * frame processor.
   *
   * If `constraints` are not specified, it will use the ones
   * provided when creating the class, or defaults.
   *
   * @param constraints Override of constraints when requesting camera access
   */ async useCamera(constraints) {
        if (this._state === `disposed`) throw new Error(`Disposed`);
        this._source = `camera`;
        if (this._teardownNeeded) this.teardown();
        if (constraints) this._cameraConstraints;
        await this.init();
    }
    async useVideo(file) {
        if (this._state === `disposed`) throw new Error(`Disposed`);
        this._source = `video`;
        if (this._teardownNeeded) this.teardown();
        this._videoFile = file;
        await this.init();
    }
    /**
   * Initialises camera
   */ async initCamera() {
        const r = await $367b84d0d2a414aa$var$start(this._cameraConstraints);
        if (r === void 0) throw new Error(`Could not start camera`);
        this._cameraStartResult = r;
        this.postInit(r);
    }
    async initVideo() {
        if (!this._videoFile) throw new Error(`Video file not defined`);
        const r = await $367b84d0d2a414aa$var$start2(this._videoFile);
        this._videoStartResult = r;
        this.postInit(r);
    }
    async postInit(r) {
        if (this._showPreview) r.videoEl.style.display = `block`;
        this._videoSourceCapture = (0, $1babec5e26cea186$export$d7a9ca4bff3f3ec8)(r.videoEl, {
            postCaptureDraw: this._postCaptureDraw,
            showCanvas: this._showCanvas,
            canvasEl: this._captureCanvasEl
        });
        this._teardownNeeded = true;
        this._cameraStartResult = r;
    }
    /**
   * Closes down connections and removes created elements.
   * Once disposed, the frame processor cannot be used
   * @returns
   */ dispose() {
        if (this._state === `disposed`) return;
        this.teardown();
        this._state = `disposed`;
    }
    async init() {
        this._timer = performance.now();
        switch(this._source){
            case `camera`:
                await this.initCamera();
                break;
            case `video`:
                await this.initVideo();
                break;
        }
        this._state = `initialised`;
    }
    teardown() {
        if (!this._teardownNeeded) return;
        if (this._source === `camera` || this._source === `video`) this._videoSourceCapture?.dispose();
        switch(this._source){
            case `camera`:
                this._cameraStartResult?.dispose();
                break;
            case `video`:
                this._videoStartResult?.dispose();
                break;
        }
        this._teardownNeeded = false;
    }
    /**
   * Get the last frame
   * @returns
   */ getFrame() {
        if (this._state === `disposed`) throw new Error(`Disposed`);
        switch(this._source){
            case `camera`:
                return this.getFrameCamera();
            case `video`:
                return this.getFrameCamera();
            default:
                throw new Error(`source type unhandled ${this._source}`);
        }
    }
    /**
   * Get the timestamp of the processor (elapsed time since starting)
   * @returns
   */ getTimestamp() {
        return performance.now() - this._timer;
    }
    getFrameCamera() {
        return this._videoSourceCapture?.capture();
    }
};
// src/io/ReconnectingWebSocket.ts
var $367b84d0d2a414aa$export$3e85abc04cb3cc35 = (url, opts = {})=>{
    const startDelayMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(opts.startDelay, 2e3);
    const maxDelayMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(opts.maxDelay, startDelayMs * 10);
    const checkStateMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(opts.checkStateMs, 5e3);
    if (startDelayMs > maxDelayMs) throw new Error(`startDelay should be less than maxDelay`);
    if (checkStateMs < 0) throw new Error(`Param 'checkState' should be above zero`);
    let reconnect = true;
    let currentState = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).init({
        closed: `connecting`,
        open: `closed`,
        connecting: [
            `closed`,
            `open`
        ]
    });
    let ws;
    const onError = (event_)=>{
        if (opts.onError) opts.onError(event_);
        else {
            console.log(`rw on error`, event_);
            console.error(` error: ${event_.error}`);
            console.error(` type: ${event_.type}`);
            console.error(` error msg: ${event_.message}`);
        }
    };
    const onMessage = (message)=>{
        if (opts.onMessage) opts.onMessage(message.data);
    };
    const connect = async ()=>{
        if (currentState.value === `connecting`) throw new Error(`Cannot connect twice`);
        currentState = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(currentState, `connecting`);
        if (ws !== void 0) {
            ws.removeEventListener(`error`, onError);
            if (opts.onMessage) ws.removeEventListener(`message`, onMessage);
            ws = void 0;
        }
        const retry = await (0, $f53657e65b61d2bb$export$603f016548da7e82)({
            async probe (_attempts) {
                try {
                    const wss = new WebSocket(url);
                    const r = await (0, $96f72d8c52c10ae7$export$848b3f93e34d51fc)(wss, [
                        `open`,
                        `error`
                    ], {
                        timeout: 1e3
                    });
                    return r.type === `open` ? {
                        success: true,
                        value: wss
                    } : {
                        success: false,
                        error: `Could not open`
                    };
                } catch (error) {
                    return {
                        success: false,
                        error: (0, $96302e292290d7c3$export$82f46aa4e6535a45)(error)
                    };
                }
            }
        }, {
            predelayMs: startDelayMs,
            limitAttempts: opts.limitAttempts
        });
        ws = retry.value;
        let result = false;
        if (retry.success && ws) {
            opts.onMessage;
            result = true;
            currentState = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(currentState, `open`);
            if (opts.onConnected) opts.onConnected();
        } else currentState = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(currentState, `closed`);
        return result;
    };
    const send = (data)=>{
        if (ws) {
            if (ws.readyState === ws.OPEN) ws.send(data);
            else onDisconnected();
        } else throw new Error(`Not connected`);
    };
    const onDisconnected = ()=>{
        if (currentState.value === `closed`) return;
        if (currentState.value === `open`) {
            currentState = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(currentState, `closed`);
            if (opts.onDisconnected) opts.onDisconnected();
        }
        if (reconnect && currentState.value !== `connecting`) {
            console.log(`Scheduling connect`);
            setTimeout(()=>{
                connect();
            }, 100);
        }
    };
    const isConnected = ()=>{
        if (!ws) return false;
        return ws.readyState === ws.OPEN;
    };
    const close = ()=>{
        reconnect = false;
        currentState = (0, $29a41e51920ca8b4$export$b89f0c42b95fa6f6).to(currentState, `closed`);
        ws?.close();
        if (opts.onDisconnected) opts.onDisconnected();
    };
    const open = ()=>{
        reconnect = true;
        if (currentState.value === `open`) return Promise.resolve(true);
        if (currentState.value === `connecting`) return Promise.resolve(false);
        return connect();
    };
    connect();
    setInterval(()=>{
        if (!ws) return;
        switch(ws.readyState){
            case ws.CLOSED:
                if (currentState.value === `open`) onDisconnected();
                break;
        }
    }, checkStateMs);
    return {
        send: send,
        isConnected: isConnected,
        close: close,
        open: open
    };
};
















// src/iterables/chain/index.ts
var $3a21733ddc25a9d4$export$283b508889bd5942 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($3a21733ddc25a9d4$export$283b508889bd5942, {
    Dom: ()=>$3a21733ddc25a9d4$export$e02548a286707272,
    From: ()=>$3a21733ddc25a9d4$export$83d6c301da3ae43e,
    Links: ()=>$3a21733ddc25a9d4$export$2a722b53f83c6a68,
    addToArray: ()=>$3a21733ddc25a9d4$export$16778529d121119,
    asArray: ()=>$3a21733ddc25a9d4$export$75093a47a9fa838d,
    asCallback: ()=>$3a21733ddc25a9d4$export$11e61faed1285c36,
    asPromise: ()=>$3a21733ddc25a9d4$export$538cda31d79078b8,
    asValue: ()=>$3a21733ddc25a9d4$export$51ea4d7e0db4b093,
    combineLatestToArray: ()=>$3a21733ddc25a9d4$export$b5235d9cdb97b833,
    combineLatestToObject: ()=>$3a21733ddc25a9d4$export$75430b411d43dc3f,
    isGenFactoryNoInput: ()=>$3a21733ddc25a9d4$export$9bc079ce4ee0d921,
    lazy: ()=>$3a21733ddc25a9d4$export$488013bae63b21da,
    mergeFlat: ()=>$3a21733ddc25a9d4$export$1ca97b40e512ebc0,
    prepare: ()=>$3a21733ddc25a9d4$export$18298bb220d85216,
    resolveToAsyncGen: ()=>$3a21733ddc25a9d4$export$19fd2268fac785a6,
    resolveToGen: ()=>$3a21733ddc25a9d4$export$48a2459239ad7f92,
    run: ()=>$3a21733ddc25a9d4$export$889ea624f2cb2c57,
    runN: ()=>$3a21733ddc25a9d4$export$bd33d8a7043b316f,
    single: ()=>$3a21733ddc25a9d4$export$863d7ca51b416cee,
    syncToArray: ()=>$3a21733ddc25a9d4$export$5eb154d8c1f8350,
    timestamp: ()=>$3a21733ddc25a9d4$export$fc00ee57782020aa
});
// src/iterables/chain/Dom.ts
var $3a21733ddc25a9d4$export$e02548a286707272 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($3a21733ddc25a9d4$export$e02548a286707272, {
    perValue: ()=>$3a21733ddc25a9d4$var$perValue,
    query: ()=>$3a21733ddc25a9d4$var$query
});
// src/iterables/chain/Util.ts
function $3a21733ddc25a9d4$export$9bc079ce4ee0d921(c) {
    if (!(`_type` in c)) return false;
    if (c._type === `GenFactoryNoInput`) return true;
    return false;
}
function* $3a21733ddc25a9d4$var$primitiveToGenerator(value) {
    yield value;
}
async function* $3a21733ddc25a9d4$var$primitiveToAsyncGenerator(value) {
    yield value;
    await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(1);
}
function $3a21733ddc25a9d4$export$48a2459239ad7f92(input) {
    if (Array.isArray(input)) {
        const a = input.values();
        a._name = `arrayInput`;
        return a;
    } else if (typeof input === `number` || typeof input === `boolean` || typeof input === `string`) return $3a21733ddc25a9d4$var$primitiveToGenerator(input);
    else if (typeof input === `function`) return input();
    return input;
}
function $3a21733ddc25a9d4$export$19fd2268fac785a6(input) {
    if (input === void 0) return;
    if (Array.isArray(input)) return (0, $2edc1eef02a7c199$export$571d59b505e6bb4e)(input);
    else if (typeof input === `number` || typeof input === `boolean` || typeof input === `string`) return $3a21733ddc25a9d4$var$primitiveToAsyncGenerator(input);
    else if (typeof input === `function`) return input();
    else if ((0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(input)) return input;
    return (0, $2edc1eef02a7c199$export$dcccc29c315dd646)(input);
}
// src/iterables/chain/Dom.ts
var $3a21733ddc25a9d4$var$createMap = (key)=>{
    const keyFunction = key ?? ((value)=>value);
    const map = /* @__PURE__ */ new Map();
    return {
        has (key2) {
            return map.has(keyFunction(key2));
        },
        get (key2) {
            return map.get(keyFunction(key2));
        },
        set (key2, value) {
            map.set(keyFunction(key2), value);
        },
        entries () {
            return map.entries();
        },
        delete (key2) {
            map.delete(key2);
        }
    };
};
function $3a21733ddc25a9d4$var$perValue(options = {}) {
    const byReference = options.byReference;
    const tagName = options.tagName ?? `div`;
    if (byReference && options.key) throw new Error(`byReference and key options are mutually exclusive`);
    const keyFunction = byReference ? void 0 : options.key ?? (0, $847987b26b102cb8$export$f5a6f2033c1996c8);
    const map = $3a21733ddc25a9d4$var$createMap(keyFunction);
    const parentElementOrQuery = options.parentEl ?? document.body;
    const parentEl = (0, $35a128b42d0e06cd$export$5c3b1267168ecce4)(parentElementOrQuery);
    const usedElements = /* @__PURE__ */ new Set();
    async function* perValue2(input) {
        for await (const value of $3a21733ddc25a9d4$export$48a2459239ad7f92(input)){
            let el = map.get(value);
            if (!el) {
                el = document.createElement(tagName);
                map.set(value, el);
                if (options.beforeInsert) options.beforeInsert(el);
                parentEl.append(el);
                if (options.afterInsert) options.afterInsert(el);
            }
            usedElements.add(el);
            yield {
                el: el,
                value: value
            };
        }
        for (const [id, el] of map.entries()){
            if (usedElements.has(el)) continue;
            if (options.beforeRemove) options.beforeRemove(el);
            el.remove();
            map.delete(id);
        }
    }
    perValue2._name = `dom.perValue`;
    return perValue2;
}
function $3a21733ddc25a9d4$var$query(options = {}) {
    const baseElement = options.baseElement ?? document;
    async function* query2(input) {
        const gen = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        for await (const value of gen)for (const element of baseElement.querySelectorAll(value))yield element;
    }
    query2._name = `dom.query`;
    return query2;
}
// src/iterables/chain/Links.ts
var $3a21733ddc25a9d4$export$2a722b53f83c6a68 = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($3a21733ddc25a9d4$export$2a722b53f83c6a68, {
    average: ()=>$3a21733ddc25a9d4$var$average2,
    chunk: ()=>$3a21733ddc25a9d4$var$chunk,
    debounce: ()=>$3a21733ddc25a9d4$var$debounce,
    delay: ()=>$3a21733ddc25a9d4$var$delay,
    drop: ()=>$3a21733ddc25a9d4$var$drop,
    duration: ()=>$3a21733ddc25a9d4$var$duration,
    filter: ()=>$3a21733ddc25a9d4$var$filter,
    max: ()=>$3a21733ddc25a9d4$var$max2,
    min: ()=>$3a21733ddc25a9d4$var$min2,
    rank: ()=>$3a21733ddc25a9d4$var$rank2,
    rankArray: ()=>$3a21733ddc25a9d4$var$rankArray,
    reduce: ()=>$3a21733ddc25a9d4$var$reduce,
    sum: ()=>$3a21733ddc25a9d4$var$sum2,
    take: ()=>$3a21733ddc25a9d4$var$take,
    tally: ()=>$3a21733ddc25a9d4$var$tally2,
    transform: ()=>$3a21733ddc25a9d4$var$transform
});
function $3a21733ddc25a9d4$var$transform(transformer) {
    async function* transform2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        for await (const value of input)yield transformer(value);
    }
    transform2._name = `transform`;
    return transform2;
}
function $3a21733ddc25a9d4$var$take(limit) {
    async function* take2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        let yielded = 0;
        for await (const value of input){
            if (++yielded > limit) break;
            yield value;
        }
    }
    take2._name = `take`;
    return take2;
}
function $3a21733ddc25a9d4$var$reduce(reducer) {
    async function* reduce2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        for await (const value of input)yield reducer(value);
    }
    reduce2._name = `reduce`;
    return reduce2;
}
function $3a21733ddc25a9d4$var$duration(elapsed) {
    const durationMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(elapsed, 0);
    async function* duration2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        const elapsed2 = (0, $29a41e51920ca8b4$export$ae56a3c442de3c6a).since();
        for await (const value of input){
            if (elapsed2() > durationMs) break;
            yield value;
        }
    }
    duration2._name = `duration`;
    return duration2;
}
function $3a21733ddc25a9d4$var$delay(options) {
    const before = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.before, 0);
    const after = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.after, 0);
    async function* delay2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        for await (const value of input){
            if (before > 0) await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(before);
            yield value;
            if (after > 0) await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(after);
        }
    }
    delay2._name = `delay`;
    return delay2;
}
function $3a21733ddc25a9d4$var$debounce(rate) {
    const rateMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(rate, 0);
    async function* debounce2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        let elapsed = (0, $29a41e51920ca8b4$export$ae56a3c442de3c6a).since();
        for await (const value of input){
            if (elapsed() < rateMs) continue;
            yield value;
            elapsed = (0, $29a41e51920ca8b4$export$ae56a3c442de3c6a).since();
        }
    }
    debounce2._name = `debounce`;
    return debounce2;
}
function $3a21733ddc25a9d4$var$tally2(countArrayItems = true) {
    async function* tally3(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        const p = (0, $2edc1eef02a7c199$export$344c33cac828114d)(countArrayItems);
        for await (const v of input)yield p(v);
    }
    tally3._name = `tally`;
    return tally3;
}
function $3a21733ddc25a9d4$var$min2() {
    async function* min3(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        const p = (0, $2edc1eef02a7c199$export$96ec731ed4dcb222)();
        for await (const value of input){
            const x = p(value);
            if (x === void 0) continue;
            yield x;
        }
    }
    min3._name = `min`;
    return min3;
}
function $3a21733ddc25a9d4$var$max2() {
    async function* max3(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        const p = (0, $2edc1eef02a7c199$export$8960430cfd85939f)();
        for await (const value of input){
            const x = p(value);
            if (x === void 0) continue;
            yield x;
        }
    }
    max3._name = `max`;
    return max3;
}
function $3a21733ddc25a9d4$var$rank2(r, options = {}) {
    async function* rank3(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        const p = (0, $2edc1eef02a7c199$export$fbc8bcd33b574fbc)(r, options);
        for await (const value of input){
            const x = p(value);
            if (x === void 0) continue;
            yield x;
        }
    }
    rank3._name = `rank`;
    return rank3;
}
function $3a21733ddc25a9d4$var$rankArray(r, options = {}) {
    const includeType = options.includeType;
    const emitEqualRanked = options.emitEqualRanked ?? false;
    const emitRepeatHighest = options.emitRepeatHighest ?? false;
    const withinArrays = options.withinArrays ?? false;
    async function* rankArray2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        let best;
        for await (const value of input){
            let emit = false;
            if (withinArrays) best = void 0;
            for (const subValue of value){
                if (includeType && typeof subValue !== includeType) continue;
                if (best === void 0) {
                    best = subValue;
                    emit = true;
                } else {
                    const result = r(subValue, best);
                    if (result == `a`) {
                        best = subValue;
                        emit = true;
                    } else if (result === `eq` && emitEqualRanked) emit = true;
                    else if (emitRepeatHighest) emit = true;
                }
            }
            if (emit && best) yield best;
        }
    }
    rankArray2._name = `rankArray`;
    return rankArray2;
}
function $3a21733ddc25a9d4$var$average2() {
    async function* average3(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        const p = (0, $2edc1eef02a7c199$export$cc6710ee5f037d57)();
        for await (const value of input){
            const x = p(value);
            if (x === void 0) continue;
            yield x;
        }
    }
    average3._name = `average`;
    return average3;
}
function $3a21733ddc25a9d4$var$sum2() {
    async function* total(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        const p = (0, $2edc1eef02a7c199$export$8a63f25cc62965f1)();
        for await (const value of input){
            const x = p(value);
            if (x === void 0) continue;
            yield x;
        }
    }
    total._name = `total`;
    return total;
}
function $3a21733ddc25a9d4$var$chunk(size, returnRemainders = true) {
    (0, $984cc5641d701af3$export$a4ff393eb12b0888)(size, `aboveZero`, `size`);
    async function* chunk2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        let buffer = [];
        for await (const value of input){
            buffer.push(value);
            if (buffer.length >= size) {
                yield buffer;
                buffer = [];
            }
        }
        if (returnRemainders && buffer.length > 0) yield buffer;
    }
    chunk2._name = `chunk`;
    return chunk2;
}
function $3a21733ddc25a9d4$var$filter(predicate) {
    async function* filter2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        for await (const value of input)if (predicate(value)) yield value;
    }
    filter2._name = `filter`;
    return filter2;
}
function $3a21733ddc25a9d4$var$drop(predicate) {
    async function* drop2(input) {
        input = $3a21733ddc25a9d4$export$48a2459239ad7f92(input);
        for await (const value of input)if (!predicate(value)) yield value;
    }
    drop2._name = `drop`;
    return drop2;
}
// src/iterables/chain/AddToArray.ts
async function $3a21733ddc25a9d4$export$16778529d121119(array2, valueToWrap) {
    const outputType = typeof valueToWrap === `function` ? valueToWrap() : valueToWrap;
    for await (const value of outputType)array2.push(value);
}
// src/iterables/chain/AsArray.ts
async function $3a21733ddc25a9d4$export$75093a47a9fa838d(valueToWrap, options = {}) {
    const outputType = typeof valueToWrap === `function` ? valueToWrap() : valueToWrap;
    return (0, $2edc1eef02a7c199$export$45b10814cc054894)(outputType, options);
}
// src/iterables/chain/AsCallback.ts
async function $3a21733ddc25a9d4$export$11e61faed1285c36(valueToWrap, callback, onDone) {
    const outputType = typeof valueToWrap === `function` ? valueToWrap() : valueToWrap;
    for await (const value of outputType)callback(value);
    if (onDone) onDone();
}
// src/iterables/chain/AsPromise.ts
function $3a21733ddc25a9d4$export$538cda31d79078b8(valueToWrap) {
    let lastValue;
    const outputType = typeof valueToWrap === `function` ? valueToWrap() : valueToWrap;
    async function asPromise2() {
        const v = await outputType.next();
        if (v.done) return;
        lastValue = v.value;
        return lastValue;
    }
    return asPromise2;
}
// src/iterables/chain/AsValue.ts
function $3a21733ddc25a9d4$export$51ea4d7e0db4b093(valueToWrap, initialValue) {
    let lastValue = initialValue;
    let awaiting = false;
    const outputType = typeof valueToWrap === `function` ? valueToWrap() : valueToWrap;
    function asValue2() {
        if (!awaiting) {
            awaiting = true;
            outputType.next().then((v)=>{
                lastValue = v.value;
                awaiting = false;
            }).catch((error)=>{
                awaiting = false;
                throw error;
            });
        }
        return lastValue;
    }
    return asValue2;
}
// src/iterables/chain/Run.ts
async function* $3a21733ddc25a9d4$export$bd33d8a7043b316f(...functions) {
    let input;
    for (const fnOrData of functions)input = typeof fnOrData === `function` ? fnOrData(input ?? []) : $3a21733ddc25a9d4$export$48a2459239ad7f92(fnOrData);
    if (input === void 0) return;
    for await (const v of input)yield v;
}
async function* $3a21733ddc25a9d4$export$889ea624f2cb2c57(gen, l0, l1, l2, l3, l4, l5) {
    let input;
    const functions = arguments;
    for (const fnOrData of functions)if (typeof fnOrData === `function`) input = fnOrData(input ?? []);
    else input = $3a21733ddc25a9d4$export$48a2459239ad7f92(fnOrData);
    if (input === void 0) return;
    for await (const v of input)yield v;
}
// src/iterables/chain/Prepare.ts
function $3a21733ddc25a9d4$export$18298bb220d85216(...functions) {
    const r = (source)=>{
        return $3a21733ddc25a9d4$export$bd33d8a7043b316f(source, ...functions);
    };
    return r;
}
// src/iterables/chain/from/index.ts
var $3a21733ddc25a9d4$export$83d6c301da3ae43e = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($3a21733ddc25a9d4$export$83d6c301da3ae43e, {
    array: ()=>$3a21733ddc25a9d4$var$array,
    event: ()=>$3a21733ddc25a9d4$var$event,
    func: ()=>$3a21733ddc25a9d4$var$func,
    iterable: ()=>$3a21733ddc25a9d4$var$iterable,
    timestamp: ()=>$3a21733ddc25a9d4$export$fc00ee57782020aa
});
// src/iterables/chain/from/Array.ts
function $3a21733ddc25a9d4$var$array(it, delay2 = 5) {
    async function* fromArray2() {
        for (const v of it){
            await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(delay2);
            yield v;
        }
    }
    fromArray2._name = `fromArray`;
    fromArray2._type = `GenFactoryNoInput`;
    return fromArray2;
}
// src/iterables/chain/from/Event.ts
function $3a21733ddc25a9d4$var$event(target, name) {
    async function* event2() {
        while(true)yield await (0, $f53657e65b61d2bb$export$a0302146205b73d0)(target, name);
    }
    event2._name = `event`;
    event2._type = `GenFactoryNoInput`;
    return event2;
}
// src/iterables/chain/from/Function.ts
function $3a21733ddc25a9d4$var$func(callback) {
    async function* fromFunction() {
        while(true){
            const v = await callback();
            if (v === void 0) break;
            yield v;
        }
    }
    fromFunction._name = `fromFunction`;
    fromFunction._type = `GenFactoryNoInput`;
    return fromFunction;
}
// src/iterables/chain/from/Iterable.ts
function $3a21733ddc25a9d4$var$iterable(it) {
    async function* fromIterable2() {
        for await (const v of it)yield v;
    }
    fromIterable2._name = `fromIterable`;
    fromIterable2._type = `GenFactoryNoInput`;
    return fromIterable2;
}
// src/iterables/chain/from/Ticks.ts
function $3a21733ddc25a9d4$export$fc00ee57782020aa(options) {
    const intervalMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.interval, 0);
    const asClockTime = options.asClockTime ?? false;
    const loops = options.loops ?? Number.MAX_SAFE_INTEGER;
    let looped = 0;
    const durationTime = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.elapsed, Number.MAX_SAFE_INTEGER);
    async function* ts() {
        const elapsed = (0, $29a41e51920ca8b4$export$ae56a3c442de3c6a).since();
        while(looped < loops && elapsed() < durationTime){
            yield asClockTime ? Date.now() : elapsed();
            const expectedTimeDiff = looped * intervalMs - elapsed();
            await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(Math.max(0, intervalMs + expectedTimeDiff));
            looped++;
        }
    }
    ts._name = `timestamp`;
    ts._type = `GenFactoryNoInput`;
    return ts;
}
// src/iterables/chain/Lazy.ts
var $3a21733ddc25a9d4$var$getLinkName = (c)=>{
    return c._name ?? c.name;
};
function $3a21733ddc25a9d4$export$488013bae63b21da() {
    const chained = [];
    let dataToUse;
    const asGenerator = (data)=>{
        if (data === void 0) data = dataToUse;
        let d = $3a21733ddc25a9d4$export$19fd2268fac785a6(data);
        for (const c of chained)if (d === void 0) {
            if ($3a21733ddc25a9d4$export$9bc079ce4ee0d921(c)) d = c();
            else throw new Error(`Function '${$3a21733ddc25a9d4$var$getLinkName(c)}' requires input. Provide it to the function, or call 'input' earlier.`);
        } else d = c(d);
        return d;
    };
    const w = {
        rankArray: (r, options)=>{
            chained.push($3a21733ddc25a9d4$var$rankArray(r, options));
            return w;
        },
        rank: (r, options)=>{
            chained.push($3a21733ddc25a9d4$var$rank2(r, options));
            return w;
        },
        transform: (transformer)=>{
            chained.push($3a21733ddc25a9d4$var$transform(transformer));
            return w;
        },
        reduce: (reducer)=>{
            chained.push($3a21733ddc25a9d4$var$reduce(reducer));
            return w;
        },
        drop: (predicate)=>{
            chained.push($3a21733ddc25a9d4$var$drop(predicate));
            return w;
        },
        delay: (options)=>{
            chained.push($3a21733ddc25a9d4$var$delay(options));
            return w;
        },
        duration: (elapsed)=>{
            chained.push($3a21733ddc25a9d4$var$duration(elapsed));
            return w;
        },
        debounce: (rate)=>{
            chained.push($3a21733ddc25a9d4$var$debounce(rate));
            return w;
        },
        fromFunction: (callback)=>{
            chained.push($3a21733ddc25a9d4$var$func(callback));
            return w;
        },
        take: (limit)=>{
            chained.push($3a21733ddc25a9d4$var$take(limit));
            return w;
        },
        chunk: (size, returnRemainders = true)=>{
            chained.push($3a21733ddc25a9d4$var$chunk(size, returnRemainders));
            return w;
        },
        filter: (predicate)=>{
            chained.push($3a21733ddc25a9d4$var$filter((v)=>predicate(v)));
            return w;
        },
        min: ()=>{
            chained.push($3a21733ddc25a9d4$var$min2());
            return w;
        },
        max: ()=>{
            chained.push($3a21733ddc25a9d4$var$max2());
            return w;
        },
        average: ()=>{
            chained.push($3a21733ddc25a9d4$var$average2());
            return w;
        },
        sum: ()=>{
            chained.push($3a21733ddc25a9d4$var$sum2());
            return w;
        },
        tally: (countArrayItems)=>{
            chained.push($3a21733ddc25a9d4$var$tally2(countArrayItems));
            return w;
        },
        input (data) {
            dataToUse = data;
            return w;
        },
        asGenerator: asGenerator,
        asAsync (data) {
            let d = data ?? dataToUse;
            for (const c of chained){
                if (d === void 0 && $3a21733ddc25a9d4$export$9bc079ce4ee0d921(c)) d = c();
                else if (d === void 0) throw new Error(`Function '${$3a21733ddc25a9d4$var$getLinkName(c)}' needs input. Pass in data calling 'asAsync', or call 'input' earlier`);
                else d = c(d);
            }
            return w;
        },
        asArray: async (data)=>{
            const g = asGenerator(data);
            return await (0, $2edc1eef02a7c199$export$45b10814cc054894)(g);
        },
        firstOutput: async (data)=>{
            const g = asGenerator(data);
            const v = await g.next();
            return v.value;
        },
        lastOutput: async (data)=>{
            const g = asGenerator(data);
            let lastValue;
            for await (const v of g)lastValue = v;
            return lastValue;
        }
    };
    return w;
}
// src/iterables/chain/MergeFlat.ts
async function* $3a21733ddc25a9d4$export$1ca97b40e512ebc0(...sources) {
    const sourcesInput = sources.map((source)=>$3a21733ddc25a9d4$export$19fd2268fac785a6(source));
    const buffer = (0, $afa7d8c33fbcfc09$export$2ddaa7a8f0593fce).mutable();
    let completed = 0;
    const schedule = async (source)=>{
        if (source === void 0) {
            completed++;
            return;
        }
        const x = await source.next();
        if (x.done) completed++;
        else {
            buffer.enqueue(x.value);
            setTimeout(()=>schedule(source), 1);
        }
    };
    for (const source of sourcesInput)setTimeout(()=>schedule(source), 1);
    const loopSpeed = 10;
    let loopFactor = 1;
    while(completed < sourcesInput.length){
        const d = buffer.dequeue();
        if (d === void 0) loopFactor = Math.min(loopFactor + 1, 10);
        else {
            yield d;
            loopFactor = 1;
        }
        await (0, $f53657e65b61d2bb$export$e772c8ff12451969)(loopSpeed * loopFactor);
    }
}
// src/iterables/chain/CombineLatestToArray.ts
async function* $3a21733ddc25a9d4$export$b5235d9cdb97b833(sources, options = {}) {
    const onSourceDone = options.onSourceDone ?? `break`;
    const finalValue = options.finalValue ?? `undefined`;
    const afterEmit = options.afterEmit ?? `last`;
    const inputs = sources.map((source, index)=>({
            waiting: void 0,
            index: index,
            gen: $3a21733ddc25a9d4$export$48a2459239ad7f92(source),
            done: false,
            lastValue: void 0
        }));
    const isDone = ()=>!inputs.some((v)=>!v.done);
    const isWaiting = ()=>inputs.some((v)=>v.waiting !== void 0);
    const allEmpty = (d)=>!d.some((v)=>v !== void 0);
    let lastEmitted = [];
    while(true){
        const promises = [];
        for (const input of inputs){
            if (input.done) continue;
            if (input.waiting !== void 0) {
                promises.push(input.waiting);
                continue;
            }
            const p = Promise.resolve((async ()=>{
                if (input.done) return input;
                const v = await input.gen.next();
                input.waiting = void 0;
                if (v.done) {
                    input.done = true;
                    if (finalValue === `undefined`) input.lastValue = void 0;
                } else input.lastValue = v.value;
                return input;
            })());
            input.waiting = p;
            promises.push(p);
        }
        const won = await Promise.race(promises);
        if (won.done && onSourceDone === `break`) break;
        const d = inputs.map((v)=>v.lastValue);
        if (d.length === 0) return;
        const dataEmpty = allEmpty(d);
        if (dataEmpty && !isWaiting()) return;
        if (!(0, $b63753f448317b08$export$248d38f6296296c5)(lastEmitted, d) && !dataEmpty) {
            lastEmitted = d;
            yield d;
        }
        if (afterEmit === `undefined`) for (const input of inputs){
            if (input.waiting !== void 0) continue;
            input.lastValue = void 0;
        }
        if (isDone()) break;
    }
}
// src/iterables/chain/CombineLatestToObject.ts
async function* $3a21733ddc25a9d4$export$75430b411d43dc3f(sources, options = {}) {
    const onSourceDone = options.onSourceDone ?? `break`;
    const finalValue = options.finalValue ?? `undefined`;
    const afterEmit = options.afterEmit ?? `last`;
    const states = /* @__PURE__ */ new Map();
    for (const [key, value] of Object.entries(sources))states.set(key, {
        gen: $3a21733ddc25a9d4$export$48a2459239ad7f92(value),
        done: false,
        lastValue: void 0,
        waiting: void 0,
        key: key
    });
    const isDone = ()=>!(0, $3ffa4b3bf3c5db47$export$ad14ef4001db2bcd)(states, (v)=>!v.done);
    const isWaiting = ()=>(0, $3ffa4b3bf3c5db47$export$ad14ef4001db2bcd)(states, (v)=>v.waiting !== void 0);
    const allEmpty = (d)=>{
        for (const v of Object.values(d)){
            if (v !== void 0) return false;
        }
        return true;
    };
    const getData = ()=>{
        const r = {};
        for (const [key, state] of states)r[key] = state.lastValue;
        return r;
    };
    let lastEmitted;
    while(true){
        const promises = [];
        for (const input of states.values()){
            if (input.done) continue;
            if (input.waiting !== void 0) {
                promises.push(input.waiting);
                continue;
            }
            const p = Promise.resolve((async ()=>{
                if (input.done) return input;
                const v = await input.gen.next();
                input.waiting = void 0;
                if (v.done) {
                    input.done = true;
                    if (finalValue === `undefined`) input.lastValue = void 0;
                } else input.lastValue = v.value;
                return input;
            })());
            input.waiting = p;
            promises.push(p);
        }
        const won = await Promise.race(promises);
        if (won.done && onSourceDone === `break`) break;
        const d = getData();
        const dataEmpty = allEmpty(d);
        if (dataEmpty && !isWaiting()) return;
        if (!(0, $847987b26b102cb8$export$7edc20bb5dc6700c)(lastEmitted, d) && !dataEmpty) {
            lastEmitted = d;
            yield d;
        }
        if (afterEmit === `undefined`) for (const input of states.values()){
            if (input.waiting !== void 0) continue;
            input.lastValue = void 0;
        }
        if (isDone()) break;
    }
}
// src/iterables/chain/Single.ts
async function $3a21733ddc25a9d4$export$863d7ca51b416cee(f, input) {
    const iterator = await f([
        input
    ]).next();
    return iterator.value;
}
// src/iterables/chain/Sync.ts
async function* $3a21733ddc25a9d4$export$5eb154d8c1f8350(sources, options = {}) {
    const onSourceDone = options.onSourceDone ?? `break`;
    const maximumWaitMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.maximumWait, 2e3);
    const finalValue = options.finalValue ?? `undefined`;
    const inputs = sources.map((source)=>({
            seq: 0,
            lastValue: void 0,
            gen: $3a21733ddc25a9d4$export$48a2459239ad7f92(source),
            done: false
        }));
    const nextWithTimeoutOpts = {
        millis: maximumWaitMs
    };
    let seq = 0;
    const isAllDone = ()=>!inputs.some((v)=>!v.done);
    let go = true;
    while(go){
        seq++;
        for (const input of inputs){
            if (input.done) {
                input.seq = seq;
                continue;
            }
            const v = await (0, $2edc1eef02a7c199$export$c8e96baae762a91b)(input.gen, nextWithTimeoutOpts);
            if (v.done) {
                input.done = true;
                input.seq = seq;
                if (finalValue === `undefined`) input.lastValue = void 0;
                if (onSourceDone === `break`) return;
            } else {
                input.lastValue = v.value;
                input.seq = seq;
            }
        }
        if (go) {
            const d = inputs.filter((v)=>v.seq === seq).map((v)=>v.lastValue);
            if (d.length === 0) return;
            if (!d.some((v)=>v !== void 0)) return;
            yield d;
        }
        if (isAllDone()) go = false;
    }
}










// src/iterables/index.ts
var $fcd49f8aa3774904$export$e77a285cb149280f = {};
(0, $f81dde33861c7f4f$export$cd3da3bb63c78796)($fcd49f8aa3774904$export$e77a285cb149280f, {
    Async: ()=>(0, $2edc1eef02a7c199$export$95889358bed0a2dc),
    Chains: ()=>(0, $3a21733ddc25a9d4$export$283b508889bd5942),
    Sync: ()=>(0, $eca7f6cd1c865161$export$62a3c7ddd42c6686),
    asCallback: ()=>$fcd49f8aa3774904$export$11e61faed1285c36,
    chunks: ()=>$fcd49f8aa3774904$export$99f96ea7ddfd7ba9,
    combineLatestToArray: ()=>$fcd49f8aa3774904$export$b5235d9cdb97b833,
    concat: ()=>$fcd49f8aa3774904$export$ee1b3e54f0441b22,
    dropWhile: ()=>$fcd49f8aa3774904$export$533af5c8cd6afa16,
    equals: ()=>$fcd49f8aa3774904$export$e9bab7fafb253603,
    every: ()=>$fcd49f8aa3774904$export$7ecc1a3b11b57dab,
    fill: ()=>$fcd49f8aa3774904$export$9563e054e6f787fb,
    filter: ()=>$fcd49f8aa3774904$export$3dea766d36a8935f,
    find: ()=>$fcd49f8aa3774904$export$71aa6c912b956294,
    flatten: ()=>$fcd49f8aa3774904$export$bffa455ba8c619a6,
    forEach: ()=>$fcd49f8aa3774904$export$4b80e395e36b5a56,
    fromArray: ()=>$fcd49f8aa3774904$export$571d59b505e6bb4e,
    fromEvent: ()=>(0, $3f856c338f7c6dcb$export$a36e16046ae8f1bb),
    fromFunction: ()=>$fcd49f8aa3774904$export$b0f238898075d24f,
    fromFunctionAwaited: ()=>$fcd49f8aa3774904$export$bdaa2e64d23e6084,
    fromIterable: ()=>$fcd49f8aa3774904$export$dcccc29c315dd646,
    isAsyncIterable: ()=>(0, $3f856c338f7c6dcb$export$edb10ab8dd75a915),
    isIterable: ()=>(0, $3f856c338f7c6dcb$export$9652023d9040757),
    iteratorController: ()=>$fcd49f8aa3774904$export$b4fbdc43e28ca85b,
    map: ()=>$fcd49f8aa3774904$export$871de8747c9eaa88,
    max: ()=>$fcd49f8aa3774904$export$8960430cfd85939f,
    min: ()=>$fcd49f8aa3774904$export$96ec731ed4dcb222,
    reduce: ()=>$fcd49f8aa3774904$export$533b26079ad0b4b,
    slice: ()=>$fcd49f8aa3774904$export$58adb3bec8346d0f,
    some: ()=>$fcd49f8aa3774904$export$ad14ef4001db2bcd,
    toArray: ()=>$fcd49f8aa3774904$export$45b10814cc054894,
    unique: ()=>$fcd49f8aa3774904$export$7a5d5c156e7dc406,
    uniqueByValue: ()=>$fcd49f8aa3774904$export$bf6a3c1875347125,
    until: ()=>$fcd49f8aa3774904$export$a40009bd2c363351,
    zip: ()=>$fcd49f8aa3774904$export$8901015135f2fb22
});
// src/iterables/Controller.ts
var $fcd49f8aa3774904$export$b4fbdc43e28ca85b = (options)=>{
    const delayMs = (0, $96f72d8c52c10ae7$export$a3f539fb9b9188ff)(options.delay, 10);
    let gen;
    const onValue = options.onValue;
    let state = `stopped`;
    let loop = (0, $f53657e65b61d2bb$export$5df75b4acf95a98a)(async ()=>{
        if (gen) {
            const r = await gen.next();
            if (r.done) {
                state = `stopped`;
                return false;
            }
            const r2 = onValue(r.value);
            if (typeof r2 === `boolean`) {
                if (!r2) state = `stopped`;
                return r2;
            }
            return true;
        } else {
            state = `stopped`;
            return false;
        }
    }, delayMs);
    const cancel = ()=>{
        if (state === `stopped`) return;
        gen = void 0;
        loop.cancel();
        state = `stopped`;
    };
    const pause = ()=>{
        if (state === `paused`) return;
        loop.cancel();
        state = `paused`;
    };
    const start = ()=>{
        if (state === `running`) return;
        if (!gen) remake();
        state = `running`;
        loop.start();
    };
    const remake = ()=>{
        if (options.iterator) gen = options.iterator();
        else throw new Error(`No source iterator`);
    };
    const restart = ()=>{
        remake();
        start();
    };
    return {
        start: start,
        cancel: cancel,
        restart: restart,
        pause: pause,
        get state () {
            return state;
        }
    };
};
// src/iterables/index.ts
function $fcd49f8aa3774904$export$b5235d9cdb97b833(sources, options = {}) {
    return (0, $3a21733ddc25a9d4$export$b5235d9cdb97b833)(sources, options);
}
function $fcd49f8aa3774904$export$96ec731ed4dcb222(it, gt = (a, b)=>a > b) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$8efb1fc49a968b94)(it, gt) : (0, $eca7f6cd1c865161$export$96ec731ed4dcb222)(it, gt);
}
function $fcd49f8aa3774904$export$8960430cfd85939f(it, gt = (a, b)=>a > b) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$ebc969c3f7f41c0b)(it, gt) : (0, $eca7f6cd1c865161$export$8960430cfd85939f)(it, gt);
}
function $fcd49f8aa3774904$export$533af5c8cd6afa16(it, f) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$533af5c8cd6afa16)(it, f) : (0, $eca7f6cd1c865161$export$533af5c8cd6afa16)(it, f);
}
function $fcd49f8aa3774904$export$a40009bd2c363351(it, callback) {
    if ((0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it)) return (0, $2edc1eef02a7c199$export$a40009bd2c363351)(it, callback);
    else (0, $eca7f6cd1c865161$export$a40009bd2c363351)(it, callback);
}
function $fcd49f8aa3774904$export$99f96ea7ddfd7ba9(it, size) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$99f96ea7ddfd7ba9)(it, size) : (0, $eca7f6cd1c865161$export$99f96ea7ddfd7ba9)(it, size);
}
function $fcd49f8aa3774904$export$3dea766d36a8935f(it, f) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$3dea766d36a8935f)(it, f) : (0, $eca7f6cd1c865161$export$3dea766d36a8935f)(it, f);
}
function $fcd49f8aa3774904$export$9563e054e6f787fb(it, v) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$9563e054e6f787fb)(it, v) : (0, $eca7f6cd1c865161$export$9563e054e6f787fb)(it, v);
}
function $fcd49f8aa3774904$export$ee1b3e54f0441b22(...its) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(its[0]) ? (0, $2edc1eef02a7c199$export$ee1b3e54f0441b22)(...its) : (0, $eca7f6cd1c865161$export$ee1b3e54f0441b22)(...its);
}
function $fcd49f8aa3774904$export$71aa6c912b956294(it, f) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$71aa6c912b956294)(it, f) : (0, $eca7f6cd1c865161$export$71aa6c912b956294)(it, f);
}
function $fcd49f8aa3774904$export$4b80e395e36b5a56(it, fn, options = {}) {
    if ((0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it)) return (0, $2edc1eef02a7c199$export$4b80e395e36b5a56)(it, fn, options);
    else (0, $eca7f6cd1c865161$export$4b80e395e36b5a56)(it, fn);
}
function $fcd49f8aa3774904$export$871de8747c9eaa88(it, f) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$871de8747c9eaa88)(it, f) : (0, $eca7f6cd1c865161$export$871de8747c9eaa88)(it, f);
}
function $fcd49f8aa3774904$export$571d59b505e6bb4e(array, interval) {
    return interval === void 0 ? (0, $eca7f6cd1c865161$export$571d59b505e6bb4e)(array) : (0, $2edc1eef02a7c199$export$571d59b505e6bb4e)(array, interval);
}
function $fcd49f8aa3774904$export$bffa455ba8c619a6(it) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$bffa455ba8c619a6)(it) : (0, $eca7f6cd1c865161$export$bffa455ba8c619a6)(it);
}
function $fcd49f8aa3774904$export$ad14ef4001db2bcd(it, f) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$ad14ef4001db2bcd)(it, f) : (0, $eca7f6cd1c865161$export$ad14ef4001db2bcd)(it, f);
}
function $fcd49f8aa3774904$export$533b26079ad0b4b(it, f, start) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$533b26079ad0b4b)(it, f, start) : (0, $eca7f6cd1c865161$export$533b26079ad0b4b)(it, f, start);
}
function $fcd49f8aa3774904$export$58adb3bec8346d0f(it, start = 0, end = Number.POSITIVE_INFINITY) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$58adb3bec8346d0f)(it, start, end) : (0, $9364ac8ced0e518d$export$58adb3bec8346d0f)(it, end);
}
function $fcd49f8aa3774904$export$7a5d5c156e7dc406(iterable) {
    if (Array.isArray(iterable)) {
        if (iterable.length === 0) return (0, $eca7f6cd1c865161$export$571d59b505e6bb4e)([]);
        return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(iterable[0]) ? (0, $2edc1eef02a7c199$export$7a5d5c156e7dc406)(iterable) : (0, $eca7f6cd1c865161$export$7a5d5c156e7dc406)(iterable);
    } else if ((0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(iterable)) return (0, $2edc1eef02a7c199$export$7a5d5c156e7dc406)(iterable);
    else return (0, $eca7f6cd1c865161$export$7a5d5c156e7dc406)(iterable);
}
function* $fcd49f8aa3774904$export$bf6a3c1875347125(input, toString = (0, $847987b26b102cb8$export$f5a6f2033c1996c8), seen = /* @__PURE__ */ new Set()) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(input) ? (0, $2edc1eef02a7c199$export$bf6a3c1875347125)(input, toString, seen) : (0, $eca7f6cd1c865161$export$bf6a3c1875347125)(input, toString, seen);
}
function $fcd49f8aa3774904$export$45b10814cc054894(it, options = {}) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$45b10814cc054894)(it, options) : (0, $eca7f6cd1c865161$export$45b10814cc054894)(it, options);
}
function $fcd49f8aa3774904$export$7ecc1a3b11b57dab(it, f) {
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it) ? (0, $2edc1eef02a7c199$export$7ecc1a3b11b57dab)(it, f) : (0, $eca7f6cd1c865161$export$7ecc1a3b11b57dab)(it, f);
}
function $fcd49f8aa3774904$export$e9bab7fafb253603(it1, it2, equality) {
    const as = (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it1) && (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(it2);
    return as ? (0, $2edc1eef02a7c199$export$e9bab7fafb253603)(it1, it2, equality) : (0, $eca7f6cd1c865161$export$e9bab7fafb253603)(it1, it2, equality);
}
function $fcd49f8aa3774904$export$8901015135f2fb22(...its) {
    if (its.length === 0) return (0, $eca7f6cd1c865161$export$571d59b505e6bb4e)([]);
    return (0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(its[0]) ? (0, $2edc1eef02a7c199$export$8901015135f2fb22)(...its) : (0, $eca7f6cd1c865161$export$8901015135f2fb22)(...its);
}
function $fcd49f8aa3774904$export$dcccc29c315dd646(iterable, interval) {
    if ((0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(iterable) || interval !== void 0) return (0, $2edc1eef02a7c199$export$dcccc29c315dd646)(iterable, interval);
    return (0, $eca7f6cd1c865161$export$dcccc29c315dd646)(iterable);
}
function* $fcd49f8aa3774904$export$b0f238898075d24f(callback) {
    while(true){
        const v = callback();
        yield v;
    }
}
async function* $fcd49f8aa3774904$export$bdaa2e64d23e6084(callback) {
    while(true){
        const v = await callback();
        yield v;
    }
}
function $fcd49f8aa3774904$export$11e61faed1285c36(input, callback, onDone) {
    if ((0, $3f856c338f7c6dcb$export$edb10ab8dd75a915)(input)) return (0, $2edc1eef02a7c199$export$11e61faed1285c36)(input, callback);
    else return (0, $eca7f6cd1c865161$export$11e61faed1285c36)(input, callback);
}


























































const $a10b99ceea8a9696$var$settings = Object.freeze({
    btnVisit: document.querySelector(`#btnVisit`),
    anim: (0, $f53657e65b61d2bb$export$262e28e3815f1ccb).continuously($a10b99ceea8a9696$var$draw, 0),
    timingFactory: (0, $66bc0de6c34dec28$export$c1165f1173362ff5).timingSourceFactory(`elapsed`, 10000, {
        cycleLimit: 1
    }),
    svgParent: document.querySelector(`#canvas`)
});
let $a10b99ceea8a9696$var$state = {
    rings: [],
    visualRings: [],
    colours: [
        `black`,
        `white`
    ],
    location: (0, $7b02fea154055fc0$export$d3d80cee07107776)((0, $7fe30c12d2da30ad$export$dccfe90fd0dcf5cf)),
    speedScale: (v)=>v,
    gustScale: (v)=>v
};
function $a10b99ceea8a9696$var$draw() {
    const { svgParent: svgParent } = $a10b99ceea8a9696$var$settings;
    let { timeline: timeline } = $a10b99ceea8a9696$var$state;
    if (!timeline) {
        timeline = $a10b99ceea8a9696$var$settings.timingFactory();
        $a10b99ceea8a9696$var$saveState({
            timeline: timeline
        });
    }
    const t = timeline();
    let somethingRunning = false;
    svgParent.style.scale = (11 - $8a5cbeb1c6ae1b41$export$9d3e539142ae65ac(t, 0, 1, 1, 10, (0, $2edc1eef02a7c199$export$892cfef512d4ea3d).Named.quadInOut)).toString();
    for (const ring of $a10b99ceea8a9696$var$state.visualRings){
        //animRing(ring, t);
        ring.group.tick();
        if (!ring.group.isDone) somethingRunning = true;
    }
    if (!somethingRunning) return false; // Stop loop
//return true;
}
function $a10b99ceea8a9696$var$cycleColours() {
    const colours = (0, $b63753f448317b08$export$da86460d40002d1f).shuffle($f361755a1171f8e6$export$fb397405d3486b2());
    $a10b99ceea8a9696$var$saveState({
        colours: colours
    });
    (0, $5d8ef0ef429bc174$export$3396301f4724b73c).setVariables({
        'colour-a': colours[0],
        'colour-b': colours[1]
    }, document.documentElement);
}
async function $a10b99ceea8a9696$var$fetch() {
    let data = [];
    try {
        data = await $c2bec1fda882e2c6$export$7a171f172be0782e($a10b99ceea8a9696$var$state.location);
        $1bed8721d717cfc5$export$57bf213be019eeb0($a10b99ceea8a9696$var$state.location.title, true);
    } catch (error) {
        $1bed8721d717cfc5$export$57bf213be019eeb0((0, $05b0ec3d1054f5d9$export$921ccba1b7c34f19).getErrorMessage(error) + '. Using demo data.');
        data = $c2bec1fda882e2c6$export$bc7e41628a29c739();
    }
    const speedScale = $8a5cbeb1c6ae1b41$export$392c70347f2a027f(0, $36aa4387660da012$export$8960430cfd85939f(data.map((d)=>d.speed)));
    const gustScale = $8a5cbeb1c6ae1b41$export$392c70347f2a027f(0, $36aa4387660da012$export$8960430cfd85939f(data.map((d)=>d.gusts)));
    const rings = $c2bec1fda882e2c6$export$90a84733300939d7({
        hours: 24
    }, data);
    const visualRings = $d8209951d49845de$export$371cab49ed4e1b88({
        strokeStyle: (0, $6fcd0133a3d1c5fc$export$2e2bcd8739ae039)($a10b99ceea8a9696$var$state.colours[1]).alpha(0.7).hex(),
        barMaximum: 100,
        minimumThickness: 2,
        gustThicknessScale: 15,
        ringDurationMs: 86400000,
        speedScale: speedScale,
        gustScale: gustScale,
        origin: {
            x: 500,
            y: 500
        },
        svg: (0, $3818f2662e2a019f$export$e364262fc575d875).makeHelper(document.querySelector(`#canvas`))
    }, rings);
    $a10b99ceea8a9696$var$saveState({
        rings: rings,
        visualRings: visualRings,
        speedScale: speedScale,
        gustScale: gustScale
    });
    for (const ring of $a10b99ceea8a9696$var$state.visualRings)ring.group.reset();
    $a10b99ceea8a9696$var$settings.anim.reset();
}
async function $a10b99ceea8a9696$var$useState() {}
async function $a10b99ceea8a9696$var$setLocation(geo) {
    $a10b99ceea8a9696$var$saveState({
        location: geo,
        rings: []
    });
    await $a10b99ceea8a9696$var$fetch();
    $a10b99ceea8a9696$var$useState();
}
async function $a10b99ceea8a9696$var$setup() {
    const { btnVisit: btnVisit } = $a10b99ceea8a9696$var$settings;
    const splashEl = document.querySelector(`#splash`);
    $a10b99ceea8a9696$var$cycleColours();
    $1bed8721d717cfc5$export$2cd8252107eb640b();
    $54bc816a2f88fb52$export$2cd8252107eb640b();
    $54bc816a2f88fb52$export$4bf9923669ad6c63.addEventListener(`located`, (args)=>{
        const geo = args.detail;
        $a10b99ceea8a9696$var$setLocation({
            latitude: geo.latitude,
            longitude: geo.longitude,
            title: `Your location`
        });
        $a10b99ceea8a9696$var$useState();
    });
    $54bc816a2f88fb52$export$4bf9923669ad6c63.addEventListener(`not-located`, ()=>{
        $a10b99ceea8a9696$var$fetch();
        $a10b99ceea8a9696$var$useState(); // Use fallback data
    });
    btnVisit.addEventListener(`click`, ()=>{
        $a10b99ceea8a9696$var$cycleColours();
        $a10b99ceea8a9696$var$setLocation((0, $7b02fea154055fc0$export$d3d80cee07107776)((0, $7fe30c12d2da30ad$export$dccfe90fd0dcf5cf)));
        $54bc816a2f88fb52$export$8c09b2ec1ffe6005();
        splashEl.classList.add(`hidden`);
    });
    splashEl.addEventListener(`click`, ()=>{
        splashEl?.classList.add(`hidden`);
    });
}
$a10b99ceea8a9696$var$setup();
/**
 * Save state
 */ function $a10b99ceea8a9696$var$saveState(s) {
    $a10b99ceea8a9696$var$state = Object.freeze({
        ...$a10b99ceea8a9696$var$state,
        ...s
    });
} // import {animateNumber} from './anim/polar';
 // animateNumber(100,0, Modulation.timeModulator())


//# sourceMappingURL=index.de9f0d34.js.map
